// This file is auto-generated by @hey-api/openapi-ts

export type Account = {
    readonly id: number;
    name: string;
    archived?: boolean;
    readonly active: boolean;
    type?: AccountTypeEnum;
    parent?: number | null;
    prettyName?: string;
    /**
     * Activates the customer portal for users in this account.
     */
    hasPortal: boolean;
    /**
     * Activates the Trackings and Communication section along with related analytics.
     */
    hasPortalBeta?: boolean;
    /**
     * Activates the ability to submit requests or data through the portal.
     */
    hasPortalSubmit?: boolean;
    /**
     * Activates the Promise section for configuration and analytics, and enables the Promise API for the account.
     */
    hasPromise: boolean;
    /**
     * Activates trending delay probability. This feature requires coordination with the data team for threshold configurations.
     */
    hasTrendingDelay: boolean;
    /**
     * Activates the email editor and journeys for designing and managing customer journeys.
     */
    hasJourney?: boolean;
    /**
     * Activates the Returns Portal, enabling users to access the Retain section in app.pl.com, including configurations and analytics.
     */
    hasReturns: boolean;
    /**
     * Activates the new user management system for authorized users.
     */
    hasNewUserManagement?: boolean;
    /**
     * Activates customer segmentation in campaign audiences. This feature requires coordination with the data team..
     */
    hasCustomerSegmentation?: boolean;
    /**
     * Activates product recommendations for order status pages and emails. This feature requires coordination with the data team for configuration.
     */
    hasProductRecommendations?: boolean;
    /**
     * Activates returns forecasting. This feature requires coordination with the data team.
     */
    hasReturnsForecasting: boolean;
    /**
     * Activates claims analytics reporting for detailed insights and data visualization.
     */
    hasClaimsReport?: boolean;
    /**
     * Activates advanced journey settings for more complex flow configurations.
     */
    hasJourneyAdvancedMode?: boolean;
    /**
     * Activates self-management functionality in app.pl.com.
     */
    hasReturnRulesV2?: boolean;
    /**
     * Activates Emotion AI, enabling analysis of customer emotion data. This feature requires coordination with the data team.
     */
    hasEmotionAi?: boolean;
    /**
     * Activates the benchmarking section in the portal to compare performance against industry standards.
     */
    hasBenchmarking?: boolean;
    /**
     * Activates the Smart Survey for creating advanced, customizable surveys, allowing self-service configuration and use as an additional content block in Campaigns.
     */
    hasSmartSurvey?: boolean;
    /**
     * Activates App Store access for installing apps and recipes.
     */
    hasAppStore?: boolean;
    /**
     * Activates on-demand tracking refresh for supported carriers.
     */
    hasOnDemandTrackingRefresh?: boolean;
    /**
     * Activates additional actions for outbound trackings to initiate a return from app.pl.com. This action is only visible for published Returns Portals with the 'Customer Service Portal' flag activated.
     */
    hasTrackingReturnInitiation?: boolean;
    /**
     * Activates Shopify returns analytics for supported accounts.
     */
    hasShopifyReturnsAnalytics?: boolean;
    /**
     * Activates App Development Access to create and edit application code
     */
    hasAppDevelopment?: boolean;
    /**
     * Activates the on demand messaging feature
     */
    hasOnDemandMessaging?: boolean;
    /**
     * Activates the custom analytics feature
     */
    hasCustomAnalytics?: boolean;
    /**
     * Activates A/B testing for the account
     */
    hasAbTesting?: boolean;
    optIns?: Array<OptInsEnum>;
    /**
     * Default email preview addressed used for integrations such as Email on Acid or Litmus
     */
    defaultEmailPreviewAddress?: string;
    /**
     * in days
     */
    dataRetentionInDays?: number;
    /**
     * (Shopify customers only) If enabled, all trackings will be accepted even if courier is not detected
     */
    readonly acceptAllTrackings: boolean;
    /**
     * Tracks the migration types this account is awaiting to monitor progress and block further changes from PAPI
     */
    waitingForMigration?: Array<WaitingForMigrationEnum>;
};

export type AccountOptIns = {
    optIns?: Array<OptInsEnum>;
};

export type AccountOptInsRequest = {
    optIns?: Array<OptInsEnum>;
};

export type AccountRequest = {
    name: string;
    archived?: boolean;
    type?: AccountTypeEnum;
    parent?: number | null;
    prettyName?: string;
    /**
     * Activates the customer portal for users in this account.
     */
    hasPortal: boolean;
    /**
     * Activates the Trackings and Communication section along with related analytics.
     */
    hasPortalBeta?: boolean;
    /**
     * Activates the ability to submit requests or data through the portal.
     */
    hasPortalSubmit?: boolean;
    /**
     * Activates the Promise section for configuration and analytics, and enables the Promise API for the account.
     */
    hasPromise: boolean;
    /**
     * Activates trending delay probability. This feature requires coordination with the data team for threshold configurations.
     */
    hasTrendingDelay: boolean;
    /**
     * Activates the email editor and journeys for designing and managing customer journeys.
     */
    hasJourney?: boolean;
    /**
     * Activates the Returns Portal, enabling users to access the Retain section in app.pl.com, including configurations and analytics.
     */
    hasReturns: boolean;
    /**
     * Activates the new user management system for authorized users.
     */
    hasNewUserManagement?: boolean;
    /**
     * Activates customer segmentation in campaign audiences. This feature requires coordination with the data team..
     */
    hasCustomerSegmentation?: boolean;
    /**
     * Activates product recommendations for order status pages and emails. This feature requires coordination with the data team for configuration.
     */
    hasProductRecommendations?: boolean;
    /**
     * Activates returns forecasting. This feature requires coordination with the data team.
     */
    hasReturnsForecasting: boolean;
    /**
     * Activates claims analytics reporting for detailed insights and data visualization.
     */
    hasClaimsReport?: boolean;
    /**
     * Activates advanced journey settings for more complex flow configurations.
     */
    hasJourneyAdvancedMode?: boolean;
    /**
     * Activates self-management functionality in app.pl.com.
     */
    hasReturnRulesV2?: boolean;
    /**
     * Activates Emotion AI, enabling analysis of customer emotion data. This feature requires coordination with the data team.
     */
    hasEmotionAi?: boolean;
    /**
     * Activates the benchmarking section in the portal to compare performance against industry standards.
     */
    hasBenchmarking?: boolean;
    /**
     * Activates the Smart Survey for creating advanced, customizable surveys, allowing self-service configuration and use as an additional content block in Campaigns.
     */
    hasSmartSurvey?: boolean;
    /**
     * Activates App Store access for installing apps and recipes.
     */
    hasAppStore?: boolean;
    /**
     * Activates on-demand tracking refresh for supported carriers.
     */
    hasOnDemandTrackingRefresh?: boolean;
    /**
     * Activates additional actions for outbound trackings to initiate a return from app.pl.com. This action is only visible for published Returns Portals with the 'Customer Service Portal' flag activated.
     */
    hasTrackingReturnInitiation?: boolean;
    /**
     * Activates Shopify returns analytics for supported accounts.
     */
    hasShopifyReturnsAnalytics?: boolean;
    /**
     * Activates App Development Access to create and edit application code
     */
    hasAppDevelopment?: boolean;
    /**
     * Activates the on demand messaging feature
     */
    hasOnDemandMessaging?: boolean;
    /**
     * Activates the custom analytics feature
     */
    hasCustomAnalytics?: boolean;
    /**
     * Activates A/B testing for the account
     */
    hasAbTesting?: boolean;
    optIns?: Array<OptInsEnum>;
    /**
     * Default email preview addressed used for integrations such as Email on Acid or Litmus
     */
    defaultEmailPreviewAddress?: string;
    /**
     * in days
     */
    dataRetentionInDays?: number;
    /**
     * Tracks the migration types this account is awaiting to monitor progress and block further changes from PAPI
     */
    waitingForMigration?: Array<WaitingForMigrationEnum>;
};

/**
 * * `company` - Company
 * * `group` - Group
 */
export enum AccountTypeEnum {
    COMPANY = 'company',
    GROUP = 'group'
}

export type AdditionalAttribute = {
    /**
     * The key of the additional attribute
     */
    key: string;
    /**
     * The value of the additional attribute
     */
    value?: unknown;
};

/**
 * * `other_trackings_of_order` - Other trackings of order (will be attached as context.order.trackings)
 * * `enriched_articles` - Articles with additional information (from product feed)
 */
export enum AdditionalContextEnum {
    OTHER_TRACKINGS_OF_ORDER = 'other_trackings_of_order',
    ENRICHED_ARTICLES = 'enriched_articles'
}

export type AddressDetails = {
    street?: string | unknown;
    zip_code?: string | unknown;
    city?: string | unknown;
    country?: string | unknown;
};

export type AddressSchema = {
    first_name?: string;
    last_name?: string;
    company_name?: string;
    /**
     * Address line, e.g. street and house number, or PO Box
     */
    address_line: string;
    /**
     * Additional address line, e.g. apartment number or company name
     */
    address_line_extra?: string;
    postal_code: string;
    /**
     * City name (min-length of 1 due to logographic languages)
     */
    city: string;
    /**
     * ISO 3166-1 alpha-3 code of country
     */
    country_iso3: string;
    /**
     * Region code, e.g. state or province code (ISO 3166-2), if available
     */
    region_code?: string;
    /**
     * Phone number related to this address, if any
     */
    phone?: string;
};

/**
 * * `pick_up_ready` - Pickup Ready
 * * `new_attempt_today` - New Attempt Today
 * * `new_attempt_next_day` - New Attempt Next Day
 * * `empty` - Empty
 */
export enum AllowedNextActionEnum {
    PICK_UP_READY = 'pick_up_ready',
    NEW_ATTEMPT_TODAY = 'new_attempt_today',
    NEW_ATTEMPT_NEXT_DAY = 'new_attempt_next_day',
    EMPTY = 'empty'
}

export type AlwaysUseFallbackValue = {
    type?: string;
    value?: boolean;
};

/**
 * * `dashboard` - Dashboard
 * * `question` - Question
 * * `metric` - Metric
 */
export enum AnalyticsTypeEnum {
    DASHBOARD = 'dashboard',
    QUESTION = 'question',
    METRIC = 'metric'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type AppDeployment = {
    readonly id: number;
    readonly account: number;
    readonly appName: string;
    readonly appType: string;
    readonly appKey: string;
    readonly customApp: number;
    readonly installedApp: number | null;
    readonly logicalOrder: number;
    readonly events: Array<JourneyTriggerEvent>;
    readonly filter: {
        [key: string]: unknown;
    };
    readonly additionalContext: Array<AdditionalContextEnum>;
    slug: string;
    kind?: KindEnum;
    version?: string;
    status?: AppDeploymentStatusEnum;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly placeholders: Array<string>;
};

export type AppDeploymentInvocationRequestRequest = {
    input: PayloadRewriteInput;
};

export type AppDeploymentInvocationResponse = {
    ok: boolean;
    response: {
        [key: string]: unknown;
    };
};

/**
 * * `deployed` - Deployed
 * * `failed` - Failed
 * * `active` - Active
 */
export enum AppDeploymentStatusEnum {
    DEPLOYED = 'deployed',
    FAILED = 'failed',
    ACTIVE = 'active'
}

export type AppleWalletModel = {
    enabled?: boolean;
    orderTypeId: string;
    merchantId: string;
    orderTypeIdCertificate: string;
    privateKey: string | unknown;
    orderManagementURL?: string;
};

export type ApplyRecipeRequestRequest = {
    /**
     * Account ID
     */
    user: number;
    configuration?: Configuration;
};

export type ApplyRecipeResponse = {
    /**
     * Recipe ID
     */
    recipe: number;
    /**
     * Account ID
     */
    user: number;
    tasks: Array<string>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Asset = {
    readonly id: number;
    account: number;
    location?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type AssetRequest = {
    account: number;
    location?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Attachment = {
    readonly id: number;
    account: number;
    name?: string;
    bucket?: string;
    path?: string;
    filename?: string;
    /**
     * Indicates if the attachment is optional. If optional, the message will be sent even if the attachment is missing.
     */
    isOptional?: boolean;
};

export type Attribute = {
    key: string;
    value: string;
};

export type AttributeRequest = {
    key: string;
    value: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Audience = {
    account: number;
    readonly campaigns: Array<SimpleCampaign>;
    readonly id: number;
    key: string;
    name: string;
    status?: CampaignStatusChoices;
    targetFlow?: TargetFlowEnum;
    targetStage?: Array<TrackingStageChoices>;
    trackingPredicate?: {
        [key: string]: unknown;
    };
    customerSegmentationPredicate?: {
        [key: string]: unknown;
    };
};

export type AudiencePreviewRequestRequest = {
    account: number;
    trackingPredicate?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type AudienceRequest = {
    account: number;
    key: string;
    name: string;
    status?: CampaignStatusChoices;
    targetFlow?: TargetFlowEnum;
    targetStage?: Array<TrackingStageChoices>;
    trackingPredicate?: {
        [key: string]: unknown;
    };
    customerSegmentationPredicate?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type AuthorizationGrant = {
    readonly id: number;
    key: string;
    readonly accessToken: string;
    readonly clientId: string;
    readonly expiresAt: string;
    invalid?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type AuthorizationGrantRequest = {
    key: string;
    invalid?: boolean;
};

export type AutoLayoutConfig = {
    readonly id: number;
    /**
     * Client to which this mapping applies
     */
    client: number;
    layout: number;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific Layouts
     */
    country?: Array<CountriesIso3166Enum>;
};

export type AutoLayoutConfigRequest = {
    /**
     * Client to which this mapping applies
     */
    client: number;
    layout: number;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific Layouts
     */
    country?: Array<CountriesIso3166Enum>;
};

export type AutoUtm = {
    utm_source?: string | unknown;
    utm_medium?: string | unknown;
    utm_campaign?: string | unknown;
    utm_content?: string | unknown;
    utm_term?: string | unknown;
};

export type AvailableTypesResponse = {
    availableTypes: Array<string>;
};

export enum CalibrationEnum {
    BALANCED = 'balanced',
    CONSERVATIVE = 'conservative',
    AGGRESSIVE = 'aggressive'
}

/**
 * Adds nested create feature
 */
export type Campaign = {
    readonly id: number;
    account: number;
    key: string;
    name: string;
    startDate?: string | null;
    endDate?: string | null;
    archiveDate?: string | null;
    priority?: number;
    status?: CampaignStatusChoices;
    campaignTargets?: Array<CampaignTargetChoices>;
    audience?: number | null;
    language?: string;
    messages?: Array<string>;
    timezone?: TimezoneEnum;
    contentBlocks: Array<ContentBlock>;
    readonly uniqueId: string;
};

/**
 * Adds nested create feature
 */
export type CampaignRequest = {
    account: number;
    key: string;
    name: string;
    startDate?: string | null;
    endDate?: string | null;
    archiveDate?: string | null;
    priority?: number;
    status?: CampaignStatusChoices;
    campaignTargets?: Array<CampaignTargetChoices>;
    audience?: number | null;
    language?: string;
    messages?: Array<string>;
    timezone?: TimezoneEnum;
    contentBlocks: Array<ContentBlockRequest>;
};

/**
 * Adds nested create feature
 */
export type CampaignResponse = {
    readonly id: number;
    account: number;
    key: string;
    name: string;
    startDate?: string | null;
    endDate?: string | null;
    archiveDate?: string | null;
    priority?: number;
    status?: CampaignStatusChoices;
    campaignTargets?: Array<CampaignTargetChoices>;
    audience?: SimpleAudience;
    language?: string;
    messages?: Array<string>;
    timezone?: TimezoneEnum;
    contentBlocks: Array<ContentBlock>;
    readonly uniqueId: string;
};

/**
 * * `published` - Published
 * * `archived` - Archived
 * * `draft` - Draft
 */
export enum CampaignStatusChoices {
    PUBLISHED = 'published',
    ARCHIVED = 'archived',
    DRAFT = 'draft'
}

/**
 * * `email` - Email
 * * `web` - Web
 * * `returns` - Returns Portal
 */
export enum CampaignTargetChoices {
    EMAIL = 'email',
    WEB = 'web',
    RETURNS = 'returns'
}

/**
 * * `critical` - Critical
 * * `error` - Error
 * * `warning` - Warning
 * * `info` - Info
 * * `success` - Success
 */
export enum ClassificationEnum {
    CRITICAL = 'critical',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
    SUCCESS = 'success'
}

/**
 * Adds nested create feature
 */
export type Client = {
    readonly id: number;
    archived?: boolean;
    account: number;
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    key: string;
    isDefault?: boolean;
    /**
     * <span style="color: red;">Changing the default language may break associated `messages`.</span>
     *
     * * `mul` - Multi Language
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    defaultLanguage?: DefaultLanguageEnum;
    /**
     * <span style="color: red;">Removing any language may break associated `messages`.</span>
     */
    languages?: Array<LanguagesEnum>;
    /**
     * Shown in FROM field of emails
     */
    name: string;
    /**
     * Full legal sender name. used for auto-generated imprints
     */
    fullName: string;
    /**
     * Shop nickname, used in UI to quickly identify client, not customer-facing
     */
    nickName?: string;
    /**
     * Sender email address, either complete email address (domain must be whitelabeled) or sender name (uses @delivery-status.com)
     */
    email?: string;
    /**
     * Sender name override, if set, this will be used as the sender name in the FROM field of emails
     */
    emailName?: string;
    contactPubEmail?: string;
    contactSupportEmail?: string;
    contactTestEmail?: string;
    contactAlertEmail?: string;
    contactPhone?: string;
    contactWebsite?: string;
    addressStreet?: string;
    addressCity?: string;
    addressZipCode?: string;
    addressCountry?: CountriesIso3166Enum;
    socialFacebook?: string;
    socialInstagram?: string;
    socialLinkedin?: string;
    socialPinterest?: string;
    socialSnapchat?: string;
    socialTiktok?: string;
    socialTrustedshops?: string;
    socialTwitter?: string;
    socialXing?: string;
    socialYoutube?: string;
    socialYoutubePlay?: string;
};

/**
 * Adds nested create feature
 */
export type ClientDetails = {
    readonly id: number;
    archived?: boolean;
    account: number;
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    key: string;
    isDefault?: boolean;
    /**
     * <span style="color: red;">Changing the default language may break associated `messages`.</span>
     *
     * * `mul` - Multi Language
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    defaultLanguage?: DefaultLanguageEnum;
    /**
     * <span style="color: red;">Removing any language may break associated `messages`.</span>
     */
    languages?: Array<LanguagesEnum>;
    /**
     * Shown in FROM field of emails
     */
    name: string;
    /**
     * Full legal sender name. used for auto-generated imprints
     */
    fullName: string;
    /**
     * Shop nickname, used in UI to quickly identify client, not customer-facing
     */
    nickName?: string;
    /**
     * Sender email address, either complete email address (domain must be whitelabeled) or sender name (uses @delivery-status.com)
     */
    email?: string;
    /**
     * Sender name override, if set, this will be used as the sender name in the FROM field of emails
     */
    emailName?: string;
    contactPubEmail?: string;
    contactSupportEmail?: string;
    contactTestEmail?: string;
    contactAlertEmail?: string;
    contactPhone?: string;
    contactWebsite?: string;
    addressStreet?: string;
    addressCity?: string;
    addressZipCode?: string;
    addressCountry?: CountriesIso3166Enum;
    socialFacebook?: string;
    socialInstagram?: string;
    socialLinkedin?: string;
    socialPinterest?: string;
    socialSnapchat?: string;
    socialTiktok?: string;
    socialTrustedshops?: string;
    socialTwitter?: string;
    socialXing?: string;
    socialYoutube?: string;
    socialYoutubePlay?: string;
    /**
     * Additional, not migrated, client static configuration. This section still needs to be edited in the backend statics.
     */
    _config?: {
        [key: string]: unknown;
    };
    localeConfigurations?: Array<ClientLocaleConfiguration>;
    placeholderValues: Array<PlaceholderValueDetail>;
};

export type ClientLanguagesResponse = {
    allLanguages: Array<string>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ClientLocaleConfiguration = {
    /**
     * Language code of this client configuration, keep empty for default
     *
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    language?: LanguagesIso639Enum;
    /**
     * Country code of this client configuration, keep empty for default
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    website?: string;
    customEmailTemplate?: string;
};

/**
 * Adds nested create feature
 */
export type ClientRequest = {
    archived?: boolean;
    account: number;
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    key: string;
    isDefault?: boolean;
    /**
     * <span style="color: red;">Changing the default language may break associated `messages`.</span>
     *
     * * `mul` - Multi Language
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    defaultLanguage?: DefaultLanguageEnum;
    /**
     * <span style="color: red;">Removing any language may break associated `messages`.</span>
     */
    languages?: Array<LanguagesEnum>;
    /**
     * Shown in FROM field of emails
     */
    name: string;
    /**
     * Full legal sender name. used for auto-generated imprints
     */
    fullName: string;
    /**
     * Shop nickname, used in UI to quickly identify client, not customer-facing
     */
    nickName?: string;
    /**
     * Sender email address, either complete email address (domain must be whitelabeled) or sender name (uses @delivery-status.com)
     */
    email?: string;
    /**
     * Sender name override, if set, this will be used as the sender name in the FROM field of emails
     */
    emailName?: string;
    contactPubEmail?: string;
    contactSupportEmail?: string;
    contactTestEmail?: string;
    contactAlertEmail?: string;
    contactPhone?: string;
    contactWebsite?: string;
    addressStreet?: string;
    addressCity?: string;
    addressZipCode?: string;
    addressCountry?: CountriesIso3166Enum;
    socialFacebook?: string;
    socialInstagram?: string;
    socialLinkedin?: string;
    socialPinterest?: string;
    socialSnapchat?: string;
    socialTiktok?: string;
    socialTrustedshops?: string;
    socialTwitter?: string;
    socialXing?: string;
    socialYoutube?: string;
    socialYoutubePlay?: string;
};

export type ClientSimple = {
    readonly id: number;
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    key: string;
    is_default?: boolean;
};

export type ClientSimpleRequest = {
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    key: string;
    is_default?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type CompensationMethod = {
    readonly id: number;
    description: string;
    /**
     * Category of this compensation method
     *
     * * `refund` - Refund
     * * `exchange` - Exchange
     * * `repair` - Repair
     */
    category?: CompensationMethodCategoryEnum;
    /**
     * External code for this compensation method
     */
    externalCode: string;
    /**
     * Tags for this compensation method
     */
    tags?: Array<CompensationMethodTagsEnum>;
    /**
     * Eligibility rules for this compensation method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
    /**
     * Will order compensation methods, low numbers come first
     */
    logicalOrder?: number;
};

/**
 * * `refund` - Refund
 * * `exchange` - Exchange
 * * `repair` - Repair
 */
export enum CompensationMethodCategoryEnum {
    REFUND = 'refund',
    EXCHANGE = 'exchange',
    REPAIR = 'repair'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type CompensationMethodRequest = {
    description: string;
    /**
     * Category of this compensation method
     *
     * * `refund` - Refund
     * * `exchange` - Exchange
     * * `repair` - Repair
     */
    category?: CompensationMethodCategoryEnum;
    /**
     * External code for this compensation method
     */
    externalCode: string;
    /**
     * Tags for this compensation method
     */
    tags?: Array<CompensationMethodTagsEnum>;
    /**
     * Eligibility rules for this compensation method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
    /**
     * Will order compensation methods, low numbers come first
     */
    logicalOrder?: number;
};

/**
 * * `warranty-exclude` - Warranty Exclude
 * * `trial-exclude` - Trial Exclude
 */
export enum CompensationMethodTagsEnum {
    WARRANTY_EXCLUDE = 'warranty-exclude',
    TRIAL_EXCLUDE = 'trial-exclude'
}

export type ConditionalPlaceholders = {
    placeholder: string;
    filter: unknown;
};

export type Configuration = {
    replacements?: {
        [key: string]: string;
    };
    references?: {
        [key: string]: number;
    };
};

export type ContactDetails = {
    alertEmail?: string | unknown;
    phone?: string | unknown;
    pubEmail?: string | unknown;
    supportEmail: string;
    testEmail?: string | unknown;
    website: string;
};

export type ContentBlock = {
    readonly id: number;
    contentType: number;
    value?: {
        [key: string]: unknown;
    };
};

export type ContentBlockRequest = {
    contentType: number;
    value?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ContentType = {
    readonly id: number;
    account: number;
    key: string;
    status?: CampaignStatusChoices;
    name: string;
    target?: CampaignTargetChoices;
    readonly jsonSchema: {
        [key: string]: unknown;
    };
    readonly compiledJsonSchema: {
        [key: string]: unknown;
    };
    uiSchema?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ContentTypeWrite = {
    readonly id: number;
    account: number;
    key: string;
    status?: CampaignStatusChoices;
    name: string;
    target?: CampaignTargetChoices;
    jsonSchema?: {
        [key: string]: unknown;
    };
    compiledJsonSchema?: {
        [key: string]: unknown;
    };
    uiSchema?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ContentTypeWriteRequest = {
    account: number;
    key: string;
    status?: CampaignStatusChoices;
    name: string;
    target?: CampaignTargetChoices;
    jsonSchema?: {
        [key: string]: unknown;
    };
    compiledJsonSchema?: {
        [key: string]: unknown;
    };
    uiSchema?: {
        [key: string]: unknown;
    };
};

/**
 * * `ABW` - Aruba (Abw)
 * * `AFG` - Afghanistan (Afg)
 * * `AGO` - Angola (Ago)
 * * `AIA` - Anguilla (Aia)
 * * `ALA` - Åland Islands (Ala)
 * * `ALB` - Albania (Alb)
 * * `AND` - Andorra (And)
 * * `ARE` - United Arab Emirates (Are)
 * * `ARG` - Argentina (Arg)
 * * `ARM` - Armenia (Arm)
 * * `ASM` - American Samoa (Asm)
 * * `ATA` - Antarctica (Ata)
 * * `ATF` - French Southern Territories (Atf)
 * * `ATG` - Antigua And Barbuda (Atg)
 * * `AUS` - Australia (Aus)
 * * `AUT` - Austria (Aut)
 * * `AZE` - Azerbaijan (Aze)
 * * `BDI` - Burundi (Bdi)
 * * `BEL` - Belgium (Bel)
 * * `BEN` - Benin (Ben)
 * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
 * * `BFA` - Burkina Faso (Bfa)
 * * `BGD` - Bangladesh (Bgd)
 * * `BGR` - Bulgaria (Bgr)
 * * `BHR` - Bahrain (Bhr)
 * * `BHS` - Bahamas (Bhs)
 * * `BIH` - Bosnia And Herzegovina (Bih)
 * * `BLM` - Saint Barthélemy (Blm)
 * * `BLR` - Belarus (Blr)
 * * `BLZ` - Belize (Blz)
 * * `BMU` - Bermuda (Bmu)
 * * `BOL` - Bolivia, Plurinational State Of (Bol)
 * * `BRA` - Brazil (Bra)
 * * `BRB` - Barbados (Brb)
 * * `BRN` - Brunei Darussalam (Brn)
 * * `BTN` - Bhutan (Btn)
 * * `BVT` - Bouvet Island (Bvt)
 * * `BWA` - Botswana (Bwa)
 * * `CAF` - Central African Republic (Caf)
 * * `CAN` - Canada (Can)
 * * `CCK` - Cocos (Keeling) Islands (Cck)
 * * `CHE` - Switzerland (Che)
 * * `CHL` - Chile (Chl)
 * * `CHN` - China (Chn)
 * * `CIV` - Côte D'Ivoire (Civ)
 * * `CMR` - Cameroon (Cmr)
 * * `COD` - Congo, The Democratic Republic Of The (Cod)
 * * `COG` - Congo (Cog)
 * * `COK` - Cook Islands (Cok)
 * * `COL` - Colombia (Col)
 * * `COM` - Comoros (Com)
 * * `CPV` - Cabo Verde (Cpv)
 * * `CRI` - Costa Rica (Cri)
 * * `CUB` - Cuba (Cub)
 * * `CUW` - Curaçao (Cuw)
 * * `CXR` - Christmas Island (Cxr)
 * * `CYM` - Cayman Islands (Cym)
 * * `CYP` - Cyprus (Cyp)
 * * `CZE` - Czechia (Cze)
 * * `DEU` - Germany (Deu)
 * * `DJI` - Djibouti (Dji)
 * * `DMA` - Dominica (Dma)
 * * `DNK` - Denmark (Dnk)
 * * `DOM` - Dominican Republic (Dom)
 * * `DZA` - Algeria (Dza)
 * * `ECU` - Ecuador (Ecu)
 * * `EGY` - Egypt (Egy)
 * * `ERI` - Eritrea (Eri)
 * * `ESH` - Western Sahara (Esh)
 * * `ESP` - Spain (Esp)
 * * `EST` - Estonia (Est)
 * * `ETH` - Ethiopia (Eth)
 * * `FIN` - Finland (Fin)
 * * `FJI` - Fiji (Fji)
 * * `FLK` - Falkland Islands (Malvinas) (Flk)
 * * `FRA` - France (Fra)
 * * `FRO` - Faroe Islands (Fro)
 * * `FSM` - Micronesia, Federated States Of (Fsm)
 * * `GAB` - Gabon (Gab)
 * * `GBR` - United Kingdom (Gbr)
 * * `GEO` - Georgia (Geo)
 * * `GGY` - Guernsey (Ggy)
 * * `GHA` - Ghana (Gha)
 * * `GIB` - Gibraltar (Gib)
 * * `GIN` - Guinea (Gin)
 * * `GLP` - Guadeloupe (Glp)
 * * `GMB` - Gambia (Gmb)
 * * `GNB` - Guinea-Bissau (Gnb)
 * * `GNQ` - Equatorial Guinea (Gnq)
 * * `GRC` - Greece (Grc)
 * * `GRD` - Grenada (Grd)
 * * `GRL` - Greenland (Grl)
 * * `GTM` - Guatemala (Gtm)
 * * `GUF` - French Guiana (Guf)
 * * `GUM` - Guam (Gum)
 * * `GUY` - Guyana (Guy)
 * * `HKG` - Hong Kong (Hkg)
 * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
 * * `HND` - Honduras (Hnd)
 * * `HRV` - Croatia (Hrv)
 * * `HTI` - Haiti (Hti)
 * * `HUN` - Hungary (Hun)
 * * `IDN` - Indonesia (Idn)
 * * `IMN` - Isle Of Man (Imn)
 * * `IND` - India (Ind)
 * * `IOT` - British Indian Ocean Territory (Iot)
 * * `IRL` - Ireland (Irl)
 * * `IRN` - Iran, Islamic Republic Of (Irn)
 * * `IRQ` - Iraq (Irq)
 * * `ISL` - Iceland (Isl)
 * * `ISR` - Israel (Isr)
 * * `ITA` - Italy (Ita)
 * * `JAM` - Jamaica (Jam)
 * * `JEY` - Jersey (Jey)
 * * `JOR` - Jordan (Jor)
 * * `JPN` - Japan (Jpn)
 * * `KAZ` - Kazakhstan (Kaz)
 * * `KEN` - Kenya (Ken)
 * * `KGZ` - Kyrgyzstan (Kgz)
 * * `KHM` - Cambodia (Khm)
 * * `KIR` - Kiribati (Kir)
 * * `KNA` - Saint Kitts And Nevis (Kna)
 * * `KOR` - Korea, Republic Of (Kor)
 * * `KWT` - Kuwait (Kwt)
 * * `LAO` - Lao People'S Democratic Republic (Lao)
 * * `LBN` - Lebanon (Lbn)
 * * `LBR` - Liberia (Lbr)
 * * `LBY` - Libya (Lby)
 * * `LCA` - Saint Lucia (Lca)
 * * `LIE` - Liechtenstein (Lie)
 * * `LKA` - Sri Lanka (Lka)
 * * `LSO` - Lesotho (Lso)
 * * `LTU` - Lithuania (Ltu)
 * * `LUX` - Luxembourg (Lux)
 * * `LVA` - Latvia (Lva)
 * * `MAC` - Macao (Mac)
 * * `MAF` - Saint Martin (French Part) (Maf)
 * * `MAR` - Morocco (Mar)
 * * `MCO` - Monaco (Mco)
 * * `MDA` - Moldova, Republic Of (Mda)
 * * `MDG` - Madagascar (Mdg)
 * * `MDV` - Maldives (Mdv)
 * * `MEX` - Mexico (Mex)
 * * `MHL` - Marshall Islands (Mhl)
 * * `MKD` - North Macedonia (Mkd)
 * * `MLI` - Mali (Mli)
 * * `MLT` - Malta (Mlt)
 * * `MMR` - Myanmar (Mmr)
 * * `MNE` - Montenegro (Mne)
 * * `MNG` - Mongolia (Mng)
 * * `MNP` - Northern Mariana Islands (Mnp)
 * * `MOZ` - Mozambique (Moz)
 * * `MRT` - Mauritania (Mrt)
 * * `MSR` - Montserrat (Msr)
 * * `MTQ` - Martinique (Mtq)
 * * `MUS` - Mauritius (Mus)
 * * `MWI` - Malawi (Mwi)
 * * `MYS` - Malaysia (Mys)
 * * `MYT` - Mayotte (Myt)
 * * `NAM` - Namibia (Nam)
 * * `NCL` - New Caledonia (Ncl)
 * * `NER` - Niger (Ner)
 * * `NFK` - Norfolk Island (Nfk)
 * * `NGA` - Nigeria (Nga)
 * * `NIC` - Nicaragua (Nic)
 * * `NIU` - Niue (Niu)
 * * `NLD` - Netherlands (Nld)
 * * `NOR` - Norway (Nor)
 * * `NPL` - Nepal (Npl)
 * * `NRU` - Nauru (Nru)
 * * `NZL` - New Zealand (Nzl)
 * * `OMN` - Oman (Omn)
 * * `PAK` - Pakistan (Pak)
 * * `PAN` - Panama (Pan)
 * * `PCN` - Pitcairn (Pcn)
 * * `PER` - Peru (Per)
 * * `PHL` - Philippines (Phl)
 * * `PLW` - Palau (Plw)
 * * `PNG` - Papua New Guinea (Png)
 * * `POL` - Poland (Pol)
 * * `PRI` - Puerto Rico (Pri)
 * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
 * * `PRT` - Portugal (Prt)
 * * `PRY` - Paraguay (Pry)
 * * `PSE` - Palestine, State Of (Pse)
 * * `PYF` - French Polynesia (Pyf)
 * * `QAT` - Qatar (Qat)
 * * `REU` - Réunion (Reu)
 * * `ROU` - Romania (Rou)
 * * `RUS` - Russian Federation (Rus)
 * * `RWA` - Rwanda (Rwa)
 * * `SAU` - Saudi Arabia (Sau)
 * * `SDN` - Sudan (Sdn)
 * * `SEN` - Senegal (Sen)
 * * `SGP` - Singapore (Sgp)
 * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
 * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
 * * `SJM` - Svalbard And Jan Mayen (Sjm)
 * * `SLB` - Solomon Islands (Slb)
 * * `SLE` - Sierra Leone (Sle)
 * * `SLV` - El Salvador (Slv)
 * * `SMR` - San Marino (Smr)
 * * `SOM` - Somalia (Som)
 * * `SPM` - Saint Pierre And Miquelon (Spm)
 * * `SRB` - Serbia (Srb)
 * * `SSD` - South Sudan (Ssd)
 * * `STP` - Sao Tome And Principe (Stp)
 * * `SUR` - Suriname (Sur)
 * * `SVK` - Slovakia (Svk)
 * * `SVN` - Slovenia (Svn)
 * * `SWE` - Sweden (Swe)
 * * `SWZ` - Eswatini (Swz)
 * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
 * * `SYC` - Seychelles (Syc)
 * * `SYR` - Syrian Arab Republic (Syr)
 * * `TCA` - Turks And Caicos Islands (Tca)
 * * `TCD` - Chad (Tcd)
 * * `TGO` - Togo (Tgo)
 * * `THA` - Thailand (Tha)
 * * `TJK` - Tajikistan (Tjk)
 * * `TKL` - Tokelau (Tkl)
 * * `TKM` - Turkmenistan (Tkm)
 * * `TLS` - Timor-Leste (Tls)
 * * `TON` - Tonga (Ton)
 * * `TTO` - Trinidad And Tobago (Tto)
 * * `TUN` - Tunisia (Tun)
 * * `TUR` - Türkiye (Tur)
 * * `TUV` - Tuvalu (Tuv)
 * * `TWN` - Taiwan, Province Of China (Twn)
 * * `TZA` - Tanzania, United Republic Of (Tza)
 * * `UGA` - Uganda (Uga)
 * * `UKR` - Ukraine (Ukr)
 * * `UMI` - United States Minor Outlying Islands (Umi)
 * * `URY` - Uruguay (Ury)
 * * `USA` - United States (Usa)
 * * `UZB` - Uzbekistan (Uzb)
 * * `VAT` - Holy See (Vatican City State) (Vat)
 * * `VCT` - Saint Vincent And The Grenadines (Vct)
 * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
 * * `VGB` - Virgin Islands, British (Vgb)
 * * `VIR` - Virgin Islands, U.S. (Vir)
 * * `VNM` - Viet Nam (Vnm)
 * * `VUT` - Vanuatu (Vut)
 * * `WLF` - Wallis And Futuna (Wlf)
 * * `WSM` - Samoa (Wsm)
 * * `YEM` - Yemen (Yem)
 * * `ZAF` - South Africa (Zaf)
 * * `ZMB` - Zambia (Zmb)
 * * `ZWE` - Zimbabwe (Zwe)
 */
export enum CountriesIso3166Enum {
    ABW = 'ABW',
    AFG = 'AFG',
    AGO = 'AGO',
    AIA = 'AIA',
    ALA = 'ALA',
    ALB = 'ALB',
    AND = 'AND',
    ARE = 'ARE',
    ARG = 'ARG',
    ARM = 'ARM',
    ASM = 'ASM',
    ATA = 'ATA',
    ATF = 'ATF',
    ATG = 'ATG',
    AUS = 'AUS',
    AUT = 'AUT',
    AZE = 'AZE',
    BDI = 'BDI',
    BEL = 'BEL',
    BEN = 'BEN',
    BES = 'BES',
    BFA = 'BFA',
    BGD = 'BGD',
    BGR = 'BGR',
    BHR = 'BHR',
    BHS = 'BHS',
    BIH = 'BIH',
    BLM = 'BLM',
    BLR = 'BLR',
    BLZ = 'BLZ',
    BMU = 'BMU',
    BOL = 'BOL',
    BRA = 'BRA',
    BRB = 'BRB',
    BRN = 'BRN',
    BTN = 'BTN',
    BVT = 'BVT',
    BWA = 'BWA',
    CAF = 'CAF',
    CAN = 'CAN',
    CCK = 'CCK',
    CHE = 'CHE',
    CHL = 'CHL',
    CHN = 'CHN',
    CIV = 'CIV',
    CMR = 'CMR',
    COD = 'COD',
    COG = 'COG',
    COK = 'COK',
    COL = 'COL',
    COM = 'COM',
    CPV = 'CPV',
    CRI = 'CRI',
    CUB = 'CUB',
    CUW = 'CUW',
    CXR = 'CXR',
    CYM = 'CYM',
    CYP = 'CYP',
    CZE = 'CZE',
    DEU = 'DEU',
    DJI = 'DJI',
    DMA = 'DMA',
    DNK = 'DNK',
    DOM = 'DOM',
    DZA = 'DZA',
    ECU = 'ECU',
    EGY = 'EGY',
    ERI = 'ERI',
    ESH = 'ESH',
    ESP = 'ESP',
    EST = 'EST',
    ETH = 'ETH',
    FIN = 'FIN',
    FJI = 'FJI',
    FLK = 'FLK',
    FRA = 'FRA',
    FRO = 'FRO',
    FSM = 'FSM',
    GAB = 'GAB',
    GBR = 'GBR',
    GEO = 'GEO',
    GGY = 'GGY',
    GHA = 'GHA',
    GIB = 'GIB',
    GIN = 'GIN',
    GLP = 'GLP',
    GMB = 'GMB',
    GNB = 'GNB',
    GNQ = 'GNQ',
    GRC = 'GRC',
    GRD = 'GRD',
    GRL = 'GRL',
    GTM = 'GTM',
    GUF = 'GUF',
    GUM = 'GUM',
    GUY = 'GUY',
    HKG = 'HKG',
    HMD = 'HMD',
    HND = 'HND',
    HRV = 'HRV',
    HTI = 'HTI',
    HUN = 'HUN',
    IDN = 'IDN',
    IMN = 'IMN',
    IND = 'IND',
    IOT = 'IOT',
    IRL = 'IRL',
    IRN = 'IRN',
    IRQ = 'IRQ',
    ISL = 'ISL',
    ISR = 'ISR',
    ITA = 'ITA',
    JAM = 'JAM',
    JEY = 'JEY',
    JOR = 'JOR',
    JPN = 'JPN',
    KAZ = 'KAZ',
    KEN = 'KEN',
    KGZ = 'KGZ',
    KHM = 'KHM',
    KIR = 'KIR',
    KNA = 'KNA',
    KOR = 'KOR',
    KWT = 'KWT',
    LAO = 'LAO',
    LBN = 'LBN',
    LBR = 'LBR',
    LBY = 'LBY',
    LCA = 'LCA',
    LIE = 'LIE',
    LKA = 'LKA',
    LSO = 'LSO',
    LTU = 'LTU',
    LUX = 'LUX',
    LVA = 'LVA',
    MAC = 'MAC',
    MAF = 'MAF',
    MAR = 'MAR',
    MCO = 'MCO',
    MDA = 'MDA',
    MDG = 'MDG',
    MDV = 'MDV',
    MEX = 'MEX',
    MHL = 'MHL',
    MKD = 'MKD',
    MLI = 'MLI',
    MLT = 'MLT',
    MMR = 'MMR',
    MNE = 'MNE',
    MNG = 'MNG',
    MNP = 'MNP',
    MOZ = 'MOZ',
    MRT = 'MRT',
    MSR = 'MSR',
    MTQ = 'MTQ',
    MUS = 'MUS',
    MWI = 'MWI',
    MYS = 'MYS',
    MYT = 'MYT',
    NAM = 'NAM',
    NCL = 'NCL',
    NER = 'NER',
    NFK = 'NFK',
    NGA = 'NGA',
    NIC = 'NIC',
    NIU = 'NIU',
    NLD = 'NLD',
    NOR = 'NOR',
    NPL = 'NPL',
    NRU = 'NRU',
    NZL = 'NZL',
    OMN = 'OMN',
    PAK = 'PAK',
    PAN = 'PAN',
    PCN = 'PCN',
    PER = 'PER',
    PHL = 'PHL',
    PLW = 'PLW',
    PNG = 'PNG',
    POL = 'POL',
    PRI = 'PRI',
    PRK = 'PRK',
    PRT = 'PRT',
    PRY = 'PRY',
    PSE = 'PSE',
    PYF = 'PYF',
    QAT = 'QAT',
    REU = 'REU',
    ROU = 'ROU',
    RUS = 'RUS',
    RWA = 'RWA',
    SAU = 'SAU',
    SDN = 'SDN',
    SEN = 'SEN',
    SGP = 'SGP',
    SGS = 'SGS',
    SHN = 'SHN',
    SJM = 'SJM',
    SLB = 'SLB',
    SLE = 'SLE',
    SLV = 'SLV',
    SMR = 'SMR',
    SOM = 'SOM',
    SPM = 'SPM',
    SRB = 'SRB',
    SSD = 'SSD',
    STP = 'STP',
    SUR = 'SUR',
    SVK = 'SVK',
    SVN = 'SVN',
    SWE = 'SWE',
    SWZ = 'SWZ',
    SXM = 'SXM',
    SYC = 'SYC',
    SYR = 'SYR',
    TCA = 'TCA',
    TCD = 'TCD',
    TGO = 'TGO',
    THA = 'THA',
    TJK = 'TJK',
    TKL = 'TKL',
    TKM = 'TKM',
    TLS = 'TLS',
    TON = 'TON',
    TTO = 'TTO',
    TUN = 'TUN',
    TUR = 'TUR',
    TUV = 'TUV',
    TWN = 'TWN',
    TZA = 'TZA',
    UGA = 'UGA',
    UKR = 'UKR',
    UMI = 'UMI',
    URY = 'URY',
    USA = 'USA',
    UZB = 'UZB',
    VAT = 'VAT',
    VCT = 'VCT',
    VEN = 'VEN',
    VGB = 'VGB',
    VIR = 'VIR',
    VNM = 'VNM',
    VUT = 'VUT',
    WLF = 'WLF',
    WSM = 'WSM',
    YEM = 'YEM',
    ZAF = 'ZAF',
    ZMB = 'ZMB',
    ZWE = 'ZWE'
}

export type Courier = {
    readonly id: number;
    name: string;
    key: string;
    type?: string;
    exposeToCustomers?: boolean;
};

export type CourierRequest = {
    name: string;
    key: string;
    type?: string;
    exposeToCustomers?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type CourierServiceLevel = {
    readonly id: number;
    account: number;
    courierServiceLevel: string;
    /**
     * From slow to fast: Standard > Expedited > Express
     *
     * * `standard` - Standard
     * * `unused` - Unused
     * * `express` - Express
     * * `expedited` - Expedited
     */
    parcellabGlobalServiceLevel: ParcellabGlobalServiceLevelEnum;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type CourierServiceLevelRequest = {
    account: number;
    courierServiceLevel: string;
    /**
     * From slow to fast: Standard > Expedited > Express
     *
     * * `standard` - Standard
     * * `unused` - Unused
     * * `express` - Express
     * * `expedited` - Expedited
     */
    parcellabGlobalServiceLevel: ParcellabGlobalServiceLevelEnum;
};

/**
 * Adds nested create feature
 */
export type CreatMessage = {
    readonly id: number;
    messageType: number;
    readonly account: number;
    client?: number | null;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific messages
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    /**
     * Select a layout *only* if you want to overide the auto layout configuration of the client(s).
     */
    layout?: number | null;
    subject?: string;
    /**
     * Short text of the message, e.g. for preview.
     */
    shortInfo?: string;
    content?: string;
    placeholderValues: Array<PlaceholderValue>;
    attachments?: Array<number>;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    /**
     * Enable or disable the message, if not active, message will not be sent regardless of flow triggers.
     */
    active?: boolean;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    /**
     * Partials that are being used in the message.
     */
    readonly partials: Array<number>;
    readonly updatedAt: string;
    readonly experiment: number | null;
    variantLabel: VariantLabelEnum | null;
    /**
     * Duplicate existing message placeholders to the new message.
     */
    duplicateMessagePlaceholders?: boolean;
};

/**
 * Adds nested create feature
 */
export type CreatMessageRequest = {
    messageType: number;
    client?: number | null;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific messages
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    /**
     * Select a layout *only* if you want to overide the auto layout configuration of the client(s).
     */
    layout?: number | null;
    subject?: string;
    /**
     * Short text of the message, e.g. for preview.
     */
    shortInfo?: string;
    content?: string;
    placeholderValues: Array<PlaceholderValueRequest>;
    attachments?: Array<number>;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    /**
     * Enable or disable the message, if not active, message will not be sent regardless of flow triggers.
     */
    active?: boolean;
    /**
     * Duplicate existing message placeholders to the new message.
     */
    duplicateMessagePlaceholders?: boolean;
};

export type CustomAnalytics = {
    readonly id: number;
    /**
     * Accounts associated with this analytics dashboard
     */
    accounts: Array<number>;
    /**
     * Title of the custom analytics
     */
    title: string;
    /**
     * Analytic type, e.g. dashboard, question, metric
     *
     * * `dashboard` - Dashboard
     * * `question` - Question
     * * `metric` - Metric
     */
    analytics_type: AnalyticsTypeEnum;
    /**
     * The unique identifier of the Metabase object (dashboard, question, or metric) used for embedding or referencing in the analytics system.
     */
    entity_id: number;
};

export type CustomAnalyticsRequest = {
    /**
     * Accounts associated with this analytics dashboard
     */
    accounts: Array<number>;
    /**
     * Title of the custom analytics
     */
    title: string;
    /**
     * Analytic type, e.g. dashboard, question, metric
     *
     * * `dashboard` - Dashboard
     * * `question` - Question
     * * `metric` - Metric
     */
    analytics_type: AnalyticsTypeEnum;
    /**
     * The unique identifier of the Metabase object (dashboard, question, or metric) used for embedding or referencing in the analytics system.
     */
    entity_id: number;
};

/**
 * Adds nested create feature
 */
export type CustomAppCreate = {
    readonly id: number;
    account: number;
    key: string;
    name: string;
    description?: string;
    type?: CustomAppTypeEnum;
    runtime?: RuntimeEnum;
    readonly isActive: boolean;
    images?: Array<Images>;
    publicDescription?: string;
    prerequisites?: string;
    color?: string;
    tags: Array<string>;
    isOfficial?: boolean;
    iconImage?: string;
    author?: string;
    readonly uniqueId: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    placeholders?: Array<string>;
    readonly hasReleasedVersion: boolean;
};

/**
 * Adds nested create feature
 */
export type CustomAppCreateRequest = {
    account: number;
    key: string;
    name: string;
    description?: string;
    type?: CustomAppTypeEnum;
    runtime?: RuntimeEnum;
    images?: Array<ImagesRequest>;
    publicDescription?: string;
    prerequisites?: string;
    color?: string;
    tags: Array<string>;
    isOfficial?: boolean;
    iconImage?: Blob | File;
    author?: string;
    placeholders?: Array<string>;
    /**
     * Instructions to generate the app code.
     */
    prompt?: string;
};

/**
 * * `outbound` - Outbound Template
 * * `event_processor` - Event Processor
 * * `tracking_enhancement` - Tracking Enhancement
 * * `payload_rewrite` - Payload Rewrites
 * * `order_status_plugin` - Order Status Page Plugin
 * * `noop` - No-op
 */
export enum CustomAppTypeEnum {
    OUTBOUND = 'outbound',
    EVENT_PROCESSOR = 'event_processor',
    TRACKING_ENHANCEMENT = 'tracking_enhancement',
    PAYLOAD_REWRITE = 'payload_rewrite',
    ORDER_STATUS_PLUGIN = 'order_status_plugin',
    NOOP = 'noop'
}

/**
 * Adds nested create feature
 */
export type CustomAppUpdate = {
    readonly id: number;
    readonly account: number;
    readonly key: string;
    name: string;
    description?: string;
    type: CustomAppTypeEnum;
    runtime: RuntimeEnum;
    readonly isActive: boolean;
    images?: Array<Images>;
    publicDescription?: string;
    prerequisites?: string;
    color?: string;
    tags: Array<string>;
    isOfficial?: boolean;
    iconImage?: string;
    author?: string;
    readonly uniqueId: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    placeholders?: Array<string>;
    hasReleasedVersion?: boolean;
};

/**
 * Adds nested create feature
 */
export type CustomAppUpdateRequest = {
    name: string;
    description?: string;
    images?: Array<ImagesRequest>;
    publicDescription?: string;
    prerequisites?: string;
    color?: string;
    tags: Array<string>;
    isOfficial?: boolean;
    iconImage?: Blob | File;
    author?: string;
    placeholders?: Array<string>;
    /**
     * Instructions to generate the app code.
     */
    prompt?: string;
    hasReleasedVersion?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type CustomerPortal = {
    readonly id: number;
    account: number;
    name: string;
    service: number;
    hasProofOfDelivery?: boolean;
    hasOrderStatusStyleEditor?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type CustomerPortalRequest = {
    account: number;
    name: string;
    service: number;
    hasProofOfDelivery?: boolean;
    hasOrderStatusStyleEditor?: boolean;
};

export type CustomizationDetails = {
    backgroundStyle?: string | unknown;
    backgroundUrl?: string | number | {
        [key: string]: unknown;
    } | unknown;
    headerBackgroundColor?: string | unknown;
    highlightColor?: string | unknown;
    logoSize?: string | unknown;
    logoUrl?: string | number | {
        [key: string]: unknown;
    } | unknown;
    logoWidth?: number | unknown;
    trustpilot?: string | number | {
        [key: string]: unknown;
    } | unknown;
    template?: string | number | {
        [key: string]: unknown;
    } | unknown;
    reviewUrl?: string | number | {
        [key: string]: unknown;
    } | unknown;
    trackingUrl?: string | number | {
        [key: string]: unknown;
    } | unknown;
    trackingUrlReturns?: string | number | {
        [key: string]: unknown;
    } | unknown;
    PickupMapsImageWidth?: string | unknown;
    TextStyling?: string | unknown;
};

export type CutoffTimesPerDay = {
    /**
     * Monday
     */
    monday?: Array<string>;
    /**
     * Tuesday
     */
    tuesday?: Array<string>;
    /**
     * Wednesday
     */
    wednesday?: Array<string>;
    /**
     * Thursday
     */
    thursday?: Array<string>;
    /**
     * Friday
     */
    friday?: Array<string>;
    /**
     * Saturday
     */
    saturday?: Array<string>;
    /**
     * Sunday
     */
    sunday?: Array<string>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DataProtectionRequest = {
    readonly id: number;
    account: number;
    readonly user: number;
    requestDenyList?: boolean;
    requestRemoval?: boolean;
    readonly subjectEmailHash: string;
    readonly evidence: {
        [key: string]: unknown;
    } | null;
    status: DataProtectionStatusChoices;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DataProtectionRequestRequest = {
    readonly id: number;
    account: number;
    readonly user: number;
    requestDenyList?: boolean;
    requestRemoval?: boolean;
    readonly subjectEmailHash: string;
    readonly evidence: {
        [key: string]: unknown;
    } | null;
    status: DataProtectionStatusChoices;
    email: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DataProtectionRequestRequestRequest = {
    account: number;
    requestDenyList?: boolean;
    requestRemoval?: boolean;
    email: string;
};

/**
 * * `requested` - Requested
 * * `completed` - Completed
 * * `failed` - Failed
 */
export enum DataProtectionStatusChoices {
    REQUESTED = 'requested',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export enum DayOfWeek {
    MON = 'mon',
    TUE = 'tue',
    WED = 'wed',
    THU = 'thu',
    FRI = 'fri',
    SAT = 'sat',
    SUN = 'sun'
}

/**
 * * `mul` - Multi Language
 * * `aa` - Afar (Aa)
 * * `ab` - Abkhazian (Ab)
 * * `ae` - Avestan (Ae)
 * * `af` - Afrikaans (Af)
 * * `ak` - Akan (Ak)
 * * `am` - Amharic (Am)
 * * `an` - Aragonese (An)
 * * `ar` - Arabic (Ar)
 * * `as` - Assamese (As)
 * * `av` - Avaric (Av)
 * * `ay` - Aymara (Ay)
 * * `az` - Azerbaijani (Az)
 * * `ba` - Bashkir (Ba)
 * * `be` - Belarusian (Be)
 * * `bg` - Bulgarian (Bg)
 * * `bi` - Bislama (Bi)
 * * `bm` - Bambara (Bm)
 * * `bn` - Bengali (Bn)
 * * `bo` - Tibetan (Bo)
 * * `br` - Breton (Br)
 * * `bs` - Bosnian (Bs)
 * * `ca` - Catalan (Ca)
 * * `ce` - Chechen (Ce)
 * * `ch` - Chamorro (Ch)
 * * `co` - Corsican (Co)
 * * `cr` - Cree (Cr)
 * * `cs` - Czech (Cs)
 * * `cu` - Church Slavic (Cu)
 * * `cv` - Chuvash (Cv)
 * * `cy` - Welsh (Cy)
 * * `da` - Danish (Da)
 * * `de` - German (De)
 * * `dv` - Dhivehi (Dv)
 * * `dz` - Dzongkha (Dz)
 * * `ee` - Ewe (Ee)
 * * `el` - Modern Greek (1453-) (El)
 * * `en` - English (En)
 * * `eo` - Esperanto (Eo)
 * * `es` - Spanish (Es)
 * * `et` - Estonian (Et)
 * * `eu` - Basque (Eu)
 * * `fa` - Persian (Fa)
 * * `ff` - Fulah (Ff)
 * * `fi` - Finnish (Fi)
 * * `fj` - Fijian (Fj)
 * * `fo` - Faroese (Fo)
 * * `fr` - French (Fr)
 * * `fy` - Western Frisian (Fy)
 * * `ga` - Irish (Ga)
 * * `gd` - Scottish Gaelic (Gd)
 * * `gl` - Galician (Gl)
 * * `gn` - Guarani (Gn)
 * * `gu` - Gujarati (Gu)
 * * `gv` - Manx (Gv)
 * * `ha` - Hausa (Ha)
 * * `he` - Hebrew (He)
 * * `hi` - Hindi (Hi)
 * * `ho` - Hiri Motu (Ho)
 * * `hr` - Croatian (Hr)
 * * `ht` - Haitian (Ht)
 * * `hu` - Hungarian (Hu)
 * * `hy` - Armenian (Hy)
 * * `hz` - Herero (Hz)
 * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
 * * `id` - Indonesian (Id)
 * * `ie` - Interlingue (Ie)
 * * `ig` - Igbo (Ig)
 * * `ii` - Sichuan Yi (Ii)
 * * `ik` - Inupiaq (Ik)
 * * `io` - Ido (Io)
 * * `is` - Icelandic (Is)
 * * `it` - Italian (It)
 * * `iu` - Inuktitut (Iu)
 * * `ja` - Japanese (Ja)
 * * `jv` - Javanese (Jv)
 * * `ka` - Georgian (Ka)
 * * `kg` - Kongo (Kg)
 * * `ki` - Kikuyu (Ki)
 * * `kj` - Kuanyama (Kj)
 * * `kk` - Kazakh (Kk)
 * * `kl` - Kalaallisut (Kl)
 * * `km` - Khmer (Km)
 * * `kn` - Kannada (Kn)
 * * `ko` - Korean (Ko)
 * * `kr` - Kanuri (Kr)
 * * `ks` - Kashmiri (Ks)
 * * `ku` - Kurdish (Ku)
 * * `kv` - Komi (Kv)
 * * `kw` - Cornish (Kw)
 * * `ky` - Kirghiz (Ky)
 * * `la` - Latin (La)
 * * `lb` - Luxembourgish (Lb)
 * * `lg` - Ganda (Lg)
 * * `li` - Limburgan (Li)
 * * `ln` - Lingala (Ln)
 * * `lo` - Lao (Lo)
 * * `lt` - Lithuanian (Lt)
 * * `lu` - Luba-Katanga (Lu)
 * * `lv` - Latvian (Lv)
 * * `mg` - Malagasy (Mg)
 * * `mh` - Marshallese (Mh)
 * * `mi` - Maori (Mi)
 * * `mk` - Macedonian (Mk)
 * * `ml` - Malayalam (Ml)
 * * `mn` - Mongolian (Mn)
 * * `mr` - Marathi (Mr)
 * * `ms` - Malay (Macrolanguage) (Ms)
 * * `mt` - Maltese (Mt)
 * * `my` - Burmese (My)
 * * `na` - Nauru (Na)
 * * `nb` - Norwegian Bokmål (Nb)
 * * `nd` - North Ndebele (Nd)
 * * `ne` - Nepali (Macrolanguage) (Ne)
 * * `ng` - Ndonga (Ng)
 * * `nl` - Dutch (Nl)
 * * `nn` - Norwegian Nynorsk (Nn)
 * * `no` - Norwegian (No)
 * * `nr` - South Ndebele (Nr)
 * * `nv` - Navajo (Nv)
 * * `ny` - Nyanja (Ny)
 * * `oc` - Occitan (Post 1500) (Oc)
 * * `oj` - Ojibwa (Oj)
 * * `om` - Oromo (Om)
 * * `or` - Oriya (Macrolanguage) (Or)
 * * `os` - Ossetian (Os)
 * * `pa` - Panjabi (Pa)
 * * `pi` - Pali (Pi)
 * * `pl` - Polish (Pl)
 * * `ps` - Pushto (Ps)
 * * `pt` - Portuguese (Pt)
 * * `qu` - Quechua (Qu)
 * * `rm` - Romansh (Rm)
 * * `rn` - Rundi (Rn)
 * * `ro` - Romanian (Ro)
 * * `ru` - Russian (Ru)
 * * `rw` - Kinyarwanda (Rw)
 * * `sa` - Sanskrit (Sa)
 * * `sc` - Sardinian (Sc)
 * * `sd` - Sindhi (Sd)
 * * `se` - Northern Sami (Se)
 * * `sg` - Sango (Sg)
 * * `sh` - Serbo-Croatian (Sh)
 * * `si` - Sinhala (Si)
 * * `sk` - Slovak (Sk)
 * * `sl` - Slovenian (Sl)
 * * `sm` - Samoan (Sm)
 * * `sn` - Shona (Sn)
 * * `so` - Somali (So)
 * * `sq` - Albanian (Sq)
 * * `sr` - Serbian (Sr)
 * * `ss` - Swati (Ss)
 * * `st` - Southern Sotho (St)
 * * `su` - Sundanese (Su)
 * * `sv` - Swedish (Sv)
 * * `sw` - Swahili (Macrolanguage) (Sw)
 * * `ta` - Tamil (Ta)
 * * `te` - Telugu (Te)
 * * `tg` - Tajik (Tg)
 * * `th` - Thai (Th)
 * * `ti` - Tigrinya (Ti)
 * * `tk` - Turkmen (Tk)
 * * `tl` - Tagalog (Tl)
 * * `tn` - Tswana (Tn)
 * * `to` - Tonga (Tonga Islands) (To)
 * * `tr` - Turkish (Tr)
 * * `ts` - Tsonga (Ts)
 * * `tt` - Tatar (Tt)
 * * `tw` - Twi (Tw)
 * * `ty` - Tahitian (Ty)
 * * `ug` - Uighur (Ug)
 * * `uk` - Ukrainian (Uk)
 * * `ur` - Urdu (Ur)
 * * `uz` - Uzbek (Uz)
 * * `ve` - Venda (Ve)
 * * `vi` - Vietnamese (Vi)
 * * `vo` - Volapük (Vo)
 * * `wa` - Walloon (Wa)
 * * `wo` - Wolof (Wo)
 * * `xh` - Xhosa (Xh)
 * * `yi` - Yiddish (Yi)
 * * `yo` - Yoruba (Yo)
 * * `za` - Zhuang (Za)
 * * `zh` - Chinese (Zh)
 * * `zu` - Zulu (Zu)
 */
export enum DefaultLanguageEnum {
    MUL = 'mul',
    AA = 'aa',
    AB = 'ab',
    AE = 'ae',
    AF = 'af',
    AK = 'ak',
    AM = 'am',
    AN = 'an',
    AR = 'ar',
    AS = 'as',
    AV = 'av',
    AY = 'ay',
    AZ = 'az',
    BA = 'ba',
    BE = 'be',
    BG = 'bg',
    BI = 'bi',
    BM = 'bm',
    BN = 'bn',
    BO = 'bo',
    BR = 'br',
    BS = 'bs',
    CA = 'ca',
    CE = 'ce',
    CH = 'ch',
    CO = 'co',
    CR = 'cr',
    CS = 'cs',
    CU = 'cu',
    CV = 'cv',
    CY = 'cy',
    DA = 'da',
    DE = 'de',
    DV = 'dv',
    DZ = 'dz',
    EE = 'ee',
    EL = 'el',
    EN = 'en',
    EO = 'eo',
    ES = 'es',
    ET = 'et',
    EU = 'eu',
    FA = 'fa',
    FF = 'ff',
    FI = 'fi',
    FJ = 'fj',
    FO = 'fo',
    FR = 'fr',
    FY = 'fy',
    GA = 'ga',
    GD = 'gd',
    GL = 'gl',
    GN = 'gn',
    GU = 'gu',
    GV = 'gv',
    HA = 'ha',
    HE = 'he',
    HI = 'hi',
    HO = 'ho',
    HR = 'hr',
    HT = 'ht',
    HU = 'hu',
    HY = 'hy',
    HZ = 'hz',
    IA = 'ia',
    ID = 'id',
    IE = 'ie',
    IG = 'ig',
    II = 'ii',
    IK = 'ik',
    IO = 'io',
    IS = 'is',
    IT = 'it',
    IU = 'iu',
    JA = 'ja',
    JV = 'jv',
    KA = 'ka',
    KG = 'kg',
    KI = 'ki',
    KJ = 'kj',
    KK = 'kk',
    KL = 'kl',
    KM = 'km',
    KN = 'kn',
    KO = 'ko',
    KR = 'kr',
    KS = 'ks',
    KU = 'ku',
    KV = 'kv',
    KW = 'kw',
    KY = 'ky',
    LA = 'la',
    LB = 'lb',
    LG = 'lg',
    LI = 'li',
    LN = 'ln',
    LO = 'lo',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    MG = 'mg',
    MH = 'mh',
    MI = 'mi',
    MK = 'mk',
    ML = 'ml',
    MN = 'mn',
    MR = 'mr',
    MS = 'ms',
    MT = 'mt',
    MY = 'my',
    NA = 'na',
    NB = 'nb',
    ND = 'nd',
    NE = 'ne',
    NG = 'ng',
    NL = 'nl',
    NN = 'nn',
    NO = 'no',
    NR = 'nr',
    NV = 'nv',
    NY = 'ny',
    OC = 'oc',
    OJ = 'oj',
    OM = 'om',
    OR = 'or',
    OS = 'os',
    PA = 'pa',
    PI = 'pi',
    PL = 'pl',
    PS = 'ps',
    PT = 'pt',
    QU = 'qu',
    RM = 'rm',
    RN = 'rn',
    RO = 'ro',
    RU = 'ru',
    RW = 'rw',
    SA = 'sa',
    SC = 'sc',
    SD = 'sd',
    SE = 'se',
    SG = 'sg',
    SH = 'sh',
    SI = 'si',
    SK = 'sk',
    SL = 'sl',
    SM = 'sm',
    SN = 'sn',
    SO = 'so',
    SQ = 'sq',
    SR = 'sr',
    SS = 'ss',
    ST = 'st',
    SU = 'su',
    SV = 'sv',
    SW = 'sw',
    TA = 'ta',
    TE = 'te',
    TG = 'tg',
    TH = 'th',
    TI = 'ti',
    TK = 'tk',
    TL = 'tl',
    TN = 'tn',
    TO = 'to',
    TR = 'tr',
    TS = 'ts',
    TT = 'tt',
    TW = 'tw',
    TY = 'ty',
    UG = 'ug',
    UK = 'uk',
    UR = 'ur',
    UZ = 'uz',
    VE = 've',
    VI = 'vi',
    VO = 'vo',
    WA = 'wa',
    WO = 'wo',
    XH = 'xh',
    YI = 'yi',
    YO = 'yo',
    ZA = 'za',
    ZH = 'zh',
    ZU = 'zu'
}

/**
 * * `=` - =
 * * `!=` - !=
 * * `<` - <
 * * `<=` - <=
 * * `>=` - >=
 * * `>` - >
 * * `between` - between
 * * `notBetween` - notBetween
 * * `null` - null
 * * `notNull` - notNull
 * * `contains` - contains
 * * `doesNotContain` - doesNotContain
 * * `beginsWith` - beginsWith
 * * `endsWith` - endsWith
 * * `doesNotBeginWith` - doesNotBeginWith
 * * `doesNotEndWith` - doesNotEndWith
 * * `in` - in
 * * `notIn` - notIn
 */
export enum DefaultOperatorEnum {
    '=' = '=',
    '!=' = '!=',
    '<' = '<',
    '<=' = '<=',
    '>=' = '>=',
    '>' = '>',
    BETWEEN = 'between',
    NOT_BETWEEN = 'notBetween',
    NULL = 'null',
    NOT_NULL = 'notNull',
    CONTAINS = 'contains',
    DOES_NOT_CONTAIN = 'doesNotContain',
    BEGINS_WITH = 'beginsWith',
    ENDS_WITH = 'endsWith',
    DOES_NOT_BEGIN_WITH = 'doesNotBeginWith',
    DOES_NOT_END_WITH = 'doesNotEndWith',
    IN = 'in',
    NOT_IN = 'notIn'
}

export enum DelayReferenceChoices {
    NOW = 'now',
    REFERENCE_KEY = 'reference_key',
    OFFSET_KEY = 'offset_key',
    OFFSET_AND_REFERENCE_KEY = 'offset_and_reference_key'
}

/**
 * * `now` - Now
 * * `reference_key` - Reference Key
 * * `offset_key` - Offset Key
 * * `offset_and_reference_key` - Offset And Reference Key
 */
export enum DelayReferenceEnum {
    NOW = 'now',
    REFERENCE_KEY = 'reference_key',
    OFFSET_KEY = 'offset_key',
    OFFSET_AND_REFERENCE_KEY = 'offset_and_reference_key'
}

/**
 * * `WEEK` - Week
 * * `DAY` - Day
 * * `HOUR` - Hour
 * * `MINUTE` - Minute
 * * `SECOND` - Second
 */
export enum DelayUnitEnum {
    WEEK = 'WEEK',
    DAY = 'DAY',
    HOUR = 'HOUR',
    MINUTE = 'MINUTE',
    SECOND = 'SECOND'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DeliveryMethod = {
    readonly id: number;
    account: number;
    /**
     * Unique ID for the delivery method, returned by API
     */
    name: string;
    /**
     * Description for the delivery method
     */
    description: string;
    warehouse?: number | null;
    courier?: number | null;
    /**
     * List of alternative courier codes used in retailer systems, can be used for API calls
     */
    courierAlias?: Array<string>;
    courierServiceLevel: Array<number>;
    /**
     * Calibration of the prediction: Does not give earlier delivery dates, but smaller delivery date ranges — aggressive will try to go for 1 day delivery window, conservative will try to achieve very high hit rate
     *
     * * `balanced` - Balanced
     * * `conservative` - Conservative
     * * `aggressive` - Aggressive
     */
    calibration?: CalibrationEnum;
    countries?: Array<CountriesIso3166Enum>;
    regions?: Array<RegionEnum>;
    workingDays?: WorkingDaysSchemaType;
    cutoffTime?: string;
    /**
     * Select true if cutoff time after midnight counts for orders placed on the day prior<br /><i>Example:</i> Order placed on Friday at 20:00 with cutoff 16:00 and working days Mon through Fri — if checkbox is true then order will be shipped on Saturday (because the cutoff is Friday + next day = Saturday at 4pm), if false then on Monday (because the next cutoff is Monday 4pm)
     */
    cutoffInNextDay?: boolean;
    cutoffTimesPerDay?: CutoffTimesPerDay;
    /**
     * Handling time <b><u>before</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    warehouseHandlingTime?: number | null;
    warehouseHandlingTimePerDay?: HandlingTimePerDay;
    /**
     * Handling time <b><u>after</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    handlingTime?: number | null;
    handlingTimePerDay?: HandlingTimePerDay;
    /**
     * If true, fallback will be used even if prediction is available
     */
    alwaysUseFallback?: boolean;
    /**
     * In courier working days
     */
    fallbackMin?: number | null;
    /**
     * In courier working days
     */
    fallbackMax?: number | null;
    /**
     * In courier working days
     */
    predictionMin?: number | null;
    /**
     * In courier working days
     */
    predictionMax?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DeliveryMethodDetails = {
    readonly id: number;
    account: number;
    /**
     * Unique ID for the delivery method, returned by API
     */
    name: string;
    /**
     * Description for the delivery method
     */
    description: string;
    warehouse: Warehouse;
    readonly courier: string;
    /**
     * List of alternative courier codes used in retailer systems, can be used for API calls
     */
    courierAlias?: Array<string>;
    readonly courierServiceLevel: Array<CourierServiceLevel>;
    /**
     * Calibration of the prediction: Does not give earlier delivery dates, but smaller delivery date ranges — aggressive will try to go for 1 day delivery window, conservative will try to achieve very high hit rate
     *
     * * `balanced` - Balanced
     * * `conservative` - Conservative
     * * `aggressive` - Aggressive
     */
    calibration?: CalibrationEnum;
    countries?: Array<CountriesIso3166Enum>;
    regions?: Array<RegionEnum>;
    workingDays?: WorkingDaysSchemaType;
    cutoffTime?: string;
    /**
     * Select true if cutoff time after midnight counts for orders placed on the day prior<br /><i>Example:</i> Order placed on Friday at 20:00 with cutoff 16:00 and working days Mon through Fri — if checkbox is true then order will be shipped on Saturday (because the cutoff is Friday + next day = Saturday at 4pm), if false then on Monday (because the next cutoff is Monday 4pm)
     */
    cutoffInNextDay?: boolean;
    cutoffTimesPerDay?: CutoffTimesPerDay;
    /**
     * Handling time <b><u>before</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    warehouseHandlingTime?: number | null;
    warehouseHandlingTimePerDay?: HandlingTimePerDay;
    /**
     * Handling time <b><u>after</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    handlingTime?: number | null;
    handlingTimePerDay?: HandlingTimePerDay;
    /**
     * If true, fallback will be used even if prediction is available
     */
    alwaysUseFallback?: boolean;
    /**
     * In courier working days
     */
    fallbackMin?: number | null;
    /**
     * In courier working days
     */
    fallbackMax?: number | null;
    /**
     * In courier working days
     */
    predictionMin?: number | null;
    /**
     * In courier working days
     */
    predictionMax?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DeliveryMethodRequest = {
    account: number;
    /**
     * Unique ID for the delivery method, returned by API
     */
    name: string;
    /**
     * Description for the delivery method
     */
    description: string;
    warehouse?: number | null;
    courier?: number | null;
    /**
     * List of alternative courier codes used in retailer systems, can be used for API calls
     */
    courierAlias?: Array<string>;
    courierServiceLevel: Array<number>;
    /**
     * Calibration of the prediction: Does not give earlier delivery dates, but smaller delivery date ranges — aggressive will try to go for 1 day delivery window, conservative will try to achieve very high hit rate
     *
     * * `balanced` - Balanced
     * * `conservative` - Conservative
     * * `aggressive` - Aggressive
     */
    calibration?: CalibrationEnum;
    countries?: Array<CountriesIso3166Enum>;
    regions?: Array<RegionEnum>;
    workingDays?: WorkingDaysSchemaType;
    cutoffTime?: string;
    /**
     * Select true if cutoff time after midnight counts for orders placed on the day prior<br /><i>Example:</i> Order placed on Friday at 20:00 with cutoff 16:00 and working days Mon through Fri — if checkbox is true then order will be shipped on Saturday (because the cutoff is Friday + next day = Saturday at 4pm), if false then on Monday (because the next cutoff is Monday 4pm)
     */
    cutoffInNextDay?: boolean;
    cutoffTimesPerDay?: CutoffTimesPerDay;
    /**
     * Handling time <b><u>before</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    warehouseHandlingTime?: number | null;
    warehouseHandlingTimePerDay?: HandlingTimePerDay;
    /**
     * Handling time <b><u>after</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    handlingTime?: number | null;
    handlingTimePerDay?: HandlingTimePerDay;
    /**
     * If true, fallback will be used even if prediction is available
     */
    alwaysUseFallback?: boolean;
    /**
     * In courier working days
     */
    fallbackMin?: number | null;
    /**
     * In courier working days
     */
    fallbackMax?: number | null;
    /**
     * In courier working days
     */
    predictionMin?: number | null;
    /**
     * In courier working days
     */
    predictionMax?: number | null;
};

/**
 * Adds nested create feature
 */
export type DeliveryPredictionService = {
    readonly id: number;
    account: number;
    /**
     * <i>Only internal:</i> Alternative Redshift SQL query to select field for courier service level
     */
    courierServiceLevelQuery?: string;
    activeDeliveryMethods: Array<number>;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    promiseRules?: Array<PromiseRule>;
};

/**
 * Adds nested create feature
 */
export type DeliveryPredictionServiceDetails = {
    readonly id: number;
    account: number;
    /**
     * <i>Only internal:</i> Alternative Redshift SQL query to select field for courier service level
     */
    courierServiceLevelQuery?: string;
    activeDeliveryMethods: Array<DeliveryMethodDetails>;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    promiseRules?: Array<PromiseRule>;
};

/**
 * Adds nested create feature
 */
export type DeliveryPredictionServiceRequest = {
    account: number;
    /**
     * <i>Only internal:</i> Alternative Redshift SQL query to select field for courier service level
     */
    courierServiceLevelQuery?: string;
    activeDeliveryMethods: Array<number>;
    promiseRules?: Array<PromiseRuleRequest>;
};

export type Document = {
    /**
     * URL to the document, in most cases this is a http URL, but it could also be a data URL (base64)
     */
    url: string;
    /**
     * MIME content type of the document, e.g. 'application/pdf'
     */
    content_type?: string;
    /**
     * Type or types of the document, maybe multiple, if bundled
     */
    type?: Array<DocumentTypeEnum>;
    /**
     * Expiry date of the document, after which it might not be retrievable
     */
    expires_at?: string;
};

export enum DocumentTypeEnum {
    LABEL = 'label',
    PACKING_SLIP = 'packing_slip',
    BARCODE = 'barcode',
    CUSTOMS_DOCUMENT = 'customs_document',
    WALLET_PASS_IO = 'wallet_pass_io',
    WALLET_PASS_ANDROID = 'wallet_pass_android',
    COMMERCIAL_INVOICE = 'commercial_invoice'
}

export enum DomainStatusChoices {
    WHITELISTED = 'whitelisted',
    BLACKLISTED = 'blacklisted',
    UNKNOWN = 'unknown'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Dummy = {
    readonly id: number;
    name: string;
    account: number;
    jsonField?: {
        [key: string]: unknown;
    } | null;
    readonly updatedAt: string;
    readonly createdAt: string;
    children?: Array<DummyChild>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DummyChild = {
    readonly id: number;
    submodel?: number | null;
    name: string;
    name2?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DummyChildRequest = {
    submodel?: number | null;
    name: string;
    name2?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type DummyRequest = {
    name: string;
    account: number;
    jsonField?: {
        [key: string]: unknown;
    } | null;
    children?: Array<DummyChildRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Email = {
    readonly id: string;
    client?: string;
    serviceMessageId?: string;
    messageType: string;
    recipient: string;
    sender: string;
    replyto: string;
    live?: boolean;
    subject: string;
    content?: string;
    uploaded?: boolean;
    attachment?: {
        [key: string]: unknown;
    } | null;
    open?: {
        [key: string]: unknown;
    } | null;
    click?: {
        [key: string]: unknown;
    } | null;
    bounce?: {
        [key: string]: unknown;
    } | null;
    complaint?: {
        [key: string]: unknown;
    } | null;
    campaignId?: string | null;
    sourceEvent: string;
    sourceTrigger: string;
    readonly createdAt: string;
    account: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Event = {
    readonly id: string;
    client?: string;
    courier?: string;
    eventType: string;
    trigger: string;
    message: string;
    channel: string;
    destinationCountryIso3?: string;
    trackingNumber?: string;
    readonly createdAt: string;
    _internalTimestamp?: number | null;
    details?: {
        [key: string]: unknown;
    } | null;
    actions?: {
        [key: string]: unknown;
    } | null;
    account: number;
    tracking: number;
};

/**
 * * `OrderCreated` - Order Created
 * * `OrderUpdated` - Order Updated
 * * `TrackingCreated` - Tracking Created
 * * `TrackingUpdated` - Tracking Updated
 * * `DeliveryStatus` - Delivery Status
 * * `DelayedDispatch` - Delayed Dispatch
 * * `LeadTimeExceeded` - Lead Time Exceeded
 * * `Invalid` - Invalid
 * * `Forgotten` - Forgotten
 * * `Dispatch` - Dispatch
 * * `Scheduled` - Scheduled
 * * `FailedAttempt` - Failed Attempt
 * * `Exception` - Exception
 * * `Delay` - Delay
 * * `Escalation` - Escalation
 * * `ReturnWarning` - Return Warning
 * * `MissingUpdates` - Missing Updates
 * * `Return` - Return
 * * `PickupReady` - Pickup Ready
 * * `Delivered` - Delivered
 * * `CustomerPromiseExceeded` - Customer Promise Exceeded
 * * `TimeWindowMissed` - Time Window Missed
 */
export enum EventTypeEnum {
    ORDER_CREATED = 'OrderCreated',
    ORDER_UPDATED = 'OrderUpdated',
    TRACKING_CREATED = 'TrackingCreated',
    TRACKING_UPDATED = 'TrackingUpdated',
    DELIVERY_STATUS = 'DeliveryStatus',
    DELAYED_DISPATCH = 'DelayedDispatch',
    LEAD_TIME_EXCEEDED = 'LeadTimeExceeded',
    INVALID = 'Invalid',
    FORGOTTEN = 'Forgotten',
    DISPATCH = 'Dispatch',
    SCHEDULED = 'Scheduled',
    FAILED_ATTEMPT = 'FailedAttempt',
    EXCEPTION = 'Exception',
    DELAY = 'Delay',
    ESCALATION = 'Escalation',
    RETURN_WARNING = 'ReturnWarning',
    MISSING_UPDATES = 'MissingUpdates',
    RETURN = 'Return',
    PICKUP_READY = 'PickupReady',
    DELIVERED = 'Delivered',
    CUSTOMER_PROMISE_EXCEEDED = 'CustomerPromiseExceeded',
    TIME_WINDOW_MISSED = 'TimeWindowMissed'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Experiment = {
    readonly id: number;
    account: number;
    name: string;
    status?: ExperimentStatusEnum;
    messageType: number;
    readonly messageTypeName: string;
    messageTypeChannel: MessageChannelTypeChoices;
    startDate: string;
    endDate: string;
    ratios: Array<ExperimentRatio>;
    archived?: boolean;
    /**
     * Label of the winning variant after the experiment is completed.
     *
     * * `A` - Variant A
     * * `B` - Variant B
     */
    winnerVariant: VariantLabelEnum;
    readonly messages: Array<Message>;
};

export type ExperimentInfoItem = {
    ExperimentId: number;
    ExperimentVariantLabel: string;
};

export type ExperimentRatio = {
    readonly id: number;
    variantLabel: VariantLabelEnum;
    /**
     * Percentage of users who will receive this variant (0-100).
     */
    ratio?: number;
};

export type ExperimentRatioRequest = {
    variantLabel: VariantLabelEnum;
    /**
     * Percentage of users who will receive this variant (0-100).
     */
    ratio?: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ExperimentRequest = {
    account: number;
    name: string;
    status?: ExperimentStatusEnum;
    messageType: number;
    startDate: string;
    endDate: string;
    ratios: Array<ExperimentRatioRequest>;
    archived?: boolean;
};

export type ExperimentResults = {
    account_id: number;
    experiment_id: number;
    variant_label: string;
    unique_clicks: number;
    unique_click_rate: string;
    unique_opens: number;
    unique_open_rate: string;
    samples: number;
};

/**
 * * `draft` - Draft
 * * `active` - Active
 * * `completed` - Completed
 */
export enum ExperimentStatusEnum {
    DRAFT = 'draft',
    ACTIVE = 'active',
    COMPLETED = 'completed'
}

export type ExtendedPlaceInfoLookupRequestRequest = {
    /**
     * ID of account for this lookup
     */
    account: number;
    location: GeoLocation | GeoLookupFuzzy;
    /**
     * List of lookups (courier, service level, criteria) to execute
     */
    lookups: Array<PlaceInfoLookupItem>;
    country_iso3?: string;
    location_address?: AddressSchema;
    /**
     * @deprecated
     */
    orderby?: OrderbyEnum;
};

export type FallbackMaxValue = {
    action: PromiseRuleChoices;
    type?: string;
    value?: number;
};

export type FallbackMinValue = {
    action: PromiseRuleChoices;
    type?: string;
    value?: number;
};

export type FilterField = {
    name: string;
    label: string;
    description?: string;
    operators: Array<{
        [key: string]: unknown;
    }>;
    defaultOperator: DefaultOperatorEnum;
    valueEditorType?: ValueEditorTypeEnum | null;
    inputType?: InputTypeEnum | null;
    values?: FilterFieldValueList;
    placeholder?: string;
    tags: Array<string>;
};

export type FilterFieldRequest = {
    name: string;
    label: string;
    description?: string;
    operators: Array<{
        [key: string]: unknown;
    }>;
    defaultOperator: DefaultOperatorEnum;
    valueEditorType?: ValueEditorTypeEnum | null;
    inputType?: InputTypeEnum | null;
    values?: FilterFieldValueListRequest;
    placeholder?: string;
    tags: Array<string>;
};

export type FilterFieldValue = {
    label: string;
    name: string | number;
};

export type FilterFieldValueList = Array<FilterFieldValue> | unknown;

export type FilterFieldValueListRequest = Array<FilterFieldValue> | unknown;

/**
 * * `hidden` - Hidden
 * * `self_return` - Self Return
 * * `customer_support` - Customer Support
 * * `carrier` - Carrier
 * * `open_box` - Open Box
 * * `marketplace` - Marketplace
 * * `geo_restriction` - Geo Restriction
 * * `hygiene` - Hygiene
 * * `customized_product` - Customized Product
 * * `digital_product` - Digital Product
 * * `final_sale` - Final Sale
 * * `non_returnable_generic` - Non Returnable Generic
 * * `keep_article` - Keep Article
 * * `needs_approval` - Needs Approval
 */
export enum FlagEnum {
    HIDDEN = 'hidden',
    SELF_RETURN = 'self_return',
    CUSTOMER_SUPPORT = 'customer_support',
    CARRIER = 'carrier',
    OPEN_BOX = 'open_box',
    MARKETPLACE = 'marketplace',
    GEO_RESTRICTION = 'geo_restriction',
    HYGIENE = 'hygiene',
    CUSTOMIZED_PRODUCT = 'customized_product',
    DIGITAL_PRODUCT = 'digital_product',
    FINAL_SALE = 'final_sale',
    NON_RETURNABLE_GENERIC = 'non_returnable_generic',
    KEEP_ARTICLE = 'keep_article',
    NEEDS_APPROVAL = 'needs_approval'
}

export enum FlagsEnum {
    IS_CANCELLABLE = 'is_cancellable',
    IS_PICKUP = 'is_pickup',
    HAS_DANGEROUS_GOODS = 'has_dangerous_goods'
}

export type GeoLocation = {
    type?: string;
    /**
     * Latitude of this location
     */
    latitude: number;
    /**
     * Longitude of this location
     */
    longitude: number;
    /**
     * Postal code of this location
     */
    postal_code?: string;
    /**
     * Region code, e.g. state or province code (ISO 3166-2), if available
     */
    region_code?: string;
    /**
     * City name (min-length of 1 due to logographic languages)
     */
    city?: string;
    /**
     * ISO 3166-1 alpha-3 code of country
     */
    country_iso3?: string;
};

export type GeoLookupFuzzy = {
    /**
     * Search term for fuzzy search
     */
    search_term: string;
    /**
     * ISO 3166-1 alpha-3 code of country
     */
    country_iso3?: string;
    orderby?: OrderbyEnum;
    /**
     * If true, only 'good' matches will be returned
     */
    strict?: boolean;
};

export type HandlingTimePerDay = {
    monday?: number;
    tuesday?: number;
    wednesday?: number;
    thursday?: number;
    friday?: number;
    saturday?: number;
    sunday?: number;
};

export type HandlingTimeValue = {
    action: PromiseRuleChoices;
    type?: string;
    value?: number;
};

/**
 * * `none` - None
 * * `optional` - Optional
 * * `required` - Required
 * * `required_in_warranty` - Required in warranty period
 */
export enum ImageUploadEnum {
    NONE = 'none',
    OPTIONAL = 'optional',
    REQUIRED = 'required',
    REQUIRED_IN_WARRANTY = 'required_in_warranty'
}

/**
 * Adds nested create feature
 */
export type Images = {
    readonly id: number;
    image: string;
    description?: string;
    altText?: string;
};

/**
 * Adds nested create feature
 */
export type ImagesRequest = {
    image: Blob | File;
    description?: string;
    altText?: string;
};

export type Import = {
    readonly id: number;
    status: ImportStatusEnum;
    import_type: ImportTypeEnum;
    file: string;
    account: number;
    client?: number | null;
};

export type ImportRequest = {
    import_type: ImportTypeEnum;
    file: Blob | File;
    account: number;
    client?: number | null;
};

/**
 * * `processing` - Processing
 * * `success` - Success
 * * `failed` - Failed
 */
export enum ImportStatusEnum {
    PROCESSING = 'processing',
    SUCCESS = 'success',
    FAILED = 'failed'
}

/**
 * * `voucher` - Voucher
 * * `orders` - Orders
 */
export enum ImportTypeEnum {
    VOUCHER = 'voucher',
    ORDERS = 'orders'
}

export type InputMessage = {
    context?: {
        [key: string]: unknown;
    };
    query: string;
};

/**
 * * `button` - button
 * * `checkbox` - checkbox
 * * `color` - color
 * * `date` - date
 * * `datetime-local` - datetime-local
 * * `email` - email
 * * `file` - file
 * * `hidden` - hidden
 * * `image` - image
 * * `month` - month
 * * `number` - number
 * * `password` - password
 * * `radio` - radio
 * * `range` - range
 * * `reset` - reset
 * * `search` - search
 * * `submit` - submit
 * * `tel` - tel
 * * `text` - text
 * * `time` - time
 * * `url` - url
 * * `week` - week
 */
export enum InputTypeEnum {
    BUTTON = 'button',
    CHECKBOX = 'checkbox',
    COLOR = 'color',
    DATE = 'date',
    DATETIME_LOCAL = 'datetime-local',
    EMAIL = 'email',
    FILE = 'file',
    HIDDEN = 'hidden',
    IMAGE = 'image',
    MONTH = 'month',
    NUMBER = 'number',
    PASSWORD = 'password',
    RADIO = 'radio',
    RANGE = 'range',
    RESET = 'reset',
    SEARCH = 'search',
    SUBMIT = 'submit',
    TEL = 'tel',
    TEXT = 'text',
    TIME = 'time',
    URL = 'url',
    WEEK = 'week'
}

/**
 * Basic serializer for InstalledApp used in list and update operations.
 */
export type InstalledApp = {
    readonly id: number;
    account: number;
    customApp: number;
    readonly appName: string;
    readonly appType: string;
    readonly appKey: string;
    readonly events: Array<JourneyTriggerEvent>;
    /**
     * The ascending order in which apps of the same type are run
     */
    logicalOrder?: number;
    readonly isActive: boolean;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly installedBy: number | null;
    readonly renderTag: string;
    readonly filter: {
        [key: string]: unknown;
    };
    readonly additionalContext: Array<AdditionalContextEnum>;
    readonly placeholders: Array<string>;
    installedAppIntegrations?: Array<InstalledAppIntegration>;
};

/**
 * Detailed serializer for InstalledApp used in retrieve operations with full integration data.
 */
export type InstalledAppDetails = {
    readonly id: number;
    account: number;
    customApp: number;
    readonly appName: string;
    readonly appType: string;
    readonly appKey: string;
    readonly events: Array<JourneyTriggerEvent>;
    /**
     * The ascending order in which apps of the same type are run
     */
    logicalOrder?: number;
    readonly isActive: boolean;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly installedBy: number | null;
    readonly renderTag: string;
    readonly filter: {
        [key: string]: unknown;
    };
    readonly additionalContext: Array<AdditionalContextEnum>;
    readonly placeholders: Array<string>;
    /**
     * Dictionary of integrations keyed by technical_key
     */
    readonly integrations: {
        [key: string]: Integration;
    };
};

/**
 * Writable serializer for InstalledAppIntegration used in update operations.
 */
export type InstalledAppIntegration = {
    readonly id: number;
    /**
     * The app integration definition (technical key + service)
     */
    appIntegration: number;
    /**
     * The specific integration instance to use for this installed app
     */
    integrationInstance: number;
};

/**
 * Writable serializer for InstalledAppIntegration used in update operations.
 */
export type InstalledAppIntegrationRequest = {
    /**
     * The app integration definition (technical key + service)
     */
    appIntegration: number;
    /**
     * The specific integration instance to use for this installed app
     */
    integrationInstance: number;
};

/**
 * Basic serializer for InstalledApp used in list and update operations.
 */
export type InstalledAppRequest = {
    account: number;
    customApp: number;
    /**
     * The ascending order in which apps of the same type are run
     */
    logicalOrder?: number;
    installedAppIntegrations?: Array<InstalledAppIntegrationRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Integration = {
    readonly id: number;
    account: number;
    client: ClientSimple;
    name: string;
    service: number;
    readonly serviceKey: string;
    config?: {
        [key: string]: unknown;
    };
    authorizationGrant: AuthorizationGrant | null;
    readonly createdAt: string;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type IntegrationRequest = {
    account: number;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * * `random` - Random
 * * `fixed` - Fixed
 */
export enum ItemOrderEnum {
    RANDOM = 'random',
    FIXED = 'fixed'
}

export type JourneyAllowedNextActionResponse = {
    PickUpReady?: boolean;
    NewAttemptToday?: boolean;
    NewAttemptNextDay?: boolean;
    Empty?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneyConfiguration = {
    readonly id: number;
    name: string;
    client?: number | null;
    account: number;
    releaseStatus: JourneyConfigurationReleaseStatusEnum;
    /**
     * Sift filter that will be added to all of the triggers belonging to this journey
     */
    filterExpression?: {
        [key: string]: unknown;
    };
    readonly filterExpressionRendered: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
    readonly lastPublishedAt: string;
    readonly triggers: Array<JourneyTrigger>;
};

/**
 * * `draft` - Draft
 * * `ready` - Ready for review
 * * `approved` - Approved
 * * `rejected` - Changes Requested
 * * `published` - Published
 */
export enum JourneyConfigurationReleaseStatusEnum {
    DRAFT = 'draft',
    READY = 'ready',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    PUBLISHED = 'published'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneyConfigurationRequest = {
    name: string;
    client?: number | null;
    account: number;
    /**
     * Sift filter that will be added to all of the triggers belonging to this journey
     */
    filterExpression?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneyFlowVisualization = {
    readonly id: number;
    account: number;
    journeyConfiguration: number;
    name?: string;
    flow?: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneyFlowVisualizationRequest = {
    account: number;
    journeyConfiguration: number;
    name?: string;
    flow?: {
        [key: string]: unknown;
    };
};

export type JourneyMessageFlowAnalysis = {
    data: {
        [key: string]: unknown;
    };
    images: {
        [key: string]: unknown;
    };
};

export type JourneyRecipientDestinationResponse = {
    customer?: boolean;
    support?: boolean;
    test?: boolean;
    courierContact?: boolean;
    plTest?: boolean;
    theirs?: number | boolean | unknown;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneySharedFilter = {
    readonly id: number;
    /**
     * The best way to reference the script is by it's name, which should be unique
     */
    name: string;
    filterExpression?: {
        [key: string]: unknown;
    } | null;
    /**
     * This identifier is generated automatically when the filter is first created, if this filter was imported then the hash is probably being used on a filter
     */
    uniqueIdentifier: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneySharedFilterRequest = {
    /**
     * The best way to reference the script is by it's name, which should be unique
     */
    name: string;
    filterExpression?: {
        [key: string]: unknown;
    } | null;
    /**
     * This identifier is generated automatically when the filter is first created, if this filter was imported then the hash is probably being used on a filter
     */
    uniqueIdentifier: string;
};

/**
 * Adds nested create feature
 */
export type JourneyTrigger = {
    readonly id: number;
    journey?: number | null;
    name: string;
    /**
     * At the moment of matching the event, check this filter against the tracking to see if we run any actions.
     */
    filterExpression?: {
        [key: string]: unknown;
    };
    readonly filterExpressionRendered: {
        [key: string]: unknown;
    };
    events: Array<JourneyTriggerEvent>;
    actions: Array<JourneyTriggerAction>;
    readonly updatedAt: string;
};

/**
 * Adds nested create feature
 */
export type JourneyTriggerAction = {
    readonly id: number;
    name: string;
    /**
     * If event is fired, will wait for defined number of hours before triggering the message, **note:** that `Filters` will be applied at the beginning of the delay, not after the delay has passed
     */
    delay?: number;
    /**
     * Time unit for the given duration in the referenced data
     *
     * * `WEEK` - Week
     * * `DAY` - Day
     * * `HOUR` - Hour
     * * `MINUTE` - Minute
     * * `SECOND` - Second
     */
    delayUnit?: DelayUnitEnum;
    delayReference?: DelayReferenceEnum;
    /**
     * Consider working hours (delay and offset)
     */
    delayConsiderWorkingHours?: boolean;
    /**
     * Reference duration to delay the trigger by, e.g. `delivery_info.customFields.maxDeliveryTimeInDays`
     */
    delayReferenceOrOffsetKey?: string | null;
    /**
     * In case you need to create a delay with the duration reference defined in delay_reference_or_offset_key but starting from the a value defined on this key
     */
    delayOffsetFromKey?: string | null;
    /**
     * After any delay configured, at the moment before the action is enacted, check this custom filter against the tracking.
     */
    filterOnSendExpression?: {
        [key: string]: unknown;
    };
    readonly filterOnSendExpressionRendered: {
        [key: string]: unknown;
    };
    /**
     * After any delay configured, at the moment before the action is enacted, check the main trigger filter against the tracking.
     */
    filterOnSendFromTrigger?: boolean;
    /**
     * If `true`, will only trigger if there are multiple trackings in the order, if `false` will trigger for each tracking in the order
     */
    sendOnlyIfMultipleTracking?: boolean;
    /**
     * If `true`, will only trigger if there is a single tracking in the order, if `false` will trigger for each tracking in the order
     */
    sendOnlyIfSingleTracking?: boolean;
    /**
     * Trigger message only if any specifics are given
     */
    onlyWithSpecifics?: boolean;
    /**
     * *For `onScheduled` only:* Trigger message only if time slot for scheduled date is given
     */
    onlyWithSpecificsTime?: boolean;
    /**
     * *For `onFailedAttempt` only:* Only trigger for these next actions
     */
    allowedNextAction?: Array<AllowedNextActionEnum>;
    /**
     * *For `onDelivered` only:* If `true`, will only trigger if all trackings in the order are delivered, if `false` will trigger if the first tracking is delivered
     */
    completelyDelivered?: boolean;
    /**
     * Only trigger message for active campaign
     */
    onlyWithActiveCampaign?: boolean;
    channels: Array<JourneyTriggerChannel>;
    readonly updatedAt: string;
    /**
     * Checks for trackings in order where return and isReturnsPortal are true, and aborts flow if present.
     */
    doNotSendIfOrderHasPortalReturn?: boolean;
};

/**
 * Adds nested create feature
 */
export type JourneyTriggerActionRequest = {
    name: string;
    /**
     * If event is fired, will wait for defined number of hours before triggering the message, **note:** that `Filters` will be applied at the beginning of the delay, not after the delay has passed
     */
    delay?: number;
    /**
     * Time unit for the given duration in the referenced data
     *
     * * `WEEK` - Week
     * * `DAY` - Day
     * * `HOUR` - Hour
     * * `MINUTE` - Minute
     * * `SECOND` - Second
     */
    delayUnit?: DelayUnitEnum;
    delayReference?: DelayReferenceEnum;
    /**
     * Consider working hours (delay and offset)
     */
    delayConsiderWorkingHours?: boolean;
    /**
     * Reference duration to delay the trigger by, e.g. `delivery_info.customFields.maxDeliveryTimeInDays`
     */
    delayReferenceOrOffsetKey?: string | null;
    /**
     * In case you need to create a delay with the duration reference defined in delay_reference_or_offset_key but starting from the a value defined on this key
     */
    delayOffsetFromKey?: string | null;
    /**
     * After any delay configured, at the moment before the action is enacted, check this custom filter against the tracking.
     */
    filterOnSendExpression?: {
        [key: string]: unknown;
    };
    /**
     * After any delay configured, at the moment before the action is enacted, check the main trigger filter against the tracking.
     */
    filterOnSendFromTrigger?: boolean;
    /**
     * If `true`, will only trigger if there are multiple trackings in the order, if `false` will trigger for each tracking in the order
     */
    sendOnlyIfMultipleTracking?: boolean;
    /**
     * If `true`, will only trigger if there is a single tracking in the order, if `false` will trigger for each tracking in the order
     */
    sendOnlyIfSingleTracking?: boolean;
    /**
     * Trigger message only if any specifics are given
     */
    onlyWithSpecifics?: boolean;
    /**
     * *For `onScheduled` only:* Trigger message only if time slot for scheduled date is given
     */
    onlyWithSpecificsTime?: boolean;
    /**
     * *For `onFailedAttempt` only:* Only trigger for these next actions
     */
    allowedNextAction?: Array<AllowedNextActionEnum>;
    /**
     * *For `onDelivered` only:* If `true`, will only trigger if all trackings in the order are delivered, if `false` will trigger if the first tracking is delivered
     */
    completelyDelivered?: boolean;
    /**
     * Only trigger message for active campaign
     */
    onlyWithActiveCampaign?: boolean;
    channels: Array<JourneyTriggerChannelRequest>;
    /**
     * Checks for trackings in order where return and isReturnsPortal are true, and aborts flow if present.
     */
    doNotSendIfOrderHasPortalReturn?: boolean;
};

/**
 * Adds nested create feature
 */
export type JourneyTriggerChannel = {
    readonly id: number;
    name?: string;
    /**
     * Channel through wich to trigger the message
     *
     * * `email` - Mail
     * * `sms` - Sms
     * * `webhook` - Webhook
     * * `slot` - Slot
     * * `kafka` - Kafka
     */
    channel?: TriggerChannelTypeChoices;
    /**
     * Previously PriorityWebhook, PriorityEmail. If there is scheduling this has no effect, and these messages will be rerouted to regular queues.
     */
    isPrioritized?: boolean;
    /**
     * What message to attach to this trigger
     */
    message?: number | null;
    /**
     * If `true`, will apply proper locale to each message triggered
     */
    localeMessage?: boolean;
    /**
     * Will trigger communication to `tracking.delivery_info.email` or `tracking.delivery_info.phone` respectively
     */
    recipientCustomer?: boolean;
    /**
     * Will trigger communication to `static.contact.supportEmail` in BCC
     */
    recipientSupport?: boolean;
    /**
     * Will trigger communication to `static.contact.testEmail` in BCC
     */
    recipientTest?: boolean;
    /**
     * Will trigger communication to `tracking.delivery_info.courierContactEmail` in BCC
     */
    recipientCourierContact?: boolean;
    /**
     * Will send communication to internal parcelLab address
     */
    recipientPlTest?: boolean;
    /**
     * *Only used for webhooks:* Retailer webhook destination to send the event to
     */
    recipientTheirs?: number | null;
    readonly integration: number | null;
    /**
     * Integration to use for this action. You can add client-specific integrations and a fallback integration with no/default client and we will figure out the filter to send to the correct integration.
     */
    integrations?: Array<number>;
    /**
     * *Webhooks only:* will apply SMS-style URL shorting to https://prcl.io/abcdef for all URLs in webhook
     */
    shortenUrls?: boolean;
    /**
     * Adds order placeholders to available placeholders for messages and layouts. Redundant if once per order/delivery is also set.
     */
    activateOrderPlaceholders?: boolean;
    /**
     * Determines the frequency of trigger activation
     *
     * * `order` - Per order for the first tracking matching the condition
     * * `delivery_id` - Per delivery number within an order for the first tracking matching the condition
     * * `tracking` - Per tracking in the order
     * * `action_channel` - Per trigger action channel
     * * `channel_default` - Default channel behavior (non-webhook triggers once per tracking, webhook triggers for each trigger action channel)
     */
    onlyOncePer?: OnlyOncePerEnum;
    /**
     * *Webhooks only:* push notifications are treated like emails or SMS, sent only once including additional order logic, don't active for machine-to-machine communication
     */
    pushNotification?: boolean;
    /**
     * By default triggers are not sent to recipients that are unsubscribed, overwrite this behavior for critical messages
     */
    sendToUnsubscribed?: boolean;
    /**
     * By default triggers are not send to recipients that are unsubscribed or after a tracking is returned, but service notices are **always** sent
     */
    isServiceNotice?: boolean;
    readonly updatedAt: string;
};

/**
 * Adds nested create feature
 */
export type JourneyTriggerChannelRequest = {
    name?: string;
    /**
     * Channel through wich to trigger the message
     *
     * * `email` - Mail
     * * `sms` - Sms
     * * `webhook` - Webhook
     * * `slot` - Slot
     * * `kafka` - Kafka
     */
    channel?: TriggerChannelTypeChoices;
    /**
     * Previously PriorityWebhook, PriorityEmail. If there is scheduling this has no effect, and these messages will be rerouted to regular queues.
     */
    isPrioritized?: boolean;
    /**
     * What message to attach to this trigger
     */
    message?: number | null;
    /**
     * If `true`, will apply proper locale to each message triggered
     */
    localeMessage?: boolean;
    /**
     * Will trigger communication to `tracking.delivery_info.email` or `tracking.delivery_info.phone` respectively
     */
    recipientCustomer?: boolean;
    /**
     * Will trigger communication to `static.contact.supportEmail` in BCC
     */
    recipientSupport?: boolean;
    /**
     * Will trigger communication to `static.contact.testEmail` in BCC
     */
    recipientTest?: boolean;
    /**
     * Will trigger communication to `tracking.delivery_info.courierContactEmail` in BCC
     */
    recipientCourierContact?: boolean;
    /**
     * Will send communication to internal parcelLab address
     */
    recipientPlTest?: boolean;
    /**
     * *Only used for webhooks:* Retailer webhook destination to send the event to
     */
    recipientTheirs?: number | null;
    /**
     * Integration to use for this action. You can add client-specific integrations and a fallback integration with no/default client and we will figure out the filter to send to the correct integration.
     */
    integrations?: Array<number>;
    /**
     * *Webhooks only:* will apply SMS-style URL shorting to https://prcl.io/abcdef for all URLs in webhook
     */
    shortenUrls?: boolean;
    /**
     * Adds order placeholders to available placeholders for messages and layouts. Redundant if once per order/delivery is also set.
     */
    activateOrderPlaceholders?: boolean;
    /**
     * Determines the frequency of trigger activation
     *
     * * `order` - Per order for the first tracking matching the condition
     * * `delivery_id` - Per delivery number within an order for the first tracking matching the condition
     * * `tracking` - Per tracking in the order
     * * `action_channel` - Per trigger action channel
     * * `channel_default` - Default channel behavior (non-webhook triggers once per tracking, webhook triggers for each trigger action channel)
     */
    onlyOncePer?: OnlyOncePerEnum;
    /**
     * *Webhooks only:* push notifications are treated like emails or SMS, sent only once including additional order logic, don't active for machine-to-machine communication
     */
    pushNotification?: boolean;
    /**
     * By default triggers are not sent to recipients that are unsubscribed, overwrite this behavior for critical messages
     */
    sendToUnsubscribed?: boolean;
    /**
     * By default triggers are not send to recipients that are unsubscribed or after a tracking is returned, but service notices are **always** sent
     */
    isServiceNotice?: boolean;
};

export type JourneyTriggerDelayResponse = {
    Delay?: number;
    DelayUnit: TimeUnitChoices;
    DelayReference: DelayReferenceChoices;
    DelayConsiderWorkingHours: boolean;
    DelayReferenceOrOffsetKey?: string | unknown;
    DelayOffsetFromKey?: string | unknown;
    DelayIgnoreTime: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneyTriggerEvent = {
    readonly id: number;
    name: string;
    account?: number;
    /**
     * Event subtypes to respond to. _( "*" ) is a special tag to respond to anything.
     */
    eventTypes: Array<string>;
    readonly filter: {
        [key: string]: unknown;
    };
    /**
     * Specify which incoming events should this match to.
     */
    slotTypes: Array<SlotTypesEnum>;
    /**
     * The logical order of the event, auto-defined based on logical slot order if not set manually
     */
    logicalOrder?: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type JourneyTriggerEventRequest = {
    name: string;
    account?: number;
    /**
     * Event subtypes to respond to. _( "*" ) is a special tag to respond to anything.
     */
    eventTypes: Array<string>;
    /**
     * Specify which incoming events should this match to.
     */
    slotTypes: Array<SlotTypesEnum>;
    /**
     * The logical order of the event, auto-defined based on logical slot order if not set manually
     */
    logicalOrder?: number;
};

/**
 * Adds nested create feature
 */
export type JourneyTriggerRequest = {
    journey?: number | null;
    name: string;
    /**
     * At the moment of matching the event, check this filter against the tracking to see if we run any actions.
     */
    filterExpression?: {
        [key: string]: unknown;
    };
    events: Array<JourneyTriggerEventRequest>;
    actions: Array<JourneyTriggerActionRequest>;
};

export type JourneyTriggerResponse = Array<JourneyTriggerResponseItem>;

/**
 * This is the object our API will respond with when Backends queries for
 * triggers with an account_id
 */
export type JourneyTriggerResponseItem = {
    Account: number;
    Id: number;
    Filter: JsonValue;
    SlotType: string;
    EventTypes: string;
    Name: string;
    Delay: JourneyTriggerDelayResponse;
    FilterOnSend: JsonValue | unknown;
    SendOnlyIfMultipleTracking: boolean;
    SendOnlyIfSingleTracking: boolean;
    OnlyWithSpecifics: boolean;
    OnlyWithSpecificsTime: boolean;
    AllowedNextAction?: JourneyAllowedNextActionResponse | unknown;
    CompletelyDelivered?: boolean;
    Channel: string;
    ChannelId: number;
    Message: string | unknown;
    IntegrationId: number | unknown;
    Recipient: JourneyRecipientDestinationResponse;
    ShortenUrls: boolean;
    OnlyOncePer: OnlyOnceChoices;
    ActivateOrderPlaceholders: boolean;
    PushNotification: boolean | unknown;
    SendToUnsubscribed: boolean;
    IsServiceNotice: boolean;
    FilterOnSendId: string;
    OnlyWithActiveCampaign?: boolean;
    ActionName: string | unknown;
    Blame?: {
        [key: string]: JourneyTriggerResponseItemBlame;
    };
    DoNotSendIfOrderHasPortalReturn: boolean;
    Experiment?: ExperimentInfoItem | unknown;
    JourneyId: number;
};

export type JourneyTriggerResponseItemBlame = {
    UpdatedAt: string;
    UpdatedBy: string | unknown;
};

export type JsonValue = unknown;

/**
 * * `preview` - Preview
 * * `test` - Test
 * * `live` - Live
 */
export enum KindEnum {
    PREVIEW = 'preview',
    TEST = 'test',
    LIVE = 'live'
}

/**
 * * `mul` - Multi Language
 * * `aa` - Afar (Aa)
 * * `ab` - Abkhazian (Ab)
 * * `ae` - Avestan (Ae)
 * * `af` - Afrikaans (Af)
 * * `ak` - Akan (Ak)
 * * `am` - Amharic (Am)
 * * `an` - Aragonese (An)
 * * `ar` - Arabic (Ar)
 * * `as` - Assamese (As)
 * * `av` - Avaric (Av)
 * * `ay` - Aymara (Ay)
 * * `az` - Azerbaijani (Az)
 * * `ba` - Bashkir (Ba)
 * * `be` - Belarusian (Be)
 * * `bg` - Bulgarian (Bg)
 * * `bi` - Bislama (Bi)
 * * `bm` - Bambara (Bm)
 * * `bn` - Bengali (Bn)
 * * `bo` - Tibetan (Bo)
 * * `br` - Breton (Br)
 * * `bs` - Bosnian (Bs)
 * * `ca` - Catalan (Ca)
 * * `ce` - Chechen (Ce)
 * * `ch` - Chamorro (Ch)
 * * `co` - Corsican (Co)
 * * `cr` - Cree (Cr)
 * * `cs` - Czech (Cs)
 * * `cu` - Church Slavic (Cu)
 * * `cv` - Chuvash (Cv)
 * * `cy` - Welsh (Cy)
 * * `da` - Danish (Da)
 * * `de` - German (De)
 * * `dv` - Dhivehi (Dv)
 * * `dz` - Dzongkha (Dz)
 * * `ee` - Ewe (Ee)
 * * `el` - Modern Greek (1453-) (El)
 * * `en` - English (En)
 * * `eo` - Esperanto (Eo)
 * * `es` - Spanish (Es)
 * * `et` - Estonian (Et)
 * * `eu` - Basque (Eu)
 * * `fa` - Persian (Fa)
 * * `ff` - Fulah (Ff)
 * * `fi` - Finnish (Fi)
 * * `fj` - Fijian (Fj)
 * * `fo` - Faroese (Fo)
 * * `fr` - French (Fr)
 * * `fy` - Western Frisian (Fy)
 * * `ga` - Irish (Ga)
 * * `gd` - Scottish Gaelic (Gd)
 * * `gl` - Galician (Gl)
 * * `gn` - Guarani (Gn)
 * * `gu` - Gujarati (Gu)
 * * `gv` - Manx (Gv)
 * * `ha` - Hausa (Ha)
 * * `he` - Hebrew (He)
 * * `hi` - Hindi (Hi)
 * * `ho` - Hiri Motu (Ho)
 * * `hr` - Croatian (Hr)
 * * `ht` - Haitian (Ht)
 * * `hu` - Hungarian (Hu)
 * * `hy` - Armenian (Hy)
 * * `hz` - Herero (Hz)
 * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
 * * `id` - Indonesian (Id)
 * * `ie` - Interlingue (Ie)
 * * `ig` - Igbo (Ig)
 * * `ii` - Sichuan Yi (Ii)
 * * `ik` - Inupiaq (Ik)
 * * `io` - Ido (Io)
 * * `is` - Icelandic (Is)
 * * `it` - Italian (It)
 * * `iu` - Inuktitut (Iu)
 * * `ja` - Japanese (Ja)
 * * `jv` - Javanese (Jv)
 * * `ka` - Georgian (Ka)
 * * `kg` - Kongo (Kg)
 * * `ki` - Kikuyu (Ki)
 * * `kj` - Kuanyama (Kj)
 * * `kk` - Kazakh (Kk)
 * * `kl` - Kalaallisut (Kl)
 * * `km` - Khmer (Km)
 * * `kn` - Kannada (Kn)
 * * `ko` - Korean (Ko)
 * * `kr` - Kanuri (Kr)
 * * `ks` - Kashmiri (Ks)
 * * `ku` - Kurdish (Ku)
 * * `kv` - Komi (Kv)
 * * `kw` - Cornish (Kw)
 * * `ky` - Kirghiz (Ky)
 * * `la` - Latin (La)
 * * `lb` - Luxembourgish (Lb)
 * * `lg` - Ganda (Lg)
 * * `li` - Limburgan (Li)
 * * `ln` - Lingala (Ln)
 * * `lo` - Lao (Lo)
 * * `lt` - Lithuanian (Lt)
 * * `lu` - Luba-Katanga (Lu)
 * * `lv` - Latvian (Lv)
 * * `mg` - Malagasy (Mg)
 * * `mh` - Marshallese (Mh)
 * * `mi` - Maori (Mi)
 * * `mk` - Macedonian (Mk)
 * * `ml` - Malayalam (Ml)
 * * `mn` - Mongolian (Mn)
 * * `mr` - Marathi (Mr)
 * * `ms` - Malay (Macrolanguage) (Ms)
 * * `mt` - Maltese (Mt)
 * * `my` - Burmese (My)
 * * `na` - Nauru (Na)
 * * `nb` - Norwegian Bokmål (Nb)
 * * `nd` - North Ndebele (Nd)
 * * `ne` - Nepali (Macrolanguage) (Ne)
 * * `ng` - Ndonga (Ng)
 * * `nl` - Dutch (Nl)
 * * `nn` - Norwegian Nynorsk (Nn)
 * * `no` - Norwegian (No)
 * * `nr` - South Ndebele (Nr)
 * * `nv` - Navajo (Nv)
 * * `ny` - Nyanja (Ny)
 * * `oc` - Occitan (Post 1500) (Oc)
 * * `oj` - Ojibwa (Oj)
 * * `om` - Oromo (Om)
 * * `or` - Oriya (Macrolanguage) (Or)
 * * `os` - Ossetian (Os)
 * * `pa` - Panjabi (Pa)
 * * `pi` - Pali (Pi)
 * * `pl` - Polish (Pl)
 * * `ps` - Pushto (Ps)
 * * `pt` - Portuguese (Pt)
 * * `qu` - Quechua (Qu)
 * * `rm` - Romansh (Rm)
 * * `rn` - Rundi (Rn)
 * * `ro` - Romanian (Ro)
 * * `ru` - Russian (Ru)
 * * `rw` - Kinyarwanda (Rw)
 * * `sa` - Sanskrit (Sa)
 * * `sc` - Sardinian (Sc)
 * * `sd` - Sindhi (Sd)
 * * `se` - Northern Sami (Se)
 * * `sg` - Sango (Sg)
 * * `sh` - Serbo-Croatian (Sh)
 * * `si` - Sinhala (Si)
 * * `sk` - Slovak (Sk)
 * * `sl` - Slovenian (Sl)
 * * `sm` - Samoan (Sm)
 * * `sn` - Shona (Sn)
 * * `so` - Somali (So)
 * * `sq` - Albanian (Sq)
 * * `sr` - Serbian (Sr)
 * * `ss` - Swati (Ss)
 * * `st` - Southern Sotho (St)
 * * `su` - Sundanese (Su)
 * * `sv` - Swedish (Sv)
 * * `sw` - Swahili (Macrolanguage) (Sw)
 * * `ta` - Tamil (Ta)
 * * `te` - Telugu (Te)
 * * `tg` - Tajik (Tg)
 * * `th` - Thai (Th)
 * * `ti` - Tigrinya (Ti)
 * * `tk` - Turkmen (Tk)
 * * `tl` - Tagalog (Tl)
 * * `tn` - Tswana (Tn)
 * * `to` - Tonga (Tonga Islands) (To)
 * * `tr` - Turkish (Tr)
 * * `ts` - Tsonga (Ts)
 * * `tt` - Tatar (Tt)
 * * `tw` - Twi (Tw)
 * * `ty` - Tahitian (Ty)
 * * `ug` - Uighur (Ug)
 * * `uk` - Ukrainian (Uk)
 * * `ur` - Urdu (Ur)
 * * `uz` - Uzbek (Uz)
 * * `ve` - Venda (Ve)
 * * `vi` - Vietnamese (Vi)
 * * `vo` - Volapük (Vo)
 * * `wa` - Walloon (Wa)
 * * `wo` - Wolof (Wo)
 * * `xh` - Xhosa (Xh)
 * * `yi` - Yiddish (Yi)
 * * `yo` - Yoruba (Yo)
 * * `za` - Zhuang (Za)
 * * `zh` - Chinese (Zh)
 * * `zu` - Zulu (Zu)
 */
export enum LanguagesEnum {
    MUL = 'mul',
    AA = 'aa',
    AB = 'ab',
    AE = 'ae',
    AF = 'af',
    AK = 'ak',
    AM = 'am',
    AN = 'an',
    AR = 'ar',
    AS = 'as',
    AV = 'av',
    AY = 'ay',
    AZ = 'az',
    BA = 'ba',
    BE = 'be',
    BG = 'bg',
    BI = 'bi',
    BM = 'bm',
    BN = 'bn',
    BO = 'bo',
    BR = 'br',
    BS = 'bs',
    CA = 'ca',
    CE = 'ce',
    CH = 'ch',
    CO = 'co',
    CR = 'cr',
    CS = 'cs',
    CU = 'cu',
    CV = 'cv',
    CY = 'cy',
    DA = 'da',
    DE = 'de',
    DV = 'dv',
    DZ = 'dz',
    EE = 'ee',
    EL = 'el',
    EN = 'en',
    EO = 'eo',
    ES = 'es',
    ET = 'et',
    EU = 'eu',
    FA = 'fa',
    FF = 'ff',
    FI = 'fi',
    FJ = 'fj',
    FO = 'fo',
    FR = 'fr',
    FY = 'fy',
    GA = 'ga',
    GD = 'gd',
    GL = 'gl',
    GN = 'gn',
    GU = 'gu',
    GV = 'gv',
    HA = 'ha',
    HE = 'he',
    HI = 'hi',
    HO = 'ho',
    HR = 'hr',
    HT = 'ht',
    HU = 'hu',
    HY = 'hy',
    HZ = 'hz',
    IA = 'ia',
    ID = 'id',
    IE = 'ie',
    IG = 'ig',
    II = 'ii',
    IK = 'ik',
    IO = 'io',
    IS = 'is',
    IT = 'it',
    IU = 'iu',
    JA = 'ja',
    JV = 'jv',
    KA = 'ka',
    KG = 'kg',
    KI = 'ki',
    KJ = 'kj',
    KK = 'kk',
    KL = 'kl',
    KM = 'km',
    KN = 'kn',
    KO = 'ko',
    KR = 'kr',
    KS = 'ks',
    KU = 'ku',
    KV = 'kv',
    KW = 'kw',
    KY = 'ky',
    LA = 'la',
    LB = 'lb',
    LG = 'lg',
    LI = 'li',
    LN = 'ln',
    LO = 'lo',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    MG = 'mg',
    MH = 'mh',
    MI = 'mi',
    MK = 'mk',
    ML = 'ml',
    MN = 'mn',
    MR = 'mr',
    MS = 'ms',
    MT = 'mt',
    MY = 'my',
    NA = 'na',
    NB = 'nb',
    ND = 'nd',
    NE = 'ne',
    NG = 'ng',
    NL = 'nl',
    NN = 'nn',
    NO = 'no',
    NR = 'nr',
    NV = 'nv',
    NY = 'ny',
    OC = 'oc',
    OJ = 'oj',
    OM = 'om',
    OR = 'or',
    OS = 'os',
    PA = 'pa',
    PI = 'pi',
    PL = 'pl',
    PS = 'ps',
    PT = 'pt',
    QU = 'qu',
    RM = 'rm',
    RN = 'rn',
    RO = 'ro',
    RU = 'ru',
    RW = 'rw',
    SA = 'sa',
    SC = 'sc',
    SD = 'sd',
    SE = 'se',
    SG = 'sg',
    SH = 'sh',
    SI = 'si',
    SK = 'sk',
    SL = 'sl',
    SM = 'sm',
    SN = 'sn',
    SO = 'so',
    SQ = 'sq',
    SR = 'sr',
    SS = 'ss',
    ST = 'st',
    SU = 'su',
    SV = 'sv',
    SW = 'sw',
    TA = 'ta',
    TE = 'te',
    TG = 'tg',
    TH = 'th',
    TI = 'ti',
    TK = 'tk',
    TL = 'tl',
    TN = 'tn',
    TO = 'to',
    TR = 'tr',
    TS = 'ts',
    TT = 'tt',
    TW = 'tw',
    TY = 'ty',
    UG = 'ug',
    UK = 'uk',
    UR = 'ur',
    UZ = 'uz',
    VE = 've',
    VI = 'vi',
    VO = 'vo',
    WA = 'wa',
    WO = 'wo',
    XH = 'xh',
    YI = 'yi',
    YO = 'yo',
    ZA = 'za',
    ZH = 'zh',
    ZU = 'zu'
}

/**
 * * `aa` - Afar (Aa)
 * * `ab` - Abkhazian (Ab)
 * * `ae` - Avestan (Ae)
 * * `af` - Afrikaans (Af)
 * * `ak` - Akan (Ak)
 * * `am` - Amharic (Am)
 * * `an` - Aragonese (An)
 * * `ar` - Arabic (Ar)
 * * `as` - Assamese (As)
 * * `av` - Avaric (Av)
 * * `ay` - Aymara (Ay)
 * * `az` - Azerbaijani (Az)
 * * `ba` - Bashkir (Ba)
 * * `be` - Belarusian (Be)
 * * `bg` - Bulgarian (Bg)
 * * `bi` - Bislama (Bi)
 * * `bm` - Bambara (Bm)
 * * `bn` - Bengali (Bn)
 * * `bo` - Tibetan (Bo)
 * * `br` - Breton (Br)
 * * `bs` - Bosnian (Bs)
 * * `ca` - Catalan (Ca)
 * * `ce` - Chechen (Ce)
 * * `ch` - Chamorro (Ch)
 * * `co` - Corsican (Co)
 * * `cr` - Cree (Cr)
 * * `cs` - Czech (Cs)
 * * `cu` - Church Slavic (Cu)
 * * `cv` - Chuvash (Cv)
 * * `cy` - Welsh (Cy)
 * * `da` - Danish (Da)
 * * `de` - German (De)
 * * `dv` - Dhivehi (Dv)
 * * `dz` - Dzongkha (Dz)
 * * `ee` - Ewe (Ee)
 * * `el` - Modern Greek (1453-) (El)
 * * `en` - English (En)
 * * `eo` - Esperanto (Eo)
 * * `es` - Spanish (Es)
 * * `et` - Estonian (Et)
 * * `eu` - Basque (Eu)
 * * `fa` - Persian (Fa)
 * * `ff` - Fulah (Ff)
 * * `fi` - Finnish (Fi)
 * * `fj` - Fijian (Fj)
 * * `fo` - Faroese (Fo)
 * * `fr` - French (Fr)
 * * `fy` - Western Frisian (Fy)
 * * `ga` - Irish (Ga)
 * * `gd` - Scottish Gaelic (Gd)
 * * `gl` - Galician (Gl)
 * * `gn` - Guarani (Gn)
 * * `gu` - Gujarati (Gu)
 * * `gv` - Manx (Gv)
 * * `ha` - Hausa (Ha)
 * * `he` - Hebrew (He)
 * * `hi` - Hindi (Hi)
 * * `ho` - Hiri Motu (Ho)
 * * `hr` - Croatian (Hr)
 * * `ht` - Haitian (Ht)
 * * `hu` - Hungarian (Hu)
 * * `hy` - Armenian (Hy)
 * * `hz` - Herero (Hz)
 * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
 * * `id` - Indonesian (Id)
 * * `ie` - Interlingue (Ie)
 * * `ig` - Igbo (Ig)
 * * `ii` - Sichuan Yi (Ii)
 * * `ik` - Inupiaq (Ik)
 * * `io` - Ido (Io)
 * * `is` - Icelandic (Is)
 * * `it` - Italian (It)
 * * `iu` - Inuktitut (Iu)
 * * `ja` - Japanese (Ja)
 * * `jv` - Javanese (Jv)
 * * `ka` - Georgian (Ka)
 * * `kg` - Kongo (Kg)
 * * `ki` - Kikuyu (Ki)
 * * `kj` - Kuanyama (Kj)
 * * `kk` - Kazakh (Kk)
 * * `kl` - Kalaallisut (Kl)
 * * `km` - Khmer (Km)
 * * `kn` - Kannada (Kn)
 * * `ko` - Korean (Ko)
 * * `kr` - Kanuri (Kr)
 * * `ks` - Kashmiri (Ks)
 * * `ku` - Kurdish (Ku)
 * * `kv` - Komi (Kv)
 * * `kw` - Cornish (Kw)
 * * `ky` - Kirghiz (Ky)
 * * `la` - Latin (La)
 * * `lb` - Luxembourgish (Lb)
 * * `lg` - Ganda (Lg)
 * * `li` - Limburgan (Li)
 * * `ln` - Lingala (Ln)
 * * `lo` - Lao (Lo)
 * * `lt` - Lithuanian (Lt)
 * * `lu` - Luba-Katanga (Lu)
 * * `lv` - Latvian (Lv)
 * * `mg` - Malagasy (Mg)
 * * `mh` - Marshallese (Mh)
 * * `mi` - Maori (Mi)
 * * `mk` - Macedonian (Mk)
 * * `ml` - Malayalam (Ml)
 * * `mn` - Mongolian (Mn)
 * * `mr` - Marathi (Mr)
 * * `ms` - Malay (Macrolanguage) (Ms)
 * * `mt` - Maltese (Mt)
 * * `my` - Burmese (My)
 * * `na` - Nauru (Na)
 * * `nb` - Norwegian Bokmål (Nb)
 * * `nd` - North Ndebele (Nd)
 * * `ne` - Nepali (Macrolanguage) (Ne)
 * * `ng` - Ndonga (Ng)
 * * `nl` - Dutch (Nl)
 * * `nn` - Norwegian Nynorsk (Nn)
 * * `no` - Norwegian (No)
 * * `nr` - South Ndebele (Nr)
 * * `nv` - Navajo (Nv)
 * * `ny` - Nyanja (Ny)
 * * `oc` - Occitan (Post 1500) (Oc)
 * * `oj` - Ojibwa (Oj)
 * * `om` - Oromo (Om)
 * * `or` - Oriya (Macrolanguage) (Or)
 * * `os` - Ossetian (Os)
 * * `pa` - Panjabi (Pa)
 * * `pi` - Pali (Pi)
 * * `pl` - Polish (Pl)
 * * `ps` - Pushto (Ps)
 * * `pt` - Portuguese (Pt)
 * * `qu` - Quechua (Qu)
 * * `rm` - Romansh (Rm)
 * * `rn` - Rundi (Rn)
 * * `ro` - Romanian (Ro)
 * * `ru` - Russian (Ru)
 * * `rw` - Kinyarwanda (Rw)
 * * `sa` - Sanskrit (Sa)
 * * `sc` - Sardinian (Sc)
 * * `sd` - Sindhi (Sd)
 * * `se` - Northern Sami (Se)
 * * `sg` - Sango (Sg)
 * * `sh` - Serbo-Croatian (Sh)
 * * `si` - Sinhala (Si)
 * * `sk` - Slovak (Sk)
 * * `sl` - Slovenian (Sl)
 * * `sm` - Samoan (Sm)
 * * `sn` - Shona (Sn)
 * * `so` - Somali (So)
 * * `sq` - Albanian (Sq)
 * * `sr` - Serbian (Sr)
 * * `ss` - Swati (Ss)
 * * `st` - Southern Sotho (St)
 * * `su` - Sundanese (Su)
 * * `sv` - Swedish (Sv)
 * * `sw` - Swahili (Macrolanguage) (Sw)
 * * `ta` - Tamil (Ta)
 * * `te` - Telugu (Te)
 * * `tg` - Tajik (Tg)
 * * `th` - Thai (Th)
 * * `ti` - Tigrinya (Ti)
 * * `tk` - Turkmen (Tk)
 * * `tl` - Tagalog (Tl)
 * * `tn` - Tswana (Tn)
 * * `to` - Tonga (Tonga Islands) (To)
 * * `tr` - Turkish (Tr)
 * * `ts` - Tsonga (Ts)
 * * `tt` - Tatar (Tt)
 * * `tw` - Twi (Tw)
 * * `ty` - Tahitian (Ty)
 * * `ug` - Uighur (Ug)
 * * `uk` - Ukrainian (Uk)
 * * `ur` - Urdu (Ur)
 * * `uz` - Uzbek (Uz)
 * * `ve` - Venda (Ve)
 * * `vi` - Vietnamese (Vi)
 * * `vo` - Volapük (Vo)
 * * `wa` - Walloon (Wa)
 * * `wo` - Wolof (Wo)
 * * `xh` - Xhosa (Xh)
 * * `yi` - Yiddish (Yi)
 * * `yo` - Yoruba (Yo)
 * * `za` - Zhuang (Za)
 * * `zh` - Chinese (Zh)
 * * `zu` - Zulu (Zu)
 */
export enum LanguagesIso639Enum {
    AA = 'aa',
    AB = 'ab',
    AE = 'ae',
    AF = 'af',
    AK = 'ak',
    AM = 'am',
    AN = 'an',
    AR = 'ar',
    AS = 'as',
    AV = 'av',
    AY = 'ay',
    AZ = 'az',
    BA = 'ba',
    BE = 'be',
    BG = 'bg',
    BI = 'bi',
    BM = 'bm',
    BN = 'bn',
    BO = 'bo',
    BR = 'br',
    BS = 'bs',
    CA = 'ca',
    CE = 'ce',
    CH = 'ch',
    CO = 'co',
    CR = 'cr',
    CS = 'cs',
    CU = 'cu',
    CV = 'cv',
    CY = 'cy',
    DA = 'da',
    DE = 'de',
    DV = 'dv',
    DZ = 'dz',
    EE = 'ee',
    EL = 'el',
    EN = 'en',
    EO = 'eo',
    ES = 'es',
    ET = 'et',
    EU = 'eu',
    FA = 'fa',
    FF = 'ff',
    FI = 'fi',
    FJ = 'fj',
    FO = 'fo',
    FR = 'fr',
    FY = 'fy',
    GA = 'ga',
    GD = 'gd',
    GL = 'gl',
    GN = 'gn',
    GU = 'gu',
    GV = 'gv',
    HA = 'ha',
    HE = 'he',
    HI = 'hi',
    HO = 'ho',
    HR = 'hr',
    HT = 'ht',
    HU = 'hu',
    HY = 'hy',
    HZ = 'hz',
    IA = 'ia',
    ID = 'id',
    IE = 'ie',
    IG = 'ig',
    II = 'ii',
    IK = 'ik',
    IO = 'io',
    IS = 'is',
    IT = 'it',
    IU = 'iu',
    JA = 'ja',
    JV = 'jv',
    KA = 'ka',
    KG = 'kg',
    KI = 'ki',
    KJ = 'kj',
    KK = 'kk',
    KL = 'kl',
    KM = 'km',
    KN = 'kn',
    KO = 'ko',
    KR = 'kr',
    KS = 'ks',
    KU = 'ku',
    KV = 'kv',
    KW = 'kw',
    KY = 'ky',
    LA = 'la',
    LB = 'lb',
    LG = 'lg',
    LI = 'li',
    LN = 'ln',
    LO = 'lo',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    MG = 'mg',
    MH = 'mh',
    MI = 'mi',
    MK = 'mk',
    ML = 'ml',
    MN = 'mn',
    MR = 'mr',
    MS = 'ms',
    MT = 'mt',
    MY = 'my',
    NA = 'na',
    NB = 'nb',
    ND = 'nd',
    NE = 'ne',
    NG = 'ng',
    NL = 'nl',
    NN = 'nn',
    NO = 'no',
    NR = 'nr',
    NV = 'nv',
    NY = 'ny',
    OC = 'oc',
    OJ = 'oj',
    OM = 'om',
    OR = 'or',
    OS = 'os',
    PA = 'pa',
    PI = 'pi',
    PL = 'pl',
    PS = 'ps',
    PT = 'pt',
    QU = 'qu',
    RM = 'rm',
    RN = 'rn',
    RO = 'ro',
    RU = 'ru',
    RW = 'rw',
    SA = 'sa',
    SC = 'sc',
    SD = 'sd',
    SE = 'se',
    SG = 'sg',
    SH = 'sh',
    SI = 'si',
    SK = 'sk',
    SL = 'sl',
    SM = 'sm',
    SN = 'sn',
    SO = 'so',
    SQ = 'sq',
    SR = 'sr',
    SS = 'ss',
    ST = 'st',
    SU = 'su',
    SV = 'sv',
    SW = 'sw',
    TA = 'ta',
    TE = 'te',
    TG = 'tg',
    TH = 'th',
    TI = 'ti',
    TK = 'tk',
    TL = 'tl',
    TN = 'tn',
    TO = 'to',
    TR = 'tr',
    TS = 'ts',
    TT = 'tt',
    TW = 'tw',
    TY = 'ty',
    UG = 'ug',
    UK = 'uk',
    UR = 'ur',
    UZ = 'uz',
    VE = 've',
    VI = 'vi',
    VO = 'vo',
    WA = 'wa',
    WO = 'wo',
    XH = 'xh',
    YI = 'yi',
    YO = 'yo',
    ZA = 'za',
    ZH = 'zh',
    ZU = 'zu'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Layout = {
    readonly id: number;
    account: number;
    prettyName?: string;
    readonly name: string;
    /**
     * Language code (ISO 639), e.g. en, de, fr, etc. or mul for multiple languages
     */
    language: string;
    /**
     * HTML content of the layout, needs to have {{content}} placeholder.
     */
    content?: string;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    autoLayout: Array<AutoLayoutConfig>;
    /**
     * Indicates if the layout is usable (complete), must contain {{content}} placeholder, <body> and <html> tags.
     */
    complete?: boolean;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    /**
     * Partials that are being used in the layout.
     */
    partials?: Array<number>;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type LayoutDetail = {
    readonly id: number;
    account: number;
    prettyName?: string;
    readonly name: string;
    /**
     * Language code (ISO 639), e.g. en, de, fr, etc. or mul for multiple languages
     */
    language: string;
    /**
     * HTML content of the layout, needs to have {{content}} placeholder.
     */
    content?: string;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    autoLayout: Array<AutoLayoutConfig>;
    /**
     * Indicates if the layout is usable (complete), must contain {{content}} placeholder, <body> and <html> tags.
     */
    complete?: boolean;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    partials: Array<Partial>;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type LayoutRequest = {
    account: number;
    prettyName?: string;
    /**
     * Language code (ISO 639), e.g. en, de, fr, etc. or mul for multiple languages
     */
    language: string;
    /**
     * HTML content of the layout, needs to have {{content}} placeholder.
     */
    content?: string;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    autoLayout: Array<AutoLayoutConfigRequest>;
    /**
     * Indicates if the layout is usable (complete), must contain {{content}} placeholder, <body> and <html> tags.
     */
    complete?: boolean;
    /**
     * Partials that are being used in the layout.
     */
    partials?: Array<number>;
};

export type LineItem = {
    version?: Version5F5Enum;
    /**
     * Retailer ID of the line item
     */
    line_item_id: string;
    /**
     * Product ID of the line item in the retailer's system. This is the primary identifier of the product or product variant.
     */
    product_id?: string;
    /**
     * Stock Keeping Unit of the line item
     */
    sku?: string;
    /**
     * Line Item ID in the order
     */
    order_item_id?: string;
    /**
     * Name of the article
     */
    article_name?: string;
    /**
     * Category of the article
     */
    article_category?: string;
    /**
     * URL to the article in the store
     */
    article_store_url?: string;
    /**
     * URL to the image of the article
     */
    article_image_url?: string;
    /**
     * Brand of the article (reference only)
     */
    article_brand?: string;
    /**
     * Size of the article (reference only)
     */
    size?: string;
    /**
     * Color of the article (reference only)
     */
    color?: string;
    /**
     * Width of the article (in millimeters)
     */
    width?: number;
    /**
     * Height of the article (in millimeters)
     */
    height?: number;
    /**
     * Length of the article (in millimeters)
     */
    length?: number;
    length_unit?: string;
    /**
     * Weight of the article (in grams or lbs)
     */
    weight?: number;
    weight_unit?: WeightUnitEnum;
    /**
     * Unit price of the article
     */
    unit_price?: string;
    /**
     * Unit quantity of the article
     */
    quantity?: number;
    /**
     * Amount invoiced amount for this line item
     */
    amount_invoiced?: string;
    /**
     * ISO 3166-1 alpha-3 code of articles country of origin, might be required based on shipment regulations
     */
    origin_country_iso3?: string;
    /**
     * If the article is bulky
     */
    is_bulky?: boolean;
    /**
     * Tags for the line item, e.g. 'category:home-apparel', or 'customergroup:vip'
     */
    tags?: Array<string>;
    /**
     * Additional attributes for this line item
     */
    additional_attributes?: Array<AdditionalAttribute>;
    [key: string]: unknown | Version5F5Enum | string | number | WeightUnitEnum | number | boolean | Array<string> | Array<AdditionalAttribute> | undefined;
};

export type LineItemReturn = {
    version?: Version5F5Enum;
    /**
     * Retailer ID of the line item, only the last number part of the whole line item id string
     */
    line_item_id: string;
    /**
     * Product ID of the line item in the retailer's system. This is the primary identifier of the product or product variant.
     */
    product_id?: string;
    /**
     * Stock Keeping Unit of the line item
     */
    sku?: string;
    /**
     * Line Item ID in the order, the whole id of the fulfillment line item
     */
    order_item_id?: string | unknown;
    /**
     * Name of the article
     */
    article_name?: string;
    /**
     * Category of the article
     */
    article_category?: string;
    /**
     * URL to the article in the store
     */
    article_store_url?: string;
    /**
     * URL to the image of the article
     */
    article_image_url?: string;
    /**
     * Brand of the article (reference only)
     */
    article_brand?: string;
    /**
     * Size of the article (reference only)
     */
    size?: string;
    /**
     * Color of the article (reference only)
     */
    color?: string;
    /**
     * Width of the article (in millimeters)
     */
    width?: number;
    /**
     * Height of the article (in millimeters)
     */
    height?: number;
    /**
     * Length of the article (in millimeters)
     */
    length?: number;
    length_unit?: string;
    /**
     * Weight of the article (in grams or lbs)
     */
    weight?: number;
    weight_unit?: WeightUnitEnum;
    /**
     * Unit price of the article
     */
    unit_price?: string;
    /**
     * Unit quantity of the article
     */
    quantity?: number;
    /**
     * Amount invoiced amount for this line item
     */
    amount_invoiced?: string;
    /**
     * ISO 3166-1 alpha-3 code of articles country of origin, might be required based on shipment regulations
     */
    origin_country_iso3?: string;
    /**
     * If the article is bulky
     */
    is_bulky?: boolean;
    /**
     * Tags for the line item, e.g. 'category:home-apparel', or 'customergroup:vip'
     */
    tags?: Array<string>;
    /**
     * Additional attributes for this line item
     */
    additional_attributes?: Array<AdditionalAttribute>;
    /**
     * The date, which is used to evaluate the line item return period
     */
    reference_date_for_return?: string;
    /**
     * The date type, which is used to evaluate the line item return period
     */
    reference_date_type?: ReferenceDateTypeEnum;
    /**
     * Id of the fulfillment that this item belongs to
     */
    fulfillment?: string | unknown;
    /**
     * Quantity of already returned items in this line.
     */
    quantity_returned?: number;
    /**
     * Date when the line item was delivered (same as the fulfillment delivered date)
     */
    delivered_date?: string;
    /**
     * Return reason (as configured in the respective return configuration for this object)
     */
    return_reason?: string;
    /**
     * Pretty text for the return reason, e.g. 'Doesn't Fit'
     */
    return_reason_pretty?: string;
    /**
     * Quantity to be returned
     */
    return_quantity?: number;
    /**
     * Description of the problem with this line item
     */
    problem_description?: string;
    /**
     * Article condition, if provided
     */
    condition?: string;
    article_images?: Array<ReturnImage>;
    /**
     * Compensation method for this line item, e.g. exchange, refund, credit
     */
    compensation_method?: string;
    /**
     * Quantity of the article that was accepted by warehouse
     */
    accepted_quantity?: number;
    /**
     * Quantity of the article that was rejected by warehouse
     */
    rejected_quantity?: number;
    /**
     * Reason for the rejection / acceptance of the article
     */
    status_reason?: string;
    [key: string]: unknown | Version5F5Enum | string | (string | unknown) | number | WeightUnitEnum | number | boolean | Array<string> | Array<AdditionalAttribute> | ReferenceDateTypeEnum | (string | unknown) | Array<ReturnImage> | undefined;
};

export type LogEntryList = Array<LogEntrySerializer> | unknown;

export type LogEntrySerializer = {
    id: string;
    module: string;
    model: string;
};

export type LogicDetails = {
    conditionalPlaceholders?: Array<ConditionalPlaceholders> | unknown;
    appleWalletOrderTracking?: AppleWalletModel | unknown;
    leadTimes?: string | number | {
        [key: string]: unknown;
    } | unknown;
    forgottenThresholds?: string | number | {
        [key: string]: unknown;
    } | unknown;
    usesOnDemandReturnLabels?: boolean;
    noSecurityHash?: boolean;
    extendArticlesWithProductFeed?: boolean;
    actionBoxOverwrites?: unknown;
    autoUtm?: AutoUtm | unknown;
    alwaysHtmlEmails?: boolean;
    combinedDispatchConfirmation?: boolean;
    useLeadTimeForPrediction?: boolean;
    useAnnouncedDeliveryDateForPrediction?: boolean;
    handlingTimes?: string | number | {
        [key: string]: unknown;
    } | unknown;
    hasAlternativeSecurityHashSetting?: string | number | {
        [key: string]: unknown;
    } | unknown;
    delayedDispatchCheck?: unknown;
    weekdays?: unknown | Array<number> | {
        [key: string]: Array<number>;
    } | {
        [key: string]: {
            [key: string]: Array<number>;
        };
    };
};

/**
 * * `zip` - zip
 * * `zipOrEmail` - Zip or Email
 * * `email` - Email
 * * `none` - none
 */
export enum LoginTypeEnum {
    ZIP = 'zip',
    ZIP_OR_EMAIL = 'zipOrEmail',
    EMAIL = 'email',
    NONE = 'none'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Media = {
    readonly id: number;
    account: number;
    file: string;
    contentType?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type MediaRequest = {
    account: number;
    file: Blob | File;
    contentType?: string;
};

/**
 * Adds nested create feature
 */
export type Message = {
    readonly id: number;
    messageType: number;
    readonly account: number;
    client?: number | null;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific messages
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    /**
     * Select a layout *only* if you want to overide the auto layout configuration of the client(s).
     */
    layout?: number | null;
    subject?: string;
    /**
     * Short text of the message, e.g. for preview.
     */
    shortInfo?: string;
    content?: string;
    placeholderValues: Array<PlaceholderValue>;
    attachments?: Array<number>;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    /**
     * Enable or disable the message, if not active, message will not be sent regardless of flow triggers.
     */
    active?: boolean;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    /**
     * Partials that are being used in the message.
     */
    readonly partials: Array<number>;
    readonly updatedAt: string;
    readonly experiment: number | null;
    variantLabel: VariantLabelEnum | null;
};

/**
 * * `email` - Email
 * * `sms` - Sms
 * * `webhook` - Webhook
 */
export enum MessageChannelTypeChoices {
    EMAIL = 'email',
    SMS = 'sms',
    WEBHOOK = 'webhook'
}

/**
 * Adds nested create feature
 */
export type MessageDetail = {
    readonly id: number;
    messageType: MessageType;
    readonly account: number;
    client?: number | null;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific messages
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    layout: Layout;
    subject?: string;
    /**
     * Short text of the message, e.g. for preview.
     */
    shortInfo?: string;
    content?: string;
    placeholderValues: Array<PlaceholderValueDetail>;
    attachments: Array<Attachment>;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    /**
     * Enable or disable the message, if not active, message will not be sent regardless of flow triggers.
     */
    active?: boolean;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    partials: Array<Partial>;
    readonly updatedAt: string;
    readonly experiment: number | null;
    variantLabel: VariantLabelEnum | null;
    readonly clientKey: string | null;
};

export type MessageGenerateAttachmentResponse = {
    bucket: string;
    filename: string;
    path: string;
    isOptional: boolean;
};

export type MessageGenerateEmailResponse = {
    id: number;
    name: string;
    subject: string;
    shortInfo: string;
    attachments?: Array<MessageGenerateAttachmentResponse>;
    placeholders: Array<MessageGeneratePlaceholderResponse>;
    layout?: string | unknown;
    layoutId?: number | unknown;
    layoutName?: string | unknown;
    message: string;
    liquid: boolean;
    active: boolean;
    partials: Array<number>;
    isAiGenerated: boolean;
};

export type MessageGeneratePlaceholderResponse = {
    name: string;
    value: string;
};

export type MessageGenerateResponse = MessageGenerateResponseType;

export type MessageGenerateResponseType = MessageGenerateSmsResponse | MessageGenerateEmailResponse | MessageGenerateWebhookResponse;

export type MessageGenerateSmsResponse = {
    id: number;
    name: string;
    placeholders: Array<MessageGeneratePlaceholderResponse>;
    message: string;
    liquid: boolean;
    active: boolean;
};

export type MessageGenerateTranslationRequestRequest = {
    /**
     * Message Type ID
     */
    message_type_id: number;
    /**
     * Language Code (ISO 639-1)
     *
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    language: LanguagesIso639Enum;
};

export type MessageGenerateWebhookResponse = {
    id: number;
    name: string;
    placeholders: Array<MessageGeneratePlaceholderResponse>;
    message: {
        [key: string]: unknown;
    };
    liquid: boolean;
    active: boolean;
};

/**
 * Adds nested create feature
 */
export type MessageRequest = {
    messageType: number;
    client?: number | null;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific messages
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    /**
     * Select a layout *only* if you want to overide the auto layout configuration of the client(s).
     */
    layout?: number | null;
    subject?: string;
    /**
     * Short text of the message, e.g. for preview.
     */
    shortInfo?: string;
    content?: string;
    placeholderValues: Array<PlaceholderValueRequest>;
    attachments?: Array<number>;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    /**
     * Enable or disable the message, if not active, message will not be sent regardless of flow triggers.
     */
    active?: boolean;
};

export type MessageTestRequestRequest = {
    /**
     * List of recipient emails
     */
    recipients: Array<string>;
    /**
     * Tracking ID for the message
     */
    tracking_id?: string;
    /**
     * Event type for the message
     *
     * * `OrderCreated` - Order Created
     * * `OrderUpdated` - Order Updated
     * * `TrackingCreated` - Tracking Created
     * * `TrackingUpdated` - Tracking Updated
     * * `DeliveryStatus` - Delivery Status
     * * `DelayedDispatch` - Delayed Dispatch
     * * `LeadTimeExceeded` - Lead Time Exceeded
     * * `Invalid` - Invalid
     * * `Forgotten` - Forgotten
     * * `Dispatch` - Dispatch
     * * `Scheduled` - Scheduled
     * * `FailedAttempt` - Failed Attempt
     * * `Exception` - Exception
     * * `Delay` - Delay
     * * `Escalation` - Escalation
     * * `ReturnWarning` - Return Warning
     * * `MissingUpdates` - Missing Updates
     * * `Return` - Return
     * * `PickupReady` - Pickup Ready
     * * `Delivered` - Delivered
     * * `CustomerPromiseExceeded` - Customer Promise Exceeded
     * * `TimeWindowMissed` - Time Window Missed
     */
    event_type?: EventTypeEnum;
    /**
     * Override layout ID for the message
     */
    layout_id?: number;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type MessageType = {
    readonly id: number;
    account: number;
    readonly name: string;
    prettyName: string;
    channel?: MessageChannelTypeChoices;
    readonly latestActiveExperimentId: number | null;
    /**
     * Custom placeholders that can be used in the message(s) for this message type.
     */
    placeholders?: Array<number>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type MessageTypeDetail = {
    readonly id: number;
    account: number;
    readonly name: string;
    prettyName: string;
    channel?: MessageChannelTypeChoices;
    readonly messages: Array<Message>;
    readonly placeholders: Array<Placeholder>;
    readonly latestActiveExperimentId: number | null;
};

export type MessageTypeGenerateRequestRequest = {
    /**
     * Message Type Name
     */
    message_type_name: string;
    /**
     * Context for the message type
     */
    context?: string;
    /**
     * Account ID
     */
    account: number;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type MessageTypeList = {
    readonly id: number;
    account: number;
    readonly name: string;
    prettyName: string;
    channel?: MessageChannelTypeChoices;
    readonly latestActiveExperimentId: number | null;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type MessageTypeRequest = {
    account: number;
    prettyName: string;
    channel?: MessageChannelTypeChoices;
    /**
     * Custom placeholders that can be used in the message(s) for this message type.
     */
    placeholders?: Array<number>;
};

export type NameDetails = {
    nick: string | unknown;
    email: string;
    emailName: string | unknown;
    short: string;
    full: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Notification = {
    readonly id: number;
    /**
     * Type of the notification, e.g. voucher, return_label etc.
     *
     * * `voucher` - No voucher codes left
     * * `returns_label` - Could not create a return label for the order
     * * `tracking_creation` - Could not create tracking/order
     * * `optin` - Opt-in
     * * `recipe-applied` - Recipe has been successfully applied
     * * `recipe-failed` - Recipe couldn't be applied
     * * `returns_vendor_api` - An error occurred in the retailer API
     * * `payload_rewrite` - Something went wrong during payload rewrite
     * * `app_execution` - Something needs attention in the app execution
     * * `track_creation_failed` - Track creation failed
     * * `shopify_api` - An error occurred in the Shopify API
     * * `oauth_grant_refresh_failed` - Your OAuth tokens could not be refreshed
     * * `email_domain_white_label_verification_failed` - Email domain verification failed
     */
    type: NotificationTypeEnum;
    /**
     * One liner title of the notification
     */
    title: string;
    /**
     * More detailed description of the notification
     */
    body?: string;
    account: number;
    /**
     * Classification of the notification, e.g. critical, warning etc.
     *
     * * `critical` - Critical
     * * `error` - Error
     * * `warning` - Warning
     * * `info` - Info
     * * `success` - Success
     */
    classification?: ClassificationEnum;
    /**
     * Scopes of the notification, e.g. returns, promise etc.
     */
    scope?: Array<ScopeEnum>;
    /**
     * Hash to identify duplicate notifications
     */
    deduplication_id: string;
    /**
     * The system that generated the notification, e.g. backend, returns etc.
     *
     * * `backend` - Backend
     * * `returns` - Returns
     * * `portal` - Portal
     */
    source_system: SourceSystemEnum;
    is_dismissed?: boolean;
    is_dismissable?: boolean;
    is_resolved?: boolean;
    /**
     * The component within the system that generated the notification, e.g. cron.voucherCodes, returns.returnLabel etc.
     */
    source_component?: string;
    readonly created_at: string;
    /**
     * The url to redirect the user to
     */
    redirect_url?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type NotificationRequest = {
    /**
     * Type of the notification, e.g. voucher, return_label etc.
     *
     * * `voucher` - No voucher codes left
     * * `returns_label` - Could not create a return label for the order
     * * `tracking_creation` - Could not create tracking/order
     * * `optin` - Opt-in
     * * `recipe-applied` - Recipe has been successfully applied
     * * `recipe-failed` - Recipe couldn't be applied
     * * `returns_vendor_api` - An error occurred in the retailer API
     * * `payload_rewrite` - Something went wrong during payload rewrite
     * * `app_execution` - Something needs attention in the app execution
     * * `track_creation_failed` - Track creation failed
     * * `shopify_api` - An error occurred in the Shopify API
     * * `oauth_grant_refresh_failed` - Your OAuth tokens could not be refreshed
     * * `email_domain_white_label_verification_failed` - Email domain verification failed
     */
    type: NotificationTypeEnum;
    /**
     * One liner title of the notification
     */
    title: string;
    /**
     * More detailed description of the notification
     */
    body?: string;
    account: number;
    /**
     * Classification of the notification, e.g. critical, warning etc.
     *
     * * `critical` - Critical
     * * `error` - Error
     * * `warning` - Warning
     * * `info` - Info
     * * `success` - Success
     */
    classification?: ClassificationEnum;
    /**
     * Scopes of the notification, e.g. returns, promise etc.
     */
    scope?: Array<ScopeEnum>;
    /**
     * Hash to identify duplicate notifications
     */
    deduplication_id: string;
    /**
     * The system that generated the notification, e.g. backend, returns etc.
     *
     * * `backend` - Backend
     * * `returns` - Returns
     * * `portal` - Portal
     */
    source_system: SourceSystemEnum;
    is_dismissed?: boolean;
    is_dismissable?: boolean;
    is_resolved?: boolean;
    /**
     * The component within the system that generated the notification, e.g. cron.voucherCodes, returns.returnLabel etc.
     */
    source_component?: string;
    /**
     * The url to redirect the user to
     */
    redirect_url?: string;
};

/**
 * * `voucher` - No voucher codes left
 * * `returns_label` - Could not create a return label for the order
 * * `tracking_creation` - Could not create tracking/order
 * * `optin` - Opt-in
 * * `recipe-applied` - Recipe has been successfully applied
 * * `recipe-failed` - Recipe couldn't be applied
 * * `returns_vendor_api` - An error occurred in the retailer API
 * * `payload_rewrite` - Something went wrong during payload rewrite
 * * `app_execution` - Something needs attention in the app execution
 * * `track_creation_failed` - Track creation failed
 * * `shopify_api` - An error occurred in the Shopify API
 * * `oauth_grant_refresh_failed` - Your OAuth tokens could not be refreshed
 * * `email_domain_white_label_verification_failed` - Email domain verification failed
 */
export enum NotificationTypeEnum {
    VOUCHER = 'voucher',
    RETURNS_LABEL = 'returns_label',
    TRACKING_CREATION = 'tracking_creation',
    OPTIN = 'optin',
    RECIPE_APPLIED = 'recipe-applied',
    RECIPE_FAILED = 'recipe-failed',
    RETURNS_VENDOR_API = 'returns_vendor_api',
    PAYLOAD_REWRITE = 'payload_rewrite',
    APP_EXECUTION = 'app_execution',
    TRACK_CREATION_FAILED = 'track_creation_failed',
    SHOPIFY_API = 'shopify_api',
    OAUTH_GRANT_REFRESH_FAILED = 'oauth_grant_refresh_failed',
    EMAIL_DOMAIN_WHITE_LABEL_VERIFICATION_FAILED = 'email_domain_white_label_verification_failed'
}

/**
 * * `tracking` - Tracking
 */
export enum ObjectTypeEnum {
    TRACKING = 'tracking'
}

export enum OnlyOnceChoices {
    ORDER = 'order',
    DELIVERY_ID = 'delivery_id',
    TRACKING = 'tracking',
    ACTION_CHANNEL = 'action_channel',
    CHANNEL_DEFAULT = 'channel_default'
}

/**
 * * `order` - Per order for the first tracking matching the condition
 * * `delivery_id` - Per delivery number within an order for the first tracking matching the condition
 * * `tracking` - Per tracking in the order
 * * `action_channel` - Per trigger action channel
 * * `channel_default` - Default channel behavior (non-webhook triggers once per tracking, webhook triggers for each trigger action channel)
 */
export enum OnlyOncePerEnum {
    ORDER = 'order',
    DELIVERY_ID = 'delivery_id',
    TRACKING = 'tracking',
    ACTION_CHANNEL = 'action_channel',
    CHANNEL_DEFAULT = 'channel_default'
}

export type OpeningHourItem = {
    day: DayOfWeek;
    /**
     * Opening time (HH:MM)
     */
    open: string;
    /**
     * Closing time (HH:MM)
     */
    close: string;
};

/**
 * * `openai` - OpenAI
 */
export enum OptInsEnum {
    OPENAI = 'openai'
}

export type OrderStatusPage = {
    readonly id: number;
    account: number;
    name: string;
    key: string;
    service: number;
    is_hidden?: boolean;
    track_and_trace_filter?: {
        [key: string]: unknown;
    };
    tracking_checkpoints_filter?: {
        [key: string]: unknown;
    };
    expose_custom_fields_publicly?: Array<string>;
    disable_zip_auth?: boolean;
    disable_ip_rate_limiter?: boolean;
    zip_required?: boolean;
    is_tracking_pii?: boolean;
    always_hide_pii?: boolean;
    config?: {
        [key: string]: unknown;
    };
};

export type OrderStatusPageRequest = {
    account: number;
    name: string;
    key: string;
    service: number;
    is_hidden?: boolean;
    track_and_trace_filter?: {
        [key: string]: unknown;
    };
    tracking_checkpoints_filter?: {
        [key: string]: unknown;
    };
    expose_custom_fields_publicly?: Array<string>;
    disable_zip_auth?: boolean;
    disable_ip_rate_limiter?: boolean;
    zip_required?: boolean;
    is_tracking_pii?: boolean;
    always_hide_pii?: boolean;
    config?: {
        [key: string]: unknown;
    };
};

export enum OrderbyEnum {
    DISTANCE = 'distance',
    SIMILARITY = 'similarity'
}

export type OutputMessage = {
    response: string;
    data?: {
        [key: string]: unknown;
    };
};

export type PaginatedAccountList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Account>;
};

export type PaginatedAppDeploymentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<AppDeployment>;
};

export type PaginatedAssetList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Asset>;
};

export type PaginatedAudienceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Audience>;
};

export type PaginatedCampaignResponseList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CampaignResponse>;
};

export type PaginatedClientList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Client>;
};

export type PaginatedContentTypeList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ContentType>;
};

export type PaginatedCourierList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Courier>;
};

export type PaginatedCourierServiceLevelList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CourierServiceLevel>;
};

export type PaginatedCustomAnalyticsList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CustomAnalytics>;
};

export type PaginatedCustomAppUpdateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CustomAppUpdate>;
};

export type PaginatedCustomerPortalList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CustomerPortal>;
};

export type PaginatedDataProtectionRequestList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DataProtectionRequest>;
};

export type PaginatedDeliveryMethodDetailsList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DeliveryMethodDetails>;
};

export type PaginatedDeliveryPredictionServiceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DeliveryPredictionService>;
};

export type PaginatedDummyList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Dummy>;
};

export type PaginatedEmailList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Email>;
};

export type PaginatedEventList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Event>;
};

export type PaginatedExperimentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Experiment>;
};

export type PaginatedExperimentResultsList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ExperimentResults>;
};

export type PaginatedFilterFieldList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<FilterField>;
};

export type PaginatedImportList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Import>;
};

export type PaginatedInstalledAppList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<InstalledApp>;
};

export type PaginatedIntegrationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Integration>;
};

export type PaginatedJourneyConfigurationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<JourneyConfiguration>;
};

export type PaginatedJourneyFlowVisualizationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<JourneyFlowVisualization>;
};

export type PaginatedJourneySharedFilterList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<JourneySharedFilter>;
};

export type PaginatedJourneyTriggerEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<JourneyTriggerEvent>;
};

export type PaginatedJourneyTriggerList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<JourneyTrigger>;
};

export type PaginatedLayoutList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Layout>;
};

export type PaginatedMediaList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Media>;
};

export type PaginatedMessageList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Message>;
};

export type PaginatedMessageTypeListList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MessageTypeList>;
};

export type PaginatedNotificationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Notification>;
};

export type PaginatedOrderStatusPageList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<OrderStatusPage>;
};

export type PaginatedPartialList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Partial>;
};

export type PaginatedPlaceInfoList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<PlaceInfo>;
};

export type PaginatedPlaceholderList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Placeholder>;
};

export type PaginatedRecipeApplicationFetchList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<RecipeApplicationFetch>;
};

export type PaginatedRecipeList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Recipe>;
};

export type PaginatedRecipientList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Recipient>;
};

export type PaginatedReferenceItemList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReferenceItem>;
};

export type PaginatedReportList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Report>;
};

export type PaginatedReturnReasonList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnReason>;
};

export type PaginatedReturnRegistrationList = {
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnRegistration>;
};

export type PaginatedReturnsCourierApiList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnsCourierApi>;
};

export type PaginatedReturnsDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnsDocumentTemplate>;
};

export type PaginatedReturnsOrderApiList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnsOrderApi>;
};

export type PaginatedReturnsPortalList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnsPortal>;
};

export type PaginatedReturnsRulesList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnsRules>;
};

export type PaginatedReturnsTranslationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ReturnsTranslation>;
};

export type PaginatedSmsAutoReplyConfigList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SmsAutoReplyConfig>;
};

export type PaginatedServiceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Service>;
};

export type PaginatedSharedObjectList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SharedObject>;
};

export type PaginatedSimpleAgentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SimpleAgent>;
};

export type PaginatedSimpleAgentThreadListList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SimpleAgentThreadList>;
};

export type PaginatedSurveyAiAnalysisList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SurveyAiAnalysis>;
};

export type PaginatedSurveyAnswerList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SurveyAnswer>;
};

export type PaginatedSurveyList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Survey>;
};

export type PaginatedTrackingList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Tracking>;
};

export type PaginatedTrendingDelayConfigurationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TrendingDelayConfiguration>;
};

export type PaginatedUserList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<User>;
};

export type PaginatedWarehouseList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Warehouse>;
};

export type PaginatedWhiteLabelDomainConfigList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<WhiteLabelDomainConfig>;
};

export type PaginatedWhitelistedDomainList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<WhitelistedDomain>;
};

/**
 * * `standard` - Standard
 * * `unused` - Unused
 * * `express` - Express
 * * `expedited` - Expedited
 */
export enum ParcellabGlobalServiceLevelEnum {
    STANDARD = 'standard',
    UNUSED = 'unused',
    EXPRESS = 'express',
    EXPEDITED = 'expedited'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Partial = {
    readonly id: number;
    account: number;
    name?: string;
    category?: PartialCategoryEnum;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * HTML content of the partial.
     */
    content?: string;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    readonly updatedAt: string;
};

/**
 * * `html_component` - HTML Component
 * * `layout` - Layout
 * * `message` - Message
 */
export enum PartialCategoryEnum {
    HTML_COMPONENT = 'html_component',
    LAYOUT = 'layout',
    MESSAGE = 'message'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PartialRequest = {
    account: number;
    name?: string;
    category?: PartialCategoryEnum;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language: string;
    /**
     * HTML content of the partial.
     */
    content?: string;
};

export type PatchedAccountRequest = {
    name?: string;
    archived?: boolean;
    type?: AccountTypeEnum;
    parent?: number | null;
    prettyName?: string;
    /**
     * Activates the customer portal for users in this account.
     */
    hasPortal?: boolean;
    /**
     * Activates the Trackings and Communication section along with related analytics.
     */
    hasPortalBeta?: boolean;
    /**
     * Activates the ability to submit requests or data through the portal.
     */
    hasPortalSubmit?: boolean;
    /**
     * Activates the Promise section for configuration and analytics, and enables the Promise API for the account.
     */
    hasPromise?: boolean;
    /**
     * Activates trending delay probability. This feature requires coordination with the data team for threshold configurations.
     */
    hasTrendingDelay?: boolean;
    /**
     * Activates the email editor and journeys for designing and managing customer journeys.
     */
    hasJourney?: boolean;
    /**
     * Activates the Returns Portal, enabling users to access the Retain section in app.pl.com, including configurations and analytics.
     */
    hasReturns?: boolean;
    /**
     * Activates the new user management system for authorized users.
     */
    hasNewUserManagement?: boolean;
    /**
     * Activates customer segmentation in campaign audiences. This feature requires coordination with the data team..
     */
    hasCustomerSegmentation?: boolean;
    /**
     * Activates product recommendations for order status pages and emails. This feature requires coordination with the data team for configuration.
     */
    hasProductRecommendations?: boolean;
    /**
     * Activates returns forecasting. This feature requires coordination with the data team.
     */
    hasReturnsForecasting?: boolean;
    /**
     * Activates claims analytics reporting for detailed insights and data visualization.
     */
    hasClaimsReport?: boolean;
    /**
     * Activates advanced journey settings for more complex flow configurations.
     */
    hasJourneyAdvancedMode?: boolean;
    /**
     * Activates self-management functionality in app.pl.com.
     */
    hasReturnRulesV2?: boolean;
    /**
     * Activates Emotion AI, enabling analysis of customer emotion data. This feature requires coordination with the data team.
     */
    hasEmotionAi?: boolean;
    /**
     * Activates the benchmarking section in the portal to compare performance against industry standards.
     */
    hasBenchmarking?: boolean;
    /**
     * Activates the Smart Survey for creating advanced, customizable surveys, allowing self-service configuration and use as an additional content block in Campaigns.
     */
    hasSmartSurvey?: boolean;
    /**
     * Activates App Store access for installing apps and recipes.
     */
    hasAppStore?: boolean;
    /**
     * Activates on-demand tracking refresh for supported carriers.
     */
    hasOnDemandTrackingRefresh?: boolean;
    /**
     * Activates additional actions for outbound trackings to initiate a return from app.pl.com. This action is only visible for published Returns Portals with the 'Customer Service Portal' flag activated.
     */
    hasTrackingReturnInitiation?: boolean;
    /**
     * Activates Shopify returns analytics for supported accounts.
     */
    hasShopifyReturnsAnalytics?: boolean;
    /**
     * Activates App Development Access to create and edit application code
     */
    hasAppDevelopment?: boolean;
    /**
     * Activates the on demand messaging feature
     */
    hasOnDemandMessaging?: boolean;
    /**
     * Activates the custom analytics feature
     */
    hasCustomAnalytics?: boolean;
    /**
     * Activates A/B testing for the account
     */
    hasAbTesting?: boolean;
    optIns?: Array<OptInsEnum>;
    /**
     * Default email preview addressed used for integrations such as Email on Acid or Litmus
     */
    defaultEmailPreviewAddress?: string;
    /**
     * in days
     */
    dataRetentionInDays?: number;
    /**
     * Tracks the migration types this account is awaiting to monitor progress and block further changes from PAPI
     */
    waitingForMigration?: Array<WaitingForMigrationEnum>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedAssetRequest = {
    account?: number;
    location?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedAudienceRequest = {
    account?: number;
    key?: string;
    name?: string;
    status?: CampaignStatusChoices;
    targetFlow?: TargetFlowEnum;
    targetStage?: Array<TrackingStageChoices>;
    trackingPredicate?: {
        [key: string]: unknown;
    };
    customerSegmentationPredicate?: {
        [key: string]: unknown;
    };
};

/**
 * Adds nested create feature
 */
export type PatchedCampaignRequest = {
    account?: number;
    key?: string;
    name?: string;
    startDate?: string | null;
    endDate?: string | null;
    archiveDate?: string | null;
    priority?: number;
    status?: CampaignStatusChoices;
    campaignTargets?: Array<CampaignTargetChoices>;
    audience?: number | null;
    language?: string;
    messages?: Array<string>;
    timezone?: TimezoneEnum;
    contentBlocks?: Array<ContentBlockRequest>;
};

/**
 * Adds nested create feature
 */
export type PatchedClientRequest = {
    archived?: boolean;
    account?: number;
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    key?: string;
    isDefault?: boolean;
    /**
     * <span style="color: red;">Changing the default language may break associated `messages`.</span>
     *
     * * `mul` - Multi Language
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    defaultLanguage?: DefaultLanguageEnum;
    /**
     * <span style="color: red;">Removing any language may break associated `messages`.</span>
     */
    languages?: Array<LanguagesEnum>;
    /**
     * Shown in FROM field of emails
     */
    name?: string;
    /**
     * Full legal sender name. used for auto-generated imprints
     */
    fullName?: string;
    /**
     * Shop nickname, used in UI to quickly identify client, not customer-facing
     */
    nickName?: string;
    /**
     * Sender email address, either complete email address (domain must be whitelabeled) or sender name (uses @delivery-status.com)
     */
    email?: string;
    /**
     * Sender name override, if set, this will be used as the sender name in the FROM field of emails
     */
    emailName?: string;
    contactPubEmail?: string;
    contactSupportEmail?: string;
    contactTestEmail?: string;
    contactAlertEmail?: string;
    contactPhone?: string;
    contactWebsite?: string;
    addressStreet?: string;
    addressCity?: string;
    addressZipCode?: string;
    addressCountry?: CountriesIso3166Enum;
    socialFacebook?: string;
    socialInstagram?: string;
    socialLinkedin?: string;
    socialPinterest?: string;
    socialSnapchat?: string;
    socialTiktok?: string;
    socialTrustedshops?: string;
    socialTwitter?: string;
    socialXing?: string;
    socialYoutube?: string;
    socialYoutubePlay?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedContentTypeRequest = {
    account?: number;
    key?: string;
    status?: CampaignStatusChoices;
    name?: string;
    target?: CampaignTargetChoices;
    uiSchema?: {
        [key: string]: unknown;
    };
};

export type PatchedCourierRequest = {
    name?: string;
    key?: string;
    type?: string;
    exposeToCustomers?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedCourierServiceLevelRequest = {
    account?: number;
    courierServiceLevel?: string;
    /**
     * From slow to fast: Standard > Expedited > Express
     *
     * * `standard` - Standard
     * * `unused` - Unused
     * * `express` - Express
     * * `expedited` - Expedited
     */
    parcellabGlobalServiceLevel?: ParcellabGlobalServiceLevelEnum;
};

export type PatchedCustomAnalyticsRequest = {
    /**
     * Accounts associated with this analytics dashboard
     */
    accounts?: Array<number>;
    /**
     * Title of the custom analytics
     */
    title?: string;
    /**
     * Analytic type, e.g. dashboard, question, metric
     *
     * * `dashboard` - Dashboard
     * * `question` - Question
     * * `metric` - Metric
     */
    analytics_type?: AnalyticsTypeEnum;
    /**
     * The unique identifier of the Metabase object (dashboard, question, or metric) used for embedding or referencing in the analytics system.
     */
    entity_id?: number;
};

/**
 * Adds nested create feature
 */
export type PatchedCustomAppUpdateRequest = {
    name?: string;
    description?: string;
    images?: Array<ImagesRequest>;
    publicDescription?: string;
    prerequisites?: string;
    color?: string;
    tags?: Array<string>;
    isOfficial?: boolean;
    iconImage?: Blob | File;
    author?: string;
    placeholders?: Array<string>;
    /**
     * Instructions to generate the app code.
     */
    prompt?: string;
    hasReleasedVersion?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedCustomerPortalRequest = {
    account?: number;
    name?: string;
    service?: number;
    hasProofOfDelivery?: boolean;
    hasOrderStatusStyleEditor?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedDataProtectionRequestRequest = {
    account?: number;
    requestDenyList?: boolean;
    requestRemoval?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedDeliveryMethodRequest = {
    account?: number;
    /**
     * Unique ID for the delivery method, returned by API
     */
    name?: string;
    /**
     * Description for the delivery method
     */
    description?: string;
    warehouse?: number | null;
    courier?: number | null;
    /**
     * List of alternative courier codes used in retailer systems, can be used for API calls
     */
    courierAlias?: Array<string>;
    courierServiceLevel?: Array<number>;
    /**
     * Calibration of the prediction: Does not give earlier delivery dates, but smaller delivery date ranges — aggressive will try to go for 1 day delivery window, conservative will try to achieve very high hit rate
     *
     * * `balanced` - Balanced
     * * `conservative` - Conservative
     * * `aggressive` - Aggressive
     */
    calibration?: CalibrationEnum;
    countries?: Array<CountriesIso3166Enum>;
    regions?: Array<RegionEnum>;
    workingDays?: WorkingDaysSchemaType;
    cutoffTime?: string;
    /**
     * Select true if cutoff time after midnight counts for orders placed on the day prior<br /><i>Example:</i> Order placed on Friday at 20:00 with cutoff 16:00 and working days Mon through Fri — if checkbox is true then order will be shipped on Saturday (because the cutoff is Friday + next day = Saturday at 4pm), if false then on Monday (because the next cutoff is Monday 4pm)
     */
    cutoffInNextDay?: boolean;
    cutoffTimesPerDay?: CutoffTimesPerDay;
    /**
     * Handling time <b><u>before</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    warehouseHandlingTime?: number | null;
    warehouseHandlingTimePerDay?: HandlingTimePerDay;
    /**
     * Handling time <b><u>after</u></b> dipatch, in working hours (i.e. 24 = 1 day)
     */
    handlingTime?: number | null;
    handlingTimePerDay?: HandlingTimePerDay;
    /**
     * If true, fallback will be used even if prediction is available
     */
    alwaysUseFallback?: boolean;
    /**
     * In courier working days
     */
    fallbackMin?: number | null;
    /**
     * In courier working days
     */
    fallbackMax?: number | null;
    /**
     * In courier working days
     */
    predictionMin?: number | null;
    /**
     * In courier working days
     */
    predictionMax?: number | null;
};

/**
 * Adds nested create feature
 */
export type PatchedDeliveryPredictionServiceRequest = {
    account?: number;
    /**
     * <i>Only internal:</i> Alternative Redshift SQL query to select field for courier service level
     */
    courierServiceLevelQuery?: string;
    activeDeliveryMethods?: Array<number>;
    promiseRules?: Array<PromiseRuleRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedDummyRequest = {
    name?: string;
    account?: number;
    jsonField?: {
        [key: string]: unknown;
    } | null;
    children?: Array<DummyChildRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedExperimentRequest = {
    account?: number;
    name?: string;
    status?: ExperimentStatusEnum;
    messageType?: number;
    startDate?: string;
    endDate?: string;
    ratios?: Array<ExperimentRatioRequest>;
    archived?: boolean;
};

export type PatchedExperimentWinnerRequestRequest = {
    /**
     * Experiment Variant Label
     *
     * * `A` - Variant A
     * * `B` - Variant B
     */
    variant_label?: VariantLabelEnum;
};

export type PatchedFilterFieldRequest = {
    name?: string;
    label?: string;
    description?: string;
    operators?: Array<{
        [key: string]: unknown;
    }>;
    defaultOperator?: DefaultOperatorEnum;
    valueEditorType?: ValueEditorTypeEnum | null;
    inputType?: InputTypeEnum | null;
    values?: FilterFieldValueListRequest;
    placeholder?: string;
    tags?: Array<string>;
};

/**
 * Basic serializer for InstalledApp used in list and update operations.
 */
export type PatchedInstalledAppRequest = {
    account?: number;
    customApp?: number;
    /**
     * The ascending order in which apps of the same type are run
     */
    logicalOrder?: number;
    installedAppIntegrations?: Array<InstalledAppIntegrationRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedIntegrationRequest = {
    account?: number;
    name?: string;
    service?: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedJourneyConfigurationRequest = {
    name?: string;
    client?: number | null;
    account?: number;
    /**
     * Sift filter that will be added to all of the triggers belonging to this journey
     */
    filterExpression?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedJourneyFlowVisualizationRequest = {
    account?: number;
    journeyConfiguration?: number;
    name?: string;
    flow?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedJourneySharedFilterRequest = {
    /**
     * The best way to reference the script is by it's name, which should be unique
     */
    name?: string;
    filterExpression?: {
        [key: string]: unknown;
    } | null;
    /**
     * This identifier is generated automatically when the filter is first created, if this filter was imported then the hash is probably being used on a filter
     */
    uniqueIdentifier?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedJourneyTriggerEventRequest = {
    name?: string;
    account?: number;
    /**
     * Event subtypes to respond to. _( "*" ) is a special tag to respond to anything.
     */
    eventTypes?: Array<string>;
    /**
     * Specify which incoming events should this match to.
     */
    slotTypes?: Array<SlotTypesEnum>;
    /**
     * The logical order of the event, auto-defined based on logical slot order if not set manually
     */
    logicalOrder?: number;
};

/**
 * Adds nested create feature
 */
export type PatchedJourneyTriggerRequest = {
    journey?: number | null;
    name?: string;
    /**
     * At the moment of matching the event, check this filter against the tracking to see if we run any actions.
     */
    filterExpression?: {
        [key: string]: unknown;
    };
    events?: Array<JourneyTriggerEventRequest>;
    actions?: Array<JourneyTriggerActionRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedLayoutRequest = {
    account?: number;
    prettyName?: string;
    /**
     * Language code (ISO 639), e.g. en, de, fr, etc. or mul for multiple languages
     */
    language?: string;
    /**
     * HTML content of the layout, needs to have {{content}} placeholder.
     */
    content?: string;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    autoLayout?: Array<AutoLayoutConfigRequest>;
    /**
     * Indicates if the layout is usable (complete), must contain {{content}} placeholder, <body> and <html> tags.
     */
    complete?: boolean;
    /**
     * Partials that are being used in the layout.
     */
    partials?: Array<number>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedMediaRequest = {
    account?: number;
    file?: Blob | File;
    contentType?: string;
};

/**
 * Adds nested create feature
 */
export type PatchedMessageRequest = {
    messageType?: number;
    client?: number | null;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language?: string;
    /**
     * Optional ISO 3166-1 alpha-3 country code e.g. USA, in case of country-specific messages
     *
     * * `ABW` - Aruba (Abw)
     * * `AFG` - Afghanistan (Afg)
     * * `AGO` - Angola (Ago)
     * * `AIA` - Anguilla (Aia)
     * * `ALA` - Åland Islands (Ala)
     * * `ALB` - Albania (Alb)
     * * `AND` - Andorra (And)
     * * `ARE` - United Arab Emirates (Are)
     * * `ARG` - Argentina (Arg)
     * * `ARM` - Armenia (Arm)
     * * `ASM` - American Samoa (Asm)
     * * `ATA` - Antarctica (Ata)
     * * `ATF` - French Southern Territories (Atf)
     * * `ATG` - Antigua And Barbuda (Atg)
     * * `AUS` - Australia (Aus)
     * * `AUT` - Austria (Aut)
     * * `AZE` - Azerbaijan (Aze)
     * * `BDI` - Burundi (Bdi)
     * * `BEL` - Belgium (Bel)
     * * `BEN` - Benin (Ben)
     * * `BES` - Bonaire, Sint Eustatius And Saba (Bes)
     * * `BFA` - Burkina Faso (Bfa)
     * * `BGD` - Bangladesh (Bgd)
     * * `BGR` - Bulgaria (Bgr)
     * * `BHR` - Bahrain (Bhr)
     * * `BHS` - Bahamas (Bhs)
     * * `BIH` - Bosnia And Herzegovina (Bih)
     * * `BLM` - Saint Barthélemy (Blm)
     * * `BLR` - Belarus (Blr)
     * * `BLZ` - Belize (Blz)
     * * `BMU` - Bermuda (Bmu)
     * * `BOL` - Bolivia, Plurinational State Of (Bol)
     * * `BRA` - Brazil (Bra)
     * * `BRB` - Barbados (Brb)
     * * `BRN` - Brunei Darussalam (Brn)
     * * `BTN` - Bhutan (Btn)
     * * `BVT` - Bouvet Island (Bvt)
     * * `BWA` - Botswana (Bwa)
     * * `CAF` - Central African Republic (Caf)
     * * `CAN` - Canada (Can)
     * * `CCK` - Cocos (Keeling) Islands (Cck)
     * * `CHE` - Switzerland (Che)
     * * `CHL` - Chile (Chl)
     * * `CHN` - China (Chn)
     * * `CIV` - Côte D'Ivoire (Civ)
     * * `CMR` - Cameroon (Cmr)
     * * `COD` - Congo, The Democratic Republic Of The (Cod)
     * * `COG` - Congo (Cog)
     * * `COK` - Cook Islands (Cok)
     * * `COL` - Colombia (Col)
     * * `COM` - Comoros (Com)
     * * `CPV` - Cabo Verde (Cpv)
     * * `CRI` - Costa Rica (Cri)
     * * `CUB` - Cuba (Cub)
     * * `CUW` - Curaçao (Cuw)
     * * `CXR` - Christmas Island (Cxr)
     * * `CYM` - Cayman Islands (Cym)
     * * `CYP` - Cyprus (Cyp)
     * * `CZE` - Czechia (Cze)
     * * `DEU` - Germany (Deu)
     * * `DJI` - Djibouti (Dji)
     * * `DMA` - Dominica (Dma)
     * * `DNK` - Denmark (Dnk)
     * * `DOM` - Dominican Republic (Dom)
     * * `DZA` - Algeria (Dza)
     * * `ECU` - Ecuador (Ecu)
     * * `EGY` - Egypt (Egy)
     * * `ERI` - Eritrea (Eri)
     * * `ESH` - Western Sahara (Esh)
     * * `ESP` - Spain (Esp)
     * * `EST` - Estonia (Est)
     * * `ETH` - Ethiopia (Eth)
     * * `FIN` - Finland (Fin)
     * * `FJI` - Fiji (Fji)
     * * `FLK` - Falkland Islands (Malvinas) (Flk)
     * * `FRA` - France (Fra)
     * * `FRO` - Faroe Islands (Fro)
     * * `FSM` - Micronesia, Federated States Of (Fsm)
     * * `GAB` - Gabon (Gab)
     * * `GBR` - United Kingdom (Gbr)
     * * `GEO` - Georgia (Geo)
     * * `GGY` - Guernsey (Ggy)
     * * `GHA` - Ghana (Gha)
     * * `GIB` - Gibraltar (Gib)
     * * `GIN` - Guinea (Gin)
     * * `GLP` - Guadeloupe (Glp)
     * * `GMB` - Gambia (Gmb)
     * * `GNB` - Guinea-Bissau (Gnb)
     * * `GNQ` - Equatorial Guinea (Gnq)
     * * `GRC` - Greece (Grc)
     * * `GRD` - Grenada (Grd)
     * * `GRL` - Greenland (Grl)
     * * `GTM` - Guatemala (Gtm)
     * * `GUF` - French Guiana (Guf)
     * * `GUM` - Guam (Gum)
     * * `GUY` - Guyana (Guy)
     * * `HKG` - Hong Kong (Hkg)
     * * `HMD` - Heard Island And Mcdonald Islands (Hmd)
     * * `HND` - Honduras (Hnd)
     * * `HRV` - Croatia (Hrv)
     * * `HTI` - Haiti (Hti)
     * * `HUN` - Hungary (Hun)
     * * `IDN` - Indonesia (Idn)
     * * `IMN` - Isle Of Man (Imn)
     * * `IND` - India (Ind)
     * * `IOT` - British Indian Ocean Territory (Iot)
     * * `IRL` - Ireland (Irl)
     * * `IRN` - Iran, Islamic Republic Of (Irn)
     * * `IRQ` - Iraq (Irq)
     * * `ISL` - Iceland (Isl)
     * * `ISR` - Israel (Isr)
     * * `ITA` - Italy (Ita)
     * * `JAM` - Jamaica (Jam)
     * * `JEY` - Jersey (Jey)
     * * `JOR` - Jordan (Jor)
     * * `JPN` - Japan (Jpn)
     * * `KAZ` - Kazakhstan (Kaz)
     * * `KEN` - Kenya (Ken)
     * * `KGZ` - Kyrgyzstan (Kgz)
     * * `KHM` - Cambodia (Khm)
     * * `KIR` - Kiribati (Kir)
     * * `KNA` - Saint Kitts And Nevis (Kna)
     * * `KOR` - Korea, Republic Of (Kor)
     * * `KWT` - Kuwait (Kwt)
     * * `LAO` - Lao People'S Democratic Republic (Lao)
     * * `LBN` - Lebanon (Lbn)
     * * `LBR` - Liberia (Lbr)
     * * `LBY` - Libya (Lby)
     * * `LCA` - Saint Lucia (Lca)
     * * `LIE` - Liechtenstein (Lie)
     * * `LKA` - Sri Lanka (Lka)
     * * `LSO` - Lesotho (Lso)
     * * `LTU` - Lithuania (Ltu)
     * * `LUX` - Luxembourg (Lux)
     * * `LVA` - Latvia (Lva)
     * * `MAC` - Macao (Mac)
     * * `MAF` - Saint Martin (French Part) (Maf)
     * * `MAR` - Morocco (Mar)
     * * `MCO` - Monaco (Mco)
     * * `MDA` - Moldova, Republic Of (Mda)
     * * `MDG` - Madagascar (Mdg)
     * * `MDV` - Maldives (Mdv)
     * * `MEX` - Mexico (Mex)
     * * `MHL` - Marshall Islands (Mhl)
     * * `MKD` - North Macedonia (Mkd)
     * * `MLI` - Mali (Mli)
     * * `MLT` - Malta (Mlt)
     * * `MMR` - Myanmar (Mmr)
     * * `MNE` - Montenegro (Mne)
     * * `MNG` - Mongolia (Mng)
     * * `MNP` - Northern Mariana Islands (Mnp)
     * * `MOZ` - Mozambique (Moz)
     * * `MRT` - Mauritania (Mrt)
     * * `MSR` - Montserrat (Msr)
     * * `MTQ` - Martinique (Mtq)
     * * `MUS` - Mauritius (Mus)
     * * `MWI` - Malawi (Mwi)
     * * `MYS` - Malaysia (Mys)
     * * `MYT` - Mayotte (Myt)
     * * `NAM` - Namibia (Nam)
     * * `NCL` - New Caledonia (Ncl)
     * * `NER` - Niger (Ner)
     * * `NFK` - Norfolk Island (Nfk)
     * * `NGA` - Nigeria (Nga)
     * * `NIC` - Nicaragua (Nic)
     * * `NIU` - Niue (Niu)
     * * `NLD` - Netherlands (Nld)
     * * `NOR` - Norway (Nor)
     * * `NPL` - Nepal (Npl)
     * * `NRU` - Nauru (Nru)
     * * `NZL` - New Zealand (Nzl)
     * * `OMN` - Oman (Omn)
     * * `PAK` - Pakistan (Pak)
     * * `PAN` - Panama (Pan)
     * * `PCN` - Pitcairn (Pcn)
     * * `PER` - Peru (Per)
     * * `PHL` - Philippines (Phl)
     * * `PLW` - Palau (Plw)
     * * `PNG` - Papua New Guinea (Png)
     * * `POL` - Poland (Pol)
     * * `PRI` - Puerto Rico (Pri)
     * * `PRK` - Korea, Democratic People'S Republic Of (Prk)
     * * `PRT` - Portugal (Prt)
     * * `PRY` - Paraguay (Pry)
     * * `PSE` - Palestine, State Of (Pse)
     * * `PYF` - French Polynesia (Pyf)
     * * `QAT` - Qatar (Qat)
     * * `REU` - Réunion (Reu)
     * * `ROU` - Romania (Rou)
     * * `RUS` - Russian Federation (Rus)
     * * `RWA` - Rwanda (Rwa)
     * * `SAU` - Saudi Arabia (Sau)
     * * `SDN` - Sudan (Sdn)
     * * `SEN` - Senegal (Sen)
     * * `SGP` - Singapore (Sgp)
     * * `SGS` - South Georgia And The South Sandwich Islands (Sgs)
     * * `SHN` - Saint Helena, Ascension And Tristan Da Cunha (Shn)
     * * `SJM` - Svalbard And Jan Mayen (Sjm)
     * * `SLB` - Solomon Islands (Slb)
     * * `SLE` - Sierra Leone (Sle)
     * * `SLV` - El Salvador (Slv)
     * * `SMR` - San Marino (Smr)
     * * `SOM` - Somalia (Som)
     * * `SPM` - Saint Pierre And Miquelon (Spm)
     * * `SRB` - Serbia (Srb)
     * * `SSD` - South Sudan (Ssd)
     * * `STP` - Sao Tome And Principe (Stp)
     * * `SUR` - Suriname (Sur)
     * * `SVK` - Slovakia (Svk)
     * * `SVN` - Slovenia (Svn)
     * * `SWE` - Sweden (Swe)
     * * `SWZ` - Eswatini (Swz)
     * * `SXM` - Sint Maarten (Dutch Part) (Sxm)
     * * `SYC` - Seychelles (Syc)
     * * `SYR` - Syrian Arab Republic (Syr)
     * * `TCA` - Turks And Caicos Islands (Tca)
     * * `TCD` - Chad (Tcd)
     * * `TGO` - Togo (Tgo)
     * * `THA` - Thailand (Tha)
     * * `TJK` - Tajikistan (Tjk)
     * * `TKL` - Tokelau (Tkl)
     * * `TKM` - Turkmenistan (Tkm)
     * * `TLS` - Timor-Leste (Tls)
     * * `TON` - Tonga (Ton)
     * * `TTO` - Trinidad And Tobago (Tto)
     * * `TUN` - Tunisia (Tun)
     * * `TUR` - Türkiye (Tur)
     * * `TUV` - Tuvalu (Tuv)
     * * `TWN` - Taiwan, Province Of China (Twn)
     * * `TZA` - Tanzania, United Republic Of (Tza)
     * * `UGA` - Uganda (Uga)
     * * `UKR` - Ukraine (Ukr)
     * * `UMI` - United States Minor Outlying Islands (Umi)
     * * `URY` - Uruguay (Ury)
     * * `USA` - United States (Usa)
     * * `UZB` - Uzbekistan (Uzb)
     * * `VAT` - Holy See (Vatican City State) (Vat)
     * * `VCT` - Saint Vincent And The Grenadines (Vct)
     * * `VEN` - Venezuela, Bolivarian Republic Of (Ven)
     * * `VGB` - Virgin Islands, British (Vgb)
     * * `VIR` - Virgin Islands, U.S. (Vir)
     * * `VNM` - Viet Nam (Vnm)
     * * `VUT` - Vanuatu (Vut)
     * * `WLF` - Wallis And Futuna (Wlf)
     * * `WSM` - Samoa (Wsm)
     * * `YEM` - Yemen (Yem)
     * * `ZAF` - South Africa (Zaf)
     * * `ZMB` - Zambia (Zmb)
     * * `ZWE` - Zimbabwe (Zwe)
     */
    country?: CountriesIso3166Enum;
    /**
     * Select a layout *only* if you want to overide the auto layout configuration of the client(s).
     */
    layout?: number | null;
    subject?: string;
    /**
     * Short text of the message, e.g. for preview.
     */
    shortInfo?: string;
    content?: string;
    placeholderValues?: Array<PlaceholderValueRequest>;
    attachments?: Array<number>;
    /**
     * Enable Liquid templating
     */
    liquid?: boolean;
    /**
     * Enable or disable the message, if not active, message will not be sent regardless of flow triggers.
     */
    active?: boolean;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type PatchedMessageTypeRequest = {
    account?: number;
    prettyName?: string;
    channel?: MessageChannelTypeChoices;
    /**
     * Custom placeholders that can be used in the message(s) for this message type.
     */
    placeholders?: Array<number>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedNotificationRequest = {
    /**
     * Type of the notification, e.g. voucher, return_label etc.
     *
     * * `voucher` - No voucher codes left
     * * `returns_label` - Could not create a return label for the order
     * * `tracking_creation` - Could not create tracking/order
     * * `optin` - Opt-in
     * * `recipe-applied` - Recipe has been successfully applied
     * * `recipe-failed` - Recipe couldn't be applied
     * * `returns_vendor_api` - An error occurred in the retailer API
     * * `payload_rewrite` - Something went wrong during payload rewrite
     * * `app_execution` - Something needs attention in the app execution
     * * `track_creation_failed` - Track creation failed
     * * `shopify_api` - An error occurred in the Shopify API
     * * `oauth_grant_refresh_failed` - Your OAuth tokens could not be refreshed
     * * `email_domain_white_label_verification_failed` - Email domain verification failed
     */
    type?: NotificationTypeEnum;
    /**
     * One liner title of the notification
     */
    title?: string;
    /**
     * More detailed description of the notification
     */
    body?: string;
    account?: number;
    /**
     * Classification of the notification, e.g. critical, warning etc.
     *
     * * `critical` - Critical
     * * `error` - Error
     * * `warning` - Warning
     * * `info` - Info
     * * `success` - Success
     */
    classification?: ClassificationEnum;
    /**
     * Scopes of the notification, e.g. returns, promise etc.
     */
    scope?: Array<ScopeEnum>;
    /**
     * Hash to identify duplicate notifications
     */
    deduplication_id?: string;
    /**
     * The system that generated the notification, e.g. backend, returns etc.
     *
     * * `backend` - Backend
     * * `returns` - Returns
     * * `portal` - Portal
     */
    source_system?: SourceSystemEnum;
    is_dismissed?: boolean;
    is_dismissable?: boolean;
    is_resolved?: boolean;
    /**
     * The component within the system that generated the notification, e.g. cron.voucherCodes, returns.returnLabel etc.
     */
    source_component?: string;
    /**
     * The url to redirect the user to
     */
    redirect_url?: string;
};

export type PatchedOrderStatusPageRequest = {
    account?: number;
    name?: string;
    key?: string;
    service?: number;
    is_hidden?: boolean;
    track_and_trace_filter?: {
        [key: string]: unknown;
    };
    tracking_checkpoints_filter?: {
        [key: string]: unknown;
    };
    expose_custom_fields_publicly?: Array<string>;
    disable_zip_auth?: boolean;
    disable_ip_rate_limiter?: boolean;
    zip_required?: boolean;
    is_tracking_pii?: boolean;
    always_hide_pii?: boolean;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedPartialRequest = {
    account?: number;
    name?: string;
    category?: PartialCategoryEnum;
    /**
     * Language code (ISO 639), e.g. en, de, etc. & mul for multi-language messages
     */
    language?: string;
    /**
     * HTML content of the partial.
     */
    content?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedPlaceInfoRequest = {
    /**
     * Address of this place
     */
    locationAddress?: AddressSchema;
    /**
     * Geo-location of this place
     */
    location?: GeoLocation;
    /**
     * Opening hours of this place
     */
    openingHours?: Array<OpeningHourItem>;
    rawPlaceType?: string;
    courier?: string;
    /**
     * ISO 3166-1 alpha-3 code of the country
     */
    countryIso3?: string;
    /**
     * Type of this place
     *
     * * `default` - Default (first party)
     * * `self_service` - Self-Service / Locker
     * * `partner_location` - Partner Location
     * * `store` - Store
     * * `other` - Other (e.g. hub)
     */
    placeType?: PlaceTypeEnum;
    /**
     * Name of this place
     */
    name?: string;
    phoneNumber?: string;
    website?: string;
    /**
     * Search Criteria that this place matches
     */
    criteria?: Array<string>;
    /**
     * Services provided at this place
     */
    services?: Array<ServicesEnum>;
    /**
     * Raw (carrier-provided) services provided at this place
     */
    rawServices?: Array<string>;
    /**
     * Whether this place info includes place details
     */
    hasDetails?: boolean;
    /**
     * Whether this place is in service (open)
     */
    isInService?: boolean;
    /**
     * External (3rd party) reference of this place, e.g. unique location ID
     */
    externalReference?: string;
    /**
     * parcelLab generated unique ID for this place
     */
    externalId?: string;
    /**
     * Additional information about this place
     */
    additionalInfo?: {
        [key: string]: unknown;
    };
    account?: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedPlaceholderRequest = {
    account?: number;
    name?: string;
    description?: string;
    category?: PlaceholderCategoryEnum;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReferenceItemRequest = {
    key?: string;
    name?: string;
    type?: ReferenceItemTypeEnum;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReportRequest = {
    account?: number;
    powerbiReportId?: string;
    isTemplate?: boolean;
    createdBy?: number;
    dataset?: number;
    name?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnReasonRequest = {
    /**
     * Parent return reason group of this return reason or group
     */
    parent?: number | null;
    account?: number;
    type?: ReturnReasonTypeEnum;
    /**
     * Default (untranslated) name of this return reason
     */
    name?: string;
    /**
     * Unique technical code for this return reason
     */
    code?: string;
    /**
     * When activated this return reason group will always be shown, even if it does not have siblings and is the only group at the respective level
     */
    alwaysShow?: boolean;
    itemOrder?: ItemOrderEnum;
    problemDescription?: ImageUploadEnum;
    /**
     * Minimum length of the problem description
     */
    problemDescriptionMinLength?: number;
    /**
     * Note for this return reason, shown to customer
     */
    note?: string;
    imageUpload?: ImageUploadEnum;
    /**
     * External code for this return reason
     *
     * * `COLOR` - COLOR
     * * `DEFECTIVE` - DEFECTIVE
     * * `NOT_AS_DESCRIBED` - NOT_AS_DESCRIBED
     * * `OTHER` - OTHER
     * * `SIZE_TOO_LARGE` - SIZE_TOO_LARGE
     * * `SIZE_TOO_SMALL` - SIZE_TOO_SMALL
     * * `STYLE` - STYLE
     * * `UNKNOWN` - UNKNOWN
     * * `UNWANTED` - UNWANTED
     * * `WRONG_ITEM` - WRONG_ITEM
     */
    shopifyReturnReason?: ShopifyReturnReasonEnum;
    /**
     * Tags for this return reason
     */
    tags?: Array<ReturnReasonTagsEnum>;
    /**
     * Eligibility rules for this compensation method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnRegistrationRequest = {
    articlesReturn?: Array<LineItemReturn>;
    articlesOrder?: Array<LineItem>;
    returnLabels?: Array<ReturnLabel>;
    customerAddress?: AddressSchema;
    version?: string | null;
    /**
     * Configuration code (unique identifier of the return portal or configuration used for this return
     */
    code?: string;
    /**
     * Unique identifier for this return registration, generated by parcelLab
     */
    externalId?: string;
    /**
     * Additional identifier (e.g. shop system id) for this return registration, generated by the retailer
     */
    externalReference?: string;
    /**
     * Retailer reference, e.g. the order number, not unique
     */
    reference?: string;
    /**
     * If true, the registration has been submitted. This is a read-only field.
     *
     * * `created` - Created
     * * `submitted` - Submitted
     * * `pending_approval` - Pending Approval
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     * * `closed` - Closed
     * * `processing_failed` - Processing Failed
     */
    status?: ReturnRegistrationStatusEnum;
    /**
     * Reason for the current status
     */
    statusReason?: string;
    originalCourier?: string;
    originalOrderId?: string | null;
    /**
     * Total amount of the original order
     */
    orderTotalAmount?: string | null;
    /**
     * Currency of the order, e.g. USD, EUR (ISO 4217)
     */
    orderCurrency?: string;
    /**
     * Language locale for this return registration, e.g. 'en', 'de', 'fr'
     */
    locale?: string;
    /**
     * ISO 639-1 language code of the recipient, if known, required for localized communication
     */
    languageIso2?: string;
    /**
     * Payment method used for the order, as setup as reference items in the accounts configuration
     */
    orderPaymentMethod?: Array<string>;
    /**
     * Date of the order
     */
    orderDate?: string | null;
    /**
     * Date of the order shipment
     */
    orderShippingDate?: string | null;
    /**
     * Date of the order delivery
     */
    orderDeliveryDate?: string | null;
    customerId?: string;
    customerEmail?: string;
    customerSalutation?: string;
    customerFirstName?: string;
    customerLastName?: string;
    /**
     * Customer phone number
     */
    customerPhone?: string;
    /**
     * ISO 3166-1 alpha-3 code of country
     */
    customerCountryIso3?: string;
    /**
     * Customer return history
     */
    customerReturnHistory?: {
        [key: string]: unknown;
    } | null;
    fulfillments?: {
        [key: string]: unknown;
    };
    /**
     * Refund method selected by customer
     */
    refundMethod?: string;
    /**
     * Purchase origin of the order
     */
    purchaseOrigin?: string;
    /**
     * Tags for the object, format <key>:<value>e.g. 'category:Home Apparel'
     */
    tags?: Array<string>;
    /**
     * Additional fields for the return registration
     */
    additionalFields?: {
        [key: string]: unknown;
    };
    /**
     * Verification code (e.g. zip/email) used for this return registration
     */
    verificationCodeUsed?: string;
    returnsPortalId?: string;
    sequenceId?: number | null;
    /**
     * Shop data for the return registration
     */
    interfaceData?: {
        [key: string]: unknown;
    };
    /**
     * Passthrough of custom fields of the original tracking via returns portal
     */
    outboundCustomFields?: {
        [key: string]: unknown;
    };
    /**
     * Indicates if the return is a pickup.
     */
    isPickup?: boolean;
    /**
     * Billing Address
     */
    billingAddress?: {
        [key: string]: unknown;
    };
    /**
     * Return from Address
     */
    returnFromAddress?: {
        [key: string]: unknown;
    };
    /**
     * Selected address for the return
     *
     * * `customer_address` - Customer Address
     * * `billing_address` - Billing Address
     * * `return_from_address` - Return from Address
     */
    selectedAddress?: SelectedAddressEnum;
    /**
     * Split factor for a/b-experiments
     */
    splitFactor?: number;
    /**
     * Account, that is linked to this registration.
     */
    account?: number;
    /**
     * Name of the technical client / shop (corresponds to the system setup), e.g. 'mybrand-a.com'
     */
    client?: number | null;
    config?: number | null;
    order?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnsCourierApiRequest = {
    account?: number;
    courierCode?: string;
    /**
     * Identifier, for instance Warehouse code
     */
    identifier?: string;
    name?: string;
    service?: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnsDocumentTemplateRequest = {
    account?: number;
    name?: string;
    /**
     * Technical key, must not contain white space
     */
    key?: string;
    /**
     * Optional identifier for the template to be used (e.g. language code / local)
     */
    identifier?: string;
    content?: string;
    requiredFields?: Array<string>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnsOrderApiRequest = {
    account?: number;
    name?: string;
    service?: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Adds nested create feature
 */
export type PatchedReturnsPortalRequest = {
    account?: number;
    name?: string;
    service?: number;
    /**
     * Optional: OAuth2 authorization grant for this service
     */
    authorizationGrant?: number | null;
    config?: {
        [key: string]: unknown;
    };
    client?: number | null;
    /**
     * Return reason groups to use for this portal
     */
    returnReasons?: Array<number>;
    compensationMethods?: Array<CompensationMethodRequest>;
    /**
     * Country and language for this portal, e.g. 'de-de' (country-language)
     */
    code?: string;
    /**
     * When activated parcelLab will host the return portal
     */
    isPlHosted?: boolean;
    /**
     * When activated the returns portal will appear in production mode (No endless spinner)
     */
    isLive?: boolean;
    /**
     * Display portal for embedded returns in app.parcellab.com
     */
    isCustomerServicePortal?: boolean;
    /**
     * RegEx to validate login credentials
     */
    loginFormat?: string;
    loginType?: LoginTypeEnum;
    /**
     * Characters to strip from reference code (Supports regex)
     */
    loginRefStripCharacters?: string;
    /**
     * RegEx to validate the login reference credentials
     */
    loginRefFormat?: string;
    /**
     * When activated returns portal will check for returnable periods, you need to set returnable periods
     */
    checkReturnability?: boolean;
    checkReturnabilityOnLoginPage?: boolean;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceStart?: string | null;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceEnd?: string | null;
    /**
     * Add this if you want to use preview features
     */
    productionUrl?: string;
    stagingUrl?: string;
    returnablePeriods?: Array<ReturnablePeriodRequest>;
    /**
     * The API to be used to fetch order information
     */
    returnsOrderApi?: number | null;
    /**
     * Translations definition to use for this portal
     */
    returnsTranslation?: number | null;
    /**
     * Returns reasons to use for this portal
     */
    returnsRules?: number | null;
    returnsCourierApis?: Array<ReturnsPortalCourierMappingRequest>;
    refundMethods?: Array<RefundMethodRequest>;
    extraAttributes?: Array<AttributeRequest>;
    articleFilters?: Array<ReturnsArticleFilterRequest>;
    /**
     * Required for creating return trackings in the parcelLab portal
     */
    parcellabApiKey?: string;
    secureWithSso?: boolean;
    /**
     * Additional translations for this portal
     */
    additionalTranslations?: Array<number>;
    /**
     * Theme to use for this portal
     */
    theme?: number | null;
    archived?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnsRulesRequest = {
    account?: number;
    name?: string;
    service?: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedReturnsTranslationRequest = {
    account?: number;
    name?: string;
    service?: number;
    code?: string;
    language?: LanguagesIso639Enum;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedSmsAutoReplyConfigRequest = {
    messageTypeOptIn?: MessageTypeRequest;
    messageTypeOptOut?: MessageTypeRequest;
    messageTypeHelp?: MessageTypeRequest;
};

export type PatchedServiceRequest = {
    name?: string;
    key?: string;
    role?: RoleEnum;
    configSchema?: {
        [key: string]: unknown;
    };
    /**
     * Optional: Auth Client Application for this service, which allows customers to authorize via OAuth2
     */
    authClient?: number | null;
    account?: number;
    isPublicService?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedSharedObjectRequest = {
    account?: number;
    objectType?: ObjectTypeEnum;
    objectId?: string;
};

export type PatchedSimpleAgentAddMessageRequest = {
    query?: string;
    context?: {
        [key: string]: unknown;
    };
};

export type PatchedSurveyRequest = {
    config?: {
        [key: string]: unknown;
    };
    name?: string;
    type?: SurveyTypeEnum;
    account?: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PatchedTrendingDelayConfigurationRequest = {
    account?: number;
    client?: number | null;
    /**
     * Warning threshold probability, in percent
     */
    probabilityThresholdWarning?: number;
    /**
     * Delayed threshold probability, in percent
     */
    probabilityThresholdDelayed?: number;
    activationConfigs?: Array<TrendingDelayActivationConfigRequest>;
};

export type PatchedUserRequest = {
    password?: string;
    jobTitle?: string;
    phoneNumber?: string;
    hasMarketingOptIn?: boolean;
    profileRole?: ProfileRoleEnum;
    /**
     * Has early access to new features (should be used internally, unless otherwise confirmed with Product Owners)
     */
    hasPreviewFeatures?: boolean;
};

export type PatchedUserSettingsRequest = {
    firstName?: string;
    lastName?: string;
    userLocale?: string;
    /**
     * Uses new track & comms module by default
     */
    hasPortalBetaEnabled?: boolean;
    portalSettings?: {
        [key: string]: unknown;
    };
    jobTitle?: string;
    phoneNumber?: string;
    hasMarketingOptIn?: boolean;
    profileRole?: ProfileRoleEnum;
    /**
     * Indicates if all required user profile fields have been filled out.
     */
    profileCompleted?: boolean;
};

/**
 * Adds nested create feature
 */
export type PatchedWarehouseRequest = {
    account?: number;
    /**
     * Pretty name for the warehouse
     */
    name?: string;
    /**
     * Unique ID for the warehouse, can be used for API calls
     */
    key?: string;
    /**
     * List of alternative warehouse codes used in retailer systems, can be used for API calls<br /><b>Important:</b> Needs to list all alternative spellings of the same warehouse in Redshift/trackings/delivery_info_warehoue
     */
    aliases?: Array<string>;
    country?: CountriesIso3166Enum;
    region?: RegionEnum;
    zip?: string;
    timezone?: TimezoneEnum;
    /**
     * If set to true, this warehouse will be used as origin location for all trackings without a specified warehouse<br /><b>Caution:</b>Should only be set once per account
     */
    isDefaultWarehouse?: boolean;
    /**
     * If true, bank holidays in region of warehouse will not be counted as working days
     */
    observeHolidays?: boolean;
    specialDays?: Array<SpecialDayRequest>;
};

export type PayloadRewriteInput = {
    payload: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PlaceInfo = {
    readonly id: number;
    /**
     * Address of this place
     */
    locationAddress: AddressSchema;
    /**
     * Geo-location of this place
     */
    location: GeoLocation;
    /**
     * Opening hours of this place
     */
    openingHours: Array<OpeningHourItem>;
    rawPlaceType: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    courier: string;
    /**
     * ISO 3166-1 alpha-3 code of the country
     */
    countryIso3: string;
    /**
     * Type of this place
     *
     * * `default` - Default (first party)
     * * `self_service` - Self-Service / Locker
     * * `partner_location` - Partner Location
     * * `store` - Store
     * * `other` - Other (e.g. hub)
     */
    placeType?: PlaceTypeEnum;
    /**
     * Name of this place
     */
    name: string;
    phoneNumber?: string;
    website?: string;
    /**
     * Search Criteria that this place matches
     */
    criteria?: Array<string>;
    /**
     * Services provided at this place
     */
    services?: Array<ServicesEnum>;
    /**
     * Raw (carrier-provided) services provided at this place
     */
    rawServices?: Array<string>;
    /**
     * Whether this place info includes place details
     */
    hasDetails?: boolean;
    /**
     * Whether this place is in service (open)
     */
    isInService?: boolean;
    /**
     * External (3rd party) reference of this place, e.g. unique location ID
     */
    externalReference: string;
    /**
     * parcelLab generated unique ID for this place
     */
    externalId?: string;
    /**
     * Additional information about this place
     */
    additionalInfo?: {
        [key: string]: unknown;
    };
    account: number;
};

export type PlaceInfoLookupItem = {
    /**
     * Courier code, e.g. 'fedex', 'dhl'
     */
    courier: string;
    /**
     * Service level to filter locations by
     */
    service_level?: string;
    /**
     * Criteria for the lookup, e.g. is delivery location (hold-at)
     */
    criteria?: Array<PlaceSearchFilter>;
    /**
     * Maximum distance to search for locations
     */
    max_distance?: number;
    /**
     * Unit of distance to return
     */
    unit?: UnitEnum;
    /**
     * Maximum number of results to return
     */
    limit?: number;
};

export type PlaceInfoLookupResponseItem = {
    /**
     * Address of this place
     */
    location_address: AddressSchema;
    /**
     * Geo-location of this place
     */
    location: GeoLocation;
    /**
     * Opening hours of this place
     */
    opening_hours: Array<OpeningHourItem>;
    raw_place_type: string;
    /**
     * Distance to the place
     */
    readonly distance: number | null;
    courier: string;
    /**
     * ISO 3166-1 alpha-3 code of the country
     */
    country_iso3: string;
    /**
     * Type of this place
     *
     * * `default` - Default (first party)
     * * `self_service` - Self-Service / Locker
     * * `partner_location` - Partner Location
     * * `store` - Store
     * * `other` - Other (e.g. hub)
     */
    place_type?: PlaceTypeEnum;
    /**
     * Name of this place
     */
    name: string;
    phone_number?: string;
    website?: string;
    /**
     * Search Criteria that this place matches
     */
    criteria?: Array<string>;
    /**
     * Services provided at this place
     */
    services?: Array<ServicesEnum>;
    /**
     * Raw (carrier-provided) services provided at this place
     */
    raw_services?: Array<string>;
    /**
     * Whether this place info includes place details
     */
    has_details?: boolean;
    /**
     * Whether this place is in service (open)
     */
    is_in_service?: boolean;
    /**
     * External (3rd party) reference of this place, e.g. unique location ID
     */
    external_reference: string;
    /**
     * parcelLab generated unique ID for this place
     */
    external_id?: string;
    /**
     * Additional information about this place
     */
    additional_info?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PlaceInfoRequest = {
    /**
     * Address of this place
     */
    locationAddress: AddressSchema;
    /**
     * Geo-location of this place
     */
    location: GeoLocation;
    /**
     * Opening hours of this place
     */
    openingHours: Array<OpeningHourItem>;
    rawPlaceType: string;
    courier: string;
    /**
     * ISO 3166-1 alpha-3 code of the country
     */
    countryIso3: string;
    /**
     * Type of this place
     *
     * * `default` - Default (first party)
     * * `self_service` - Self-Service / Locker
     * * `partner_location` - Partner Location
     * * `store` - Store
     * * `other` - Other (e.g. hub)
     */
    placeType?: PlaceTypeEnum;
    /**
     * Name of this place
     */
    name: string;
    phoneNumber?: string;
    website?: string;
    /**
     * Search Criteria that this place matches
     */
    criteria?: Array<string>;
    /**
     * Services provided at this place
     */
    services?: Array<ServicesEnum>;
    /**
     * Raw (carrier-provided) services provided at this place
     */
    rawServices?: Array<string>;
    /**
     * Whether this place info includes place details
     */
    hasDetails?: boolean;
    /**
     * Whether this place is in service (open)
     */
    isInService?: boolean;
    /**
     * External (3rd party) reference of this place, e.g. unique location ID
     */
    externalReference: string;
    /**
     * parcelLab generated unique ID for this place
     */
    externalId?: string;
    /**
     * Additional information about this place
     */
    additionalInfo?: {
        [key: string]: unknown;
    };
    account: number;
};

export enum PlaceSearchFilter {
    DROPOFF_LOCATION = 'dropoff_location',
    COLLECTION_POINT = 'collection_point'
}

/**
 * * `default` - Default (first party)
 * * `self_service` - Self-Service / Locker
 * * `partner_location` - Partner Location
 * * `store` - Store
 * * `other` - Other (e.g. hub)
 */
export enum PlaceTypeEnum {
    DEFAULT = 'default',
    SELF_SERVICE = 'self_service',
    PARTNER_LOCATION = 'partner_location',
    STORE = 'store',
    OTHER = 'other'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Placeholder = {
    readonly id: number;
    account: number;
    name?: string;
    description?: string;
    category?: PlaceholderCategoryEnum;
};

/**
 * * `layout` - Layout Placeholders
 * * `message` - Message Placeholders
 * * `client` - Client Placeholders
 * * `default` - Default
 */
export enum PlaceholderCategoryEnum {
    LAYOUT = 'layout',
    MESSAGE = 'message',
    CLIENT = 'client',
    DEFAULT = 'default'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type PlaceholderRequest = {
    account: number;
    name?: string;
    description?: string;
    category?: PlaceholderCategoryEnum;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type PlaceholderValue = {
    readonly id: number;
    placeholder: number;
    /**
     * Optional language code (ISO 639), e.g. en, de, etc.
     *
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    language?: LanguagesIso639Enum;
    value?: string;
    /**
     * Select a media file to use as placeholder value.
     */
    media?: number | null;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type PlaceholderValueDetail = {
    readonly id: number;
    placeholder: Placeholder;
    /**
     * Optional language code (ISO 639), e.g. en, de, etc.
     *
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    language?: LanguagesIso639Enum;
    value: string;
    /**
     * Select a media file to use as placeholder value.
     */
    media?: number | null;
};

/**
 * Moves `UniqueValidator`'s from the validation stage to the save stage.
 * It solves the problem with nested validation for unique fields on update.
 *
 * If you want more details, you can read related issues and articles:
 * https://github.com/beda-software/drf-writable-nested/issues/1
 * http://www.django-rest-framework.org/api-guide/validators/#updating-nested-serializers
 *
 * Example of usage:
 * ```
 * class Child(models.Model):
 * field = models.CharField(unique=True)
 *
 *
 * class Parent(models.Model):
 * child = models.ForeignKey('Child')
 *
 *
 * class ChildSerializer(UniqueFieldsMixin, serializers.ModelSerializer):
 * class Meta:
 * model = Child
 *
 *
 * class ParentSerializer(NestedUpdateMixin, serializers.ModelSerializer):
 * child = ChildSerializer()
 *
 * class Meta:
 * model = Parent
 * ```
 *
 * Note: `UniqueFieldsMixin` must be applied only on the serializer
 * which has unique fields.
 *
 * Note: When you are using both mixins
 * (`UniqueFieldsMixin` and `NestedCreateMixin` or `NestedUpdateMixin`)
 * you should put `UniqueFieldsMixin` ahead.
 */
export type PlaceholderValueRequest = {
    placeholder: number;
    /**
     * Optional language code (ISO 639), e.g. en, de, etc.
     *
     * * `aa` - Afar (Aa)
     * * `ab` - Abkhazian (Ab)
     * * `ae` - Avestan (Ae)
     * * `af` - Afrikaans (Af)
     * * `ak` - Akan (Ak)
     * * `am` - Amharic (Am)
     * * `an` - Aragonese (An)
     * * `ar` - Arabic (Ar)
     * * `as` - Assamese (As)
     * * `av` - Avaric (Av)
     * * `ay` - Aymara (Ay)
     * * `az` - Azerbaijani (Az)
     * * `ba` - Bashkir (Ba)
     * * `be` - Belarusian (Be)
     * * `bg` - Bulgarian (Bg)
     * * `bi` - Bislama (Bi)
     * * `bm` - Bambara (Bm)
     * * `bn` - Bengali (Bn)
     * * `bo` - Tibetan (Bo)
     * * `br` - Breton (Br)
     * * `bs` - Bosnian (Bs)
     * * `ca` - Catalan (Ca)
     * * `ce` - Chechen (Ce)
     * * `ch` - Chamorro (Ch)
     * * `co` - Corsican (Co)
     * * `cr` - Cree (Cr)
     * * `cs` - Czech (Cs)
     * * `cu` - Church Slavic (Cu)
     * * `cv` - Chuvash (Cv)
     * * `cy` - Welsh (Cy)
     * * `da` - Danish (Da)
     * * `de` - German (De)
     * * `dv` - Dhivehi (Dv)
     * * `dz` - Dzongkha (Dz)
     * * `ee` - Ewe (Ee)
     * * `el` - Modern Greek (1453-) (El)
     * * `en` - English (En)
     * * `eo` - Esperanto (Eo)
     * * `es` - Spanish (Es)
     * * `et` - Estonian (Et)
     * * `eu` - Basque (Eu)
     * * `fa` - Persian (Fa)
     * * `ff` - Fulah (Ff)
     * * `fi` - Finnish (Fi)
     * * `fj` - Fijian (Fj)
     * * `fo` - Faroese (Fo)
     * * `fr` - French (Fr)
     * * `fy` - Western Frisian (Fy)
     * * `ga` - Irish (Ga)
     * * `gd` - Scottish Gaelic (Gd)
     * * `gl` - Galician (Gl)
     * * `gn` - Guarani (Gn)
     * * `gu` - Gujarati (Gu)
     * * `gv` - Manx (Gv)
     * * `ha` - Hausa (Ha)
     * * `he` - Hebrew (He)
     * * `hi` - Hindi (Hi)
     * * `ho` - Hiri Motu (Ho)
     * * `hr` - Croatian (Hr)
     * * `ht` - Haitian (Ht)
     * * `hu` - Hungarian (Hu)
     * * `hy` - Armenian (Hy)
     * * `hz` - Herero (Hz)
     * * `ia` - Interlingua (International Auxiliary Language Association) (Ia)
     * * `id` - Indonesian (Id)
     * * `ie` - Interlingue (Ie)
     * * `ig` - Igbo (Ig)
     * * `ii` - Sichuan Yi (Ii)
     * * `ik` - Inupiaq (Ik)
     * * `io` - Ido (Io)
     * * `is` - Icelandic (Is)
     * * `it` - Italian (It)
     * * `iu` - Inuktitut (Iu)
     * * `ja` - Japanese (Ja)
     * * `jv` - Javanese (Jv)
     * * `ka` - Georgian (Ka)
     * * `kg` - Kongo (Kg)
     * * `ki` - Kikuyu (Ki)
     * * `kj` - Kuanyama (Kj)
     * * `kk` - Kazakh (Kk)
     * * `kl` - Kalaallisut (Kl)
     * * `km` - Khmer (Km)
     * * `kn` - Kannada (Kn)
     * * `ko` - Korean (Ko)
     * * `kr` - Kanuri (Kr)
     * * `ks` - Kashmiri (Ks)
     * * `ku` - Kurdish (Ku)
     * * `kv` - Komi (Kv)
     * * `kw` - Cornish (Kw)
     * * `ky` - Kirghiz (Ky)
     * * `la` - Latin (La)
     * * `lb` - Luxembourgish (Lb)
     * * `lg` - Ganda (Lg)
     * * `li` - Limburgan (Li)
     * * `ln` - Lingala (Ln)
     * * `lo` - Lao (Lo)
     * * `lt` - Lithuanian (Lt)
     * * `lu` - Luba-Katanga (Lu)
     * * `lv` - Latvian (Lv)
     * * `mg` - Malagasy (Mg)
     * * `mh` - Marshallese (Mh)
     * * `mi` - Maori (Mi)
     * * `mk` - Macedonian (Mk)
     * * `ml` - Malayalam (Ml)
     * * `mn` - Mongolian (Mn)
     * * `mr` - Marathi (Mr)
     * * `ms` - Malay (Macrolanguage) (Ms)
     * * `mt` - Maltese (Mt)
     * * `my` - Burmese (My)
     * * `na` - Nauru (Na)
     * * `nb` - Norwegian Bokmål (Nb)
     * * `nd` - North Ndebele (Nd)
     * * `ne` - Nepali (Macrolanguage) (Ne)
     * * `ng` - Ndonga (Ng)
     * * `nl` - Dutch (Nl)
     * * `nn` - Norwegian Nynorsk (Nn)
     * * `no` - Norwegian (No)
     * * `nr` - South Ndebele (Nr)
     * * `nv` - Navajo (Nv)
     * * `ny` - Nyanja (Ny)
     * * `oc` - Occitan (Post 1500) (Oc)
     * * `oj` - Ojibwa (Oj)
     * * `om` - Oromo (Om)
     * * `or` - Oriya (Macrolanguage) (Or)
     * * `os` - Ossetian (Os)
     * * `pa` - Panjabi (Pa)
     * * `pi` - Pali (Pi)
     * * `pl` - Polish (Pl)
     * * `ps` - Pushto (Ps)
     * * `pt` - Portuguese (Pt)
     * * `qu` - Quechua (Qu)
     * * `rm` - Romansh (Rm)
     * * `rn` - Rundi (Rn)
     * * `ro` - Romanian (Ro)
     * * `ru` - Russian (Ru)
     * * `rw` - Kinyarwanda (Rw)
     * * `sa` - Sanskrit (Sa)
     * * `sc` - Sardinian (Sc)
     * * `sd` - Sindhi (Sd)
     * * `se` - Northern Sami (Se)
     * * `sg` - Sango (Sg)
     * * `sh` - Serbo-Croatian (Sh)
     * * `si` - Sinhala (Si)
     * * `sk` - Slovak (Sk)
     * * `sl` - Slovenian (Sl)
     * * `sm` - Samoan (Sm)
     * * `sn` - Shona (Sn)
     * * `so` - Somali (So)
     * * `sq` - Albanian (Sq)
     * * `sr` - Serbian (Sr)
     * * `ss` - Swati (Ss)
     * * `st` - Southern Sotho (St)
     * * `su` - Sundanese (Su)
     * * `sv` - Swedish (Sv)
     * * `sw` - Swahili (Macrolanguage) (Sw)
     * * `ta` - Tamil (Ta)
     * * `te` - Telugu (Te)
     * * `tg` - Tajik (Tg)
     * * `th` - Thai (Th)
     * * `ti` - Tigrinya (Ti)
     * * `tk` - Turkmen (Tk)
     * * `tl` - Tagalog (Tl)
     * * `tn` - Tswana (Tn)
     * * `to` - Tonga (Tonga Islands) (To)
     * * `tr` - Turkish (Tr)
     * * `ts` - Tsonga (Ts)
     * * `tt` - Tatar (Tt)
     * * `tw` - Twi (Tw)
     * * `ty` - Tahitian (Ty)
     * * `ug` - Uighur (Ug)
     * * `uk` - Ukrainian (Uk)
     * * `ur` - Urdu (Ur)
     * * `uz` - Uzbek (Uz)
     * * `ve` - Venda (Ve)
     * * `vi` - Vietnamese (Vi)
     * * `vo` - Volapük (Vo)
     * * `wa` - Walloon (Wa)
     * * `wo` - Wolof (Wo)
     * * `xh` - Xhosa (Xh)
     * * `yi` - Yiddish (Yi)
     * * `yo` - Yoruba (Yo)
     * * `za` - Zhuang (Za)
     * * `zh` - Chinese (Zh)
     * * `zu` - Zulu (Zu)
     */
    language?: LanguagesIso639Enum;
    value?: string;
    /**
     * Select a media file to use as placeholder value.
     */
    media?: number | null;
};

export type PowerBiEmbedToken = {
    token: string;
    expires_at: string;
};

/**
 * * `customer_service_agent` - Customer Service Agent
 * * `CRM` - CRM
 * * `customer_service` - Customer Service
 * * `customer_experience` - Customer Experience
 * * `digital_marketing_and_ecommerce` - Digital Marketing & eCommerce
 * * `logistics` - Logistics
 * * `operations_and_supply_chain` - Operations & Supply Chain
 * * `product_and_technology` - Product & Technology
 * * `other` - Other
 */
export enum ProfileRoleEnum {
    CUSTOMER_SERVICE_AGENT = 'customer_service_agent',
    CRM = 'CRM',
    CUSTOMER_SERVICE = 'customer_service',
    CUSTOMER_EXPERIENCE = 'customer_experience',
    DIGITAL_MARKETING_AND_ECOMMERCE = 'digital_marketing_and_ecommerce',
    LOGISTICS = 'logistics',
    OPERATIONS_AND_SUPPLY_CHAIN = 'operations_and_supply_chain',
    PRODUCT_AND_TECHNOLOGY = 'product_and_technology',
    OTHER = 'other'
}

export type PromiseCalibrationValue = {
    type?: string;
    value: CalibrationEnum;
};

export type PromiseRule = {
    readonly id: number;
    name: string;
    startDate: string;
    endDate: string;
    filterExpression?: {
        [key: string]: unknown;
    } | null;
    changes: PromiseRuleChangeListSchema;
};

export type PromiseRuleChangeListSchema = Array<PromiseCalibrationValue | WarehouseHandlingTimeValue | HandlingTimeValue | FallbackMinValue | FallbackMaxValue | AlwaysUseFallbackValue>;

export enum PromiseRuleChoices {
    CHANGE = 'change',
    SET = 'set'
}

export type PromiseRuleRequest = {
    name: string;
    startDate: string;
    endDate: string;
    filterExpression?: {
        [key: string]: unknown;
    } | null;
    changes: PromiseRuleChangeListSchema;
};

export type Recipe = {
    readonly id: number;
    readonly uniqueId: string;
    images: Array<RecipeImage>;
    readonly name: string;
    readonly description: string;
    tags: Array<string>;
    items: RecipeItemList;
    category: RecipeCategoryEnum;
    readonly iconImage: string | null;
    readonly isOfficial: boolean;
    readonly color: string;
    readonly author: string;
    readonly prerequisites: string;
    /**
     *
     * A JSON schema defining the configuration for this recipe.
     * The schema includes two main properties: `replacements` and `references`.
     * `replacements` is an object where each key-value pair represents a replacement with string values.
     * `references` is an object where each key-value pair represents a reference with numeric values.
     *
     * Any schema for this field should always include these two fields.
     *
     */
    readonly configSchema: {
        [key: string]: unknown;
    };
    readonly publicDescription: string;
};

export type RecipeApplicationFetch = {
    readonly id: number;
    readonly recipeId: number | null;
    appliedBy?: number | null;
    readonly createdAt: string;
    log: LogEntryList;
};

export type RecipeApplicationPublishResponse = {
    success: boolean;
};

/**
 * * `plproduct` - Product
 * * `engage` - Engage
 * * `retain` - Retain
 */
export enum RecipeCategoryEnum {
    PLPRODUCT = 'plproduct',
    ENGAGE = 'engage',
    RETAIN = 'retain'
}

export type RecipeImage = {
    image: string;
    description?: string;
    altText?: string;
};

export type RecipeItemList = Array<string>;

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Recipient = {
    readonly pk: string;
    hash: string;
    readonly createdAt: string;
    /**
     * Channel for recipient record (e.g. email, sms)
     *
     * * `sms` - SMS
     * * `email` - Email
     */
    channel?: RecipientChannelEnum;
    actionsHistory?: {
        [key: string]: unknown;
    };
    unsubscription?: Array<number>;
    blacklist?: Array<number>;
    bounceBlacklist?: Array<number>;
};

/**
 * * `sms` - SMS
 * * `email` - Email
 */
export enum RecipientChannelEnum {
    SMS = 'sms',
    EMAIL = 'email'
}

export enum ReferenceDateTypeEnum {
    ORDER_DATE = 'order_date',
    SHIPPING_DATE = 'shipping_date',
    DELIVERY_DATE = 'delivery_date'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReferenceItem = {
    readonly id: number;
    readonly account: number;
    key: string;
    name: string;
    type: ReferenceItemTypeEnum;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReferenceItemRequest = {
    key: string;
    name: string;
    type: ReferenceItemTypeEnum;
};

/**
 * * `destination-country-iso3` - Destination Country ISO3
 * * `client` - Client
 * * `courier` - Courier
 * * `warehouse` - Warehouse
 * * `courier-service-level` - Courier Service Level
 * * `delivery-method` - Delivery Method
 * * `delivery-info-market` - Delivery Info Market
 * * `payment-method` - Payment Method
 * * `order-status` - Order Status
 * * `claim-reason` - Claim Reason
 * * `return-reject-reason` - Return Reject Reason
 * * `delivery-timezone` - Timezone (Delivery Info)
 * * `delivery-region` - Region (Destination)
 * * `delivery-location` - Delivery Location
 * * `delivery-status` - Delivery Status
 * * `delivery-exception` - Delivery Exception
 * * `tracking-tags` - Tracking Tags
 */
export enum ReferenceItemTypeEnum {
    DESTINATION_COUNTRY_ISO3 = 'destination-country-iso3',
    CLIENT = 'client',
    COURIER = 'courier',
    WAREHOUSE = 'warehouse',
    COURIER_SERVICE_LEVEL = 'courier-service-level',
    DELIVERY_METHOD = 'delivery-method',
    DELIVERY_INFO_MARKET = 'delivery-info-market',
    PAYMENT_METHOD = 'payment-method',
    ORDER_STATUS = 'order-status',
    CLAIM_REASON = 'claim-reason',
    RETURN_REJECT_REASON = 'return-reject-reason',
    DELIVERY_TIMEZONE = 'delivery-timezone',
    DELIVERY_REGION = 'delivery-region',
    DELIVERY_LOCATION = 'delivery-location',
    DELIVERY_STATUS = 'delivery-status',
    DELIVERY_EXCEPTION = 'delivery-exception',
    TRACKING_TAGS = 'tracking-tags'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type RefundMethod = {
    readonly id: number;
    /**
     * Unique technical code for this refund method, (shopify supports exactly 'original-payment-method', 'store-credit', 'gift-card')
     */
    code: string;
    type: RefundMethodTypeEnum;
    /**
     * Eligibility rules for this refund method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
    /**
     * Will order refund methods, low numbers come first
     */
    logicalOrder?: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type RefundMethodRequest = {
    /**
     * Unique technical code for this refund method, (shopify supports exactly 'original-payment-method', 'store-credit', 'gift-card')
     */
    code: string;
    type: RefundMethodTypeEnum;
    /**
     * Eligibility rules for this refund method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
    /**
     * Will order refund methods, low numbers come first
     */
    logicalOrder?: number;
};

/**
 * * `original-payment-method` - Original
 * * `gift-card` - Gift Card
 * * `store-credit` - Store Credit
 */
export enum RefundMethodTypeEnum {
    ORIGINAL_PAYMENT_METHOD = 'original-payment-method',
    GIFT_CARD = 'gift-card',
    STORE_CREDIT = 'store-credit'
}

/**
 * * `AF-BDS` - AFG-Badakhshān
 * * `AF-BGL` - AFG-Baghlān
 * * `AF-BAL` - AFG-Balkh
 * * `AF-BDG` - AFG-Bādghīs
 * * `AF-BAM` - AFG-Bāmyān
 * * `AF-DAY` - AFG-Dāykundī
 * * `AF-FRA` - AFG-Farāh
 * * `AF-FYB` - AFG-Fāryāb
 * * `AF-GHA` - AFG-Ghaznī
 * * `AF-GHO` - AFG-Ghōr
 * * `AF-HEL` - AFG-Helmand
 * * `AF-HER` - AFG-Herāt
 * * `AF-JOW` - AFG-Jowzjān
 * * `AF-KAN` - AFG-Kandahār
 * * `AF-KHO` - AFG-Khōst
 * * `AF-KNR` - AFG-Kunaṟ
 * * `AF-KDZ` - AFG-Kunduz
 * * `AF-KAB` - AFG-Kābul
 * * `AF-KAP` - AFG-Kāpīsā
 * * `AF-LAG` - AFG-Laghmān
 * * `AF-LOG` - AFG-Lōgar
 * * `AF-NAN` - AFG-Nangarhār
 * * `AF-NIM` - AFG-Nīmrōz
 * * `AF-NUR` - AFG-Nūristān
 * * `AF-PIA` - AFG-Paktiyā
 * * `AF-PKA` - AFG-Paktīkā
 * * `AF-PAN` - AFG-Panjshayr
 * * `AF-PAR` - AFG-Parwān
 * * `AF-SAM` - AFG-Samangān
 * * `AF-SAR` - AFG-Sar-e Pul
 * * `AF-TAK` - AFG-Takhār
 * * `AF-URU` - AFG-Uruzgān
 * * `AF-WAR` - AFG-Wardak
 * * `AF-ZAB` - AFG-Zābul
 * * `AO-BGO` - AGO-Bengo
 * * `AO-BGU` - AGO-Benguela
 * * `AO-BIE` - AGO-Bié
 * * `AO-CAB` - AGO-Cabinda
 * * `AO-CCU` - AGO-Cuando Cubango
 * * `AO-CNO` - AGO-Cuanza-Norte
 * * `AO-CUS` - AGO-Cuanza-Sul
 * * `AO-CNN` - AGO-Cunene
 * * `AO-HUA` - AGO-Huambo
 * * `AO-HUI` - AGO-Huíla
 * * `AO-LUA` - AGO-Luanda
 * * `AO-LNO` - AGO-Lunda-Norte
 * * `AO-LSU` - AGO-Lunda-Sul
 * * `AO-MAL` - AGO-Malange
 * * `AO-MOX` - AGO-Moxico
 * * `AO-NAM` - AGO-Namibe
 * * `AO-UIG` - AGO-Uíge
 * * `AO-ZAI` - AGO-Zaire
 * * `AL-01` - ALB-Berat
 * * `AL-09` - ALB-Dibër
 * * `AL-02` - ALB-Durrës
 * * `AL-03` - ALB-Elbasan
 * * `AL-04` - ALB-Fier
 * * `AL-05` - ALB-Gjirokastër
 * * `AL-06` - ALB-Korçë
 * * `AL-07` - ALB-Kukës
 * * `AL-08` - ALB-Lezhë
 * * `AL-10` - ALB-Shkodër
 * * `AL-11` - ALB-Tiranë
 * * `AL-12` - ALB-Vlorë
 * * `AD-07` - AND-Andorra la Vella
 * * `AD-02` - AND-Canillo
 * * `AD-03` - AND-Encamp
 * * `AD-08` - AND-Escaldes-Engordany
 * * `AD-04` - AND-La Massana
 * * `AD-05` - AND-Ordino
 * * `AD-06` - AND-Sant Julià de Lòria
 * * `AE-AZ` - ARE-Abū Z̧aby
 * * `AE-FU` - ARE-Al Fujayrah
 * * `AE-SH` - ARE-Ash Shāriqah
 * * `AE-DU` - ARE-Dubayy
 * * `AE-RK` - ARE-Ra’s al Khaymah
 * * `AE-UQ` - ARE-Umm al Qaywayn
 * * `AE-AJ` - ARE-‘Ajmān
 * * `AR-B` - ARG-Buenos Aires
 * * `AR-K` - ARG-Catamarca
 * * `AR-H` - ARG-Chaco
 * * `AR-U` - ARG-Chubut
 * * `AR-C` - ARG-Ciudad Autónoma de Buenos Aires
 * * `AR-W` - ARG-Corrientes
 * * `AR-X` - ARG-Córdoba
 * * `AR-E` - ARG-Entre Ríos
 * * `AR-P` - ARG-Formosa
 * * `AR-Y` - ARG-Jujuy
 * * `AR-L` - ARG-La Pampa
 * * `AR-F` - ARG-La Rioja
 * * `AR-M` - ARG-Mendoza
 * * `AR-N` - ARG-Misiones
 * * `AR-Q` - ARG-Neuquén
 * * `AR-R` - ARG-Río Negro
 * * `AR-A` - ARG-Salta
 * * `AR-J` - ARG-San Juan
 * * `AR-D` - ARG-San Luis
 * * `AR-Z` - ARG-Santa Cruz
 * * `AR-S` - ARG-Santa Fe
 * * `AR-G` - ARG-Santiago del Estero
 * * `AR-V` - ARG-Tierra del Fuego
 * * `AR-T` - ARG-Tucumán
 * * `AM-AG` - ARM-Aragac̣otn
 * * `AM-AR` - ARM-Ararat
 * * `AM-AV` - ARM-Armavir
 * * `AM-ER` - ARM-Erevan
 * * `AM-GR` - ARM-Geġark'unik'
 * * `AM-KT` - ARM-Kotayk'
 * * `AM-LO` - ARM-Loṙi
 * * `AM-SU` - ARM-Syunik'
 * * `AM-TV` - ARM-Tavuš
 * * `AM-VD` - ARM-Vayoć Jor
 * * `AM-SH` - ARM-Širak
 * * `AG-10` - ATG-Barbuda
 * * `AG-11` - ATG-Redonda
 * * `AG-03` - ATG-Saint George
 * * `AG-04` - ATG-Saint John
 * * `AG-05` - ATG-Saint Mary
 * * `AG-06` - ATG-Saint Paul
 * * `AG-07` - ATG-Saint Peter
 * * `AG-08` - ATG-Saint Philip
 * * `AU-ACT` - AUS-Australian Capital Territory
 * * `AU-NSW` - AUS-New South Wales
 * * `AU-NT` - AUS-Northern Territory
 * * `AU-QLD` - AUS-Queensland
 * * `AU-SA` - AUS-South Australia
 * * `AU-TAS` - AUS-Tasmania
 * * `AU-VIC` - AUS-Victoria
 * * `AU-WA` - AUS-Western Australia
 * * `AT-1` - AUT-Burgenland
 * * `AT-2` - AUT-Kärnten
 * * `AT-3` - AUT-Niederösterreich
 * * `AT-4` - AUT-Oberösterreich
 * * `AT-5` - AUT-Salzburg
 * * `AT-6` - AUT-Steiermark
 * * `AT-7` - AUT-Tirol
 * * `AT-8` - AUT-Vorarlberg
 * * `AT-9` - AUT-Wien
 * * `AZ-ABS` - AZE-Abşeron
 * * `AZ-AST` - AZE-Astara
 * * `AZ-AGC` - AZE-Ağcabədi
 * * `AZ-AGM` - AZE-Ağdam
 * * `AZ-AGS` - AZE-Ağdaş
 * * `AZ-AGA` - AZE-Ağstafa
 * * `AZ-AGU` - AZE-Ağsu
 * * `AZ-BAB` - AZE-Babək
 * * `AZ-BA` - AZE-Bakı
 * * `AZ-BAL` - AZE-Balakən
 * * `AZ-BEY` - AZE-Beyləqan
 * * `AZ-BIL` - AZE-Biləsuvar
 * * `AZ-BAR` - AZE-Bərdə
 * * `AZ-CUL` - AZE-Culfa
 * * `AZ-CAB` - AZE-Cəbrayıl
 * * `AZ-CAL` - AZE-Cəlilabad
 * * `AZ-DAS` - AZE-Daşkəsən
 * * `AZ-FUZ` - AZE-Füzuli
 * * `AZ-GOR` - AZE-Goranboy
 * * `AZ-GYG` - AZE-Göygöl
 * * `AZ-GOY` - AZE-Göyçay
 * * `AZ-GAD` - AZE-Gədəbəy
 * * `AZ-GA` - AZE-Gəncə
 * * `AZ-HAC` - AZE-Hacıqabul
 * * `AZ-KUR` - AZE-Kürdəmir
 * * `AZ-KAN` - AZE-Kǝngǝrli
 * * `AZ-KAL` - AZE-Kəlbəcər
 * * `AZ-LAC` - AZE-Laçın
 * * `AZ-LER` - AZE-Lerik
 * * `AZ-LA` - AZE-Lənkəran
 * * `AZ-LAN` - AZE-Lənkəran
 * * `AZ-MAS` - AZE-Masallı
 * * `AZ-MI` - AZE-Mingəçevir
 * * `AZ-NA` - AZE-Naftalan
 * * `AZ-NV` - AZE-Naxçıvan
 * * `AZ-NX` - AZE-Naxçıvan
 * * `AZ-NEF` - AZE-Neftçala
 * * `AZ-ORD` - AZE-Ordubad
 * * `AZ-OGU` - AZE-Oğuz
 * * `AZ-QAX` - AZE-Qax
 * * `AZ-QAZ` - AZE-Qazax
 * * `AZ-QOB` - AZE-Qobustan
 * * `AZ-QBA` - AZE-Quba
 * * `AZ-QBI` - AZE-Qubadlı
 * * `AZ-QUS` - AZE-Qusar
 * * `AZ-QAB` - AZE-Qəbələ
 * * `AZ-SAT` - AZE-Saatlı
 * * `AZ-SAB` - AZE-Sabirabad
 * * `AZ-SAL` - AZE-Salyan
 * * `AZ-SMX` - AZE-Samux
 * * `AZ-SIY` - AZE-Siyəzən
 * * `AZ-SM` - AZE-Sumqayıt
 * * `AZ-SAD` - AZE-Sədərək
 * * `AZ-TOV` - AZE-Tovuz
 * * `AZ-TAR` - AZE-Tərtər
 * * `AZ-UCA` - AZE-Ucar
 * * `AZ-XA` - AZE-Xankəndi
 * * `AZ-XAC` - AZE-Xaçmaz
 * * `AZ-XCI` - AZE-Xocalı
 * * `AZ-XVD` - AZE-Xocavənd
 * * `AZ-XIZ` - AZE-Xızı
 * * `AZ-YAR` - AZE-Yardımlı
 * * `AZ-YE` - AZE-Yevlax
 * * `AZ-YEV` - AZE-Yevlax
 * * `AZ-ZAQ` - AZE-Zaqatala
 * * `AZ-ZAN` - AZE-Zəngilan
 * * `AZ-ZAR` - AZE-Zərdab
 * * `AZ-IMI` - AZE-İmişli
 * * `AZ-ISM` - AZE-İsmayıllı
 * * `AZ-SBN` - AZE-Şabran
 * * `AZ-SAH` - AZE-Şahbuz
 * * `AZ-SMI` - AZE-Şamaxı
 * * `AZ-SR` - AZE-Şirvan
 * * `AZ-SUS` - AZE-Şuşa
 * * `AZ-SA` - AZE-Şəki
 * * `AZ-SAK` - AZE-Şəki
 * * `AZ-SKR` - AZE-Şəmkir
 * * `AZ-SAR` - AZE-Şərur
 * * `BI-BB` - BDI-Bubanza
 * * `BI-BM` - BDI-Bujumbura Mairie
 * * `BI-BL` - BDI-Bujumbura Rural
 * * `BI-BR` - BDI-Bururi
 * * `BI-CA` - BDI-Cankuzo
 * * `BI-CI` - BDI-Cibitoke
 * * `BI-GI` - BDI-Gitega
 * * `BI-KR` - BDI-Karuzi
 * * `BI-KY` - BDI-Kayanza
 * * `BI-KI` - BDI-Kirundo
 * * `BI-MA` - BDI-Makamba
 * * `BI-MU` - BDI-Muramvya
 * * `BI-MY` - BDI-Muyinga
 * * `BI-MW` - BDI-Mwaro
 * * `BI-NG` - BDI-Ngozi
 * * `BI-RM` - BDI-Rumonge
 * * `BI-RT` - BDI-Rutana
 * * `BI-RY` - BDI-Ruyigi
 * * `BE-VAN` - BEL-Antwerpen
 * * `BE-WBR` - BEL-Brabant wallon
 * * `BE-BRU` - BEL-Bruxelles-Capitale, Région de
 * * `BE-WHT` - BEL-Hainaut
 * * `BE-VLI` - BEL-Limburg
 * * `BE-WLG` - BEL-Liège
 * * `BE-WLX` - BEL-Luxembourg
 * * `BE-WNA` - BEL-Namur
 * * `BE-VOV` - BEL-Oost-Vlaanderen
 * * `BE-VLG` - BEL-Vlaams Gewest
 * * `BE-VBR` - BEL-Vlaams-Brabant
 * * `BE-VWV` - BEL-West-Vlaanderen
 * * `BE-WAL` - BEL-wallonne, Région
 * * `BJ-AL` - BEN-Alibori
 * * `BJ-AK` - BEN-Atacora
 * * `BJ-AQ` - BEN-Atlantique
 * * `BJ-BO` - BEN-Borgou
 * * `BJ-CO` - BEN-Collines
 * * `BJ-KO` - BEN-Couffo
 * * `BJ-DO` - BEN-Donga
 * * `BJ-LI` - BEN-Littoral
 * * `BJ-MO` - BEN-Mono
 * * `BJ-OU` - BEN-Ouémé
 * * `BJ-PL` - BEN-Plateau
 * * `BJ-ZO` - BEN-Zou
 * * `BQ-BO` - BES-Bonaire
 * * `BQ-SA` - BES-Saba
 * * `BQ-SE` - BES-Sint Eustatius
 * * `BF-BAL` - BFA-Balé
 * * `BF-BAM` - BFA-Bam
 * * `BF-BAN` - BFA-Banwa
 * * `BF-BAZ` - BFA-Bazèga
 * * `BF-01` - BFA-Boucle du Mouhoun
 * * `BF-BGR` - BFA-Bougouriba
 * * `BF-BLG` - BFA-Boulgou
 * * `BF-BLK` - BFA-Boulkiemdé
 * * `BF-02` - BFA-Cascades
 * * `BF-03` - BFA-Centre
 * * `BF-04` - BFA-Centre-Est
 * * `BF-05` - BFA-Centre-Nord
 * * `BF-06` - BFA-Centre-Ouest
 * * `BF-07` - BFA-Centre-Sud
 * * `BF-COM` - BFA-Comoé
 * * `BF-08` - BFA-Est
 * * `BF-GAN` - BFA-Ganzourgou
 * * `BF-GNA` - BFA-Gnagna
 * * `BF-GOU` - BFA-Gourma
 * * `BF-09` - BFA-Hauts-Bassins
 * * `BF-HOU` - BFA-Houet
 * * `BF-IOB` - BFA-Ioba
 * * `BF-KAD` - BFA-Kadiogo
 * * `BF-KMD` - BFA-Komondjari
 * * `BF-KMP` - BFA-Kompienga
 * * `BF-KOS` - BFA-Kossi
 * * `BF-KOP` - BFA-Koulpélogo
 * * `BF-KOT` - BFA-Kouritenga
 * * `BF-KOW` - BFA-Kourwéogo
 * * `BF-KEN` - BFA-Kénédougou
 * * `BF-LOR` - BFA-Loroum
 * * `BF-LER` - BFA-Léraba
 * * `BF-MOU` - BFA-Mouhoun
 * * `BF-NAO` - BFA-Nahouri
 * * `BF-NAM` - BFA-Namentenga
 * * `BF-NAY` - BFA-Nayala
 * * `BF-10` - BFA-Nord
 * * `BF-NOU` - BFA-Noumbiel
 * * `BF-OUB` - BFA-Oubritenga
 * * `BF-OUD` - BFA-Oudalan
 * * `BF-PAS` - BFA-Passoré
 * * `BF-11` - BFA-Plateau-Central
 * * `BF-PON` - BFA-Poni
 * * `BF-12` - BFA-Sahel
 * * `BF-SNG` - BFA-Sanguié
 * * `BF-SMT` - BFA-Sanmatenga
 * * `BF-SIS` - BFA-Sissili
 * * `BF-SOM` - BFA-Soum
 * * `BF-SOR` - BFA-Sourou
 * * `BF-13` - BFA-Sud-Ouest
 * * `BF-SEN` - BFA-Séno
 * * `BF-TAP` - BFA-Tapoa
 * * `BF-TUI` - BFA-Tuy
 * * `BF-YAG` - BFA-Yagha
 * * `BF-YAT` - BFA-Yatenga
 * * `BF-ZIR` - BFA-Ziro
 * * `BF-ZON` - BFA-Zondoma
 * * `BF-ZOU` - BFA-Zoundwéogo
 * * `BD-05` - BGD-Bagerhat
 * * `BD-01` - BGD-Bandarban
 * * `BD-02` - BGD-Barguna
 * * `BD-06` - BGD-Barishal
 * * `BD-A` - BGD-Barishal
 * * `BD-07` - BGD-Bhola
 * * `BD-03` - BGD-Bogura
 * * `BD-04` - BGD-Brahmanbaria
 * * `BD-09` - BGD-Chandpur
 * * `BD-45` - BGD-Chapai Nawabganj
 * * `BD-10` - BGD-Chattogram
 * * `BD-B` - BGD-Chattogram
 * * `BD-12` - BGD-Chuadanga
 * * `BD-11` - BGD-Cox's Bazar
 * * `BD-08` - BGD-Cumilla
 * * `BD-13` - BGD-Dhaka
 * * `BD-C` - BGD-Dhaka
 * * `BD-14` - BGD-Dinajpur
 * * `BD-15` - BGD-Faridpur
 * * `BD-16` - BGD-Feni
 * * `BD-19` - BGD-Gaibandha
 * * `BD-18` - BGD-Gazipur
 * * `BD-17` - BGD-Gopalganj
 * * `BD-20` - BGD-Habiganj
 * * `BD-21` - BGD-Jamalpur
 * * `BD-22` - BGD-Jashore
 * * `BD-25` - BGD-Jhalakathi
 * * `BD-23` - BGD-Jhenaidah
 * * `BD-24` - BGD-Joypurhat
 * * `BD-29` - BGD-Khagrachhari
 * * `BD-27` - BGD-Khulna
 * * `BD-D` - BGD-Khulna
 * * `BD-26` - BGD-Kishoreganj
 * * `BD-28` - BGD-Kurigram
 * * `BD-30` - BGD-Kushtia
 * * `BD-31` - BGD-Lakshmipur
 * * `BD-32` - BGD-Lalmonirhat
 * * `BD-36` - BGD-Madaripur
 * * `BD-37` - BGD-Magura
 * * `BD-33` - BGD-Manikganj
 * * `BD-39` - BGD-Meherpur
 * * `BD-38` - BGD-Moulvibazar
 * * `BD-35` - BGD-Munshiganj
 * * `BD-34` - BGD-Mymensingh
 * * `BD-H` - BGD-Mymensingh
 * * `BD-48` - BGD-Naogaon
 * * `BD-43` - BGD-Narail
 * * `BD-40` - BGD-Narayanganj
 * * `BD-42` - BGD-Narsingdi
 * * `BD-44` - BGD-Natore
 * * `BD-41` - BGD-Netrakona
 * * `BD-46` - BGD-Nilphamari
 * * `BD-47` - BGD-Noakhali
 * * `BD-49` - BGD-Pabna
 * * `BD-52` - BGD-Panchagarh
 * * `BD-51` - BGD-Patuakhali
 * * `BD-50` - BGD-Pirojpur
 * * `BD-53` - BGD-Rajbari
 * * `BD-54` - BGD-Rajshahi
 * * `BD-E` - BGD-Rajshahi
 * * `BD-56` - BGD-Rangamati
 * * `BD-55` - BGD-Rangpur
 * * `BD-F` - BGD-Rangpur
 * * `BD-58` - BGD-Satkhira
 * * `BD-62` - BGD-Shariatpur
 * * `BD-57` - BGD-Sherpur
 * * `BD-59` - BGD-Sirajganj
 * * `BD-61` - BGD-Sunamganj
 * * `BD-60` - BGD-Sylhet
 * * `BD-G` - BGD-Sylhet
 * * `BD-63` - BGD-Tangail
 * * `BD-64` - BGD-Thakurgaon
 * * `BG-01` - BGR-Blagoevgrad
 * * `BG-02` - BGR-Burgas
 * * `BG-08` - BGR-Dobrich
 * * `BG-07` - BGR-Gabrovo
 * * `BG-26` - BGR-Haskovo
 * * `BG-09` - BGR-Kardzhali
 * * `BG-10` - BGR-Kyustendil
 * * `BG-11` - BGR-Lovech
 * * `BG-12` - BGR-Montana
 * * `BG-13` - BGR-Pazardzhik
 * * `BG-14` - BGR-Pernik
 * * `BG-15` - BGR-Pleven
 * * `BG-16` - BGR-Plovdiv
 * * `BG-17` - BGR-Razgrad
 * * `BG-18` - BGR-Ruse
 * * `BG-27` - BGR-Shumen
 * * `BG-19` - BGR-Silistra
 * * `BG-20` - BGR-Sliven
 * * `BG-21` - BGR-Smolyan
 * * `BG-23` - BGR-Sofia
 * * `BG-22` - BGR-Sofia (stolitsa)
 * * `BG-24` - BGR-Stara Zagora
 * * `BG-25` - BGR-Targovishte
 * * `BG-03` - BGR-Varna
 * * `BG-04` - BGR-Veliko Tarnovo
 * * `BG-05` - BGR-Vidin
 * * `BG-06` - BGR-Vratsa
 * * `BG-28` - BGR-Yambol
 * * `BH-14` - BHR-Al Janūbīyah
 * * `BH-15` - BHR-Al Muḩarraq
 * * `BH-13` - BHR-Al ‘Āşimah
 * * `BH-17` - BHR-Ash Shamālīyah
 * * `BS-AK` - BHS-Acklins
 * * `BS-BY` - BHS-Berry Islands
 * * `BS-BI` - BHS-Bimini
 * * `BS-BP` - BHS-Black Point
 * * `BS-CI` - BHS-Cat Island
 * * `BS-CO` - BHS-Central Abaco
 * * `BS-CS` - BHS-Central Andros
 * * `BS-CE` - BHS-Central Eleuthera
 * * `BS-FP` - BHS-City of Freeport
 * * `BS-CK` - BHS-Crooked Island and Long Cay
 * * `BS-EG` - BHS-East Grand Bahama
 * * `BS-EX` - BHS-Exuma
 * * `BS-GC` - BHS-Grand Cay
 * * `BS-HI` - BHS-Harbour Island
 * * `BS-HT` - BHS-Hope Town
 * * `BS-IN` - BHS-Inagua
 * * `BS-LI` - BHS-Long Island
 * * `BS-MC` - BHS-Mangrove Cay
 * * `BS-MG` - BHS-Mayaguana
 * * `BS-MI` - BHS-Moore's Island
 * * `BS-NP` - BHS-New Providence
 * * `BS-NO` - BHS-North Abaco
 * * `BS-NS` - BHS-North Andros
 * * `BS-NE` - BHS-North Eleuthera
 * * `BS-RI` - BHS-Ragged Island
 * * `BS-RC` - BHS-Rum Cay
 * * `BS-SS` - BHS-San Salvador
 * * `BS-SO` - BHS-South Abaco
 * * `BS-SA` - BHS-South Andros
 * * `BS-SE` - BHS-South Eleuthera
 * * `BS-SW` - BHS-Spanish Wells
 * * `BS-WG` - BHS-West Grand Bahama
 * * `BA-BRC` - BIH-Brčko distrikt
 * * `BA-BIH` - BIH-Federacija Bosne i Hercegovine
 * * `BA-SRP` - BIH-Republika Srpska
 * * `BY-BR` - BLR-Bresckaja voblasć
 * * `BY-HO` - BLR-Gomel'skaja oblast'
 * * `BY-HM` - BLR-Gorod Minsk
 * * `BY-HR` - BLR-Grodnenskaja oblast'
 * * `BY-MA` - BLR-Mahilioŭskaja voblasć
 * * `BY-MI` - BLR-Minskaja oblast'
 * * `BY-VI` - BLR-Viciebskaja voblasć
 * * `BZ-BZ` - BLZ-Belize
 * * `BZ-CY` - BLZ-Cayo
 * * `BZ-CZL` - BLZ-Corozal
 * * `BZ-OW` - BLZ-Orange Walk
 * * `BZ-SC` - BLZ-Stann Creek
 * * `BZ-TOL` - BLZ-Toledo
 * * `BO-H` - BOL-Chuquisaca
 * * `BO-C` - BOL-Cochabamba
 * * `BO-B` - BOL-El Beni
 * * `BO-L` - BOL-La Paz
 * * `BO-O` - BOL-Oruro
 * * `BO-N` - BOL-Pando
 * * `BO-P` - BOL-Potosí
 * * `BO-S` - BOL-Santa Cruz
 * * `BO-T` - BOL-Tarija
 * * `BR-AC` - BRA-Acre
 * * `BR-AL` - BRA-Alagoas
 * * `BR-AP` - BRA-Amapá
 * * `BR-AM` - BRA-Amazonas
 * * `BR-BA` - BRA-Bahia
 * * `BR-CE` - BRA-Ceará
 * * `BR-DF` - BRA-Distrito Federal
 * * `BR-ES` - BRA-Espírito Santo
 * * `BR-GO` - BRA-Goiás
 * * `BR-MA` - BRA-Maranhão
 * * `BR-MT` - BRA-Mato Grosso
 * * `BR-MS` - BRA-Mato Grosso do Sul
 * * `BR-MG` - BRA-Minas Gerais
 * * `BR-PR` - BRA-Paraná
 * * `BR-PB` - BRA-Paraíba
 * * `BR-PA` - BRA-Pará
 * * `BR-PE` - BRA-Pernambuco
 * * `BR-PI` - BRA-Piauí
 * * `BR-RN` - BRA-Rio Grande do Norte
 * * `BR-RS` - BRA-Rio Grande do Sul
 * * `BR-RJ` - BRA-Rio de Janeiro
 * * `BR-RO` - BRA-Rondônia
 * * `BR-RR` - BRA-Roraima
 * * `BR-SC` - BRA-Santa Catarina
 * * `BR-SE` - BRA-Sergipe
 * * `BR-SP` - BRA-São Paulo
 * * `BR-TO` - BRA-Tocantins
 * * `BB-01` - BRB-Christ Church
 * * `BB-02` - BRB-Saint Andrew
 * * `BB-03` - BRB-Saint George
 * * `BB-04` - BRB-Saint James
 * * `BB-05` - BRB-Saint John
 * * `BB-06` - BRB-Saint Joseph
 * * `BB-07` - BRB-Saint Lucy
 * * `BB-08` - BRB-Saint Michael
 * * `BB-09` - BRB-Saint Peter
 * * `BB-10` - BRB-Saint Philip
 * * `BB-11` - BRB-Saint Thomas
 * * `BN-BE` - BRN-Belait
 * * `BN-BM` - BRN-Brunei-Muara
 * * `BN-TE` - BRN-Temburong
 * * `BN-TU` - BRN-Tutong
 * * `BT-33` - BTN-Bumthang
 * * `BT-12` - BTN-Chhukha
 * * `BT-22` - BTN-Dagana
 * * `BT-GA` - BTN-Gasa
 * * `BT-13` - BTN-Haa
 * * `BT-44` - BTN-Lhuentse
 * * `BT-42` - BTN-Monggar
 * * `BT-11` - BTN-Paro
 * * `BT-43` - BTN-Pema Gatshel
 * * `BT-23` - BTN-Punakha
 * * `BT-45` - BTN-Samdrup Jongkhar
 * * `BT-14` - BTN-Samtse
 * * `BT-31` - BTN-Sarpang
 * * `BT-15` - BTN-Thimphu
 * * `BT-TY` - BTN-Trashi Yangtse
 * * `BT-41` - BTN-Trashigang
 * * `BT-32` - BTN-Trongsa
 * * `BT-21` - BTN-Tsirang
 * * `BT-24` - BTN-Wangdue Phodrang
 * * `BT-34` - BTN-Zhemgang
 * * `BW-CE` - BWA-Central
 * * `BW-CH` - BWA-Chobe
 * * `BW-FR` - BWA-Francistown
 * * `BW-GA` - BWA-Gaborone
 * * `BW-GH` - BWA-Ghanzi
 * * `BW-JW` - BWA-Jwaneng
 * * `BW-KG` - BWA-Kgalagadi
 * * `BW-KL` - BWA-Kgatleng
 * * `BW-KW` - BWA-Kweneng
 * * `BW-LO` - BWA-Lobatse
 * * `BW-NE` - BWA-North East
 * * `BW-NW` - BWA-North West
 * * `BW-SP` - BWA-Selibe Phikwe
 * * `BW-SE` - BWA-South East
 * * `BW-SO` - BWA-Southern
 * * `BW-ST` - BWA-Sowa Town
 * * `CF-BB` - CAF-Bamingui-Bangoran
 * * `CF-BGF` - CAF-Bangui
 * * `CF-BK` - CAF-Basse-Kotto
 * * `CF-KB` - CAF-Gribingui
 * * `CF-HM` - CAF-Haut-Mbomou
 * * `CF-HK` - CAF-Haute-Kotto
 * * `CF-HS` - CAF-Haute-Sangha / Mambéré-Kadéï
 * * `CF-KG` - CAF-Kémo-Gribingui
 * * `CF-LB` - CAF-Lobaye
 * * `CF-MB` - CAF-Mbomou
 * * `CF-NM` - CAF-Nana-Mambéré
 * * `CF-MP` - CAF-Ombella-Mpoko
 * * `CF-UK` - CAF-Ouaka
 * * `CF-AC` - CAF-Ouham
 * * `CF-OP` - CAF-Ouham-Pendé
 * * `CF-SE` - CAF-Sangha
 * * `CF-VK` - CAF-Vakaga
 * * `CA-AB` - CAN-Alberta
 * * `CA-BC` - CAN-British Columbia
 * * `CA-MB` - CAN-Manitoba
 * * `CA-NB` - CAN-New Brunswick
 * * `CA-NL` - CAN-Newfoundland and Labrador
 * * `CA-NT` - CAN-Northwest Territories
 * * `CA-NS` - CAN-Nova Scotia
 * * `CA-NU` - CAN-Nunavut
 * * `CA-ON` - CAN-Ontario
 * * `CA-PE` - CAN-Prince Edward Island
 * * `CA-QC` - CAN-Quebec
 * * `CA-SK` - CAN-Saskatchewan
 * * `CA-YT` - CAN-Yukon
 * * `CH-AG` - CHE-Aargau
 * * `CH-AR` - CHE-Appenzell Ausserrhoden
 * * `CH-AI` - CHE-Appenzell Innerrhoden
 * * `CH-BL` - CHE-Basel-Landschaft
 * * `CH-BS` - CHE-Basel-Stadt
 * * `CH-BE` - CHE-Berne
 * * `CH-FR` - CHE-Fribourg
 * * `CH-GE` - CHE-Genève
 * * `CH-GL` - CHE-Glarus
 * * `CH-GR` - CHE-Graubünden
 * * `CH-JU` - CHE-Jura
 * * `CH-LU` - CHE-Luzern
 * * `CH-NE` - CHE-Neuchâtel
 * * `CH-NW` - CHE-Nidwalden
 * * `CH-OW` - CHE-Obwalden
 * * `CH-SG` - CHE-Sankt Gallen
 * * `CH-SH` - CHE-Schaffhausen
 * * `CH-SZ` - CHE-Schwyz
 * * `CH-SO` - CHE-Solothurn
 * * `CH-TG` - CHE-Thurgau
 * * `CH-TI` - CHE-Ticino
 * * `CH-UR` - CHE-Uri
 * * `CH-VS` - CHE-Valais
 * * `CH-VD` - CHE-Vaud
 * * `CH-ZG` - CHE-Zug
 * * `CH-ZH` - CHE-Zürich
 * * `CL-AI` - CHL-Aisén del General Carlos Ibañez del Campo
 * * `CL-AN` - CHL-Antofagasta
 * * `CL-AP` - CHL-Arica y Parinacota
 * * `CL-AT` - CHL-Atacama
 * * `CL-BI` - CHL-Biobío
 * * `CL-CO` - CHL-Coquimbo
 * * `CL-AR` - CHL-La Araucanía
 * * `CL-LI` - CHL-Libertador General Bernardo O'Higgins
 * * `CL-LL` - CHL-Los Lagos
 * * `CL-LR` - CHL-Los Ríos
 * * `CL-MA` - CHL-Magallanes
 * * `CL-ML` - CHL-Maule
 * * `CL-RM` - CHL-Región Metropolitana de Santiago
 * * `CL-TA` - CHL-Tarapacá
 * * `CL-VS` - CHL-Valparaíso
 * * `CL-NB` - CHL-Ñuble
 * * `CN-AH` - CHN-Anhui Sheng
 * * `CN-BJ` - CHN-Beijing Shi
 * * `CN-CQ` - CHN-Chongqing Shi
 * * `CN-FJ` - CHN-Fujian Sheng
 * * `CN-GS` - CHN-Gansu Sheng
 * * `CN-GD` - CHN-Guangdong Sheng
 * * `CN-GX` - CHN-Guangxi Zhuangzu Zizhiqu
 * * `CN-GZ` - CHN-Guizhou Sheng
 * * `CN-HI` - CHN-Hainan Sheng
 * * `CN-HE` - CHN-Hebei Sheng
 * * `CN-HL` - CHN-Heilongjiang Sheng
 * * `CN-HA` - CHN-Henan Sheng
 * * `CN-HK` - CHN-Hong Kong SAR
 * * `CN-HB` - CHN-Hubei Sheng
 * * `CN-HN` - CHN-Hunan Sheng
 * * `CN-JS` - CHN-Jiangsu Sheng
 * * `CN-JX` - CHN-Jiangxi Sheng
 * * `CN-JL` - CHN-Jilin Sheng
 * * `CN-LN` - CHN-Liaoning Sheng
 * * `CN-MO` - CHN-Macao SAR
 * * `CN-NM` - CHN-Nei Mongol Zizhiqu
 * * `CN-NX` - CHN-Ningxia Huizu Zizhiqu
 * * `CN-QH` - CHN-Qinghai Sheng
 * * `CN-SN` - CHN-Shaanxi Sheng
 * * `CN-SD` - CHN-Shandong Sheng
 * * `CN-SH` - CHN-Shanghai Shi
 * * `CN-SX` - CHN-Shanxi Sheng
 * * `CN-SC` - CHN-Sichuan Sheng
 * * `CN-TW` - CHN-Taiwan Sheng
 * * `CN-TJ` - CHN-Tianjin Shi
 * * `CN-XJ` - CHN-Xinjiang Uygur Zizhiqu
 * * `CN-XZ` - CHN-Xizang Zizhiqu
 * * `CN-YN` - CHN-Yunnan Sheng
 * * `CN-ZJ` - CHN-Zhejiang Sheng
 * * `CI-AB` - CIV-Abidjan
 * * `CI-BS` - CIV-Bas-Sassandra
 * * `CI-CM` - CIV-Comoé
 * * `CI-DN` - CIV-Denguélé
 * * `CI-GD` - CIV-Gôh-Djiboua
 * * `CI-LC` - CIV-Lacs
 * * `CI-LG` - CIV-Lagunes
 * * `CI-MG` - CIV-Montagnes
 * * `CI-SM` - CIV-Sassandra-Marahoué
 * * `CI-SV` - CIV-Savanes
 * * `CI-VB` - CIV-Vallée du Bandama
 * * `CI-WR` - CIV-Woroba
 * * `CI-YM` - CIV-Yamoussoukro
 * * `CI-ZZ` - CIV-Zanzan
 * * `CM-AD` - CMR-Adamaoua
 * * `CM-CE` - CMR-Centre
 * * `CM-ES` - CMR-East
 * * `CM-EN` - CMR-Far North
 * * `CM-LT` - CMR-Littoral
 * * `CM-NO` - CMR-North
 * * `CM-NW` - CMR-North-West
 * * `CM-SU` - CMR-South
 * * `CM-SW` - CMR-South-West
 * * `CM-OU` - CMR-West
 * * `CD-BU` - COD-Bas-Uélé
 * * `CD-HK` - COD-Haut-Katanga
 * * `CD-HL` - COD-Haut-Lomami
 * * `CD-HU` - COD-Haut-Uélé
 * * `CD-IT` - COD-Ituri
 * * `CD-KS` - COD-Kasaï
 * * `CD-KC` - COD-Kasaï Central
 * * `CD-KE` - COD-Kasaï Oriental
 * * `CD-KN` - COD-Kinshasa
 * * `CD-BC` - COD-Kongo Central
 * * `CD-KG` - COD-Kwango
 * * `CD-KL` - COD-Kwilu
 * * `CD-LO` - COD-Lomami
 * * `CD-LU` - COD-Lualaba
 * * `CD-MN` - COD-Mai-Ndombe
 * * `CD-MA` - COD-Maniema
 * * `CD-MO` - COD-Mongala
 * * `CD-NK` - COD-Nord-Kivu
 * * `CD-NU` - COD-Nord-Ubangi
 * * `CD-SA` - COD-Sankuru
 * * `CD-SK` - COD-Sud-Kivu
 * * `CD-SU` - COD-Sud-Ubangi
 * * `CD-TA` - COD-Tanganyika
 * * `CD-TO` - COD-Tshopo
 * * `CD-TU` - COD-Tshuapa
 * * `CD-EQ` - COD-Équateur
 * * `CG-11` - COG-Bouenza
 * * `CG-BZV` - COG-Brazzaville
 * * `CG-8` - COG-Cuvette
 * * `CG-15` - COG-Cuvette-Ouest
 * * `CG-5` - COG-Kouilou
 * * `CG-7` - COG-Likouala
 * * `CG-2` - COG-Lékoumou
 * * `CG-9` - COG-Niari
 * * `CG-14` - COG-Plateaux
 * * `CG-16` - COG-Pointe-Noire
 * * `CG-12` - COG-Pool
 * * `CG-13` - COG-Sangha
 * * `CO-AMA` - COL-Amazonas
 * * `CO-ANT` - COL-Antioquia
 * * `CO-ARA` - COL-Arauca
 * * `CO-ATL` - COL-Atlántico
 * * `CO-BOL` - COL-Bolívar
 * * `CO-BOY` - COL-Boyacá
 * * `CO-CAL` - COL-Caldas
 * * `CO-CAQ` - COL-Caquetá
 * * `CO-CAS` - COL-Casanare
 * * `CO-CAU` - COL-Cauca
 * * `CO-CES` - COL-Cesar
 * * `CO-CHO` - COL-Chocó
 * * `CO-CUN` - COL-Cundinamarca
 * * `CO-COR` - COL-Córdoba
 * * `CO-DC` - COL-Distrito Capital de Bogotá
 * * `CO-GUA` - COL-Guainía
 * * `CO-GUV` - COL-Guaviare
 * * `CO-HUI` - COL-Huila
 * * `CO-LAG` - COL-La Guajira
 * * `CO-MAG` - COL-Magdalena
 * * `CO-MET` - COL-Meta
 * * `CO-NAR` - COL-Nariño
 * * `CO-NSA` - COL-Norte de Santander
 * * `CO-PUT` - COL-Putumayo
 * * `CO-QUI` - COL-Quindío
 * * `CO-RIS` - COL-Risaralda
 * * `CO-SAP` - COL-San Andrés, Providencia y Santa Catalina
 * * `CO-SAN` - COL-Santander
 * * `CO-SUC` - COL-Sucre
 * * `CO-TOL` - COL-Tolima
 * * `CO-VAC` - COL-Valle del Cauca
 * * `CO-VAU` - COL-Vaupés
 * * `CO-VID` - COL-Vichada
 * * `KM-A` - COM-Anjouan
 * * `KM-G` - COM-Grande Comore
 * * `KM-M` - COM-Mohéli
 * * `CV-BV` - CPV-Boa Vista
 * * `CV-BR` - CPV-Brava
 * * `CV-B` - CPV-Ilhas de Barlavento
 * * `CV-S` - CPV-Ilhas de Sotavento
 * * `CV-MA` - CPV-Maio
 * * `CV-MO` - CPV-Mosteiros
 * * `CV-PA` - CPV-Paul
 * * `CV-PN` - CPV-Porto Novo
 * * `CV-PR` - CPV-Praia
 * * `CV-RB` - CPV-Ribeira Brava
 * * `CV-RG` - CPV-Ribeira Grande
 * * `CV-RS` - CPV-Ribeira Grande de Santiago
 * * `CV-SL` - CPV-Sal
 * * `CV-CA` - CPV-Santa Catarina
 * * `CV-CF` - CPV-Santa Catarina do Fogo
 * * `CV-CR` - CPV-Santa Cruz
 * * `CV-SD` - CPV-São Domingos
 * * `CV-SF` - CPV-São Filipe
 * * `CV-SO` - CPV-São Lourenço dos Órgãos
 * * `CV-SM` - CPV-São Miguel
 * * `CV-SS` - CPV-São Salvador do Mundo
 * * `CV-SV` - CPV-São Vicente
 * * `CV-TA` - CPV-Tarrafal
 * * `CV-TS` - CPV-Tarrafal de São Nicolau
 * * `CR-A` - CRI-Alajuela
 * * `CR-C` - CRI-Cartago
 * * `CR-G` - CRI-Guanacaste
 * * `CR-H` - CRI-Heredia
 * * `CR-L` - CRI-Limón
 * * `CR-P` - CRI-Puntarenas
 * * `CR-SJ` - CRI-San José
 * * `CU-15` - CUB-Artemisa
 * * `CU-09` - CUB-Camagüey
 * * `CU-08` - CUB-Ciego de Ávila
 * * `CU-06` - CUB-Cienfuegos
 * * `CU-12` - CUB-Granma
 * * `CU-14` - CUB-Guantánamo
 * * `CU-11` - CUB-Holguín
 * * `CU-99` - CUB-Isla de la Juventud
 * * `CU-03` - CUB-La Habana
 * * `CU-10` - CUB-Las Tunas
 * * `CU-04` - CUB-Matanzas
 * * `CU-16` - CUB-Mayabeque
 * * `CU-01` - CUB-Pinar del Río
 * * `CU-07` - CUB-Sancti Spíritus
 * * `CU-13` - CUB-Santiago de Cuba
 * * `CU-05` - CUB-Villa Clara
 * * `CY-04` - CYP-Ammochostos
 * * `CY-05` - CYP-Baf
 * * `CY-06` - CYP-Girne
 * * `CY-03` - CYP-Larnaka
 * * `CY-01` - CYP-Lefkosia
 * * `CY-02` - CYP-Lemesos
 * * `CZ-201` - CZE-Benešov
 * * `CZ-202` - CZE-Beroun
 * * `CZ-641` - CZE-Blansko
 * * `CZ-642` - CZE-Brno-město
 * * `CZ-643` - CZE-Brno-venkov
 * * `CZ-801` - CZE-Bruntál
 * * `CZ-644` - CZE-Břeclav
 * * `CZ-411` - CZE-Cheb
 * * `CZ-422` - CZE-Chomutov
 * * `CZ-531` - CZE-Chrudim
 * * `CZ-321` - CZE-Domažlice
 * * `CZ-421` - CZE-Děčín
 * * `CZ-802` - CZE-Frýdek-Místek
 * * `CZ-631` - CZE-Havlíčkův Brod
 * * `CZ-645` - CZE-Hodonín
 * * `CZ-521` - CZE-Hradec Králové
 * * `CZ-512` - CZE-Jablonec nad Nisou
 * * `CZ-711` - CZE-Jeseník
 * * `CZ-632` - CZE-Jihlava
 * * `CZ-64` - CZE-Jihomoravský kraj
 * * `CZ-31` - CZE-Jihočeský kraj
 * * `CZ-313` - CZE-Jindřichův Hradec
 * * `CZ-522` - CZE-Jičín
 * * `CZ-41` - CZE-Karlovarský kraj
 * * `CZ-412` - CZE-Karlovy Vary
 * * `CZ-803` - CZE-Karviná
 * * `CZ-203` - CZE-Kladno
 * * `CZ-322` - CZE-Klatovy
 * * `CZ-204` - CZE-Kolín
 * * `CZ-63` - CZE-Kraj Vysočina
 * * `CZ-721` - CZE-Kroměříž
 * * `CZ-52` - CZE-Královéhradecký kraj
 * * `CZ-205` - CZE-Kutná Hora
 * * `CZ-513` - CZE-Liberec
 * * `CZ-51` - CZE-Liberecký kraj
 * * `CZ-423` - CZE-Litoměřice
 * * `CZ-424` - CZE-Louny
 * * `CZ-207` - CZE-Mladá Boleslav
 * * `CZ-80` - CZE-Moravskoslezský kraj
 * * `CZ-425` - CZE-Most
 * * `CZ-206` - CZE-Mělník
 * * `CZ-804` - CZE-Nový Jičín
 * * `CZ-208` - CZE-Nymburk
 * * `CZ-523` - CZE-Náchod
 * * `CZ-712` - CZE-Olomouc
 * * `CZ-71` - CZE-Olomoucký kraj
 * * `CZ-805` - CZE-Opava
 * * `CZ-806` - CZE-Ostrava-město
 * * `CZ-532` - CZE-Pardubice
 * * `CZ-53` - CZE-Pardubický kraj
 * * `CZ-633` - CZE-Pelhřimov
 * * `CZ-324` - CZE-Plzeň-jih
 * * `CZ-323` - CZE-Plzeň-město
 * * `CZ-325` - CZE-Plzeň-sever
 * * `CZ-32` - CZE-Plzeňský kraj
 * * `CZ-315` - CZE-Prachatice
 * * `CZ-10` - CZE-Praha, Hlavní město
 * * `CZ-209` - CZE-Praha-východ
 * * `CZ-20A` - CZE-Praha-západ
 * * `CZ-713` - CZE-Prostějov
 * * `CZ-314` - CZE-Písek
 * * `CZ-714` - CZE-Přerov
 * * `CZ-20B` - CZE-Příbram
 * * `CZ-20C` - CZE-Rakovník
 * * `CZ-326` - CZE-Rokycany
 * * `CZ-524` - CZE-Rychnov nad Kněžnou
 * * `CZ-514` - CZE-Semily
 * * `CZ-413` - CZE-Sokolov
 * * `CZ-316` - CZE-Strakonice
 * * `CZ-20` - CZE-Středočeský kraj
 * * `CZ-533` - CZE-Svitavy
 * * `CZ-327` - CZE-Tachov
 * * `CZ-426` - CZE-Teplice
 * * `CZ-525` - CZE-Trutnov
 * * `CZ-317` - CZE-Tábor
 * * `CZ-634` - CZE-Třebíč
 * * `CZ-722` - CZE-Uherské Hradiště
 * * `CZ-723` - CZE-Vsetín
 * * `CZ-646` - CZE-Vyškov
 * * `CZ-724` - CZE-Zlín
 * * `CZ-72` - CZE-Zlínský kraj
 * * `CZ-647` - CZE-Znojmo
 * * `CZ-42` - CZE-Ústecký kraj
 * * `CZ-427` - CZE-Ústí nad Labem
 * * `CZ-534` - CZE-Ústí nad Orlicí
 * * `CZ-511` - CZE-Česká Lípa
 * * `CZ-311` - CZE-České Budějovice
 * * `CZ-312` - CZE-Český Krumlov
 * * `CZ-715` - CZE-Šumperk
 * * `CZ-635` - CZE-Žďár nad Sázavou
 * * `DE-BW` - DEU-Baden-Württemberg
 * * `DE-BY` - DEU-Bayern
 * * `DE-BE` - DEU-Berlin
 * * `DE-BB` - DEU-Brandenburg
 * * `DE-HB` - DEU-Bremen
 * * `DE-HH` - DEU-Hamburg
 * * `DE-HE` - DEU-Hessen
 * * `DE-MV` - DEU-Mecklenburg-Vorpommern
 * * `DE-NI` - DEU-Niedersachsen
 * * `DE-NW` - DEU-Nordrhein-Westfalen
 * * `DE-RP` - DEU-Rheinland-Pfalz
 * * `DE-SL` - DEU-Saarland
 * * `DE-SN` - DEU-Sachsen
 * * `DE-ST` - DEU-Sachsen-Anhalt
 * * `DE-SH` - DEU-Schleswig-Holstein
 * * `DE-TH` - DEU-Thüringen
 * * `DJ-AS` - DJI-Ali Sabieh
 * * `DJ-AR` - DJI-Arta
 * * `DJ-DI` - DJI-Dikhil
 * * `DJ-DJ` - DJI-Djibouti
 * * `DJ-OB` - DJI-Obock
 * * `DJ-TA` - DJI-Tadjourah
 * * `DM-02` - DMA-Saint Andrew
 * * `DM-03` - DMA-Saint David
 * * `DM-04` - DMA-Saint George
 * * `DM-05` - DMA-Saint John
 * * `DM-06` - DMA-Saint Joseph
 * * `DM-07` - DMA-Saint Luke
 * * `DM-08` - DMA-Saint Mark
 * * `DM-09` - DMA-Saint Patrick
 * * `DM-10` - DMA-Saint Paul
 * * `DM-11` - DMA-Saint Peter
 * * `DK-84` - DNK-Hovedstaden
 * * `DK-82` - DNK-Midtjylland
 * * `DK-81` - DNK-Nordjylland
 * * `DK-85` - DNK-Sjælland
 * * `DK-83` - DNK-Syddanmark
 * * `DO-02` - DOM-Azua
 * * `DO-03` - DOM-Baoruco
 * * `DO-04` - DOM-Barahona
 * * `DO-33` - DOM-Cibao Nordeste
 * * `DO-34` - DOM-Cibao Noroeste
 * * `DO-35` - DOM-Cibao Norte
 * * `DO-36` - DOM-Cibao Sur
 * * `DO-05` - DOM-Dajabón
 * * `DO-01` - DOM-Distrito Nacional (Santo Domingo)
 * * `DO-06` - DOM-Duarte
 * * `DO-08` - DOM-El Seibo
 * * `DO-37` - DOM-El Valle
 * * `DO-07` - DOM-Elías Piña
 * * `DO-38` - DOM-Enriquillo
 * * `DO-09` - DOM-Espaillat
 * * `DO-30` - DOM-Hato Mayor
 * * `DO-19` - DOM-Hermanas Mirabal
 * * `DO-39` - DOM-Higuamo
 * * `DO-10` - DOM-Independencia
 * * `DO-11` - DOM-La Altagracia
 * * `DO-12` - DOM-La Romana
 * * `DO-13` - DOM-La Vega
 * * `DO-14` - DOM-María Trinidad Sánchez
 * * `DO-28` - DOM-Monseñor Nouel
 * * `DO-15` - DOM-Monte Cristi
 * * `DO-29` - DOM-Monte Plata
 * * `DO-40` - DOM-Ozama
 * * `DO-16` - DOM-Pedernales
 * * `DO-17` - DOM-Peravia
 * * `DO-18` - DOM-Puerto Plata
 * * `DO-20` - DOM-Samaná
 * * `DO-21` - DOM-San Cristóbal
 * * `DO-31` - DOM-San José de Ocoa
 * * `DO-22` - DOM-San Juan
 * * `DO-23` - DOM-San Pedro de Macorís
 * * `DO-25` - DOM-Santiago
 * * `DO-26` - DOM-Santiago Rodríguez
 * * `DO-32` - DOM-Santo Domingo
 * * `DO-24` - DOM-Sánchez Ramírez
 * * `DO-41` - DOM-Valdesia
 * * `DO-27` - DOM-Valverde
 * * `DO-42` - DOM-Yuma
 * * `DZ-01` - DZA-Adrar
 * * `DZ-16` - DZA-Alger
 * * `DZ-23` - DZA-Annaba
 * * `DZ-44` - DZA-Aïn Defla
 * * `DZ-46` - DZA-Aïn Témouchent
 * * `DZ-05` - DZA-Batna
 * * `DZ-07` - DZA-Biskra
 * * `DZ-09` - DZA-Blida
 * * `DZ-50` - DZA-Bordj Badji Mokhtar
 * * `DZ-34` - DZA-Bordj Bou Arréridj
 * * `DZ-10` - DZA-Bouira
 * * `DZ-35` - DZA-Boumerdès
 * * `DZ-08` - DZA-Béchar
 * * `DZ-06` - DZA-Béjaïa
 * * `DZ-52` - DZA-Béni Abbès
 * * `DZ-02` - DZA-Chlef
 * * `DZ-25` - DZA-Constantine
 * * `DZ-56` - DZA-Djanet
 * * `DZ-17` - DZA-Djelfa
 * * `DZ-32` - DZA-El Bayadh
 * * `DZ-57` - DZA-El Meghaier
 * * `DZ-58` - DZA-El Meniaa
 * * `DZ-39` - DZA-El Oued
 * * `DZ-36` - DZA-El Tarf
 * * `DZ-47` - DZA-Ghardaïa
 * * `DZ-24` - DZA-Guelma
 * * `DZ-33` - DZA-Illizi
 * * `DZ-54` - DZA-In Guezzam
 * * `DZ-53` - DZA-In Salah
 * * `DZ-18` - DZA-Jijel
 * * `DZ-40` - DZA-Khenchela
 * * `DZ-03` - DZA-Laghouat
 * * `DZ-28` - DZA-M'sila
 * * `DZ-29` - DZA-Mascara
 * * `DZ-43` - DZA-Mila
 * * `DZ-27` - DZA-Mostaganem
 * * `DZ-26` - DZA-Médéa
 * * `DZ-45` - DZA-Naama
 * * `DZ-31` - DZA-Oran
 * * `DZ-30` - DZA-Ouargla
 * * `DZ-51` - DZA-Ouled Djellal
 * * `DZ-04` - DZA-Oum el Bouaghi
 * * `DZ-48` - DZA-Relizane
 * * `DZ-20` - DZA-Saïda
 * * `DZ-22` - DZA-Sidi Bel Abbès
 * * `DZ-21` - DZA-Skikda
 * * `DZ-41` - DZA-Souk Ahras
 * * `DZ-19` - DZA-Sétif
 * * `DZ-11` - DZA-Tamanrasset
 * * `DZ-14` - DZA-Tiaret
 * * `DZ-49` - DZA-Timimoun
 * * `DZ-37` - DZA-Tindouf
 * * `DZ-42` - DZA-Tipaza
 * * `DZ-38` - DZA-Tissemsilt
 * * `DZ-15` - DZA-Tizi Ouzou
 * * `DZ-13` - DZA-Tlemcen
 * * `DZ-55` - DZA-Touggourt
 * * `DZ-12` - DZA-Tébessa
 * * `EC-A` - ECU-Azuay
 * * `EC-B` - ECU-Bolívar
 * * `EC-C` - ECU-Carchi
 * * `EC-F` - ECU-Cañar
 * * `EC-H` - ECU-Chimborazo
 * * `EC-X` - ECU-Cotopaxi
 * * `EC-O` - ECU-El Oro
 * * `EC-E` - ECU-Esmeraldas
 * * `EC-W` - ECU-Galápagos
 * * `EC-G` - ECU-Guayas
 * * `EC-I` - ECU-Imbabura
 * * `EC-L` - ECU-Loja
 * * `EC-R` - ECU-Los Ríos
 * * `EC-M` - ECU-Manabí
 * * `EC-S` - ECU-Morona Santiago
 * * `EC-N` - ECU-Napo
 * * `EC-D` - ECU-Orellana
 * * `EC-Y` - ECU-Pastaza
 * * `EC-P` - ECU-Pichincha
 * * `EC-SE` - ECU-Santa Elena
 * * `EC-SD` - ECU-Santo Domingo de los Tsáchilas
 * * `EC-U` - ECU-Sucumbíos
 * * `EC-T` - ECU-Tungurahua
 * * `EC-Z` - ECU-Zamora Chinchipe
 * * `EG-DK` - EGY-Ad Daqahlīyah
 * * `EG-BA` - EGY-Al Baḩr al Aḩmar
 * * `EG-BH` - EGY-Al Buḩayrah
 * * `EG-FYM` - EGY-Al Fayyūm
 * * `EG-GH` - EGY-Al Gharbīyah
 * * `EG-ALX` - EGY-Al Iskandarīyah
 * * `EG-IS` - EGY-Al Ismā'īlīyah
 * * `EG-GZ` - EGY-Al Jīzah
 * * `EG-MN` - EGY-Al Minyā
 * * `EG-MNF` - EGY-Al Minūfīyah
 * * `EG-KB` - EGY-Al Qalyūbīyah
 * * `EG-C` - EGY-Al Qāhirah
 * * `EG-LX` - EGY-Al Uqşur
 * * `EG-WAD` - EGY-Al Wādī al Jadīd
 * * `EG-SUZ` - EGY-As Suways
 * * `EG-SHR` - EGY-Ash Sharqīyah
 * * `EG-ASN` - EGY-Aswān
 * * `EG-AST` - EGY-Asyūţ
 * * `EG-BNS` - EGY-Banī Suwayf
 * * `EG-PTS` - EGY-Būr Sa‘īd
 * * `EG-DT` - EGY-Dumyāţ
 * * `EG-JS` - EGY-Janūb Sīnā'
 * * `EG-KFS` - EGY-Kafr ash Shaykh
 * * `EG-MT` - EGY-Maţrūḩ
 * * `EG-KN` - EGY-Qinā
 * * `EG-SIN` - EGY-Shamāl Sīnā'
 * * `EG-SHG` - EGY-Sūhāj
 * * `ER-MA` - ERI-Al Awsaţ
 * * `ER-DU` - ERI-Al Janūbī
 * * `ER-AN` - ERI-Ansabā
 * * `ER-DK` - ERI-Debubawi K’eyyĭḥ Baḥri
 * * `ER-GB` - ERI-Gash-Barka
 * * `ER-SK` - ERI-Semienawi K’eyyĭḥ Baḥri
 * * `ES-C` - ESP-A Coruña [La Coruña]
 * * `ES-A` - ESP-Alacant*
 * * `ES-AB` - ESP-Albacete
 * * `ES-AL` - ESP-Almería
 * * `ES-AN` - ESP-Andalucía
 * * `ES-VI` - ESP-Araba*
 * * `ES-AR` - ESP-Aragón
 * * `ES-O` - ESP-Asturias
 * * `ES-AS` - ESP-Asturias, Principado de
 * * `ES-BA` - ESP-Badajoz
 * * `ES-B` - ESP-Barcelona [Barcelona]
 * * `ES-BI` - ESP-Bizkaia
 * * `ES-BU` - ESP-Burgos
 * * `ES-CN` - ESP-Canarias
 * * `ES-CB` - ESP-Cantabria
 * * `ES-S` - ESP-Cantabria
 * * `ES-CS` - ESP-Castelló*
 * * `ES-CL` - ESP-Castilla y León
 * * `ES-CM` - ESP-Castilla-La Mancha
 * * `ES-CT` - ESP-Catalunya [Cataluña]
 * * `ES-CE` - ESP-Ceuta
 * * `ES-CR` - ESP-Ciudad Real
 * * `ES-CU` - ESP-Cuenca
 * * `ES-CC` - ESP-Cáceres
 * * `ES-CA` - ESP-Cádiz
 * * `ES-CO` - ESP-Córdoba
 * * `ES-PV` - ESP-Euskal Herria
 * * `ES-EX` - ESP-Extremadura
 * * `ES-GA` - ESP-Galicia [Galicia]
 * * `ES-SS` - ESP-Gipuzkoa
 * * `ES-GI` - ESP-Girona [Gerona]
 * * `ES-GR` - ESP-Granada
 * * `ES-GU` - ESP-Guadalajara
 * * `ES-H` - ESP-Huelva
 * * `ES-HU` - ESP-Huesca
 * * `ES-IB` - ESP-Illes Balears [Islas Baleares]
 * * `ES-PM` - ESP-Illes Balears [Islas Baleares]
 * * `ES-J` - ESP-Jaén
 * * `ES-LO` - ESP-La Rioja
 * * `ES-RI` - ESP-La Rioja
 * * `ES-GC` - ESP-Las Palmas
 * * `ES-LE` - ESP-León
 * * `ES-L` - ESP-Lleida [Lérida]
 * * `ES-LU` - ESP-Lugo [Lugo]
 * * `ES-M` - ESP-Madrid
 * * `ES-MD` - ESP-Madrid, Comunidad de
 * * `ES-ML` - ESP-Melilla
 * * `ES-MU` - ESP-Murcia
 * * `ES-MC` - ESP-Murcia, Región de
 * * `ES-MA` - ESP-Málaga
 * * `ES-NA` - ESP-Nafarroa*
 * * `ES-NC` - ESP-Nafarroako Foru Komunitatea*
 * * `ES-OR` - ESP-Ourense [Orense]
 * * `ES-P` - ESP-Palencia
 * * `ES-PO` - ESP-Pontevedra [Pontevedra]
 * * `ES-SA` - ESP-Salamanca
 * * `ES-TF` - ESP-Santa Cruz de Tenerife
 * * `ES-SG` - ESP-Segovia
 * * `ES-SE` - ESP-Sevilla
 * * `ES-SO` - ESP-Soria
 * * `ES-T` - ESP-Tarragona [Tarragona]
 * * `ES-TE` - ESP-Teruel
 * * `ES-TO` - ESP-Toledo
 * * `ES-V` - ESP-Valencia
 * * `ES-VC` - ESP-Valenciana, Comunidad
 * * `ES-VA` - ESP-Valladolid
 * * `ES-ZA` - ESP-Zamora
 * * `ES-Z` - ESP-Zaragoza
 * * `ES-AV` - ESP-Ávila
 * * `EE-130` - EST-Alutaguse
 * * `EE-141` - EST-Anija
 * * `EE-142` - EST-Antsla
 * * `EE-171` - EST-Elva
 * * `EE-184` - EST-Haapsalu
 * * `EE-191` - EST-Haljala
 * * `EE-37` - EST-Harjumaa
 * * `EE-198` - EST-Harku
 * * `EE-205` - EST-Hiiumaa
 * * `EE-39` - EST-Hiiumaa
 * * `EE-214` - EST-Häädemeeste
 * * `EE-45` - EST-Ida-Virumaa
 * * `EE-255` - EST-Järva
 * * `EE-52` - EST-Järvamaa
 * * `EE-245` - EST-Jõelähtme
 * * `EE-247` - EST-Jõgeva
 * * `EE-50` - EST-Jõgevamaa
 * * `EE-251` - EST-Jõhvi
 * * `EE-272` - EST-Kadrina
 * * `EE-283` - EST-Kambja
 * * `EE-284` - EST-Kanepi
 * * `EE-291` - EST-Kastre
 * * `EE-293` - EST-Kehtna
 * * `EE-296` - EST-Keila
 * * `EE-303` - EST-Kihnu
 * * `EE-305` - EST-Kiili
 * * `EE-317` - EST-Kohila
 * * `EE-321` - EST-Kohtla-Järve
 * * `EE-338` - EST-Kose
 * * `EE-353` - EST-Kuusalu
 * * `EE-424` - EST-Loksa
 * * `EE-432` - EST-Luunja
 * * `EE-431` - EST-Lääne-Harju
 * * `EE-441` - EST-Lääne-Nigula
 * * `EE-60` - EST-Lääne-Virumaa
 * * `EE-56` - EST-Läänemaa
 * * `EE-430` - EST-Lääneranna
 * * `EE-442` - EST-Lüganuse
 * * `EE-446` - EST-Maardu
 * * `EE-478` - EST-Muhu
 * * `EE-480` - EST-Mulgi
 * * `EE-486` - EST-Mustvee
 * * `EE-503` - EST-Märjamaa
 * * `EE-511` - EST-Narva
 * * `EE-514` - EST-Narva-Jõesuu
 * * `EE-528` - EST-Nõo
 * * `EE-557` - EST-Otepää
 * * `EE-567` - EST-Paide
 * * `EE-586` - EST-Peipsiääre
 * * `EE-624` - EST-Pärnu
 * * `EE-68` - EST-Pärnumaa
 * * `EE-638` - EST-Põhja-Pärnumaa
 * * `EE-615` - EST-Põhja-Sakala
 * * `EE-618` - EST-Põltsamaa
 * * `EE-622` - EST-Põlva
 * * `EE-64` - EST-Põlvamaa
 * * `EE-651` - EST-Raasiku
 * * `EE-653` - EST-Rae
 * * `EE-661` - EST-Rakvere
 * * `EE-663` - EST-Rakvere
 * * `EE-668` - EST-Rapla
 * * `EE-71` - EST-Raplamaa
 * * `EE-689` - EST-Ruhnu
 * * `EE-708` - EST-Räpina
 * * `EE-698` - EST-Rõuge
 * * `EE-712` - EST-Saarde
 * * `EE-714` - EST-Saaremaa
 * * `EE-74` - EST-Saaremaa
 * * `EE-719` - EST-Saku
 * * `EE-726` - EST-Saue
 * * `EE-732` - EST-Setomaa
 * * `EE-735` - EST-Sillamäe
 * * `EE-784` - EST-Tallinn
 * * `EE-792` - EST-Tapa
 * * `EE-793` - EST-Tartu
 * * `EE-796` - EST-Tartu
 * * `EE-79` - EST-Tartumaa
 * * `EE-803` - EST-Toila
 * * `EE-809` - EST-Tori
 * * `EE-824` - EST-Tõrva
 * * `EE-834` - EST-Türi
 * * `EE-855` - EST-Valga
 * * `EE-81` - EST-Valgamaa
 * * `EE-890` - EST-Viimsi
 * * `EE-897` - EST-Viljandi
 * * `EE-899` - EST-Viljandi
 * * `EE-84` - EST-Viljandimaa
 * * `EE-901` - EST-Vinni
 * * `EE-903` - EST-Viru-Nigula
 * * `EE-907` - EST-Vormsi
 * * `EE-928` - EST-Väike-Maarja
 * * `EE-917` - EST-Võru
 * * `EE-919` - EST-Võru
 * * `EE-87` - EST-Võrumaa
 * * `ET-AA` - ETH-Addis Ababa
 * * `ET-AF` - ETH-Afar
 * * `ET-AM` - ETH-Amara
 * * `ET-BE` - ETH-Benshangul-Gumaz
 * * `ET-DD` - ETH-Dire Dawa
 * * `ET-GA` - ETH-Gambela Peoples
 * * `ET-HA` - ETH-Harari People
 * * `ET-OR` - ETH-Oromia
 * * `ET-SI` - ETH-Sidama
 * * `ET-SO` - ETH-Somali
 * * `ET-SN` - ETH-Southern Nations, Nationalities and Peoples
 * * `ET-SW` - ETH-Southwest Ethiopia Peoples
 * * `ET-TI` - ETH-Tigrai
 * * `FI-02` - FIN-Etelä-Karjala
 * * `FI-03` - FIN-Etelä-Pohjanmaa
 * * `FI-04` - FIN-Etelä-Savo
 * * `FI-05` - FIN-Kainuu
 * * `FI-06` - FIN-Kanta-Häme
 * * `FI-07` - FIN-Keski-Pohjanmaa
 * * `FI-08` - FIN-Keski-Suomi
 * * `FI-09` - FIN-Kymenlaakso
 * * `FI-01` - FIN-Landskapet Åland
 * * `FI-10` - FIN-Lappi
 * * `FI-11` - FIN-Pirkanmaa
 * * `FI-12` - FIN-Pohjanmaa
 * * `FI-13` - FIN-Pohjois-Karjala
 * * `FI-14` - FIN-Pohjois-Pohjanmaa
 * * `FI-15` - FIN-Pohjois-Savo
 * * `FI-16` - FIN-Päijät-Häme
 * * `FI-17` - FIN-Satakunta
 * * `FI-18` - FIN-Uusimaa
 * * `FI-19` - FIN-Varsinais-Suomi
 * * `FJ-01` - FJI-Ba
 * * `FJ-02` - FJI-Bua
 * * `FJ-03` - FJI-Cakaudrove
 * * `FJ-C` - FJI-Central
 * * `FJ-E` - FJI-Eastern
 * * `FJ-04` - FJI-Kadavu
 * * `FJ-05` - FJI-Lau
 * * `FJ-06` - FJI-Lomaiviti
 * * `FJ-07` - FJI-Macuata
 * * `FJ-08` - FJI-Nadroga and Navosa
 * * `FJ-09` - FJI-Naitasiri
 * * `FJ-10` - FJI-Namosi
 * * `FJ-N` - FJI-Northern
 * * `FJ-11` - FJI-Ra
 * * `FJ-12` - FJI-Rewa
 * * `FJ-R` - FJI-Rotuma
 * * `FJ-13` - FJI-Serua
 * * `FJ-14` - FJI-Tailevu
 * * `FJ-W` - FJI-Western
 * * `FR-01` - FRA-Ain
 * * `FR-02` - FRA-Aisne
 * * `FR-03` - FRA-Allier
 * * `FR-06` - FRA-Alpes-Maritimes
 * * `FR-04` - FRA-Alpes-de-Haute-Provence
 * * `FR-6AE` - FRA-Alsace
 * * `FR-08` - FRA-Ardennes
 * * `FR-07` - FRA-Ardèche
 * * `FR-09` - FRA-Ariège
 * * `FR-10` - FRA-Aube
 * * `FR-11` - FRA-Aude
 * * `FR-ARA` - FRA-Auvergne-Rhône-Alpes
 * * `FR-12` - FRA-Aveyron
 * * `FR-67` - FRA-Bas-Rhin
 * * `FR-13` - FRA-Bouches-du-Rhône
 * * `FR-BFC` - FRA-Bourgogne-Franche-Comté
 * * `FR-BRE` - FRA-Bretagne
 * * `FR-14` - FRA-Calvados
 * * `FR-15` - FRA-Cantal
 * * `FR-CVL` - FRA-Centre-Val de Loire
 * * `FR-16` - FRA-Charente
 * * `FR-17` - FRA-Charente-Maritime
 * * `FR-18` - FRA-Cher
 * * `FR-CP` - FRA-Clipperton
 * * `FR-19` - FRA-Corrèze
 * * `FR-20R` - FRA-Corse
 * * `FR-2A` - FRA-Corse-du-Sud
 * * `FR-23` - FRA-Creuse
 * * `FR-21` - FRA-Côte-d'Or
 * * `FR-22` - FRA-Côtes-d'Armor
 * * `FR-79` - FRA-Deux-Sèvres
 * * `FR-24` - FRA-Dordogne
 * * `FR-25` - FRA-Doubs
 * * `FR-26` - FRA-Drôme
 * * `FR-91` - FRA-Essonne
 * * `FR-27` - FRA-Eure
 * * `FR-28` - FRA-Eure-et-Loir
 * * `FR-29` - FRA-Finistère
 * * `FR-30` - FRA-Gard
 * * `FR-32` - FRA-Gers
 * * `FR-33` - FRA-Gironde
 * * `FR-GES` - FRA-Grand-Est
 * * `FR-971` - FRA-Guadeloupe
 * * `FR-973` - FRA-Guyane (française)
 * * `FR-68` - FRA-Haut-Rhin
 * * `FR-2B` - FRA-Haute-Corse
 * * `FR-31` - FRA-Haute-Garonne
 * * `FR-43` - FRA-Haute-Loire
 * * `FR-52` - FRA-Haute-Marne
 * * `FR-74` - FRA-Haute-Savoie
 * * `FR-70` - FRA-Haute-Saône
 * * `FR-87` - FRA-Haute-Vienne
 * * `FR-05` - FRA-Hautes-Alpes
 * * `FR-65` - FRA-Hautes-Pyrénées
 * * `FR-HDF` - FRA-Hauts-de-France
 * * `FR-92` - FRA-Hauts-de-Seine
 * * `FR-34` - FRA-Hérault
 * * `FR-35` - FRA-Ille-et-Vilaine
 * * `FR-36` - FRA-Indre
 * * `FR-37` - FRA-Indre-et-Loire
 * * `FR-38` - FRA-Isère
 * * `FR-39` - FRA-Jura
 * * `FR-974` - FRA-La Réunion
 * * `FR-40` - FRA-Landes
 * * `FR-41` - FRA-Loir-et-Cher
 * * `FR-42` - FRA-Loire
 * * `FR-44` - FRA-Loire-Atlantique
 * * `FR-45` - FRA-Loiret
 * * `FR-46` - FRA-Lot
 * * `FR-47` - FRA-Lot-et-Garonne
 * * `FR-48` - FRA-Lozère
 * * `FR-49` - FRA-Maine-et-Loire
 * * `FR-50` - FRA-Manche
 * * `FR-51` - FRA-Marne
 * * `FR-972` - FRA-Martinique
 * * `FR-53` - FRA-Mayenne
 * * `FR-976` - FRA-Mayotte
 * * `FR-54` - FRA-Meurthe-et-Moselle
 * * `FR-55` - FRA-Meuse
 * * `FR-56` - FRA-Morbihan
 * * `FR-57` - FRA-Moselle
 * * `FR-69M` - FRA-Métropole de Lyon
 * * `FR-58` - FRA-Nièvre
 * * `FR-59` - FRA-Nord
 * * `FR-NOR` - FRA-Normandie
 * * `FR-NAQ` - FRA-Nouvelle-Aquitaine
 * * `FR-NC` - FRA-Nouvelle-Calédonie
 * * `FR-OCC` - FRA-Occitanie
 * * `FR-60` - FRA-Oise
 * * `FR-61` - FRA-Orne
 * * `FR-75C` - FRA-Paris
 * * `FR-62` - FRA-Pas-de-Calais
 * * `FR-PDL` - FRA-Pays-de-la-Loire
 * * `FR-PF` - FRA-Polynésie française
 * * `FR-PAC` - FRA-Provence-Alpes-Côte-d’Azur
 * * `FR-63` - FRA-Puy-de-Dôme
 * * `FR-64` - FRA-Pyrénées-Atlantiques
 * * `FR-66` - FRA-Pyrénées-Orientales
 * * `FR-69` - FRA-Rhône
 * * `FR-BL` - FRA-Saint-Barthélemy
 * * `FR-MF` - FRA-Saint-Martin
 * * `FR-PM` - FRA-Saint-Pierre-et-Miquelon
 * * `FR-72` - FRA-Sarthe
 * * `FR-73` - FRA-Savoie
 * * `FR-71` - FRA-Saône-et-Loire
 * * `FR-76` - FRA-Seine-Maritime
 * * `FR-93` - FRA-Seine-Saint-Denis
 * * `FR-77` - FRA-Seine-et-Marne
 * * `FR-80` - FRA-Somme
 * * `FR-81` - FRA-Tarn
 * * `FR-82` - FRA-Tarn-et-Garonne
 * * `FR-TF` - FRA-Terres australes françaises
 * * `FR-90` - FRA-Territoire de Belfort
 * * `FR-95` - FRA-Val-d'Oise
 * * `FR-94` - FRA-Val-de-Marne
 * * `FR-83` - FRA-Var
 * * `FR-84` - FRA-Vaucluse
 * * `FR-85` - FRA-Vendée
 * * `FR-86` - FRA-Vienne
 * * `FR-88` - FRA-Vosges
 * * `FR-WF` - FRA-Wallis-et-Futuna
 * * `FR-89` - FRA-Yonne
 * * `FR-78` - FRA-Yvelines
 * * `FR-IDF` - FRA-Île-de-France
 * * `FM-TRK` - FSM-Chuuk
 * * `FM-KSA` - FSM-Kosrae
 * * `FM-PNI` - FSM-Pohnpei
 * * `FM-YAP` - FSM-Yap
 * * `GA-1` - GAB-Estuaire
 * * `GA-2` - GAB-Haut-Ogooué
 * * `GA-3` - GAB-Moyen-Ogooué
 * * `GA-4` - GAB-Ngounié
 * * `GA-5` - GAB-Nyanga
 * * `GA-6` - GAB-Ogooué-Ivindo
 * * `GA-7` - GAB-Ogooué-Lolo
 * * `GA-8` - GAB-Ogooué-Maritime
 * * `GA-9` - GAB-Woleu-Ntem
 * * `GB-ABE` - GBR-Aberdeen City
 * * `GB-ABD` - GBR-Aberdeenshire
 * * `GB-ANS` - GBR-Angus
 * * `GB-ANN` - GBR-Antrim and Newtownabbey
 * * `GB-AND` - GBR-Ards and North Down
 * * `GB-AGB` - GBR-Argyll and Bute
 * * `GB-ABC` - GBR-Armagh City, Banbridge and Craigavon
 * * `GB-BDG` - GBR-Barking and Dagenham
 * * `GB-BNE` - GBR-Barnet
 * * `GB-BNS` - GBR-Barnsley
 * * `GB-BAS` - GBR-Bath and North East Somerset
 * * `GB-BDF` - GBR-Bedford
 * * `GB-BFS` - GBR-Belfast City
 * * `GB-BEX` - GBR-Bexley
 * * `GB-BIR` - GBR-Birmingham
 * * `GB-BBD` - GBR-Blackburn with Darwen
 * * `GB-BPL` - GBR-Blackpool
 * * `GB-BGW` - GBR-Blaenau Gwent
 * * `GB-BOL` - GBR-Bolton
 * * `GB-BCP` - GBR-Bournemouth, Christchurch and Poole
 * * `GB-BRC` - GBR-Bracknell Forest
 * * `GB-BRD` - GBR-Bradford
 * * `GB-BEN` - GBR-Brent
 * * `GB-BGE` - GBR-Bridgend [Pen-y-bont ar Ogwr GB-POG]
 * * `GB-BNH` - GBR-Brighton and Hove
 * * `GB-BST` - GBR-Bristol, City of
 * * `GB-BRY` - GBR-Bromley
 * * `GB-BKM` - GBR-Buckinghamshire
 * * `GB-BUR` - GBR-Bury
 * * `GB-CAY` - GBR-Caerphilly [Caerffili GB-CAF]
 * * `GB-CLD` - GBR-Calderdale
 * * `GB-CAM` - GBR-Cambridgeshire
 * * `GB-CMD` - GBR-Camden
 * * `GB-CRF` - GBR-Cardiff [Caerdydd GB-CRD]
 * * `GB-CMN` - GBR-Carmarthenshire [Sir Gaerfyrddin GB-GFY]
 * * `GB-CCG` - GBR-Causeway Coast and Glens
 * * `GB-CBF` - GBR-Central Bedfordshire
 * * `GB-CGN` - GBR-Ceredigion [Sir Ceredigion]
 * * `GB-CHE` - GBR-Cheshire East
 * * `GB-CHW` - GBR-Cheshire West and Chester
 * * `GB-CLK` - GBR-Clackmannanshire
 * * `GB-CWY` - GBR-Conwy
 * * `GB-CON` - GBR-Cornwall
 * * `GB-COV` - GBR-Coventry
 * * `GB-CRY` - GBR-Croydon
 * * `GB-CMA` - GBR-Cumbria
 * * `GB-DAL` - GBR-Darlington
 * * `GB-DEN` - GBR-Denbighshire [Sir Ddinbych GB-DDB]
 * * `GB-DER` - GBR-Derby
 * * `GB-DBY` - GBR-Derbyshire
 * * `GB-DRS` - GBR-Derry and Strabane
 * * `GB-DEV` - GBR-Devon
 * * `GB-DNC` - GBR-Doncaster
 * * `GB-DOR` - GBR-Dorset
 * * `GB-DUD` - GBR-Dudley
 * * `GB-DGY` - GBR-Dumfries and Galloway
 * * `GB-DND` - GBR-Dundee City
 * * `GB-DUR` - GBR-Durham, County
 * * `GB-EAL` - GBR-Ealing
 * * `GB-EAY` - GBR-East Ayrshire
 * * `GB-EDU` - GBR-East Dunbartonshire
 * * `GB-ELN` - GBR-East Lothian
 * * `GB-ERW` - GBR-East Renfrewshire
 * * `GB-ERY` - GBR-East Riding of Yorkshire
 * * `GB-ESX` - GBR-East Sussex
 * * `GB-EDH` - GBR-Edinburgh, City of
 * * `GB-ELS` - GBR-Eilean Siar
 * * `GB-ENF` - GBR-Enfield
 * * `GB-ENG` - GBR-England
 * * `GB-ESS` - GBR-Essex
 * * `GB-FAL` - GBR-Falkirk
 * * `GB-FMO` - GBR-Fermanagh and Omagh
 * * `GB-FIF` - GBR-Fife
 * * `GB-FLN` - GBR-Flintshire [Sir y Fflint GB-FFL]
 * * `GB-GAT` - GBR-Gateshead
 * * `GB-GLG` - GBR-Glasgow City
 * * `GB-GLS` - GBR-Gloucestershire
 * * `GB-GRE` - GBR-Greenwich
 * * `GB-GWN` - GBR-Gwynedd
 * * `GB-HCK` - GBR-Hackney
 * * `GB-HAL` - GBR-Halton
 * * `GB-HMF` - GBR-Hammersmith and Fulham
 * * `GB-HAM` - GBR-Hampshire
 * * `GB-HRY` - GBR-Haringey
 * * `GB-HRW` - GBR-Harrow
 * * `GB-HPL` - GBR-Hartlepool
 * * `GB-HAV` - GBR-Havering
 * * `GB-HEF` - GBR-Herefordshire
 * * `GB-HRT` - GBR-Hertfordshire
 * * `GB-HLD` - GBR-Highland
 * * `GB-HIL` - GBR-Hillingdon
 * * `GB-HNS` - GBR-Hounslow
 * * `GB-IVC` - GBR-Inverclyde
 * * `GB-AGY` - GBR-Isle of Anglesey [Sir Ynys Môn GB-YNM]
 * * `GB-IOW` - GBR-Isle of Wight
 * * `GB-IOS` - GBR-Isles of Scilly
 * * `GB-ISL` - GBR-Islington
 * * `GB-KEC` - GBR-Kensington and Chelsea
 * * `GB-KEN` - GBR-Kent
 * * `GB-KHL` - GBR-Kingston upon Hull
 * * `GB-KTT` - GBR-Kingston upon Thames
 * * `GB-KIR` - GBR-Kirklees
 * * `GB-KWL` - GBR-Knowsley
 * * `GB-LBH` - GBR-Lambeth
 * * `GB-LAN` - GBR-Lancashire
 * * `GB-LDS` - GBR-Leeds
 * * `GB-LCE` - GBR-Leicester
 * * `GB-LEC` - GBR-Leicestershire
 * * `GB-LEW` - GBR-Lewisham
 * * `GB-LIN` - GBR-Lincolnshire
 * * `GB-LBC` - GBR-Lisburn and Castlereagh
 * * `GB-LIV` - GBR-Liverpool
 * * `GB-LND` - GBR-London, City of
 * * `GB-LUT` - GBR-Luton
 * * `GB-MAN` - GBR-Manchester
 * * `GB-MDW` - GBR-Medway
 * * `GB-MTY` - GBR-Merthyr Tydfil [Merthyr Tudful GB-MTU]
 * * `GB-MRT` - GBR-Merton
 * * `GB-MEA` - GBR-Mid and East Antrim
 * * `GB-MUL` - GBR-Mid-Ulster
 * * `GB-MDB` - GBR-Middlesbrough
 * * `GB-MLN` - GBR-Midlothian
 * * `GB-MIK` - GBR-Milton Keynes
 * * `GB-MON` - GBR-Monmouthshire [Sir Fynwy GB-FYN]
 * * `GB-MRY` - GBR-Moray
 * * `GB-NTL` - GBR-Neath Port Talbot [Castell-nedd Port Talbot GB-CTL]
 * * `GB-NET` - GBR-Newcastle upon Tyne
 * * `GB-NWM` - GBR-Newham
 * * `GB-NWP` - GBR-Newport [Casnewydd GB-CNW]
 * * `GB-NMD` - GBR-Newry, Mourne and Down
 * * `GB-NFK` - GBR-Norfolk
 * * `GB-NAY` - GBR-North Ayrshire
 * * `GB-NEL` - GBR-North East Lincolnshire
 * * `GB-NLK` - GBR-North Lanarkshire
 * * `GB-NLN` - GBR-North Lincolnshire
 * * `GB-NNH` - GBR-North Northamptonshire
 * * `GB-NSM` - GBR-North Somerset
 * * `GB-NTY` - GBR-North Tyneside
 * * `GB-NYK` - GBR-North Yorkshire
 * * `GB-NIR` - GBR-Northern Ireland
 * * `GB-NBL` - GBR-Northumberland
 * * `GB-NGM` - GBR-Nottingham
 * * `GB-NTT` - GBR-Nottinghamshire
 * * `GB-OLD` - GBR-Oldham
 * * `GB-ORK` - GBR-Orkney Islands
 * * `GB-OXF` - GBR-Oxfordshire
 * * `GB-PEM` - GBR-Pembrokeshire [Sir Benfro GB-BNF]
 * * `GB-PKN` - GBR-Perth and Kinross
 * * `GB-PTE` - GBR-Peterborough
 * * `GB-PLY` - GBR-Plymouth
 * * `GB-POR` - GBR-Portsmouth
 * * `GB-POW` - GBR-Powys
 * * `GB-RDG` - GBR-Reading
 * * `GB-RDB` - GBR-Redbridge
 * * `GB-RCC` - GBR-Redcar and Cleveland
 * * `GB-RFW` - GBR-Renfrewshire
 * * `GB-RCT` - GBR-Rhondda Cynon Taff [Rhondda CynonTaf]
 * * `GB-RIC` - GBR-Richmond upon Thames
 * * `GB-RCH` - GBR-Rochdale
 * * `GB-ROT` - GBR-Rotherham
 * * `GB-RUT` - GBR-Rutland
 * * `GB-SLF` - GBR-Salford
 * * `GB-SAW` - GBR-Sandwell
 * * `GB-SCT` - GBR-Scotland
 * * `GB-SCB` - GBR-Scottish Borders
 * * `GB-SFT` - GBR-Sefton
 * * `GB-SHF` - GBR-Sheffield
 * * `GB-ZET` - GBR-Shetland Islands
 * * `GB-SHR` - GBR-Shropshire
 * * `GB-SLG` - GBR-Slough
 * * `GB-SOL` - GBR-Solihull
 * * `GB-SOM` - GBR-Somerset
 * * `GB-SAY` - GBR-South Ayrshire
 * * `GB-SGC` - GBR-South Gloucestershire
 * * `GB-SLK` - GBR-South Lanarkshire
 * * `GB-STY` - GBR-South Tyneside
 * * `GB-STH` - GBR-Southampton
 * * `GB-SOS` - GBR-Southend-on-Sea
 * * `GB-SWK` - GBR-Southwark
 * * `GB-SHN` - GBR-St. Helens
 * * `GB-STS` - GBR-Staffordshire
 * * `GB-STG` - GBR-Stirling
 * * `GB-SKP` - GBR-Stockport
 * * `GB-STT` - GBR-Stockton-on-Tees
 * * `GB-STE` - GBR-Stoke-on-Trent
 * * `GB-SFK` - GBR-Suffolk
 * * `GB-SND` - GBR-Sunderland
 * * `GB-SRY` - GBR-Surrey
 * * `GB-STN` - GBR-Sutton
 * * `GB-SWA` - GBR-Swansea [Abertawe GB-ATA]
 * * `GB-SWD` - GBR-Swindon
 * * `GB-TAM` - GBR-Tameside
 * * `GB-TFW` - GBR-Telford and Wrekin
 * * `GB-THR` - GBR-Thurrock
 * * `GB-TOB` - GBR-Torbay
 * * `GB-TOF` - GBR-Torfaen [Tor-faen]
 * * `GB-TWH` - GBR-Tower Hamlets
 * * `GB-TRF` - GBR-Trafford
 * * `GB-VGL` - GBR-Vale of Glamorgan, The [Bro Morgannwg GB-BMG]
 * * `GB-WKF` - GBR-Wakefield
 * * `GB-WLS` - GBR-Wales [Cymru GB-CYM]
 * * `GB-WLL` - GBR-Walsall
 * * `GB-WFT` - GBR-Waltham Forest
 * * `GB-WND` - GBR-Wandsworth
 * * `GB-WRT` - GBR-Warrington
 * * `GB-WAR` - GBR-Warwickshire
 * * `GB-WBK` - GBR-West Berkshire
 * * `GB-WDU` - GBR-West Dunbartonshire
 * * `GB-WLN` - GBR-West Lothian
 * * `GB-WNH` - GBR-West Northamptonshire
 * * `GB-WSX` - GBR-West Sussex
 * * `GB-WSM` - GBR-Westminster
 * * `GB-WGN` - GBR-Wigan
 * * `GB-WIL` - GBR-Wiltshire
 * * `GB-WNM` - GBR-Windsor and Maidenhead
 * * `GB-WRL` - GBR-Wirral
 * * `GB-WOK` - GBR-Wokingham
 * * `GB-WLV` - GBR-Wolverhampton
 * * `GB-WOR` - GBR-Worcestershire
 * * `GB-WRX` - GBR-Wrexham [Wrecsam GB-WRC]
 * * `GB-YOR` - GBR-York
 * * `GE-AB` - GEO-Abkhazia
 * * `GE-AJ` - GEO-Ajaria
 * * `GE-GU` - GEO-Guria
 * * `GE-IM` - GEO-Imereti
 * * `GE-KA` - GEO-K'akheti
 * * `GE-KK` - GEO-Kvemo Kartli
 * * `GE-MM` - GEO-Mtskheta-Mtianeti
 * * `GE-RL` - GEO-Rach'a-Lechkhumi-Kvemo Svaneti
 * * `GE-SZ` - GEO-Samegrelo-Zemo Svaneti
 * * `GE-SJ` - GEO-Samtskhe-Javakheti
 * * `GE-SK` - GEO-Shida Kartli
 * * `GE-TB` - GEO-Tbilisi
 * * `GH-AF` - GHA-Ahafo
 * * `GH-AH` - GHA-Ashanti
 * * `GH-BO` - GHA-Bono
 * * `GH-BE` - GHA-Bono East
 * * `GH-CP` - GHA-Central
 * * `GH-EP` - GHA-Eastern
 * * `GH-AA` - GHA-Greater Accra
 * * `GH-NE` - GHA-North East
 * * `GH-NP` - GHA-Northern
 * * `GH-OT` - GHA-Oti
 * * `GH-SV` - GHA-Savannah
 * * `GH-UE` - GHA-Upper East
 * * `GH-UW` - GHA-Upper West
 * * `GH-TV` - GHA-Volta
 * * `GH-WP` - GHA-Western
 * * `GH-WN` - GHA-Western North
 * * `GN-BE` - GIN-Beyla
 * * `GN-BF` - GIN-Boffa
 * * `GN-B` - GIN-Boké
 * * `GN-BK` - GIN-Boké
 * * `GN-C` - GIN-Conakry
 * * `GN-CO` - GIN-Coyah
 * * `GN-DB` - GIN-Dabola
 * * `GN-DL` - GIN-Dalaba
 * * `GN-DI` - GIN-Dinguiraye
 * * `GN-DU` - GIN-Dubréka
 * * `GN-F` - GIN-Faranah
 * * `GN-FA` - GIN-Faranah
 * * `GN-FO` - GIN-Forécariah
 * * `GN-FR` - GIN-Fria
 * * `GN-GA` - GIN-Gaoual
 * * `GN-GU` - GIN-Guékédou
 * * `GN-K` - GIN-Kankan
 * * `GN-KA` - GIN-Kankan
 * * `GN-D` - GIN-Kindia
 * * `GN-KD` - GIN-Kindia
 * * `GN-KS` - GIN-Kissidougou
 * * `GN-KB` - GIN-Koubia
 * * `GN-KN` - GIN-Koundara
 * * `GN-KO` - GIN-Kouroussa
 * * `GN-KE` - GIN-Kérouané
 * * `GN-L` - GIN-Labé
 * * `GN-LA` - GIN-Labé
 * * `GN-LO` - GIN-Lola
 * * `GN-LE` - GIN-Lélouma
 * * `GN-MC` - GIN-Macenta
 * * `GN-ML` - GIN-Mali
 * * `GN-M` - GIN-Mamou
 * * `GN-MM` - GIN-Mamou
 * * `GN-MD` - GIN-Mandiana
 * * `GN-N` - GIN-Nzérékoré
 * * `GN-NZ` - GIN-Nzérékoré
 * * `GN-PI` - GIN-Pita
 * * `GN-SI` - GIN-Siguiri
 * * `GN-TO` - GIN-Tougué
 * * `GN-TE` - GIN-Télimélé
 * * `GN-YO` - GIN-Yomou
 * * `GM-B` - GMB-Banjul
 * * `GM-M` - GMB-Central River
 * * `GM-L` - GMB-Lower River
 * * `GM-N` - GMB-North Bank
 * * `GM-U` - GMB-Upper River
 * * `GM-W` - GMB-Western
 * * `GW-BA` - GNB-Bafatá
 * * `GW-BM` - GNB-Biombo
 * * `GW-BS` - GNB-Bissau
 * * `GW-BL` - GNB-Bolama / Bijagós
 * * `GW-CA` - GNB-Cacheu
 * * `GW-GA` - GNB-Gabú
 * * `GW-L` - GNB-Leste
 * * `GW-N` - GNB-Norte
 * * `GW-OI` - GNB-Oio
 * * `GW-QU` - GNB-Quinara
 * * `GW-S` - GNB-Sul
 * * `GW-TO` - GNB-Tombali
 * * `GQ-AN` - GNQ-Annobon
 * * `GQ-BN` - GNQ-Bioko Nord
 * * `GQ-BS` - GNQ-Bioko Sud
 * * `GQ-CS` - GNQ-Centro Sud
 * * `GQ-DJ` - GNQ-Djibloho
 * * `GQ-KN` - GNQ-Kié-Ntem
 * * `GQ-LI` - GNQ-Littoral
 * * `GQ-C` - GNQ-Région Continentale
 * * `GQ-I` - GNQ-Région Insulaire
 * * `GQ-WN` - GNQ-Wele-Nzas
 * * `GR-A` - GRC-Anatolikí Makedonía kai Thráki
 * * `GR-I` - GRC-Attikí
 * * `GR-G` - GRC-Dytikí Elláda
 * * `GR-C` - GRC-Dytikí Makedonía
 * * `GR-F` - GRC-Ionía Nísia
 * * `GR-B` - GRC-Kentrikí Makedonía
 * * `GR-M` - GRC-Kríti
 * * `GR-L` - GRC-Nótio Aigaío
 * * `GR-J` - GRC-Pelopónnisos
 * * `GR-H` - GRC-Stereá Elláda
 * * `GR-E` - GRC-Thessalía
 * * `GR-K` - GRC-Vóreio Aigaío
 * * `GR-69` - GRC-Ágion Óros
 * * `GR-D` - GRC-Ípeiros
 * * `GD-01` - GRD-Saint Andrew
 * * `GD-02` - GRD-Saint David
 * * `GD-03` - GRD-Saint George
 * * `GD-04` - GRD-Saint John
 * * `GD-05` - GRD-Saint Mark
 * * `GD-06` - GRD-Saint Patrick
 * * `GD-10` - GRD-Southern Grenadine Islands
 * * `GL-AV` - GRL-Avannaata Kommunia
 * * `GL-KU` - GRL-Kommune Kujalleq
 * * `GL-QT` - GRL-Kommune Qeqertalik
 * * `GL-SM` - GRL-Kommuneqarfik Sermersooq
 * * `GL-QE` - GRL-Qeqqata Kommunia
 * * `GT-16` - GTM-Alta Verapaz
 * * `GT-15` - GTM-Baja Verapaz
 * * `GT-04` - GTM-Chimaltenango
 * * `GT-20` - GTM-Chiquimula
 * * `GT-02` - GTM-El Progreso
 * * `GT-05` - GTM-Escuintla
 * * `GT-01` - GTM-Guatemala
 * * `GT-13` - GTM-Huehuetenango
 * * `GT-18` - GTM-Izabal
 * * `GT-21` - GTM-Jalapa
 * * `GT-22` - GTM-Jutiapa
 * * `GT-17` - GTM-Petén
 * * `GT-09` - GTM-Quetzaltenango
 * * `GT-14` - GTM-Quiché
 * * `GT-11` - GTM-Retalhuleu
 * * `GT-03` - GTM-Sacatepéquez
 * * `GT-12` - GTM-San Marcos
 * * `GT-06` - GTM-Santa Rosa
 * * `GT-07` - GTM-Sololá
 * * `GT-10` - GTM-Suchitepéquez
 * * `GT-08` - GTM-Totonicapán
 * * `GT-19` - GTM-Zacapa
 * * `GY-BA` - GUY-Barima-Waini
 * * `GY-CU` - GUY-Cuyuni-Mazaruni
 * * `GY-DE` - GUY-Demerara-Mahaica
 * * `GY-EB` - GUY-East Berbice-Corentyne
 * * `GY-ES` - GUY-Essequibo Islands-West Demerara
 * * `GY-MA` - GUY-Mahaica-Berbice
 * * `GY-PM` - GUY-Pomeroon-Supenaam
 * * `GY-PT` - GUY-Potaro-Siparuni
 * * `GY-UD` - GUY-Upper Demerara-Berbice
 * * `GY-UT` - GUY-Upper Takutu-Upper Essequibo
 * * `HN-AT` - HND-Atlántida
 * * `HN-CH` - HND-Choluteca
 * * `HN-CL` - HND-Colón
 * * `HN-CM` - HND-Comayagua
 * * `HN-CP` - HND-Copán
 * * `HN-CR` - HND-Cortés
 * * `HN-EP` - HND-El Paraíso
 * * `HN-FM` - HND-Francisco Morazán
 * * `HN-GD` - HND-Gracias a Dios
 * * `HN-IN` - HND-Intibucá
 * * `HN-IB` - HND-Islas de la Bahía
 * * `HN-LP` - HND-La Paz
 * * `HN-LE` - HND-Lempira
 * * `HN-OC` - HND-Ocotepeque
 * * `HN-OL` - HND-Olancho
 * * `HN-SB` - HND-Santa Bárbara
 * * `HN-VA` - HND-Valle
 * * `HN-YO` - HND-Yoro
 * * `HR-07` - HRV-Bjelovarsko-bilogorska županija
 * * `HR-12` - HRV-Brodsko-posavska županija
 * * `HR-19` - HRV-Dubrovačko-neretvanska županija
 * * `HR-21` - HRV-Grad Zagreb
 * * `HR-18` - HRV-Istarska županija
 * * `HR-04` - HRV-Karlovačka županija
 * * `HR-06` - HRV-Koprivničko-križevačka županija
 * * `HR-02` - HRV-Krapinsko-zagorska županija
 * * `HR-09` - HRV-Ličko-senjska županija
 * * `HR-20` - HRV-Međimurska županija
 * * `HR-14` - HRV-Osječko-baranjska županija
 * * `HR-11` - HRV-Požeško-slavonska županija
 * * `HR-08` - HRV-Primorsko-goranska županija
 * * `HR-03` - HRV-Sisačko-moslavačka županija
 * * `HR-17` - HRV-Splitsko-dalmatinska županija
 * * `HR-05` - HRV-Varaždinska županija
 * * `HR-10` - HRV-Virovitičko-podravska županija
 * * `HR-16` - HRV-Vukovarsko-srijemska županija
 * * `HR-13` - HRV-Zadarska županija
 * * `HR-01` - HRV-Zagrebačka županija
 * * `HR-15` - HRV-Šibensko-kninska županija
 * * `HT-AR` - HTI-Artibonite
 * * `HT-CE` - HTI-Centre
 * * `HT-GA` - HTI-Grande’Anse
 * * `HT-NI` - HTI-Nippes
 * * `HT-ND` - HTI-Nord
 * * `HT-NE` - HTI-Nord-Est
 * * `HT-NO` - HTI-Nord-Ouest
 * * `HT-OU` - HTI-Ouest
 * * `HT-SD` - HTI-Sud
 * * `HT-SE` - HTI-Sud-Est
 * * `HU-BA` - HUN-Baranya
 * * `HU-BZ` - HUN-Borsod-Abaúj-Zemplén
 * * `HU-BU` - HUN-Budapest
 * * `HU-BK` - HUN-Bács-Kiskun
 * * `HU-BE` - HUN-Békés
 * * `HU-BC` - HUN-Békéscsaba
 * * `HU-CS` - HUN-Csongrád-Csanád
 * * `HU-DE` - HUN-Debrecen
 * * `HU-DU` - HUN-Dunaújváros
 * * `HU-EG` - HUN-Eger
 * * `HU-FE` - HUN-Fejér
 * * `HU-GY` - HUN-Győr
 * * `HU-GS` - HUN-Győr-Moson-Sopron
 * * `HU-HB` - HUN-Hajdú-Bihar
 * * `HU-HE` - HUN-Heves
 * * `HU-HV` - HUN-Hódmezővásárhely
 * * `HU-JN` - HUN-Jász-Nagykun-Szolnok
 * * `HU-KV` - HUN-Kaposvár
 * * `HU-KM` - HUN-Kecskemét
 * * `HU-KE` - HUN-Komárom-Esztergom
 * * `HU-MI` - HUN-Miskolc
 * * `HU-NK` - HUN-Nagykanizsa
 * * `HU-NY` - HUN-Nyíregyháza
 * * `HU-NO` - HUN-Nógrád
 * * `HU-PE` - HUN-Pest
 * * `HU-PS` - HUN-Pécs
 * * `HU-ST` - HUN-Salgótarján
 * * `HU-SO` - HUN-Somogy
 * * `HU-SN` - HUN-Sopron
 * * `HU-SZ` - HUN-Szabolcs-Szatmár-Bereg
 * * `HU-SD` - HUN-Szeged
 * * `HU-SS` - HUN-Szekszárd
 * * `HU-SK` - HUN-Szolnok
 * * `HU-SH` - HUN-Szombathely
 * * `HU-SF` - HUN-Székesfehérvár
 * * `HU-TB` - HUN-Tatabánya
 * * `HU-TO` - HUN-Tolna
 * * `HU-VA` - HUN-Vas
 * * `HU-VE` - HUN-Veszprém
 * * `HU-VM` - HUN-Veszprém
 * * `HU-ZA` - HUN-Zala
 * * `HU-ZE` - HUN-Zalaegerszeg
 * * `HU-ER` - HUN-Érd
 * * `ID-AC` - IDN-Aceh
 * * `ID-BA` - IDN-Bali
 * * `ID-BT` - IDN-Banten
 * * `ID-BE` - IDN-Bengkulu
 * * `ID-GO` - IDN-Gorontalo
 * * `ID-JK` - IDN-Jakarta Raya
 * * `ID-JA` - IDN-Jambi
 * * `ID-JW` - IDN-Jawa
 * * `ID-JB` - IDN-Jawa Barat
 * * `ID-JT` - IDN-Jawa Tengah
 * * `ID-JI` - IDN-Jawa Timur
 * * `ID-KA` - IDN-Kalimantan
 * * `ID-KB` - IDN-Kalimantan Barat
 * * `ID-KS` - IDN-Kalimantan Selatan
 * * `ID-KT` - IDN-Kalimantan Tengah
 * * `ID-KI` - IDN-Kalimantan Timur
 * * `ID-KU` - IDN-Kalimantan Utara
 * * `ID-BB` - IDN-Kepulauan Bangka Belitung
 * * `ID-KR` - IDN-Kepulauan Riau
 * * `ID-LA` - IDN-Lampung
 * * `ID-MA` - IDN-Maluku
 * * `ID-ML` - IDN-Maluku
 * * `ID-MU` - IDN-Maluku Utara
 * * `ID-NU` - IDN-Nusa Tenggara
 * * `ID-NB` - IDN-Nusa Tenggara Barat
 * * `ID-NT` - IDN-Nusa Tenggara Timur
 * * `ID-PA` - IDN-Papua
 * * `ID-PP` - IDN-Papua
 * * `ID-PB` - IDN-Papua Barat
 * * `ID-PD` - IDN-Papua Barat Daya
 * * `ID-PE` - IDN-Papua Pengunungan
 * * `ID-PS` - IDN-Papua Selatan
 * * `ID-PT` - IDN-Papua Tengah
 * * `ID-RI` - IDN-Riau
 * * `ID-SL` - IDN-Sulawesi
 * * `ID-SR` - IDN-Sulawesi Barat
 * * `ID-SN` - IDN-Sulawesi Selatan
 * * `ID-ST` - IDN-Sulawesi Tengah
 * * `ID-SG` - IDN-Sulawesi Tenggara
 * * `ID-SA` - IDN-Sulawesi Utara
 * * `ID-SM` - IDN-Sumatera
 * * `ID-SB` - IDN-Sumatera Barat
 * * `ID-SS` - IDN-Sumatera Selatan
 * * `ID-SU` - IDN-Sumatera Utara
 * * `ID-YO` - IDN-Yogyakarta
 * * `IN-AN` - IND-Andaman and Nicobar Islands
 * * `IN-AP` - IND-Andhra Pradesh
 * * `IN-AR` - IND-Arunāchal Pradesh
 * * `IN-AS` - IND-Assam
 * * `IN-BR` - IND-Bihār
 * * `IN-CH` - IND-Chandīgarh
 * * `IN-CG` - IND-Chhattīsgarh
 * * `IN-DL` - IND-Delhi
 * * `IN-DH` - IND-Dādra and Nagar Haveli and Damān and Diu
 * * `IN-GA` - IND-Goa
 * * `IN-GJ` - IND-Gujarāt
 * * `IN-HR` - IND-Haryāna
 * * `IN-HP` - IND-Himāchal Pradesh
 * * `IN-JK` - IND-Jammu and Kashmīr
 * * `IN-JH` - IND-Jhārkhand
 * * `IN-KA` - IND-Karnātaka
 * * `IN-KL` - IND-Kerala
 * * `IN-LA` - IND-Ladākh
 * * `IN-LD` - IND-Lakshadweep
 * * `IN-MP` - IND-Madhya Pradesh
 * * `IN-MH` - IND-Mahārāshtra
 * * `IN-MN` - IND-Manipur
 * * `IN-ML` - IND-Meghālaya
 * * `IN-MZ` - IND-Mizoram
 * * `IN-NL` - IND-Nāgāland
 * * `IN-OD` - IND-Odisha
 * * `IN-PY` - IND-Puducherry
 * * `IN-PB` - IND-Punjab
 * * `IN-RJ` - IND-Rājasthān
 * * `IN-SK` - IND-Sikkim
 * * `IN-TN` - IND-Tamil Nādu
 * * `IN-TS` - IND-Telangāna
 * * `IN-TR` - IND-Tripura
 * * `IN-UP` - IND-Uttar Pradesh
 * * `IN-UK` - IND-Uttarākhand
 * * `IN-WB` - IND-West Bengal
 * * `IE-CW` - IRL-Carlow
 * * `IE-CN` - IRL-Cavan
 * * `IE-CE` - IRL-Clare
 * * `IE-C` - IRL-Connaught
 * * `IE-CO` - IRL-Cork
 * * `IE-DL` - IRL-Donegal
 * * `IE-D` - IRL-Dublin
 * * `IE-G` - IRL-Galway
 * * `IE-KY` - IRL-Kerry
 * * `IE-KE` - IRL-Kildare
 * * `IE-KK` - IRL-Kilkenny
 * * `IE-LS` - IRL-Laois
 * * `IE-L` - IRL-Leinster
 * * `IE-LM` - IRL-Leitrim
 * * `IE-LK` - IRL-Limerick
 * * `IE-LD` - IRL-Longford
 * * `IE-LH` - IRL-Louth
 * * `IE-MO` - IRL-Mayo
 * * `IE-MH` - IRL-Meath
 * * `IE-MN` - IRL-Monaghan
 * * `IE-M` - IRL-Munster
 * * `IE-OY` - IRL-Offaly
 * * `IE-RN` - IRL-Roscommon
 * * `IE-SO` - IRL-Sligo
 * * `IE-TA` - IRL-Tipperary
 * * `IE-U` - IRL-Ulster
 * * `IE-WD` - IRL-Waterford
 * * `IE-WH` - IRL-Westmeath
 * * `IE-WX` - IRL-Wexford
 * * `IE-WW` - IRL-Wicklow
 * * `IR-30` - IRN-Alborz
 * * `IR-24` - IRN-Ardabīl
 * * `IR-18` - IRN-Būshehr
 * * `IR-14` - IRN-Chahār Maḩāl va Bakhtīārī
 * * `IR-10` - IRN-Eşfahān
 * * `IR-07` - IRN-Fārs
 * * `IR-27` - IRN-Golestān
 * * `IR-01` - IRN-Gīlān
 * * `IR-13` - IRN-Hamadān
 * * `IR-22` - IRN-Hormozgān
 * * `IR-08` - IRN-Kermān
 * * `IR-05` - IRN-Kermānshāh
 * * `IR-29` - IRN-Khorāsān-e Jonūbī
 * * `IR-09` - IRN-Khorāsān-e Raẕavī
 * * `IR-28` - IRN-Khorāsān-e Shomālī
 * * `IR-06` - IRN-Khūzestān
 * * `IR-17` - IRN-Kohgīlūyeh va Bowyer Aḩmad
 * * `IR-12` - IRN-Kordestān
 * * `IR-15` - IRN-Lorestān
 * * `IR-00` - IRN-Markazī
 * * `IR-02` - IRN-Māzandarān
 * * `IR-26` - IRN-Qazvīn
 * * `IR-25` - IRN-Qom
 * * `IR-20` - IRN-Semnān
 * * `IR-11` - IRN-Sīstān va Balūchestān
 * * `IR-23` - IRN-Tehrān
 * * `IR-21` - IRN-Yazd
 * * `IR-19` - IRN-Zanjān
 * * `IR-04` - IRN-Āz̄ārbāyjān-e Ghārbī
 * * `IR-03` - IRN-Āz̄ārbāyjān-e Shārqī
 * * `IR-16` - IRN-Īlām
 * * `IQ-AN` - IRQ-Al Anbār
 * * `IQ-BA` - IRQ-Al Başrah
 * * `IQ-MU` - IRQ-Al Muthanná
 * * `IQ-QA` - IRQ-Al Qādisīyah
 * * `IQ-NA` - IRQ-An Najaf
 * * `IQ-AR` - IRQ-Arbīl
 * * `IQ-SU` - IRQ-As Sulaymānīyah
 * * `IQ-BG` - IRQ-Baghdād
 * * `IQ-BB` - IRQ-Bābil
 * * `IQ-DA` - IRQ-Dahūk
 * * `IQ-DQ` - IRQ-Dhī Qār
 * * `IQ-DI` - IRQ-Diyālá
 * * `IQ-KR` - IRQ-Herêm-î Kurdistan
 * * `IQ-KA` - IRQ-Karbalā’
 * * `IQ-KI` - IRQ-Kirkūk
 * * `IQ-MA` - IRQ-Maysān
 * * `IQ-NI` - IRQ-Nīnawá
 * * `IQ-WA` - IRQ-Wāsiţ
 * * `IQ-SD` - IRQ-Şalāḩ ad Dīn
 * * `IS-AKN` - ISL-Akraneskaupstaður
 * * `IS-AKU` - ISL-Akureyrarbær
 * * `IS-7` - ISL-Austurland
 * * `IS-BLA` - ISL-Bláskógabyggð
 * * `IS-BOL` - ISL-Bolungarvíkurkaupstaður
 * * `IS-BOG` - ISL-Borgarbyggð
 * * `IS-DAB` - ISL-Dalabyggð
 * * `IS-DAV` - ISL-Dalvíkurbyggð
 * * `IS-EOM` - ISL-Eyja- og Miklaholtshreppur
 * * `IS-EYF` - ISL-Eyjafjarðarsveit
 * * `IS-FJL` - ISL-Fjallabyggð
 * * `IS-FJD` - ISL-Fjarðabyggð
 * * `IS-FLR` - ISL-Fljótsdalshreppur
 * * `IS-FLA` - ISL-Flóahreppur
 * * `IS-GAR` - ISL-Garðabær
 * * `IS-GRN` - ISL-Grindavíkurbær
 * * `IS-GRU` - ISL-Grundarfjarðarbær
 * * `IS-GOG` - ISL-Grímsnes- og Grafningshreppur
 * * `IS-GRY` - ISL-Grýtubakkahreppur
 * * `IS-HAF` - ISL-Hafnarfjarðarkaupstaður
 * * `IS-HRU` - ISL-Hrunamannahreppur
 * * `IS-HVA` - ISL-Hvalfjarðarsveit
 * * `IS-HVE` - ISL-Hveragerðisbær
 * * `IS-1` - ISL-Höfuðborgarsvæði
 * * `IS-HRG` - ISL-Hörgársveit
 * * `IS-HUG` - ISL-Húnabyggð
 * * `IS-HUV` - ISL-Húnaþing vestra
 * * `IS-KAL` - ISL-Kaldrananeshreppur
 * * `IS-KJO` - ISL-Kjósarhreppur
 * * `IS-KOP` - ISL-Kópavogsbær
 * * `IS-LAN` - ISL-Langanesbyggð
 * * `IS-MOS` - ISL-Mosfellsbær
 * * `IS-MUL` - ISL-Múlaþing
 * * `IS-MYR` - ISL-Mýrdalshreppur
 * * `IS-6` - ISL-Norðurland eystra
 * * `IS-5` - ISL-Norðurland vestra
 * * `IS-NOR` - ISL-Norðurþing
 * * `IS-RGE` - ISL-Rangárþing eystra
 * * `IS-RGY` - ISL-Rangárþing ytra
 * * `IS-RHH` - ISL-Reykhólahreppur
 * * `IS-RKN` - ISL-Reykjanesbær
 * * `IS-RKV` - ISL-Reykjavíkurborg
 * * `IS-SEL` - ISL-Seltjarnarnesbær
 * * `IS-SKF` - ISL-Skaftárhreppur
 * * `IS-SKG` - ISL-Skagabyggð
 * * `IS-SKR` - ISL-Skagafjörður
 * * `IS-SOG` - ISL-Skeiða- og Gnúpverjahreppur
 * * `IS-SKO` - ISL-Skorradalshreppur
 * * `IS-SNF` - ISL-Snæfellsbær
 * * `IS-STR` - ISL-Strandabyggð
 * * `IS-STY` - ISL-Stykkishólmsbær
 * * `IS-8` - ISL-Suðurland
 * * `IS-2` - ISL-Suðurnes
 * * `IS-SDN` - ISL-Suðurnesjabær
 * * `IS-SBT` - ISL-Svalbarðsstrandarhreppur
 * * `IS-SHF` - ISL-Sveitarfélagið Hornafjörður
 * * `IS-SSS` - ISL-Sveitarfélagið Skagaströnd
 * * `IS-SVG` - ISL-Sveitarfélagið Vogar
 * * `IS-SFA` - ISL-Sveitarfélagið Árborg
 * * `IS-SOL` - ISL-Sveitarfélagið Ölfus
 * * `IS-SDV` - ISL-Súðavíkurhreppur
 * * `IS-TJO` - ISL-Tjörneshreppur
 * * `IS-TAL` - ISL-Tálknafjarðarhreppur
 * * `IS-4` - ISL-Vestfirðir
 * * `IS-VEM` - ISL-Vestmannaeyjabær
 * * `IS-VER` - ISL-Vesturbyggð
 * * `IS-3` - ISL-Vesturland
 * * `IS-VOP` - ISL-Vopnafjarðarhreppur
 * * `IS-ARN` - ISL-Árneshreppur
 * * `IS-ASA` - ISL-Ásahreppur
 * * `IS-ISA` - ISL-Ísafjarðarbær
 * * `IS-THG` - ISL-Þingeyjarsveit
 * * `IL-M` - ISR-Al Awsaţ
 * * `IL-D` - ISR-Al Janūbī
 * * `IL-JM` - ISR-Al Quds
 * * `IL-Z` - ISR-Ash Shamālī
 * * `IL-HA` - ISR-H̱efa
 * * `IL-TA` - ISR-Tall Abīb
 * * `IT-65` - ITA-Abruzzo
 * * `IT-AG` - ITA-Agrigento
 * * `IT-AL` - ITA-Alessandria
 * * `IT-AN` - ITA-Ancona
 * * `IT-AR` - ITA-Arezzo
 * * `IT-AP` - ITA-Ascoli Piceno
 * * `IT-AT` - ITA-Asti
 * * `IT-AV` - ITA-Avellino
 * * `IT-BA` - ITA-Bari
 * * `IT-BT` - ITA-Barletta-Andria-Trani
 * * `IT-77` - ITA-Basilicata
 * * `IT-BL` - ITA-Belluno
 * * `IT-BN` - ITA-Benevento
 * * `IT-BG` - ITA-Bergamo
 * * `IT-BI` - ITA-Biella
 * * `IT-BO` - ITA-Bologna
 * * `IT-BZ` - ITA-Bolzano
 * * `IT-BS` - ITA-Brescia
 * * `IT-BR` - ITA-Brindisi
 * * `IT-CA` - ITA-Cagliari
 * * `IT-78` - ITA-Calabria
 * * `IT-CL` - ITA-Caltanissetta
 * * `IT-72` - ITA-Campania
 * * `IT-CB` - ITA-Campobasso
 * * `IT-CE` - ITA-Caserta
 * * `IT-CT` - ITA-Catania
 * * `IT-CZ` - ITA-Catanzaro
 * * `IT-CH` - ITA-Chieti
 * * `IT-CO` - ITA-Como
 * * `IT-CS` - ITA-Cosenza
 * * `IT-CR` - ITA-Cremona
 * * `IT-KR` - ITA-Crotone
 * * `IT-CN` - ITA-Cuneo
 * * `IT-45` - ITA-Emilia-Romagna
 * * `IT-EN` - ITA-Enna
 * * `IT-FM` - ITA-Fermo
 * * `IT-FE` - ITA-Ferrara
 * * `IT-FI` - ITA-Firenze
 * * `IT-FG` - ITA-Foggia
 * * `IT-FC` - ITA-Forlì-Cesena
 * * `IT-36` - ITA-Friuli Venezia Giulia
 * * `IT-FR` - ITA-Frosinone
 * * `IT-GE` - ITA-Genova
 * * `IT-GO` - ITA-Gorizia
 * * `IT-GR` - ITA-Grosseto
 * * `IT-IM` - ITA-Imperia
 * * `IT-IS` - ITA-Isernia
 * * `IT-AQ` - ITA-L'Aquila
 * * `IT-SP` - ITA-La Spezia
 * * `IT-LT` - ITA-Latina
 * * `IT-62` - ITA-Lazio
 * * `IT-LE` - ITA-Lecce
 * * `IT-LC` - ITA-Lecco
 * * `IT-42` - ITA-Liguria
 * * `IT-LI` - ITA-Livorno
 * * `IT-LO` - ITA-Lodi
 * * `IT-25` - ITA-Lombardia
 * * `IT-LU` - ITA-Lucca
 * * `IT-MC` - ITA-Macerata
 * * `IT-MN` - ITA-Mantova
 * * `IT-57` - ITA-Marche
 * * `IT-MS` - ITA-Massa-Carrara
 * * `IT-MT` - ITA-Matera
 * * `IT-ME` - ITA-Messina
 * * `IT-MI` - ITA-Milano
 * * `IT-MO` - ITA-Modena
 * * `IT-67` - ITA-Molise
 * * `IT-MB` - ITA-Monza e Brianza
 * * `IT-NA` - ITA-Napoli
 * * `IT-NO` - ITA-Novara
 * * `IT-NU` - ITA-Nuoro
 * * `IT-OR` - ITA-Oristano
 * * `IT-PD` - ITA-Padova
 * * `IT-PA` - ITA-Palermo
 * * `IT-PR` - ITA-Parma
 * * `IT-PV` - ITA-Pavia
 * * `IT-PG` - ITA-Perugia
 * * `IT-PU` - ITA-Pesaro e Urbino
 * * `IT-PE` - ITA-Pescara
 * * `IT-PC` - ITA-Piacenza
 * * `IT-21` - ITA-Piemonte
 * * `IT-PI` - ITA-Pisa
 * * `IT-PT` - ITA-Pistoia
 * * `IT-PN` - ITA-Pordenone
 * * `IT-PZ` - ITA-Potenza
 * * `IT-PO` - ITA-Prato
 * * `IT-75` - ITA-Puglia
 * * `IT-RG` - ITA-Ragusa
 * * `IT-RA` - ITA-Ravenna
 * * `IT-RC` - ITA-Reggio Calabria
 * * `IT-RE` - ITA-Reggio Emilia
 * * `IT-RI` - ITA-Rieti
 * * `IT-RN` - ITA-Rimini
 * * `IT-RM` - ITA-Roma
 * * `IT-RO` - ITA-Rovigo
 * * `IT-SA` - ITA-Salerno
 * * `IT-88` - ITA-Sardegna
 * * `IT-SS` - ITA-Sassari
 * * `IT-SV` - ITA-Savona
 * * `IT-82` - ITA-Sicilia
 * * `IT-SI` - ITA-Siena
 * * `IT-SR` - ITA-Siracusa
 * * `IT-SO` - ITA-Sondrio
 * * `IT-SU` - ITA-Sud Sardegna
 * * `IT-TA` - ITA-Taranto
 * * `IT-TE` - ITA-Teramo
 * * `IT-TR` - ITA-Terni
 * * `IT-TO` - ITA-Torino
 * * `IT-52` - ITA-Toscana
 * * `IT-TP` - ITA-Trapani
 * * `IT-32` - ITA-Trentino-Alto Adige
 * * `IT-TN` - ITA-Trento
 * * `IT-TV` - ITA-Treviso
 * * `IT-TS` - ITA-Trieste
 * * `IT-UD` - ITA-Udine
 * * `IT-55` - ITA-Umbria
 * * `IT-23` - ITA-Val d'Aoste
 * * `IT-VA` - ITA-Varese
 * * `IT-34` - ITA-Veneto
 * * `IT-VE` - ITA-Venezia
 * * `IT-VB` - ITA-Verbano-Cusio-Ossola
 * * `IT-VC` - ITA-Vercelli
 * * `IT-VR` - ITA-Verona
 * * `IT-VV` - ITA-Vibo Valentia
 * * `IT-VI` - ITA-Vicenza
 * * `IT-VT` - ITA-Viterbo
 * * `JM-13` - JAM-Clarendon
 * * `JM-09` - JAM-Hanover
 * * `JM-01` - JAM-Kingston
 * * `JM-12` - JAM-Manchester
 * * `JM-04` - JAM-Portland
 * * `JM-02` - JAM-Saint Andrew
 * * `JM-06` - JAM-Saint Ann
 * * `JM-14` - JAM-Saint Catherine
 * * `JM-11` - JAM-Saint Elizabeth
 * * `JM-08` - JAM-Saint James
 * * `JM-05` - JAM-Saint Mary
 * * `JM-03` - JAM-Saint Thomas
 * * `JM-07` - JAM-Trelawny
 * * `JM-10` - JAM-Westmoreland
 * * `JO-BA` - JOR-Al Balqā’
 * * `JO-KA` - JOR-Al Karak
 * * `JO-MA` - JOR-Al Mafraq
 * * `JO-AQ` - JOR-Al ‘Aqabah
 * * `JO-AM` - JOR-Al ‘A̅şimah
 * * `JO-AZ` - JOR-Az Zarqā’
 * * `JO-AT` - JOR-Aţ Ţafīlah
 * * `JO-IR` - JOR-Irbid
 * * `JO-JA` - JOR-Jarash
 * * `JO-MN` - JOR-Ma‘ān
 * * `JO-MD` - JOR-Mādabā
 * * `JO-AJ` - JOR-‘Ajlūn
 * * `JP-23` - JPN-Aichi
 * * `JP-05` - JPN-Akita
 * * `JP-02` - JPN-Aomori
 * * `JP-12` - JPN-Chiba
 * * `JP-38` - JPN-Ehime
 * * `JP-18` - JPN-Fukui
 * * `JP-40` - JPN-Fukuoka
 * * `JP-07` - JPN-Fukushima
 * * `JP-21` - JPN-Gifu
 * * `JP-10` - JPN-Gunma
 * * `JP-34` - JPN-Hiroshima
 * * `JP-01` - JPN-Hokkaido
 * * `JP-28` - JPN-Hyogo
 * * `JP-08` - JPN-Ibaraki
 * * `JP-17` - JPN-Ishikawa
 * * `JP-03` - JPN-Iwate
 * * `JP-37` - JPN-Kagawa
 * * `JP-46` - JPN-Kagoshima
 * * `JP-14` - JPN-Kanagawa
 * * `JP-39` - JPN-Kochi
 * * `JP-43` - JPN-Kumamoto
 * * `JP-26` - JPN-Kyoto
 * * `JP-24` - JPN-Mie
 * * `JP-04` - JPN-Miyagi
 * * `JP-45` - JPN-Miyazaki
 * * `JP-20` - JPN-Nagano
 * * `JP-42` - JPN-Nagasaki
 * * `JP-29` - JPN-Nara
 * * `JP-15` - JPN-Niigata
 * * `JP-44` - JPN-Oita
 * * `JP-33` - JPN-Okayama
 * * `JP-47` - JPN-Okinawa
 * * `JP-27` - JPN-Osaka
 * * `JP-41` - JPN-Saga
 * * `JP-11` - JPN-Saitama
 * * `JP-25` - JPN-Shiga
 * * `JP-32` - JPN-Shimane
 * * `JP-22` - JPN-Shizuoka
 * * `JP-09` - JPN-Tochigi
 * * `JP-36` - JPN-Tokushima
 * * `JP-13` - JPN-Tokyo
 * * `JP-31` - JPN-Tottori
 * * `JP-16` - JPN-Toyama
 * * `JP-30` - JPN-Wakayama
 * * `JP-06` - JPN-Yamagata
 * * `JP-35` - JPN-Yamaguchi
 * * `JP-19` - JPN-Yamanashi
 * * `KZ-10` - KAZ-Abajskaja oblast’
 * * `KZ-11` - KAZ-Akmolinskaja oblast'
 * * `KZ-15` - KAZ-Aktjubinskaja oblast'
 * * `KZ-19` - KAZ-Almatinskaja oblast'
 * * `KZ-75` - KAZ-Almaty
 * * `KZ-71` - KAZ-Astana
 * * `KZ-23` - KAZ-Atyrauskaja oblast'
 * * `KZ-27` - KAZ-Batys Qazaqstan oblysy
 * * `KZ-35` - KAZ-Karagandinskaja oblast'
 * * `KZ-39` - KAZ-Kostanajskaja oblast'
 * * `KZ-43` - KAZ-Kyzylordinskaja oblast'
 * * `KZ-47` - KAZ-Mangghystaū oblysy
 * * `KZ-55` - KAZ-Pavlodar oblysy
 * * `KZ-59` - KAZ-Severo-Kazahstanskaja oblast'
 * * `KZ-63` - KAZ-Shyghys Qazaqstan oblysy
 * * `KZ-79` - KAZ-Shymkent
 * * `KZ-61` - KAZ-Turkestankaya oblast'
 * * `KZ-62` - KAZ-Ulytauskaja oblast’
 * * `KZ-31` - KAZ-Zhambyl oblysy
 * * `KZ-33` - KAZ-Zhetisū oblysy
 * * `KE-01` - KEN-Baringo
 * * `KE-02` - KEN-Bomet
 * * `KE-03` - KEN-Bungoma
 * * `KE-04` - KEN-Busia
 * * `KE-05` - KEN-Elgeyo/Marakwet
 * * `KE-06` - KEN-Embu
 * * `KE-07` - KEN-Garissa
 * * `KE-08` - KEN-Homa Bay
 * * `KE-09` - KEN-Isiolo
 * * `KE-10` - KEN-Kajiado
 * * `KE-11` - KEN-Kakamega
 * * `KE-12` - KEN-Kericho
 * * `KE-13` - KEN-Kiambu
 * * `KE-14` - KEN-Kilifi
 * * `KE-15` - KEN-Kirinyaga
 * * `KE-16` - KEN-Kisii
 * * `KE-17` - KEN-Kisumu
 * * `KE-18` - KEN-Kitui
 * * `KE-19` - KEN-Kwale
 * * `KE-20` - KEN-Laikipia
 * * `KE-21` - KEN-Lamu
 * * `KE-22` - KEN-Machakos
 * * `KE-23` - KEN-Makueni
 * * `KE-24` - KEN-Mandera
 * * `KE-25` - KEN-Marsabit
 * * `KE-26` - KEN-Meru
 * * `KE-27` - KEN-Migori
 * * `KE-28` - KEN-Mombasa
 * * `KE-29` - KEN-Murang'a
 * * `KE-30` - KEN-Nairobi City
 * * `KE-31` - KEN-Nakuru
 * * `KE-32` - KEN-Nandi
 * * `KE-33` - KEN-Narok
 * * `KE-34` - KEN-Nyamira
 * * `KE-35` - KEN-Nyandarua
 * * `KE-36` - KEN-Nyeri
 * * `KE-37` - KEN-Samburu
 * * `KE-38` - KEN-Siaya
 * * `KE-39` - KEN-Taita/Taveta
 * * `KE-40` - KEN-Tana River
 * * `KE-41` - KEN-Tharaka-Nithi
 * * `KE-42` - KEN-Trans Nzoia
 * * `KE-43` - KEN-Turkana
 * * `KE-44` - KEN-Uasin Gishu
 * * `KE-45` - KEN-Vihiga
 * * `KE-46` - KEN-Wajir
 * * `KE-47` - KEN-West Pokot
 * * `KG-B` - KGZ-Batken
 * * `KG-GB` - KGZ-Bishkek Shaary
 * * `KG-C` - KGZ-Chuyskaya oblast'
 * * `KG-J` - KGZ-Dzhalal-Abadskaya oblast'
 * * `KG-GO` - KGZ-Gorod Osh
 * * `KG-Y` - KGZ-Issyk-Kul'skaja oblast'
 * * `KG-N` - KGZ-Naryn
 * * `KG-O` - KGZ-Osh
 * * `KG-T` - KGZ-Talas
 * * `KH-2` - KHM-Baat Dambang
 * * `KH-1` - KHM-Banteay Mean Choăy
 * * `KH-23` - KHM-Kaeb
 * * `KH-3` - KHM-Kampong Chaam
 * * `KH-4` - KHM-Kampong Chhnang
 * * `KH-5` - KHM-Kampong Spueu
 * * `KH-6` - KHM-Kampong Thum
 * * `KH-7` - KHM-Kampot
 * * `KH-8` - KHM-Kandaal
 * * `KH-9` - KHM-Kaoh Kong
 * * `KH-10` - KHM-Kracheh
 * * `KH-11` - KHM-Mondol Kiri
 * * `KH-22` - KHM-Otdar Mean Chey
 * * `KH-24` - KHM-Pailin
 * * `KH-12` - KHM-Phnom Penh
 * * `KH-15` - KHM-Pousaat
 * * `KH-18` - KHM-Preah Sihanouk
 * * `KH-13` - KHM-Preah Vihear
 * * `KH-14` - KHM-Prey Veaeng
 * * `KH-16` - KHM-Rotanak Kiri
 * * `KH-17` - KHM-Siem Reab
 * * `KH-19` - KHM-Stoĕng Trêng
 * * `KH-20` - KHM-Svaay Rieng
 * * `KH-21` - KHM-Taakaev
 * * `KH-25` - KHM-Tbong Khmum
 * * `KI-G` - KIR-Gilbert Islands
 * * `KI-L` - KIR-Line Islands
 * * `KI-P` - KIR-Phoenix Islands
 * * `KN-01` - KNA-Christ Church Nichola Town
 * * `KN-N` - KNA-Nevis
 * * `KN-02` - KNA-Saint Anne Sandy Point
 * * `KN-03` - KNA-Saint George Basseterre
 * * `KN-04` - KNA-Saint George Gingerland
 * * `KN-05` - KNA-Saint James Windward
 * * `KN-06` - KNA-Saint John Capisterre
 * * `KN-07` - KNA-Saint John Figtree
 * * `KN-K` - KNA-Saint Kitts
 * * `KN-08` - KNA-Saint Mary Cayon
 * * `KN-09` - KNA-Saint Paul Capisterre
 * * `KN-10` - KNA-Saint Paul Charlestown
 * * `KN-11` - KNA-Saint Peter Basseterre
 * * `KN-12` - KNA-Saint Thomas Lowland
 * * `KN-13` - KNA-Saint Thomas Middle Island
 * * `KN-15` - KNA-Trinity Palmetto Point
 * * `KR-26` - KOR-Busan-gwangyeoksi
 * * `KR-43` - KOR-Chungcheongbuk-do
 * * `KR-44` - KOR-Chungcheongnam-do
 * * `KR-27` - KOR-Daegu-gwangyeoksi
 * * `KR-30` - KOR-Daejeon-gwangyeoksi
 * * `KR-42` - KOR-Gangwon-teukbyeoljachido
 * * `KR-29` - KOR-Gwangju-gwangyeoksi
 * * `KR-41` - KOR-Gyeonggi-do
 * * `KR-47` - KOR-Gyeongsangbuk-do
 * * `KR-48` - KOR-Gyeongsangnam-do
 * * `KR-28` - KOR-Incheon-gwangyeoksi
 * * `KR-49` - KOR-Jeju-teukbyeoljachido
 * * `KR-45` - KOR-Jeollabuk-do
 * * `KR-46` - KOR-Jeollanam-do
 * * `KR-50` - KOR-Sejong
 * * `KR-11` - KOR-Seoul-teukbyeolsi
 * * `KR-31` - KOR-Ulsan-gwangyeoksi
 * * `KW-AH` - KWT-Al Aḩmadī
 * * `KW-FA` - KWT-Al Farwānīyah
 * * `KW-JA` - KWT-Al Jahrā’
 * * `KW-KU` - KWT-Al ‘Āşimah
 * * `KW-MU` - KWT-Mubārak al Kabīr
 * * `KW-HA` - KWT-Ḩawallī
 * * `LA-AT` - LAO-Attapu
 * * `LA-BK` - LAO-Bokèo
 * * `LA-BL` - LAO-Bolikhamxai
 * * `LA-CH` - LAO-Champasak
 * * `LA-HO` - LAO-Houaphan
 * * `LA-KH` - LAO-Khammouan
 * * `LA-LM` - LAO-Louang Namtha
 * * `LA-LP` - LAO-Louangphabang
 * * `LA-OU` - LAO-Oudômxai
 * * `LA-PH` - LAO-Phôngsali
 * * `LA-SL` - LAO-Salavan
 * * `LA-SV` - LAO-Savannakhét
 * * `LA-VI` - LAO-Viangchan
 * * `LA-VT` - LAO-Viangchan
 * * `LA-XA` - LAO-Xaignabouli
 * * `LA-XS` - LAO-Xaisômboun
 * * `LA-XI` - LAO-Xiangkhouang
 * * `LA-XE` - LAO-Xékong
 * * `LB-AK` - LBN-Aakkâr
 * * `LB-BI` - LBN-Al Biqā‘
 * * `LB-JA` - LBN-Al Janūb
 * * `LB-NA` - LBN-An Nabaţīyah
 * * `LB-AS` - LBN-Ash Shimāl
 * * `LB-BH` - LBN-Baalbek-Hermel
 * * `LB-BA` - LBN-Bayrūt
 * * `LB-JL` - LBN-Jabal Lubnān
 * * `LR-BM` - LBR-Bomi
 * * `LR-BG` - LBR-Bong
 * * `LR-GP` - LBR-Gbarpolu
 * * `LR-GB` - LBR-Grand Bassa
 * * `LR-CM` - LBR-Grand Cape Mount
 * * `LR-GG` - LBR-Grand Gedeh
 * * `LR-GK` - LBR-Grand Kru
 * * `LR-LO` - LBR-Lofa
 * * `LR-MG` - LBR-Margibi
 * * `LR-MY` - LBR-Maryland
 * * `LR-MO` - LBR-Montserrado
 * * `LR-NI` - LBR-Nimba
 * * `LR-RI` - LBR-River Cess
 * * `LR-RG` - LBR-River Gee
 * * `LR-SI` - LBR-Sinoe
 * * `LY-BU` - LBY-Al Buţnān
 * * `LY-JA` - LBY-Al Jabal al Akhḑar
 * * `LY-JG` - LBY-Al Jabal al Gharbī
 * * `LY-JI` - LBY-Al Jafārah
 * * `LY-JU` - LBY-Al Jufrah
 * * `LY-KF` - LBY-Al Kufrah
 * * `LY-MJ` - LBY-Al Marj
 * * `LY-MB` - LBY-Al Marqab
 * * `LY-WA` - LBY-Al Wāḩāt
 * * `LY-NQ` - LBY-An Nuqāţ al Khams
 * * `LY-ZA` - LBY-Az Zāwiyah
 * * `LY-BA` - LBY-Banghāzī
 * * `LY-DR` - LBY-Darnah
 * * `LY-GT` - LBY-Ghāt
 * * `LY-MI` - LBY-Mişrātah
 * * `LY-MQ` - LBY-Murzuq
 * * `LY-NL` - LBY-Nālūt
 * * `LY-SB` - LBY-Sabhā
 * * `LY-SR` - LBY-Surt
 * * `LY-WD` - LBY-Wādī al Ḩayāt
 * * `LY-WS` - LBY-Wādī ash Shāţi’
 * * `LY-TB` - LBY-Ţarābulus
 * * `LC-01` - LCA-Anse la Raye
 * * `LC-12` - LCA-Canaries
 * * `LC-02` - LCA-Castries
 * * `LC-03` - LCA-Choiseul
 * * `LC-05` - LCA-Dennery
 * * `LC-06` - LCA-Gros Islet
 * * `LC-07` - LCA-Laborie
 * * `LC-08` - LCA-Micoud
 * * `LC-10` - LCA-Soufrière
 * * `LC-11` - LCA-Vieux Fort
 * * `LI-01` - LIE-Balzers
 * * `LI-02` - LIE-Eschen
 * * `LI-03` - LIE-Gamprin
 * * `LI-04` - LIE-Mauren
 * * `LI-05` - LIE-Planken
 * * `LI-06` - LIE-Ruggell
 * * `LI-07` - LIE-Schaan
 * * `LI-08` - LIE-Schellenberg
 * * `LI-09` - LIE-Triesen
 * * `LI-10` - LIE-Triesenberg
 * * `LI-11` - LIE-Vaduz
 * * `LK-52` - LKA-Ampara
 * * `LK-71` - LKA-Anuradhapura
 * * `LK-81` - LKA-Badulla
 * * `LK-51` - LKA-Batticaloa
 * * `LK-2` - LKA-Central Province
 * * `LK-11` - LKA-Colombo
 * * `LK-5` - LKA-Eastern Province
 * * `LK-31` - LKA-Galle
 * * `LK-12` - LKA-Gampaha
 * * `LK-33` - LKA-Hambantota
 * * `LK-41` - LKA-Jaffna
 * * `LK-13` - LKA-Kalutara
 * * `LK-21` - LKA-Kandy
 * * `LK-92` - LKA-Kegalla
 * * `LK-42` - LKA-Kilinochchi
 * * `LK-61` - LKA-Kurunegala
 * * `LK-43` - LKA-Mannar
 * * `LK-22` - LKA-Matale
 * * `LK-32` - LKA-Matara
 * * `LK-82` - LKA-Monaragala
 * * `LK-45` - LKA-Mullaittivu
 * * `LK-7` - LKA-North Central Province
 * * `LK-6` - LKA-North Western Province
 * * `LK-4` - LKA-Northern Province
 * * `LK-23` - LKA-Nuwara Eliya
 * * `LK-72` - LKA-Polonnaruwa
 * * `LK-62` - LKA-Puttalam
 * * `LK-91` - LKA-Ratnapura
 * * `LK-9` - LKA-Sabaragamuwa Province
 * * `LK-3` - LKA-Southern Province
 * * `LK-53` - LKA-Trincomalee
 * * `LK-8` - LKA-Uva Province
 * * `LK-44` - LKA-Vavuniya
 * * `LK-1` - LKA-Western Province
 * * `LS-D` - LSO-Berea
 * * `LS-B` - LSO-Botha-Bothe
 * * `LS-C` - LSO-Leribe
 * * `LS-E` - LSO-Mafeteng
 * * `LS-A` - LSO-Maseru
 * * `LS-F` - LSO-Mohale's Hoek
 * * `LS-J` - LSO-Mokhotlong
 * * `LS-H` - LSO-Qacha's Nek
 * * `LS-G` - LSO-Quthing
 * * `LS-K` - LSO-Thaba-Tseka
 * * `LT-01` - LTU-Akmenė
 * * `LT-AL` - LTU-Alytaus apskritis
 * * `LT-02` - LTU-Alytaus miestas
 * * `LT-03` - LTU-Alytus
 * * `LT-04` - LTU-Anykščiai
 * * `LT-05` - LTU-Birštonas
 * * `LT-06` - LTU-Biržai
 * * `LT-07` - LTU-Druskininkai
 * * `LT-08` - LTU-Elektrėnai
 * * `LT-09` - LTU-Ignalina
 * * `LT-10` - LTU-Jonava
 * * `LT-11` - LTU-Joniškis
 * * `LT-12` - LTU-Jurbarkas
 * * `LT-13` - LTU-Kaišiadorys
 * * `LT-14` - LTU-Kalvarija
 * * `LT-16` - LTU-Kaunas
 * * `LT-KU` - LTU-Kauno apskritis
 * * `LT-15` - LTU-Kauno miestas
 * * `LT-17` - LTU-Kazlų Rūdos
 * * `LT-19` - LTU-Kelmė
 * * `LT-21` - LTU-Klaipėda
 * * `LT-KL` - LTU-Klaipėdos apskritis
 * * `LT-20` - LTU-Klaipėdos miestas
 * * `LT-22` - LTU-Kretinga
 * * `LT-23` - LTU-Kupiškis
 * * `LT-18` - LTU-Kėdainiai
 * * `LT-24` - LTU-Lazdijai
 * * `LT-25` - LTU-Marijampolė
 * * `LT-MR` - LTU-Marijampolės apskritis
 * * `LT-26` - LTU-Mažeikiai
 * * `LT-27` - LTU-Molėtai
 * * `LT-28` - LTU-Neringa
 * * `LT-29` - LTU-Pagėgiai
 * * `LT-30` - LTU-Pakruojis
 * * `LT-31` - LTU-Palangos miestas
 * * `LT-PN` - LTU-Panevėžio apskritis
 * * `LT-32` - LTU-Panevėžio miestas
 * * `LT-33` - LTU-Panevėžys
 * * `LT-34` - LTU-Pasvalys
 * * `LT-35` - LTU-Plungė
 * * `LT-36` - LTU-Prienai
 * * `LT-37` - LTU-Radviliškis
 * * `LT-38` - LTU-Raseiniai
 * * `LT-39` - LTU-Rietavas
 * * `LT-40` - LTU-Rokiškis
 * * `LT-48` - LTU-Skuodas
 * * `LT-50` - LTU-Tauragė
 * * `LT-TA` - LTU-Tauragės apskritis
 * * `LT-51` - LTU-Telšiai
 * * `LT-TE` - LTU-Telšių apskritis
 * * `LT-52` - LTU-Trakai
 * * `LT-53` - LTU-Ukmergė
 * * `LT-54` - LTU-Utena
 * * `LT-UT` - LTU-Utenos apskritis
 * * `LT-55` - LTU-Varėna
 * * `LT-56` - LTU-Vilkaviškis
 * * `LT-VL` - LTU-Vilniaus apskritis
 * * `LT-57` - LTU-Vilniaus miestas
 * * `LT-58` - LTU-Vilnius
 * * `LT-59` - LTU-Visaginas
 * * `LT-60` - LTU-Zarasai
 * * `LT-41` - LTU-Šakiai
 * * `LT-42` - LTU-Šalčininkai
 * * `LT-44` - LTU-Šiauliai
 * * `LT-SA` - LTU-Šiaulių apskritis
 * * `LT-43` - LTU-Šiaulių miestas
 * * `LT-45` - LTU-Šilalė
 * * `LT-46` - LTU-Šilutė
 * * `LT-47` - LTU-Širvintos
 * * `LT-49` - LTU-Švenčionys
 * * `LU-CA` - LUX-Capellen
 * * `LU-CL` - LUX-Clervaux
 * * `LU-DI` - LUX-Diekirch
 * * `LU-EC` - LUX-Echternach
 * * `LU-ES` - LUX-Esch-sur-Alzette
 * * `LU-GR` - LUX-Grevenmacher
 * * `LU-LU` - LUX-Luxembourg
 * * `LU-ME` - LUX-Mersch
 * * `LU-RD` - LUX-Redange
 * * `LU-RM` - LUX-Remich
 * * `LU-VD` - LUX-Vianden
 * * `LU-WI` - LUX-Wiltz
 * * `LV-002` - LVA-Aizkraukles novads
 * * `LV-007` - LVA-Alūksnes novads
 * * `LV-111` - LVA-Augšdaugavas novads
 * * `LV-015` - LVA-Balvu novads
 * * `LV-016` - LVA-Bauskas novads
 * * `LV-022` - LVA-Cēsu novads
 * * `LV-DGV` - LVA-Daugavpils
 * * `LV-112` - LVA-Dienvidkurzemes Novads
 * * `LV-026` - LVA-Dobeles novads
 * * `LV-033` - LVA-Gulbenes novads
 * * `LV-JEL` - LVA-Jelgava
 * * `LV-041` - LVA-Jelgavas novads
 * * `LV-042` - LVA-Jēkabpils novads
 * * `LV-JUR` - LVA-Jūrmala
 * * `LV-047` - LVA-Krāslavas novads
 * * `LV-050` - LVA-Kuldīgas novads
 * * `LV-LPX` - LVA-Liepāja
 * * `LV-054` - LVA-Limbažu novads
 * * `LV-058` - LVA-Ludzas novads
 * * `LV-056` - LVA-Līvānu novads
 * * `LV-059` - LVA-Madonas novads
 * * `LV-062` - LVA-Mārupes novads
 * * `LV-067` - LVA-Ogres novads
 * * `LV-068` - LVA-Olaines novads
 * * `LV-073` - LVA-Preiļu novads
 * * `LV-080` - LVA-Ropažu novads
 * * `LV-REZ` - LVA-Rēzekne
 * * `LV-077` - LVA-Rēzeknes novads
 * * `LV-RIX` - LVA-Rīga
 * * `LV-087` - LVA-Salaspils novads
 * * `LV-088` - LVA-Saldus novads
 * * `LV-089` - LVA-Saulkrastu novads
 * * `LV-091` - LVA-Siguldas novads
 * * `LV-094` - LVA-Smiltenes novads
 * * `LV-097` - LVA-Talsu novads
 * * `LV-099` - LVA-Tukuma novads
 * * `LV-101` - LVA-Valkas novads
 * * `LV-113` - LVA-Valmieras Novads
 * * `LV-102` - LVA-Varakļānu novads
 * * `LV-VEN` - LVA-Ventspils
 * * `LV-106` - LVA-Ventspils novads
 * * `LV-011` - LVA-Ādažu novads
 * * `LV-052` - LVA-Ķekavas novads
 * * `MA-AGD` - MAR-Agadir-Ida-Ou-Tanane
 * * `MA-HAO` - MAR-Al Haouz
 * * `MA-HOC` - MAR-Al Hoceïma
 * * `MA-AOU` - MAR-Aousserd (EH)
 * * `MA-ASZ` - MAR-Assa-Zag (EH-partial)
 * * `MA-AZI` - MAR-Azilal
 * * `MA-BES` - MAR-Benslimane
 * * `MA-BER` - MAR-Berkane
 * * `MA-BRR` - MAR-Berrechid
 * * `MA-BOD` - MAR-Boujdour (EH)
 * * `MA-BOM` - MAR-Boulemane
 * * `MA-BEM` - MAR-Béni Mellal
 * * `MA-05` - MAR-Béni Mellal-Khénifra
 * * `MA-CAS` - MAR-Casablanca
 * * `MA-06` - MAR-Casablanca-Settat
 * * `MA-CHE` - MAR-Chefchaouen
 * * `MA-CHI` - MAR-Chichaoua
 * * `MA-CHT` - MAR-Chtouka-Ait Baha
 * * `MA-12` - MAR-Dakhla-Oued Ed-Dahab (EH)
 * * `MA-DRI` - MAR-Driouch
 * * `MA-08` - MAR-Drâa-Tafilalet
 * * `MA-HAJ` - MAR-El Hajeb
 * * `MA-JDI` - MAR-El Jadida
 * * `MA-KES` - MAR-El Kelâa des Sraghna
 * * `MA-ERR` - MAR-Errachidia
 * * `MA-ESM` - MAR-Es-Semara (EH-partial)
 * * `MA-ESI` - MAR-Essaouira
 * * `MA-FAH` - MAR-Fahs-Anjra
 * * `MA-FIG` - MAR-Figuig
 * * `MA-FQH` - MAR-Fquih Ben Salah
 * * `MA-FES` - MAR-Fès
 * * `MA-03` - MAR-Fès-Meknès
 * * `MA-GUE` - MAR-Guelmim
 * * `MA-10` - MAR-Guelmim-Oued Noun (EH-partial)
 * * `MA-GUF` - MAR-Guercif
 * * `MA-IFR` - MAR-Ifrane
 * * `MA-INE` - MAR-Inezgane-Ait Melloul
 * * `MA-JRA` - MAR-Jerada
 * * `MA-KHO` - MAR-Khouribga
 * * `MA-KHE` - MAR-Khémisset
 * * `MA-KHN` - MAR-Khénifra
 * * `MA-KEN` - MAR-Kénitra
 * * `MA-02` - MAR-L'Oriental
 * * `MA-LAR` - MAR-Larache
 * * `MA-LAA` - MAR-Laâyoune (EH)
 * * `MA-11` - MAR-Laâyoune-Sakia El Hamra (EH-partial)
 * * `MA-MAR` - MAR-Marrakech
 * * `MA-07` - MAR-Marrakech-Safi
 * * `MA-MEK` - MAR-Meknès
 * * `MA-MID` - MAR-Midelt
 * * `MA-MOH` - MAR-Mohammadia
 * * `MA-MOU` - MAR-Moulay Yacoub
 * * `MA-MED` - MAR-Médiouna
 * * `MA-MDF` - MAR-M’diq-Fnideq
 * * `MA-NAD` - MAR-Nador
 * * `MA-NOU` - MAR-Nouaceur
 * * `MA-OUA` - MAR-Ouarzazate
 * * `MA-OUD` - MAR-Oued Ed-Dahab (EH)
 * * `MA-OUZ` - MAR-Ouezzane
 * * `MA-OUJ` - MAR-Oujda-Angad
 * * `MA-RAB` - MAR-Rabat
 * * `MA-04` - MAR-Rabat-Salé-Kénitra
 * * `MA-REH` - MAR-Rehamna
 * * `MA-SAF` - MAR-Safi
 * * `MA-SAL` - MAR-Salé
 * * `MA-SEF` - MAR-Sefrou
 * * `MA-SET` - MAR-Settat
 * * `MA-SIB` - MAR-Sidi Bennour
 * * `MA-SIF` - MAR-Sidi Ifni
 * * `MA-SIK` - MAR-Sidi Kacem
 * * `MA-SIL` - MAR-Sidi Slimane
 * * `MA-SKH` - MAR-Skhirate-Témara
 * * `MA-09` - MAR-Souss-Massa
 * * `MA-TNT` - MAR-Tan-Tan (EH-partial)
 * * `MA-TNG` - MAR-Tanger-Assilah
 * * `MA-01` - MAR-Tanger-Tétouan-Al Hoceïma
 * * `MA-TAO` - MAR-Taounate
 * * `MA-TAI` - MAR-Taourirt
 * * `MA-TAF` - MAR-Tarfaya (EH-partial)
 * * `MA-TAR` - MAR-Taroudannt
 * * `MA-TAT` - MAR-Tata
 * * `MA-TAZ` - MAR-Taza
 * * `MA-TIN` - MAR-Tinghir
 * * `MA-TIZ` - MAR-Tiznit
 * * `MA-TET` - MAR-Tétouan
 * * `MA-YUS` - MAR-Youssoufia
 * * `MA-ZAG` - MAR-Zagora
 * * `MC-FO` - MCO-Fontvieille
 * * `MC-JE` - MCO-Jardin Exotique
 * * `MC-CL` - MCO-La Colle
 * * `MC-CO` - MCO-La Condamine
 * * `MC-GA` - MCO-La Gare
 * * `MC-SO` - MCO-La Source
 * * `MC-LA` - MCO-Larvotto
 * * `MC-MA` - MCO-Malbousquet
 * * `MC-MO` - MCO-Monaco-Ville
 * * `MC-MG` - MCO-Moneghetti
 * * `MC-MC` - MCO-Monte-Carlo
 * * `MC-MU` - MCO-Moulins
 * * `MC-PH` - MCO-Port-Hercule
 * * `MC-SR` - MCO-Saint-Roman
 * * `MC-SD` - MCO-Sainte-Dévote
 * * `MC-SP` - MCO-Spélugues
 * * `MC-VR` - MCO-Vallon de la Rousse
 * * `MD-AN` - MDA-Anenii Noi
 * * `MD-BS` - MDA-Basarabeasca
 * * `MD-BD` - MDA-Bender [Tighina]
 * * `MD-BR` - MDA-Briceni
 * * `MD-BA` - MDA-Bălți
 * * `MD-CA` - MDA-Cahul
 * * `MD-CT` - MDA-Cantemir
 * * `MD-CU` - MDA-Chișinău
 * * `MD-CM` - MDA-Cimișlia
 * * `MD-CR` - MDA-Criuleni
 * * `MD-CL` - MDA-Călărași
 * * `MD-CS` - MDA-Căușeni
 * * `MD-DO` - MDA-Dondușeni
 * * `MD-DR` - MDA-Drochia
 * * `MD-DU` - MDA-Dubăsari
 * * `MD-ED` - MDA-Edineț
 * * `MD-FL` - MDA-Florești
 * * `MD-FA` - MDA-Fălești
 * * `MD-GL` - MDA-Glodeni
 * * `MD-GA` - MDA-Găgăuzia, Unitatea teritorială autonomă (UTAG)
 * * `MD-HI` - MDA-Hîncești
 * * `MD-IA` - MDA-Ialoveni
 * * `MD-LE` - MDA-Leova
 * * `MD-NI` - MDA-Nisporeni
 * * `MD-OC` - MDA-Ocnița
 * * `MD-OR` - MDA-Orhei
 * * `MD-RE` - MDA-Rezina
 * * `MD-RI` - MDA-Rîșcani
 * * `MD-SO` - MDA-Soroca
 * * `MD-ST` - MDA-Strășeni
 * * `MD-SN` - MDA-Stînga Nistrului, unitatea teritorială din
 * * `MD-SI` - MDA-Sîngerei
 * * `MD-TA` - MDA-Taraclia
 * * `MD-TE` - MDA-Telenești
 * * `MD-UN` - MDA-Ungheni
 * * `MD-SD` - MDA-Șoldănești
 * * `MD-SV` - MDA-Ștefan Vodă
 * * `MG-T` - MDG-Antananarivo
 * * `MG-D` - MDG-Antsiranana
 * * `MG-F` - MDG-Fianarantsoa
 * * `MG-M` - MDG-Mahajanga
 * * `MG-A` - MDG-Toamasina
 * * `MG-U` - MDG-Toliara
 * * `MV-01` - MDV-Addu City
 * * `MV-03` - MDV-Faadhippolhu
 * * `MV-04` - MDV-Felidhu Atoll
 * * `MV-29` - MDV-Fuvammulah
 * * `MV-05` - MDV-Hahdhunmathi
 * * `MV-08` - MDV-Kolhumadulu
 * * `MV-MLE` - MDV-Male
 * * `MV-26` - MDV-Male Atoll
 * * `MV-12` - MDV-Mulaku Atoll
 * * `MV-02` - MDV-North Ari Atoll
 * * `MV-27` - MDV-North Huvadhu Atoll
 * * `MV-13` - MDV-North Maalhosmadulu
 * * `MV-24` - MDV-North Miladhunmadulu
 * * `MV-14` - MDV-North Nilandhe Atoll
 * * `MV-07` - MDV-North Thiladhunmathi
 * * `MV-00` - MDV-South Ari Atoll
 * * `MV-28` - MDV-South Huvadhu Atoll
 * * `MV-20` - MDV-South Maalhosmadulu
 * * `MV-25` - MDV-South Miladhunmadulu
 * * `MV-17` - MDV-South Nilandhe Atoll
 * * `MV-23` - MDV-South Thiladhunmathi
 * * `MX-AGU` - MEX-Aguascalientes
 * * `MX-BCN` - MEX-Baja California
 * * `MX-BCS` - MEX-Baja California Sur
 * * `MX-CAM` - MEX-Campeche
 * * `MX-CHP` - MEX-Chiapas
 * * `MX-CHH` - MEX-Chihuahua
 * * `MX-CMX` - MEX-Ciudad de México
 * * `MX-COA` - MEX-Coahuila de Zaragoza
 * * `MX-COL` - MEX-Colima
 * * `MX-DUR` - MEX-Durango
 * * `MX-GUA` - MEX-Guanajuato
 * * `MX-GRO` - MEX-Guerrero
 * * `MX-HID` - MEX-Hidalgo
 * * `MX-JAL` - MEX-Jalisco
 * * `MX-MIC` - MEX-Michoacán de Ocampo
 * * `MX-MOR` - MEX-Morelos
 * * `MX-MEX` - MEX-México
 * * `MX-NAY` - MEX-Nayarit
 * * `MX-NLE` - MEX-Nuevo León
 * * `MX-OAX` - MEX-Oaxaca
 * * `MX-PUE` - MEX-Puebla
 * * `MX-QUE` - MEX-Querétaro
 * * `MX-ROO` - MEX-Quintana Roo
 * * `MX-SLP` - MEX-San Luis Potosí
 * * `MX-SIN` - MEX-Sinaloa
 * * `MX-SON` - MEX-Sonora
 * * `MX-TAB` - MEX-Tabasco
 * * `MX-TAM` - MEX-Tamaulipas
 * * `MX-TLA` - MEX-Tlaxcala
 * * `MX-VER` - MEX-Veracruz de Ignacio de la Llave
 * * `MX-YUC` - MEX-Yucatán
 * * `MX-ZAC` - MEX-Zacatecas
 * * `MH-ALL` - MHL-Ailinglaplap
 * * `MH-ALK` - MHL-Ailuk
 * * `MH-ARN` - MHL-Arno
 * * `MH-AUR` - MHL-Aur
 * * `MH-KIL` - MHL-Bikini & Kili
 * * `MH-EBO` - MHL-Ebon
 * * `MH-ENI` - MHL-Enewetak & Ujelang
 * * `MH-JAB` - MHL-Jabat
 * * `MH-JAL` - MHL-Jaluit
 * * `MH-KWA` - MHL-Kwajalein
 * * `MH-LAE` - MHL-Lae
 * * `MH-LIB` - MHL-Lib
 * * `MH-LIK` - MHL-Likiep
 * * `MH-MAJ` - MHL-Majuro
 * * `MH-MAL` - MHL-Maloelap
 * * `MH-MEJ` - MHL-Mejit
 * * `MH-MIL` - MHL-Mili
 * * `MH-NMK` - MHL-Namdrik
 * * `MH-NMU` - MHL-Namu
 * * `MH-L` - MHL-Ralik chain
 * * `MH-T` - MHL-Ratak chain
 * * `MH-RON` - MHL-Rongelap
 * * `MH-UJA` - MHL-Ujae
 * * `MH-UTI` - MHL-Utrik
 * * `MH-WTH` - MHL-Wotho
 * * `MH-WTJ` - MHL-Wotje
 * * `MK-801` - MKD-Aerodrom †
 * * `MK-802` - MKD-Aračinovo
 * * `MK-201` - MKD-Berovo
 * * `MK-501` - MKD-Bitola
 * * `MK-401` - MKD-Bogdanci
 * * `MK-601` - MKD-Bogovinje
 * * `MK-402` - MKD-Bosilovo
 * * `MK-602` - MKD-Brvenica
 * * `MK-803` - MKD-Butel †
 * * `MK-313` - MKD-Centar Župa
 * * `MK-814` - MKD-Centar †
 * * `MK-303` - MKD-Debar
 * * `MK-304` - MKD-Debrca
 * * `MK-203` - MKD-Delčevo
 * * `MK-502` - MKD-Demir Hisar
 * * `MK-103` - MKD-Demir Kapija
 * * `MK-406` - MKD-Dojran
 * * `MK-503` - MKD-Dolneni
 * * `MK-804` - MKD-Gazi Baba †
 * * `MK-405` - MKD-Gevgelija
 * * `MK-805` - MKD-Gjorče Petrov †
 * * `MK-604` - MKD-Gostivar
 * * `MK-102` - MKD-Gradsko
 * * `MK-807` - MKD-Ilinden
 * * `MK-606` - MKD-Jegunovce
 * * `MK-205` - MKD-Karbinci
 * * `MK-808` - MKD-Karpoš †
 * * `MK-104` - MKD-Kavadarci
 * * `MK-809` - MKD-Kisela Voda †
 * * `MK-307` - MKD-Kičevo
 * * `MK-407` - MKD-Konče
 * * `MK-206` - MKD-Kočani
 * * `MK-701` - MKD-Kratovo
 * * `MK-702` - MKD-Kriva Palanka
 * * `MK-504` - MKD-Krivogaštani
 * * `MK-505` - MKD-Kruševo
 * * `MK-703` - MKD-Kumanovo
 * * `MK-704` - MKD-Lipkovo
 * * `MK-105` - MKD-Lozovo
 * * `MK-207` - MKD-Makedonska Kamenica
 * * `MK-308` - MKD-Makedonski Brod
 * * `MK-607` - MKD-Mavrovo i Rostuše
 * * `MK-506` - MKD-Mogila
 * * `MK-106` - MKD-Negotino
 * * `MK-507` - MKD-Novaci
 * * `MK-408` - MKD-Novo Selo
 * * `MK-310` - MKD-Ohrid
 * * `MK-208` - MKD-Pehčevo
 * * `MK-810` - MKD-Petrovec
 * * `MK-311` - MKD-Plasnica
 * * `MK-508` - MKD-Prilep
 * * `MK-209` - MKD-Probištip
 * * `MK-409` - MKD-Radoviš
 * * `MK-705` - MKD-Rankovce
 * * `MK-509` - MKD-Resen
 * * `MK-107` - MKD-Rosoman
 * * `MK-811` - MKD-Saraj †
 * * `MK-812` - MKD-Sopište
 * * `MK-706` - MKD-Staro Nagoričane
 * * `MK-312` - MKD-Struga
 * * `MK-410` - MKD-Strumica
 * * `MK-813` - MKD-Studeničani
 * * `MK-108` - MKD-Sveti Nikole
 * * `MK-608` - MKD-Tearce
 * * `MK-609` - MKD-Tetovo
 * * `MK-403` - MKD-Valandovo
 * * `MK-404` - MKD-Vasilevo
 * * `MK-101` - MKD-Veles
 * * `MK-301` - MKD-Vevčani
 * * `MK-202` - MKD-Vinica
 * * `MK-603` - MKD-Vrapčište
 * * `MK-806` - MKD-Zelenikovo
 * * `MK-204` - MKD-Zrnovci
 * * `MK-815` - MKD-Čair †
 * * `MK-109` - MKD-Čaška
 * * `MK-210` - MKD-Češinovo-Obleševo
 * * `MK-816` - MKD-Čučer-Sandevo
 * * `MK-211` - MKD-Štip
 * * `MK-817` - MKD-Šuto Orizari †
 * * `MK-605` - MKD-Želino
 * * `ML-BKO` - MLI-Bamako
 * * `ML-7` - MLI-Gao
 * * `ML-1` - MLI-Kayes
 * * `ML-8` - MLI-Kidal
 * * `ML-2` - MLI-Koulikoro
 * * `ML-5` - MLI-Mopti
 * * `ML-9` - MLI-Ménaka
 * * `ML-3` - MLI-Sikasso
 * * `ML-4` - MLI-Ségou
 * * `ML-10` - MLI-Taoudénit
 * * `ML-6` - MLI-Tombouctou
 * * `MT-01` - MLT-Attard
 * * `MT-02` - MLT-Balzan
 * * `MT-03` - MLT-Birgu
 * * `MT-04` - MLT-Birkirkara
 * * `MT-05` - MLT-Birżebbuġa
 * * `MT-06` - MLT-Bormla
 * * `MT-07` - MLT-Dingli
 * * `MT-08` - MLT-Fgura
 * * `MT-09` - MLT-Floriana
 * * `MT-10` - MLT-Fontana
 * * `MT-11` - MLT-Gudja
 * * `MT-13` - MLT-Għajnsielem
 * * `MT-14` - MLT-Għarb
 * * `MT-15` - MLT-Għargħur
 * * `MT-16` - MLT-Għasri
 * * `MT-17` - MLT-Għaxaq
 * * `MT-12` - MLT-Gżira
 * * `MT-19` - MLT-Iklin
 * * `MT-20` - MLT-Isla
 * * `MT-21` - MLT-Kalkara
 * * `MT-22` - MLT-Kerċem
 * * `MT-23` - MLT-Kirkop
 * * `MT-24` - MLT-Lija
 * * `MT-25` - MLT-Luqa
 * * `MT-26` - MLT-Marsa
 * * `MT-27` - MLT-Marsaskala
 * * `MT-28` - MLT-Marsaxlokk
 * * `MT-29` - MLT-Mdina
 * * `MT-30` - MLT-Mellieħa
 * * `MT-32` - MLT-Mosta
 * * `MT-33` - MLT-Mqabba
 * * `MT-34` - MLT-Msida
 * * `MT-35` - MLT-Mtarfa
 * * `MT-36` - MLT-Munxar
 * * `MT-31` - MLT-Mġarr
 * * `MT-37` - MLT-Nadur
 * * `MT-38` - MLT-Naxxar
 * * `MT-39` - MLT-Paola
 * * `MT-40` - MLT-Pembroke
 * * `MT-41` - MLT-Pietà
 * * `MT-42` - MLT-Qala
 * * `MT-43` - MLT-Qormi
 * * `MT-44` - MLT-Qrendi
 * * `MT-45` - MLT-Rabat Gozo
 * * `MT-46` - MLT-Rabat Malta
 * * `MT-47` - MLT-Safi
 * * `MT-49` - MLT-Saint John
 * * `MT-48` - MLT-Saint Julian's
 * * `MT-50` - MLT-Saint Lawrence
 * * `MT-53` - MLT-Saint Lucia's
 * * `MT-51` - MLT-Saint Paul's Bay
 * * `MT-52` - MLT-Sannat
 * * `MT-54` - MLT-Santa Venera
 * * `MT-55` - MLT-Siġġiewi
 * * `MT-56` - MLT-Sliema
 * * `MT-57` - MLT-Swieqi
 * * `MT-58` - MLT-Ta' Xbiex
 * * `MT-59` - MLT-Tarxien
 * * `MT-60` - MLT-Valletta
 * * `MT-61` - MLT-Xagħra
 * * `MT-62` - MLT-Xewkija
 * * `MT-63` - MLT-Xgħajra
 * * `MT-18` - MLT-Ħamrun
 * * `MT-64` - MLT-Żabbar
 * * `MT-65` - MLT-Żebbuġ Gozo
 * * `MT-66` - MLT-Żebbuġ Malta
 * * `MT-67` - MLT-Żejtun
 * * `MT-68` - MLT-Żurrieq
 * * `MM-07` - MMR-Ayeyarwady
 * * `MM-02` - MMR-Bago
 * * `MM-14` - MMR-Chin
 * * `MM-11` - MMR-Kachin
 * * `MM-12` - MMR-Kayah
 * * `MM-13` - MMR-Kayin
 * * `MM-03` - MMR-Magway
 * * `MM-04` - MMR-Mandalay
 * * `MM-15` - MMR-Mon
 * * `MM-18` - MMR-Nay Pyi Taw
 * * `MM-16` - MMR-Rakhine
 * * `MM-01` - MMR-Sagaing
 * * `MM-17` - MMR-Shan
 * * `MM-05` - MMR-Tanintharyi
 * * `MM-06` - MMR-Yangon
 * * `ME-01` - MNE-Andrijevica
 * * `ME-02` - MNE-Bar
 * * `ME-03` - MNE-Berane
 * * `ME-04` - MNE-Bijelo Polje
 * * `ME-05` - MNE-Budva
 * * `ME-06` - MNE-Cetinje
 * * `ME-07` - MNE-Danilovgrad
 * * `ME-22` - MNE-Gusinje
 * * `ME-08` - MNE-Herceg-Novi
 * * `ME-09` - MNE-Kolašin
 * * `ME-10` - MNE-Kotor
 * * `ME-11` - MNE-Mojkovac
 * * `ME-12` - MNE-Nikšić
 * * `ME-23` - MNE-Petnjica
 * * `ME-13` - MNE-Plav
 * * `ME-14` - MNE-Pljevlja
 * * `ME-15` - MNE-Plužine
 * * `ME-16` - MNE-Podgorica
 * * `ME-17` - MNE-Rožaje
 * * `ME-19` - MNE-Tivat
 * * `ME-24` - MNE-Tuzi
 * * `ME-20` - MNE-Ulcinj
 * * `ME-25` - MNE-Zeta
 * * `ME-18` - MNE-Šavnik
 * * `ME-21` - MNE-Žabljak
 * * `MN-073` - MNG-Arhangay
 * * `MN-071` - MNG-Bayan-Ölgiy
 * * `MN-069` - MNG-Bayanhongor
 * * `MN-067` - MNG-Bulgan
 * * `MN-037` - MNG-Darhan uul
 * * `MN-061` - MNG-Dornod
 * * `MN-063` - MNG-Dornogovĭ
 * * `MN-059` - MNG-Dundgovĭ
 * * `MN-057` - MNG-Dzavhan
 * * `MN-065` - MNG-Govĭ-Altay
 * * `MN-064` - MNG-Govĭ-Sümber
 * * `MN-039` - MNG-Hentiy
 * * `MN-043` - MNG-Hovd
 * * `MN-041` - MNG-Hövsgöl
 * * `MN-035` - MNG-Orhon
 * * `MN-049` - MNG-Selenge
 * * `MN-051` - MNG-Sühbaatar
 * * `MN-047` - MNG-Töv
 * * `MN-1` - MNG-Ulaanbaatar
 * * `MN-046` - MNG-Uvs
 * * `MN-053` - MNG-Ömnögovĭ
 * * `MN-055` - MNG-Övörhangay
 * * `MZ-P` - MOZ-Cabo Delgado
 * * `MZ-G` - MOZ-Gaza
 * * `MZ-I` - MOZ-Inhambane
 * * `MZ-B` - MOZ-Manica
 * * `MZ-L` - MOZ-Maputo
 * * `MZ-MPM` - MOZ-Maputo
 * * `MZ-N` - MOZ-Nampula
 * * `MZ-A` - MOZ-Niassa
 * * `MZ-S` - MOZ-Sofala
 * * `MZ-T` - MOZ-Tete
 * * `MZ-Q` - MOZ-Zambézia
 * * `MR-07` - MRT-Adrar
 * * `MR-03` - MRT-Assaba
 * * `MR-05` - MRT-Brakna
 * * `MR-08` - MRT-Dakhlet Nouâdhibou
 * * `MR-04` - MRT-Gorgol
 * * `MR-10` - MRT-Guidimaka
 * * `MR-01` - MRT-Hodh ech Chargui
 * * `MR-02` - MRT-Hodh el Gharbi
 * * `MR-12` - MRT-Inchiri
 * * `MR-14` - MRT-Nouakchott Nord
 * * `MR-13` - MRT-Nouakchott Ouest
 * * `MR-15` - MRT-Nouakchott Sud
 * * `MR-09` - MRT-Tagant
 * * `MR-11` - MRT-Tiris Zemmour
 * * `MR-06` - MRT-Trarza
 * * `MU-AG` - MUS-Agalega Islands
 * * `MU-BL` - MUS-Black River
 * * `MU-CC` - MUS-Cargados Carajos Shoals
 * * `MU-FL` - MUS-Flacq
 * * `MU-GP` - MUS-Grand Port
 * * `MU-MO` - MUS-Moka
 * * `MU-PA` - MUS-Pamplemousses
 * * `MU-PW` - MUS-Plaines Wilhems
 * * `MU-PL` - MUS-Port Louis
 * * `MU-RR` - MUS-Rivière du Rempart
 * * `MU-RO` - MUS-Rodrigues Island
 * * `MU-SA` - MUS-Savanne
 * * `MW-BA` - MWI-Balaka
 * * `MW-BL` - MWI-Blantyre
 * * `MW-C` - MWI-Central Region
 * * `MW-CK` - MWI-Chikwawa
 * * `MW-CR` - MWI-Chiradzulu
 * * `MW-CT` - MWI-Chitipa
 * * `MW-DE` - MWI-Dedza
 * * `MW-DO` - MWI-Dowa
 * * `MW-KR` - MWI-Karonga
 * * `MW-KS` - MWI-Kasungu
 * * `MW-LK` - MWI-Likoma
 * * `MW-LI` - MWI-Lilongwe
 * * `MW-MH` - MWI-Machinga
 * * `MW-MG` - MWI-Mangochi
 * * `MW-MC` - MWI-Mchinji
 * * `MW-MU` - MWI-Mulanje
 * * `MW-MW` - MWI-Mwanza
 * * `MW-MZ` - MWI-Mzimba
 * * `MW-NE` - MWI-Neno
 * * `MW-NB` - MWI-Nkhata Bay
 * * `MW-NK` - MWI-Nkhotakota
 * * `MW-N` - MWI-Northern Region
 * * `MW-NS` - MWI-Nsanje
 * * `MW-NU` - MWI-Ntcheu
 * * `MW-NI` - MWI-Ntchisi
 * * `MW-PH` - MWI-Phalombe
 * * `MW-RU` - MWI-Rumphi
 * * `MW-SA` - MWI-Salima
 * * `MW-S` - MWI-Southern Region
 * * `MW-TH` - MWI-Thyolo
 * * `MW-ZO` - MWI-Zomba
 * * `MY-01` - MYS-Johor
 * * `MY-02` - MYS-Kedah
 * * `MY-03` - MYS-Kelantan
 * * `MY-04` - MYS-Melaka
 * * `MY-05` - MYS-Negeri Sembilan
 * * `MY-06` - MYS-Pahang
 * * `MY-08` - MYS-Perak
 * * `MY-09` - MYS-Perlis
 * * `MY-07` - MYS-Pulau Pinang
 * * `MY-12` - MYS-Sabah
 * * `MY-13` - MYS-Sarawak
 * * `MY-10` - MYS-Selangor
 * * `MY-11` - MYS-Terengganu
 * * `MY-14` - MYS-Wilayah Persekutuan Kuala Lumpur
 * * `MY-15` - MYS-Wilayah Persekutuan Labuan
 * * `MY-16` - MYS-Wilayah Persekutuan Putrajaya
 * * `NA-KA` - NAM-//Karas
 * * `NA-ER` - NAM-Erongo
 * * `NA-HA` - NAM-Hardap
 * * `NA-KE` - NAM-Kavango East
 * * `NA-KW` - NAM-Kavango West
 * * `NA-KH` - NAM-Khomas
 * * `NA-KU` - NAM-Kunene
 * * `NA-OW` - NAM-Ohangwena
 * * `NA-OH` - NAM-Omaheke
 * * `NA-OS` - NAM-Omusati
 * * `NA-ON` - NAM-Oshana
 * * `NA-OT` - NAM-Oshikoto
 * * `NA-OD` - NAM-Otjozondjupa
 * * `NA-CA` - NAM-Zambezi
 * * `NE-1` - NER-Agadez
 * * `NE-2` - NER-Diffa
 * * `NE-3` - NER-Dosso
 * * `NE-4` - NER-Maradi
 * * `NE-8` - NER-Niamey
 * * `NE-5` - NER-Tahoua
 * * `NE-6` - NER-Tillabéri
 * * `NE-7` - NER-Zinder
 * * `NG-AB` - NGA-Abia
 * * `NG-FC` - NGA-Abuja Federal Capital Territory
 * * `NG-AD` - NGA-Adamawa
 * * `NG-AK` - NGA-Akwa Ibom
 * * `NG-AN` - NGA-Anambra
 * * `NG-BA` - NGA-Bauchi
 * * `NG-BY` - NGA-Bayelsa
 * * `NG-BE` - NGA-Benue
 * * `NG-BO` - NGA-Borno
 * * `NG-CR` - NGA-Cross River
 * * `NG-DE` - NGA-Delta
 * * `NG-EB` - NGA-Ebonyi
 * * `NG-ED` - NGA-Edo
 * * `NG-EK` - NGA-Ekiti
 * * `NG-EN` - NGA-Enugu
 * * `NG-GO` - NGA-Gombe
 * * `NG-IM` - NGA-Imo
 * * `NG-JI` - NGA-Jigawa
 * * `NG-KD` - NGA-Kaduna
 * * `NG-KN` - NGA-Kano
 * * `NG-KT` - NGA-Katsina
 * * `NG-KE` - NGA-Kebbi
 * * `NG-KO` - NGA-Kogi
 * * `NG-KW` - NGA-Kwara
 * * `NG-LA` - NGA-Lagos
 * * `NG-NA` - NGA-Nasarawa
 * * `NG-NI` - NGA-Niger
 * * `NG-OG` - NGA-Ogun
 * * `NG-ON` - NGA-Ondo
 * * `NG-OS` - NGA-Osun
 * * `NG-OY` - NGA-Oyo
 * * `NG-PL` - NGA-Plateau
 * * `NG-RI` - NGA-Rivers
 * * `NG-SO` - NGA-Sokoto
 * * `NG-TA` - NGA-Taraba
 * * `NG-YO` - NGA-Yobe
 * * `NG-ZA` - NGA-Zamfara
 * * `NI-BO` - NIC-Boaco
 * * `NI-CA` - NIC-Carazo
 * * `NI-CI` - NIC-Chinandega
 * * `NI-CO` - NIC-Chontales
 * * `NI-AN` - NIC-Costa Caribe Norte
 * * `NI-AS` - NIC-Costa Caribe Sur
 * * `NI-ES` - NIC-Estelí
 * * `NI-GR` - NIC-Granada
 * * `NI-JI` - NIC-Jinotega
 * * `NI-LE` - NIC-León
 * * `NI-MD` - NIC-Madriz
 * * `NI-MN` - NIC-Managua
 * * `NI-MS` - NIC-Masaya
 * * `NI-MT` - NIC-Matagalpa
 * * `NI-NS` - NIC-Nueva Segovia
 * * `NI-RI` - NIC-Rivas
 * * `NI-SJ` - NIC-Río San Juan
 * * `NL-AW` - NLD-Aruba
 * * `NL-BQ1` - NLD-Bonaire
 * * `NL-CW` - NLD-Curaçao
 * * `NL-DR` - NLD-Drenthe
 * * `NL-FL` - NLD-Flevoland
 * * `NL-FR` - NLD-Fryslân
 * * `NL-GE` - NLD-Gelderland
 * * `NL-GR` - NLD-Groningen
 * * `NL-LI` - NLD-Limburg
 * * `NL-NB` - NLD-Noord-Brabant
 * * `NL-NH` - NLD-Noord-Holland
 * * `NL-OV` - NLD-Overijssel
 * * `NL-BQ2` - NLD-Saba
 * * `NL-BQ3` - NLD-Sint Eustatius
 * * `NL-SX` - NLD-Sint Maarten
 * * `NL-UT` - NLD-Utrecht
 * * `NL-ZE` - NLD-Zeeland
 * * `NL-ZH` - NLD-Zuid-Holland
 * * `NO-42` - NOR-Agder
 * * `NO-34` - NOR-Innlandet
 * * `NO-22` - NOR-Jan Mayen (Arctic Region)
 * * `NO-15` - NOR-Møre og Romsdal
 * * `NO-18` - NOR-Nordland
 * * `NO-03` - NOR-Oslo
 * * `NO-11` - NOR-Rogaland
 * * `NO-54` - NOR-Romssa ja Finnmárkku
 * * `NO-21` - NOR-Svalbard (Arctic Region)
 * * `NO-50` - NOR-Trööndelage
 * * `NO-38` - NOR-Vestfold og Telemark
 * * `NO-46` - NOR-Vestland
 * * `NO-30` - NOR-Viken
 * * `NP-P3` - NPL-Bagmati
 * * `NP-P4` - NPL-Gandaki
 * * `NP-P6` - NPL-Karnali
 * * `NP-P1` - NPL-Koshi
 * * `NP-P5` - NPL-Lumbini
 * * `NP-P2` - NPL-Madhesh
 * * `NP-P7` - NPL-Sudurpashchim
 * * `NR-01` - NRU-Aiwo
 * * `NR-02` - NRU-Anabar
 * * `NR-03` - NRU-Anetan
 * * `NR-04` - NRU-Anibare
 * * `NR-05` - NRU-Baitsi
 * * `NR-06` - NRU-Boe
 * * `NR-07` - NRU-Buada
 * * `NR-08` - NRU-Denigomodu
 * * `NR-09` - NRU-Ewa
 * * `NR-10` - NRU-Ijuw
 * * `NR-11` - NRU-Meneng
 * * `NR-12` - NRU-Nibok
 * * `NR-13` - NRU-Uaboe
 * * `NR-14` - NRU-Yaren
 * * `NZ-AUK` - NZL-Auckland
 * * `NZ-BOP` - NZL-Bay of Plenty
 * * `NZ-CAN` - NZL-Canterbury
 * * `NZ-CIT` - NZL-Chatham Islands Territory
 * * `NZ-GIS` - NZL-Gisborne
 * * `NZ-WGN` - NZL-Greater Wellington
 * * `NZ-HKB` - NZL-Hawke's Bay
 * * `NZ-MWT` - NZL-Manawatū-Whanganui
 * * `NZ-MBH` - NZL-Marlborough
 * * `NZ-NSN` - NZL-Nelson
 * * `NZ-NTL` - NZL-Northland
 * * `NZ-OTA` - NZL-Otago
 * * `NZ-STL` - NZL-Southland
 * * `NZ-TKI` - NZL-Taranaki
 * * `NZ-TAS` - NZL-Tasman
 * * `NZ-WKO` - NZL-Waikato
 * * `NZ-WTC` - NZL-West Coast
 * * `OM-DA` - OMN-Ad Dākhilīyah
 * * `OM-BU` - OMN-Al Buraymī
 * * `OM-WU` - OMN-Al Wusţá
 * * `OM-ZA` - OMN-Az̧ Z̧āhirah
 * * `OM-BJ` - OMN-Janūb al Bāţinah
 * * `OM-SJ` - OMN-Janūb ash Sharqīyah
 * * `OM-MA` - OMN-Masqaţ
 * * `OM-MU` - OMN-Musandam
 * * `OM-BS` - OMN-Shamāl al Bāţinah
 * * `OM-SS` - OMN-Shamāl ash Sharqīyah
 * * `OM-ZU` - OMN-Z̧ufār
 * * `PK-JK` - PAK-Azad Jammu and Kashmir
 * * `PK-BA` - PAK-Balochistan
 * * `PK-GB` - PAK-Gilgit-Baltistan
 * * `PK-IS` - PAK-Islamabad
 * * `PK-KP` - PAK-Khyber Pakhtunkhwa
 * * `PK-PB` - PAK-Punjab
 * * `PK-SD` - PAK-Sindh
 * * `PA-1` - PAN-Bocas del Toro
 * * `PA-4` - PAN-Chiriquí
 * * `PA-2` - PAN-Coclé
 * * `PA-3` - PAN-Colón
 * * `PA-5` - PAN-Darién
 * * `PA-EM` - PAN-Emberá
 * * `PA-KY` - PAN-Guna Yala
 * * `PA-6` - PAN-Herrera
 * * `PA-7` - PAN-Los Santos
 * * `PA-NT` - PAN-Naso Tjër Di
 * * `PA-NB` - PAN-Ngäbe-Buglé
 * * `PA-8` - PAN-Panamá
 * * `PA-10` - PAN-Panamá Oeste
 * * `PA-9` - PAN-Veraguas
 * * `PE-AMA` - PER-Amarumayu
 * * `PE-ANC` - PER-Ancash
 * * `PE-APU` - PER-Apurimaq
 * * `PE-ARE` - PER-Arequipa
 * * `PE-AYA` - PER-Ayacucho
 * * `PE-CAJ` - PER-Cajamarca
 * * `PE-CUS` - PER-Cusco
 * * `PE-CAL` - PER-El Callao
 * * `PE-HUV` - PER-Huancavelica
 * * `PE-JUN` - PER-Hunin
 * * `PE-HUC` - PER-Huánuco
 * * `PE-ICA` - PER-Ica
 * * `PE-LAL` - PER-La Libertad
 * * `PE-LAM` - PER-Lambayeque
 * * `PE-LIM` - PER-Lima
 * * `PE-LMA` - PER-Lima hatun llaqta
 * * `PE-LOR` - PER-Loreto
 * * `PE-MDD` - PER-Madre de Dios
 * * `PE-MOQ` - PER-Moquegua
 * * `PE-PAS` - PER-Pasco
 * * `PE-PIU` - PER-Piura
 * * `PE-PUN` - PER-Puno
 * * `PE-SAM` - PER-San Martin
 * * `PE-TAC` - PER-Tacna
 * * `PE-TUM` - PER-Tumbes
 * * `PE-UCA` - PER-Ucayali
 * * `PH-ABR` - PHL-Abra
 * * `PH-AGN` - PHL-Agusan del Norte
 * * `PH-AGS` - PHL-Agusan del Sur
 * * `PH-AKL` - PHL-Aklan
 * * `PH-ALB` - PHL-Albay
 * * `PH-ANT` - PHL-Antique
 * * `PH-APA` - PHL-Apayao
 * * `PH-AUR` - PHL-Aurora
 * * `PH-14` - PHL-Autonomous Region in Muslim Mindanao (ARMM)
 * * `PH-BAS` - PHL-Basilan
 * * `PH-BAN` - PHL-Bataan
 * * `PH-BTN` - PHL-Batanes
 * * `PH-BTG` - PHL-Batangas
 * * `PH-BEN` - PHL-Benguet
 * * `PH-05` - PHL-Bicol (Region V)
 * * `PH-BIL` - PHL-Biliran
 * * `PH-BOH` - PHL-Bohol
 * * `PH-BUK` - PHL-Bukidnon
 * * `PH-BUL` - PHL-Bulacan
 * * `PH-CAG` - PHL-Cagayan
 * * `PH-02` - PHL-Cagayan Valley (Region II)
 * * `PH-40` - PHL-Calabarzon (Region IV-A)
 * * `PH-CAN` - PHL-Camarines Norte
 * * `PH-CAS` - PHL-Camarines Sur
 * * `PH-CAM` - PHL-Camiguin
 * * `PH-CAP` - PHL-Capiz
 * * `PH-13` - PHL-Caraga (Region XIII)
 * * `PH-CAT` - PHL-Catanduanes
 * * `PH-CAV` - PHL-Cavite
 * * `PH-CEB` - PHL-Cebu
 * * `PH-03` - PHL-Central Luzon (Region III)
 * * `PH-07` - PHL-Central Visayas (Region VII)
 * * `PH-15` - PHL-Cordillera Administrative Region (CAR)
 * * `PH-NCO` - PHL-Cotabato
 * * `PH-11` - PHL-Davao (Region XI)
 * * `PH-DVO` - PHL-Davao Occidental
 * * `PH-DAO` - PHL-Davao Oriental
 * * `PH-COM` - PHL-Davao de Oro
 * * `PH-DAV` - PHL-Davao del Norte
 * * `PH-DAS` - PHL-Davao del Sur
 * * `PH-DIN` - PHL-Dinagat Islands
 * * `PH-EAS` - PHL-Eastern Samar
 * * `PH-08` - PHL-Eastern Visayas (Region VIII)
 * * `PH-GUI` - PHL-Guimaras
 * * `PH-IFU` - PHL-Ifugao
 * * `PH-01` - PHL-Ilocos (Region I)
 * * `PH-ILN` - PHL-Ilocos Norte
 * * `PH-ILS` - PHL-Ilocos Sur
 * * `PH-ILI` - PHL-Iloilo
 * * `PH-ISA` - PHL-Isabela
 * * `PH-KAL` - PHL-Kalinga
 * * `PH-LUN` - PHL-La Union
 * * `PH-LAG` - PHL-Laguna
 * * `PH-LAN` - PHL-Lanao del Norte
 * * `PH-LAS` - PHL-Lanao del Sur
 * * `PH-LEY` - PHL-Leyte
 * * `PH-MGN` - PHL-Maguindanao del Norte
 * * `PH-MGS` - PHL-Maguindanao del Sur
 * * `PH-MAD` - PHL-Marinduque
 * * `PH-MAS` - PHL-Masbate
 * * `PH-41` - PHL-Mimaropa (Region IV-B)
 * * `PH-MDC` - PHL-Mindoro Occidental
 * * `PH-MDR` - PHL-Mindoro Oriental
 * * `PH-MSC` - PHL-Misamis Occidental
 * * `PH-MSR` - PHL-Misamis Oriental
 * * `PH-MOU` - PHL-Mountain Province
 * * `PH-00` - PHL-National Capital Region
 * * `PH-NEC` - PHL-Negros Occidental
 * * `PH-NER` - PHL-Negros Oriental
 * * `PH-10` - PHL-Northern Mindanao (Region X)
 * * `PH-NSA` - PHL-Northern Samar
 * * `PH-NUE` - PHL-Nueva Ecija
 * * `PH-NUV` - PHL-Nueva Vizcaya
 * * `PH-PLW` - PHL-Palawan
 * * `PH-PAM` - PHL-Pampanga
 * * `PH-PAN` - PHL-Pangasinan
 * * `PH-QUE` - PHL-Quezon
 * * `PH-QUI` - PHL-Quirino
 * * `PH-RIZ` - PHL-Rizal
 * * `PH-ROM` - PHL-Romblon
 * * `PH-WSA` - PHL-Samar
 * * `PH-SAR` - PHL-Sarangani
 * * `PH-SIG` - PHL-Siquijor
 * * `PH-12` - PHL-Soccsksargen (Region XII)
 * * `PH-SOR` - PHL-Sorsogon
 * * `PH-SCO` - PHL-South Cotabato
 * * `PH-SLE` - PHL-Southern Leyte
 * * `PH-SUK` - PHL-Sultan Kudarat
 * * `PH-SLU` - PHL-Sulu
 * * `PH-SUN` - PHL-Surigao del Norte
 * * `PH-SUR` - PHL-Surigao del Sur
 * * `PH-TAR` - PHL-Tarlac
 * * `PH-TAW` - PHL-Tawi-Tawi
 * * `PH-06` - PHL-Western Visayas (Region VI)
 * * `PH-ZMB` - PHL-Zambales
 * * `PH-09` - PHL-Zamboanga Peninsula (Region IX)
 * * `PH-ZSI` - PHL-Zamboanga Sibugay
 * * `PH-ZAN` - PHL-Zamboanga del Norte
 * * `PH-ZAS` - PHL-Zamboanga del Sur
 * * `PW-002` - PLW-Aimeliik
 * * `PW-004` - PLW-Airai
 * * `PW-010` - PLW-Angaur
 * * `PW-050` - PLW-Hatohobei
 * * `PW-100` - PLW-Kayangel
 * * `PW-150` - PLW-Koror
 * * `PW-212` - PLW-Melekeok
 * * `PW-214` - PLW-Ngaraard
 * * `PW-218` - PLW-Ngarchelong
 * * `PW-222` - PLW-Ngardmau
 * * `PW-224` - PLW-Ngatpang
 * * `PW-226` - PLW-Ngchesar
 * * `PW-227` - PLW-Ngeremlengui
 * * `PW-228` - PLW-Ngiwal
 * * `PW-350` - PLW-Peleliu
 * * `PW-370` - PLW-Sonsorol
 * * `PG-NSB` - PNG-Bougainville
 * * `PG-CPM` - PNG-Central
 * * `PG-CPK` - PNG-Chimbu
 * * `PG-EBR` - PNG-East New Britain
 * * `PG-ESW` - PNG-East Sepik
 * * `PG-EHG` - PNG-Eastern Highlands
 * * `PG-EPW` - PNG-Enga
 * * `PG-GPK` - PNG-Gulf
 * * `PG-HLA` - PNG-Hela
 * * `PG-JWK` - PNG-Jiwaka
 * * `PG-MPM` - PNG-Madang
 * * `PG-MRL` - PNG-Manus
 * * `PG-MBA` - PNG-Milne Bay
 * * `PG-MPL` - PNG-Morobe
 * * `PG-NCD` - PNG-National Capital District (Port Moresby)
 * * `PG-NIK` - PNG-New Ireland
 * * `PG-NPP` - PNG-Northern
 * * `PG-SHM` - PNG-Southern Highlands
 * * `PG-WBK` - PNG-West New Britain
 * * `PG-SAN` - PNG-West Sepik
 * * `PG-WPD` - PNG-Western
 * * `PG-WHM` - PNG-Western Highlands
 * * `PL-02` - POL-Dolnośląskie
 * * `PL-04` - POL-Kujawsko-Pomorskie
 * * `PL-06` - POL-Lubelskie
 * * `PL-08` - POL-Lubuskie
 * * `PL-14` - POL-Mazowieckie
 * * `PL-12` - POL-Małopolskie
 * * `PL-16` - POL-Opolskie
 * * `PL-18` - POL-Podkarpackie
 * * `PL-20` - POL-Podlaskie
 * * `PL-22` - POL-Pomorskie
 * * `PL-28` - POL-Warmińsko-Mazurskie
 * * `PL-30` - POL-Wielkopolskie
 * * `PL-32` - POL-Zachodniopomorskie
 * * `PL-10` - POL-Łódzkie
 * * `PL-24` - POL-Śląskie
 * * `PL-26` - POL-Świętokrzyskie
 * * `KP-04` - PRK-Chagang-do
 * * `KP-09` - PRK-Hamgyǒng-bukto
 * * `KP-08` - PRK-Hamgyǒng-namdo
 * * `KP-06` - PRK-Hwanghae-bukto
 * * `KP-05` - PRK-Hwanghae-namdo
 * * `KP-15` - PRK-Kaeseong
 * * `KP-07` - PRK-Kangweonto
 * * `KP-14` - PRK-Nampho
 * * `KP-03` - PRK-P'yǒngan-bukto
 * * `KP-02` - PRK-P'yǒngan-namdo
 * * `KP-01` - PRK-P'yǒngyang
 * * `KP-13` - PRK-Raseon
 * * `KP-10` - PRK-Ryanggang-do
 * * `PT-01` - PRT-Aveiro
 * * `PT-02` - PRT-Beja
 * * `PT-03` - PRT-Braga
 * * `PT-04` - PRT-Bragança
 * * `PT-05` - PRT-Castelo Branco
 * * `PT-06` - PRT-Coimbra
 * * `PT-08` - PRT-Faro
 * * `PT-09` - PRT-Guarda
 * * `PT-10` - PRT-Leiria
 * * `PT-11` - PRT-Lisboa
 * * `PT-12` - PRT-Portalegre
 * * `PT-13` - PRT-Porto
 * * `PT-30` - PRT-Região Autónoma da Madeira
 * * `PT-20` - PRT-Região Autónoma dos Açores
 * * `PT-14` - PRT-Santarém
 * * `PT-15` - PRT-Setúbal
 * * `PT-16` - PRT-Viana do Castelo
 * * `PT-17` - PRT-Vila Real
 * * `PT-18` - PRT-Viseu
 * * `PT-07` - PRT-Évora
 * * `PY-16` - PRY-Alto Paraguay
 * * `PY-10` - PRY-Alto Paraná
 * * `PY-13` - PRY-Amambay
 * * `PY-ASU` - PRY-Asunción
 * * `PY-19` - PRY-Boquerón
 * * `PY-5` - PRY-Caaguazú
 * * `PY-6` - PRY-Caazapá
 * * `PY-14` - PRY-Canindeyú
 * * `PY-11` - PRY-Central
 * * `PY-1` - PRY-Concepción
 * * `PY-3` - PRY-Cordillera
 * * `PY-4` - PRY-Guairá
 * * `PY-7` - PRY-Itapúa
 * * `PY-8` - PRY-Misiones
 * * `PY-9` - PRY-Paraguarí
 * * `PY-15` - PRY-Presidente Hayes
 * * `PY-2` - PRY-San Pedro
 * * `PY-12` - PRY-Ñeembucú
 * * `PS-BTH` - PSE-Bethlehem
 * * `PS-DEB` - PSE-Deir El Balah
 * * `PS-GZA` - PSE-Gaza
 * * `PS-HBN` - PSE-Hebron
 * * `PS-JEN` - PSE-Jenin
 * * `PS-JRH` - PSE-Jericho and Al Aghwar
 * * `PS-JEM` - PSE-Jerusalem
 * * `PS-KYS` - PSE-Khan Yunis
 * * `PS-NBS` - PSE-Nablus
 * * `PS-NGZ` - PSE-North Gaza
 * * `PS-QQA` - PSE-Qalqilya
 * * `PS-RFH` - PSE-Rafah
 * * `PS-RBH` - PSE-Ramallah
 * * `PS-SLT` - PSE-Salfit
 * * `PS-TBS` - PSE-Tubas
 * * `PS-TKM` - PSE-Tulkarm
 * * `QA-DA` - QAT-Ad Dawḩah
 * * `QA-KH` - QAT-Al Khawr wa adh Dhakhīrah
 * * `QA-WA` - QAT-Al Wakrah
 * * `QA-RA` - QAT-Ar Rayyān
 * * `QA-MS` - QAT-Ash Shamāl
 * * `QA-SH` - QAT-Ash Shīḩānīyah
 * * `QA-ZA` - QAT-Az̧ Z̧a‘āyin
 * * `QA-US` - QAT-Umm Şalāl
 * * `RO-AB` - ROU-Alba
 * * `RO-AR` - ROU-Arad
 * * `RO-AG` - ROU-Argeș
 * * `RO-BC` - ROU-Bacău
 * * `RO-BH` - ROU-Bihor
 * * `RO-BN` - ROU-Bistrița-Năsăud
 * * `RO-BT` - ROU-Botoșani
 * * `RO-BV` - ROU-Brașov
 * * `RO-BR` - ROU-Brăila
 * * `RO-B` - ROU-București
 * * `RO-BZ` - ROU-Buzău
 * * `RO-CS` - ROU-Caraș-Severin
 * * `RO-CJ` - ROU-Cluj
 * * `RO-CT` - ROU-Constanța
 * * `RO-CV` - ROU-Covasna
 * * `RO-CL` - ROU-Călărași
 * * `RO-DJ` - ROU-Dolj
 * * `RO-DB` - ROU-Dâmbovița
 * * `RO-GL` - ROU-Galați
 * * `RO-GR` - ROU-Giurgiu
 * * `RO-GJ` - ROU-Gorj
 * * `RO-HR` - ROU-Harghita
 * * `RO-HD` - ROU-Hunedoara
 * * `RO-IL` - ROU-Ialomița
 * * `RO-IS` - ROU-Iași
 * * `RO-IF` - ROU-Ilfov
 * * `RO-MM` - ROU-Maramureș
 * * `RO-MH` - ROU-Mehedinți
 * * `RO-MS` - ROU-Mureș
 * * `RO-NT` - ROU-Neamț
 * * `RO-OT` - ROU-Olt
 * * `RO-PH` - ROU-Prahova
 * * `RO-SM` - ROU-Satu Mare
 * * `RO-SB` - ROU-Sibiu
 * * `RO-SV` - ROU-Suceava
 * * `RO-SJ` - ROU-Sălaj
 * * `RO-TR` - ROU-Teleorman
 * * `RO-TM` - ROU-Timiș
 * * `RO-TL` - ROU-Tulcea
 * * `RO-VS` - ROU-Vaslui
 * * `RO-VN` - ROU-Vrancea
 * * `RO-VL` - ROU-Vâlcea
 * * `RU-AD` - RUS-Adygeja, Respublika
 * * `RU-AL` - RUS-Altaj, Respublika
 * * `RU-ALT` - RUS-Altajskij kraj
 * * `RU-AMU` - RUS-Amurskaja oblast'
 * * `RU-ARK` - RUS-Arhangel'skaja oblast'
 * * `RU-AST` - RUS-Astrahanskaja oblast'
 * * `RU-BA` - RUS-Bashkortostan, Respublika
 * * `RU-BEL` - RUS-Belgorodskaja oblast'
 * * `RU-BRY` - RUS-Brjanskaja oblast'
 * * `RU-BU` - RUS-Burjatija, Respublika
 * * `RU-CE` - RUS-Chechenskaya Respublika
 * * `RU-CHE` - RUS-Chelyabinskaya oblast'
 * * `RU-CHU` - RUS-Chukotskiy avtonomnyy okrug
 * * `RU-CU` - RUS-Chuvashskaya Respublika
 * * `RU-DA` - RUS-Dagestan, Respublika
 * * `RU-YEV` - RUS-Evrejskaja avtonomnaja oblast'
 * * `RU-KHA` - RUS-Habarovskij kraj
 * * `RU-KK` - RUS-Hakasija, Respublika
 * * `RU-KHM` - RUS-Hanty-Mansijskij avtonomnyj okrug
 * * `RU-IN` - RUS-Ingushetiya, Respublika
 * * `RU-IRK` - RUS-Irkutskaja oblast'
 * * `RU-IVA` - RUS-Ivanovskaja oblast'
 * * `RU-YAN` - RUS-Jamalo-Neneckij avtonomnyj okrug
 * * `RU-YAR` - RUS-Jaroslavskaja oblast'
 * * `RU-KB` - RUS-Kabardino-Balkarskaja Respublika
 * * `RU-KGD` - RUS-Kaliningradskaja oblast'
 * * `RU-KL` - RUS-Kalmykija, Respublika
 * * `RU-KLU` - RUS-Kaluzhskaya oblast'
 * * `RU-KAM` - RUS-Kamchatskiy kray
 * * `RU-KC` - RUS-Karachayevo-Cherkesskaya Respublika
 * * `RU-KR` - RUS-Karelija, Respublika
 * * `RU-KEM` - RUS-Kemerovskaja oblast'
 * * `RU-KIR` - RUS-Kirovskaja oblast'
 * * `RU-KO` - RUS-Komi, Respublika
 * * `RU-KOS` - RUS-Kostromskaja oblast'
 * * `RU-KDA` - RUS-Krasnodarskij kraj
 * * `RU-KYA` - RUS-Krasnojarskij kraj
 * * `RU-KGN` - RUS-Kurganskaja oblast'
 * * `RU-KRS` - RUS-Kurskaja oblast'
 * * `RU-LEN` - RUS-Leningradskaja oblast'
 * * `RU-LIP` - RUS-Lipeckaja oblast'
 * * `RU-MAG` - RUS-Magadanskaja oblast'
 * * `RU-ME` - RUS-Marij Èl, Respublika
 * * `RU-MO` - RUS-Mordovija, Respublika
 * * `RU-MOS` - RUS-Moskovskaja oblast'
 * * `RU-MOW` - RUS-Moskva
 * * `RU-MUR` - RUS-Murmanskaja oblast'
 * * `RU-NEN` - RUS-Neneckij avtonomnyj okrug
 * * `RU-NIZ` - RUS-Nizhegorodskaya oblast'
 * * `RU-NGR` - RUS-Novgorodskaja oblast'
 * * `RU-NVS` - RUS-Novosibirskaja oblast'
 * * `RU-OMS` - RUS-Omskaja oblast'
 * * `RU-ORE` - RUS-Orenburgskaja oblast'
 * * `RU-ORL` - RUS-Orlovskaja oblast'
 * * `RU-PNZ` - RUS-Penzenskaja oblast'
 * * `RU-PER` - RUS-Permskij kraj
 * * `RU-PRI` - RUS-Primorskij kraj
 * * `RU-PSK` - RUS-Pskovskaja oblast'
 * * `RU-RYA` - RUS-Rjazanskaja oblast'
 * * `RU-ROS` - RUS-Rostovskaja oblast'
 * * `RU-SA` - RUS-Saha, Respublika
 * * `RU-SAK` - RUS-Sahalinskaja oblast'
 * * `RU-SAM` - RUS-Samarskaja oblast'
 * * `RU-SPE` - RUS-Sankt-Peterburg
 * * `RU-SAR` - RUS-Saratovskaja oblast'
 * * `RU-SE` - RUS-Severnaja Osetija, Respublika
 * * `RU-SMO` - RUS-Smolenskaja oblast'
 * * `RU-STA` - RUS-Stavropol'skij kraj
 * * `RU-SVE` - RUS-Sverdlovskaja oblast'
 * * `RU-TAM` - RUS-Tambovskaja oblast'
 * * `RU-TA` - RUS-Tatarstan, Respublika
 * * `RU-TYU` - RUS-Tjumenskaja oblast'
 * * `RU-TOM` - RUS-Tomskaja oblast'
 * * `RU-TUL` - RUS-Tul'skaja oblast'
 * * `RU-TVE` - RUS-Tverskaja oblast'
 * * `RU-TY` - RUS-Tyva, Respublika
 * * `RU-UD` - RUS-Udmurtskaja Respublika
 * * `RU-ULY` - RUS-Ul'janovskaja oblast'
 * * `RU-VLA` - RUS-Vladimirskaja oblast'
 * * `RU-VGG` - RUS-Volgogradskaja oblast'
 * * `RU-VLG` - RUS-Vologodskaja oblast'
 * * `RU-VOR` - RUS-Voronezhskaya oblast'
 * * `RU-ZAB` - RUS-Zabajkal'skij kraj
 * * `RW-01` - RWA-City of Kigali
 * * `RW-02` - RWA-Eastern
 * * `RW-03` - RWA-Northern
 * * `RW-05` - RWA-Southern
 * * `RW-04` - RWA-Western
 * * `SA-14` - SAU-'Asīr
 * * `SA-11` - SAU-Al Bāḩah
 * * `SA-12` - SAU-Al Jawf
 * * `SA-03` - SAU-Al Madīnah al Munawwarah
 * * `SA-05` - SAU-Al Qaşīm
 * * `SA-08` - SAU-Al Ḩudūd ash Shamālīyah
 * * `SA-01` - SAU-Ar Riyāḑ
 * * `SA-04` - SAU-Ash Sharqīyah
 * * `SA-09` - SAU-Jāzān
 * * `SA-02` - SAU-Makkah al Mukarramah
 * * `SA-10` - SAU-Najrān
 * * `SA-07` - SAU-Tabūk
 * * `SA-06` - SAU-Ḩā'il
 * * `SD-NB` - SDN-Blue Nile
 * * `SD-DC` - SDN-Central Darfur
 * * `SD-DE` - SDN-East Darfur
 * * `SD-GD` - SDN-Gedaref
 * * `SD-GZ` - SDN-Gezira
 * * `SD-KA` - SDN-Kassala
 * * `SD-KH` - SDN-Khartoum
 * * `SD-DN` - SDN-North Darfur
 * * `SD-KN` - SDN-North Kordofan
 * * `SD-NO` - SDN-Northern
 * * `SD-RS` - SDN-Red Sea
 * * `SD-NR` - SDN-River Nile
 * * `SD-SI` - SDN-Sennar
 * * `SD-DS` - SDN-South Darfur
 * * `SD-KS` - SDN-South Kordofan
 * * `SD-DW` - SDN-West Darfur
 * * `SD-GK` - SDN-West Kordofan
 * * `SD-NW` - SDN-White Nile
 * * `SN-DK` - SEN-Dakar
 * * `SN-DB` - SEN-Diourbel
 * * `SN-FK` - SEN-Fatick
 * * `SN-KA` - SEN-Kaffrine
 * * `SN-KL` - SEN-Kaolack
 * * `SN-KD` - SEN-Kolda
 * * `SN-KE` - SEN-Kédougou
 * * `SN-LG` - SEN-Louga
 * * `SN-MT` - SEN-Matam
 * * `SN-SL` - SEN-Saint-Louis
 * * `SN-SE` - SEN-Sédhiou
 * * `SN-TC` - SEN-Tambacounda
 * * `SN-TH` - SEN-Thiès
 * * `SN-ZG` - SEN-Ziguinchor
 * * `SG-01` - SGP-Central Singapore
 * * `SG-02` - SGP-North East
 * * `SG-03` - SGP-North West
 * * `SG-04` - SGP-South East
 * * `SG-05` - SGP-South West
 * * `SH-AC` - SHN-Ascension
 * * `SH-HL` - SHN-Saint Helena
 * * `SH-TA` - SHN-Tristan da Cunha
 * * `SB-CT` - SLB-Capital Territory (Honiara)
 * * `SB-CE` - SLB-Central
 * * `SB-CH` - SLB-Choiseul
 * * `SB-GU` - SLB-Guadalcanal
 * * `SB-IS` - SLB-Isabel
 * * `SB-MK` - SLB-Makira-Ulawa
 * * `SB-ML` - SLB-Malaita
 * * `SB-RB` - SLB-Rennell and Bellona
 * * `SB-TE` - SLB-Temotu
 * * `SB-WE` - SLB-Western
 * * `SL-E` - SLE-Eastern
 * * `SL-NW` - SLE-North Western
 * * `SL-N` - SLE-Northern
 * * `SL-S` - SLE-Southern
 * * `SL-W` - SLE-Western Area (Freetown)
 * * `SV-AH` - SLV-Ahuachapán
 * * `SV-CA` - SLV-Cabañas
 * * `SV-CH` - SLV-Chalatenango
 * * `SV-CU` - SLV-Cuscatlán
 * * `SV-LI` - SLV-La Libertad
 * * `SV-PA` - SLV-La Paz
 * * `SV-UN` - SLV-La Unión
 * * `SV-MO` - SLV-Morazán
 * * `SV-SM` - SLV-San Miguel
 * * `SV-SS` - SLV-San Salvador
 * * `SV-SV` - SLV-San Vicente
 * * `SV-SA` - SLV-Santa Ana
 * * `SV-SO` - SLV-Sonsonate
 * * `SV-US` - SLV-Usulután
 * * `SM-01` - SMR-Acquaviva
 * * `SM-06` - SMR-Borgo Maggiore
 * * `SM-02` - SMR-Chiesanuova
 * * `SM-07` - SMR-Città di San Marino
 * * `SM-03` - SMR-Domagnano
 * * `SM-04` - SMR-Faetano
 * * `SM-05` - SMR-Fiorentino
 * * `SM-08` - SMR-Montegiardino
 * * `SM-09` - SMR-Serravalle
 * * `SO-AW` - SOM-Awdal
 * * `SO-BK` - SOM-Bakool
 * * `SO-BN` - SOM-Banaadir
 * * `SO-BR` - SOM-Bari
 * * `SO-BY` - SOM-Bay
 * * `SO-GA` - SOM-Galguduud
 * * `SO-GE` - SOM-Gedo
 * * `SO-HI` - SOM-Hiiraan
 * * `SO-JD` - SOM-Jubbada Dhexe
 * * `SO-JH` - SOM-Jubbada Hoose
 * * `SO-MU` - SOM-Mudug
 * * `SO-NU` - SOM-Nugaal
 * * `SO-SA` - SOM-Sanaag
 * * `SO-SD` - SOM-Shabeellaha Dhexe
 * * `SO-SH` - SOM-Shabeellaha Hoose
 * * `SO-SO` - SOM-Sool
 * * `SO-TO` - SOM-Togdheer
 * * `SO-WO` - SOM-Woqooyi Galbeed
 * * `RS-00` - SRB-Beograd
 * * `RS-14` - SRB-Borski okrug
 * * `RS-11` - SRB-Braničevski okrug
 * * `RS-23` - SRB-Jablanički okrug
 * * `RS-04` - SRB-Južnobanatski okrug
 * * `RS-06` - SRB-Južnobački okrug
 * * `RS-09` - SRB-Kolubarski okrug
 * * `RS-KM` - SRB-Kosovo-Metohija
 * * `RS-25` - SRB-Kosovski okrug
 * * `RS-28` - SRB-Kosovsko-Mitrovački okrug
 * * `RS-29` - SRB-Kosovsko-Pomoravski okrug
 * * `RS-08` - SRB-Mačvanski okrug
 * * `RS-17` - SRB-Moravički okrug
 * * `RS-20` - SRB-Nišavski okrug
 * * `RS-26` - SRB-Pećki okrug
 * * `RS-22` - SRB-Pirotski okrug
 * * `RS-10` - SRB-Podunavski okrug
 * * `RS-13` - SRB-Pomoravski okrug
 * * `RS-27` - SRB-Prizrenski okrug
 * * `RS-24` - SRB-Pčinjski okrug
 * * `RS-19` - SRB-Rasinski okrug
 * * `RS-18` - SRB-Raški okrug
 * * `RS-03` - SRB-Severnobanatski okrug
 * * `RS-01` - SRB-Severnobački okrug
 * * `RS-02` - SRB-Srednjebanatski okrug
 * * `RS-07` - SRB-Sremski okrug
 * * `RS-21` - SRB-Toplički okrug
 * * `RS-VO` - SRB-Vojvodina
 * * `RS-15` - SRB-Zaječarski okrug
 * * `RS-05` - SRB-Zapadnobački okrug
 * * `RS-16` - SRB-Zlatiborski okrug
 * * `RS-12` - SRB-Šumadijski okrug
 * * `SS-EC` - SSD-Central Equatoria
 * * `SS-EE` - SSD-Eastern Equatoria
 * * `SS-JG` - SSD-Jonglei
 * * `SS-LK` - SSD-Lakes
 * * `SS-BN` - SSD-Northern Bahr el Ghazal
 * * `SS-UY` - SSD-Unity
 * * `SS-NU` - SSD-Upper Nile
 * * `SS-WR` - SSD-Warrap
 * * `SS-BW` - SSD-Western Bahr el Ghazal
 * * `SS-EW` - SSD-Western Equatoria
 * * `ST-02` - STP-Cantagalo
 * * `ST-03` - STP-Caué
 * * `ST-04` - STP-Lembá
 * * `ST-05` - STP-Lobata
 * * `ST-06` - STP-Mé-Zóchi
 * * `ST-P` - STP-Príncipe
 * * `ST-01` - STP-Água Grande
 * * `SR-BR` - SUR-Brokopondo
 * * `SR-CM` - SUR-Commewijne
 * * `SR-CR` - SUR-Coronie
 * * `SR-MA` - SUR-Marowijne
 * * `SR-NI` - SUR-Nickerie
 * * `SR-PR` - SUR-Para
 * * `SR-PM` - SUR-Paramaribo
 * * `SR-SA` - SUR-Saramacca
 * * `SR-SI` - SUR-Sipaliwini
 * * `SR-WA` - SUR-Wanica
 * * `SK-BC` - SVK-Banskobystrický kraj
 * * `SK-BL` - SVK-Bratislavský kraj
 * * `SK-KI` - SVK-Košický kraj
 * * `SK-NI` - SVK-Nitriansky kraj
 * * `SK-PV` - SVK-Prešovský kraj
 * * `SK-TC` - SVK-Trenčiansky kraj
 * * `SK-TA` - SVK-Trnavský kraj
 * * `SK-ZI` - SVK-Žilinský kraj
 * * `SI-001` - SVN-Ajdovščina
 * * `SI-213` - SVN-Ankaran
 * * `SI-195` - SVN-Apače
 * * `SI-002` - SVN-Beltinci
 * * `SI-148` - SVN-Benedikt
 * * `SI-149` - SVN-Bistrica ob Sotli
 * * `SI-003` - SVN-Bled
 * * `SI-150` - SVN-Bloke
 * * `SI-004` - SVN-Bohinj
 * * `SI-005` - SVN-Borovnica
 * * `SI-006` - SVN-Bovec
 * * `SI-151` - SVN-Braslovče
 * * `SI-007` - SVN-Brda
 * * `SI-008` - SVN-Brezovica
 * * `SI-009` - SVN-Brežice
 * * `SI-152` - SVN-Cankova
 * * `SI-011` - SVN-Celje
 * * `SI-012` - SVN-Cerklje na Gorenjskem
 * * `SI-013` - SVN-Cerknica
 * * `SI-014` - SVN-Cerkno
 * * `SI-153` - SVN-Cerkvenjak
 * * `SI-196` - SVN-Cirkulane
 * * `SI-018` - SVN-Destrnik
 * * `SI-019` - SVN-Divača
 * * `SI-154` - SVN-Dobje
 * * `SI-020` - SVN-Dobrepolje
 * * `SI-155` - SVN-Dobrna
 * * `SI-021` - SVN-Dobrova-Polhov Gradec
 * * `SI-156` - SVN-Dobrovnik
 * * `SI-022` - SVN-Dol pri Ljubljani
 * * `SI-157` - SVN-Dolenjske Toplice
 * * `SI-023` - SVN-Domžale
 * * `SI-024` - SVN-Dornava
 * * `SI-025` - SVN-Dravograd
 * * `SI-026` - SVN-Duplek
 * * `SI-027` - SVN-Gorenja vas-Poljane
 * * `SI-028` - SVN-Gorišnica
 * * `SI-207` - SVN-Gorje
 * * `SI-029` - SVN-Gornja Radgona
 * * `SI-030` - SVN-Gornji Grad
 * * `SI-031` - SVN-Gornji Petrovci
 * * `SI-158` - SVN-Grad
 * * `SI-032` - SVN-Grosuplje
 * * `SI-159` - SVN-Hajdina
 * * `SI-161` - SVN-Hodoš
 * * `SI-162` - SVN-Horjul
 * * `SI-160` - SVN-Hoče-Slivnica
 * * `SI-034` - SVN-Hrastnik
 * * `SI-035` - SVN-Hrpelje-Kozina
 * * `SI-036` - SVN-Idrija
 * * `SI-037` - SVN-Ig
 * * `SI-038` - SVN-Ilirska Bistrica
 * * `SI-039` - SVN-Ivančna Gorica
 * * `SI-040` - SVN-Izola
 * * `SI-041` - SVN-Jesenice
 * * `SI-163` - SVN-Jezersko
 * * `SI-042` - SVN-Juršinci
 * * `SI-043` - SVN-Kamnik
 * * `SI-044` - SVN-Kanal ob Soči
 * * `SI-045` - SVN-Kidričevo
 * * `SI-046` - SVN-Kobarid
 * * `SI-047` - SVN-Kobilje
 * * `SI-049` - SVN-Komen
 * * `SI-164` - SVN-Komenda
 * * `SI-050` - SVN-Koper
 * * `SI-197` - SVN-Kostanjevica na Krki
 * * `SI-165` - SVN-Kostel
 * * `SI-051` - SVN-Kozje
 * * `SI-048` - SVN-Kočevje
 * * `SI-052` - SVN-Kranj
 * * `SI-053` - SVN-Kranjska Gora
 * * `SI-166` - SVN-Križevci
 * * `SI-054` - SVN-Krško
 * * `SI-055` - SVN-Kungota
 * * `SI-056` - SVN-Kuzma
 * * `SI-057` - SVN-Laško
 * * `SI-058` - SVN-Lenart
 * * `SI-059` - SVN-Lendava
 * * `SI-060` - SVN-Litija
 * * `SI-061` - SVN-Ljubljana
 * * `SI-062` - SVN-Ljubno
 * * `SI-063` - SVN-Ljutomer
 * * `SI-208` - SVN-Log-Dragomer
 * * `SI-064` - SVN-Logatec
 * * `SI-167` - SVN-Lovrenc na Pohorju
 * * `SI-065` - SVN-Loška dolina
 * * `SI-066` - SVN-Loški Potok
 * * `SI-068` - SVN-Lukovica
 * * `SI-067` - SVN-Luče
 * * `SI-069` - SVN-Majšperk
 * * `SI-198` - SVN-Makole
 * * `SI-070` - SVN-Maribor
 * * `SI-168` - SVN-Markovci
 * * `SI-071` - SVN-Medvode
 * * `SI-072` - SVN-Mengeš
 * * `SI-073` - SVN-Metlika
 * * `SI-074` - SVN-Mežica
 * * `SI-169` - SVN-Miklavž na Dravskem polju
 * * `SI-075` - SVN-Miren-Kostanjevica
 * * `SI-212` - SVN-Mirna
 * * `SI-170` - SVN-Mirna Peč
 * * `SI-076` - SVN-Mislinja
 * * `SI-199` - SVN-Mokronog-Trebelno
 * * `SI-078` - SVN-Moravske Toplice
 * * `SI-077` - SVN-Moravče
 * * `SI-079` - SVN-Mozirje
 * * `SI-080` - SVN-Murska Sobota
 * * `SI-081` - SVN-Muta
 * * `SI-082` - SVN-Naklo
 * * `SI-083` - SVN-Nazarje
 * * `SI-084` - SVN-Nova Gorica
 * * `SI-085` - SVN-Novo Mesto
 * * `SI-086` - SVN-Odranci
 * * `SI-171` - SVN-Oplotnica
 * * `SI-087` - SVN-Ormož
 * * `SI-088` - SVN-Osilnica
 * * `SI-089` - SVN-Pesnica
 * * `SI-090` - SVN-Piran
 * * `SI-091` - SVN-Pivka
 * * `SI-172` - SVN-Podlehnik
 * * `SI-093` - SVN-Podvelka
 * * `SI-092` - SVN-Podčetrtek
 * * `SI-200` - SVN-Poljčane
 * * `SI-173` - SVN-Polzela
 * * `SI-094` - SVN-Postojna
 * * `SI-174` - SVN-Prebold
 * * `SI-095` - SVN-Preddvor
 * * `SI-175` - SVN-Prevalje
 * * `SI-096` - SVN-Ptuj
 * * `SI-097` - SVN-Puconci
 * * `SI-100` - SVN-Radenci
 * * `SI-099` - SVN-Radeče
 * * `SI-101` - SVN-Radlje ob Dravi
 * * `SI-102` - SVN-Radovljica
 * * `SI-103` - SVN-Ravne na Koroškem
 * * `SI-176` - SVN-Razkrižje
 * * `SI-098` - SVN-Rače-Fram
 * * `SI-201` - SVN-Renče-Vogrsko
 * * `SI-209` - SVN-Rečica ob Savinji
 * * `SI-104` - SVN-Ribnica
 * * `SI-177` - SVN-Ribnica na Pohorju
 * * `SI-107` - SVN-Rogatec
 * * `SI-106` - SVN-Rogaška Slatina
 * * `SI-105` - SVN-Rogašovci
 * * `SI-108` - SVN-Ruše
 * * `SI-178` - SVN-Selnica ob Dravi
 * * `SI-109` - SVN-Semič
 * * `SI-110` - SVN-Sevnica
 * * `SI-111` - SVN-Sežana
 * * `SI-112` - SVN-Slovenj Gradec
 * * `SI-113` - SVN-Slovenska Bistrica
 * * `SI-114` - SVN-Slovenske Konjice
 * * `SI-179` - SVN-Sodražica
 * * `SI-180` - SVN-Solčava
 * * `SI-202` - SVN-Središče ob Dravi
 * * `SI-115` - SVN-Starše
 * * `SI-203` - SVN-Straža
 * * `SI-181` - SVN-Sveta Ana
 * * `SI-204` - SVN-Sveta Trojica v Slovenskih goricah
 * * `SI-182` - SVN-Sveti Andraž v Slovenskih goricah
 * * `SI-116` - SVN-Sveti Jurij ob Ščavnici
 * * `SI-210` - SVN-Sveti Jurij v Slovenskih goricah
 * * `SI-205` - SVN-Sveti Tomaž
 * * `SI-184` - SVN-Tabor
 * * `SI-010` - SVN-Tišina
 * * `SI-128` - SVN-Tolmin
 * * `SI-129` - SVN-Trbovlje
 * * `SI-130` - SVN-Trebnje
 * * `SI-185` - SVN-Trnovska Vas
 * * `SI-186` - SVN-Trzin
 * * `SI-131` - SVN-Tržič
 * * `SI-132` - SVN-Turnišče
 * * `SI-133` - SVN-Velenje
 * * `SI-187` - SVN-Velika Polana
 * * `SI-134` - SVN-Velike Lašče
 * * `SI-188` - SVN-Veržej
 * * `SI-135` - SVN-Videm
 * * `SI-136` - SVN-Vipava
 * * `SI-137` - SVN-Vitanje
 * * `SI-138` - SVN-Vodice
 * * `SI-139` - SVN-Vojnik
 * * `SI-189` - SVN-Vransko
 * * `SI-140` - SVN-Vrhnika
 * * `SI-141` - SVN-Vuzenica
 * * `SI-142` - SVN-Zagorje ob Savi
 * * `SI-143` - SVN-Zavrč
 * * `SI-144` - SVN-Zreče
 * * `SI-015` - SVN-Črenšovci
 * * `SI-016` - SVN-Črna na Koroškem
 * * `SI-017` - SVN-Črnomelj
 * * `SI-033` - SVN-Šalovci
 * * `SI-183` - SVN-Šempeter-Vrtojba
 * * `SI-118` - SVN-Šentilj
 * * `SI-119` - SVN-Šentjernej
 * * `SI-120` - SVN-Šentjur
 * * `SI-211` - SVN-Šentrupert
 * * `SI-117` - SVN-Šenčur
 * * `SI-121` - SVN-Škocjan
 * * `SI-122` - SVN-Škofja Loka
 * * `SI-123` - SVN-Škofljica
 * * `SI-124` - SVN-Šmarje pri Jelšah
 * * `SI-206` - SVN-Šmarješke Toplice
 * * `SI-125` - SVN-Šmartno ob Paki
 * * `SI-194` - SVN-Šmartno pri Litiji
 * * `SI-126` - SVN-Šoštanj
 * * `SI-127` - SVN-Štore
 * * `SI-190` - SVN-Žalec
 * * `SI-146` - SVN-Železniki
 * * `SI-191` - SVN-Žetale
 * * `SI-147` - SVN-Žiri
 * * `SI-192` - SVN-Žirovnica
 * * `SI-193` - SVN-Žužemberk
 * * `SE-K` - SWE-Blekinge län [SE-10]
 * * `SE-W` - SWE-Dalarnas län [SE-20]
 * * `SE-I` - SWE-Gotlands län [SE-09]
 * * `SE-X` - SWE-Gävleborgs län [SE-21]
 * * `SE-N` - SWE-Hallands län [SE-13]
 * * `SE-Z` - SWE-Jämtlands län [SE-23]
 * * `SE-F` - SWE-Jönköpings län [SE-06]
 * * `SE-H` - SWE-Kalmar län [SE-08]
 * * `SE-G` - SWE-Kronobergs län [SE-07]
 * * `SE-BD` - SWE-Norrbottens län [SE-25]
 * * `SE-M` - SWE-Skåne län [SE-12]
 * * `SE-AB` - SWE-Stockholms län [SE-01]
 * * `SE-D` - SWE-Södermanlands län [SE-04]
 * * `SE-C` - SWE-Uppsala län [SE-03]
 * * `SE-S` - SWE-Värmlands län [SE-17]
 * * `SE-AC` - SWE-Västerbottens län [SE-24]
 * * `SE-Y` - SWE-Västernorrlands län [SE-22]
 * * `SE-U` - SWE-Västmanlands län [SE-19]
 * * `SE-O` - SWE-Västra Götalands län [SE-14]
 * * `SE-T` - SWE-Örebro län [SE-18]
 * * `SE-E` - SWE-Östergötlands län [SE-05]
 * * `SZ-HH` - SWZ-Hhohho
 * * `SZ-LU` - SWZ-Lubombo
 * * `SZ-MA` - SWZ-Manzini
 * * `SZ-SH` - SWZ-Shiselweni
 * * `SC-02` - SYC-Anse Boileau
 * * `SC-03` - SYC-Anse Etoile
 * * `SC-05` - SYC-Anse Royale
 * * `SC-01` - SYC-Anse aux Pins
 * * `SC-04` - SYC-Au Cap
 * * `SC-06` - SYC-Baie Lazare
 * * `SC-07` - SYC-Baie Sainte Anne
 * * `SC-08` - SYC-Beau Vallon
 * * `SC-09` - SYC-Bel Air
 * * `SC-10` - SYC-Bel Ombre
 * * `SC-11` - SYC-Cascade
 * * `SC-16` - SYC-English River
 * * `SC-12` - SYC-Glacis
 * * `SC-13` - SYC-Grand Anse Mahe
 * * `SC-14` - SYC-Grand Anse Praslin
 * * `SC-26` - SYC-Ile Perseverance I
 * * `SC-27` - SYC-Ile Perseverance II
 * * `SC-15` - SYC-La Digue
 * * `SC-24` - SYC-Les Mamelles
 * * `SC-17` - SYC-Mont Buxton
 * * `SC-18` - SYC-Mont Fleuri
 * * `SC-19` - SYC-Plaisance
 * * `SC-20` - SYC-Pointe Larue
 * * `SC-21` - SYC-Port Glaud
 * * `SC-25` - SYC-Roche Caiman
 * * `SC-22` - SYC-Saint Louis
 * * `SC-23` - SYC-Takamaka
 * * `SY-LA` - SYR-Al Lādhiqīyah
 * * `SY-QU` - SYR-Al Qunayţirah
 * * `SY-HA` - SYR-Al Ḩasakah
 * * `SY-RA` - SYR-Ar Raqqah
 * * `SY-SU` - SYR-As Suwaydā'
 * * `SY-DR` - SYR-Dar'ā
 * * `SY-DY` - SYR-Dayr az Zawr
 * * `SY-DI` - SYR-Dimashq
 * * `SY-ID` - SYR-Idlib
 * * `SY-RD` - SYR-Rīf Dimashq
 * * `SY-TA` - SYR-Ţarţūs
 * * `SY-HL` - SYR-Ḩalab
 * * `SY-HM` - SYR-Ḩamāh
 * * `SY-HI` - SYR-Ḩimş
 * * `TD-BG` - TCD-Bahr el Ghazal
 * * `TD-BA` - TCD-Batha
 * * `TD-BO` - TCD-Borkou
 * * `TD-CB` - TCD-Chari-Baguirmi
 * * `TD-EE` - TCD-Ennedi-Est
 * * `TD-EO` - TCD-Ennedi-Ouest
 * * `TD-GR` - TCD-Guéra
 * * `TD-HL` - TCD-Hadjer Lamis
 * * `TD-KA` - TCD-Kanem
 * * `TD-LC` - TCD-Lac
 * * `TD-LO` - TCD-Logone-Occidental
 * * `TD-LR` - TCD-Logone-Oriental
 * * `TD-MA` - TCD-Mandoul
 * * `TD-ME` - TCD-Mayo-Kebbi-Est
 * * `TD-MO` - TCD-Mayo-Kebbi-Ouest
 * * `TD-MC` - TCD-Moyen-Chari
 * * `TD-OD` - TCD-Ouaddaï
 * * `TD-SA` - TCD-Salamat
 * * `TD-SI` - TCD-Sila
 * * `TD-TA` - TCD-Tandjilé
 * * `TD-TI` - TCD-Tibesti
 * * `TD-ND` - TCD-Ville de Ndjamena
 * * `TD-WF` - TCD-Wadi Fira
 * * `TG-C` - TGO-Centrale
 * * `TG-K` - TGO-Kara
 * * `TG-M` - TGO-Maritime (Région)
 * * `TG-P` - TGO-Plateaux
 * * `TG-S` - TGO-Savanes
 * * `TH-37` - THA-Amnat Charoen
 * * `TH-15` - THA-Ang Thong
 * * `TH-38` - THA-Bueng Kan
 * * `TH-31` - THA-Buri Ram
 * * `TH-24` - THA-Chachoengsao
 * * `TH-18` - THA-Chai Nat
 * * `TH-36` - THA-Chaiyaphum
 * * `TH-22` - THA-Chanthaburi
 * * `TH-50` - THA-Chiang Mai
 * * `TH-57` - THA-Chiang Rai
 * * `TH-20` - THA-Chon Buri
 * * `TH-86` - THA-Chumphon
 * * `TH-46` - THA-Kalasin
 * * `TH-62` - THA-Kamphaeng Phet
 * * `TH-71` - THA-Kanchanaburi
 * * `TH-40` - THA-Khon Kaen
 * * `TH-81` - THA-Krabi
 * * `TH-10` - THA-Krung Thep Maha Nakhon
 * * `TH-52` - THA-Lampang
 * * `TH-51` - THA-Lamphun
 * * `TH-42` - THA-Loei
 * * `TH-16` - THA-Lop Buri
 * * `TH-58` - THA-Mae Hong Son
 * * `TH-44` - THA-Maha Sarakham
 * * `TH-49` - THA-Mukdahan
 * * `TH-26` - THA-Nakhon Nayok
 * * `TH-73` - THA-Nakhon Pathom
 * * `TH-48` - THA-Nakhon Phanom
 * * `TH-30` - THA-Nakhon Ratchasima
 * * `TH-60` - THA-Nakhon Sawan
 * * `TH-80` - THA-Nakhon Si Thammarat
 * * `TH-55` - THA-Nan
 * * `TH-96` - THA-Narathiwat
 * * `TH-39` - THA-Nong Bua Lam Phu
 * * `TH-43` - THA-Nong Khai
 * * `TH-12` - THA-Nonthaburi
 * * `TH-13` - THA-Pathum Thani
 * * `TH-94` - THA-Pattani
 * * `TH-82` - THA-Phangnga
 * * `TH-93` - THA-Phatthalung
 * * `TH-S` - THA-Phatthaya
 * * `TH-56` - THA-Phayao
 * * `TH-67` - THA-Phetchabun
 * * `TH-76` - THA-Phetchaburi
 * * `TH-66` - THA-Phichit
 * * `TH-65` - THA-Phitsanulok
 * * `TH-14` - THA-Phra Nakhon Si Ayutthaya
 * * `TH-54` - THA-Phrae
 * * `TH-83` - THA-Phuket
 * * `TH-25` - THA-Prachin Buri
 * * `TH-77` - THA-Prachuap Khiri Khan
 * * `TH-85` - THA-Ranong
 * * `TH-70` - THA-Ratchaburi
 * * `TH-21` - THA-Rayong
 * * `TH-45` - THA-Roi Et
 * * `TH-27` - THA-Sa Kaeo
 * * `TH-47` - THA-Sakon Nakhon
 * * `TH-11` - THA-Samut Prakan
 * * `TH-74` - THA-Samut Sakhon
 * * `TH-75` - THA-Samut Songkhram
 * * `TH-19` - THA-Saraburi
 * * `TH-91` - THA-Satun
 * * `TH-33` - THA-Si Sa Ket
 * * `TH-17` - THA-Sing Buri
 * * `TH-90` - THA-Songkhla
 * * `TH-64` - THA-Sukhothai
 * * `TH-72` - THA-Suphan Buri
 * * `TH-84` - THA-Surat Thani
 * * `TH-32` - THA-Surin
 * * `TH-63` - THA-Tak
 * * `TH-92` - THA-Trang
 * * `TH-23` - THA-Trat
 * * `TH-34` - THA-Ubon Ratchathani
 * * `TH-41` - THA-Udon Thani
 * * `TH-61` - THA-Uthai Thani
 * * `TH-53` - THA-Uttaradit
 * * `TH-95` - THA-Yala
 * * `TH-35` - THA-Yasothon
 * * `TJ-DU` - TJK-Dushanbe
 * * `TJ-KT` - TJK-Khatlon
 * * `TJ-GB` - TJK-Kŭhistoni Badakhshon
 * * `TJ-SU` - TJK-Sughd
 * * `TJ-RA` - TJK-nohiyahoi tobei jumhurí
 * * `TM-A` - TKM-Ahal
 * * `TM-S` - TKM-Aşgabat
 * * `TM-B` - TKM-Balkan
 * * `TM-D` - TKM-Daşoguz
 * * `TM-L` - TKM-Lebap
 * * `TM-M` - TKM-Mary
 * * `TL-AL` - TLS-Aileu
 * * `TL-AN` - TLS-Ainaro
 * * `TL-BA` - TLS-Baucau
 * * `TL-BO` - TLS-Bobonaro
 * * `TL-CO` - TLS-Cova Lima
 * * `TL-DI` - TLS-Díli
 * * `TL-ER` - TLS-Ermera
 * * `TL-LA` - TLS-Lautein
 * * `TL-LI` - TLS-Likisá
 * * `TL-MT` - TLS-Manatuto
 * * `TL-MF` - TLS-Manufahi
 * * `TL-OE` - TLS-Oekusi-Ambenu
 * * `TL-VI` - TLS-Vikeke
 * * `TO-01` - TON-'Eua
 * * `TO-02` - TON-Ha'apai
 * * `TO-03` - TON-Niuas
 * * `TO-04` - TON-Tongatapu
 * * `TO-05` - TON-Vava'u
 * * `TT-ARI` - TTO-Arima
 * * `TT-CHA` - TTO-Chaguanas
 * * `TT-CTT` - TTO-Couva-Tabaquite-Talparo
 * * `TT-DMN` - TTO-Diego Martin
 * * `TT-MRC` - TTO-Mayaro-Rio Claro
 * * `TT-PED` - TTO-Penal-Debe
 * * `TT-PTF` - TTO-Point Fortin
 * * `TT-POS` - TTO-Port of Spain
 * * `TT-PRT` - TTO-Princes Town
 * * `TT-SFO` - TTO-San Fernando
 * * `TT-SJL` - TTO-San Juan-Laventille
 * * `TT-SGE` - TTO-Sangre Grande
 * * `TT-SIP` - TTO-Siparia
 * * `TT-TOB` - TTO-Tobago
 * * `TT-TUP` - TTO-Tunapuna-Piarco
 * * `TN-13` - TUN-Ben Arous
 * * `TN-23` - TUN-Bizerte
 * * `TN-31` - TUN-Béja
 * * `TN-81` - TUN-Gabès
 * * `TN-71` - TUN-Gafsa
 * * `TN-32` - TUN-Jendouba
 * * `TN-41` - TUN-Kairouan
 * * `TN-42` - TUN-Kasserine
 * * `TN-73` - TUN-Kébili
 * * `TN-12` - TUN-L'Ariana
 * * `TN-14` - TUN-La Manouba
 * * `TN-33` - TUN-Le Kef
 * * `TN-53` - TUN-Mahdia
 * * `TN-52` - TUN-Monastir
 * * `TN-82` - TUN-Médenine
 * * `TN-21` - TUN-Nabeul
 * * `TN-61` - TUN-Sfax
 * * `TN-43` - TUN-Sidi Bouzid
 * * `TN-34` - TUN-Siliana
 * * `TN-51` - TUN-Sousse
 * * `TN-83` - TUN-Tataouine
 * * `TN-72` - TUN-Tozeur
 * * `TN-11` - TUN-Tunis
 * * `TN-22` - TUN-Zaghouan
 * * `TR-01` - TUR-Adana
 * * `TR-02` - TUR-Adıyaman
 * * `TR-03` - TUR-Afyonkarahisar
 * * `TR-68` - TUR-Aksaray
 * * `TR-05` - TUR-Amasya
 * * `TR-06` - TUR-Ankara
 * * `TR-07` - TUR-Antalya
 * * `TR-75` - TUR-Ardahan
 * * `TR-08` - TUR-Artvin
 * * `TR-09` - TUR-Aydın
 * * `TR-04` - TUR-Ağrı
 * * `TR-10` - TUR-Balıkesir
 * * `TR-74` - TUR-Bartın
 * * `TR-72` - TUR-Batman
 * * `TR-69` - TUR-Bayburt
 * * `TR-11` - TUR-Bilecik
 * * `TR-12` - TUR-Bingöl
 * * `TR-13` - TUR-Bitlis
 * * `TR-14` - TUR-Bolu
 * * `TR-15` - TUR-Burdur
 * * `TR-16` - TUR-Bursa
 * * `TR-20` - TUR-Denizli
 * * `TR-21` - TUR-Diyarbakır
 * * `TR-81` - TUR-Düzce
 * * `TR-22` - TUR-Edirne
 * * `TR-23` - TUR-Elazığ
 * * `TR-24` - TUR-Erzincan
 * * `TR-25` - TUR-Erzurum
 * * `TR-26` - TUR-Eskişehir
 * * `TR-27` - TUR-Gaziantep
 * * `TR-28` - TUR-Giresun
 * * `TR-29` - TUR-Gümüşhane
 * * `TR-30` - TUR-Hakkâri
 * * `TR-31` - TUR-Hatay
 * * `TR-32` - TUR-Isparta
 * * `TR-76` - TUR-Iğdır
 * * `TR-46` - TUR-Kahramanmaraş
 * * `TR-78` - TUR-Karabük
 * * `TR-70` - TUR-Karaman
 * * `TR-36` - TUR-Kars
 * * `TR-37` - TUR-Kastamonu
 * * `TR-38` - TUR-Kayseri
 * * `TR-79` - TUR-Kilis
 * * `TR-41` - TUR-Kocaeli
 * * `TR-42` - TUR-Konya
 * * `TR-43` - TUR-Kütahya
 * * `TR-39` - TUR-Kırklareli
 * * `TR-71` - TUR-Kırıkkale
 * * `TR-40` - TUR-Kırşehir
 * * `TR-44` - TUR-Malatya
 * * `TR-45` - TUR-Manisa
 * * `TR-47` - TUR-Mardin
 * * `TR-33` - TUR-Mersin
 * * `TR-48` - TUR-Muğla
 * * `TR-49` - TUR-Muş
 * * `TR-50` - TUR-Nevşehir
 * * `TR-51` - TUR-Niğde
 * * `TR-52` - TUR-Ordu
 * * `TR-80` - TUR-Osmaniye
 * * `TR-53` - TUR-Rize
 * * `TR-54` - TUR-Sakarya
 * * `TR-55` - TUR-Samsun
 * * `TR-56` - TUR-Siirt
 * * `TR-57` - TUR-Sinop
 * * `TR-58` - TUR-Sivas
 * * `TR-59` - TUR-Tekirdağ
 * * `TR-60` - TUR-Tokat
 * * `TR-61` - TUR-Trabzon
 * * `TR-62` - TUR-Tunceli
 * * `TR-64` - TUR-Uşak
 * * `TR-65` - TUR-Van
 * * `TR-77` - TUR-Yalova
 * * `TR-66` - TUR-Yozgat
 * * `TR-67` - TUR-Zonguldak
 * * `TR-17` - TUR-Çanakkale
 * * `TR-18` - TUR-Çankırı
 * * `TR-19` - TUR-Çorum
 * * `TR-34` - TUR-İstanbul
 * * `TR-35` - TUR-İzmir
 * * `TR-63` - TUR-Şanlıurfa
 * * `TR-73` - TUR-Şırnak
 * * `TV-FUN` - TUV-Funafuti
 * * `TV-NMG` - TUV-Nanumaga
 * * `TV-NMA` - TUV-Nanumea
 * * `TV-NIT` - TUV-Niutao
 * * `TV-NUI` - TUV-Nui
 * * `TV-NKF` - TUV-Nukufetau
 * * `TV-NKL` - TUV-Nukulaelae
 * * `TV-VAI` - TUV-Vaitupu
 * * `TW-CHA` - TWN-Changhua
 * * `TW-CYI` - TWN-Chiayi
 * * `TW-CYQ` - TWN-Chiayi
 * * `TW-HSQ` - TWN-Hsinchu
 * * `TW-HSZ` - TWN-Hsinchu
 * * `TW-HUA` - TWN-Hualien
 * * `TW-KHH` - TWN-Kaohsiung
 * * `TW-KEE` - TWN-Keelung
 * * `TW-KIN` - TWN-Kinmen
 * * `TW-LIE` - TWN-Lienchiang
 * * `TW-MIA` - TWN-Miaoli
 * * `TW-NAN` - TWN-Nantou
 * * `TW-NWT` - TWN-New Taipei
 * * `TW-PEN` - TWN-Penghu
 * * `TW-PIF` - TWN-Pingtung
 * * `TW-TXG` - TWN-Taichung
 * * `TW-TNN` - TWN-Tainan
 * * `TW-TPE` - TWN-Taipei
 * * `TW-TTT` - TWN-Taitung
 * * `TW-TAO` - TWN-Taoyuan
 * * `TW-ILA` - TWN-Yilan
 * * `TW-YUN` - TWN-Yunlin
 * * `TZ-01` - TZA-Arusha
 * * `TZ-19` - TZA-Coast
 * * `TZ-02` - TZA-Dar es Salaam
 * * `TZ-03` - TZA-Dodoma
 * * `TZ-27` - TZA-Geita
 * * `TZ-04` - TZA-Iringa
 * * `TZ-05` - TZA-Kagera
 * * `TZ-28` - TZA-Katavi
 * * `TZ-08` - TZA-Kigoma
 * * `TZ-09` - TZA-Kilimanjaro
 * * `TZ-12` - TZA-Lindi
 * * `TZ-26` - TZA-Manyara
 * * `TZ-13` - TZA-Mara
 * * `TZ-14` - TZA-Mbeya
 * * `TZ-16` - TZA-Morogoro
 * * `TZ-17` - TZA-Mtwara
 * * `TZ-18` - TZA-Mwanza
 * * `TZ-29` - TZA-Njombe
 * * `TZ-06` - TZA-Pemba North
 * * `TZ-10` - TZA-Pemba South
 * * `TZ-20` - TZA-Rukwa
 * * `TZ-21` - TZA-Ruvuma
 * * `TZ-22` - TZA-Shinyanga
 * * `TZ-30` - TZA-Simiyu
 * * `TZ-23` - TZA-Singida
 * * `TZ-31` - TZA-Songwe
 * * `TZ-24` - TZA-Tabora
 * * `TZ-25` - TZA-Tanga
 * * `TZ-07` - TZA-Zanzibar North
 * * `TZ-11` - TZA-Zanzibar South
 * * `TZ-15` - TZA-Zanzibar West
 * * `UG-314` - UGA-Abim
 * * `UG-301` - UGA-Adjumani
 * * `UG-322` - UGA-Agago
 * * `UG-323` - UGA-Alebtong
 * * `UG-315` - UGA-Amolatar
 * * `UG-324` - UGA-Amudat
 * * `UG-216` - UGA-Amuria
 * * `UG-316` - UGA-Amuru
 * * `UG-302` - UGA-Apac
 * * `UG-303` - UGA-Arua
 * * `UG-217` - UGA-Budaka
 * * `UG-218` - UGA-Bududa
 * * `UG-201` - UGA-Bugiri
 * * `UG-235` - UGA-Bugweri
 * * `UG-420` - UGA-Buhweju
 * * `UG-117` - UGA-Buikwe
 * * `UG-219` - UGA-Bukedea
 * * `UG-118` - UGA-Bukomansibi
 * * `UG-220` - UGA-Bukwo
 * * `UG-225` - UGA-Bulambuli
 * * `UG-416` - UGA-Buliisa
 * * `UG-401` - UGA-Bundibugyo
 * * `UG-430` - UGA-Bunyangabu
 * * `UG-402` - UGA-Bushenyi
 * * `UG-202` - UGA-Busia
 * * `UG-221` - UGA-Butaleja
 * * `UG-119` - UGA-Butambala
 * * `UG-233` - UGA-Butebo
 * * `UG-120` - UGA-Buvuma
 * * `UG-226` - UGA-Buyende
 * * `UG-C` - UGA-Central
 * * `UG-317` - UGA-Dokolo
 * * `UG-E` - UGA-Eastern
 * * `UG-121` - UGA-Gomba
 * * `UG-304` - UGA-Gulu
 * * `UG-403` - UGA-Hoima
 * * `UG-417` - UGA-Ibanda
 * * `UG-203` - UGA-Iganga
 * * `UG-418` - UGA-Isingiro
 * * `UG-204` - UGA-Jinja
 * * `UG-318` - UGA-Kaabong
 * * `UG-404` - UGA-Kabale
 * * `UG-405` - UGA-Kabarole
 * * `UG-213` - UGA-Kaberamaido
 * * `UG-427` - UGA-Kagadi
 * * `UG-428` - UGA-Kakumiro
 * * `UG-237` - UGA-Kalaki
 * * `UG-101` - UGA-Kalangala
 * * `UG-222` - UGA-Kaliro
 * * `UG-122` - UGA-Kalungu
 * * `UG-102` - UGA-Kampala
 * * `UG-205` - UGA-Kamuli
 * * `UG-413` - UGA-Kamwenge
 * * `UG-414` - UGA-Kanungu
 * * `UG-206` - UGA-Kapchorwa
 * * `UG-236` - UGA-Kapelebyong
 * * `UG-335` - UGA-Karenga
 * * `UG-126` - UGA-Kasanda
 * * `UG-406` - UGA-Kasese
 * * `UG-207` - UGA-Katakwi
 * * `UG-112` - UGA-Kayunga
 * * `UG-433` - UGA-Kazo
 * * `UG-407` - UGA-Kibaale
 * * `UG-103` - UGA-Kiboga
 * * `UG-227` - UGA-Kibuku
 * * `UG-432` - UGA-Kikuube
 * * `UG-419` - UGA-Kiruhura
 * * `UG-421` - UGA-Kiryandongo
 * * `UG-408` - UGA-Kisoro
 * * `UG-434` - UGA-Kitagwenda
 * * `UG-305` - UGA-Kitgum
 * * `UG-319` - UGA-Koboko
 * * `UG-325` - UGA-Kole
 * * `UG-306` - UGA-Kotido
 * * `UG-208` - UGA-Kumi
 * * `UG-333` - UGA-Kwania
 * * `UG-228` - UGA-Kween
 * * `UG-123` - UGA-Kyankwanzi
 * * `UG-422` - UGA-Kyegegwa
 * * `UG-415` - UGA-Kyenjojo
 * * `UG-125` - UGA-Kyotera
 * * `UG-326` - UGA-Lamwo
 * * `UG-307` - UGA-Lira
 * * `UG-229` - UGA-Luuka
 * * `UG-104` - UGA-Luwero
 * * `UG-124` - UGA-Lwengo
 * * `UG-114` - UGA-Lyantonde
 * * `UG-336` - UGA-Madi-Okollo
 * * `UG-223` - UGA-Manafwa
 * * `UG-320` - UGA-Maracha
 * * `UG-105` - UGA-Masaka
 * * `UG-409` - UGA-Masindi
 * * `UG-214` - UGA-Mayuge
 * * `UG-209` - UGA-Mbale
 * * `UG-410` - UGA-Mbarara
 * * `UG-423` - UGA-Mitooma
 * * `UG-115` - UGA-Mityana
 * * `UG-308` - UGA-Moroto
 * * `UG-309` - UGA-Moyo
 * * `UG-106` - UGA-Mpigi
 * * `UG-107` - UGA-Mubende
 * * `UG-108` - UGA-Mukono
 * * `UG-334` - UGA-Nabilatuk
 * * `UG-311` - UGA-Nakapiripirit
 * * `UG-116` - UGA-Nakaseke
 * * `UG-109` - UGA-Nakasongola
 * * `UG-230` - UGA-Namayingo
 * * `UG-234` - UGA-Namisindwa
 * * `UG-224` - UGA-Namutumba
 * * `UG-327` - UGA-Napak
 * * `UG-310` - UGA-Nebbi
 * * `UG-231` - UGA-Ngora
 * * `UG-N` - UGA-Northern
 * * `UG-424` - UGA-Ntoroko
 * * `UG-411` - UGA-Ntungamo
 * * `UG-328` - UGA-Nwoya
 * * `UG-337` - UGA-Obongi
 * * `UG-331` - UGA-Omoro
 * * `UG-329` - UGA-Otuke
 * * `UG-321` - UGA-Oyam
 * * `UG-312` - UGA-Pader
 * * `UG-332` - UGA-Pakwach
 * * `UG-210` - UGA-Pallisa
 * * `UG-110` - UGA-Rakai
 * * `UG-429` - UGA-Rubanda
 * * `UG-425` - UGA-Rubirizi
 * * `UG-431` - UGA-Rukiga
 * * `UG-412` - UGA-Rukungiri
 * * `UG-435` - UGA-Rwampara
 * * `UG-111` - UGA-Sembabule
 * * `UG-232` - UGA-Serere
 * * `UG-426` - UGA-Sheema
 * * `UG-215` - UGA-Sironko
 * * `UG-211` - UGA-Soroti
 * * `UG-212` - UGA-Tororo
 * * `UG-113` - UGA-Wakiso
 * * `UG-W` - UGA-Western
 * * `UG-313` - UGA-Yumbe
 * * `UG-330` - UGA-Zombo
 * * `UA-43` - UKR-Avtonomna Respublika Krym
 * * `UA-71` - UKR-Cherkaska oblast
 * * `UA-74` - UKR-Chernihivska oblast
 * * `UA-77` - UKR-Chernivetska oblast
 * * `UA-12` - UKR-Dnipropetrovska oblast
 * * `UA-14` - UKR-Donetska oblast
 * * `UA-26` - UKR-Ivano-Frankivska oblast
 * * `UA-63` - UKR-Kharkivska oblast
 * * `UA-65` - UKR-Khersonska oblast
 * * `UA-68` - UKR-Khmelnytska oblast
 * * `UA-35` - UKR-Kirovohradska oblast
 * * `UA-30` - UKR-Kyiv
 * * `UA-32` - UKR-Kyivska oblast
 * * `UA-09` - UKR-Luhanska oblast
 * * `UA-46` - UKR-Lvivska oblast
 * * `UA-48` - UKR-Mykolaivska oblast
 * * `UA-51` - UKR-Odeska oblast
 * * `UA-53` - UKR-Poltavska oblast
 * * `UA-56` - UKR-Rivnenska oblast
 * * `UA-40` - UKR-Sevastopol
 * * `UA-59` - UKR-Sumska oblast
 * * `UA-61` - UKR-Ternopilska oblast
 * * `UA-05` - UKR-Vinnytska oblast
 * * `UA-07` - UKR-Volynska oblast
 * * `UA-21` - UKR-Zakarpatska oblast
 * * `UA-23` - UKR-Zaporizka oblast
 * * `UA-18` - UKR-Zhytomyrska oblast
 * * `UM-81` - UMI-Baker Island
 * * `UM-84` - UMI-Howland Island
 * * `UM-86` - UMI-Jarvis Island
 * * `UM-67` - UMI-Johnston Atoll
 * * `UM-89` - UMI-Kingman Reef
 * * `UM-71` - UMI-Midway Islands
 * * `UM-76` - UMI-Navassa Island
 * * `UM-95` - UMI-Palmyra Atoll
 * * `UM-79` - UMI-Wake Island
 * * `UY-AR` - URY-Artigas
 * * `UY-CA` - URY-Canelones
 * * `UY-CL` - URY-Cerro Largo
 * * `UY-CO` - URY-Colonia
 * * `UY-DU` - URY-Durazno
 * * `UY-FS` - URY-Flores
 * * `UY-FD` - URY-Florida
 * * `UY-LA` - URY-Lavalleja
 * * `UY-MA` - URY-Maldonado
 * * `UY-MO` - URY-Montevideo
 * * `UY-PA` - URY-Paysandú
 * * `UY-RV` - URY-Rivera
 * * `UY-RO` - URY-Rocha
 * * `UY-RN` - URY-Río Negro
 * * `UY-SA` - URY-Salto
 * * `UY-SJ` - URY-San José
 * * `UY-SO` - URY-Soriano
 * * `UY-TA` - URY-Tacuarembó
 * * `UY-TT` - URY-Treinta y Tres
 * * `US-AL` - USA-Alabama
 * * `US-AK` - USA-Alaska
 * * `US-AS` - USA-American Samoa
 * * `US-AZ` - USA-Arizona
 * * `US-AR` - USA-Arkansas
 * * `US-CA` - USA-California
 * * `US-CO` - USA-Colorado
 * * `US-CT` - USA-Connecticut
 * * `US-DE` - USA-Delaware
 * * `US-DC` - USA-District of Columbia
 * * `US-FL` - USA-Florida
 * * `US-GA` - USA-Georgia
 * * `US-GU` - USA-Guam
 * * `US-HI` - USA-Hawaii
 * * `US-ID` - USA-Idaho
 * * `US-IL` - USA-Illinois
 * * `US-IN` - USA-Indiana
 * * `US-IA` - USA-Iowa
 * * `US-KS` - USA-Kansas
 * * `US-KY` - USA-Kentucky
 * * `US-LA` - USA-Louisiana
 * * `US-ME` - USA-Maine
 * * `US-MD` - USA-Maryland
 * * `US-MA` - USA-Massachusetts
 * * `US-MI` - USA-Michigan
 * * `US-MN` - USA-Minnesota
 * * `US-MS` - USA-Mississippi
 * * `US-MO` - USA-Missouri
 * * `US-MT` - USA-Montana
 * * `US-NE` - USA-Nebraska
 * * `US-NV` - USA-Nevada
 * * `US-NH` - USA-New Hampshire
 * * `US-NJ` - USA-New Jersey
 * * `US-NM` - USA-New Mexico
 * * `US-NY` - USA-New York
 * * `US-NC` - USA-North Carolina
 * * `US-ND` - USA-North Dakota
 * * `US-MP` - USA-Northern Mariana Islands
 * * `US-OH` - USA-Ohio
 * * `US-OK` - USA-Oklahoma
 * * `US-OR` - USA-Oregon
 * * `US-PA` - USA-Pennsylvania
 * * `US-PR` - USA-Puerto Rico
 * * `US-RI` - USA-Rhode Island
 * * `US-SC` - USA-South Carolina
 * * `US-SD` - USA-South Dakota
 * * `US-TN` - USA-Tennessee
 * * `US-TX` - USA-Texas
 * * `US-UM` - USA-United States Minor Outlying Islands
 * * `US-UT` - USA-Utah
 * * `US-VT` - USA-Vermont
 * * `US-VI` - USA-Virgin Islands, U.S.
 * * `US-VA` - USA-Virginia
 * * `US-WA` - USA-Washington
 * * `US-WV` - USA-West Virginia
 * * `US-WI` - USA-Wisconsin
 * * `US-WY` - USA-Wyoming
 * * `UZ-AN` - UZB-Andijon
 * * `UZ-BU` - UZB-Buxoro
 * * `UZ-FA` - UZB-Farg‘ona
 * * `UZ-JI` - UZB-Jizzax
 * * `UZ-NG` - UZB-Namangan
 * * `UZ-NW` - UZB-Navoiy
 * * `UZ-QA` - UZB-Qashqadaryo
 * * `UZ-QR` - UZB-Qoraqalpog‘iston Respublikasi
 * * `UZ-SA` - UZB-Samarqand
 * * `UZ-SI` - UZB-Sirdaryo
 * * `UZ-SU` - UZB-Surxondaryo
 * * `UZ-TK` - UZB-Toshkent
 * * `UZ-TO` - UZB-Toshkent
 * * `UZ-XO` - UZB-Xorazm
 * * `VC-01` - VCT-Charlotte
 * * `VC-06` - VCT-Grenadines
 * * `VC-02` - VCT-Saint Andrew
 * * `VC-03` - VCT-Saint David
 * * `VC-04` - VCT-Saint George
 * * `VC-05` - VCT-Saint Patrick
 * * `VE-Z` - VEN-Amazonas
 * * `VE-B` - VEN-Anzoátegui
 * * `VE-C` - VEN-Apure
 * * `VE-D` - VEN-Aragua
 * * `VE-E` - VEN-Barinas
 * * `VE-F` - VEN-Bolívar
 * * `VE-G` - VEN-Carabobo
 * * `VE-H` - VEN-Cojedes
 * * `VE-Y` - VEN-Delta Amacuro
 * * `VE-W` - VEN-Dependencias Federales
 * * `VE-A` - VEN-Distrito Capital
 * * `VE-I` - VEN-Falcón
 * * `VE-J` - VEN-Guárico
 * * `VE-X` - VEN-La Guaira
 * * `VE-K` - VEN-Lara
 * * `VE-M` - VEN-Miranda
 * * `VE-N` - VEN-Monagas
 * * `VE-L` - VEN-Mérida
 * * `VE-O` - VEN-Nueva Esparta
 * * `VE-P` - VEN-Portuguesa
 * * `VE-R` - VEN-Sucre
 * * `VE-T` - VEN-Trujillo
 * * `VE-S` - VEN-Táchira
 * * `VE-U` - VEN-Yaracuy
 * * `VE-V` - VEN-Zulia
 * * `VN-44` - VNM-An Giang
 * * `VN-43` - VNM-Bà Rịa - Vũng Tàu
 * * `VN-57` - VNM-Bình Dương
 * * `VN-58` - VNM-Bình Phước
 * * `VN-40` - VNM-Bình Thuận
 * * `VN-31` - VNM-Bình Định
 * * `VN-55` - VNM-Bạc Liêu
 * * `VN-54` - VNM-Bắc Giang
 * * `VN-53` - VNM-Bắc Kạn
 * * `VN-56` - VNM-Bắc Ninh
 * * `VN-50` - VNM-Bến Tre
 * * `VN-04` - VNM-Cao Bằng
 * * `VN-59` - VNM-Cà Mau
 * * `VN-CT` - VNM-Cần Thơ
 * * `VN-30` - VNM-Gia Lai
 * * `VN-03` - VNM-Hà Giang
 * * `VN-63` - VNM-Hà Nam
 * * `VN-HN` - VNM-Hà Nội
 * * `VN-23` - VNM-Hà Tĩnh
 * * `VN-14` - VNM-Hòa Bình
 * * `VN-66` - VNM-Hưng Yên
 * * `VN-61` - VNM-Hải Dương
 * * `VN-HP` - VNM-Hải Phòng
 * * `VN-73` - VNM-Hậu Giang
 * * `VN-SG` - VNM-Hồ Chí Minh
 * * `VN-34` - VNM-Khánh Hòa
 * * `VN-47` - VNM-Kiến Giang
 * * `VN-28` - VNM-Kon Tum
 * * `VN-01` - VNM-Lai Châu
 * * `VN-41` - VNM-Long An
 * * `VN-02` - VNM-Lào Cai
 * * `VN-35` - VNM-Lâm Đồng
 * * `VN-09` - VNM-Lạng Sơn
 * * `VN-67` - VNM-Nam Định
 * * `VN-22` - VNM-Nghệ An
 * * `VN-18` - VNM-Ninh Bình
 * * `VN-36` - VNM-Ninh Thuận
 * * `VN-68` - VNM-Phú Thọ
 * * `VN-32` - VNM-Phú Yên
 * * `VN-24` - VNM-Quảng Bình
 * * `VN-27` - VNM-Quảng Nam
 * * `VN-29` - VNM-Quảng Ngãi
 * * `VN-13` - VNM-Quảng Ninh
 * * `VN-25` - VNM-Quảng Trị
 * * `VN-52` - VNM-Sóc Trăng
 * * `VN-05` - VNM-Sơn La
 * * `VN-21` - VNM-Thanh Hóa
 * * `VN-20` - VNM-Thái Bình
 * * `VN-69` - VNM-Thái Nguyên
 * * `VN-26` - VNM-Thừa Thiên-Huế
 * * `VN-46` - VNM-Tiền Giang
 * * `VN-51` - VNM-Trà Vinh
 * * `VN-07` - VNM-Tuyên Quang
 * * `VN-37` - VNM-Tây Ninh
 * * `VN-49` - VNM-Vĩnh Long
 * * `VN-70` - VNM-Vĩnh Phúc
 * * `VN-06` - VNM-Yên Bái
 * * `VN-71` - VNM-Điện Biên
 * * `VN-DN` - VNM-Đà Nẵng
 * * `VN-33` - VNM-Đắk Lắk
 * * `VN-72` - VNM-Đắk Nông
 * * `VN-39` - VNM-Đồng Nai
 * * `VN-45` - VNM-Đồng Tháp
 * * `VU-MAP` - VUT-Malampa
 * * `VU-PAM` - VUT-Pénama
 * * `VU-SAM` - VUT-Sanma
 * * `VU-SEE` - VUT-Shéfa
 * * `VU-TAE` - VUT-Taféa
 * * `VU-TOB` - VUT-Torba
 * * `WF-AL` - WLF-Alo
 * * `WF-SG` - WLF-Sigave
 * * `WF-UV` - WLF-Uvea
 * * `WS-AA` - WSM-A'ana
 * * `WS-AL` - WSM-Aiga-i-le-Tai
 * * `WS-AT` - WSM-Atua
 * * `WS-FA` - WSM-Fa'asaleleaga
 * * `WS-GE` - WSM-Gaga'emauga
 * * `WS-GI` - WSM-Gagaifomauga
 * * `WS-PA` - WSM-Palauli
 * * `WS-SA` - WSM-Satupa'itea
 * * `WS-TU` - WSM-Tuamasaga
 * * `WS-VF` - WSM-Va'a-o-Fonoti
 * * `WS-VS` - WSM-Vaisigano
 * * `YE-AB` - YEM-Abyan
 * * `YE-BA` - YEM-Al Bayḑā’
 * * `YE-JA` - YEM-Al Jawf
 * * `YE-MR` - YEM-Al Mahrah
 * * `YE-MW` - YEM-Al Maḩwīt
 * * `YE-HU` - YEM-Al Ḩudaydah
 * * `YE-SA` - YEM-Amānat al ‘Āşimah [city]
 * * `YE-SU` - YEM-Arkhabīl Suquţrá
 * * `YE-DA` - YEM-Aḑ Ḑāli‘
 * * `YE-DH` - YEM-Dhamār
 * * `YE-IB` - YEM-Ibb
 * * `YE-LA` - YEM-Laḩij
 * * `YE-MA` - YEM-Ma’rib
 * * `YE-RA` - YEM-Raymah
 * * `YE-SH` - YEM-Shabwah
 * * `YE-TA` - YEM-Tāʻizz
 * * `YE-SN` - YEM-Şanʻā’
 * * `YE-SD` - YEM-Şāʻdah
 * * `YE-HJ` - YEM-Ḩajjah
 * * `YE-HD` - YEM-Ḩaḑramawt
 * * `YE-AD` - YEM-‘Adan
 * * `YE-AM` - YEM-‘Amrān
 * * `ZA-EC` - ZAF-Eastern Cape
 * * `ZA-FS` - ZAF-Free State
 * * `ZA-GP` - ZAF-Gauteng
 * * `ZA-KZN` - ZAF-Kwazulu-Natal
 * * `ZA-LP` - ZAF-Limpopo
 * * `ZA-MP` - ZAF-Mpumalanga
 * * `ZA-NW` - ZAF-North-West
 * * `ZA-NC` - ZAF-Northern Cape
 * * `ZA-WC` - ZAF-Western Cape
 * * `ZM-02` - ZMB-Central
 * * `ZM-08` - ZMB-Copperbelt
 * * `ZM-03` - ZMB-Eastern
 * * `ZM-04` - ZMB-Luapula
 * * `ZM-09` - ZMB-Lusaka
 * * `ZM-10` - ZMB-Muchinga
 * * `ZM-06` - ZMB-North-Western
 * * `ZM-05` - ZMB-Northern
 * * `ZM-07` - ZMB-Southern
 * * `ZM-01` - ZMB-Western
 * * `ZW-BU` - ZWE-Bulawayo
 * * `ZW-HA` - ZWE-Harare
 * * `ZW-MA` - ZWE-Manicaland
 * * `ZW-MC` - ZWE-Mashonaland Central
 * * `ZW-ME` - ZWE-Mashonaland East
 * * `ZW-MW` - ZWE-Mashonaland West
 * * `ZW-MV` - ZWE-Masvingo
 * * `ZW-MN` - ZWE-Matabeleland North
 * * `ZW-MS` - ZWE-Matabeleland South
 * * `ZW-MI` - ZWE-Midlands
 */
export enum RegionEnum {
    AF_BDS = 'AF-BDS',
    AF_BGL = 'AF-BGL',
    AF_BAL = 'AF-BAL',
    AF_BDG = 'AF-BDG',
    AF_BAM = 'AF-BAM',
    AF_DAY = 'AF-DAY',
    AF_FRA = 'AF-FRA',
    AF_FYB = 'AF-FYB',
    AF_GHA = 'AF-GHA',
    AF_GHO = 'AF-GHO',
    AF_HEL = 'AF-HEL',
    AF_HER = 'AF-HER',
    AF_JOW = 'AF-JOW',
    AF_KAN = 'AF-KAN',
    AF_KHO = 'AF-KHO',
    AF_KNR = 'AF-KNR',
    AF_KDZ = 'AF-KDZ',
    AF_KAB = 'AF-KAB',
    AF_KAP = 'AF-KAP',
    AF_LAG = 'AF-LAG',
    AF_LOG = 'AF-LOG',
    AF_NAN = 'AF-NAN',
    AF_NIM = 'AF-NIM',
    AF_NUR = 'AF-NUR',
    AF_PIA = 'AF-PIA',
    AF_PKA = 'AF-PKA',
    AF_PAN = 'AF-PAN',
    AF_PAR = 'AF-PAR',
    AF_SAM = 'AF-SAM',
    AF_SAR = 'AF-SAR',
    AF_TAK = 'AF-TAK',
    AF_URU = 'AF-URU',
    AF_WAR = 'AF-WAR',
    AF_ZAB = 'AF-ZAB',
    AO_BGO = 'AO-BGO',
    AO_BGU = 'AO-BGU',
    AO_BIE = 'AO-BIE',
    AO_CAB = 'AO-CAB',
    AO_CCU = 'AO-CCU',
    AO_CNO = 'AO-CNO',
    AO_CUS = 'AO-CUS',
    AO_CNN = 'AO-CNN',
    AO_HUA = 'AO-HUA',
    AO_HUI = 'AO-HUI',
    AO_LUA = 'AO-LUA',
    AO_LNO = 'AO-LNO',
    AO_LSU = 'AO-LSU',
    AO_MAL = 'AO-MAL',
    AO_MOX = 'AO-MOX',
    AO_NAM = 'AO-NAM',
    AO_UIG = 'AO-UIG',
    AO_ZAI = 'AO-ZAI',
    AL_01 = 'AL-01',
    AL_09 = 'AL-09',
    AL_02 = 'AL-02',
    AL_03 = 'AL-03',
    AL_04 = 'AL-04',
    AL_05 = 'AL-05',
    AL_06 = 'AL-06',
    AL_07 = 'AL-07',
    AL_08 = 'AL-08',
    AL_10 = 'AL-10',
    AL_11 = 'AL-11',
    AL_12 = 'AL-12',
    AD_07 = 'AD-07',
    AD_02 = 'AD-02',
    AD_03 = 'AD-03',
    AD_08 = 'AD-08',
    AD_04 = 'AD-04',
    AD_05 = 'AD-05',
    AD_06 = 'AD-06',
    AE_AZ = 'AE-AZ',
    AE_FU = 'AE-FU',
    AE_SH = 'AE-SH',
    AE_DU = 'AE-DU',
    AE_RK = 'AE-RK',
    AE_UQ = 'AE-UQ',
    AE_AJ = 'AE-AJ',
    AR_B = 'AR-B',
    AR_K = 'AR-K',
    AR_H = 'AR-H',
    AR_U = 'AR-U',
    AR_C = 'AR-C',
    AR_W = 'AR-W',
    AR_X = 'AR-X',
    AR_E = 'AR-E',
    AR_P = 'AR-P',
    AR_Y = 'AR-Y',
    AR_L = 'AR-L',
    AR_F = 'AR-F',
    AR_M = 'AR-M',
    AR_N = 'AR-N',
    AR_Q = 'AR-Q',
    AR_R = 'AR-R',
    AR_A = 'AR-A',
    AR_J = 'AR-J',
    AR_D = 'AR-D',
    AR_Z = 'AR-Z',
    AR_S = 'AR-S',
    AR_G = 'AR-G',
    AR_V = 'AR-V',
    AR_T = 'AR-T',
    AM_AG = 'AM-AG',
    AM_AR = 'AM-AR',
    AM_AV = 'AM-AV',
    AM_ER = 'AM-ER',
    AM_GR = 'AM-GR',
    AM_KT = 'AM-KT',
    AM_LO = 'AM-LO',
    AM_SU = 'AM-SU',
    AM_TV = 'AM-TV',
    AM_VD = 'AM-VD',
    AM_SH = 'AM-SH',
    AG_10 = 'AG-10',
    AG_11 = 'AG-11',
    AG_03 = 'AG-03',
    AG_04 = 'AG-04',
    AG_05 = 'AG-05',
    AG_06 = 'AG-06',
    AG_07 = 'AG-07',
    AG_08 = 'AG-08',
    AU_ACT = 'AU-ACT',
    AU_NSW = 'AU-NSW',
    AU_NT = 'AU-NT',
    AU_QLD = 'AU-QLD',
    AU_SA = 'AU-SA',
    AU_TAS = 'AU-TAS',
    AU_VIC = 'AU-VIC',
    AU_WA = 'AU-WA',
    AT_1 = 'AT-1',
    AT_2 = 'AT-2',
    AT_3 = 'AT-3',
    AT_4 = 'AT-4',
    AT_5 = 'AT-5',
    AT_6 = 'AT-6',
    AT_7 = 'AT-7',
    AT_8 = 'AT-8',
    AT_9 = 'AT-9',
    AZ_ABS = 'AZ-ABS',
    AZ_AST = 'AZ-AST',
    AZ_AGC = 'AZ-AGC',
    AZ_AGM = 'AZ-AGM',
    AZ_AGS = 'AZ-AGS',
    AZ_AGA = 'AZ-AGA',
    AZ_AGU = 'AZ-AGU',
    AZ_BAB = 'AZ-BAB',
    AZ_BA = 'AZ-BA',
    AZ_BAL = 'AZ-BAL',
    AZ_BEY = 'AZ-BEY',
    AZ_BIL = 'AZ-BIL',
    AZ_BAR = 'AZ-BAR',
    AZ_CUL = 'AZ-CUL',
    AZ_CAB = 'AZ-CAB',
    AZ_CAL = 'AZ-CAL',
    AZ_DAS = 'AZ-DAS',
    AZ_FUZ = 'AZ-FUZ',
    AZ_GOR = 'AZ-GOR',
    AZ_GYG = 'AZ-GYG',
    AZ_GOY = 'AZ-GOY',
    AZ_GAD = 'AZ-GAD',
    AZ_GA = 'AZ-GA',
    AZ_HAC = 'AZ-HAC',
    AZ_KUR = 'AZ-KUR',
    AZ_KAN = 'AZ-KAN',
    AZ_KAL = 'AZ-KAL',
    AZ_LAC = 'AZ-LAC',
    AZ_LER = 'AZ-LER',
    AZ_LA = 'AZ-LA',
    AZ_LAN = 'AZ-LAN',
    AZ_MAS = 'AZ-MAS',
    AZ_MI = 'AZ-MI',
    AZ_NA = 'AZ-NA',
    AZ_NV = 'AZ-NV',
    AZ_NX = 'AZ-NX',
    AZ_NEF = 'AZ-NEF',
    AZ_ORD = 'AZ-ORD',
    AZ_OGU = 'AZ-OGU',
    AZ_QAX = 'AZ-QAX',
    AZ_QAZ = 'AZ-QAZ',
    AZ_QOB = 'AZ-QOB',
    AZ_QBA = 'AZ-QBA',
    AZ_QBI = 'AZ-QBI',
    AZ_QUS = 'AZ-QUS',
    AZ_QAB = 'AZ-QAB',
    AZ_SAT = 'AZ-SAT',
    AZ_SAB = 'AZ-SAB',
    AZ_SAL = 'AZ-SAL',
    AZ_SMX = 'AZ-SMX',
    AZ_SIY = 'AZ-SIY',
    AZ_SM = 'AZ-SM',
    AZ_SAD = 'AZ-SAD',
    AZ_TOV = 'AZ-TOV',
    AZ_TAR = 'AZ-TAR',
    AZ_UCA = 'AZ-UCA',
    AZ_XA = 'AZ-XA',
    AZ_XAC = 'AZ-XAC',
    AZ_XCI = 'AZ-XCI',
    AZ_XVD = 'AZ-XVD',
    AZ_XIZ = 'AZ-XIZ',
    AZ_YAR = 'AZ-YAR',
    AZ_YE = 'AZ-YE',
    AZ_YEV = 'AZ-YEV',
    AZ_ZAQ = 'AZ-ZAQ',
    AZ_ZAN = 'AZ-ZAN',
    AZ_ZAR = 'AZ-ZAR',
    AZ_IMI = 'AZ-IMI',
    AZ_ISM = 'AZ-ISM',
    AZ_SBN = 'AZ-SBN',
    AZ_SAH = 'AZ-SAH',
    AZ_SMI = 'AZ-SMI',
    AZ_SR = 'AZ-SR',
    AZ_SUS = 'AZ-SUS',
    AZ_SA = 'AZ-SA',
    AZ_SAK = 'AZ-SAK',
    AZ_SKR = 'AZ-SKR',
    AZ_SAR = 'AZ-SAR',
    BI_BB = 'BI-BB',
    BI_BM = 'BI-BM',
    BI_BL = 'BI-BL',
    BI_BR = 'BI-BR',
    BI_CA = 'BI-CA',
    BI_CI = 'BI-CI',
    BI_GI = 'BI-GI',
    BI_KR = 'BI-KR',
    BI_KY = 'BI-KY',
    BI_KI = 'BI-KI',
    BI_MA = 'BI-MA',
    BI_MU = 'BI-MU',
    BI_MY = 'BI-MY',
    BI_MW = 'BI-MW',
    BI_NG = 'BI-NG',
    BI_RM = 'BI-RM',
    BI_RT = 'BI-RT',
    BI_RY = 'BI-RY',
    BE_VAN = 'BE-VAN',
    BE_WBR = 'BE-WBR',
    BE_BRU = 'BE-BRU',
    BE_WHT = 'BE-WHT',
    BE_VLI = 'BE-VLI',
    BE_WLG = 'BE-WLG',
    BE_WLX = 'BE-WLX',
    BE_WNA = 'BE-WNA',
    BE_VOV = 'BE-VOV',
    BE_VLG = 'BE-VLG',
    BE_VBR = 'BE-VBR',
    BE_VWV = 'BE-VWV',
    BE_WAL = 'BE-WAL',
    BJ_AL = 'BJ-AL',
    BJ_AK = 'BJ-AK',
    BJ_AQ = 'BJ-AQ',
    BJ_BO = 'BJ-BO',
    BJ_CO = 'BJ-CO',
    BJ_KO = 'BJ-KO',
    BJ_DO = 'BJ-DO',
    BJ_LI = 'BJ-LI',
    BJ_MO = 'BJ-MO',
    BJ_OU = 'BJ-OU',
    BJ_PL = 'BJ-PL',
    BJ_ZO = 'BJ-ZO',
    BQ_BO = 'BQ-BO',
    BQ_SA = 'BQ-SA',
    BQ_SE = 'BQ-SE',
    BF_BAL = 'BF-BAL',
    BF_BAM = 'BF-BAM',
    BF_BAN = 'BF-BAN',
    BF_BAZ = 'BF-BAZ',
    BF_01 = 'BF-01',
    BF_BGR = 'BF-BGR',
    BF_BLG = 'BF-BLG',
    BF_BLK = 'BF-BLK',
    BF_02 = 'BF-02',
    BF_03 = 'BF-03',
    BF_04 = 'BF-04',
    BF_05 = 'BF-05',
    BF_06 = 'BF-06',
    BF_07 = 'BF-07',
    BF_COM = 'BF-COM',
    BF_08 = 'BF-08',
    BF_GAN = 'BF-GAN',
    BF_GNA = 'BF-GNA',
    BF_GOU = 'BF-GOU',
    BF_09 = 'BF-09',
    BF_HOU = 'BF-HOU',
    BF_IOB = 'BF-IOB',
    BF_KAD = 'BF-KAD',
    BF_KMD = 'BF-KMD',
    BF_KMP = 'BF-KMP',
    BF_KOS = 'BF-KOS',
    BF_KOP = 'BF-KOP',
    BF_KOT = 'BF-KOT',
    BF_KOW = 'BF-KOW',
    BF_KEN = 'BF-KEN',
    BF_LOR = 'BF-LOR',
    BF_LER = 'BF-LER',
    BF_MOU = 'BF-MOU',
    BF_NAO = 'BF-NAO',
    BF_NAM = 'BF-NAM',
    BF_NAY = 'BF-NAY',
    BF_10 = 'BF-10',
    BF_NOU = 'BF-NOU',
    BF_OUB = 'BF-OUB',
    BF_OUD = 'BF-OUD',
    BF_PAS = 'BF-PAS',
    BF_11 = 'BF-11',
    BF_PON = 'BF-PON',
    BF_12 = 'BF-12',
    BF_SNG = 'BF-SNG',
    BF_SMT = 'BF-SMT',
    BF_SIS = 'BF-SIS',
    BF_SOM = 'BF-SOM',
    BF_SOR = 'BF-SOR',
    BF_13 = 'BF-13',
    BF_SEN = 'BF-SEN',
    BF_TAP = 'BF-TAP',
    BF_TUI = 'BF-TUI',
    BF_YAG = 'BF-YAG',
    BF_YAT = 'BF-YAT',
    BF_ZIR = 'BF-ZIR',
    BF_ZON = 'BF-ZON',
    BF_ZOU = 'BF-ZOU',
    BD_05 = 'BD-05',
    BD_01 = 'BD-01',
    BD_02 = 'BD-02',
    BD_06 = 'BD-06',
    BD_A = 'BD-A',
    BD_07 = 'BD-07',
    BD_03 = 'BD-03',
    BD_04 = 'BD-04',
    BD_09 = 'BD-09',
    BD_45 = 'BD-45',
    BD_10 = 'BD-10',
    BD_B = 'BD-B',
    BD_12 = 'BD-12',
    BD_11 = 'BD-11',
    BD_08 = 'BD-08',
    BD_13 = 'BD-13',
    BD_C = 'BD-C',
    BD_14 = 'BD-14',
    BD_15 = 'BD-15',
    BD_16 = 'BD-16',
    BD_19 = 'BD-19',
    BD_18 = 'BD-18',
    BD_17 = 'BD-17',
    BD_20 = 'BD-20',
    BD_21 = 'BD-21',
    BD_22 = 'BD-22',
    BD_25 = 'BD-25',
    BD_23 = 'BD-23',
    BD_24 = 'BD-24',
    BD_29 = 'BD-29',
    BD_27 = 'BD-27',
    BD_D = 'BD-D',
    BD_26 = 'BD-26',
    BD_28 = 'BD-28',
    BD_30 = 'BD-30',
    BD_31 = 'BD-31',
    BD_32 = 'BD-32',
    BD_36 = 'BD-36',
    BD_37 = 'BD-37',
    BD_33 = 'BD-33',
    BD_39 = 'BD-39',
    BD_38 = 'BD-38',
    BD_35 = 'BD-35',
    BD_34 = 'BD-34',
    BD_H = 'BD-H',
    BD_48 = 'BD-48',
    BD_43 = 'BD-43',
    BD_40 = 'BD-40',
    BD_42 = 'BD-42',
    BD_44 = 'BD-44',
    BD_41 = 'BD-41',
    BD_46 = 'BD-46',
    BD_47 = 'BD-47',
    BD_49 = 'BD-49',
    BD_52 = 'BD-52',
    BD_51 = 'BD-51',
    BD_50 = 'BD-50',
    BD_53 = 'BD-53',
    BD_54 = 'BD-54',
    BD_E = 'BD-E',
    BD_56 = 'BD-56',
    BD_55 = 'BD-55',
    BD_F = 'BD-F',
    BD_58 = 'BD-58',
    BD_62 = 'BD-62',
    BD_57 = 'BD-57',
    BD_59 = 'BD-59',
    BD_61 = 'BD-61',
    BD_60 = 'BD-60',
    BD_G = 'BD-G',
    BD_63 = 'BD-63',
    BD_64 = 'BD-64',
    BG_01 = 'BG-01',
    BG_02 = 'BG-02',
    BG_08 = 'BG-08',
    BG_07 = 'BG-07',
    BG_26 = 'BG-26',
    BG_09 = 'BG-09',
    BG_10 = 'BG-10',
    BG_11 = 'BG-11',
    BG_12 = 'BG-12',
    BG_13 = 'BG-13',
    BG_14 = 'BG-14',
    BG_15 = 'BG-15',
    BG_16 = 'BG-16',
    BG_17 = 'BG-17',
    BG_18 = 'BG-18',
    BG_27 = 'BG-27',
    BG_19 = 'BG-19',
    BG_20 = 'BG-20',
    BG_21 = 'BG-21',
    BG_23 = 'BG-23',
    BG_22 = 'BG-22',
    BG_24 = 'BG-24',
    BG_25 = 'BG-25',
    BG_03 = 'BG-03',
    BG_04 = 'BG-04',
    BG_05 = 'BG-05',
    BG_06 = 'BG-06',
    BG_28 = 'BG-28',
    BH_14 = 'BH-14',
    BH_15 = 'BH-15',
    BH_13 = 'BH-13',
    BH_17 = 'BH-17',
    BS_AK = 'BS-AK',
    BS_BY = 'BS-BY',
    BS_BI = 'BS-BI',
    BS_BP = 'BS-BP',
    BS_CI = 'BS-CI',
    BS_CO = 'BS-CO',
    BS_CS = 'BS-CS',
    BS_CE = 'BS-CE',
    BS_FP = 'BS-FP',
    BS_CK = 'BS-CK',
    BS_EG = 'BS-EG',
    BS_EX = 'BS-EX',
    BS_GC = 'BS-GC',
    BS_HI = 'BS-HI',
    BS_HT = 'BS-HT',
    BS_IN = 'BS-IN',
    BS_LI = 'BS-LI',
    BS_MC = 'BS-MC',
    BS_MG = 'BS-MG',
    BS_MI = 'BS-MI',
    BS_NP = 'BS-NP',
    BS_NO = 'BS-NO',
    BS_NS = 'BS-NS',
    BS_NE = 'BS-NE',
    BS_RI = 'BS-RI',
    BS_RC = 'BS-RC',
    BS_SS = 'BS-SS',
    BS_SO = 'BS-SO',
    BS_SA = 'BS-SA',
    BS_SE = 'BS-SE',
    BS_SW = 'BS-SW',
    BS_WG = 'BS-WG',
    BA_BRC = 'BA-BRC',
    BA_BIH = 'BA-BIH',
    BA_SRP = 'BA-SRP',
    BY_BR = 'BY-BR',
    BY_HO = 'BY-HO',
    BY_HM = 'BY-HM',
    BY_HR = 'BY-HR',
    BY_MA = 'BY-MA',
    BY_MI = 'BY-MI',
    BY_VI = 'BY-VI',
    BZ_BZ = 'BZ-BZ',
    BZ_CY = 'BZ-CY',
    BZ_CZL = 'BZ-CZL',
    BZ_OW = 'BZ-OW',
    BZ_SC = 'BZ-SC',
    BZ_TOL = 'BZ-TOL',
    BO_H = 'BO-H',
    BO_C = 'BO-C',
    BO_B = 'BO-B',
    BO_L = 'BO-L',
    BO_O = 'BO-O',
    BO_N = 'BO-N',
    BO_P = 'BO-P',
    BO_S = 'BO-S',
    BO_T = 'BO-T',
    BR_AC = 'BR-AC',
    BR_AL = 'BR-AL',
    BR_AP = 'BR-AP',
    BR_AM = 'BR-AM',
    BR_BA = 'BR-BA',
    BR_CE = 'BR-CE',
    BR_DF = 'BR-DF',
    BR_ES = 'BR-ES',
    BR_GO = 'BR-GO',
    BR_MA = 'BR-MA',
    BR_MT = 'BR-MT',
    BR_MS = 'BR-MS',
    BR_MG = 'BR-MG',
    BR_PR = 'BR-PR',
    BR_PB = 'BR-PB',
    BR_PA = 'BR-PA',
    BR_PE = 'BR-PE',
    BR_PI = 'BR-PI',
    BR_RN = 'BR-RN',
    BR_RS = 'BR-RS',
    BR_RJ = 'BR-RJ',
    BR_RO = 'BR-RO',
    BR_RR = 'BR-RR',
    BR_SC = 'BR-SC',
    BR_SE = 'BR-SE',
    BR_SP = 'BR-SP',
    BR_TO = 'BR-TO',
    BB_01 = 'BB-01',
    BB_02 = 'BB-02',
    BB_03 = 'BB-03',
    BB_04 = 'BB-04',
    BB_05 = 'BB-05',
    BB_06 = 'BB-06',
    BB_07 = 'BB-07',
    BB_08 = 'BB-08',
    BB_09 = 'BB-09',
    BB_10 = 'BB-10',
    BB_11 = 'BB-11',
    BN_BE = 'BN-BE',
    BN_BM = 'BN-BM',
    BN_TE = 'BN-TE',
    BN_TU = 'BN-TU',
    BT_33 = 'BT-33',
    BT_12 = 'BT-12',
    BT_22 = 'BT-22',
    BT_GA = 'BT-GA',
    BT_13 = 'BT-13',
    BT_44 = 'BT-44',
    BT_42 = 'BT-42',
    BT_11 = 'BT-11',
    BT_43 = 'BT-43',
    BT_23 = 'BT-23',
    BT_45 = 'BT-45',
    BT_14 = 'BT-14',
    BT_31 = 'BT-31',
    BT_15 = 'BT-15',
    BT_TY = 'BT-TY',
    BT_41 = 'BT-41',
    BT_32 = 'BT-32',
    BT_21 = 'BT-21',
    BT_24 = 'BT-24',
    BT_34 = 'BT-34',
    BW_CE = 'BW-CE',
    BW_CH = 'BW-CH',
    BW_FR = 'BW-FR',
    BW_GA = 'BW-GA',
    BW_GH = 'BW-GH',
    BW_JW = 'BW-JW',
    BW_KG = 'BW-KG',
    BW_KL = 'BW-KL',
    BW_KW = 'BW-KW',
    BW_LO = 'BW-LO',
    BW_NE = 'BW-NE',
    BW_NW = 'BW-NW',
    BW_SP = 'BW-SP',
    BW_SE = 'BW-SE',
    BW_SO = 'BW-SO',
    BW_ST = 'BW-ST',
    CF_BB = 'CF-BB',
    CF_BGF = 'CF-BGF',
    CF_BK = 'CF-BK',
    CF_KB = 'CF-KB',
    CF_HM = 'CF-HM',
    CF_HK = 'CF-HK',
    CF_HS = 'CF-HS',
    CF_KG = 'CF-KG',
    CF_LB = 'CF-LB',
    CF_MB = 'CF-MB',
    CF_NM = 'CF-NM',
    CF_MP = 'CF-MP',
    CF_UK = 'CF-UK',
    CF_AC = 'CF-AC',
    CF_OP = 'CF-OP',
    CF_SE = 'CF-SE',
    CF_VK = 'CF-VK',
    CA_AB = 'CA-AB',
    CA_BC = 'CA-BC',
    CA_MB = 'CA-MB',
    CA_NB = 'CA-NB',
    CA_NL = 'CA-NL',
    CA_NT = 'CA-NT',
    CA_NS = 'CA-NS',
    CA_NU = 'CA-NU',
    CA_ON = 'CA-ON',
    CA_PE = 'CA-PE',
    CA_QC = 'CA-QC',
    CA_SK = 'CA-SK',
    CA_YT = 'CA-YT',
    CH_AG = 'CH-AG',
    CH_AR = 'CH-AR',
    CH_AI = 'CH-AI',
    CH_BL = 'CH-BL',
    CH_BS = 'CH-BS',
    CH_BE = 'CH-BE',
    CH_FR = 'CH-FR',
    CH_GE = 'CH-GE',
    CH_GL = 'CH-GL',
    CH_GR = 'CH-GR',
    CH_JU = 'CH-JU',
    CH_LU = 'CH-LU',
    CH_NE = 'CH-NE',
    CH_NW = 'CH-NW',
    CH_OW = 'CH-OW',
    CH_SG = 'CH-SG',
    CH_SH = 'CH-SH',
    CH_SZ = 'CH-SZ',
    CH_SO = 'CH-SO',
    CH_TG = 'CH-TG',
    CH_TI = 'CH-TI',
    CH_UR = 'CH-UR',
    CH_VS = 'CH-VS',
    CH_VD = 'CH-VD',
    CH_ZG = 'CH-ZG',
    CH_ZH = 'CH-ZH',
    CL_AI = 'CL-AI',
    CL_AN = 'CL-AN',
    CL_AP = 'CL-AP',
    CL_AT = 'CL-AT',
    CL_BI = 'CL-BI',
    CL_CO = 'CL-CO',
    CL_AR = 'CL-AR',
    CL_LI = 'CL-LI',
    CL_LL = 'CL-LL',
    CL_LR = 'CL-LR',
    CL_MA = 'CL-MA',
    CL_ML = 'CL-ML',
    CL_RM = 'CL-RM',
    CL_TA = 'CL-TA',
    CL_VS = 'CL-VS',
    CL_NB = 'CL-NB',
    CN_AH = 'CN-AH',
    CN_BJ = 'CN-BJ',
    CN_CQ = 'CN-CQ',
    CN_FJ = 'CN-FJ',
    CN_GS = 'CN-GS',
    CN_GD = 'CN-GD',
    CN_GX = 'CN-GX',
    CN_GZ = 'CN-GZ',
    CN_HI = 'CN-HI',
    CN_HE = 'CN-HE',
    CN_HL = 'CN-HL',
    CN_HA = 'CN-HA',
    CN_HK = 'CN-HK',
    CN_HB = 'CN-HB',
    CN_HN = 'CN-HN',
    CN_JS = 'CN-JS',
    CN_JX = 'CN-JX',
    CN_JL = 'CN-JL',
    CN_LN = 'CN-LN',
    CN_MO = 'CN-MO',
    CN_NM = 'CN-NM',
    CN_NX = 'CN-NX',
    CN_QH = 'CN-QH',
    CN_SN = 'CN-SN',
    CN_SD = 'CN-SD',
    CN_SH = 'CN-SH',
    CN_SX = 'CN-SX',
    CN_SC = 'CN-SC',
    CN_TW = 'CN-TW',
    CN_TJ = 'CN-TJ',
    CN_XJ = 'CN-XJ',
    CN_XZ = 'CN-XZ',
    CN_YN = 'CN-YN',
    CN_ZJ = 'CN-ZJ',
    CI_AB = 'CI-AB',
    CI_BS = 'CI-BS',
    CI_CM = 'CI-CM',
    CI_DN = 'CI-DN',
    CI_GD = 'CI-GD',
    CI_LC = 'CI-LC',
    CI_LG = 'CI-LG',
    CI_MG = 'CI-MG',
    CI_SM = 'CI-SM',
    CI_SV = 'CI-SV',
    CI_VB = 'CI-VB',
    CI_WR = 'CI-WR',
    CI_YM = 'CI-YM',
    CI_ZZ = 'CI-ZZ',
    CM_AD = 'CM-AD',
    CM_CE = 'CM-CE',
    CM_ES = 'CM-ES',
    CM_EN = 'CM-EN',
    CM_LT = 'CM-LT',
    CM_NO = 'CM-NO',
    CM_NW = 'CM-NW',
    CM_SU = 'CM-SU',
    CM_SW = 'CM-SW',
    CM_OU = 'CM-OU',
    CD_BU = 'CD-BU',
    CD_HK = 'CD-HK',
    CD_HL = 'CD-HL',
    CD_HU = 'CD-HU',
    CD_IT = 'CD-IT',
    CD_KS = 'CD-KS',
    CD_KC = 'CD-KC',
    CD_KE = 'CD-KE',
    CD_KN = 'CD-KN',
    CD_BC = 'CD-BC',
    CD_KG = 'CD-KG',
    CD_KL = 'CD-KL',
    CD_LO = 'CD-LO',
    CD_LU = 'CD-LU',
    CD_MN = 'CD-MN',
    CD_MA = 'CD-MA',
    CD_MO = 'CD-MO',
    CD_NK = 'CD-NK',
    CD_NU = 'CD-NU',
    CD_SA = 'CD-SA',
    CD_SK = 'CD-SK',
    CD_SU = 'CD-SU',
    CD_TA = 'CD-TA',
    CD_TO = 'CD-TO',
    CD_TU = 'CD-TU',
    CD_EQ = 'CD-EQ',
    CG_11 = 'CG-11',
    CG_BZV = 'CG-BZV',
    CG_8 = 'CG-8',
    CG_15 = 'CG-15',
    CG_5 = 'CG-5',
    CG_7 = 'CG-7',
    CG_2 = 'CG-2',
    CG_9 = 'CG-9',
    CG_14 = 'CG-14',
    CG_16 = 'CG-16',
    CG_12 = 'CG-12',
    CG_13 = 'CG-13',
    CO_AMA = 'CO-AMA',
    CO_ANT = 'CO-ANT',
    CO_ARA = 'CO-ARA',
    CO_ATL = 'CO-ATL',
    CO_BOL = 'CO-BOL',
    CO_BOY = 'CO-BOY',
    CO_CAL = 'CO-CAL',
    CO_CAQ = 'CO-CAQ',
    CO_CAS = 'CO-CAS',
    CO_CAU = 'CO-CAU',
    CO_CES = 'CO-CES',
    CO_CHO = 'CO-CHO',
    CO_CUN = 'CO-CUN',
    CO_COR = 'CO-COR',
    CO_DC = 'CO-DC',
    CO_GUA = 'CO-GUA',
    CO_GUV = 'CO-GUV',
    CO_HUI = 'CO-HUI',
    CO_LAG = 'CO-LAG',
    CO_MAG = 'CO-MAG',
    CO_MET = 'CO-MET',
    CO_NAR = 'CO-NAR',
    CO_NSA = 'CO-NSA',
    CO_PUT = 'CO-PUT',
    CO_QUI = 'CO-QUI',
    CO_RIS = 'CO-RIS',
    CO_SAP = 'CO-SAP',
    CO_SAN = 'CO-SAN',
    CO_SUC = 'CO-SUC',
    CO_TOL = 'CO-TOL',
    CO_VAC = 'CO-VAC',
    CO_VAU = 'CO-VAU',
    CO_VID = 'CO-VID',
    KM_A = 'KM-A',
    KM_G = 'KM-G',
    KM_M = 'KM-M',
    CV_BV = 'CV-BV',
    CV_BR = 'CV-BR',
    CV_B = 'CV-B',
    CV_S = 'CV-S',
    CV_MA = 'CV-MA',
    CV_MO = 'CV-MO',
    CV_PA = 'CV-PA',
    CV_PN = 'CV-PN',
    CV_PR = 'CV-PR',
    CV_RB = 'CV-RB',
    CV_RG = 'CV-RG',
    CV_RS = 'CV-RS',
    CV_SL = 'CV-SL',
    CV_CA = 'CV-CA',
    CV_CF = 'CV-CF',
    CV_CR = 'CV-CR',
    CV_SD = 'CV-SD',
    CV_SF = 'CV-SF',
    CV_SO = 'CV-SO',
    CV_SM = 'CV-SM',
    CV_SS = 'CV-SS',
    CV_SV = 'CV-SV',
    CV_TA = 'CV-TA',
    CV_TS = 'CV-TS',
    CR_A = 'CR-A',
    CR_C = 'CR-C',
    CR_G = 'CR-G',
    CR_H = 'CR-H',
    CR_L = 'CR-L',
    CR_P = 'CR-P',
    CR_SJ = 'CR-SJ',
    CU_15 = 'CU-15',
    CU_09 = 'CU-09',
    CU_08 = 'CU-08',
    CU_06 = 'CU-06',
    CU_12 = 'CU-12',
    CU_14 = 'CU-14',
    CU_11 = 'CU-11',
    CU_99 = 'CU-99',
    CU_03 = 'CU-03',
    CU_10 = 'CU-10',
    CU_04 = 'CU-04',
    CU_16 = 'CU-16',
    CU_01 = 'CU-01',
    CU_07 = 'CU-07',
    CU_13 = 'CU-13',
    CU_05 = 'CU-05',
    CY_04 = 'CY-04',
    CY_05 = 'CY-05',
    CY_06 = 'CY-06',
    CY_03 = 'CY-03',
    CY_01 = 'CY-01',
    CY_02 = 'CY-02',
    CZ_201 = 'CZ-201',
    CZ_202 = 'CZ-202',
    CZ_641 = 'CZ-641',
    CZ_642 = 'CZ-642',
    CZ_643 = 'CZ-643',
    CZ_801 = 'CZ-801',
    CZ_644 = 'CZ-644',
    CZ_411 = 'CZ-411',
    CZ_422 = 'CZ-422',
    CZ_531 = 'CZ-531',
    CZ_321 = 'CZ-321',
    CZ_421 = 'CZ-421',
    CZ_802 = 'CZ-802',
    CZ_631 = 'CZ-631',
    CZ_645 = 'CZ-645',
    CZ_521 = 'CZ-521',
    CZ_512 = 'CZ-512',
    CZ_711 = 'CZ-711',
    CZ_632 = 'CZ-632',
    CZ_64 = 'CZ-64',
    CZ_31 = 'CZ-31',
    CZ_313 = 'CZ-313',
    CZ_522 = 'CZ-522',
    CZ_41 = 'CZ-41',
    CZ_412 = 'CZ-412',
    CZ_803 = 'CZ-803',
    CZ_203 = 'CZ-203',
    CZ_322 = 'CZ-322',
    CZ_204 = 'CZ-204',
    CZ_63 = 'CZ-63',
    CZ_721 = 'CZ-721',
    CZ_52 = 'CZ-52',
    CZ_205 = 'CZ-205',
    CZ_513 = 'CZ-513',
    CZ_51 = 'CZ-51',
    CZ_423 = 'CZ-423',
    CZ_424 = 'CZ-424',
    CZ_207 = 'CZ-207',
    CZ_80 = 'CZ-80',
    CZ_425 = 'CZ-425',
    CZ_206 = 'CZ-206',
    CZ_804 = 'CZ-804',
    CZ_208 = 'CZ-208',
    CZ_523 = 'CZ-523',
    CZ_712 = 'CZ-712',
    CZ_71 = 'CZ-71',
    CZ_805 = 'CZ-805',
    CZ_806 = 'CZ-806',
    CZ_532 = 'CZ-532',
    CZ_53 = 'CZ-53',
    CZ_633 = 'CZ-633',
    CZ_324 = 'CZ-324',
    CZ_323 = 'CZ-323',
    CZ_325 = 'CZ-325',
    CZ_32 = 'CZ-32',
    CZ_315 = 'CZ-315',
    CZ_10 = 'CZ-10',
    CZ_209 = 'CZ-209',
    CZ_20A = 'CZ-20A',
    CZ_713 = 'CZ-713',
    CZ_314 = 'CZ-314',
    CZ_714 = 'CZ-714',
    CZ_20B = 'CZ-20B',
    CZ_20C = 'CZ-20C',
    CZ_326 = 'CZ-326',
    CZ_524 = 'CZ-524',
    CZ_514 = 'CZ-514',
    CZ_413 = 'CZ-413',
    CZ_316 = 'CZ-316',
    CZ_20 = 'CZ-20',
    CZ_533 = 'CZ-533',
    CZ_327 = 'CZ-327',
    CZ_426 = 'CZ-426',
    CZ_525 = 'CZ-525',
    CZ_317 = 'CZ-317',
    CZ_634 = 'CZ-634',
    CZ_722 = 'CZ-722',
    CZ_723 = 'CZ-723',
    CZ_646 = 'CZ-646',
    CZ_724 = 'CZ-724',
    CZ_72 = 'CZ-72',
    CZ_647 = 'CZ-647',
    CZ_42 = 'CZ-42',
    CZ_427 = 'CZ-427',
    CZ_534 = 'CZ-534',
    CZ_511 = 'CZ-511',
    CZ_311 = 'CZ-311',
    CZ_312 = 'CZ-312',
    CZ_715 = 'CZ-715',
    CZ_635 = 'CZ-635',
    DE_BW = 'DE-BW',
    DE_BY = 'DE-BY',
    DE_BE = 'DE-BE',
    DE_BB = 'DE-BB',
    DE_HB = 'DE-HB',
    DE_HH = 'DE-HH',
    DE_HE = 'DE-HE',
    DE_MV = 'DE-MV',
    DE_NI = 'DE-NI',
    DE_NW = 'DE-NW',
    DE_RP = 'DE-RP',
    DE_SL = 'DE-SL',
    DE_SN = 'DE-SN',
    DE_ST = 'DE-ST',
    DE_SH = 'DE-SH',
    DE_TH = 'DE-TH',
    DJ_AS = 'DJ-AS',
    DJ_AR = 'DJ-AR',
    DJ_DI = 'DJ-DI',
    DJ_DJ = 'DJ-DJ',
    DJ_OB = 'DJ-OB',
    DJ_TA = 'DJ-TA',
    DM_02 = 'DM-02',
    DM_03 = 'DM-03',
    DM_04 = 'DM-04',
    DM_05 = 'DM-05',
    DM_06 = 'DM-06',
    DM_07 = 'DM-07',
    DM_08 = 'DM-08',
    DM_09 = 'DM-09',
    DM_10 = 'DM-10',
    DM_11 = 'DM-11',
    DK_84 = 'DK-84',
    DK_82 = 'DK-82',
    DK_81 = 'DK-81',
    DK_85 = 'DK-85',
    DK_83 = 'DK-83',
    DO_02 = 'DO-02',
    DO_03 = 'DO-03',
    DO_04 = 'DO-04',
    DO_33 = 'DO-33',
    DO_34 = 'DO-34',
    DO_35 = 'DO-35',
    DO_36 = 'DO-36',
    DO_05 = 'DO-05',
    DO_01 = 'DO-01',
    DO_06 = 'DO-06',
    DO_08 = 'DO-08',
    DO_37 = 'DO-37',
    DO_07 = 'DO-07',
    DO_38 = 'DO-38',
    DO_09 = 'DO-09',
    DO_30 = 'DO-30',
    DO_19 = 'DO-19',
    DO_39 = 'DO-39',
    DO_10 = 'DO-10',
    DO_11 = 'DO-11',
    DO_12 = 'DO-12',
    DO_13 = 'DO-13',
    DO_14 = 'DO-14',
    DO_28 = 'DO-28',
    DO_15 = 'DO-15',
    DO_29 = 'DO-29',
    DO_40 = 'DO-40',
    DO_16 = 'DO-16',
    DO_17 = 'DO-17',
    DO_18 = 'DO-18',
    DO_20 = 'DO-20',
    DO_21 = 'DO-21',
    DO_31 = 'DO-31',
    DO_22 = 'DO-22',
    DO_23 = 'DO-23',
    DO_25 = 'DO-25',
    DO_26 = 'DO-26',
    DO_32 = 'DO-32',
    DO_24 = 'DO-24',
    DO_41 = 'DO-41',
    DO_27 = 'DO-27',
    DO_42 = 'DO-42',
    DZ_01 = 'DZ-01',
    DZ_16 = 'DZ-16',
    DZ_23 = 'DZ-23',
    DZ_44 = 'DZ-44',
    DZ_46 = 'DZ-46',
    DZ_05 = 'DZ-05',
    DZ_07 = 'DZ-07',
    DZ_09 = 'DZ-09',
    DZ_50 = 'DZ-50',
    DZ_34 = 'DZ-34',
    DZ_10 = 'DZ-10',
    DZ_35 = 'DZ-35',
    DZ_08 = 'DZ-08',
    DZ_06 = 'DZ-06',
    DZ_52 = 'DZ-52',
    DZ_02 = 'DZ-02',
    DZ_25 = 'DZ-25',
    DZ_56 = 'DZ-56',
    DZ_17 = 'DZ-17',
    DZ_32 = 'DZ-32',
    DZ_57 = 'DZ-57',
    DZ_58 = 'DZ-58',
    DZ_39 = 'DZ-39',
    DZ_36 = 'DZ-36',
    DZ_47 = 'DZ-47',
    DZ_24 = 'DZ-24',
    DZ_33 = 'DZ-33',
    DZ_54 = 'DZ-54',
    DZ_53 = 'DZ-53',
    DZ_18 = 'DZ-18',
    DZ_40 = 'DZ-40',
    DZ_03 = 'DZ-03',
    DZ_28 = 'DZ-28',
    DZ_29 = 'DZ-29',
    DZ_43 = 'DZ-43',
    DZ_27 = 'DZ-27',
    DZ_26 = 'DZ-26',
    DZ_45 = 'DZ-45',
    DZ_31 = 'DZ-31',
    DZ_30 = 'DZ-30',
    DZ_51 = 'DZ-51',
    DZ_04 = 'DZ-04',
    DZ_48 = 'DZ-48',
    DZ_20 = 'DZ-20',
    DZ_22 = 'DZ-22',
    DZ_21 = 'DZ-21',
    DZ_41 = 'DZ-41',
    DZ_19 = 'DZ-19',
    DZ_11 = 'DZ-11',
    DZ_14 = 'DZ-14',
    DZ_49 = 'DZ-49',
    DZ_37 = 'DZ-37',
    DZ_42 = 'DZ-42',
    DZ_38 = 'DZ-38',
    DZ_15 = 'DZ-15',
    DZ_13 = 'DZ-13',
    DZ_55 = 'DZ-55',
    DZ_12 = 'DZ-12',
    EC_A = 'EC-A',
    EC_B = 'EC-B',
    EC_C = 'EC-C',
    EC_F = 'EC-F',
    EC_H = 'EC-H',
    EC_X = 'EC-X',
    EC_O = 'EC-O',
    EC_E = 'EC-E',
    EC_W = 'EC-W',
    EC_G = 'EC-G',
    EC_I = 'EC-I',
    EC_L = 'EC-L',
    EC_R = 'EC-R',
    EC_M = 'EC-M',
    EC_S = 'EC-S',
    EC_N = 'EC-N',
    EC_D = 'EC-D',
    EC_Y = 'EC-Y',
    EC_P = 'EC-P',
    EC_SE = 'EC-SE',
    EC_SD = 'EC-SD',
    EC_U = 'EC-U',
    EC_T = 'EC-T',
    EC_Z = 'EC-Z',
    EG_DK = 'EG-DK',
    EG_BA = 'EG-BA',
    EG_BH = 'EG-BH',
    EG_FYM = 'EG-FYM',
    EG_GH = 'EG-GH',
    EG_ALX = 'EG-ALX',
    EG_IS = 'EG-IS',
    EG_GZ = 'EG-GZ',
    EG_MN = 'EG-MN',
    EG_MNF = 'EG-MNF',
    EG_KB = 'EG-KB',
    EG_C = 'EG-C',
    EG_LX = 'EG-LX',
    EG_WAD = 'EG-WAD',
    EG_SUZ = 'EG-SUZ',
    EG_SHR = 'EG-SHR',
    EG_ASN = 'EG-ASN',
    EG_AST = 'EG-AST',
    EG_BNS = 'EG-BNS',
    EG_PTS = 'EG-PTS',
    EG_DT = 'EG-DT',
    EG_JS = 'EG-JS',
    EG_KFS = 'EG-KFS',
    EG_MT = 'EG-MT',
    EG_KN = 'EG-KN',
    EG_SIN = 'EG-SIN',
    EG_SHG = 'EG-SHG',
    ER_MA = 'ER-MA',
    ER_DU = 'ER-DU',
    ER_AN = 'ER-AN',
    ER_DK = 'ER-DK',
    ER_GB = 'ER-GB',
    ER_SK = 'ER-SK',
    ES_C = 'ES-C',
    ES_A = 'ES-A',
    ES_AB = 'ES-AB',
    ES_AL = 'ES-AL',
    ES_AN = 'ES-AN',
    ES_VI = 'ES-VI',
    ES_AR = 'ES-AR',
    ES_O = 'ES-O',
    ES_AS = 'ES-AS',
    ES_BA = 'ES-BA',
    ES_B = 'ES-B',
    ES_BI = 'ES-BI',
    ES_BU = 'ES-BU',
    ES_CN = 'ES-CN',
    ES_CB = 'ES-CB',
    ES_S = 'ES-S',
    ES_CS = 'ES-CS',
    ES_CL = 'ES-CL',
    ES_CM = 'ES-CM',
    ES_CT = 'ES-CT',
    ES_CE = 'ES-CE',
    ES_CR = 'ES-CR',
    ES_CU = 'ES-CU',
    ES_CC = 'ES-CC',
    ES_CA = 'ES-CA',
    ES_CO = 'ES-CO',
    ES_PV = 'ES-PV',
    ES_EX = 'ES-EX',
    ES_GA = 'ES-GA',
    ES_SS = 'ES-SS',
    ES_GI = 'ES-GI',
    ES_GR = 'ES-GR',
    ES_GU = 'ES-GU',
    ES_H = 'ES-H',
    ES_HU = 'ES-HU',
    ES_IB = 'ES-IB',
    ES_PM = 'ES-PM',
    ES_J = 'ES-J',
    ES_LO = 'ES-LO',
    ES_RI = 'ES-RI',
    ES_GC = 'ES-GC',
    ES_LE = 'ES-LE',
    ES_L = 'ES-L',
    ES_LU = 'ES-LU',
    ES_M = 'ES-M',
    ES_MD = 'ES-MD',
    ES_ML = 'ES-ML',
    ES_MU = 'ES-MU',
    ES_MC = 'ES-MC',
    ES_MA = 'ES-MA',
    ES_NA = 'ES-NA',
    ES_NC = 'ES-NC',
    ES_OR = 'ES-OR',
    ES_P = 'ES-P',
    ES_PO = 'ES-PO',
    ES_SA = 'ES-SA',
    ES_TF = 'ES-TF',
    ES_SG = 'ES-SG',
    ES_SE = 'ES-SE',
    ES_SO = 'ES-SO',
    ES_T = 'ES-T',
    ES_TE = 'ES-TE',
    ES_TO = 'ES-TO',
    ES_V = 'ES-V',
    ES_VC = 'ES-VC',
    ES_VA = 'ES-VA',
    ES_ZA = 'ES-ZA',
    ES_Z = 'ES-Z',
    ES_AV = 'ES-AV',
    EE_130 = 'EE-130',
    EE_141 = 'EE-141',
    EE_142 = 'EE-142',
    EE_171 = 'EE-171',
    EE_184 = 'EE-184',
    EE_191 = 'EE-191',
    EE_37 = 'EE-37',
    EE_198 = 'EE-198',
    EE_205 = 'EE-205',
    EE_39 = 'EE-39',
    EE_214 = 'EE-214',
    EE_45 = 'EE-45',
    EE_255 = 'EE-255',
    EE_52 = 'EE-52',
    EE_245 = 'EE-245',
    EE_247 = 'EE-247',
    EE_50 = 'EE-50',
    EE_251 = 'EE-251',
    EE_272 = 'EE-272',
    EE_283 = 'EE-283',
    EE_284 = 'EE-284',
    EE_291 = 'EE-291',
    EE_293 = 'EE-293',
    EE_296 = 'EE-296',
    EE_303 = 'EE-303',
    EE_305 = 'EE-305',
    EE_317 = 'EE-317',
    EE_321 = 'EE-321',
    EE_338 = 'EE-338',
    EE_353 = 'EE-353',
    EE_424 = 'EE-424',
    EE_432 = 'EE-432',
    EE_431 = 'EE-431',
    EE_441 = 'EE-441',
    EE_60 = 'EE-60',
    EE_56 = 'EE-56',
    EE_430 = 'EE-430',
    EE_442 = 'EE-442',
    EE_446 = 'EE-446',
    EE_478 = 'EE-478',
    EE_480 = 'EE-480',
    EE_486 = 'EE-486',
    EE_503 = 'EE-503',
    EE_511 = 'EE-511',
    EE_514 = 'EE-514',
    EE_528 = 'EE-528',
    EE_557 = 'EE-557',
    EE_567 = 'EE-567',
    EE_586 = 'EE-586',
    EE_624 = 'EE-624',
    EE_68 = 'EE-68',
    EE_638 = 'EE-638',
    EE_615 = 'EE-615',
    EE_618 = 'EE-618',
    EE_622 = 'EE-622',
    EE_64 = 'EE-64',
    EE_651 = 'EE-651',
    EE_653 = 'EE-653',
    EE_661 = 'EE-661',
    EE_663 = 'EE-663',
    EE_668 = 'EE-668',
    EE_71 = 'EE-71',
    EE_689 = 'EE-689',
    EE_708 = 'EE-708',
    EE_698 = 'EE-698',
    EE_712 = 'EE-712',
    EE_714 = 'EE-714',
    EE_74 = 'EE-74',
    EE_719 = 'EE-719',
    EE_726 = 'EE-726',
    EE_732 = 'EE-732',
    EE_735 = 'EE-735',
    EE_784 = 'EE-784',
    EE_792 = 'EE-792',
    EE_793 = 'EE-793',
    EE_796 = 'EE-796',
    EE_79 = 'EE-79',
    EE_803 = 'EE-803',
    EE_809 = 'EE-809',
    EE_824 = 'EE-824',
    EE_834 = 'EE-834',
    EE_855 = 'EE-855',
    EE_81 = 'EE-81',
    EE_890 = 'EE-890',
    EE_897 = 'EE-897',
    EE_899 = 'EE-899',
    EE_84 = 'EE-84',
    EE_901 = 'EE-901',
    EE_903 = 'EE-903',
    EE_907 = 'EE-907',
    EE_928 = 'EE-928',
    EE_917 = 'EE-917',
    EE_919 = 'EE-919',
    EE_87 = 'EE-87',
    ET_AA = 'ET-AA',
    ET_AF = 'ET-AF',
    ET_AM = 'ET-AM',
    ET_BE = 'ET-BE',
    ET_DD = 'ET-DD',
    ET_GA = 'ET-GA',
    ET_HA = 'ET-HA',
    ET_OR = 'ET-OR',
    ET_SI = 'ET-SI',
    ET_SO = 'ET-SO',
    ET_SN = 'ET-SN',
    ET_SW = 'ET-SW',
    ET_TI = 'ET-TI',
    FI_02 = 'FI-02',
    FI_03 = 'FI-03',
    FI_04 = 'FI-04',
    FI_05 = 'FI-05',
    FI_06 = 'FI-06',
    FI_07 = 'FI-07',
    FI_08 = 'FI-08',
    FI_09 = 'FI-09',
    FI_01 = 'FI-01',
    FI_10 = 'FI-10',
    FI_11 = 'FI-11',
    FI_12 = 'FI-12',
    FI_13 = 'FI-13',
    FI_14 = 'FI-14',
    FI_15 = 'FI-15',
    FI_16 = 'FI-16',
    FI_17 = 'FI-17',
    FI_18 = 'FI-18',
    FI_19 = 'FI-19',
    FJ_01 = 'FJ-01',
    FJ_02 = 'FJ-02',
    FJ_03 = 'FJ-03',
    FJ_C = 'FJ-C',
    FJ_E = 'FJ-E',
    FJ_04 = 'FJ-04',
    FJ_05 = 'FJ-05',
    FJ_06 = 'FJ-06',
    FJ_07 = 'FJ-07',
    FJ_08 = 'FJ-08',
    FJ_09 = 'FJ-09',
    FJ_10 = 'FJ-10',
    FJ_N = 'FJ-N',
    FJ_11 = 'FJ-11',
    FJ_12 = 'FJ-12',
    FJ_R = 'FJ-R',
    FJ_13 = 'FJ-13',
    FJ_14 = 'FJ-14',
    FJ_W = 'FJ-W',
    FR_01 = 'FR-01',
    FR_02 = 'FR-02',
    FR_03 = 'FR-03',
    FR_06 = 'FR-06',
    FR_04 = 'FR-04',
    FR_6AE = 'FR-6AE',
    FR_08 = 'FR-08',
    FR_07 = 'FR-07',
    FR_09 = 'FR-09',
    FR_10 = 'FR-10',
    FR_11 = 'FR-11',
    FR_ARA = 'FR-ARA',
    FR_12 = 'FR-12',
    FR_67 = 'FR-67',
    FR_13 = 'FR-13',
    FR_BFC = 'FR-BFC',
    FR_BRE = 'FR-BRE',
    FR_14 = 'FR-14',
    FR_15 = 'FR-15',
    FR_CVL = 'FR-CVL',
    FR_16 = 'FR-16',
    FR_17 = 'FR-17',
    FR_18 = 'FR-18',
    FR_CP = 'FR-CP',
    FR_19 = 'FR-19',
    FR_20R = 'FR-20R',
    FR_2A = 'FR-2A',
    FR_23 = 'FR-23',
    FR_21 = 'FR-21',
    FR_22 = 'FR-22',
    FR_79 = 'FR-79',
    FR_24 = 'FR-24',
    FR_25 = 'FR-25',
    FR_26 = 'FR-26',
    FR_91 = 'FR-91',
    FR_27 = 'FR-27',
    FR_28 = 'FR-28',
    FR_29 = 'FR-29',
    FR_30 = 'FR-30',
    FR_32 = 'FR-32',
    FR_33 = 'FR-33',
    FR_GES = 'FR-GES',
    FR_971 = 'FR-971',
    FR_973 = 'FR-973',
    FR_68 = 'FR-68',
    FR_2B = 'FR-2B',
    FR_31 = 'FR-31',
    FR_43 = 'FR-43',
    FR_52 = 'FR-52',
    FR_74 = 'FR-74',
    FR_70 = 'FR-70',
    FR_87 = 'FR-87',
    FR_05 = 'FR-05',
    FR_65 = 'FR-65',
    FR_HDF = 'FR-HDF',
    FR_92 = 'FR-92',
    FR_34 = 'FR-34',
    FR_35 = 'FR-35',
    FR_36 = 'FR-36',
    FR_37 = 'FR-37',
    FR_38 = 'FR-38',
    FR_39 = 'FR-39',
    FR_974 = 'FR-974',
    FR_40 = 'FR-40',
    FR_41 = 'FR-41',
    FR_42 = 'FR-42',
    FR_44 = 'FR-44',
    FR_45 = 'FR-45',
    FR_46 = 'FR-46',
    FR_47 = 'FR-47',
    FR_48 = 'FR-48',
    FR_49 = 'FR-49',
    FR_50 = 'FR-50',
    FR_51 = 'FR-51',
    FR_972 = 'FR-972',
    FR_53 = 'FR-53',
    FR_976 = 'FR-976',
    FR_54 = 'FR-54',
    FR_55 = 'FR-55',
    FR_56 = 'FR-56',
    FR_57 = 'FR-57',
    FR_69M = 'FR-69M',
    FR_58 = 'FR-58',
    FR_59 = 'FR-59',
    FR_NOR = 'FR-NOR',
    FR_NAQ = 'FR-NAQ',
    FR_NC = 'FR-NC',
    FR_OCC = 'FR-OCC',
    FR_60 = 'FR-60',
    FR_61 = 'FR-61',
    FR_75C = 'FR-75C',
    FR_62 = 'FR-62',
    FR_PDL = 'FR-PDL',
    FR_PF = 'FR-PF',
    FR_PAC = 'FR-PAC',
    FR_63 = 'FR-63',
    FR_64 = 'FR-64',
    FR_66 = 'FR-66',
    FR_69 = 'FR-69',
    FR_BL = 'FR-BL',
    FR_MF = 'FR-MF',
    FR_PM = 'FR-PM',
    FR_72 = 'FR-72',
    FR_73 = 'FR-73',
    FR_71 = 'FR-71',
    FR_76 = 'FR-76',
    FR_93 = 'FR-93',
    FR_77 = 'FR-77',
    FR_80 = 'FR-80',
    FR_81 = 'FR-81',
    FR_82 = 'FR-82',
    FR_TF = 'FR-TF',
    FR_90 = 'FR-90',
    FR_95 = 'FR-95',
    FR_94 = 'FR-94',
    FR_83 = 'FR-83',
    FR_84 = 'FR-84',
    FR_85 = 'FR-85',
    FR_86 = 'FR-86',
    FR_88 = 'FR-88',
    FR_WF = 'FR-WF',
    FR_89 = 'FR-89',
    FR_78 = 'FR-78',
    FR_IDF = 'FR-IDF',
    FM_TRK = 'FM-TRK',
    FM_KSA = 'FM-KSA',
    FM_PNI = 'FM-PNI',
    FM_YAP = 'FM-YAP',
    GA_1 = 'GA-1',
    GA_2 = 'GA-2',
    GA_3 = 'GA-3',
    GA_4 = 'GA-4',
    GA_5 = 'GA-5',
    GA_6 = 'GA-6',
    GA_7 = 'GA-7',
    GA_8 = 'GA-8',
    GA_9 = 'GA-9',
    GB_ABE = 'GB-ABE',
    GB_ABD = 'GB-ABD',
    GB_ANS = 'GB-ANS',
    GB_ANN = 'GB-ANN',
    GB_AND = 'GB-AND',
    GB_AGB = 'GB-AGB',
    GB_ABC = 'GB-ABC',
    GB_BDG = 'GB-BDG',
    GB_BNE = 'GB-BNE',
    GB_BNS = 'GB-BNS',
    GB_BAS = 'GB-BAS',
    GB_BDF = 'GB-BDF',
    GB_BFS = 'GB-BFS',
    GB_BEX = 'GB-BEX',
    GB_BIR = 'GB-BIR',
    GB_BBD = 'GB-BBD',
    GB_BPL = 'GB-BPL',
    GB_BGW = 'GB-BGW',
    GB_BOL = 'GB-BOL',
    GB_BCP = 'GB-BCP',
    GB_BRC = 'GB-BRC',
    GB_BRD = 'GB-BRD',
    GB_BEN = 'GB-BEN',
    GB_BGE = 'GB-BGE',
    GB_BNH = 'GB-BNH',
    GB_BST = 'GB-BST',
    GB_BRY = 'GB-BRY',
    GB_BKM = 'GB-BKM',
    GB_BUR = 'GB-BUR',
    GB_CAY = 'GB-CAY',
    GB_CLD = 'GB-CLD',
    GB_CAM = 'GB-CAM',
    GB_CMD = 'GB-CMD',
    GB_CRF = 'GB-CRF',
    GB_CMN = 'GB-CMN',
    GB_CCG = 'GB-CCG',
    GB_CBF = 'GB-CBF',
    GB_CGN = 'GB-CGN',
    GB_CHE = 'GB-CHE',
    GB_CHW = 'GB-CHW',
    GB_CLK = 'GB-CLK',
    GB_CWY = 'GB-CWY',
    GB_CON = 'GB-CON',
    GB_COV = 'GB-COV',
    GB_CRY = 'GB-CRY',
    GB_CMA = 'GB-CMA',
    GB_DAL = 'GB-DAL',
    GB_DEN = 'GB-DEN',
    GB_DER = 'GB-DER',
    GB_DBY = 'GB-DBY',
    GB_DRS = 'GB-DRS',
    GB_DEV = 'GB-DEV',
    GB_DNC = 'GB-DNC',
    GB_DOR = 'GB-DOR',
    GB_DUD = 'GB-DUD',
    GB_DGY = 'GB-DGY',
    GB_DND = 'GB-DND',
    GB_DUR = 'GB-DUR',
    GB_EAL = 'GB-EAL',
    GB_EAY = 'GB-EAY',
    GB_EDU = 'GB-EDU',
    GB_ELN = 'GB-ELN',
    GB_ERW = 'GB-ERW',
    GB_ERY = 'GB-ERY',
    GB_ESX = 'GB-ESX',
    GB_EDH = 'GB-EDH',
    GB_ELS = 'GB-ELS',
    GB_ENF = 'GB-ENF',
    GB_ENG = 'GB-ENG',
    GB_ESS = 'GB-ESS',
    GB_FAL = 'GB-FAL',
    GB_FMO = 'GB-FMO',
    GB_FIF = 'GB-FIF',
    GB_FLN = 'GB-FLN',
    GB_GAT = 'GB-GAT',
    GB_GLG = 'GB-GLG',
    GB_GLS = 'GB-GLS',
    GB_GRE = 'GB-GRE',
    GB_GWN = 'GB-GWN',
    GB_HCK = 'GB-HCK',
    GB_HAL = 'GB-HAL',
    GB_HMF = 'GB-HMF',
    GB_HAM = 'GB-HAM',
    GB_HRY = 'GB-HRY',
    GB_HRW = 'GB-HRW',
    GB_HPL = 'GB-HPL',
    GB_HAV = 'GB-HAV',
    GB_HEF = 'GB-HEF',
    GB_HRT = 'GB-HRT',
    GB_HLD = 'GB-HLD',
    GB_HIL = 'GB-HIL',
    GB_HNS = 'GB-HNS',
    GB_IVC = 'GB-IVC',
    GB_AGY = 'GB-AGY',
    GB_IOW = 'GB-IOW',
    GB_IOS = 'GB-IOS',
    GB_ISL = 'GB-ISL',
    GB_KEC = 'GB-KEC',
    GB_KEN = 'GB-KEN',
    GB_KHL = 'GB-KHL',
    GB_KTT = 'GB-KTT',
    GB_KIR = 'GB-KIR',
    GB_KWL = 'GB-KWL',
    GB_LBH = 'GB-LBH',
    GB_LAN = 'GB-LAN',
    GB_LDS = 'GB-LDS',
    GB_LCE = 'GB-LCE',
    GB_LEC = 'GB-LEC',
    GB_LEW = 'GB-LEW',
    GB_LIN = 'GB-LIN',
    GB_LBC = 'GB-LBC',
    GB_LIV = 'GB-LIV',
    GB_LND = 'GB-LND',
    GB_LUT = 'GB-LUT',
    GB_MAN = 'GB-MAN',
    GB_MDW = 'GB-MDW',
    GB_MTY = 'GB-MTY',
    GB_MRT = 'GB-MRT',
    GB_MEA = 'GB-MEA',
    GB_MUL = 'GB-MUL',
    GB_MDB = 'GB-MDB',
    GB_MLN = 'GB-MLN',
    GB_MIK = 'GB-MIK',
    GB_MON = 'GB-MON',
    GB_MRY = 'GB-MRY',
    GB_NTL = 'GB-NTL',
    GB_NET = 'GB-NET',
    GB_NWM = 'GB-NWM',
    GB_NWP = 'GB-NWP',
    GB_NMD = 'GB-NMD',
    GB_NFK = 'GB-NFK',
    GB_NAY = 'GB-NAY',
    GB_NEL = 'GB-NEL',
    GB_NLK = 'GB-NLK',
    GB_NLN = 'GB-NLN',
    GB_NNH = 'GB-NNH',
    GB_NSM = 'GB-NSM',
    GB_NTY = 'GB-NTY',
    GB_NYK = 'GB-NYK',
    GB_NIR = 'GB-NIR',
    GB_NBL = 'GB-NBL',
    GB_NGM = 'GB-NGM',
    GB_NTT = 'GB-NTT',
    GB_OLD = 'GB-OLD',
    GB_ORK = 'GB-ORK',
    GB_OXF = 'GB-OXF',
    GB_PEM = 'GB-PEM',
    GB_PKN = 'GB-PKN',
    GB_PTE = 'GB-PTE',
    GB_PLY = 'GB-PLY',
    GB_POR = 'GB-POR',
    GB_POW = 'GB-POW',
    GB_RDG = 'GB-RDG',
    GB_RDB = 'GB-RDB',
    GB_RCC = 'GB-RCC',
    GB_RFW = 'GB-RFW',
    GB_RCT = 'GB-RCT',
    GB_RIC = 'GB-RIC',
    GB_RCH = 'GB-RCH',
    GB_ROT = 'GB-ROT',
    GB_RUT = 'GB-RUT',
    GB_SLF = 'GB-SLF',
    GB_SAW = 'GB-SAW',
    GB_SCT = 'GB-SCT',
    GB_SCB = 'GB-SCB',
    GB_SFT = 'GB-SFT',
    GB_SHF = 'GB-SHF',
    GB_ZET = 'GB-ZET',
    GB_SHR = 'GB-SHR',
    GB_SLG = 'GB-SLG',
    GB_SOL = 'GB-SOL',
    GB_SOM = 'GB-SOM',
    GB_SAY = 'GB-SAY',
    GB_SGC = 'GB-SGC',
    GB_SLK = 'GB-SLK',
    GB_STY = 'GB-STY',
    GB_STH = 'GB-STH',
    GB_SOS = 'GB-SOS',
    GB_SWK = 'GB-SWK',
    GB_SHN = 'GB-SHN',
    GB_STS = 'GB-STS',
    GB_STG = 'GB-STG',
    GB_SKP = 'GB-SKP',
    GB_STT = 'GB-STT',
    GB_STE = 'GB-STE',
    GB_SFK = 'GB-SFK',
    GB_SND = 'GB-SND',
    GB_SRY = 'GB-SRY',
    GB_STN = 'GB-STN',
    GB_SWA = 'GB-SWA',
    GB_SWD = 'GB-SWD',
    GB_TAM = 'GB-TAM',
    GB_TFW = 'GB-TFW',
    GB_THR = 'GB-THR',
    GB_TOB = 'GB-TOB',
    GB_TOF = 'GB-TOF',
    GB_TWH = 'GB-TWH',
    GB_TRF = 'GB-TRF',
    GB_VGL = 'GB-VGL',
    GB_WKF = 'GB-WKF',
    GB_WLS = 'GB-WLS',
    GB_WLL = 'GB-WLL',
    GB_WFT = 'GB-WFT',
    GB_WND = 'GB-WND',
    GB_WRT = 'GB-WRT',
    GB_WAR = 'GB-WAR',
    GB_WBK = 'GB-WBK',
    GB_WDU = 'GB-WDU',
    GB_WLN = 'GB-WLN',
    GB_WNH = 'GB-WNH',
    GB_WSX = 'GB-WSX',
    GB_WSM = 'GB-WSM',
    GB_WGN = 'GB-WGN',
    GB_WIL = 'GB-WIL',
    GB_WNM = 'GB-WNM',
    GB_WRL = 'GB-WRL',
    GB_WOK = 'GB-WOK',
    GB_WLV = 'GB-WLV',
    GB_WOR = 'GB-WOR',
    GB_WRX = 'GB-WRX',
    GB_YOR = 'GB-YOR',
    GE_AB = 'GE-AB',
    GE_AJ = 'GE-AJ',
    GE_GU = 'GE-GU',
    GE_IM = 'GE-IM',
    GE_KA = 'GE-KA',
    GE_KK = 'GE-KK',
    GE_MM = 'GE-MM',
    GE_RL = 'GE-RL',
    GE_SZ = 'GE-SZ',
    GE_SJ = 'GE-SJ',
    GE_SK = 'GE-SK',
    GE_TB = 'GE-TB',
    GH_AF = 'GH-AF',
    GH_AH = 'GH-AH',
    GH_BO = 'GH-BO',
    GH_BE = 'GH-BE',
    GH_CP = 'GH-CP',
    GH_EP = 'GH-EP',
    GH_AA = 'GH-AA',
    GH_NE = 'GH-NE',
    GH_NP = 'GH-NP',
    GH_OT = 'GH-OT',
    GH_SV = 'GH-SV',
    GH_UE = 'GH-UE',
    GH_UW = 'GH-UW',
    GH_TV = 'GH-TV',
    GH_WP = 'GH-WP',
    GH_WN = 'GH-WN',
    GN_BE = 'GN-BE',
    GN_BF = 'GN-BF',
    GN_B = 'GN-B',
    GN_BK = 'GN-BK',
    GN_C = 'GN-C',
    GN_CO = 'GN-CO',
    GN_DB = 'GN-DB',
    GN_DL = 'GN-DL',
    GN_DI = 'GN-DI',
    GN_DU = 'GN-DU',
    GN_F = 'GN-F',
    GN_FA = 'GN-FA',
    GN_FO = 'GN-FO',
    GN_FR = 'GN-FR',
    GN_GA = 'GN-GA',
    GN_GU = 'GN-GU',
    GN_K = 'GN-K',
    GN_KA = 'GN-KA',
    GN_D = 'GN-D',
    GN_KD = 'GN-KD',
    GN_KS = 'GN-KS',
    GN_KB = 'GN-KB',
    GN_KN = 'GN-KN',
    GN_KO = 'GN-KO',
    GN_KE = 'GN-KE',
    GN_L = 'GN-L',
    GN_LA = 'GN-LA',
    GN_LO = 'GN-LO',
    GN_LE = 'GN-LE',
    GN_MC = 'GN-MC',
    GN_ML = 'GN-ML',
    GN_M = 'GN-M',
    GN_MM = 'GN-MM',
    GN_MD = 'GN-MD',
    GN_N = 'GN-N',
    GN_NZ = 'GN-NZ',
    GN_PI = 'GN-PI',
    GN_SI = 'GN-SI',
    GN_TO = 'GN-TO',
    GN_TE = 'GN-TE',
    GN_YO = 'GN-YO',
    GM_B = 'GM-B',
    GM_M = 'GM-M',
    GM_L = 'GM-L',
    GM_N = 'GM-N',
    GM_U = 'GM-U',
    GM_W = 'GM-W',
    GW_BA = 'GW-BA',
    GW_BM = 'GW-BM',
    GW_BS = 'GW-BS',
    GW_BL = 'GW-BL',
    GW_CA = 'GW-CA',
    GW_GA = 'GW-GA',
    GW_L = 'GW-L',
    GW_N = 'GW-N',
    GW_OI = 'GW-OI',
    GW_QU = 'GW-QU',
    GW_S = 'GW-S',
    GW_TO = 'GW-TO',
    GQ_AN = 'GQ-AN',
    GQ_BN = 'GQ-BN',
    GQ_BS = 'GQ-BS',
    GQ_CS = 'GQ-CS',
    GQ_DJ = 'GQ-DJ',
    GQ_KN = 'GQ-KN',
    GQ_LI = 'GQ-LI',
    GQ_C = 'GQ-C',
    GQ_I = 'GQ-I',
    GQ_WN = 'GQ-WN',
    GR_A = 'GR-A',
    GR_I = 'GR-I',
    GR_G = 'GR-G',
    GR_C = 'GR-C',
    GR_F = 'GR-F',
    GR_B = 'GR-B',
    GR_M = 'GR-M',
    GR_L = 'GR-L',
    GR_J = 'GR-J',
    GR_H = 'GR-H',
    GR_E = 'GR-E',
    GR_K = 'GR-K',
    GR_69 = 'GR-69',
    GR_D = 'GR-D',
    GD_01 = 'GD-01',
    GD_02 = 'GD-02',
    GD_03 = 'GD-03',
    GD_04 = 'GD-04',
    GD_05 = 'GD-05',
    GD_06 = 'GD-06',
    GD_10 = 'GD-10',
    GL_AV = 'GL-AV',
    GL_KU = 'GL-KU',
    GL_QT = 'GL-QT',
    GL_SM = 'GL-SM',
    GL_QE = 'GL-QE',
    GT_16 = 'GT-16',
    GT_15 = 'GT-15',
    GT_04 = 'GT-04',
    GT_20 = 'GT-20',
    GT_02 = 'GT-02',
    GT_05 = 'GT-05',
    GT_01 = 'GT-01',
    GT_13 = 'GT-13',
    GT_18 = 'GT-18',
    GT_21 = 'GT-21',
    GT_22 = 'GT-22',
    GT_17 = 'GT-17',
    GT_09 = 'GT-09',
    GT_14 = 'GT-14',
    GT_11 = 'GT-11',
    GT_03 = 'GT-03',
    GT_12 = 'GT-12',
    GT_06 = 'GT-06',
    GT_07 = 'GT-07',
    GT_10 = 'GT-10',
    GT_08 = 'GT-08',
    GT_19 = 'GT-19',
    GY_BA = 'GY-BA',
    GY_CU = 'GY-CU',
    GY_DE = 'GY-DE',
    GY_EB = 'GY-EB',
    GY_ES = 'GY-ES',
    GY_MA = 'GY-MA',
    GY_PM = 'GY-PM',
    GY_PT = 'GY-PT',
    GY_UD = 'GY-UD',
    GY_UT = 'GY-UT',
    HN_AT = 'HN-AT',
    HN_CH = 'HN-CH',
    HN_CL = 'HN-CL',
    HN_CM = 'HN-CM',
    HN_CP = 'HN-CP',
    HN_CR = 'HN-CR',
    HN_EP = 'HN-EP',
    HN_FM = 'HN-FM',
    HN_GD = 'HN-GD',
    HN_IN = 'HN-IN',
    HN_IB = 'HN-IB',
    HN_LP = 'HN-LP',
    HN_LE = 'HN-LE',
    HN_OC = 'HN-OC',
    HN_OL = 'HN-OL',
    HN_SB = 'HN-SB',
    HN_VA = 'HN-VA',
    HN_YO = 'HN-YO',
    HR_07 = 'HR-07',
    HR_12 = 'HR-12',
    HR_19 = 'HR-19',
    HR_21 = 'HR-21',
    HR_18 = 'HR-18',
    HR_04 = 'HR-04',
    HR_06 = 'HR-06',
    HR_02 = 'HR-02',
    HR_09 = 'HR-09',
    HR_20 = 'HR-20',
    HR_14 = 'HR-14',
    HR_11 = 'HR-11',
    HR_08 = 'HR-08',
    HR_03 = 'HR-03',
    HR_17 = 'HR-17',
    HR_05 = 'HR-05',
    HR_10 = 'HR-10',
    HR_16 = 'HR-16',
    HR_13 = 'HR-13',
    HR_01 = 'HR-01',
    HR_15 = 'HR-15',
    HT_AR = 'HT-AR',
    HT_CE = 'HT-CE',
    HT_GA = 'HT-GA',
    HT_NI = 'HT-NI',
    HT_ND = 'HT-ND',
    HT_NE = 'HT-NE',
    HT_NO = 'HT-NO',
    HT_OU = 'HT-OU',
    HT_SD = 'HT-SD',
    HT_SE = 'HT-SE',
    HU_BA = 'HU-BA',
    HU_BZ = 'HU-BZ',
    HU_BU = 'HU-BU',
    HU_BK = 'HU-BK',
    HU_BE = 'HU-BE',
    HU_BC = 'HU-BC',
    HU_CS = 'HU-CS',
    HU_DE = 'HU-DE',
    HU_DU = 'HU-DU',
    HU_EG = 'HU-EG',
    HU_FE = 'HU-FE',
    HU_GY = 'HU-GY',
    HU_GS = 'HU-GS',
    HU_HB = 'HU-HB',
    HU_HE = 'HU-HE',
    HU_HV = 'HU-HV',
    HU_JN = 'HU-JN',
    HU_KV = 'HU-KV',
    HU_KM = 'HU-KM',
    HU_KE = 'HU-KE',
    HU_MI = 'HU-MI',
    HU_NK = 'HU-NK',
    HU_NY = 'HU-NY',
    HU_NO = 'HU-NO',
    HU_PE = 'HU-PE',
    HU_PS = 'HU-PS',
    HU_ST = 'HU-ST',
    HU_SO = 'HU-SO',
    HU_SN = 'HU-SN',
    HU_SZ = 'HU-SZ',
    HU_SD = 'HU-SD',
    HU_SS = 'HU-SS',
    HU_SK = 'HU-SK',
    HU_SH = 'HU-SH',
    HU_SF = 'HU-SF',
    HU_TB = 'HU-TB',
    HU_TO = 'HU-TO',
    HU_VA = 'HU-VA',
    HU_VE = 'HU-VE',
    HU_VM = 'HU-VM',
    HU_ZA = 'HU-ZA',
    HU_ZE = 'HU-ZE',
    HU_ER = 'HU-ER',
    ID_AC = 'ID-AC',
    ID_BA = 'ID-BA',
    ID_BT = 'ID-BT',
    ID_BE = 'ID-BE',
    ID_GO = 'ID-GO',
    ID_JK = 'ID-JK',
    ID_JA = 'ID-JA',
    ID_JW = 'ID-JW',
    ID_JB = 'ID-JB',
    ID_JT = 'ID-JT',
    ID_JI = 'ID-JI',
    ID_KA = 'ID-KA',
    ID_KB = 'ID-KB',
    ID_KS = 'ID-KS',
    ID_KT = 'ID-KT',
    ID_KI = 'ID-KI',
    ID_KU = 'ID-KU',
    ID_BB = 'ID-BB',
    ID_KR = 'ID-KR',
    ID_LA = 'ID-LA',
    ID_MA = 'ID-MA',
    ID_ML = 'ID-ML',
    ID_MU = 'ID-MU',
    ID_NU = 'ID-NU',
    ID_NB = 'ID-NB',
    ID_NT = 'ID-NT',
    ID_PA = 'ID-PA',
    ID_PP = 'ID-PP',
    ID_PB = 'ID-PB',
    ID_PD = 'ID-PD',
    ID_PE = 'ID-PE',
    ID_PS = 'ID-PS',
    ID_PT = 'ID-PT',
    ID_RI = 'ID-RI',
    ID_SL = 'ID-SL',
    ID_SR = 'ID-SR',
    ID_SN = 'ID-SN',
    ID_ST = 'ID-ST',
    ID_SG = 'ID-SG',
    ID_SA = 'ID-SA',
    ID_SM = 'ID-SM',
    ID_SB = 'ID-SB',
    ID_SS = 'ID-SS',
    ID_SU = 'ID-SU',
    ID_YO = 'ID-YO',
    IN_AN = 'IN-AN',
    IN_AP = 'IN-AP',
    IN_AR = 'IN-AR',
    IN_AS = 'IN-AS',
    IN_BR = 'IN-BR',
    IN_CH = 'IN-CH',
    IN_CG = 'IN-CG',
    IN_DL = 'IN-DL',
    IN_DH = 'IN-DH',
    IN_GA = 'IN-GA',
    IN_GJ = 'IN-GJ',
    IN_HR = 'IN-HR',
    IN_HP = 'IN-HP',
    IN_JK = 'IN-JK',
    IN_JH = 'IN-JH',
    IN_KA = 'IN-KA',
    IN_KL = 'IN-KL',
    IN_LA = 'IN-LA',
    IN_LD = 'IN-LD',
    IN_MP = 'IN-MP',
    IN_MH = 'IN-MH',
    IN_MN = 'IN-MN',
    IN_ML = 'IN-ML',
    IN_MZ = 'IN-MZ',
    IN_NL = 'IN-NL',
    IN_OD = 'IN-OD',
    IN_PY = 'IN-PY',
    IN_PB = 'IN-PB',
    IN_RJ = 'IN-RJ',
    IN_SK = 'IN-SK',
    IN_TN = 'IN-TN',
    IN_TS = 'IN-TS',
    IN_TR = 'IN-TR',
    IN_UP = 'IN-UP',
    IN_UK = 'IN-UK',
    IN_WB = 'IN-WB',
    IE_CW = 'IE-CW',
    IE_CN = 'IE-CN',
    IE_CE = 'IE-CE',
    IE_C = 'IE-C',
    IE_CO = 'IE-CO',
    IE_DL = 'IE-DL',
    IE_D = 'IE-D',
    IE_G = 'IE-G',
    IE_KY = 'IE-KY',
    IE_KE = 'IE-KE',
    IE_KK = 'IE-KK',
    IE_LS = 'IE-LS',
    IE_L = 'IE-L',
    IE_LM = 'IE-LM',
    IE_LK = 'IE-LK',
    IE_LD = 'IE-LD',
    IE_LH = 'IE-LH',
    IE_MO = 'IE-MO',
    IE_MH = 'IE-MH',
    IE_MN = 'IE-MN',
    IE_M = 'IE-M',
    IE_OY = 'IE-OY',
    IE_RN = 'IE-RN',
    IE_SO = 'IE-SO',
    IE_TA = 'IE-TA',
    IE_U = 'IE-U',
    IE_WD = 'IE-WD',
    IE_WH = 'IE-WH',
    IE_WX = 'IE-WX',
    IE_WW = 'IE-WW',
    IR_30 = 'IR-30',
    IR_24 = 'IR-24',
    IR_18 = 'IR-18',
    IR_14 = 'IR-14',
    IR_10 = 'IR-10',
    IR_07 = 'IR-07',
    IR_27 = 'IR-27',
    IR_01 = 'IR-01',
    IR_13 = 'IR-13',
    IR_22 = 'IR-22',
    IR_08 = 'IR-08',
    IR_05 = 'IR-05',
    IR_29 = 'IR-29',
    IR_09 = 'IR-09',
    IR_28 = 'IR-28',
    IR_06 = 'IR-06',
    IR_17 = 'IR-17',
    IR_12 = 'IR-12',
    IR_15 = 'IR-15',
    IR_00 = 'IR-00',
    IR_02 = 'IR-02',
    IR_26 = 'IR-26',
    IR_25 = 'IR-25',
    IR_20 = 'IR-20',
    IR_11 = 'IR-11',
    IR_23 = 'IR-23',
    IR_21 = 'IR-21',
    IR_19 = 'IR-19',
    IR_04 = 'IR-04',
    IR_03 = 'IR-03',
    IR_16 = 'IR-16',
    IQ_AN = 'IQ-AN',
    IQ_BA = 'IQ-BA',
    IQ_MU = 'IQ-MU',
    IQ_QA = 'IQ-QA',
    IQ_NA = 'IQ-NA',
    IQ_AR = 'IQ-AR',
    IQ_SU = 'IQ-SU',
    IQ_BG = 'IQ-BG',
    IQ_BB = 'IQ-BB',
    IQ_DA = 'IQ-DA',
    IQ_DQ = 'IQ-DQ',
    IQ_DI = 'IQ-DI',
    IQ_KR = 'IQ-KR',
    IQ_KA = 'IQ-KA',
    IQ_KI = 'IQ-KI',
    IQ_MA = 'IQ-MA',
    IQ_NI = 'IQ-NI',
    IQ_WA = 'IQ-WA',
    IQ_SD = 'IQ-SD',
    IS_AKN = 'IS-AKN',
    IS_AKU = 'IS-AKU',
    IS_7 = 'IS-7',
    IS_BLA = 'IS-BLA',
    IS_BOL = 'IS-BOL',
    IS_BOG = 'IS-BOG',
    IS_DAB = 'IS-DAB',
    IS_DAV = 'IS-DAV',
    IS_EOM = 'IS-EOM',
    IS_EYF = 'IS-EYF',
    IS_FJL = 'IS-FJL',
    IS_FJD = 'IS-FJD',
    IS_FLR = 'IS-FLR',
    IS_FLA = 'IS-FLA',
    IS_GAR = 'IS-GAR',
    IS_GRN = 'IS-GRN',
    IS_GRU = 'IS-GRU',
    IS_GOG = 'IS-GOG',
    IS_GRY = 'IS-GRY',
    IS_HAF = 'IS-HAF',
    IS_HRU = 'IS-HRU',
    IS_HVA = 'IS-HVA',
    IS_HVE = 'IS-HVE',
    IS_1 = 'IS-1',
    IS_HRG = 'IS-HRG',
    IS_HUG = 'IS-HUG',
    IS_HUV = 'IS-HUV',
    IS_KAL = 'IS-KAL',
    IS_KJO = 'IS-KJO',
    IS_KOP = 'IS-KOP',
    IS_LAN = 'IS-LAN',
    IS_MOS = 'IS-MOS',
    IS_MUL = 'IS-MUL',
    IS_MYR = 'IS-MYR',
    IS_6 = 'IS-6',
    IS_5 = 'IS-5',
    IS_NOR = 'IS-NOR',
    IS_RGE = 'IS-RGE',
    IS_RGY = 'IS-RGY',
    IS_RHH = 'IS-RHH',
    IS_RKN = 'IS-RKN',
    IS_RKV = 'IS-RKV',
    IS_SEL = 'IS-SEL',
    IS_SKF = 'IS-SKF',
    IS_SKG = 'IS-SKG',
    IS_SKR = 'IS-SKR',
    IS_SOG = 'IS-SOG',
    IS_SKO = 'IS-SKO',
    IS_SNF = 'IS-SNF',
    IS_STR = 'IS-STR',
    IS_STY = 'IS-STY',
    IS_8 = 'IS-8',
    IS_2 = 'IS-2',
    IS_SDN = 'IS-SDN',
    IS_SBT = 'IS-SBT',
    IS_SHF = 'IS-SHF',
    IS_SSS = 'IS-SSS',
    IS_SVG = 'IS-SVG',
    IS_SFA = 'IS-SFA',
    IS_SOL = 'IS-SOL',
    IS_SDV = 'IS-SDV',
    IS_TJO = 'IS-TJO',
    IS_TAL = 'IS-TAL',
    IS_4 = 'IS-4',
    IS_VEM = 'IS-VEM',
    IS_VER = 'IS-VER',
    IS_3 = 'IS-3',
    IS_VOP = 'IS-VOP',
    IS_ARN = 'IS-ARN',
    IS_ASA = 'IS-ASA',
    IS_ISA = 'IS-ISA',
    IS_THG = 'IS-THG',
    IL_M = 'IL-M',
    IL_D = 'IL-D',
    IL_JM = 'IL-JM',
    IL_Z = 'IL-Z',
    IL_HA = 'IL-HA',
    IL_TA = 'IL-TA',
    IT_65 = 'IT-65',
    IT_AG = 'IT-AG',
    IT_AL = 'IT-AL',
    IT_AN = 'IT-AN',
    IT_AR = 'IT-AR',
    IT_AP = 'IT-AP',
    IT_AT = 'IT-AT',
    IT_AV = 'IT-AV',
    IT_BA = 'IT-BA',
    IT_BT = 'IT-BT',
    IT_77 = 'IT-77',
    IT_BL = 'IT-BL',
    IT_BN = 'IT-BN',
    IT_BG = 'IT-BG',
    IT_BI = 'IT-BI',
    IT_BO = 'IT-BO',
    IT_BZ = 'IT-BZ',
    IT_BS = 'IT-BS',
    IT_BR = 'IT-BR',
    IT_CA = 'IT-CA',
    IT_78 = 'IT-78',
    IT_CL = 'IT-CL',
    IT_72 = 'IT-72',
    IT_CB = 'IT-CB',
    IT_CE = 'IT-CE',
    IT_CT = 'IT-CT',
    IT_CZ = 'IT-CZ',
    IT_CH = 'IT-CH',
    IT_CO = 'IT-CO',
    IT_CS = 'IT-CS',
    IT_CR = 'IT-CR',
    IT_KR = 'IT-KR',
    IT_CN = 'IT-CN',
    IT_45 = 'IT-45',
    IT_EN = 'IT-EN',
    IT_FM = 'IT-FM',
    IT_FE = 'IT-FE',
    IT_FI = 'IT-FI',
    IT_FG = 'IT-FG',
    IT_FC = 'IT-FC',
    IT_36 = 'IT-36',
    IT_FR = 'IT-FR',
    IT_GE = 'IT-GE',
    IT_GO = 'IT-GO',
    IT_GR = 'IT-GR',
    IT_IM = 'IT-IM',
    IT_IS = 'IT-IS',
    IT_AQ = 'IT-AQ',
    IT_SP = 'IT-SP',
    IT_LT = 'IT-LT',
    IT_62 = 'IT-62',
    IT_LE = 'IT-LE',
    IT_LC = 'IT-LC',
    IT_42 = 'IT-42',
    IT_LI = 'IT-LI',
    IT_LO = 'IT-LO',
    IT_25 = 'IT-25',
    IT_LU = 'IT-LU',
    IT_MC = 'IT-MC',
    IT_MN = 'IT-MN',
    IT_57 = 'IT-57',
    IT_MS = 'IT-MS',
    IT_MT = 'IT-MT',
    IT_ME = 'IT-ME',
    IT_MI = 'IT-MI',
    IT_MO = 'IT-MO',
    IT_67 = 'IT-67',
    IT_MB = 'IT-MB',
    IT_NA = 'IT-NA',
    IT_NO = 'IT-NO',
    IT_NU = 'IT-NU',
    IT_OR = 'IT-OR',
    IT_PD = 'IT-PD',
    IT_PA = 'IT-PA',
    IT_PR = 'IT-PR',
    IT_PV = 'IT-PV',
    IT_PG = 'IT-PG',
    IT_PU = 'IT-PU',
    IT_PE = 'IT-PE',
    IT_PC = 'IT-PC',
    IT_21 = 'IT-21',
    IT_PI = 'IT-PI',
    IT_PT = 'IT-PT',
    IT_PN = 'IT-PN',
    IT_PZ = 'IT-PZ',
    IT_PO = 'IT-PO',
    IT_75 = 'IT-75',
    IT_RG = 'IT-RG',
    IT_RA = 'IT-RA',
    IT_RC = 'IT-RC',
    IT_RE = 'IT-RE',
    IT_RI = 'IT-RI',
    IT_RN = 'IT-RN',
    IT_RM = 'IT-RM',
    IT_RO = 'IT-RO',
    IT_SA = 'IT-SA',
    IT_88 = 'IT-88',
    IT_SS = 'IT-SS',
    IT_SV = 'IT-SV',
    IT_82 = 'IT-82',
    IT_SI = 'IT-SI',
    IT_SR = 'IT-SR',
    IT_SO = 'IT-SO',
    IT_SU = 'IT-SU',
    IT_TA = 'IT-TA',
    IT_TE = 'IT-TE',
    IT_TR = 'IT-TR',
    IT_TO = 'IT-TO',
    IT_52 = 'IT-52',
    IT_TP = 'IT-TP',
    IT_32 = 'IT-32',
    IT_TN = 'IT-TN',
    IT_TV = 'IT-TV',
    IT_TS = 'IT-TS',
    IT_UD = 'IT-UD',
    IT_55 = 'IT-55',
    IT_23 = 'IT-23',
    IT_VA = 'IT-VA',
    IT_34 = 'IT-34',
    IT_VE = 'IT-VE',
    IT_VB = 'IT-VB',
    IT_VC = 'IT-VC',
    IT_VR = 'IT-VR',
    IT_VV = 'IT-VV',
    IT_VI = 'IT-VI',
    IT_VT = 'IT-VT',
    JM_13 = 'JM-13',
    JM_09 = 'JM-09',
    JM_01 = 'JM-01',
    JM_12 = 'JM-12',
    JM_04 = 'JM-04',
    JM_02 = 'JM-02',
    JM_06 = 'JM-06',
    JM_14 = 'JM-14',
    JM_11 = 'JM-11',
    JM_08 = 'JM-08',
    JM_05 = 'JM-05',
    JM_03 = 'JM-03',
    JM_07 = 'JM-07',
    JM_10 = 'JM-10',
    JO_BA = 'JO-BA',
    JO_KA = 'JO-KA',
    JO_MA = 'JO-MA',
    JO_AQ = 'JO-AQ',
    JO_AM = 'JO-AM',
    JO_AZ = 'JO-AZ',
    JO_AT = 'JO-AT',
    JO_IR = 'JO-IR',
    JO_JA = 'JO-JA',
    JO_MN = 'JO-MN',
    JO_MD = 'JO-MD',
    JO_AJ = 'JO-AJ',
    JP_23 = 'JP-23',
    JP_05 = 'JP-05',
    JP_02 = 'JP-02',
    JP_12 = 'JP-12',
    JP_38 = 'JP-38',
    JP_18 = 'JP-18',
    JP_40 = 'JP-40',
    JP_07 = 'JP-07',
    JP_21 = 'JP-21',
    JP_10 = 'JP-10',
    JP_34 = 'JP-34',
    JP_01 = 'JP-01',
    JP_28 = 'JP-28',
    JP_08 = 'JP-08',
    JP_17 = 'JP-17',
    JP_03 = 'JP-03',
    JP_37 = 'JP-37',
    JP_46 = 'JP-46',
    JP_14 = 'JP-14',
    JP_39 = 'JP-39',
    JP_43 = 'JP-43',
    JP_26 = 'JP-26',
    JP_24 = 'JP-24',
    JP_04 = 'JP-04',
    JP_45 = 'JP-45',
    JP_20 = 'JP-20',
    JP_42 = 'JP-42',
    JP_29 = 'JP-29',
    JP_15 = 'JP-15',
    JP_44 = 'JP-44',
    JP_33 = 'JP-33',
    JP_47 = 'JP-47',
    JP_27 = 'JP-27',
    JP_41 = 'JP-41',
    JP_11 = 'JP-11',
    JP_25 = 'JP-25',
    JP_32 = 'JP-32',
    JP_22 = 'JP-22',
    JP_09 = 'JP-09',
    JP_36 = 'JP-36',
    JP_13 = 'JP-13',
    JP_31 = 'JP-31',
    JP_16 = 'JP-16',
    JP_30 = 'JP-30',
    JP_06 = 'JP-06',
    JP_35 = 'JP-35',
    JP_19 = 'JP-19',
    KZ_10 = 'KZ-10',
    KZ_11 = 'KZ-11',
    KZ_15 = 'KZ-15',
    KZ_19 = 'KZ-19',
    KZ_75 = 'KZ-75',
    KZ_71 = 'KZ-71',
    KZ_23 = 'KZ-23',
    KZ_27 = 'KZ-27',
    KZ_35 = 'KZ-35',
    KZ_39 = 'KZ-39',
    KZ_43 = 'KZ-43',
    KZ_47 = 'KZ-47',
    KZ_55 = 'KZ-55',
    KZ_59 = 'KZ-59',
    KZ_63 = 'KZ-63',
    KZ_79 = 'KZ-79',
    KZ_61 = 'KZ-61',
    KZ_62 = 'KZ-62',
    KZ_31 = 'KZ-31',
    KZ_33 = 'KZ-33',
    KE_01 = 'KE-01',
    KE_02 = 'KE-02',
    KE_03 = 'KE-03',
    KE_04 = 'KE-04',
    KE_05 = 'KE-05',
    KE_06 = 'KE-06',
    KE_07 = 'KE-07',
    KE_08 = 'KE-08',
    KE_09 = 'KE-09',
    KE_10 = 'KE-10',
    KE_11 = 'KE-11',
    KE_12 = 'KE-12',
    KE_13 = 'KE-13',
    KE_14 = 'KE-14',
    KE_15 = 'KE-15',
    KE_16 = 'KE-16',
    KE_17 = 'KE-17',
    KE_18 = 'KE-18',
    KE_19 = 'KE-19',
    KE_20 = 'KE-20',
    KE_21 = 'KE-21',
    KE_22 = 'KE-22',
    KE_23 = 'KE-23',
    KE_24 = 'KE-24',
    KE_25 = 'KE-25',
    KE_26 = 'KE-26',
    KE_27 = 'KE-27',
    KE_28 = 'KE-28',
    KE_29 = 'KE-29',
    KE_30 = 'KE-30',
    KE_31 = 'KE-31',
    KE_32 = 'KE-32',
    KE_33 = 'KE-33',
    KE_34 = 'KE-34',
    KE_35 = 'KE-35',
    KE_36 = 'KE-36',
    KE_37 = 'KE-37',
    KE_38 = 'KE-38',
    KE_39 = 'KE-39',
    KE_40 = 'KE-40',
    KE_41 = 'KE-41',
    KE_42 = 'KE-42',
    KE_43 = 'KE-43',
    KE_44 = 'KE-44',
    KE_45 = 'KE-45',
    KE_46 = 'KE-46',
    KE_47 = 'KE-47',
    KG_B = 'KG-B',
    KG_GB = 'KG-GB',
    KG_C = 'KG-C',
    KG_J = 'KG-J',
    KG_GO = 'KG-GO',
    KG_Y = 'KG-Y',
    KG_N = 'KG-N',
    KG_O = 'KG-O',
    KG_T = 'KG-T',
    KH_2 = 'KH-2',
    KH_1 = 'KH-1',
    KH_23 = 'KH-23',
    KH_3 = 'KH-3',
    KH_4 = 'KH-4',
    KH_5 = 'KH-5',
    KH_6 = 'KH-6',
    KH_7 = 'KH-7',
    KH_8 = 'KH-8',
    KH_9 = 'KH-9',
    KH_10 = 'KH-10',
    KH_11 = 'KH-11',
    KH_22 = 'KH-22',
    KH_24 = 'KH-24',
    KH_12 = 'KH-12',
    KH_15 = 'KH-15',
    KH_18 = 'KH-18',
    KH_13 = 'KH-13',
    KH_14 = 'KH-14',
    KH_16 = 'KH-16',
    KH_17 = 'KH-17',
    KH_19 = 'KH-19',
    KH_20 = 'KH-20',
    KH_21 = 'KH-21',
    KH_25 = 'KH-25',
    KI_G = 'KI-G',
    KI_L = 'KI-L',
    KI_P = 'KI-P',
    KN_01 = 'KN-01',
    KN_N = 'KN-N',
    KN_02 = 'KN-02',
    KN_03 = 'KN-03',
    KN_04 = 'KN-04',
    KN_05 = 'KN-05',
    KN_06 = 'KN-06',
    KN_07 = 'KN-07',
    KN_K = 'KN-K',
    KN_08 = 'KN-08',
    KN_09 = 'KN-09',
    KN_10 = 'KN-10',
    KN_11 = 'KN-11',
    KN_12 = 'KN-12',
    KN_13 = 'KN-13',
    KN_15 = 'KN-15',
    KR_26 = 'KR-26',
    KR_43 = 'KR-43',
    KR_44 = 'KR-44',
    KR_27 = 'KR-27',
    KR_30 = 'KR-30',
    KR_42 = 'KR-42',
    KR_29 = 'KR-29',
    KR_41 = 'KR-41',
    KR_47 = 'KR-47',
    KR_48 = 'KR-48',
    KR_28 = 'KR-28',
    KR_49 = 'KR-49',
    KR_45 = 'KR-45',
    KR_46 = 'KR-46',
    KR_50 = 'KR-50',
    KR_11 = 'KR-11',
    KR_31 = 'KR-31',
    KW_AH = 'KW-AH',
    KW_FA = 'KW-FA',
    KW_JA = 'KW-JA',
    KW_KU = 'KW-KU',
    KW_MU = 'KW-MU',
    KW_HA = 'KW-HA',
    LA_AT = 'LA-AT',
    LA_BK = 'LA-BK',
    LA_BL = 'LA-BL',
    LA_CH = 'LA-CH',
    LA_HO = 'LA-HO',
    LA_KH = 'LA-KH',
    LA_LM = 'LA-LM',
    LA_LP = 'LA-LP',
    LA_OU = 'LA-OU',
    LA_PH = 'LA-PH',
    LA_SL = 'LA-SL',
    LA_SV = 'LA-SV',
    LA_VI = 'LA-VI',
    LA_VT = 'LA-VT',
    LA_XA = 'LA-XA',
    LA_XS = 'LA-XS',
    LA_XI = 'LA-XI',
    LA_XE = 'LA-XE',
    LB_AK = 'LB-AK',
    LB_BI = 'LB-BI',
    LB_JA = 'LB-JA',
    LB_NA = 'LB-NA',
    LB_AS = 'LB-AS',
    LB_BH = 'LB-BH',
    LB_BA = 'LB-BA',
    LB_JL = 'LB-JL',
    LR_BM = 'LR-BM',
    LR_BG = 'LR-BG',
    LR_GP = 'LR-GP',
    LR_GB = 'LR-GB',
    LR_CM = 'LR-CM',
    LR_GG = 'LR-GG',
    LR_GK = 'LR-GK',
    LR_LO = 'LR-LO',
    LR_MG = 'LR-MG',
    LR_MY = 'LR-MY',
    LR_MO = 'LR-MO',
    LR_NI = 'LR-NI',
    LR_RI = 'LR-RI',
    LR_RG = 'LR-RG',
    LR_SI = 'LR-SI',
    LY_BU = 'LY-BU',
    LY_JA = 'LY-JA',
    LY_JG = 'LY-JG',
    LY_JI = 'LY-JI',
    LY_JU = 'LY-JU',
    LY_KF = 'LY-KF',
    LY_MJ = 'LY-MJ',
    LY_MB = 'LY-MB',
    LY_WA = 'LY-WA',
    LY_NQ = 'LY-NQ',
    LY_ZA = 'LY-ZA',
    LY_BA = 'LY-BA',
    LY_DR = 'LY-DR',
    LY_GT = 'LY-GT',
    LY_MI = 'LY-MI',
    LY_MQ = 'LY-MQ',
    LY_NL = 'LY-NL',
    LY_SB = 'LY-SB',
    LY_SR = 'LY-SR',
    LY_WD = 'LY-WD',
    LY_WS = 'LY-WS',
    LY_TB = 'LY-TB',
    LC_01 = 'LC-01',
    LC_12 = 'LC-12',
    LC_02 = 'LC-02',
    LC_03 = 'LC-03',
    LC_05 = 'LC-05',
    LC_06 = 'LC-06',
    LC_07 = 'LC-07',
    LC_08 = 'LC-08',
    LC_10 = 'LC-10',
    LC_11 = 'LC-11',
    LI_01 = 'LI-01',
    LI_02 = 'LI-02',
    LI_03 = 'LI-03',
    LI_04 = 'LI-04',
    LI_05 = 'LI-05',
    LI_06 = 'LI-06',
    LI_07 = 'LI-07',
    LI_08 = 'LI-08',
    LI_09 = 'LI-09',
    LI_10 = 'LI-10',
    LI_11 = 'LI-11',
    LK_52 = 'LK-52',
    LK_71 = 'LK-71',
    LK_81 = 'LK-81',
    LK_51 = 'LK-51',
    LK_2 = 'LK-2',
    LK_11 = 'LK-11',
    LK_5 = 'LK-5',
    LK_31 = 'LK-31',
    LK_12 = 'LK-12',
    LK_33 = 'LK-33',
    LK_41 = 'LK-41',
    LK_13 = 'LK-13',
    LK_21 = 'LK-21',
    LK_92 = 'LK-92',
    LK_42 = 'LK-42',
    LK_61 = 'LK-61',
    LK_43 = 'LK-43',
    LK_22 = 'LK-22',
    LK_32 = 'LK-32',
    LK_82 = 'LK-82',
    LK_45 = 'LK-45',
    LK_7 = 'LK-7',
    LK_6 = 'LK-6',
    LK_4 = 'LK-4',
    LK_23 = 'LK-23',
    LK_72 = 'LK-72',
    LK_62 = 'LK-62',
    LK_91 = 'LK-91',
    LK_9 = 'LK-9',
    LK_3 = 'LK-3',
    LK_53 = 'LK-53',
    LK_8 = 'LK-8',
    LK_44 = 'LK-44',
    LK_1 = 'LK-1',
    LS_D = 'LS-D',
    LS_B = 'LS-B',
    LS_C = 'LS-C',
    LS_E = 'LS-E',
    LS_A = 'LS-A',
    LS_F = 'LS-F',
    LS_J = 'LS-J',
    LS_H = 'LS-H',
    LS_G = 'LS-G',
    LS_K = 'LS-K',
    LT_01 = 'LT-01',
    LT_AL = 'LT-AL',
    LT_02 = 'LT-02',
    LT_03 = 'LT-03',
    LT_04 = 'LT-04',
    LT_05 = 'LT-05',
    LT_06 = 'LT-06',
    LT_07 = 'LT-07',
    LT_08 = 'LT-08',
    LT_09 = 'LT-09',
    LT_10 = 'LT-10',
    LT_11 = 'LT-11',
    LT_12 = 'LT-12',
    LT_13 = 'LT-13',
    LT_14 = 'LT-14',
    LT_16 = 'LT-16',
    LT_KU = 'LT-KU',
    LT_15 = 'LT-15',
    LT_17 = 'LT-17',
    LT_19 = 'LT-19',
    LT_21 = 'LT-21',
    LT_KL = 'LT-KL',
    LT_20 = 'LT-20',
    LT_22 = 'LT-22',
    LT_23 = 'LT-23',
    LT_18 = 'LT-18',
    LT_24 = 'LT-24',
    LT_25 = 'LT-25',
    LT_MR = 'LT-MR',
    LT_26 = 'LT-26',
    LT_27 = 'LT-27',
    LT_28 = 'LT-28',
    LT_29 = 'LT-29',
    LT_30 = 'LT-30',
    LT_31 = 'LT-31',
    LT_PN = 'LT-PN',
    LT_32 = 'LT-32',
    LT_33 = 'LT-33',
    LT_34 = 'LT-34',
    LT_35 = 'LT-35',
    LT_36 = 'LT-36',
    LT_37 = 'LT-37',
    LT_38 = 'LT-38',
    LT_39 = 'LT-39',
    LT_40 = 'LT-40',
    LT_48 = 'LT-48',
    LT_50 = 'LT-50',
    LT_TA = 'LT-TA',
    LT_51 = 'LT-51',
    LT_TE = 'LT-TE',
    LT_52 = 'LT-52',
    LT_53 = 'LT-53',
    LT_54 = 'LT-54',
    LT_UT = 'LT-UT',
    LT_55 = 'LT-55',
    LT_56 = 'LT-56',
    LT_VL = 'LT-VL',
    LT_57 = 'LT-57',
    LT_58 = 'LT-58',
    LT_59 = 'LT-59',
    LT_60 = 'LT-60',
    LT_41 = 'LT-41',
    LT_42 = 'LT-42',
    LT_44 = 'LT-44',
    LT_SA = 'LT-SA',
    LT_43 = 'LT-43',
    LT_45 = 'LT-45',
    LT_46 = 'LT-46',
    LT_47 = 'LT-47',
    LT_49 = 'LT-49',
    LU_CA = 'LU-CA',
    LU_CL = 'LU-CL',
    LU_DI = 'LU-DI',
    LU_EC = 'LU-EC',
    LU_ES = 'LU-ES',
    LU_GR = 'LU-GR',
    LU_LU = 'LU-LU',
    LU_ME = 'LU-ME',
    LU_RD = 'LU-RD',
    LU_RM = 'LU-RM',
    LU_VD = 'LU-VD',
    LU_WI = 'LU-WI',
    LV_002 = 'LV-002',
    LV_007 = 'LV-007',
    LV_111 = 'LV-111',
    LV_015 = 'LV-015',
    LV_016 = 'LV-016',
    LV_022 = 'LV-022',
    LV_DGV = 'LV-DGV',
    LV_112 = 'LV-112',
    LV_026 = 'LV-026',
    LV_033 = 'LV-033',
    LV_JEL = 'LV-JEL',
    LV_041 = 'LV-041',
    LV_042 = 'LV-042',
    LV_JUR = 'LV-JUR',
    LV_047 = 'LV-047',
    LV_050 = 'LV-050',
    LV_LPX = 'LV-LPX',
    LV_054 = 'LV-054',
    LV_058 = 'LV-058',
    LV_056 = 'LV-056',
    LV_059 = 'LV-059',
    LV_062 = 'LV-062',
    LV_067 = 'LV-067',
    LV_068 = 'LV-068',
    LV_073 = 'LV-073',
    LV_080 = 'LV-080',
    LV_REZ = 'LV-REZ',
    LV_077 = 'LV-077',
    LV_RIX = 'LV-RIX',
    LV_087 = 'LV-087',
    LV_088 = 'LV-088',
    LV_089 = 'LV-089',
    LV_091 = 'LV-091',
    LV_094 = 'LV-094',
    LV_097 = 'LV-097',
    LV_099 = 'LV-099',
    LV_101 = 'LV-101',
    LV_113 = 'LV-113',
    LV_102 = 'LV-102',
    LV_VEN = 'LV-VEN',
    LV_106 = 'LV-106',
    LV_011 = 'LV-011',
    LV_052 = 'LV-052',
    MA_AGD = 'MA-AGD',
    MA_HAO = 'MA-HAO',
    MA_HOC = 'MA-HOC',
    MA_AOU = 'MA-AOU',
    MA_ASZ = 'MA-ASZ',
    MA_AZI = 'MA-AZI',
    MA_BES = 'MA-BES',
    MA_BER = 'MA-BER',
    MA_BRR = 'MA-BRR',
    MA_BOD = 'MA-BOD',
    MA_BOM = 'MA-BOM',
    MA_BEM = 'MA-BEM',
    MA_05 = 'MA-05',
    MA_CAS = 'MA-CAS',
    MA_06 = 'MA-06',
    MA_CHE = 'MA-CHE',
    MA_CHI = 'MA-CHI',
    MA_CHT = 'MA-CHT',
    MA_12 = 'MA-12',
    MA_DRI = 'MA-DRI',
    MA_08 = 'MA-08',
    MA_HAJ = 'MA-HAJ',
    MA_JDI = 'MA-JDI',
    MA_KES = 'MA-KES',
    MA_ERR = 'MA-ERR',
    MA_ESM = 'MA-ESM',
    MA_ESI = 'MA-ESI',
    MA_FAH = 'MA-FAH',
    MA_FIG = 'MA-FIG',
    MA_FQH = 'MA-FQH',
    MA_FES = 'MA-FES',
    MA_03 = 'MA-03',
    MA_GUE = 'MA-GUE',
    MA_10 = 'MA-10',
    MA_GUF = 'MA-GUF',
    MA_IFR = 'MA-IFR',
    MA_INE = 'MA-INE',
    MA_JRA = 'MA-JRA',
    MA_KHO = 'MA-KHO',
    MA_KHE = 'MA-KHE',
    MA_KHN = 'MA-KHN',
    MA_KEN = 'MA-KEN',
    MA_02 = 'MA-02',
    MA_LAR = 'MA-LAR',
    MA_LAA = 'MA-LAA',
    MA_11 = 'MA-11',
    MA_MAR = 'MA-MAR',
    MA_07 = 'MA-07',
    MA_MEK = 'MA-MEK',
    MA_MID = 'MA-MID',
    MA_MOH = 'MA-MOH',
    MA_MOU = 'MA-MOU',
    MA_MED = 'MA-MED',
    MA_MDF = 'MA-MDF',
    MA_NAD = 'MA-NAD',
    MA_NOU = 'MA-NOU',
    MA_OUA = 'MA-OUA',
    MA_OUD = 'MA-OUD',
    MA_OUZ = 'MA-OUZ',
    MA_OUJ = 'MA-OUJ',
    MA_RAB = 'MA-RAB',
    MA_04 = 'MA-04',
    MA_REH = 'MA-REH',
    MA_SAF = 'MA-SAF',
    MA_SAL = 'MA-SAL',
    MA_SEF = 'MA-SEF',
    MA_SET = 'MA-SET',
    MA_SIB = 'MA-SIB',
    MA_SIF = 'MA-SIF',
    MA_SIK = 'MA-SIK',
    MA_SIL = 'MA-SIL',
    MA_SKH = 'MA-SKH',
    MA_09 = 'MA-09',
    MA_TNT = 'MA-TNT',
    MA_TNG = 'MA-TNG',
    MA_01 = 'MA-01',
    MA_TAO = 'MA-TAO',
    MA_TAI = 'MA-TAI',
    MA_TAF = 'MA-TAF',
    MA_TAR = 'MA-TAR',
    MA_TAT = 'MA-TAT',
    MA_TAZ = 'MA-TAZ',
    MA_TIN = 'MA-TIN',
    MA_TIZ = 'MA-TIZ',
    MA_TET = 'MA-TET',
    MA_YUS = 'MA-YUS',
    MA_ZAG = 'MA-ZAG',
    MC_FO = 'MC-FO',
    MC_JE = 'MC-JE',
    MC_CL = 'MC-CL',
    MC_CO = 'MC-CO',
    MC_GA = 'MC-GA',
    MC_SO = 'MC-SO',
    MC_LA = 'MC-LA',
    MC_MA = 'MC-MA',
    MC_MO = 'MC-MO',
    MC_MG = 'MC-MG',
    MC_MC = 'MC-MC',
    MC_MU = 'MC-MU',
    MC_PH = 'MC-PH',
    MC_SR = 'MC-SR',
    MC_SD = 'MC-SD',
    MC_SP = 'MC-SP',
    MC_VR = 'MC-VR',
    MD_AN = 'MD-AN',
    MD_BS = 'MD-BS',
    MD_BD = 'MD-BD',
    MD_BR = 'MD-BR',
    MD_BA = 'MD-BA',
    MD_CA = 'MD-CA',
    MD_CT = 'MD-CT',
    MD_CU = 'MD-CU',
    MD_CM = 'MD-CM',
    MD_CR = 'MD-CR',
    MD_CL = 'MD-CL',
    MD_CS = 'MD-CS',
    MD_DO = 'MD-DO',
    MD_DR = 'MD-DR',
    MD_DU = 'MD-DU',
    MD_ED = 'MD-ED',
    MD_FL = 'MD-FL',
    MD_FA = 'MD-FA',
    MD_GL = 'MD-GL',
    MD_GA = 'MD-GA',
    MD_HI = 'MD-HI',
    MD_IA = 'MD-IA',
    MD_LE = 'MD-LE',
    MD_NI = 'MD-NI',
    MD_OC = 'MD-OC',
    MD_OR = 'MD-OR',
    MD_RE = 'MD-RE',
    MD_RI = 'MD-RI',
    MD_SO = 'MD-SO',
    MD_ST = 'MD-ST',
    MD_SN = 'MD-SN',
    MD_SI = 'MD-SI',
    MD_TA = 'MD-TA',
    MD_TE = 'MD-TE',
    MD_UN = 'MD-UN',
    MD_SD = 'MD-SD',
    MD_SV = 'MD-SV',
    MG_T = 'MG-T',
    MG_D = 'MG-D',
    MG_F = 'MG-F',
    MG_M = 'MG-M',
    MG_A = 'MG-A',
    MG_U = 'MG-U',
    MV_01 = 'MV-01',
    MV_03 = 'MV-03',
    MV_04 = 'MV-04',
    MV_29 = 'MV-29',
    MV_05 = 'MV-05',
    MV_08 = 'MV-08',
    MV_MLE = 'MV-MLE',
    MV_26 = 'MV-26',
    MV_12 = 'MV-12',
    MV_02 = 'MV-02',
    MV_27 = 'MV-27',
    MV_13 = 'MV-13',
    MV_24 = 'MV-24',
    MV_14 = 'MV-14',
    MV_07 = 'MV-07',
    MV_00 = 'MV-00',
    MV_28 = 'MV-28',
    MV_20 = 'MV-20',
    MV_25 = 'MV-25',
    MV_17 = 'MV-17',
    MV_23 = 'MV-23',
    MX_AGU = 'MX-AGU',
    MX_BCN = 'MX-BCN',
    MX_BCS = 'MX-BCS',
    MX_CAM = 'MX-CAM',
    MX_CHP = 'MX-CHP',
    MX_CHH = 'MX-CHH',
    MX_CMX = 'MX-CMX',
    MX_COA = 'MX-COA',
    MX_COL = 'MX-COL',
    MX_DUR = 'MX-DUR',
    MX_GUA = 'MX-GUA',
    MX_GRO = 'MX-GRO',
    MX_HID = 'MX-HID',
    MX_JAL = 'MX-JAL',
    MX_MIC = 'MX-MIC',
    MX_MOR = 'MX-MOR',
    MX_MEX = 'MX-MEX',
    MX_NAY = 'MX-NAY',
    MX_NLE = 'MX-NLE',
    MX_OAX = 'MX-OAX',
    MX_PUE = 'MX-PUE',
    MX_QUE = 'MX-QUE',
    MX_ROO = 'MX-ROO',
    MX_SLP = 'MX-SLP',
    MX_SIN = 'MX-SIN',
    MX_SON = 'MX-SON',
    MX_TAB = 'MX-TAB',
    MX_TAM = 'MX-TAM',
    MX_TLA = 'MX-TLA',
    MX_VER = 'MX-VER',
    MX_YUC = 'MX-YUC',
    MX_ZAC = 'MX-ZAC',
    MH_ALL = 'MH-ALL',
    MH_ALK = 'MH-ALK',
    MH_ARN = 'MH-ARN',
    MH_AUR = 'MH-AUR',
    MH_KIL = 'MH-KIL',
    MH_EBO = 'MH-EBO',
    MH_ENI = 'MH-ENI',
    MH_JAB = 'MH-JAB',
    MH_JAL = 'MH-JAL',
    MH_KWA = 'MH-KWA',
    MH_LAE = 'MH-LAE',
    MH_LIB = 'MH-LIB',
    MH_LIK = 'MH-LIK',
    MH_MAJ = 'MH-MAJ',
    MH_MAL = 'MH-MAL',
    MH_MEJ = 'MH-MEJ',
    MH_MIL = 'MH-MIL',
    MH_NMK = 'MH-NMK',
    MH_NMU = 'MH-NMU',
    MH_L = 'MH-L',
    MH_T = 'MH-T',
    MH_RON = 'MH-RON',
    MH_UJA = 'MH-UJA',
    MH_UTI = 'MH-UTI',
    MH_WTH = 'MH-WTH',
    MH_WTJ = 'MH-WTJ',
    MK_801 = 'MK-801',
    MK_802 = 'MK-802',
    MK_201 = 'MK-201',
    MK_501 = 'MK-501',
    MK_401 = 'MK-401',
    MK_601 = 'MK-601',
    MK_402 = 'MK-402',
    MK_602 = 'MK-602',
    MK_803 = 'MK-803',
    MK_313 = 'MK-313',
    MK_814 = 'MK-814',
    MK_303 = 'MK-303',
    MK_304 = 'MK-304',
    MK_203 = 'MK-203',
    MK_502 = 'MK-502',
    MK_103 = 'MK-103',
    MK_406 = 'MK-406',
    MK_503 = 'MK-503',
    MK_804 = 'MK-804',
    MK_405 = 'MK-405',
    MK_805 = 'MK-805',
    MK_604 = 'MK-604',
    MK_102 = 'MK-102',
    MK_807 = 'MK-807',
    MK_606 = 'MK-606',
    MK_205 = 'MK-205',
    MK_808 = 'MK-808',
    MK_104 = 'MK-104',
    MK_809 = 'MK-809',
    MK_307 = 'MK-307',
    MK_407 = 'MK-407',
    MK_206 = 'MK-206',
    MK_701 = 'MK-701',
    MK_702 = 'MK-702',
    MK_504 = 'MK-504',
    MK_505 = 'MK-505',
    MK_703 = 'MK-703',
    MK_704 = 'MK-704',
    MK_105 = 'MK-105',
    MK_207 = 'MK-207',
    MK_308 = 'MK-308',
    MK_607 = 'MK-607',
    MK_506 = 'MK-506',
    MK_106 = 'MK-106',
    MK_507 = 'MK-507',
    MK_408 = 'MK-408',
    MK_310 = 'MK-310',
    MK_208 = 'MK-208',
    MK_810 = 'MK-810',
    MK_311 = 'MK-311',
    MK_508 = 'MK-508',
    MK_209 = 'MK-209',
    MK_409 = 'MK-409',
    MK_705 = 'MK-705',
    MK_509 = 'MK-509',
    MK_107 = 'MK-107',
    MK_811 = 'MK-811',
    MK_812 = 'MK-812',
    MK_706 = 'MK-706',
    MK_312 = 'MK-312',
    MK_410 = 'MK-410',
    MK_813 = 'MK-813',
    MK_108 = 'MK-108',
    MK_608 = 'MK-608',
    MK_609 = 'MK-609',
    MK_403 = 'MK-403',
    MK_404 = 'MK-404',
    MK_101 = 'MK-101',
    MK_301 = 'MK-301',
    MK_202 = 'MK-202',
    MK_603 = 'MK-603',
    MK_806 = 'MK-806',
    MK_204 = 'MK-204',
    MK_815 = 'MK-815',
    MK_109 = 'MK-109',
    MK_210 = 'MK-210',
    MK_816 = 'MK-816',
    MK_211 = 'MK-211',
    MK_817 = 'MK-817',
    MK_605 = 'MK-605',
    ML_BKO = 'ML-BKO',
    ML_7 = 'ML-7',
    ML_1 = 'ML-1',
    ML_8 = 'ML-8',
    ML_2 = 'ML-2',
    ML_5 = 'ML-5',
    ML_9 = 'ML-9',
    ML_3 = 'ML-3',
    ML_4 = 'ML-4',
    ML_10 = 'ML-10',
    ML_6 = 'ML-6',
    MT_01 = 'MT-01',
    MT_02 = 'MT-02',
    MT_03 = 'MT-03',
    MT_04 = 'MT-04',
    MT_05 = 'MT-05',
    MT_06 = 'MT-06',
    MT_07 = 'MT-07',
    MT_08 = 'MT-08',
    MT_09 = 'MT-09',
    MT_10 = 'MT-10',
    MT_11 = 'MT-11',
    MT_13 = 'MT-13',
    MT_14 = 'MT-14',
    MT_15 = 'MT-15',
    MT_16 = 'MT-16',
    MT_17 = 'MT-17',
    MT_12 = 'MT-12',
    MT_19 = 'MT-19',
    MT_20 = 'MT-20',
    MT_21 = 'MT-21',
    MT_22 = 'MT-22',
    MT_23 = 'MT-23',
    MT_24 = 'MT-24',
    MT_25 = 'MT-25',
    MT_26 = 'MT-26',
    MT_27 = 'MT-27',
    MT_28 = 'MT-28',
    MT_29 = 'MT-29',
    MT_30 = 'MT-30',
    MT_32 = 'MT-32',
    MT_33 = 'MT-33',
    MT_34 = 'MT-34',
    MT_35 = 'MT-35',
    MT_36 = 'MT-36',
    MT_31 = 'MT-31',
    MT_37 = 'MT-37',
    MT_38 = 'MT-38',
    MT_39 = 'MT-39',
    MT_40 = 'MT-40',
    MT_41 = 'MT-41',
    MT_42 = 'MT-42',
    MT_43 = 'MT-43',
    MT_44 = 'MT-44',
    MT_45 = 'MT-45',
    MT_46 = 'MT-46',
    MT_47 = 'MT-47',
    MT_49 = 'MT-49',
    MT_48 = 'MT-48',
    MT_50 = 'MT-50',
    MT_53 = 'MT-53',
    MT_51 = 'MT-51',
    MT_52 = 'MT-52',
    MT_54 = 'MT-54',
    MT_55 = 'MT-55',
    MT_56 = 'MT-56',
    MT_57 = 'MT-57',
    MT_58 = 'MT-58',
    MT_59 = 'MT-59',
    MT_60 = 'MT-60',
    MT_61 = 'MT-61',
    MT_62 = 'MT-62',
    MT_63 = 'MT-63',
    MT_18 = 'MT-18',
    MT_64 = 'MT-64',
    MT_65 = 'MT-65',
    MT_66 = 'MT-66',
    MT_67 = 'MT-67',
    MT_68 = 'MT-68',
    MM_07 = 'MM-07',
    MM_02 = 'MM-02',
    MM_14 = 'MM-14',
    MM_11 = 'MM-11',
    MM_12 = 'MM-12',
    MM_13 = 'MM-13',
    MM_03 = 'MM-03',
    MM_04 = 'MM-04',
    MM_15 = 'MM-15',
    MM_18 = 'MM-18',
    MM_16 = 'MM-16',
    MM_01 = 'MM-01',
    MM_17 = 'MM-17',
    MM_05 = 'MM-05',
    MM_06 = 'MM-06',
    ME_01 = 'ME-01',
    ME_02 = 'ME-02',
    ME_03 = 'ME-03',
    ME_04 = 'ME-04',
    ME_05 = 'ME-05',
    ME_06 = 'ME-06',
    ME_07 = 'ME-07',
    ME_22 = 'ME-22',
    ME_08 = 'ME-08',
    ME_09 = 'ME-09',
    ME_10 = 'ME-10',
    ME_11 = 'ME-11',
    ME_12 = 'ME-12',
    ME_23 = 'ME-23',
    ME_13 = 'ME-13',
    ME_14 = 'ME-14',
    ME_15 = 'ME-15',
    ME_16 = 'ME-16',
    ME_17 = 'ME-17',
    ME_19 = 'ME-19',
    ME_24 = 'ME-24',
    ME_20 = 'ME-20',
    ME_25 = 'ME-25',
    ME_18 = 'ME-18',
    ME_21 = 'ME-21',
    MN_073 = 'MN-073',
    MN_071 = 'MN-071',
    MN_069 = 'MN-069',
    MN_067 = 'MN-067',
    MN_037 = 'MN-037',
    MN_061 = 'MN-061',
    MN_063 = 'MN-063',
    MN_059 = 'MN-059',
    MN_057 = 'MN-057',
    MN_065 = 'MN-065',
    MN_064 = 'MN-064',
    MN_039 = 'MN-039',
    MN_043 = 'MN-043',
    MN_041 = 'MN-041',
    MN_035 = 'MN-035',
    MN_049 = 'MN-049',
    MN_051 = 'MN-051',
    MN_047 = 'MN-047',
    MN_1 = 'MN-1',
    MN_046 = 'MN-046',
    MN_053 = 'MN-053',
    MN_055 = 'MN-055',
    MZ_P = 'MZ-P',
    MZ_G = 'MZ-G',
    MZ_I = 'MZ-I',
    MZ_B = 'MZ-B',
    MZ_L = 'MZ-L',
    MZ_MPM = 'MZ-MPM',
    MZ_N = 'MZ-N',
    MZ_A = 'MZ-A',
    MZ_S = 'MZ-S',
    MZ_T = 'MZ-T',
    MZ_Q = 'MZ-Q',
    MR_07 = 'MR-07',
    MR_03 = 'MR-03',
    MR_05 = 'MR-05',
    MR_08 = 'MR-08',
    MR_04 = 'MR-04',
    MR_10 = 'MR-10',
    MR_01 = 'MR-01',
    MR_02 = 'MR-02',
    MR_12 = 'MR-12',
    MR_14 = 'MR-14',
    MR_13 = 'MR-13',
    MR_15 = 'MR-15',
    MR_09 = 'MR-09',
    MR_11 = 'MR-11',
    MR_06 = 'MR-06',
    MU_AG = 'MU-AG',
    MU_BL = 'MU-BL',
    MU_CC = 'MU-CC',
    MU_FL = 'MU-FL',
    MU_GP = 'MU-GP',
    MU_MO = 'MU-MO',
    MU_PA = 'MU-PA',
    MU_PW = 'MU-PW',
    MU_PL = 'MU-PL',
    MU_RR = 'MU-RR',
    MU_RO = 'MU-RO',
    MU_SA = 'MU-SA',
    MW_BA = 'MW-BA',
    MW_BL = 'MW-BL',
    MW_C = 'MW-C',
    MW_CK = 'MW-CK',
    MW_CR = 'MW-CR',
    MW_CT = 'MW-CT',
    MW_DE = 'MW-DE',
    MW_DO = 'MW-DO',
    MW_KR = 'MW-KR',
    MW_KS = 'MW-KS',
    MW_LK = 'MW-LK',
    MW_LI = 'MW-LI',
    MW_MH = 'MW-MH',
    MW_MG = 'MW-MG',
    MW_MC = 'MW-MC',
    MW_MU = 'MW-MU',
    MW_MW = 'MW-MW',
    MW_MZ = 'MW-MZ',
    MW_NE = 'MW-NE',
    MW_NB = 'MW-NB',
    MW_NK = 'MW-NK',
    MW_N = 'MW-N',
    MW_NS = 'MW-NS',
    MW_NU = 'MW-NU',
    MW_NI = 'MW-NI',
    MW_PH = 'MW-PH',
    MW_RU = 'MW-RU',
    MW_SA = 'MW-SA',
    MW_S = 'MW-S',
    MW_TH = 'MW-TH',
    MW_ZO = 'MW-ZO',
    MY_01 = 'MY-01',
    MY_02 = 'MY-02',
    MY_03 = 'MY-03',
    MY_04 = 'MY-04',
    MY_05 = 'MY-05',
    MY_06 = 'MY-06',
    MY_08 = 'MY-08',
    MY_09 = 'MY-09',
    MY_07 = 'MY-07',
    MY_12 = 'MY-12',
    MY_13 = 'MY-13',
    MY_10 = 'MY-10',
    MY_11 = 'MY-11',
    MY_14 = 'MY-14',
    MY_15 = 'MY-15',
    MY_16 = 'MY-16',
    NA_KA = 'NA-KA',
    NA_ER = 'NA-ER',
    NA_HA = 'NA-HA',
    NA_KE = 'NA-KE',
    NA_KW = 'NA-KW',
    NA_KH = 'NA-KH',
    NA_KU = 'NA-KU',
    NA_OW = 'NA-OW',
    NA_OH = 'NA-OH',
    NA_OS = 'NA-OS',
    NA_ON = 'NA-ON',
    NA_OT = 'NA-OT',
    NA_OD = 'NA-OD',
    NA_CA = 'NA-CA',
    NE_1 = 'NE-1',
    NE_2 = 'NE-2',
    NE_3 = 'NE-3',
    NE_4 = 'NE-4',
    NE_8 = 'NE-8',
    NE_5 = 'NE-5',
    NE_6 = 'NE-6',
    NE_7 = 'NE-7',
    NG_AB = 'NG-AB',
    NG_FC = 'NG-FC',
    NG_AD = 'NG-AD',
    NG_AK = 'NG-AK',
    NG_AN = 'NG-AN',
    NG_BA = 'NG-BA',
    NG_BY = 'NG-BY',
    NG_BE = 'NG-BE',
    NG_BO = 'NG-BO',
    NG_CR = 'NG-CR',
    NG_DE = 'NG-DE',
    NG_EB = 'NG-EB',
    NG_ED = 'NG-ED',
    NG_EK = 'NG-EK',
    NG_EN = 'NG-EN',
    NG_GO = 'NG-GO',
    NG_IM = 'NG-IM',
    NG_JI = 'NG-JI',
    NG_KD = 'NG-KD',
    NG_KN = 'NG-KN',
    NG_KT = 'NG-KT',
    NG_KE = 'NG-KE',
    NG_KO = 'NG-KO',
    NG_KW = 'NG-KW',
    NG_LA = 'NG-LA',
    NG_NA = 'NG-NA',
    NG_NI = 'NG-NI',
    NG_OG = 'NG-OG',
    NG_ON = 'NG-ON',
    NG_OS = 'NG-OS',
    NG_OY = 'NG-OY',
    NG_PL = 'NG-PL',
    NG_RI = 'NG-RI',
    NG_SO = 'NG-SO',
    NG_TA = 'NG-TA',
    NG_YO = 'NG-YO',
    NG_ZA = 'NG-ZA',
    NI_BO = 'NI-BO',
    NI_CA = 'NI-CA',
    NI_CI = 'NI-CI',
    NI_CO = 'NI-CO',
    NI_AN = 'NI-AN',
    NI_AS = 'NI-AS',
    NI_ES = 'NI-ES',
    NI_GR = 'NI-GR',
    NI_JI = 'NI-JI',
    NI_LE = 'NI-LE',
    NI_MD = 'NI-MD',
    NI_MN = 'NI-MN',
    NI_MS = 'NI-MS',
    NI_MT = 'NI-MT',
    NI_NS = 'NI-NS',
    NI_RI = 'NI-RI',
    NI_SJ = 'NI-SJ',
    NL_AW = 'NL-AW',
    NL_BQ1 = 'NL-BQ1',
    NL_CW = 'NL-CW',
    NL_DR = 'NL-DR',
    NL_FL = 'NL-FL',
    NL_FR = 'NL-FR',
    NL_GE = 'NL-GE',
    NL_GR = 'NL-GR',
    NL_LI = 'NL-LI',
    NL_NB = 'NL-NB',
    NL_NH = 'NL-NH',
    NL_OV = 'NL-OV',
    NL_BQ2 = 'NL-BQ2',
    NL_BQ3 = 'NL-BQ3',
    NL_SX = 'NL-SX',
    NL_UT = 'NL-UT',
    NL_ZE = 'NL-ZE',
    NL_ZH = 'NL-ZH',
    NO_42 = 'NO-42',
    NO_34 = 'NO-34',
    NO_22 = 'NO-22',
    NO_15 = 'NO-15',
    NO_18 = 'NO-18',
    NO_03 = 'NO-03',
    NO_11 = 'NO-11',
    NO_54 = 'NO-54',
    NO_21 = 'NO-21',
    NO_50 = 'NO-50',
    NO_38 = 'NO-38',
    NO_46 = 'NO-46',
    NO_30 = 'NO-30',
    NP_P3 = 'NP-P3',
    NP_P4 = 'NP-P4',
    NP_P6 = 'NP-P6',
    NP_P1 = 'NP-P1',
    NP_P5 = 'NP-P5',
    NP_P2 = 'NP-P2',
    NP_P7 = 'NP-P7',
    NR_01 = 'NR-01',
    NR_02 = 'NR-02',
    NR_03 = 'NR-03',
    NR_04 = 'NR-04',
    NR_05 = 'NR-05',
    NR_06 = 'NR-06',
    NR_07 = 'NR-07',
    NR_08 = 'NR-08',
    NR_09 = 'NR-09',
    NR_10 = 'NR-10',
    NR_11 = 'NR-11',
    NR_12 = 'NR-12',
    NR_13 = 'NR-13',
    NR_14 = 'NR-14',
    NZ_AUK = 'NZ-AUK',
    NZ_BOP = 'NZ-BOP',
    NZ_CAN = 'NZ-CAN',
    NZ_CIT = 'NZ-CIT',
    NZ_GIS = 'NZ-GIS',
    NZ_WGN = 'NZ-WGN',
    NZ_HKB = 'NZ-HKB',
    NZ_MWT = 'NZ-MWT',
    NZ_MBH = 'NZ-MBH',
    NZ_NSN = 'NZ-NSN',
    NZ_NTL = 'NZ-NTL',
    NZ_OTA = 'NZ-OTA',
    NZ_STL = 'NZ-STL',
    NZ_TKI = 'NZ-TKI',
    NZ_TAS = 'NZ-TAS',
    NZ_WKO = 'NZ-WKO',
    NZ_WTC = 'NZ-WTC',
    OM_DA = 'OM-DA',
    OM_BU = 'OM-BU',
    OM_WU = 'OM-WU',
    OM_ZA = 'OM-ZA',
    OM_BJ = 'OM-BJ',
    OM_SJ = 'OM-SJ',
    OM_MA = 'OM-MA',
    OM_MU = 'OM-MU',
    OM_BS = 'OM-BS',
    OM_SS = 'OM-SS',
    OM_ZU = 'OM-ZU',
    PK_JK = 'PK-JK',
    PK_BA = 'PK-BA',
    PK_GB = 'PK-GB',
    PK_IS = 'PK-IS',
    PK_KP = 'PK-KP',
    PK_PB = 'PK-PB',
    PK_SD = 'PK-SD',
    PA_1 = 'PA-1',
    PA_4 = 'PA-4',
    PA_2 = 'PA-2',
    PA_3 = 'PA-3',
    PA_5 = 'PA-5',
    PA_EM = 'PA-EM',
    PA_KY = 'PA-KY',
    PA_6 = 'PA-6',
    PA_7 = 'PA-7',
    PA_NT = 'PA-NT',
    PA_NB = 'PA-NB',
    PA_8 = 'PA-8',
    PA_10 = 'PA-10',
    PA_9 = 'PA-9',
    PE_AMA = 'PE-AMA',
    PE_ANC = 'PE-ANC',
    PE_APU = 'PE-APU',
    PE_ARE = 'PE-ARE',
    PE_AYA = 'PE-AYA',
    PE_CAJ = 'PE-CAJ',
    PE_CUS = 'PE-CUS',
    PE_CAL = 'PE-CAL',
    PE_HUV = 'PE-HUV',
    PE_JUN = 'PE-JUN',
    PE_HUC = 'PE-HUC',
    PE_ICA = 'PE-ICA',
    PE_LAL = 'PE-LAL',
    PE_LAM = 'PE-LAM',
    PE_LIM = 'PE-LIM',
    PE_LMA = 'PE-LMA',
    PE_LOR = 'PE-LOR',
    PE_MDD = 'PE-MDD',
    PE_MOQ = 'PE-MOQ',
    PE_PAS = 'PE-PAS',
    PE_PIU = 'PE-PIU',
    PE_PUN = 'PE-PUN',
    PE_SAM = 'PE-SAM',
    PE_TAC = 'PE-TAC',
    PE_TUM = 'PE-TUM',
    PE_UCA = 'PE-UCA',
    PH_ABR = 'PH-ABR',
    PH_AGN = 'PH-AGN',
    PH_AGS = 'PH-AGS',
    PH_AKL = 'PH-AKL',
    PH_ALB = 'PH-ALB',
    PH_ANT = 'PH-ANT',
    PH_APA = 'PH-APA',
    PH_AUR = 'PH-AUR',
    PH_14 = 'PH-14',
    PH_BAS = 'PH-BAS',
    PH_BAN = 'PH-BAN',
    PH_BTN = 'PH-BTN',
    PH_BTG = 'PH-BTG',
    PH_BEN = 'PH-BEN',
    PH_05 = 'PH-05',
    PH_BIL = 'PH-BIL',
    PH_BOH = 'PH-BOH',
    PH_BUK = 'PH-BUK',
    PH_BUL = 'PH-BUL',
    PH_CAG = 'PH-CAG',
    PH_02 = 'PH-02',
    PH_40 = 'PH-40',
    PH_CAN = 'PH-CAN',
    PH_CAS = 'PH-CAS',
    PH_CAM = 'PH-CAM',
    PH_CAP = 'PH-CAP',
    PH_13 = 'PH-13',
    PH_CAT = 'PH-CAT',
    PH_CAV = 'PH-CAV',
    PH_CEB = 'PH-CEB',
    PH_03 = 'PH-03',
    PH_07 = 'PH-07',
    PH_15 = 'PH-15',
    PH_NCO = 'PH-NCO',
    PH_11 = 'PH-11',
    PH_DVO = 'PH-DVO',
    PH_DAO = 'PH-DAO',
    PH_COM = 'PH-COM',
    PH_DAV = 'PH-DAV',
    PH_DAS = 'PH-DAS',
    PH_DIN = 'PH-DIN',
    PH_EAS = 'PH-EAS',
    PH_08 = 'PH-08',
    PH_GUI = 'PH-GUI',
    PH_IFU = 'PH-IFU',
    PH_01 = 'PH-01',
    PH_ILN = 'PH-ILN',
    PH_ILS = 'PH-ILS',
    PH_ILI = 'PH-ILI',
    PH_ISA = 'PH-ISA',
    PH_KAL = 'PH-KAL',
    PH_LUN = 'PH-LUN',
    PH_LAG = 'PH-LAG',
    PH_LAN = 'PH-LAN',
    PH_LAS = 'PH-LAS',
    PH_LEY = 'PH-LEY',
    PH_MGN = 'PH-MGN',
    PH_MGS = 'PH-MGS',
    PH_MAD = 'PH-MAD',
    PH_MAS = 'PH-MAS',
    PH_41 = 'PH-41',
    PH_MDC = 'PH-MDC',
    PH_MDR = 'PH-MDR',
    PH_MSC = 'PH-MSC',
    PH_MSR = 'PH-MSR',
    PH_MOU = 'PH-MOU',
    PH_00 = 'PH-00',
    PH_NEC = 'PH-NEC',
    PH_NER = 'PH-NER',
    PH_10 = 'PH-10',
    PH_NSA = 'PH-NSA',
    PH_NUE = 'PH-NUE',
    PH_NUV = 'PH-NUV',
    PH_PLW = 'PH-PLW',
    PH_PAM = 'PH-PAM',
    PH_PAN = 'PH-PAN',
    PH_QUE = 'PH-QUE',
    PH_QUI = 'PH-QUI',
    PH_RIZ = 'PH-RIZ',
    PH_ROM = 'PH-ROM',
    PH_WSA = 'PH-WSA',
    PH_SAR = 'PH-SAR',
    PH_SIG = 'PH-SIG',
    PH_12 = 'PH-12',
    PH_SOR = 'PH-SOR',
    PH_SCO = 'PH-SCO',
    PH_SLE = 'PH-SLE',
    PH_SUK = 'PH-SUK',
    PH_SLU = 'PH-SLU',
    PH_SUN = 'PH-SUN',
    PH_SUR = 'PH-SUR',
    PH_TAR = 'PH-TAR',
    PH_TAW = 'PH-TAW',
    PH_06 = 'PH-06',
    PH_ZMB = 'PH-ZMB',
    PH_09 = 'PH-09',
    PH_ZSI = 'PH-ZSI',
    PH_ZAN = 'PH-ZAN',
    PH_ZAS = 'PH-ZAS',
    PW_002 = 'PW-002',
    PW_004 = 'PW-004',
    PW_010 = 'PW-010',
    PW_050 = 'PW-050',
    PW_100 = 'PW-100',
    PW_150 = 'PW-150',
    PW_212 = 'PW-212',
    PW_214 = 'PW-214',
    PW_218 = 'PW-218',
    PW_222 = 'PW-222',
    PW_224 = 'PW-224',
    PW_226 = 'PW-226',
    PW_227 = 'PW-227',
    PW_228 = 'PW-228',
    PW_350 = 'PW-350',
    PW_370 = 'PW-370',
    PG_NSB = 'PG-NSB',
    PG_CPM = 'PG-CPM',
    PG_CPK = 'PG-CPK',
    PG_EBR = 'PG-EBR',
    PG_ESW = 'PG-ESW',
    PG_EHG = 'PG-EHG',
    PG_EPW = 'PG-EPW',
    PG_GPK = 'PG-GPK',
    PG_HLA = 'PG-HLA',
    PG_JWK = 'PG-JWK',
    PG_MPM = 'PG-MPM',
    PG_MRL = 'PG-MRL',
    PG_MBA = 'PG-MBA',
    PG_MPL = 'PG-MPL',
    PG_NCD = 'PG-NCD',
    PG_NIK = 'PG-NIK',
    PG_NPP = 'PG-NPP',
    PG_SHM = 'PG-SHM',
    PG_WBK = 'PG-WBK',
    PG_SAN = 'PG-SAN',
    PG_WPD = 'PG-WPD',
    PG_WHM = 'PG-WHM',
    PL_02 = 'PL-02',
    PL_04 = 'PL-04',
    PL_06 = 'PL-06',
    PL_08 = 'PL-08',
    PL_14 = 'PL-14',
    PL_12 = 'PL-12',
    PL_16 = 'PL-16',
    PL_18 = 'PL-18',
    PL_20 = 'PL-20',
    PL_22 = 'PL-22',
    PL_28 = 'PL-28',
    PL_30 = 'PL-30',
    PL_32 = 'PL-32',
    PL_10 = 'PL-10',
    PL_24 = 'PL-24',
    PL_26 = 'PL-26',
    KP_04 = 'KP-04',
    KP_09 = 'KP-09',
    KP_08 = 'KP-08',
    KP_06 = 'KP-06',
    KP_05 = 'KP-05',
    KP_15 = 'KP-15',
    KP_07 = 'KP-07',
    KP_14 = 'KP-14',
    KP_03 = 'KP-03',
    KP_02 = 'KP-02',
    KP_01 = 'KP-01',
    KP_13 = 'KP-13',
    KP_10 = 'KP-10',
    PT_01 = 'PT-01',
    PT_02 = 'PT-02',
    PT_03 = 'PT-03',
    PT_04 = 'PT-04',
    PT_05 = 'PT-05',
    PT_06 = 'PT-06',
    PT_08 = 'PT-08',
    PT_09 = 'PT-09',
    PT_10 = 'PT-10',
    PT_11 = 'PT-11',
    PT_12 = 'PT-12',
    PT_13 = 'PT-13',
    PT_30 = 'PT-30',
    PT_20 = 'PT-20',
    PT_14 = 'PT-14',
    PT_15 = 'PT-15',
    PT_16 = 'PT-16',
    PT_17 = 'PT-17',
    PT_18 = 'PT-18',
    PT_07 = 'PT-07',
    PY_16 = 'PY-16',
    PY_10 = 'PY-10',
    PY_13 = 'PY-13',
    PY_ASU = 'PY-ASU',
    PY_19 = 'PY-19',
    PY_5 = 'PY-5',
    PY_6 = 'PY-6',
    PY_14 = 'PY-14',
    PY_11 = 'PY-11',
    PY_1 = 'PY-1',
    PY_3 = 'PY-3',
    PY_4 = 'PY-4',
    PY_7 = 'PY-7',
    PY_8 = 'PY-8',
    PY_9 = 'PY-9',
    PY_15 = 'PY-15',
    PY_2 = 'PY-2',
    PY_12 = 'PY-12',
    PS_BTH = 'PS-BTH',
    PS_DEB = 'PS-DEB',
    PS_GZA = 'PS-GZA',
    PS_HBN = 'PS-HBN',
    PS_JEN = 'PS-JEN',
    PS_JRH = 'PS-JRH',
    PS_JEM = 'PS-JEM',
    PS_KYS = 'PS-KYS',
    PS_NBS = 'PS-NBS',
    PS_NGZ = 'PS-NGZ',
    PS_QQA = 'PS-QQA',
    PS_RFH = 'PS-RFH',
    PS_RBH = 'PS-RBH',
    PS_SLT = 'PS-SLT',
    PS_TBS = 'PS-TBS',
    PS_TKM = 'PS-TKM',
    QA_DA = 'QA-DA',
    QA_KH = 'QA-KH',
    QA_WA = 'QA-WA',
    QA_RA = 'QA-RA',
    QA_MS = 'QA-MS',
    QA_SH = 'QA-SH',
    QA_ZA = 'QA-ZA',
    QA_US = 'QA-US',
    RO_AB = 'RO-AB',
    RO_AR = 'RO-AR',
    RO_AG = 'RO-AG',
    RO_BC = 'RO-BC',
    RO_BH = 'RO-BH',
    RO_BN = 'RO-BN',
    RO_BT = 'RO-BT',
    RO_BV = 'RO-BV',
    RO_BR = 'RO-BR',
    RO_B = 'RO-B',
    RO_BZ = 'RO-BZ',
    RO_CS = 'RO-CS',
    RO_CJ = 'RO-CJ',
    RO_CT = 'RO-CT',
    RO_CV = 'RO-CV',
    RO_CL = 'RO-CL',
    RO_DJ = 'RO-DJ',
    RO_DB = 'RO-DB',
    RO_GL = 'RO-GL',
    RO_GR = 'RO-GR',
    RO_GJ = 'RO-GJ',
    RO_HR = 'RO-HR',
    RO_HD = 'RO-HD',
    RO_IL = 'RO-IL',
    RO_IS = 'RO-IS',
    RO_IF = 'RO-IF',
    RO_MM = 'RO-MM',
    RO_MH = 'RO-MH',
    RO_MS = 'RO-MS',
    RO_NT = 'RO-NT',
    RO_OT = 'RO-OT',
    RO_PH = 'RO-PH',
    RO_SM = 'RO-SM',
    RO_SB = 'RO-SB',
    RO_SV = 'RO-SV',
    RO_SJ = 'RO-SJ',
    RO_TR = 'RO-TR',
    RO_TM = 'RO-TM',
    RO_TL = 'RO-TL',
    RO_VS = 'RO-VS',
    RO_VN = 'RO-VN',
    RO_VL = 'RO-VL',
    RU_AD = 'RU-AD',
    RU_AL = 'RU-AL',
    RU_ALT = 'RU-ALT',
    RU_AMU = 'RU-AMU',
    RU_ARK = 'RU-ARK',
    RU_AST = 'RU-AST',
    RU_BA = 'RU-BA',
    RU_BEL = 'RU-BEL',
    RU_BRY = 'RU-BRY',
    RU_BU = 'RU-BU',
    RU_CE = 'RU-CE',
    RU_CHE = 'RU-CHE',
    RU_CHU = 'RU-CHU',
    RU_CU = 'RU-CU',
    RU_DA = 'RU-DA',
    RU_YEV = 'RU-YEV',
    RU_KHA = 'RU-KHA',
    RU_KK = 'RU-KK',
    RU_KHM = 'RU-KHM',
    RU_IN = 'RU-IN',
    RU_IRK = 'RU-IRK',
    RU_IVA = 'RU-IVA',
    RU_YAN = 'RU-YAN',
    RU_YAR = 'RU-YAR',
    RU_KB = 'RU-KB',
    RU_KGD = 'RU-KGD',
    RU_KL = 'RU-KL',
    RU_KLU = 'RU-KLU',
    RU_KAM = 'RU-KAM',
    RU_KC = 'RU-KC',
    RU_KR = 'RU-KR',
    RU_KEM = 'RU-KEM',
    RU_KIR = 'RU-KIR',
    RU_KO = 'RU-KO',
    RU_KOS = 'RU-KOS',
    RU_KDA = 'RU-KDA',
    RU_KYA = 'RU-KYA',
    RU_KGN = 'RU-KGN',
    RU_KRS = 'RU-KRS',
    RU_LEN = 'RU-LEN',
    RU_LIP = 'RU-LIP',
    RU_MAG = 'RU-MAG',
    RU_ME = 'RU-ME',
    RU_MO = 'RU-MO',
    RU_MOS = 'RU-MOS',
    RU_MOW = 'RU-MOW',
    RU_MUR = 'RU-MUR',
    RU_NEN = 'RU-NEN',
    RU_NIZ = 'RU-NIZ',
    RU_NGR = 'RU-NGR',
    RU_NVS = 'RU-NVS',
    RU_OMS = 'RU-OMS',
    RU_ORE = 'RU-ORE',
    RU_ORL = 'RU-ORL',
    RU_PNZ = 'RU-PNZ',
    RU_PER = 'RU-PER',
    RU_PRI = 'RU-PRI',
    RU_PSK = 'RU-PSK',
    RU_RYA = 'RU-RYA',
    RU_ROS = 'RU-ROS',
    RU_SA = 'RU-SA',
    RU_SAK = 'RU-SAK',
    RU_SAM = 'RU-SAM',
    RU_SPE = 'RU-SPE',
    RU_SAR = 'RU-SAR',
    RU_SE = 'RU-SE',
    RU_SMO = 'RU-SMO',
    RU_STA = 'RU-STA',
    RU_SVE = 'RU-SVE',
    RU_TAM = 'RU-TAM',
    RU_TA = 'RU-TA',
    RU_TYU = 'RU-TYU',
    RU_TOM = 'RU-TOM',
    RU_TUL = 'RU-TUL',
    RU_TVE = 'RU-TVE',
    RU_TY = 'RU-TY',
    RU_UD = 'RU-UD',
    RU_ULY = 'RU-ULY',
    RU_VLA = 'RU-VLA',
    RU_VGG = 'RU-VGG',
    RU_VLG = 'RU-VLG',
    RU_VOR = 'RU-VOR',
    RU_ZAB = 'RU-ZAB',
    RW_01 = 'RW-01',
    RW_02 = 'RW-02',
    RW_03 = 'RW-03',
    RW_05 = 'RW-05',
    RW_04 = 'RW-04',
    SA_14 = 'SA-14',
    SA_11 = 'SA-11',
    SA_12 = 'SA-12',
    SA_03 = 'SA-03',
    SA_05 = 'SA-05',
    SA_08 = 'SA-08',
    SA_01 = 'SA-01',
    SA_04 = 'SA-04',
    SA_09 = 'SA-09',
    SA_02 = 'SA-02',
    SA_10 = 'SA-10',
    SA_07 = 'SA-07',
    SA_06 = 'SA-06',
    SD_NB = 'SD-NB',
    SD_DC = 'SD-DC',
    SD_DE = 'SD-DE',
    SD_GD = 'SD-GD',
    SD_GZ = 'SD-GZ',
    SD_KA = 'SD-KA',
    SD_KH = 'SD-KH',
    SD_DN = 'SD-DN',
    SD_KN = 'SD-KN',
    SD_NO = 'SD-NO',
    SD_RS = 'SD-RS',
    SD_NR = 'SD-NR',
    SD_SI = 'SD-SI',
    SD_DS = 'SD-DS',
    SD_KS = 'SD-KS',
    SD_DW = 'SD-DW',
    SD_GK = 'SD-GK',
    SD_NW = 'SD-NW',
    SN_DK = 'SN-DK',
    SN_DB = 'SN-DB',
    SN_FK = 'SN-FK',
    SN_KA = 'SN-KA',
    SN_KL = 'SN-KL',
    SN_KD = 'SN-KD',
    SN_KE = 'SN-KE',
    SN_LG = 'SN-LG',
    SN_MT = 'SN-MT',
    SN_SL = 'SN-SL',
    SN_SE = 'SN-SE',
    SN_TC = 'SN-TC',
    SN_TH = 'SN-TH',
    SN_ZG = 'SN-ZG',
    SG_01 = 'SG-01',
    SG_02 = 'SG-02',
    SG_03 = 'SG-03',
    SG_04 = 'SG-04',
    SG_05 = 'SG-05',
    SH_AC = 'SH-AC',
    SH_HL = 'SH-HL',
    SH_TA = 'SH-TA',
    SB_CT = 'SB-CT',
    SB_CE = 'SB-CE',
    SB_CH = 'SB-CH',
    SB_GU = 'SB-GU',
    SB_IS = 'SB-IS',
    SB_MK = 'SB-MK',
    SB_ML = 'SB-ML',
    SB_RB = 'SB-RB',
    SB_TE = 'SB-TE',
    SB_WE = 'SB-WE',
    SL_E = 'SL-E',
    SL_NW = 'SL-NW',
    SL_N = 'SL-N',
    SL_S = 'SL-S',
    SL_W = 'SL-W',
    SV_AH = 'SV-AH',
    SV_CA = 'SV-CA',
    SV_CH = 'SV-CH',
    SV_CU = 'SV-CU',
    SV_LI = 'SV-LI',
    SV_PA = 'SV-PA',
    SV_UN = 'SV-UN',
    SV_MO = 'SV-MO',
    SV_SM = 'SV-SM',
    SV_SS = 'SV-SS',
    SV_SV = 'SV-SV',
    SV_SA = 'SV-SA',
    SV_SO = 'SV-SO',
    SV_US = 'SV-US',
    SM_01 = 'SM-01',
    SM_06 = 'SM-06',
    SM_02 = 'SM-02',
    SM_07 = 'SM-07',
    SM_03 = 'SM-03',
    SM_04 = 'SM-04',
    SM_05 = 'SM-05',
    SM_08 = 'SM-08',
    SM_09 = 'SM-09',
    SO_AW = 'SO-AW',
    SO_BK = 'SO-BK',
    SO_BN = 'SO-BN',
    SO_BR = 'SO-BR',
    SO_BY = 'SO-BY',
    SO_GA = 'SO-GA',
    SO_GE = 'SO-GE',
    SO_HI = 'SO-HI',
    SO_JD = 'SO-JD',
    SO_JH = 'SO-JH',
    SO_MU = 'SO-MU',
    SO_NU = 'SO-NU',
    SO_SA = 'SO-SA',
    SO_SD = 'SO-SD',
    SO_SH = 'SO-SH',
    SO_SO = 'SO-SO',
    SO_TO = 'SO-TO',
    SO_WO = 'SO-WO',
    RS_00 = 'RS-00',
    RS_14 = 'RS-14',
    RS_11 = 'RS-11',
    RS_23 = 'RS-23',
    RS_04 = 'RS-04',
    RS_06 = 'RS-06',
    RS_09 = 'RS-09',
    RS_KM = 'RS-KM',
    RS_25 = 'RS-25',
    RS_28 = 'RS-28',
    RS_29 = 'RS-29',
    RS_08 = 'RS-08',
    RS_17 = 'RS-17',
    RS_20 = 'RS-20',
    RS_26 = 'RS-26',
    RS_22 = 'RS-22',
    RS_10 = 'RS-10',
    RS_13 = 'RS-13',
    RS_27 = 'RS-27',
    RS_24 = 'RS-24',
    RS_19 = 'RS-19',
    RS_18 = 'RS-18',
    RS_03 = 'RS-03',
    RS_01 = 'RS-01',
    RS_02 = 'RS-02',
    RS_07 = 'RS-07',
    RS_21 = 'RS-21',
    RS_VO = 'RS-VO',
    RS_15 = 'RS-15',
    RS_05 = 'RS-05',
    RS_16 = 'RS-16',
    RS_12 = 'RS-12',
    SS_EC = 'SS-EC',
    SS_EE = 'SS-EE',
    SS_JG = 'SS-JG',
    SS_LK = 'SS-LK',
    SS_BN = 'SS-BN',
    SS_UY = 'SS-UY',
    SS_NU = 'SS-NU',
    SS_WR = 'SS-WR',
    SS_BW = 'SS-BW',
    SS_EW = 'SS-EW',
    ST_02 = 'ST-02',
    ST_03 = 'ST-03',
    ST_04 = 'ST-04',
    ST_05 = 'ST-05',
    ST_06 = 'ST-06',
    ST_P = 'ST-P',
    ST_01 = 'ST-01',
    SR_BR = 'SR-BR',
    SR_CM = 'SR-CM',
    SR_CR = 'SR-CR',
    SR_MA = 'SR-MA',
    SR_NI = 'SR-NI',
    SR_PR = 'SR-PR',
    SR_PM = 'SR-PM',
    SR_SA = 'SR-SA',
    SR_SI = 'SR-SI',
    SR_WA = 'SR-WA',
    SK_BC = 'SK-BC',
    SK_BL = 'SK-BL',
    SK_KI = 'SK-KI',
    SK_NI = 'SK-NI',
    SK_PV = 'SK-PV',
    SK_TC = 'SK-TC',
    SK_TA = 'SK-TA',
    SK_ZI = 'SK-ZI',
    SI_001 = 'SI-001',
    SI_213 = 'SI-213',
    SI_195 = 'SI-195',
    SI_002 = 'SI-002',
    SI_148 = 'SI-148',
    SI_149 = 'SI-149',
    SI_003 = 'SI-003',
    SI_150 = 'SI-150',
    SI_004 = 'SI-004',
    SI_005 = 'SI-005',
    SI_006 = 'SI-006',
    SI_151 = 'SI-151',
    SI_007 = 'SI-007',
    SI_008 = 'SI-008',
    SI_009 = 'SI-009',
    SI_152 = 'SI-152',
    SI_011 = 'SI-011',
    SI_012 = 'SI-012',
    SI_013 = 'SI-013',
    SI_014 = 'SI-014',
    SI_153 = 'SI-153',
    SI_196 = 'SI-196',
    SI_018 = 'SI-018',
    SI_019 = 'SI-019',
    SI_154 = 'SI-154',
    SI_020 = 'SI-020',
    SI_155 = 'SI-155',
    SI_021 = 'SI-021',
    SI_156 = 'SI-156',
    SI_022 = 'SI-022',
    SI_157 = 'SI-157',
    SI_023 = 'SI-023',
    SI_024 = 'SI-024',
    SI_025 = 'SI-025',
    SI_026 = 'SI-026',
    SI_027 = 'SI-027',
    SI_028 = 'SI-028',
    SI_207 = 'SI-207',
    SI_029 = 'SI-029',
    SI_030 = 'SI-030',
    SI_031 = 'SI-031',
    SI_158 = 'SI-158',
    SI_032 = 'SI-032',
    SI_159 = 'SI-159',
    SI_161 = 'SI-161',
    SI_162 = 'SI-162',
    SI_160 = 'SI-160',
    SI_034 = 'SI-034',
    SI_035 = 'SI-035',
    SI_036 = 'SI-036',
    SI_037 = 'SI-037',
    SI_038 = 'SI-038',
    SI_039 = 'SI-039',
    SI_040 = 'SI-040',
    SI_041 = 'SI-041',
    SI_163 = 'SI-163',
    SI_042 = 'SI-042',
    SI_043 = 'SI-043',
    SI_044 = 'SI-044',
    SI_045 = 'SI-045',
    SI_046 = 'SI-046',
    SI_047 = 'SI-047',
    SI_049 = 'SI-049',
    SI_164 = 'SI-164',
    SI_050 = 'SI-050',
    SI_197 = 'SI-197',
    SI_165 = 'SI-165',
    SI_051 = 'SI-051',
    SI_048 = 'SI-048',
    SI_052 = 'SI-052',
    SI_053 = 'SI-053',
    SI_166 = 'SI-166',
    SI_054 = 'SI-054',
    SI_055 = 'SI-055',
    SI_056 = 'SI-056',
    SI_057 = 'SI-057',
    SI_058 = 'SI-058',
    SI_059 = 'SI-059',
    SI_060 = 'SI-060',
    SI_061 = 'SI-061',
    SI_062 = 'SI-062',
    SI_063 = 'SI-063',
    SI_208 = 'SI-208',
    SI_064 = 'SI-064',
    SI_167 = 'SI-167',
    SI_065 = 'SI-065',
    SI_066 = 'SI-066',
    SI_068 = 'SI-068',
    SI_067 = 'SI-067',
    SI_069 = 'SI-069',
    SI_198 = 'SI-198',
    SI_070 = 'SI-070',
    SI_168 = 'SI-168',
    SI_071 = 'SI-071',
    SI_072 = 'SI-072',
    SI_073 = 'SI-073',
    SI_074 = 'SI-074',
    SI_169 = 'SI-169',
    SI_075 = 'SI-075',
    SI_212 = 'SI-212',
    SI_170 = 'SI-170',
    SI_076 = 'SI-076',
    SI_199 = 'SI-199',
    SI_078 = 'SI-078',
    SI_077 = 'SI-077',
    SI_079 = 'SI-079',
    SI_080 = 'SI-080',
    SI_081 = 'SI-081',
    SI_082 = 'SI-082',
    SI_083 = 'SI-083',
    SI_084 = 'SI-084',
    SI_085 = 'SI-085',
    SI_086 = 'SI-086',
    SI_171 = 'SI-171',
    SI_087 = 'SI-087',
    SI_088 = 'SI-088',
    SI_089 = 'SI-089',
    SI_090 = 'SI-090',
    SI_091 = 'SI-091',
    SI_172 = 'SI-172',
    SI_093 = 'SI-093',
    SI_092 = 'SI-092',
    SI_200 = 'SI-200',
    SI_173 = 'SI-173',
    SI_094 = 'SI-094',
    SI_174 = 'SI-174',
    SI_095 = 'SI-095',
    SI_175 = 'SI-175',
    SI_096 = 'SI-096',
    SI_097 = 'SI-097',
    SI_100 = 'SI-100',
    SI_099 = 'SI-099',
    SI_101 = 'SI-101',
    SI_102 = 'SI-102',
    SI_103 = 'SI-103',
    SI_176 = 'SI-176',
    SI_098 = 'SI-098',
    SI_201 = 'SI-201',
    SI_209 = 'SI-209',
    SI_104 = 'SI-104',
    SI_177 = 'SI-177',
    SI_107 = 'SI-107',
    SI_106 = 'SI-106',
    SI_105 = 'SI-105',
    SI_108 = 'SI-108',
    SI_178 = 'SI-178',
    SI_109 = 'SI-109',
    SI_110 = 'SI-110',
    SI_111 = 'SI-111',
    SI_112 = 'SI-112',
    SI_113 = 'SI-113',
    SI_114 = 'SI-114',
    SI_179 = 'SI-179',
    SI_180 = 'SI-180',
    SI_202 = 'SI-202',
    SI_115 = 'SI-115',
    SI_203 = 'SI-203',
    SI_181 = 'SI-181',
    SI_204 = 'SI-204',
    SI_182 = 'SI-182',
    SI_116 = 'SI-116',
    SI_210 = 'SI-210',
    SI_205 = 'SI-205',
    SI_184 = 'SI-184',
    SI_010 = 'SI-010',
    SI_128 = 'SI-128',
    SI_129 = 'SI-129',
    SI_130 = 'SI-130',
    SI_185 = 'SI-185',
    SI_186 = 'SI-186',
    SI_131 = 'SI-131',
    SI_132 = 'SI-132',
    SI_133 = 'SI-133',
    SI_187 = 'SI-187',
    SI_134 = 'SI-134',
    SI_188 = 'SI-188',
    SI_135 = 'SI-135',
    SI_136 = 'SI-136',
    SI_137 = 'SI-137',
    SI_138 = 'SI-138',
    SI_139 = 'SI-139',
    SI_189 = 'SI-189',
    SI_140 = 'SI-140',
    SI_141 = 'SI-141',
    SI_142 = 'SI-142',
    SI_143 = 'SI-143',
    SI_144 = 'SI-144',
    SI_015 = 'SI-015',
    SI_016 = 'SI-016',
    SI_017 = 'SI-017',
    SI_033 = 'SI-033',
    SI_183 = 'SI-183',
    SI_118 = 'SI-118',
    SI_119 = 'SI-119',
    SI_120 = 'SI-120',
    SI_211 = 'SI-211',
    SI_117 = 'SI-117',
    SI_121 = 'SI-121',
    SI_122 = 'SI-122',
    SI_123 = 'SI-123',
    SI_124 = 'SI-124',
    SI_206 = 'SI-206',
    SI_125 = 'SI-125',
    SI_194 = 'SI-194',
    SI_126 = 'SI-126',
    SI_127 = 'SI-127',
    SI_190 = 'SI-190',
    SI_146 = 'SI-146',
    SI_191 = 'SI-191',
    SI_147 = 'SI-147',
    SI_192 = 'SI-192',
    SI_193 = 'SI-193',
    SE_K = 'SE-K',
    SE_W = 'SE-W',
    SE_I = 'SE-I',
    SE_X = 'SE-X',
    SE_N = 'SE-N',
    SE_Z = 'SE-Z',
    SE_F = 'SE-F',
    SE_H = 'SE-H',
    SE_G = 'SE-G',
    SE_BD = 'SE-BD',
    SE_M = 'SE-M',
    SE_AB = 'SE-AB',
    SE_D = 'SE-D',
    SE_C = 'SE-C',
    SE_S = 'SE-S',
    SE_AC = 'SE-AC',
    SE_Y = 'SE-Y',
    SE_U = 'SE-U',
    SE_O = 'SE-O',
    SE_T = 'SE-T',
    SE_E = 'SE-E',
    SZ_HH = 'SZ-HH',
    SZ_LU = 'SZ-LU',
    SZ_MA = 'SZ-MA',
    SZ_SH = 'SZ-SH',
    SC_02 = 'SC-02',
    SC_03 = 'SC-03',
    SC_05 = 'SC-05',
    SC_01 = 'SC-01',
    SC_04 = 'SC-04',
    SC_06 = 'SC-06',
    SC_07 = 'SC-07',
    SC_08 = 'SC-08',
    SC_09 = 'SC-09',
    SC_10 = 'SC-10',
    SC_11 = 'SC-11',
    SC_16 = 'SC-16',
    SC_12 = 'SC-12',
    SC_13 = 'SC-13',
    SC_14 = 'SC-14',
    SC_26 = 'SC-26',
    SC_27 = 'SC-27',
    SC_15 = 'SC-15',
    SC_24 = 'SC-24',
    SC_17 = 'SC-17',
    SC_18 = 'SC-18',
    SC_19 = 'SC-19',
    SC_20 = 'SC-20',
    SC_21 = 'SC-21',
    SC_25 = 'SC-25',
    SC_22 = 'SC-22',
    SC_23 = 'SC-23',
    SY_LA = 'SY-LA',
    SY_QU = 'SY-QU',
    SY_HA = 'SY-HA',
    SY_RA = 'SY-RA',
    SY_SU = 'SY-SU',
    SY_DR = 'SY-DR',
    SY_DY = 'SY-DY',
    SY_DI = 'SY-DI',
    SY_ID = 'SY-ID',
    SY_RD = 'SY-RD',
    SY_TA = 'SY-TA',
    SY_HL = 'SY-HL',
    SY_HM = 'SY-HM',
    SY_HI = 'SY-HI',
    TD_BG = 'TD-BG',
    TD_BA = 'TD-BA',
    TD_BO = 'TD-BO',
    TD_CB = 'TD-CB',
    TD_EE = 'TD-EE',
    TD_EO = 'TD-EO',
    TD_GR = 'TD-GR',
    TD_HL = 'TD-HL',
    TD_KA = 'TD-KA',
    TD_LC = 'TD-LC',
    TD_LO = 'TD-LO',
    TD_LR = 'TD-LR',
    TD_MA = 'TD-MA',
    TD_ME = 'TD-ME',
    TD_MO = 'TD-MO',
    TD_MC = 'TD-MC',
    TD_OD = 'TD-OD',
    TD_SA = 'TD-SA',
    TD_SI = 'TD-SI',
    TD_TA = 'TD-TA',
    TD_TI = 'TD-TI',
    TD_ND = 'TD-ND',
    TD_WF = 'TD-WF',
    TG_C = 'TG-C',
    TG_K = 'TG-K',
    TG_M = 'TG-M',
    TG_P = 'TG-P',
    TG_S = 'TG-S',
    TH_37 = 'TH-37',
    TH_15 = 'TH-15',
    TH_38 = 'TH-38',
    TH_31 = 'TH-31',
    TH_24 = 'TH-24',
    TH_18 = 'TH-18',
    TH_36 = 'TH-36',
    TH_22 = 'TH-22',
    TH_50 = 'TH-50',
    TH_57 = 'TH-57',
    TH_20 = 'TH-20',
    TH_86 = 'TH-86',
    TH_46 = 'TH-46',
    TH_62 = 'TH-62',
    TH_71 = 'TH-71',
    TH_40 = 'TH-40',
    TH_81 = 'TH-81',
    TH_10 = 'TH-10',
    TH_52 = 'TH-52',
    TH_51 = 'TH-51',
    TH_42 = 'TH-42',
    TH_16 = 'TH-16',
    TH_58 = 'TH-58',
    TH_44 = 'TH-44',
    TH_49 = 'TH-49',
    TH_26 = 'TH-26',
    TH_73 = 'TH-73',
    TH_48 = 'TH-48',
    TH_30 = 'TH-30',
    TH_60 = 'TH-60',
    TH_80 = 'TH-80',
    TH_55 = 'TH-55',
    TH_96 = 'TH-96',
    TH_39 = 'TH-39',
    TH_43 = 'TH-43',
    TH_12 = 'TH-12',
    TH_13 = 'TH-13',
    TH_94 = 'TH-94',
    TH_82 = 'TH-82',
    TH_93 = 'TH-93',
    TH_S = 'TH-S',
    TH_56 = 'TH-56',
    TH_67 = 'TH-67',
    TH_76 = 'TH-76',
    TH_66 = 'TH-66',
    TH_65 = 'TH-65',
    TH_14 = 'TH-14',
    TH_54 = 'TH-54',
    TH_83 = 'TH-83',
    TH_25 = 'TH-25',
    TH_77 = 'TH-77',
    TH_85 = 'TH-85',
    TH_70 = 'TH-70',
    TH_21 = 'TH-21',
    TH_45 = 'TH-45',
    TH_27 = 'TH-27',
    TH_47 = 'TH-47',
    TH_11 = 'TH-11',
    TH_74 = 'TH-74',
    TH_75 = 'TH-75',
    TH_19 = 'TH-19',
    TH_91 = 'TH-91',
    TH_33 = 'TH-33',
    TH_17 = 'TH-17',
    TH_90 = 'TH-90',
    TH_64 = 'TH-64',
    TH_72 = 'TH-72',
    TH_84 = 'TH-84',
    TH_32 = 'TH-32',
    TH_63 = 'TH-63',
    TH_92 = 'TH-92',
    TH_23 = 'TH-23',
    TH_34 = 'TH-34',
    TH_41 = 'TH-41',
    TH_61 = 'TH-61',
    TH_53 = 'TH-53',
    TH_95 = 'TH-95',
    TH_35 = 'TH-35',
    TJ_DU = 'TJ-DU',
    TJ_KT = 'TJ-KT',
    TJ_GB = 'TJ-GB',
    TJ_SU = 'TJ-SU',
    TJ_RA = 'TJ-RA',
    TM_A = 'TM-A',
    TM_S = 'TM-S',
    TM_B = 'TM-B',
    TM_D = 'TM-D',
    TM_L = 'TM-L',
    TM_M = 'TM-M',
    TL_AL = 'TL-AL',
    TL_AN = 'TL-AN',
    TL_BA = 'TL-BA',
    TL_BO = 'TL-BO',
    TL_CO = 'TL-CO',
    TL_DI = 'TL-DI',
    TL_ER = 'TL-ER',
    TL_LA = 'TL-LA',
    TL_LI = 'TL-LI',
    TL_MT = 'TL-MT',
    TL_MF = 'TL-MF',
    TL_OE = 'TL-OE',
    TL_VI = 'TL-VI',
    TO_01 = 'TO-01',
    TO_02 = 'TO-02',
    TO_03 = 'TO-03',
    TO_04 = 'TO-04',
    TO_05 = 'TO-05',
    TT_ARI = 'TT-ARI',
    TT_CHA = 'TT-CHA',
    TT_CTT = 'TT-CTT',
    TT_DMN = 'TT-DMN',
    TT_MRC = 'TT-MRC',
    TT_PED = 'TT-PED',
    TT_PTF = 'TT-PTF',
    TT_POS = 'TT-POS',
    TT_PRT = 'TT-PRT',
    TT_SFO = 'TT-SFO',
    TT_SJL = 'TT-SJL',
    TT_SGE = 'TT-SGE',
    TT_SIP = 'TT-SIP',
    TT_TOB = 'TT-TOB',
    TT_TUP = 'TT-TUP',
    TN_13 = 'TN-13',
    TN_23 = 'TN-23',
    TN_31 = 'TN-31',
    TN_81 = 'TN-81',
    TN_71 = 'TN-71',
    TN_32 = 'TN-32',
    TN_41 = 'TN-41',
    TN_42 = 'TN-42',
    TN_73 = 'TN-73',
    TN_12 = 'TN-12',
    TN_14 = 'TN-14',
    TN_33 = 'TN-33',
    TN_53 = 'TN-53',
    TN_52 = 'TN-52',
    TN_82 = 'TN-82',
    TN_21 = 'TN-21',
    TN_61 = 'TN-61',
    TN_43 = 'TN-43',
    TN_34 = 'TN-34',
    TN_51 = 'TN-51',
    TN_83 = 'TN-83',
    TN_72 = 'TN-72',
    TN_11 = 'TN-11',
    TN_22 = 'TN-22',
    TR_01 = 'TR-01',
    TR_02 = 'TR-02',
    TR_03 = 'TR-03',
    TR_68 = 'TR-68',
    TR_05 = 'TR-05',
    TR_06 = 'TR-06',
    TR_07 = 'TR-07',
    TR_75 = 'TR-75',
    TR_08 = 'TR-08',
    TR_09 = 'TR-09',
    TR_04 = 'TR-04',
    TR_10 = 'TR-10',
    TR_74 = 'TR-74',
    TR_72 = 'TR-72',
    TR_69 = 'TR-69',
    TR_11 = 'TR-11',
    TR_12 = 'TR-12',
    TR_13 = 'TR-13',
    TR_14 = 'TR-14',
    TR_15 = 'TR-15',
    TR_16 = 'TR-16',
    TR_20 = 'TR-20',
    TR_21 = 'TR-21',
    TR_81 = 'TR-81',
    TR_22 = 'TR-22',
    TR_23 = 'TR-23',
    TR_24 = 'TR-24',
    TR_25 = 'TR-25',
    TR_26 = 'TR-26',
    TR_27 = 'TR-27',
    TR_28 = 'TR-28',
    TR_29 = 'TR-29',
    TR_30 = 'TR-30',
    TR_31 = 'TR-31',
    TR_32 = 'TR-32',
    TR_76 = 'TR-76',
    TR_46 = 'TR-46',
    TR_78 = 'TR-78',
    TR_70 = 'TR-70',
    TR_36 = 'TR-36',
    TR_37 = 'TR-37',
    TR_38 = 'TR-38',
    TR_79 = 'TR-79',
    TR_41 = 'TR-41',
    TR_42 = 'TR-42',
    TR_43 = 'TR-43',
    TR_39 = 'TR-39',
    TR_71 = 'TR-71',
    TR_40 = 'TR-40',
    TR_44 = 'TR-44',
    TR_45 = 'TR-45',
    TR_47 = 'TR-47',
    TR_33 = 'TR-33',
    TR_48 = 'TR-48',
    TR_49 = 'TR-49',
    TR_50 = 'TR-50',
    TR_51 = 'TR-51',
    TR_52 = 'TR-52',
    TR_80 = 'TR-80',
    TR_53 = 'TR-53',
    TR_54 = 'TR-54',
    TR_55 = 'TR-55',
    TR_56 = 'TR-56',
    TR_57 = 'TR-57',
    TR_58 = 'TR-58',
    TR_59 = 'TR-59',
    TR_60 = 'TR-60',
    TR_61 = 'TR-61',
    TR_62 = 'TR-62',
    TR_64 = 'TR-64',
    TR_65 = 'TR-65',
    TR_77 = 'TR-77',
    TR_66 = 'TR-66',
    TR_67 = 'TR-67',
    TR_17 = 'TR-17',
    TR_18 = 'TR-18',
    TR_19 = 'TR-19',
    TR_34 = 'TR-34',
    TR_35 = 'TR-35',
    TR_63 = 'TR-63',
    TR_73 = 'TR-73',
    TV_FUN = 'TV-FUN',
    TV_NMG = 'TV-NMG',
    TV_NMA = 'TV-NMA',
    TV_NIT = 'TV-NIT',
    TV_NUI = 'TV-NUI',
    TV_NKF = 'TV-NKF',
    TV_NKL = 'TV-NKL',
    TV_VAI = 'TV-VAI',
    TW_CHA = 'TW-CHA',
    TW_CYI = 'TW-CYI',
    TW_CYQ = 'TW-CYQ',
    TW_HSQ = 'TW-HSQ',
    TW_HSZ = 'TW-HSZ',
    TW_HUA = 'TW-HUA',
    TW_KHH = 'TW-KHH',
    TW_KEE = 'TW-KEE',
    TW_KIN = 'TW-KIN',
    TW_LIE = 'TW-LIE',
    TW_MIA = 'TW-MIA',
    TW_NAN = 'TW-NAN',
    TW_NWT = 'TW-NWT',
    TW_PEN = 'TW-PEN',
    TW_PIF = 'TW-PIF',
    TW_TXG = 'TW-TXG',
    TW_TNN = 'TW-TNN',
    TW_TPE = 'TW-TPE',
    TW_TTT = 'TW-TTT',
    TW_TAO = 'TW-TAO',
    TW_ILA = 'TW-ILA',
    TW_YUN = 'TW-YUN',
    TZ_01 = 'TZ-01',
    TZ_19 = 'TZ-19',
    TZ_02 = 'TZ-02',
    TZ_03 = 'TZ-03',
    TZ_27 = 'TZ-27',
    TZ_04 = 'TZ-04',
    TZ_05 = 'TZ-05',
    TZ_28 = 'TZ-28',
    TZ_08 = 'TZ-08',
    TZ_09 = 'TZ-09',
    TZ_12 = 'TZ-12',
    TZ_26 = 'TZ-26',
    TZ_13 = 'TZ-13',
    TZ_14 = 'TZ-14',
    TZ_16 = 'TZ-16',
    TZ_17 = 'TZ-17',
    TZ_18 = 'TZ-18',
    TZ_29 = 'TZ-29',
    TZ_06 = 'TZ-06',
    TZ_10 = 'TZ-10',
    TZ_20 = 'TZ-20',
    TZ_21 = 'TZ-21',
    TZ_22 = 'TZ-22',
    TZ_30 = 'TZ-30',
    TZ_23 = 'TZ-23',
    TZ_31 = 'TZ-31',
    TZ_24 = 'TZ-24',
    TZ_25 = 'TZ-25',
    TZ_07 = 'TZ-07',
    TZ_11 = 'TZ-11',
    TZ_15 = 'TZ-15',
    UG_314 = 'UG-314',
    UG_301 = 'UG-301',
    UG_322 = 'UG-322',
    UG_323 = 'UG-323',
    UG_315 = 'UG-315',
    UG_324 = 'UG-324',
    UG_216 = 'UG-216',
    UG_316 = 'UG-316',
    UG_302 = 'UG-302',
    UG_303 = 'UG-303',
    UG_217 = 'UG-217',
    UG_218 = 'UG-218',
    UG_201 = 'UG-201',
    UG_235 = 'UG-235',
    UG_420 = 'UG-420',
    UG_117 = 'UG-117',
    UG_219 = 'UG-219',
    UG_118 = 'UG-118',
    UG_220 = 'UG-220',
    UG_225 = 'UG-225',
    UG_416 = 'UG-416',
    UG_401 = 'UG-401',
    UG_430 = 'UG-430',
    UG_402 = 'UG-402',
    UG_202 = 'UG-202',
    UG_221 = 'UG-221',
    UG_119 = 'UG-119',
    UG_233 = 'UG-233',
    UG_120 = 'UG-120',
    UG_226 = 'UG-226',
    UG_C = 'UG-C',
    UG_317 = 'UG-317',
    UG_E = 'UG-E',
    UG_121 = 'UG-121',
    UG_304 = 'UG-304',
    UG_403 = 'UG-403',
    UG_417 = 'UG-417',
    UG_203 = 'UG-203',
    UG_418 = 'UG-418',
    UG_204 = 'UG-204',
    UG_318 = 'UG-318',
    UG_404 = 'UG-404',
    UG_405 = 'UG-405',
    UG_213 = 'UG-213',
    UG_427 = 'UG-427',
    UG_428 = 'UG-428',
    UG_237 = 'UG-237',
    UG_101 = 'UG-101',
    UG_222 = 'UG-222',
    UG_122 = 'UG-122',
    UG_102 = 'UG-102',
    UG_205 = 'UG-205',
    UG_413 = 'UG-413',
    UG_414 = 'UG-414',
    UG_206 = 'UG-206',
    UG_236 = 'UG-236',
    UG_335 = 'UG-335',
    UG_126 = 'UG-126',
    UG_406 = 'UG-406',
    UG_207 = 'UG-207',
    UG_112 = 'UG-112',
    UG_433 = 'UG-433',
    UG_407 = 'UG-407',
    UG_103 = 'UG-103',
    UG_227 = 'UG-227',
    UG_432 = 'UG-432',
    UG_419 = 'UG-419',
    UG_421 = 'UG-421',
    UG_408 = 'UG-408',
    UG_434 = 'UG-434',
    UG_305 = 'UG-305',
    UG_319 = 'UG-319',
    UG_325 = 'UG-325',
    UG_306 = 'UG-306',
    UG_208 = 'UG-208',
    UG_333 = 'UG-333',
    UG_228 = 'UG-228',
    UG_123 = 'UG-123',
    UG_422 = 'UG-422',
    UG_415 = 'UG-415',
    UG_125 = 'UG-125',
    UG_326 = 'UG-326',
    UG_307 = 'UG-307',
    UG_229 = 'UG-229',
    UG_104 = 'UG-104',
    UG_124 = 'UG-124',
    UG_114 = 'UG-114',
    UG_336 = 'UG-336',
    UG_223 = 'UG-223',
    UG_320 = 'UG-320',
    UG_105 = 'UG-105',
    UG_409 = 'UG-409',
    UG_214 = 'UG-214',
    UG_209 = 'UG-209',
    UG_410 = 'UG-410',
    UG_423 = 'UG-423',
    UG_115 = 'UG-115',
    UG_308 = 'UG-308',
    UG_309 = 'UG-309',
    UG_106 = 'UG-106',
    UG_107 = 'UG-107',
    UG_108 = 'UG-108',
    UG_334 = 'UG-334',
    UG_311 = 'UG-311',
    UG_116 = 'UG-116',
    UG_109 = 'UG-109',
    UG_230 = 'UG-230',
    UG_234 = 'UG-234',
    UG_224 = 'UG-224',
    UG_327 = 'UG-327',
    UG_310 = 'UG-310',
    UG_231 = 'UG-231',
    UG_N = 'UG-N',
    UG_424 = 'UG-424',
    UG_411 = 'UG-411',
    UG_328 = 'UG-328',
    UG_337 = 'UG-337',
    UG_331 = 'UG-331',
    UG_329 = 'UG-329',
    UG_321 = 'UG-321',
    UG_312 = 'UG-312',
    UG_332 = 'UG-332',
    UG_210 = 'UG-210',
    UG_110 = 'UG-110',
    UG_429 = 'UG-429',
    UG_425 = 'UG-425',
    UG_431 = 'UG-431',
    UG_412 = 'UG-412',
    UG_435 = 'UG-435',
    UG_111 = 'UG-111',
    UG_232 = 'UG-232',
    UG_426 = 'UG-426',
    UG_215 = 'UG-215',
    UG_211 = 'UG-211',
    UG_212 = 'UG-212',
    UG_113 = 'UG-113',
    UG_W = 'UG-W',
    UG_313 = 'UG-313',
    UG_330 = 'UG-330',
    UA_43 = 'UA-43',
    UA_71 = 'UA-71',
    UA_74 = 'UA-74',
    UA_77 = 'UA-77',
    UA_12 = 'UA-12',
    UA_14 = 'UA-14',
    UA_26 = 'UA-26',
    UA_63 = 'UA-63',
    UA_65 = 'UA-65',
    UA_68 = 'UA-68',
    UA_35 = 'UA-35',
    UA_30 = 'UA-30',
    UA_32 = 'UA-32',
    UA_09 = 'UA-09',
    UA_46 = 'UA-46',
    UA_48 = 'UA-48',
    UA_51 = 'UA-51',
    UA_53 = 'UA-53',
    UA_56 = 'UA-56',
    UA_40 = 'UA-40',
    UA_59 = 'UA-59',
    UA_61 = 'UA-61',
    UA_05 = 'UA-05',
    UA_07 = 'UA-07',
    UA_21 = 'UA-21',
    UA_23 = 'UA-23',
    UA_18 = 'UA-18',
    UM_81 = 'UM-81',
    UM_84 = 'UM-84',
    UM_86 = 'UM-86',
    UM_67 = 'UM-67',
    UM_89 = 'UM-89',
    UM_71 = 'UM-71',
    UM_76 = 'UM-76',
    UM_95 = 'UM-95',
    UM_79 = 'UM-79',
    UY_AR = 'UY-AR',
    UY_CA = 'UY-CA',
    UY_CL = 'UY-CL',
    UY_CO = 'UY-CO',
    UY_DU = 'UY-DU',
    UY_FS = 'UY-FS',
    UY_FD = 'UY-FD',
    UY_LA = 'UY-LA',
    UY_MA = 'UY-MA',
    UY_MO = 'UY-MO',
    UY_PA = 'UY-PA',
    UY_RV = 'UY-RV',
    UY_RO = 'UY-RO',
    UY_RN = 'UY-RN',
    UY_SA = 'UY-SA',
    UY_SJ = 'UY-SJ',
    UY_SO = 'UY-SO',
    UY_TA = 'UY-TA',
    UY_TT = 'UY-TT',
    US_AL = 'US-AL',
    US_AK = 'US-AK',
    US_AS = 'US-AS',
    US_AZ = 'US-AZ',
    US_AR = 'US-AR',
    US_CA = 'US-CA',
    US_CO = 'US-CO',
    US_CT = 'US-CT',
    US_DE = 'US-DE',
    US_DC = 'US-DC',
    US_FL = 'US-FL',
    US_GA = 'US-GA',
    US_GU = 'US-GU',
    US_HI = 'US-HI',
    US_ID = 'US-ID',
    US_IL = 'US-IL',
    US_IN = 'US-IN',
    US_IA = 'US-IA',
    US_KS = 'US-KS',
    US_KY = 'US-KY',
    US_LA = 'US-LA',
    US_ME = 'US-ME',
    US_MD = 'US-MD',
    US_MA = 'US-MA',
    US_MI = 'US-MI',
    US_MN = 'US-MN',
    US_MS = 'US-MS',
    US_MO = 'US-MO',
    US_MT = 'US-MT',
    US_NE = 'US-NE',
    US_NV = 'US-NV',
    US_NH = 'US-NH',
    US_NJ = 'US-NJ',
    US_NM = 'US-NM',
    US_NY = 'US-NY',
    US_NC = 'US-NC',
    US_ND = 'US-ND',
    US_MP = 'US-MP',
    US_OH = 'US-OH',
    US_OK = 'US-OK',
    US_OR = 'US-OR',
    US_PA = 'US-PA',
    US_PR = 'US-PR',
    US_RI = 'US-RI',
    US_SC = 'US-SC',
    US_SD = 'US-SD',
    US_TN = 'US-TN',
    US_TX = 'US-TX',
    US_UM = 'US-UM',
    US_UT = 'US-UT',
    US_VT = 'US-VT',
    US_VI = 'US-VI',
    US_VA = 'US-VA',
    US_WA = 'US-WA',
    US_WV = 'US-WV',
    US_WI = 'US-WI',
    US_WY = 'US-WY',
    UZ_AN = 'UZ-AN',
    UZ_BU = 'UZ-BU',
    UZ_FA = 'UZ-FA',
    UZ_JI = 'UZ-JI',
    UZ_NG = 'UZ-NG',
    UZ_NW = 'UZ-NW',
    UZ_QA = 'UZ-QA',
    UZ_QR = 'UZ-QR',
    UZ_SA = 'UZ-SA',
    UZ_SI = 'UZ-SI',
    UZ_SU = 'UZ-SU',
    UZ_TK = 'UZ-TK',
    UZ_TO = 'UZ-TO',
    UZ_XO = 'UZ-XO',
    VC_01 = 'VC-01',
    VC_06 = 'VC-06',
    VC_02 = 'VC-02',
    VC_03 = 'VC-03',
    VC_04 = 'VC-04',
    VC_05 = 'VC-05',
    VE_Z = 'VE-Z',
    VE_B = 'VE-B',
    VE_C = 'VE-C',
    VE_D = 'VE-D',
    VE_E = 'VE-E',
    VE_F = 'VE-F',
    VE_G = 'VE-G',
    VE_H = 'VE-H',
    VE_Y = 'VE-Y',
    VE_W = 'VE-W',
    VE_A = 'VE-A',
    VE_I = 'VE-I',
    VE_J = 'VE-J',
    VE_X = 'VE-X',
    VE_K = 'VE-K',
    VE_M = 'VE-M',
    VE_N = 'VE-N',
    VE_L = 'VE-L',
    VE_O = 'VE-O',
    VE_P = 'VE-P',
    VE_R = 'VE-R',
    VE_T = 'VE-T',
    VE_S = 'VE-S',
    VE_U = 'VE-U',
    VE_V = 'VE-V',
    VN_44 = 'VN-44',
    VN_43 = 'VN-43',
    VN_57 = 'VN-57',
    VN_58 = 'VN-58',
    VN_40 = 'VN-40',
    VN_31 = 'VN-31',
    VN_55 = 'VN-55',
    VN_54 = 'VN-54',
    VN_53 = 'VN-53',
    VN_56 = 'VN-56',
    VN_50 = 'VN-50',
    VN_04 = 'VN-04',
    VN_59 = 'VN-59',
    VN_CT = 'VN-CT',
    VN_30 = 'VN-30',
    VN_03 = 'VN-03',
    VN_63 = 'VN-63',
    VN_HN = 'VN-HN',
    VN_23 = 'VN-23',
    VN_14 = 'VN-14',
    VN_66 = 'VN-66',
    VN_61 = 'VN-61',
    VN_HP = 'VN-HP',
    VN_73 = 'VN-73',
    VN_SG = 'VN-SG',
    VN_34 = 'VN-34',
    VN_47 = 'VN-47',
    VN_28 = 'VN-28',
    VN_01 = 'VN-01',
    VN_41 = 'VN-41',
    VN_02 = 'VN-02',
    VN_35 = 'VN-35',
    VN_09 = 'VN-09',
    VN_67 = 'VN-67',
    VN_22 = 'VN-22',
    VN_18 = 'VN-18',
    VN_36 = 'VN-36',
    VN_68 = 'VN-68',
    VN_32 = 'VN-32',
    VN_24 = 'VN-24',
    VN_27 = 'VN-27',
    VN_29 = 'VN-29',
    VN_13 = 'VN-13',
    VN_25 = 'VN-25',
    VN_52 = 'VN-52',
    VN_05 = 'VN-05',
    VN_21 = 'VN-21',
    VN_20 = 'VN-20',
    VN_69 = 'VN-69',
    VN_26 = 'VN-26',
    VN_46 = 'VN-46',
    VN_51 = 'VN-51',
    VN_07 = 'VN-07',
    VN_37 = 'VN-37',
    VN_49 = 'VN-49',
    VN_70 = 'VN-70',
    VN_06 = 'VN-06',
    VN_71 = 'VN-71',
    VN_DN = 'VN-DN',
    VN_33 = 'VN-33',
    VN_72 = 'VN-72',
    VN_39 = 'VN-39',
    VN_45 = 'VN-45',
    VU_MAP = 'VU-MAP',
    VU_PAM = 'VU-PAM',
    VU_SAM = 'VU-SAM',
    VU_SEE = 'VU-SEE',
    VU_TAE = 'VU-TAE',
    VU_TOB = 'VU-TOB',
    WF_AL = 'WF-AL',
    WF_SG = 'WF-SG',
    WF_UV = 'WF-UV',
    WS_AA = 'WS-AA',
    WS_AL = 'WS-AL',
    WS_AT = 'WS-AT',
    WS_FA = 'WS-FA',
    WS_GE = 'WS-GE',
    WS_GI = 'WS-GI',
    WS_PA = 'WS-PA',
    WS_SA = 'WS-SA',
    WS_TU = 'WS-TU',
    WS_VF = 'WS-VF',
    WS_VS = 'WS-VS',
    YE_AB = 'YE-AB',
    YE_BA = 'YE-BA',
    YE_JA = 'YE-JA',
    YE_MR = 'YE-MR',
    YE_MW = 'YE-MW',
    YE_HU = 'YE-HU',
    YE_SA = 'YE-SA',
    YE_SU = 'YE-SU',
    YE_DA = 'YE-DA',
    YE_DH = 'YE-DH',
    YE_IB = 'YE-IB',
    YE_LA = 'YE-LA',
    YE_MA = 'YE-MA',
    YE_RA = 'YE-RA',
    YE_SH = 'YE-SH',
    YE_TA = 'YE-TA',
    YE_SN = 'YE-SN',
    YE_SD = 'YE-SD',
    YE_HJ = 'YE-HJ',
    YE_HD = 'YE-HD',
    YE_AD = 'YE-AD',
    YE_AM = 'YE-AM',
    ZA_EC = 'ZA-EC',
    ZA_FS = 'ZA-FS',
    ZA_GP = 'ZA-GP',
    ZA_KZN = 'ZA-KZN',
    ZA_LP = 'ZA-LP',
    ZA_MP = 'ZA-MP',
    ZA_NW = 'ZA-NW',
    ZA_NC = 'ZA-NC',
    ZA_WC = 'ZA-WC',
    ZM_02 = 'ZM-02',
    ZM_08 = 'ZM-08',
    ZM_03 = 'ZM-03',
    ZM_04 = 'ZM-04',
    ZM_09 = 'ZM-09',
    ZM_10 = 'ZM-10',
    ZM_06 = 'ZM-06',
    ZM_05 = 'ZM-05',
    ZM_07 = 'ZM-07',
    ZM_01 = 'ZM-01',
    ZW_BU = 'ZW-BU',
    ZW_HA = 'ZW-HA',
    ZW_MA = 'ZW-MA',
    ZW_MC = 'ZW-MC',
    ZW_ME = 'ZW-ME',
    ZW_MW = 'ZW-MW',
    ZW_MV = 'ZW-MV',
    ZW_MN = 'ZW-MN',
    ZW_MS = 'ZW-MS',
    ZW_MI = 'ZW-MI'
}

/**
 * * `draft` - Draft
 * * `published` - Published
 */
export enum ReleaseStatus68aEnum {
    DRAFT = 'draft',
    PUBLISHED = 'published'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Report = {
    readonly id: number;
    account: number;
    powerbiReportId: string;
    isTemplate?: boolean;
    createdBy: number;
    dataset: number;
    name: string;
};

/**
 * Custom report create serializer
 */
export type ReportCreate = {
    account: number;
    name: string;
};

/**
 * Custom report create serializer
 */
export type ReportCreateRequest = {
    account: number;
    name: string;
    reportTemplate: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReportRequest = {
    account: number;
    powerbiReportId: string;
    isTemplate?: boolean;
    createdBy: number;
    dataset: number;
    name: string;
};

export type ResultsWrapper = {
    results: Array<StaticResponseItem>;
};

export type ReturnImage = {
    url: string;
    name: string;
    mime_type: string;
};

export type ReturnLabel = {
    /**
     * Return label courier code or drop-off code, e.g. barcode
     */
    courier: string;
    /**
     * Service level of the return label
     */
    service_level?: string;
    /**
     * Tracking number of the return label (or in case of Barcode the barcode)
     */
    tracking_number: string;
    type?: ReturnLabelTypeEnum;
    /**
     * Flags (extra markers) for the return label, such as 'has_dangerous_goods', or 'is_pickup'
     */
    flags?: Array<FlagsEnum>;
    /**
     * Documents related to this return label (e.g. print label, barcode, packing slip, wallet-passes)
     */
    documents?: Array<Document>;
    /**
     * Destination ID for the return label, e.g. warehouse code
     */
    destination_id?: string;
    /**
     * The line item IDs to which the label should be attached
     */
    line_item_ids?: Array<string>;
    /**
     * Indicates if the return label is free of charge
     */
    is_free_label?: boolean;
    /**
     * Cost of the return label
     */
    label_cost_amount?: string;
    /**
     * Tracking ID of the shipment in the parcelLab system
     */
    tracking_id?: string;
    /**
     * Unique retailer-provided reference of the shipment, either this tracking number is required
     */
    external_reference?: string;
    delivery_status?: TrackingStageChoices;
    /**
     * Scheduled pickup date for the return label. Nullable if not a pickup return.
     */
    pickup_date?: string;
    /**
     * Scheduled pickup time for the return label. Nullable if not a pickup return.
     */
    pickup_time?: string;
    /**
     * Indicates if the return is a pickup order.
     */
    is_pickup?: boolean;
};

export enum ReturnLabelTypeEnum {
    SHIPPING = 'shipping',
    CUSTOM = 'custom'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnReason = {
    readonly id: number;
    /**
     * Parent return reason group of this return reason or group
     */
    parent?: number | null;
    account: number;
    type?: ReturnReasonTypeEnum;
    /**
     * Default (untranslated) name of this return reason
     */
    name: string;
    /**
     * Unique technical code for this return reason
     */
    code: string;
    /**
     * When activated this return reason group will always be shown, even if it does not have siblings and is the only group at the respective level
     */
    alwaysShow?: boolean;
    itemOrder?: ItemOrderEnum;
    problemDescription?: ImageUploadEnum;
    /**
     * Minimum length of the problem description
     */
    problemDescriptionMinLength?: number;
    /**
     * Note for this return reason, shown to customer
     */
    note?: string;
    imageUpload?: ImageUploadEnum;
    /**
     * External code for this return reason
     *
     * * `COLOR` - COLOR
     * * `DEFECTIVE` - DEFECTIVE
     * * `NOT_AS_DESCRIBED` - NOT_AS_DESCRIBED
     * * `OTHER` - OTHER
     * * `SIZE_TOO_LARGE` - SIZE_TOO_LARGE
     * * `SIZE_TOO_SMALL` - SIZE_TOO_SMALL
     * * `STYLE` - STYLE
     * * `UNKNOWN` - UNKNOWN
     * * `UNWANTED` - UNWANTED
     * * `WRONG_ITEM` - WRONG_ITEM
     */
    shopifyReturnReason?: ShopifyReturnReasonEnum;
    /**
     * Tags for this return reason
     */
    tags?: Array<ReturnReasonTagsEnum>;
    readonly children: string;
    /**
     * Eligibility rules for this compensation method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnReasonMoveRequest = {
    targetPosition?: TargetPositionEnum;
    target?: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnReasonRequest = {
    /**
     * Parent return reason group of this return reason or group
     */
    parent?: number | null;
    account: number;
    type?: ReturnReasonTypeEnum;
    /**
     * Default (untranslated) name of this return reason
     */
    name: string;
    /**
     * Unique technical code for this return reason
     */
    code: string;
    /**
     * When activated this return reason group will always be shown, even if it does not have siblings and is the only group at the respective level
     */
    alwaysShow?: boolean;
    itemOrder?: ItemOrderEnum;
    problemDescription?: ImageUploadEnum;
    /**
     * Minimum length of the problem description
     */
    problemDescriptionMinLength?: number;
    /**
     * Note for this return reason, shown to customer
     */
    note?: string;
    imageUpload?: ImageUploadEnum;
    /**
     * External code for this return reason
     *
     * * `COLOR` - COLOR
     * * `DEFECTIVE` - DEFECTIVE
     * * `NOT_AS_DESCRIBED` - NOT_AS_DESCRIBED
     * * `OTHER` - OTHER
     * * `SIZE_TOO_LARGE` - SIZE_TOO_LARGE
     * * `SIZE_TOO_SMALL` - SIZE_TOO_SMALL
     * * `STYLE` - STYLE
     * * `UNKNOWN` - UNKNOWN
     * * `UNWANTED` - UNWANTED
     * * `WRONG_ITEM` - WRONG_ITEM
     */
    shopifyReturnReason?: ShopifyReturnReasonEnum;
    /**
     * Tags for this return reason
     */
    tags?: Array<ReturnReasonTagsEnum>;
    /**
     * Eligibility rules for this compensation method
     */
    targetingRules?: {
        [key: string]: unknown;
    };
};

/**
 * * `warranty-exclude` - Warranty Exclude
 * * `trial-exclude` - Trial Exclude
 * * `requires-confirmation` - Requires CS Confirmation
 * * `info-only` - Info Only
 */
export enum ReturnReasonTagsEnum {
    WARRANTY_EXCLUDE = 'warranty-exclude',
    TRIAL_EXCLUDE = 'trial-exclude',
    REQUIRES_CONFIRMATION = 'requires-confirmation',
    INFO_ONLY = 'info-only'
}

/**
 * * `reason` - Reason
 * * `group` - Reason Group
 */
export enum ReturnReasonTypeEnum {
    REASON = 'reason',
    GROUP = 'group'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnRegistration = {
    readonly id: number;
    articlesReturn?: Array<LineItemReturn>;
    articlesOrder?: Array<LineItem>;
    returnLabels?: Array<ReturnLabel>;
    customerAddress?: AddressSchema;
    readonly createdAt: string;
    readonly updatedAt: string;
    version?: string | null;
    /**
     * Name of the client, as configured in account setup.
     */
    readonly clientKey: string;
    /**
     * Configuration code (unique identifier of the return portal or configuration used for this return
     */
    code: string;
    /**
     * Unique identifier for this return registration, generated by parcelLab
     */
    externalId?: string;
    /**
     * Additional identifier (e.g. shop system id) for this return registration, generated by the retailer
     */
    externalReference?: string;
    /**
     * Retailer reference, e.g. the order number, not unique
     */
    reference: string;
    /**
     * If true, the registration has been submitted. This is a read-only field.
     *
     * * `created` - Created
     * * `submitted` - Submitted
     * * `pending_approval` - Pending Approval
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     * * `closed` - Closed
     * * `processing_failed` - Processing Failed
     */
    status?: ReturnRegistrationStatusEnum;
    /**
     * Reason for the current status
     */
    statusReason?: string;
    originalCourier?: string;
    originalOrderId?: string | null;
    /**
     * Total amount of the original order
     */
    orderTotalAmount?: string | null;
    /**
     * Currency of the order, e.g. USD, EUR (ISO 4217)
     */
    orderCurrency?: string;
    /**
     * Language locale for this return registration, e.g. 'en', 'de', 'fr'
     */
    locale?: string;
    /**
     * ISO 639-1 language code of the recipient, if known, required for localized communication
     */
    languageIso2?: string;
    /**
     * Payment method used for the order, as setup as reference items in the accounts configuration
     */
    orderPaymentMethod?: Array<string>;
    /**
     * Date of the order
     */
    orderDate?: string | null;
    /**
     * Date of the order shipment
     */
    orderShippingDate?: string | null;
    /**
     * Date of the order delivery
     */
    orderDeliveryDate?: string | null;
    customerId?: string;
    customerEmail?: string;
    customerSalutation?: string;
    customerFirstName?: string;
    customerLastName?: string;
    /**
     * Customer phone number
     */
    customerPhone?: string;
    /**
     * ISO 3166-1 alpha-3 code of country
     */
    customerCountryIso3?: string;
    /**
     * Customer return history
     */
    customerReturnHistory?: {
        [key: string]: unknown;
    } | null;
    fulfillments?: {
        [key: string]: unknown;
    };
    /**
     * Refund method selected by customer
     */
    refundMethod?: string;
    /**
     * Purchase origin of the order
     */
    purchaseOrigin?: string;
    /**
     * Date(-time) of the return registration
     */
    readonly submittedAt: string;
    /**
     * Tags for the object, format <key>:<value>e.g. 'category:Home Apparel'
     */
    tags?: Array<string>;
    /**
     * Additional fields for the return registration
     */
    additionalFields?: {
        [key: string]: unknown;
    };
    /**
     * Verification code (e.g. zip/email) used for this return registration
     */
    verificationCodeUsed?: string;
    returnsPortalId?: string;
    sequenceId?: number | null;
    /**
     * Shop data for the return registration
     */
    interfaceData?: {
        [key: string]: unknown;
    };
    /**
     * Passthrough of custom fields of the original tracking via returns portal
     */
    outboundCustomFields?: {
        [key: string]: unknown;
    };
    /**
     * Indicates if the return is a pickup.
     */
    isPickup: boolean;
    /**
     * Billing Address
     */
    billingAddress: {
        [key: string]: unknown;
    };
    /**
     * Return from Address
     */
    returnFromAddress: {
        [key: string]: unknown;
    };
    /**
     * Selected address for the return
     *
     * * `customer_address` - Customer Address
     * * `billing_address` - Billing Address
     * * `return_from_address` - Return from Address
     */
    selectedAddress?: SelectedAddressEnum;
    /**
     * Split factor for a/b-experiments
     */
    splitFactor?: number;
    /**
     * Account, that is linked to this registration.
     */
    account: number;
    /**
     * Name of the technical client / shop (corresponds to the system setup), e.g. 'mybrand-a.com'
     */
    client?: number | null;
    config?: number | null;
    order?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnRegistrationRequest = {
    articlesReturn?: Array<LineItemReturn>;
    articlesOrder?: Array<LineItem>;
    returnLabels?: Array<ReturnLabel>;
    customerAddress?: AddressSchema;
    version?: string | null;
    /**
     * Configuration code (unique identifier of the return portal or configuration used for this return
     */
    code: string;
    /**
     * Unique identifier for this return registration, generated by parcelLab
     */
    externalId?: string;
    /**
     * Additional identifier (e.g. shop system id) for this return registration, generated by the retailer
     */
    externalReference?: string;
    /**
     * Retailer reference, e.g. the order number, not unique
     */
    reference: string;
    /**
     * If true, the registration has been submitted. This is a read-only field.
     *
     * * `created` - Created
     * * `submitted` - Submitted
     * * `pending_approval` - Pending Approval
     * * `approved` - Approved
     * * `rejected` - Rejected
     * * `cancelled` - Cancelled
     * * `closed` - Closed
     * * `processing_failed` - Processing Failed
     */
    status?: ReturnRegistrationStatusEnum;
    /**
     * Reason for the current status
     */
    statusReason?: string;
    originalCourier?: string;
    originalOrderId?: string | null;
    /**
     * Total amount of the original order
     */
    orderTotalAmount?: string | null;
    /**
     * Currency of the order, e.g. USD, EUR (ISO 4217)
     */
    orderCurrency?: string;
    /**
     * Language locale for this return registration, e.g. 'en', 'de', 'fr'
     */
    locale?: string;
    /**
     * ISO 639-1 language code of the recipient, if known, required for localized communication
     */
    languageIso2?: string;
    /**
     * Payment method used for the order, as setup as reference items in the accounts configuration
     */
    orderPaymentMethod?: Array<string>;
    /**
     * Date of the order
     */
    orderDate?: string | null;
    /**
     * Date of the order shipment
     */
    orderShippingDate?: string | null;
    /**
     * Date of the order delivery
     */
    orderDeliveryDate?: string | null;
    customerId?: string;
    customerEmail?: string;
    customerSalutation?: string;
    customerFirstName?: string;
    customerLastName?: string;
    /**
     * Customer phone number
     */
    customerPhone?: string;
    /**
     * ISO 3166-1 alpha-3 code of country
     */
    customerCountryIso3?: string;
    /**
     * Customer return history
     */
    customerReturnHistory?: {
        [key: string]: unknown;
    } | null;
    fulfillments?: {
        [key: string]: unknown;
    };
    /**
     * Refund method selected by customer
     */
    refundMethod?: string;
    /**
     * Purchase origin of the order
     */
    purchaseOrigin?: string;
    /**
     * Tags for the object, format <key>:<value>e.g. 'category:Home Apparel'
     */
    tags?: Array<string>;
    /**
     * Additional fields for the return registration
     */
    additionalFields?: {
        [key: string]: unknown;
    };
    /**
     * Verification code (e.g. zip/email) used for this return registration
     */
    verificationCodeUsed?: string;
    returnsPortalId?: string;
    sequenceId?: number | null;
    /**
     * Shop data for the return registration
     */
    interfaceData?: {
        [key: string]: unknown;
    };
    /**
     * Passthrough of custom fields of the original tracking via returns portal
     */
    outboundCustomFields?: {
        [key: string]: unknown;
    };
    /**
     * Indicates if the return is a pickup.
     */
    isPickup: boolean;
    /**
     * Billing Address
     */
    billingAddress: {
        [key: string]: unknown;
    };
    /**
     * Return from Address
     */
    returnFromAddress: {
        [key: string]: unknown;
    };
    /**
     * Selected address for the return
     *
     * * `customer_address` - Customer Address
     * * `billing_address` - Billing Address
     * * `return_from_address` - Return from Address
     */
    selectedAddress?: SelectedAddressEnum;
    /**
     * Split factor for a/b-experiments
     */
    splitFactor?: number;
    /**
     * Account, that is linked to this registration.
     */
    account: number;
    /**
     * Name of the technical client / shop (corresponds to the system setup), e.g. 'mybrand-a.com'
     */
    client?: number | null;
    config?: number | null;
    order?: number | null;
};

/**
 * * `created` - Created
 * * `submitted` - Submitted
 * * `pending_approval` - Pending Approval
 * * `approved` - Approved
 * * `rejected` - Rejected
 * * `cancelled` - Cancelled
 * * `closed` - Closed
 * * `processing_failed` - Processing Failed
 */
export enum ReturnRegistrationStatusEnum {
    CREATED = 'created',
    SUBMITTED = 'submitted',
    PENDING_APPROVAL = 'pending_approval',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    CANCELLED = 'cancelled',
    CLOSED = 'closed',
    PROCESSING_FAILED = 'processing_failed'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnablePeriod = {
    readonly id: number;
    description: string;
    /**
     * in days
     */
    trialPeriod: number;
    /**
     * Grace period (OrderDate) in days is calculated from the OrderDate in days
     */
    gracePeriod: number;
    /**
     * Grace period (ShippingDate) in days is calculated from the ShippingDate in days
     */
    gracePeriodShippingDate?: number;
    isWarrantyPeriod: boolean;
    filter?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnablePeriodRequest = {
    description: string;
    /**
     * in days
     */
    trialPeriod: number;
    /**
     * Grace period (OrderDate) in days is calculated from the OrderDate in days
     */
    gracePeriod: number;
    /**
     * Grace period (ShippingDate) in days is calculated from the ShippingDate in days
     */
    gracePeriodShippingDate?: number;
    isWarrantyPeriod: boolean;
    filter?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsArticleFilter = {
    flag: FlagEnum;
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Only for 'Keep Articles' — This is the maximum number of articles allowed to keep: if the overall quantity of items registered for return and marked as 'keep article' is exceeded, the customer cannot keep any of the articles after all but in fact has to return them, and the keep article-flag is removed from the articles. If this field is empty, there is no limit.
     */
    keepArticleMaxLimit?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsArticleFilterRequest = {
    flag: FlagEnum;
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Only for 'Keep Articles' — This is the maximum number of articles allowed to keep: if the overall quantity of items registered for return and marked as 'keep article' is exceeded, the customer cannot keep any of the articles after all but in fact has to return them, and the keep article-flag is removed from the articles. If this field is empty, there is no limit.
     */
    keepArticleMaxLimit?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsCourierApi = {
    readonly id: number;
    account: number;
    courierCode?: string;
    /**
     * Identifier, for instance Warehouse code
     */
    identifier?: string;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    readonly inheritsFrom: number | null;
    readonly inheritsFromName: string;
    readonly serviceName: string;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
    authorizationGrant: AuthorizationGrant | null;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsCourierApiCreate = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsCourierApiCreateRequest = {
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsCourierApiRequest = {
    account: number;
    courierCode?: string;
    /**
     * Identifier, for instance Warehouse code
     */
    identifier?: string;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsDocumentTemplate = {
    readonly id: number;
    account: number;
    name?: string;
    /**
     * Technical key, must not contain white space
     */
    key?: string;
    /**
     * Optional identifier for the template to be used (e.g. language code / local)
     */
    identifier?: string;
    content?: string;
    readonly updatedAt: string;
    requiredFields?: Array<string>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsDocumentTemplateRequest = {
    account: number;
    name?: string;
    /**
     * Technical key, must not contain white space
     */
    key?: string;
    /**
     * Optional identifier for the template to be used (e.g. language code / local)
     */
    identifier?: string;
    content?: string;
    requiredFields?: Array<string>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsOrderApi = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    readonly inheritsFrom: number | null;
    readonly inheritsFromName: string;
    readonly serviceName: string;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsOrderApiCreate = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsOrderApiCreateRequest = {
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsOrderApiRequest = {
    account: number;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Adds nested create feature
 */
export type ReturnsPortal = {
    readonly id: number;
    account: number;
    name: string;
    service: number;
    /**
     * Optional: OAuth2 authorization grant for this service
     */
    authorizationGrant?: number | null;
    config?: {
        [key: string]: unknown;
    };
    client?: number | null;
    /**
     * Return reason groups to use for this portal
     */
    returnReasons?: Array<number>;
    compensationMethods: Array<CompensationMethod>;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    readonly inheritsFrom: number | null;
    readonly inheritsFromName: string;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    /**
     * Country and language for this portal, e.g. 'de-de' (country-language)
     */
    code?: string;
    /**
     * When activated parcelLab will host the return portal
     */
    isPlHosted?: boolean;
    /**
     * When activated the returns portal will appear in production mode (No endless spinner)
     */
    isLive?: boolean;
    /**
     * Display portal for embedded returns in app.parcellab.com
     */
    isCustomerServicePortal?: boolean;
    /**
     * RegEx to validate login credentials
     */
    loginFormat?: string;
    loginType?: LoginTypeEnum;
    /**
     * Characters to strip from reference code (Supports regex)
     */
    loginRefStripCharacters?: string;
    /**
     * RegEx to validate the login reference credentials
     */
    loginRefFormat?: string;
    /**
     * When activated returns portal will check for returnable periods, you need to set returnable periods
     */
    checkReturnability?: boolean;
    checkReturnabilityOnLoginPage?: boolean;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceStart?: string | null;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceEnd?: string | null;
    /**
     * Add this if you want to use preview features
     */
    productionUrl?: string;
    stagingUrl?: string;
    returnablePeriods: Array<ReturnablePeriod>;
    /**
     * The API to be used to fetch order information
     */
    returnsOrderApi?: number | null;
    /**
     * Translations definition to use for this portal
     */
    returnsTranslation?: number | null;
    /**
     * Returns reasons to use for this portal
     */
    returnsRules?: number | null;
    returnsCourierApis: Array<ReturnsPortalCourierMapping>;
    refundMethods: Array<RefundMethod>;
    extraAttributes: Array<Attribute>;
    articleFilters: Array<ReturnsArticleFilter>;
    /**
     * Required for creating return trackings in the parcelLab portal
     */
    parcellabApiKey?: string;
    secureWithSso?: boolean;
    readonly updatedAt: string;
    /**
     * Additional translations for this portal
     */
    additionalTranslations?: Array<number>;
    /**
     * Theme to use for this portal
     */
    theme?: number | null;
    archived?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsPortalCourierMapping = {
    courierApi: number;
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Will order couriers on the courier selection page, low numbers come first
     */
    logicalOrder?: number;
    /**
     * When activated this courier will be hidden behind the 'show more' button if there is at least one courier that is not hidden
     */
    hideBehindShowMore?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsPortalCourierMappingDetails = {
    courierApi: ReturnsCourierApi;
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Will order couriers on the courier selection page, low numbers come first
     */
    logicalOrder?: number;
    /**
     * When activated this courier will be hidden behind the 'show more' button if there is at least one courier that is not hidden
     */
    hideBehindShowMore?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsPortalCourierMappingRequest = {
    courierApi: number;
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Will order couriers on the courier selection page, low numbers come first
     */
    logicalOrder?: number;
    /**
     * When activated this courier will be hidden behind the 'show more' button if there is at least one courier that is not hidden
     */
    hideBehindShowMore?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsPortalCreate = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    service: number;
    name: string;
    /**
     * Country and language for this portal, e.g. 'de-de' (country-language)
     */
    code?: string;
    client?: number | null;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsPortalCreateRequest = {
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    service: number;
    name: string;
    /**
     * Country and language for this portal, e.g. 'de-de' (country-language)
     */
    code?: string;
    client?: number | null;
};

/**
 * Adds nested create feature
 */
export type ReturnsPortalDetails = {
    readonly id: number;
    account: number;
    name: string;
    service: number;
    /**
     * Optional: OAuth2 authorization grant for this service
     */
    authorizationGrant?: number | null;
    config?: {
        [key: string]: unknown;
    };
    client?: number | null;
    returnReasons: Array<ReturnReason>;
    compensationMethods: Array<CompensationMethod>;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    readonly inheritsFrom: number | null;
    readonly inheritsFromName: string;
    releaseStatus: ReleaseStatus68aEnum;
    readonly releasedBy: number | null;
    readonly releasedAt: string | null;
    readonly hasReleasedVersion: boolean;
    /**
     * Country and language for this portal, e.g. 'de-de' (country-language)
     */
    code?: string;
    /**
     * When activated parcelLab will host the return portal
     */
    isPlHosted?: boolean;
    /**
     * When activated the returns portal will appear in production mode (No endless spinner)
     */
    isLive?: boolean;
    /**
     * Display portal for embedded returns in app.parcellab.com
     */
    isCustomerServicePortal?: boolean;
    /**
     * RegEx to validate login credentials
     */
    loginFormat?: string;
    loginType?: LoginTypeEnum;
    /**
     * Characters to strip from reference code (Supports regex)
     */
    loginRefStripCharacters?: string;
    /**
     * RegEx to validate the login reference credentials
     */
    loginRefFormat?: string;
    /**
     * When activated returns portal will check for returnable periods, you need to set returnable periods
     */
    checkReturnability?: boolean;
    checkReturnabilityOnLoginPage?: boolean;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceStart?: string | null;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceEnd?: string | null;
    /**
     * Add this if you want to use preview features
     */
    productionUrl?: string;
    stagingUrl?: string;
    returnablePeriods: Array<ReturnablePeriod>;
    returnsOrderApi: ReturnsOrderApi;
    returnsTranslation: ReturnsTranslation;
    returnsRules: ReturnsRules;
    returnsCourierApis: Array<ReturnsPortalCourierMappingDetails>;
    refundMethods: Array<RefundMethod>;
    extraAttributes: Array<Attribute>;
    articleFilters: Array<ReturnsArticleFilter>;
    /**
     * Required for creating return trackings in the parcelLab portal
     */
    parcellabApiKey?: string;
    secureWithSso?: boolean;
    readonly updatedAt: string;
    additionalTranslations: Array<ReturnsTranslation>;
    /**
     * Theme to use for this portal
     */
    theme?: number | null;
    archived?: boolean;
    version: ReturnsPortalDetailsVersionEnum;
    readonly clientKey: string;
    readonly hasNewReturnReasons: boolean;
    readonly themeExternalId: string | null;
};

export enum ReturnsPortalDetailsVersionEnum {
    V1 = 'v1',
    V2 = 'v2'
}

/**
 * Adds nested create feature
 */
export type ReturnsPortalRequest = {
    account: number;
    name: string;
    service: number;
    /**
     * Optional: OAuth2 authorization grant for this service
     */
    authorizationGrant?: number | null;
    config?: {
        [key: string]: unknown;
    };
    client?: number | null;
    /**
     * Return reason groups to use for this portal
     */
    returnReasons?: Array<number>;
    compensationMethods: Array<CompensationMethodRequest>;
    /**
     * Country and language for this portal, e.g. 'de-de' (country-language)
     */
    code?: string;
    /**
     * When activated parcelLab will host the return portal
     */
    isPlHosted?: boolean;
    /**
     * When activated the returns portal will appear in production mode (No endless spinner)
     */
    isLive?: boolean;
    /**
     * Display portal for embedded returns in app.parcellab.com
     */
    isCustomerServicePortal?: boolean;
    /**
     * RegEx to validate login credentials
     */
    loginFormat?: string;
    loginType?: LoginTypeEnum;
    /**
     * Characters to strip from reference code (Supports regex)
     */
    loginRefStripCharacters?: string;
    /**
     * RegEx to validate the login reference credentials
     */
    loginRefFormat?: string;
    /**
     * When activated returns portal will check for returnable periods, you need to set returnable periods
     */
    checkReturnability?: boolean;
    checkReturnabilityOnLoginPage?: boolean;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceStart?: string | null;
    /**
     * Changes here will restrict login into the returns portal. Remember: you have to use UTC time.
     */
    maintenanceEnd?: string | null;
    /**
     * Add this if you want to use preview features
     */
    productionUrl?: string;
    stagingUrl?: string;
    returnablePeriods: Array<ReturnablePeriodRequest>;
    /**
     * The API to be used to fetch order information
     */
    returnsOrderApi?: number | null;
    /**
     * Translations definition to use for this portal
     */
    returnsTranslation?: number | null;
    /**
     * Returns reasons to use for this portal
     */
    returnsRules?: number | null;
    returnsCourierApis: Array<ReturnsPortalCourierMappingRequest>;
    refundMethods: Array<RefundMethodRequest>;
    extraAttributes: Array<AttributeRequest>;
    articleFilters: Array<ReturnsArticleFilterRequest>;
    /**
     * Required for creating return trackings in the parcelLab portal
     */
    parcellabApiKey?: string;
    secureWithSso?: boolean;
    /**
     * Additional translations for this portal
     */
    additionalTranslations?: Array<number>;
    /**
     * Theme to use for this portal
     */
    theme?: number | null;
    archived?: boolean;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsRules = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    readonly inheritsFrom: number | null;
    readonly inheritsFromName: string;
    readonly serviceName: string;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsRulesCreate = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsRulesCreateRequest = {
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsRulesRequest = {
    account: number;
    name: string;
    service: number;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsTranslation = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    readonly inheritsFrom: number | null;
    readonly inheritsFromName: string;
    readonly serviceName: string;
    name: string;
    service: number;
    code?: string;
    language: LanguagesIso639Enum;
    config?: {
        [key: string]: unknown;
    };
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsTranslationCreate = {
    readonly id: number;
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
    code?: string;
    language: LanguagesIso639Enum;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsTranslationCreateRequest = {
    account: number;
    /**
     * Inherit fields from this object, and can be updated with changes from this object.
     */
    inheritsFrom?: number | null;
    name: string;
    service: number;
    code?: string;
    language: LanguagesIso639Enum;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type ReturnsTranslationRequest = {
    account: number;
    name: string;
    service: number;
    code?: string;
    language: LanguagesIso639Enum;
    config?: {
        [key: string]: unknown;
    };
};

/**
 * * `returns-translation` - Returns | Return Translation
 * * `returns-rules` - Returns | Return Rules
 * * `returns-order` - Returns | Order API
 * * `returns-courier` - Returns | Courier API
 * * `returns-portal` - Returns | Portal
 * * `portal-customer-portal` - Portal | Customer Portal
 * * `portal-order-status` - Portal | Order Status Page
 * * `campaign-campaign` - Campaign | Campaign
 * * `integration` - Connect | Integration
 * * `integration-sms` - Connect | SMS Integration
 * * `integration-webhook` - Connect | Webhook Integration
 * * `integration-placeinfo` - Connect | Placeinfo API
 * * `external-order-management` - Connect | External Order Management
 */
export enum RoleEnum {
    RETURNS_TRANSLATION = 'returns-translation',
    RETURNS_RULES = 'returns-rules',
    RETURNS_ORDER = 'returns-order',
    RETURNS_COURIER = 'returns-courier',
    RETURNS_PORTAL = 'returns-portal',
    PORTAL_CUSTOMER_PORTAL = 'portal-customer-portal',
    PORTAL_ORDER_STATUS = 'portal-order-status',
    CAMPAIGN_CAMPAIGN = 'campaign-campaign',
    INTEGRATION = 'integration',
    INTEGRATION_SMS = 'integration-sms',
    INTEGRATION_WEBHOOK = 'integration-webhook',
    INTEGRATION_PLACEINFO = 'integration-placeinfo',
    EXTERNAL_ORDER_MANAGEMENT = 'external-order-management'
}

/**
 * * `python3.11` - Python 3.11
 * * `nodejs20.x` - Node.js 20 ESM
 */
export enum RuntimeEnum {
    PYTHON3_11 = 'python3.11',
    NODEJS20_X = 'nodejs20.x'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SmsAutoReplyConfig = {
    readonly id: number;
    client: ClientSimple;
    smsIntegration: Integration;
    messageTypeOptIn: MessageType;
    messageTypeOptOut: MessageType;
    messageTypeHelp: MessageType;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SmsAutoReplyConfigRequest = {
    messageTypeOptIn: MessageTypeRequest;
    messageTypeOptOut: MessageTypeRequest;
    messageTypeHelp: MessageTypeRequest;
};

/**
 * * `returns` - Returns
 * * `promise` - PlPromise
 * * `campaign` - Campaign
 * * `admin` - Admin
 * * `trackings` - Trackings
 * * `communications` - Communications
 */
export enum ScopeEnum {
    RETURNS = 'returns',
    PROMISE = 'promise',
    CAMPAIGN = 'campaign',
    ADMIN = 'admin',
    TRACKINGS = 'trackings',
    COMMUNICATIONS = 'communications'
}

/**
 * * `customer_address` - Customer Address
 * * `billing_address` - Billing Address
 * * `return_from_address` - Return from Address
 */
export enum SelectedAddressEnum {
    CUSTOMER_ADDRESS = 'customer_address',
    BILLING_ADDRESS = 'billing_address',
    RETURN_FROM_ADDRESS = 'return_from_address'
}

export type Service = {
    readonly id: number;
    name: string;
    key: string;
    role: RoleEnum;
    configSchema?: {
        [key: string]: unknown;
    };
    /**
     * Optional: Auth Client Application for this service, which allows customers to authorize via OAuth2
     */
    authClient?: number | null;
    account: number;
    isPublicService?: boolean;
};

export type ServiceRequest = {
    name: string;
    key: string;
    role: RoleEnum;
    configSchema?: {
        [key: string]: unknown;
    };
    /**
     * Optional: Auth Client Application for this service, which allows customers to authorize via OAuth2
     */
    authClient?: number | null;
    account: number;
    isPublicService?: boolean;
};

/**
 * * `drop_box` - Drop Box / Locker
 * * `shipping_service` - Shipping Services (generic)
 * * `international_shipping` - International Shipping
 * * `return_service` - Return-specific Services
 * * `hold_at_location` - Hold at Location
 * * `dangerous_goods` - Dangerous Goods
 * * `airport_location` - Airport Location
 * * `packaging` - Packaging
 * * `customs` - Customs / Clearance
 * * `cash_on_delivery` - Cash on Delivery
 */
export enum ServicesEnum {
    DROP_BOX = 'drop_box',
    SHIPPING_SERVICE = 'shipping_service',
    INTERNATIONAL_SHIPPING = 'international_shipping',
    RETURN_SERVICE = 'return_service',
    HOLD_AT_LOCATION = 'hold_at_location',
    DANGEROUS_GOODS = 'dangerous_goods',
    AIRPORT_LOCATION = 'airport_location',
    PACKAGING = 'packaging',
    CUSTOMS = 'customs',
    CASH_ON_DELIVERY = 'cash_on_delivery'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SharedObject = {
    readonly id: number;
    account: number;
    objectType: ObjectTypeEnum;
    objectId: string;
    readonly signedToken: string;
    readonly user: number;
    readonly expiresAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SharedObjectRequest = {
    account: number;
    objectType: ObjectTypeEnum;
    objectId: string;
};

/**
 * * `COLOR` - COLOR
 * * `DEFECTIVE` - DEFECTIVE
 * * `NOT_AS_DESCRIBED` - NOT_AS_DESCRIBED
 * * `OTHER` - OTHER
 * * `SIZE_TOO_LARGE` - SIZE_TOO_LARGE
 * * `SIZE_TOO_SMALL` - SIZE_TOO_SMALL
 * * `STYLE` - STYLE
 * * `UNKNOWN` - UNKNOWN
 * * `UNWANTED` - UNWANTED
 * * `WRONG_ITEM` - WRONG_ITEM
 */
export enum ShopifyReturnReasonEnum {
    COLOR = 'COLOR',
    DEFECTIVE = 'DEFECTIVE',
    NOT_AS_DESCRIBED = 'NOT_AS_DESCRIBED',
    OTHER = 'OTHER',
    SIZE_TOO_LARGE = 'SIZE_TOO_LARGE',
    SIZE_TOO_SMALL = 'SIZE_TOO_SMALL',
    STYLE = 'STYLE',
    UNKNOWN = 'UNKNOWN',
    UNWANTED = 'UNWANTED',
    WRONG_ITEM = 'WRONG_ITEM'
}

export type SigninRequestRequest = {
    username: string;
    password: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleAgent = {
    readonly id: number;
    account: number;
    /**
     * Up to you
     */
    name: string;
    readonly createdAt: string;
    readonly updatedAt: string;
};

export type SimpleAgentAddMessageRequest = {
    query: string;
    context: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleAgentThreadCreateRequest = {
    account: number;
    /**
     * External ID of this agent, used on the simple agent thread API
     */
    agent: string;
    query: string;
    context: {
        [key: string]: unknown;
    };
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleAgentThreadDetail = {
    readonly id: number;
    account: number;
    /**
     * External ID of this agent, used on the simple agent thread API
     */
    agent: string;
    readonly user: number;
    readonly createdAt: string;
    readonly updatedAt: string;
    messages: Array<InputMessage | OutputMessage>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleAgentThreadList = {
    readonly id: number;
    account: number;
    /**
     * External ID of this agent, used on the simple agent thread API
     */
    agent: string;
    readonly user: number;
    readonly createdAt: string;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleAudience = {
    readonly id: number;
    key: string;
    name: string;
    status?: CampaignStatusChoices;
    targetFlow?: TargetFlowEnum;
    targetStage?: Array<TrackingStageChoices>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleCampaign = {
    readonly id: number;
    key: string;
    uniqueId?: string;
    campaignTargets?: Array<CampaignTargetChoices>;
    messages?: Array<string>;
    language?: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type SimpleCampaignRequest = {
    key: string;
    uniqueId?: string;
    campaignTargets?: Array<CampaignTargetChoices>;
    messages?: Array<string>;
    language?: string;
};

/**
 * * `onOrderCreated` - On Order Created
 * * `onTrackingCreated` - On Tracking Created
 * * `onOrderUpdated` - On Order Updated
 * * `onTrackingUpdated` - On Tracking Updated
 * * `onDispatch` - On Dispatch
 * * `onDeliveryStatus` - On Delivery Status
 * * `onCustomEvent` - On Custom Event
 * * `onScheduled` - On Scheduled
 * * `onDelay` - On Delay
 * * `onForgotten` - On Forgotten
 * * `onDelivered` - On Delivered
 * * `onPickupReady` - On Pickup Ready
 * * `onReturnWarning` - On Return Warning
 * * `onException` - On Exception
 * * `onReturn` - On Return
 * * `onEscalation` - On Escalation
 * * `onInvalid` - On Invalid
 * * `onTrackingClosed` - On Tracking Closed
 * * `onSurveyResponse` - On Survey Response
 */
export enum SlotTypesEnum {
    ON_ORDER_CREATED = 'onOrderCreated',
    ON_TRACKING_CREATED = 'onTrackingCreated',
    ON_ORDER_UPDATED = 'onOrderUpdated',
    ON_TRACKING_UPDATED = 'onTrackingUpdated',
    ON_DISPATCH = 'onDispatch',
    ON_DELIVERY_STATUS = 'onDeliveryStatus',
    ON_CUSTOM_EVENT = 'onCustomEvent',
    ON_SCHEDULED = 'onScheduled',
    ON_DELAY = 'onDelay',
    ON_FORGOTTEN = 'onForgotten',
    ON_DELIVERED = 'onDelivered',
    ON_PICKUP_READY = 'onPickupReady',
    ON_RETURN_WARNING = 'onReturnWarning',
    ON_EXCEPTION = 'onException',
    ON_RETURN = 'onReturn',
    ON_ESCALATION = 'onEscalation',
    ON_INVALID = 'onInvalid',
    ON_TRACKING_CLOSED = 'onTrackingClosed',
    ON_SURVEY_RESPONSE = 'onSurveyResponse'
}

export type SocialDetails = {
    facebook?: string | number | {
        [key: string]: unknown;
    } | unknown;
    instagram?: string | number | {
        [key: string]: unknown;
    } | unknown;
    linkedin?: string | number | {
        [key: string]: unknown;
    } | unknown;
    pinterest?: string | number | {
        [key: string]: unknown;
    } | unknown;
    snapchat?: string | number | {
        [key: string]: unknown;
    } | unknown;
    tiktok?: string | number | {
        [key: string]: unknown;
    } | unknown;
    trustedshops?: string | number | {
        [key: string]: unknown;
    } | unknown;
    twitter?: string | number | {
        [key: string]: unknown;
    } | unknown;
    xing?: string | number | {
        [key: string]: unknown;
    } | unknown;
    youtube?: string | number | {
        [key: string]: unknown;
    } | unknown;
    'youtube-play'?: string | number | {
        [key: string]: unknown;
    } | unknown;
};

/**
 * * `backend` - Backend
 * * `returns` - Returns
 * * `portal` - Portal
 */
export enum SourceSystemEnum {
    BACKEND = 'backend',
    RETURNS = 'returns',
    PORTAL = 'portal'
}

export type SpecialDay = {
    readonly id: number;
    date: string;
    note?: string;
    /**
     * If set to false, special day will be treated as working day
     */
    closed?: boolean;
    /**
     * If true, special day will be applied every year on same day and month (i.e. year is ignored)
     */
    repeats_every_year?: boolean;
};

export type SpecialDayRequest = {
    date: string;
    note?: string;
    /**
     * If set to false, special day will be treated as working day
     */
    closed?: boolean;
    /**
     * If true, special day will be applied every year on same day and month (i.e. year is ignored)
     */
    repeats_every_year?: boolean;
};

export type StaticClientLocaleConfiguration = {
    social?: SocialDetails | unknown;
    website: string | unknown;
    customEmailTemplate?: string | unknown;
    language?: string | unknown;
    country?: string | unknown;
};

export type StaticResponse = ResultsWrapper;

/**
 * This is the object our API will respond with when Backends queries for
 * clients with an account_id
 */
export type StaticResponseItem = {
    account: number;
    id: number;
    key: string;
    is_default?: boolean;
    name: NameDetails | unknown;
    address: AddressDetails | unknown;
    contact: ContactDetails | unknown;
    alwaysReturnWildcardCheckpoint?: boolean;
    survey?: {
        [key: string]: unknown;
    } | Array<SurveyDetails> | unknown;
    customisation?: CustomizationDetails | unknown;
    hidePageFooter?: boolean;
    weekdays?: unknown | Array<number> | {
        [key: string]: Array<number>;
    } | {
        [key: string]: {
            [key: string]: Array<number>;
        };
    };
    utm_params?: string | unknown;
    social?: SocialDetails | unknown;
    language?: Array<string> | unknown;
    articleBasedPlaceholders?: unknown;
    logic?: LogicDetails | unknown;
    lexicon?: {
        [key: string]: string;
    } | {
        [key: string]: {
            [key: string]: string;
        };
    } | unknown;
    surveyLogoBackgroundColour?: string | unknown;
    surveyUrl?: string | unknown;
    zenloopSurvey?: ZenloopSurveyDetails | unknown;
    localeConfigurations?: Array<StaticClientLocaleConfiguration>;
};

export type Survey = {
    readonly id: string;
    readonly emailPreviewCdn: string;
    config?: {
        [key: string]: unknown;
    };
    name: string;
    status: SurveyStatusEnum;
    type?: SurveyTypeEnum;
    readonly surveyUrl: string;
    readonly isEditable: boolean;
    account: number;
    readonly lastResponse: string;
};

export type SurveyAiAnalysis = {
    analysis: string;
};

export type SurveyAnswer = {
    data?: {
        [key: string]: unknown;
    };
};

export type SurveyDetails = {
    category: string;
    categoryName?: string | unknown;
    question: string;
    questionId: string;
    questionType: string;
};

export type SurveyEmail = {
    content: string;
};

export type SurveyRequest = {
    config?: {
        [key: string]: unknown;
    };
    name: string;
    type?: SurveyTypeEnum;
    account: number;
};

/**
 * * `draft` - Draft
 * * `archived` - Archived
 * * `published` - Published
 */
export enum SurveyStatusEnum {
    DRAFT = 'draft',
    ARCHIVED = 'archived',
    PUBLISHED = 'published'
}

/**
 * * `nps` - NPS
 * * `smart_survey` - Smart Survey
 */
export enum SurveyTypeEnum {
    NPS = 'nps',
    SMART_SURVEY = 'smart_survey'
}

/**
 * * `default` - Default
 * * `exception` - Exception
 */
export enum TargetFlowEnum {
    DEFAULT = 'default',
    EXCEPTION = 'exception'
}

/**
 * * `first-child` - first-child
 * * `last-child` - last-child
 * * `left` - left
 * * `right` - right
 */
export enum TargetPositionEnum {
    FIRST_CHILD = 'first-child',
    LAST_CHILD = 'last-child',
    LEFT = 'left',
    RIGHT = 'right'
}

export enum TimeUnitChoices {
    WEEK = 'WEEK',
    DAY = 'DAY',
    HOUR = 'HOUR',
    MINUTE = 'MINUTE',
    SECOND = 'SECOND'
}

/**
 * * `Africa/Abidjan` - Africa/Abidjan
 * * `Africa/Accra` - Africa/Accra
 * * `Africa/Addis_Ababa` - Africa/Addis_Ababa
 * * `Africa/Algiers` - Africa/Algiers
 * * `Africa/Asmara` - Africa/Asmara
 * * `Africa/Asmera` - Africa/Asmera
 * * `Africa/Bamako` - Africa/Bamako
 * * `Africa/Bangui` - Africa/Bangui
 * * `Africa/Banjul` - Africa/Banjul
 * * `Africa/Bissau` - Africa/Bissau
 * * `Africa/Blantyre` - Africa/Blantyre
 * * `Africa/Brazzaville` - Africa/Brazzaville
 * * `Africa/Bujumbura` - Africa/Bujumbura
 * * `Africa/Cairo` - Africa/Cairo
 * * `Africa/Casablanca` - Africa/Casablanca
 * * `Africa/Ceuta` - Africa/Ceuta
 * * `Africa/Conakry` - Africa/Conakry
 * * `Africa/Dakar` - Africa/Dakar
 * * `Africa/Dar_es_Salaam` - Africa/Dar_es_Salaam
 * * `Africa/Djibouti` - Africa/Djibouti
 * * `Africa/Douala` - Africa/Douala
 * * `Africa/El_Aaiun` - Africa/El_Aaiun
 * * `Africa/Freetown` - Africa/Freetown
 * * `Africa/Gaborone` - Africa/Gaborone
 * * `Africa/Harare` - Africa/Harare
 * * `Africa/Johannesburg` - Africa/Johannesburg
 * * `Africa/Juba` - Africa/Juba
 * * `Africa/Kampala` - Africa/Kampala
 * * `Africa/Khartoum` - Africa/Khartoum
 * * `Africa/Kigali` - Africa/Kigali
 * * `Africa/Kinshasa` - Africa/Kinshasa
 * * `Africa/Lagos` - Africa/Lagos
 * * `Africa/Libreville` - Africa/Libreville
 * * `Africa/Lome` - Africa/Lome
 * * `Africa/Luanda` - Africa/Luanda
 * * `Africa/Lubumbashi` - Africa/Lubumbashi
 * * `Africa/Lusaka` - Africa/Lusaka
 * * `Africa/Malabo` - Africa/Malabo
 * * `Africa/Maputo` - Africa/Maputo
 * * `Africa/Maseru` - Africa/Maseru
 * * `Africa/Mbabane` - Africa/Mbabane
 * * `Africa/Mogadishu` - Africa/Mogadishu
 * * `Africa/Monrovia` - Africa/Monrovia
 * * `Africa/Nairobi` - Africa/Nairobi
 * * `Africa/Ndjamena` - Africa/Ndjamena
 * * `Africa/Niamey` - Africa/Niamey
 * * `Africa/Nouakchott` - Africa/Nouakchott
 * * `Africa/Ouagadougou` - Africa/Ouagadougou
 * * `Africa/Porto-Novo` - Africa/Porto-Novo
 * * `Africa/Sao_Tome` - Africa/Sao_Tome
 * * `Africa/Timbuktu` - Africa/Timbuktu
 * * `Africa/Tripoli` - Africa/Tripoli
 * * `Africa/Tunis` - Africa/Tunis
 * * `Africa/Windhoek` - Africa/Windhoek
 * * `America/Adak` - America/Adak
 * * `America/Anchorage` - America/Anchorage
 * * `America/Anguilla` - America/Anguilla
 * * `America/Antigua` - America/Antigua
 * * `America/Araguaina` - America/Araguaina
 * * `America/Argentina/Buenos_Aires` - America/Argentina/Buenos_Aires
 * * `America/Argentina/Catamarca` - America/Argentina/Catamarca
 * * `America/Argentina/ComodRivadavia` - America/Argentina/ComodRivadavia
 * * `America/Argentina/Cordoba` - America/Argentina/Cordoba
 * * `America/Argentina/Jujuy` - America/Argentina/Jujuy
 * * `America/Argentina/La_Rioja` - America/Argentina/La_Rioja
 * * `America/Argentina/Mendoza` - America/Argentina/Mendoza
 * * `America/Argentina/Rio_Gallegos` - America/Argentina/Rio_Gallegos
 * * `America/Argentina/Salta` - America/Argentina/Salta
 * * `America/Argentina/San_Juan` - America/Argentina/San_Juan
 * * `America/Argentina/San_Luis` - America/Argentina/San_Luis
 * * `America/Argentina/Tucuman` - America/Argentina/Tucuman
 * * `America/Argentina/Ushuaia` - America/Argentina/Ushuaia
 * * `America/Aruba` - America/Aruba
 * * `America/Asuncion` - America/Asuncion
 * * `America/Atikokan` - America/Atikokan
 * * `America/Atka` - America/Atka
 * * `America/Bahia` - America/Bahia
 * * `America/Bahia_Banderas` - America/Bahia_Banderas
 * * `America/Barbados` - America/Barbados
 * * `America/Belem` - America/Belem
 * * `America/Belize` - America/Belize
 * * `America/Blanc-Sablon` - America/Blanc-Sablon
 * * `America/Boa_Vista` - America/Boa_Vista
 * * `America/Bogota` - America/Bogota
 * * `America/Boise` - America/Boise
 * * `America/Buenos_Aires` - America/Buenos_Aires
 * * `America/Cambridge_Bay` - America/Cambridge_Bay
 * * `America/Campo_Grande` - America/Campo_Grande
 * * `America/Cancun` - America/Cancun
 * * `America/Caracas` - America/Caracas
 * * `America/Catamarca` - America/Catamarca
 * * `America/Cayenne` - America/Cayenne
 * * `America/Cayman` - America/Cayman
 * * `America/Chicago` - America/Chicago
 * * `America/Chihuahua` - America/Chihuahua
 * * `America/Ciudad_Juarez` - America/Ciudad_Juarez
 * * `America/Coral_Harbour` - America/Coral_Harbour
 * * `America/Cordoba` - America/Cordoba
 * * `America/Costa_Rica` - America/Costa_Rica
 * * `America/Coyhaique` - America/Coyhaique
 * * `America/Creston` - America/Creston
 * * `America/Cuiaba` - America/Cuiaba
 * * `America/Curacao` - America/Curacao
 * * `America/Danmarkshavn` - America/Danmarkshavn
 * * `America/Dawson` - America/Dawson
 * * `America/Dawson_Creek` - America/Dawson_Creek
 * * `America/Denver` - America/Denver
 * * `America/Detroit` - America/Detroit
 * * `America/Dominica` - America/Dominica
 * * `America/Edmonton` - America/Edmonton
 * * `America/Eirunepe` - America/Eirunepe
 * * `America/El_Salvador` - America/El_Salvador
 * * `America/Ensenada` - America/Ensenada
 * * `America/Fort_Nelson` - America/Fort_Nelson
 * * `America/Fort_Wayne` - America/Fort_Wayne
 * * `America/Fortaleza` - America/Fortaleza
 * * `America/Glace_Bay` - America/Glace_Bay
 * * `America/Godthab` - America/Godthab
 * * `America/Goose_Bay` - America/Goose_Bay
 * * `America/Grand_Turk` - America/Grand_Turk
 * * `America/Grenada` - America/Grenada
 * * `America/Guadeloupe` - America/Guadeloupe
 * * `America/Guatemala` - America/Guatemala
 * * `America/Guayaquil` - America/Guayaquil
 * * `America/Guyana` - America/Guyana
 * * `America/Halifax` - America/Halifax
 * * `America/Havana` - America/Havana
 * * `America/Hermosillo` - America/Hermosillo
 * * `America/Indiana/Indianapolis` - America/Indiana/Indianapolis
 * * `America/Indiana/Knox` - America/Indiana/Knox
 * * `America/Indiana/Marengo` - America/Indiana/Marengo
 * * `America/Indiana/Petersburg` - America/Indiana/Petersburg
 * * `America/Indiana/Tell_City` - America/Indiana/Tell_City
 * * `America/Indiana/Vevay` - America/Indiana/Vevay
 * * `America/Indiana/Vincennes` - America/Indiana/Vincennes
 * * `America/Indiana/Winamac` - America/Indiana/Winamac
 * * `America/Indianapolis` - America/Indianapolis
 * * `America/Inuvik` - America/Inuvik
 * * `America/Iqaluit` - America/Iqaluit
 * * `America/Jamaica` - America/Jamaica
 * * `America/Jujuy` - America/Jujuy
 * * `America/Juneau` - America/Juneau
 * * `America/Kentucky/Louisville` - America/Kentucky/Louisville
 * * `America/Kentucky/Monticello` - America/Kentucky/Monticello
 * * `America/Knox_IN` - America/Knox_IN
 * * `America/Kralendijk` - America/Kralendijk
 * * `America/La_Paz` - America/La_Paz
 * * `America/Lima` - America/Lima
 * * `America/Los_Angeles` - America/Los_Angeles
 * * `America/Louisville` - America/Louisville
 * * `America/Lower_Princes` - America/Lower_Princes
 * * `America/Maceio` - America/Maceio
 * * `America/Managua` - America/Managua
 * * `America/Manaus` - America/Manaus
 * * `America/Marigot` - America/Marigot
 * * `America/Martinique` - America/Martinique
 * * `America/Matamoros` - America/Matamoros
 * * `America/Mazatlan` - America/Mazatlan
 * * `America/Mendoza` - America/Mendoza
 * * `America/Menominee` - America/Menominee
 * * `America/Merida` - America/Merida
 * * `America/Metlakatla` - America/Metlakatla
 * * `America/Mexico_City` - America/Mexico_City
 * * `America/Miquelon` - America/Miquelon
 * * `America/Moncton` - America/Moncton
 * * `America/Monterrey` - America/Monterrey
 * * `America/Montevideo` - America/Montevideo
 * * `America/Montreal` - America/Montreal
 * * `America/Montserrat` - America/Montserrat
 * * `America/Nassau` - America/Nassau
 * * `America/New_York` - America/New_York
 * * `America/Nipigon` - America/Nipigon
 * * `America/Nome` - America/Nome
 * * `America/Noronha` - America/Noronha
 * * `America/North_Dakota/Beulah` - America/North_Dakota/Beulah
 * * `America/North_Dakota/Center` - America/North_Dakota/Center
 * * `America/North_Dakota/New_Salem` - America/North_Dakota/New_Salem
 * * `America/Nuuk` - America/Nuuk
 * * `America/Ojinaga` - America/Ojinaga
 * * `America/Panama` - America/Panama
 * * `America/Pangnirtung` - America/Pangnirtung
 * * `America/Paramaribo` - America/Paramaribo
 * * `America/Phoenix` - America/Phoenix
 * * `America/Port-au-Prince` - America/Port-au-Prince
 * * `America/Port_of_Spain` - America/Port_of_Spain
 * * `America/Porto_Acre` - America/Porto_Acre
 * * `America/Porto_Velho` - America/Porto_Velho
 * * `America/Puerto_Rico` - America/Puerto_Rico
 * * `America/Punta_Arenas` - America/Punta_Arenas
 * * `America/Rainy_River` - America/Rainy_River
 * * `America/Rankin_Inlet` - America/Rankin_Inlet
 * * `America/Recife` - America/Recife
 * * `America/Regina` - America/Regina
 * * `America/Resolute` - America/Resolute
 * * `America/Rio_Branco` - America/Rio_Branco
 * * `America/Rosario` - America/Rosario
 * * `America/Santa_Isabel` - America/Santa_Isabel
 * * `America/Santarem` - America/Santarem
 * * `America/Santiago` - America/Santiago
 * * `America/Santo_Domingo` - America/Santo_Domingo
 * * `America/Sao_Paulo` - America/Sao_Paulo
 * * `America/Scoresbysund` - America/Scoresbysund
 * * `America/Shiprock` - America/Shiprock
 * * `America/Sitka` - America/Sitka
 * * `America/St_Barthelemy` - America/St_Barthelemy
 * * `America/St_Johns` - America/St_Johns
 * * `America/St_Kitts` - America/St_Kitts
 * * `America/St_Lucia` - America/St_Lucia
 * * `America/St_Thomas` - America/St_Thomas
 * * `America/St_Vincent` - America/St_Vincent
 * * `America/Swift_Current` - America/Swift_Current
 * * `America/Tegucigalpa` - America/Tegucigalpa
 * * `America/Thule` - America/Thule
 * * `America/Thunder_Bay` - America/Thunder_Bay
 * * `America/Tijuana` - America/Tijuana
 * * `America/Toronto` - America/Toronto
 * * `America/Tortola` - America/Tortola
 * * `America/Vancouver` - America/Vancouver
 * * `America/Virgin` - America/Virgin
 * * `America/Whitehorse` - America/Whitehorse
 * * `America/Winnipeg` - America/Winnipeg
 * * `America/Yakutat` - America/Yakutat
 * * `America/Yellowknife` - America/Yellowknife
 * * `Antarctica/Casey` - Antarctica/Casey
 * * `Antarctica/Davis` - Antarctica/Davis
 * * `Antarctica/DumontDUrville` - Antarctica/DumontDUrville
 * * `Antarctica/Macquarie` - Antarctica/Macquarie
 * * `Antarctica/Mawson` - Antarctica/Mawson
 * * `Antarctica/McMurdo` - Antarctica/McMurdo
 * * `Antarctica/Palmer` - Antarctica/Palmer
 * * `Antarctica/Rothera` - Antarctica/Rothera
 * * `Antarctica/South_Pole` - Antarctica/South_Pole
 * * `Antarctica/Syowa` - Antarctica/Syowa
 * * `Antarctica/Troll` - Antarctica/Troll
 * * `Antarctica/Vostok` - Antarctica/Vostok
 * * `Arctic/Longyearbyen` - Arctic/Longyearbyen
 * * `Asia/Aden` - Asia/Aden
 * * `Asia/Almaty` - Asia/Almaty
 * * `Asia/Amman` - Asia/Amman
 * * `Asia/Anadyr` - Asia/Anadyr
 * * `Asia/Aqtau` - Asia/Aqtau
 * * `Asia/Aqtobe` - Asia/Aqtobe
 * * `Asia/Ashgabat` - Asia/Ashgabat
 * * `Asia/Ashkhabad` - Asia/Ashkhabad
 * * `Asia/Atyrau` - Asia/Atyrau
 * * `Asia/Baghdad` - Asia/Baghdad
 * * `Asia/Bahrain` - Asia/Bahrain
 * * `Asia/Baku` - Asia/Baku
 * * `Asia/Bangkok` - Asia/Bangkok
 * * `Asia/Barnaul` - Asia/Barnaul
 * * `Asia/Beirut` - Asia/Beirut
 * * `Asia/Bishkek` - Asia/Bishkek
 * * `Asia/Brunei` - Asia/Brunei
 * * `Asia/Calcutta` - Asia/Calcutta
 * * `Asia/Chita` - Asia/Chita
 * * `Asia/Choibalsan` - Asia/Choibalsan
 * * `Asia/Chongqing` - Asia/Chongqing
 * * `Asia/Chungking` - Asia/Chungking
 * * `Asia/Colombo` - Asia/Colombo
 * * `Asia/Dacca` - Asia/Dacca
 * * `Asia/Damascus` - Asia/Damascus
 * * `Asia/Dhaka` - Asia/Dhaka
 * * `Asia/Dili` - Asia/Dili
 * * `Asia/Dubai` - Asia/Dubai
 * * `Asia/Dushanbe` - Asia/Dushanbe
 * * `Asia/Famagusta` - Asia/Famagusta
 * * `Asia/Gaza` - Asia/Gaza
 * * `Asia/Harbin` - Asia/Harbin
 * * `Asia/Hebron` - Asia/Hebron
 * * `Asia/Ho_Chi_Minh` - Asia/Ho_Chi_Minh
 * * `Asia/Hong_Kong` - Asia/Hong_Kong
 * * `Asia/Hovd` - Asia/Hovd
 * * `Asia/Irkutsk` - Asia/Irkutsk
 * * `Asia/Istanbul` - Asia/Istanbul
 * * `Asia/Jakarta` - Asia/Jakarta
 * * `Asia/Jayapura` - Asia/Jayapura
 * * `Asia/Jerusalem` - Asia/Jerusalem
 * * `Asia/Kabul` - Asia/Kabul
 * * `Asia/Kamchatka` - Asia/Kamchatka
 * * `Asia/Karachi` - Asia/Karachi
 * * `Asia/Kashgar` - Asia/Kashgar
 * * `Asia/Kathmandu` - Asia/Kathmandu
 * * `Asia/Katmandu` - Asia/Katmandu
 * * `Asia/Khandyga` - Asia/Khandyga
 * * `Asia/Kolkata` - Asia/Kolkata
 * * `Asia/Krasnoyarsk` - Asia/Krasnoyarsk
 * * `Asia/Kuala_Lumpur` - Asia/Kuala_Lumpur
 * * `Asia/Kuching` - Asia/Kuching
 * * `Asia/Kuwait` - Asia/Kuwait
 * * `Asia/Macao` - Asia/Macao
 * * `Asia/Macau` - Asia/Macau
 * * `Asia/Magadan` - Asia/Magadan
 * * `Asia/Makassar` - Asia/Makassar
 * * `Asia/Manila` - Asia/Manila
 * * `Asia/Muscat` - Asia/Muscat
 * * `Asia/Nicosia` - Asia/Nicosia
 * * `Asia/Novokuznetsk` - Asia/Novokuznetsk
 * * `Asia/Novosibirsk` - Asia/Novosibirsk
 * * `Asia/Omsk` - Asia/Omsk
 * * `Asia/Oral` - Asia/Oral
 * * `Asia/Phnom_Penh` - Asia/Phnom_Penh
 * * `Asia/Pontianak` - Asia/Pontianak
 * * `Asia/Pyongyang` - Asia/Pyongyang
 * * `Asia/Qatar` - Asia/Qatar
 * * `Asia/Qostanay` - Asia/Qostanay
 * * `Asia/Qyzylorda` - Asia/Qyzylorda
 * * `Asia/Rangoon` - Asia/Rangoon
 * * `Asia/Riyadh` - Asia/Riyadh
 * * `Asia/Saigon` - Asia/Saigon
 * * `Asia/Sakhalin` - Asia/Sakhalin
 * * `Asia/Samarkand` - Asia/Samarkand
 * * `Asia/Seoul` - Asia/Seoul
 * * `Asia/Shanghai` - Asia/Shanghai
 * * `Asia/Singapore` - Asia/Singapore
 * * `Asia/Srednekolymsk` - Asia/Srednekolymsk
 * * `Asia/Taipei` - Asia/Taipei
 * * `Asia/Tashkent` - Asia/Tashkent
 * * `Asia/Tbilisi` - Asia/Tbilisi
 * * `Asia/Tehran` - Asia/Tehran
 * * `Asia/Tel_Aviv` - Asia/Tel_Aviv
 * * `Asia/Thimbu` - Asia/Thimbu
 * * `Asia/Thimphu` - Asia/Thimphu
 * * `Asia/Tokyo` - Asia/Tokyo
 * * `Asia/Tomsk` - Asia/Tomsk
 * * `Asia/Ujung_Pandang` - Asia/Ujung_Pandang
 * * `Asia/Ulaanbaatar` - Asia/Ulaanbaatar
 * * `Asia/Ulan_Bator` - Asia/Ulan_Bator
 * * `Asia/Urumqi` - Asia/Urumqi
 * * `Asia/Ust-Nera` - Asia/Ust-Nera
 * * `Asia/Vientiane` - Asia/Vientiane
 * * `Asia/Vladivostok` - Asia/Vladivostok
 * * `Asia/Yakutsk` - Asia/Yakutsk
 * * `Asia/Yangon` - Asia/Yangon
 * * `Asia/Yekaterinburg` - Asia/Yekaterinburg
 * * `Asia/Yerevan` - Asia/Yerevan
 * * `Atlantic/Azores` - Atlantic/Azores
 * * `Atlantic/Bermuda` - Atlantic/Bermuda
 * * `Atlantic/Canary` - Atlantic/Canary
 * * `Atlantic/Cape_Verde` - Atlantic/Cape_Verde
 * * `Atlantic/Faeroe` - Atlantic/Faeroe
 * * `Atlantic/Faroe` - Atlantic/Faroe
 * * `Atlantic/Jan_Mayen` - Atlantic/Jan_Mayen
 * * `Atlantic/Madeira` - Atlantic/Madeira
 * * `Atlantic/Reykjavik` - Atlantic/Reykjavik
 * * `Atlantic/South_Georgia` - Atlantic/South_Georgia
 * * `Atlantic/St_Helena` - Atlantic/St_Helena
 * * `Atlantic/Stanley` - Atlantic/Stanley
 * * `Australia/ACT` - Australia/ACT
 * * `Australia/Adelaide` - Australia/Adelaide
 * * `Australia/Brisbane` - Australia/Brisbane
 * * `Australia/Broken_Hill` - Australia/Broken_Hill
 * * `Australia/Canberra` - Australia/Canberra
 * * `Australia/Currie` - Australia/Currie
 * * `Australia/Darwin` - Australia/Darwin
 * * `Australia/Eucla` - Australia/Eucla
 * * `Australia/Hobart` - Australia/Hobart
 * * `Australia/LHI` - Australia/LHI
 * * `Australia/Lindeman` - Australia/Lindeman
 * * `Australia/Lord_Howe` - Australia/Lord_Howe
 * * `Australia/Melbourne` - Australia/Melbourne
 * * `Australia/NSW` - Australia/NSW
 * * `Australia/North` - Australia/North
 * * `Australia/Perth` - Australia/Perth
 * * `Australia/Queensland` - Australia/Queensland
 * * `Australia/South` - Australia/South
 * * `Australia/Sydney` - Australia/Sydney
 * * `Australia/Tasmania` - Australia/Tasmania
 * * `Australia/Victoria` - Australia/Victoria
 * * `Australia/West` - Australia/West
 * * `Australia/Yancowinna` - Australia/Yancowinna
 * * `Brazil/Acre` - Brazil/Acre
 * * `Brazil/DeNoronha` - Brazil/DeNoronha
 * * `Brazil/East` - Brazil/East
 * * `Brazil/West` - Brazil/West
 * * `CET` - CET
 * * `CST6CDT` - CST6CDT
 * * `Canada/Atlantic` - Canada/Atlantic
 * * `Canada/Central` - Canada/Central
 * * `Canada/Eastern` - Canada/Eastern
 * * `Canada/Mountain` - Canada/Mountain
 * * `Canada/Newfoundland` - Canada/Newfoundland
 * * `Canada/Pacific` - Canada/Pacific
 * * `Canada/Saskatchewan` - Canada/Saskatchewan
 * * `Canada/Yukon` - Canada/Yukon
 * * `Chile/Continental` - Chile/Continental
 * * `Chile/EasterIsland` - Chile/EasterIsland
 * * `Cuba` - Cuba
 * * `EET` - EET
 * * `EST` - EST
 * * `EST5EDT` - EST5EDT
 * * `Egypt` - Egypt
 * * `Eire` - Eire
 * * `Etc/GMT` - Etc/GMT
 * * `Etc/GMT+0` - Etc/GMT+0
 * * `Etc/GMT+1` - Etc/GMT+1
 * * `Etc/GMT+10` - Etc/GMT+10
 * * `Etc/GMT+11` - Etc/GMT+11
 * * `Etc/GMT+12` - Etc/GMT+12
 * * `Etc/GMT+2` - Etc/GMT+2
 * * `Etc/GMT+3` - Etc/GMT+3
 * * `Etc/GMT+4` - Etc/GMT+4
 * * `Etc/GMT+5` - Etc/GMT+5
 * * `Etc/GMT+6` - Etc/GMT+6
 * * `Etc/GMT+7` - Etc/GMT+7
 * * `Etc/GMT+8` - Etc/GMT+8
 * * `Etc/GMT+9` - Etc/GMT+9
 * * `Etc/GMT-0` - Etc/GMT-0
 * * `Etc/GMT-1` - Etc/GMT-1
 * * `Etc/GMT-10` - Etc/GMT-10
 * * `Etc/GMT-11` - Etc/GMT-11
 * * `Etc/GMT-12` - Etc/GMT-12
 * * `Etc/GMT-13` - Etc/GMT-13
 * * `Etc/GMT-14` - Etc/GMT-14
 * * `Etc/GMT-2` - Etc/GMT-2
 * * `Etc/GMT-3` - Etc/GMT-3
 * * `Etc/GMT-4` - Etc/GMT-4
 * * `Etc/GMT-5` - Etc/GMT-5
 * * `Etc/GMT-6` - Etc/GMT-6
 * * `Etc/GMT-7` - Etc/GMT-7
 * * `Etc/GMT-8` - Etc/GMT-8
 * * `Etc/GMT-9` - Etc/GMT-9
 * * `Etc/GMT0` - Etc/GMT0
 * * `Etc/Greenwich` - Etc/Greenwich
 * * `Etc/UCT` - Etc/UCT
 * * `Etc/UTC` - Etc/UTC
 * * `Etc/Universal` - Etc/Universal
 * * `Etc/Zulu` - Etc/Zulu
 * * `Europe/Amsterdam` - Europe/Amsterdam
 * * `Europe/Andorra` - Europe/Andorra
 * * `Europe/Astrakhan` - Europe/Astrakhan
 * * `Europe/Athens` - Europe/Athens
 * * `Europe/Belfast` - Europe/Belfast
 * * `Europe/Belgrade` - Europe/Belgrade
 * * `Europe/Berlin` - Europe/Berlin
 * * `Europe/Bratislava` - Europe/Bratislava
 * * `Europe/Brussels` - Europe/Brussels
 * * `Europe/Bucharest` - Europe/Bucharest
 * * `Europe/Budapest` - Europe/Budapest
 * * `Europe/Busingen` - Europe/Busingen
 * * `Europe/Chisinau` - Europe/Chisinau
 * * `Europe/Copenhagen` - Europe/Copenhagen
 * * `Europe/Dublin` - Europe/Dublin
 * * `Europe/Gibraltar` - Europe/Gibraltar
 * * `Europe/Guernsey` - Europe/Guernsey
 * * `Europe/Helsinki` - Europe/Helsinki
 * * `Europe/Isle_of_Man` - Europe/Isle_of_Man
 * * `Europe/Istanbul` - Europe/Istanbul
 * * `Europe/Jersey` - Europe/Jersey
 * * `Europe/Kaliningrad` - Europe/Kaliningrad
 * * `Europe/Kiev` - Europe/Kiev
 * * `Europe/Kirov` - Europe/Kirov
 * * `Europe/Kyiv` - Europe/Kyiv
 * * `Europe/Lisbon` - Europe/Lisbon
 * * `Europe/Ljubljana` - Europe/Ljubljana
 * * `Europe/London` - Europe/London
 * * `Europe/Luxembourg` - Europe/Luxembourg
 * * `Europe/Madrid` - Europe/Madrid
 * * `Europe/Malta` - Europe/Malta
 * * `Europe/Mariehamn` - Europe/Mariehamn
 * * `Europe/Minsk` - Europe/Minsk
 * * `Europe/Monaco` - Europe/Monaco
 * * `Europe/Moscow` - Europe/Moscow
 * * `Europe/Nicosia` - Europe/Nicosia
 * * `Europe/Oslo` - Europe/Oslo
 * * `Europe/Paris` - Europe/Paris
 * * `Europe/Podgorica` - Europe/Podgorica
 * * `Europe/Prague` - Europe/Prague
 * * `Europe/Riga` - Europe/Riga
 * * `Europe/Rome` - Europe/Rome
 * * `Europe/Samara` - Europe/Samara
 * * `Europe/San_Marino` - Europe/San_Marino
 * * `Europe/Sarajevo` - Europe/Sarajevo
 * * `Europe/Saratov` - Europe/Saratov
 * * `Europe/Simferopol` - Europe/Simferopol
 * * `Europe/Skopje` - Europe/Skopje
 * * `Europe/Sofia` - Europe/Sofia
 * * `Europe/Stockholm` - Europe/Stockholm
 * * `Europe/Tallinn` - Europe/Tallinn
 * * `Europe/Tirane` - Europe/Tirane
 * * `Europe/Tiraspol` - Europe/Tiraspol
 * * `Europe/Ulyanovsk` - Europe/Ulyanovsk
 * * `Europe/Uzhgorod` - Europe/Uzhgorod
 * * `Europe/Vaduz` - Europe/Vaduz
 * * `Europe/Vatican` - Europe/Vatican
 * * `Europe/Vienna` - Europe/Vienna
 * * `Europe/Vilnius` - Europe/Vilnius
 * * `Europe/Volgograd` - Europe/Volgograd
 * * `Europe/Warsaw` - Europe/Warsaw
 * * `Europe/Zagreb` - Europe/Zagreb
 * * `Europe/Zaporozhye` - Europe/Zaporozhye
 * * `Europe/Zurich` - Europe/Zurich
 * * `GB` - GB
 * * `GB-Eire` - GB-Eire
 * * `GMT` - GMT
 * * `GMT+0` - GMT+0
 * * `GMT-0` - GMT-0
 * * `GMT0` - GMT0
 * * `Greenwich` - Greenwich
 * * `HST` - HST
 * * `Hongkong` - Hongkong
 * * `Iceland` - Iceland
 * * `Indian/Antananarivo` - Indian/Antananarivo
 * * `Indian/Chagos` - Indian/Chagos
 * * `Indian/Christmas` - Indian/Christmas
 * * `Indian/Cocos` - Indian/Cocos
 * * `Indian/Comoro` - Indian/Comoro
 * * `Indian/Kerguelen` - Indian/Kerguelen
 * * `Indian/Mahe` - Indian/Mahe
 * * `Indian/Maldives` - Indian/Maldives
 * * `Indian/Mauritius` - Indian/Mauritius
 * * `Indian/Mayotte` - Indian/Mayotte
 * * `Indian/Reunion` - Indian/Reunion
 * * `Iran` - Iran
 * * `Israel` - Israel
 * * `Jamaica` - Jamaica
 * * `Japan` - Japan
 * * `Kwajalein` - Kwajalein
 * * `Libya` - Libya
 * * `MET` - MET
 * * `MST` - MST
 * * `MST7MDT` - MST7MDT
 * * `Mexico/BajaNorte` - Mexico/BajaNorte
 * * `Mexico/BajaSur` - Mexico/BajaSur
 * * `Mexico/General` - Mexico/General
 * * `NZ` - NZ
 * * `NZ-CHAT` - NZ-CHAT
 * * `Navajo` - Navajo
 * * `PRC` - PRC
 * * `PST8PDT` - PST8PDT
 * * `Pacific/Apia` - Pacific/Apia
 * * `Pacific/Auckland` - Pacific/Auckland
 * * `Pacific/Bougainville` - Pacific/Bougainville
 * * `Pacific/Chatham` - Pacific/Chatham
 * * `Pacific/Chuuk` - Pacific/Chuuk
 * * `Pacific/Easter` - Pacific/Easter
 * * `Pacific/Efate` - Pacific/Efate
 * * `Pacific/Enderbury` - Pacific/Enderbury
 * * `Pacific/Fakaofo` - Pacific/Fakaofo
 * * `Pacific/Fiji` - Pacific/Fiji
 * * `Pacific/Funafuti` - Pacific/Funafuti
 * * `Pacific/Galapagos` - Pacific/Galapagos
 * * `Pacific/Gambier` - Pacific/Gambier
 * * `Pacific/Guadalcanal` - Pacific/Guadalcanal
 * * `Pacific/Guam` - Pacific/Guam
 * * `Pacific/Honolulu` - Pacific/Honolulu
 * * `Pacific/Johnston` - Pacific/Johnston
 * * `Pacific/Kanton` - Pacific/Kanton
 * * `Pacific/Kiritimati` - Pacific/Kiritimati
 * * `Pacific/Kosrae` - Pacific/Kosrae
 * * `Pacific/Kwajalein` - Pacific/Kwajalein
 * * `Pacific/Majuro` - Pacific/Majuro
 * * `Pacific/Marquesas` - Pacific/Marquesas
 * * `Pacific/Midway` - Pacific/Midway
 * * `Pacific/Nauru` - Pacific/Nauru
 * * `Pacific/Niue` - Pacific/Niue
 * * `Pacific/Norfolk` - Pacific/Norfolk
 * * `Pacific/Noumea` - Pacific/Noumea
 * * `Pacific/Pago_Pago` - Pacific/Pago_Pago
 * * `Pacific/Palau` - Pacific/Palau
 * * `Pacific/Pitcairn` - Pacific/Pitcairn
 * * `Pacific/Pohnpei` - Pacific/Pohnpei
 * * `Pacific/Ponape` - Pacific/Ponape
 * * `Pacific/Port_Moresby` - Pacific/Port_Moresby
 * * `Pacific/Rarotonga` - Pacific/Rarotonga
 * * `Pacific/Saipan` - Pacific/Saipan
 * * `Pacific/Samoa` - Pacific/Samoa
 * * `Pacific/Tahiti` - Pacific/Tahiti
 * * `Pacific/Tarawa` - Pacific/Tarawa
 * * `Pacific/Tongatapu` - Pacific/Tongatapu
 * * `Pacific/Truk` - Pacific/Truk
 * * `Pacific/Wake` - Pacific/Wake
 * * `Pacific/Wallis` - Pacific/Wallis
 * * `Pacific/Yap` - Pacific/Yap
 * * `Poland` - Poland
 * * `Portugal` - Portugal
 * * `ROC` - ROC
 * * `ROK` - ROK
 * * `Singapore` - Singapore
 * * `Turkey` - Turkey
 * * `UCT` - UCT
 * * `US/Alaska` - US/Alaska
 * * `US/Aleutian` - US/Aleutian
 * * `US/Arizona` - US/Arizona
 * * `US/Central` - US/Central
 * * `US/East-Indiana` - US/East-Indiana
 * * `US/Eastern` - US/Eastern
 * * `US/Hawaii` - US/Hawaii
 * * `US/Indiana-Starke` - US/Indiana-Starke
 * * `US/Michigan` - US/Michigan
 * * `US/Mountain` - US/Mountain
 * * `US/Pacific` - US/Pacific
 * * `US/Samoa` - US/Samoa
 * * `UTC` - UTC
 * * `Universal` - Universal
 * * `W-SU` - W-SU
 * * `WET` - WET
 * * `Zulu` - Zulu
 */
export enum TimezoneEnum {
    AFRICA_ABIDJAN = 'Africa/Abidjan',
    AFRICA_ACCRA = 'Africa/Accra',
    AFRICA_ADDIS_ABABA = 'Africa/Addis_Ababa',
    AFRICA_ALGIERS = 'Africa/Algiers',
    AFRICA_ASMARA = 'Africa/Asmara',
    AFRICA_ASMERA = 'Africa/Asmera',
    AFRICA_BAMAKO = 'Africa/Bamako',
    AFRICA_BANGUI = 'Africa/Bangui',
    AFRICA_BANJUL = 'Africa/Banjul',
    AFRICA_BISSAU = 'Africa/Bissau',
    AFRICA_BLANTYRE = 'Africa/Blantyre',
    AFRICA_BRAZZAVILLE = 'Africa/Brazzaville',
    AFRICA_BUJUMBURA = 'Africa/Bujumbura',
    AFRICA_CAIRO = 'Africa/Cairo',
    AFRICA_CASABLANCA = 'Africa/Casablanca',
    AFRICA_CEUTA = 'Africa/Ceuta',
    AFRICA_CONAKRY = 'Africa/Conakry',
    AFRICA_DAKAR = 'Africa/Dakar',
    AFRICA_DAR_ES_SALAAM = 'Africa/Dar_es_Salaam',
    AFRICA_DJIBOUTI = 'Africa/Djibouti',
    AFRICA_DOUALA = 'Africa/Douala',
    AFRICA_EL_AAIUN = 'Africa/El_Aaiun',
    AFRICA_FREETOWN = 'Africa/Freetown',
    AFRICA_GABORONE = 'Africa/Gaborone',
    AFRICA_HARARE = 'Africa/Harare',
    AFRICA_JOHANNESBURG = 'Africa/Johannesburg',
    AFRICA_JUBA = 'Africa/Juba',
    AFRICA_KAMPALA = 'Africa/Kampala',
    AFRICA_KHARTOUM = 'Africa/Khartoum',
    AFRICA_KIGALI = 'Africa/Kigali',
    AFRICA_KINSHASA = 'Africa/Kinshasa',
    AFRICA_LAGOS = 'Africa/Lagos',
    AFRICA_LIBREVILLE = 'Africa/Libreville',
    AFRICA_LOME = 'Africa/Lome',
    AFRICA_LUANDA = 'Africa/Luanda',
    AFRICA_LUBUMBASHI = 'Africa/Lubumbashi',
    AFRICA_LUSAKA = 'Africa/Lusaka',
    AFRICA_MALABO = 'Africa/Malabo',
    AFRICA_MAPUTO = 'Africa/Maputo',
    AFRICA_MASERU = 'Africa/Maseru',
    AFRICA_MBABANE = 'Africa/Mbabane',
    AFRICA_MOGADISHU = 'Africa/Mogadishu',
    AFRICA_MONROVIA = 'Africa/Monrovia',
    AFRICA_NAIROBI = 'Africa/Nairobi',
    AFRICA_NDJAMENA = 'Africa/Ndjamena',
    AFRICA_NIAMEY = 'Africa/Niamey',
    AFRICA_NOUAKCHOTT = 'Africa/Nouakchott',
    AFRICA_OUAGADOUGOU = 'Africa/Ouagadougou',
    AFRICA_PORTO_NOVO = 'Africa/Porto-Novo',
    AFRICA_SAO_TOME = 'Africa/Sao_Tome',
    AFRICA_TIMBUKTU = 'Africa/Timbuktu',
    AFRICA_TRIPOLI = 'Africa/Tripoli',
    AFRICA_TUNIS = 'Africa/Tunis',
    AFRICA_WINDHOEK = 'Africa/Windhoek',
    AMERICA_ADAK = 'America/Adak',
    AMERICA_ANCHORAGE = 'America/Anchorage',
    AMERICA_ANGUILLA = 'America/Anguilla',
    AMERICA_ANTIGUA = 'America/Antigua',
    AMERICA_ARAGUAINA = 'America/Araguaina',
    AMERICA_ARGENTINA_BUENOS_AIRES = 'America/Argentina/Buenos_Aires',
    AMERICA_ARGENTINA_CATAMARCA = 'America/Argentina/Catamarca',
    AMERICA_ARGENTINA_COMOD_RIVADAVIA = 'America/Argentina/ComodRivadavia',
    AMERICA_ARGENTINA_CORDOBA = 'America/Argentina/Cordoba',
    AMERICA_ARGENTINA_JUJUY = 'America/Argentina/Jujuy',
    AMERICA_ARGENTINA_LA_RIOJA = 'America/Argentina/La_Rioja',
    AMERICA_ARGENTINA_MENDOZA = 'America/Argentina/Mendoza',
    AMERICA_ARGENTINA_RIO_GALLEGOS = 'America/Argentina/Rio_Gallegos',
    AMERICA_ARGENTINA_SALTA = 'America/Argentina/Salta',
    AMERICA_ARGENTINA_SAN_JUAN = 'America/Argentina/San_Juan',
    AMERICA_ARGENTINA_SAN_LUIS = 'America/Argentina/San_Luis',
    AMERICA_ARGENTINA_TUCUMAN = 'America/Argentina/Tucuman',
    AMERICA_ARGENTINA_USHUAIA = 'America/Argentina/Ushuaia',
    AMERICA_ARUBA = 'America/Aruba',
    AMERICA_ASUNCION = 'America/Asuncion',
    AMERICA_ATIKOKAN = 'America/Atikokan',
    AMERICA_ATKA = 'America/Atka',
    AMERICA_BAHIA = 'America/Bahia',
    AMERICA_BAHIA_BANDERAS = 'America/Bahia_Banderas',
    AMERICA_BARBADOS = 'America/Barbados',
    AMERICA_BELEM = 'America/Belem',
    AMERICA_BELIZE = 'America/Belize',
    AMERICA_BLANC_SABLON = 'America/Blanc-Sablon',
    AMERICA_BOA_VISTA = 'America/Boa_Vista',
    AMERICA_BOGOTA = 'America/Bogota',
    AMERICA_BOISE = 'America/Boise',
    AMERICA_BUENOS_AIRES = 'America/Buenos_Aires',
    AMERICA_CAMBRIDGE_BAY = 'America/Cambridge_Bay',
    AMERICA_CAMPO_GRANDE = 'America/Campo_Grande',
    AMERICA_CANCUN = 'America/Cancun',
    AMERICA_CARACAS = 'America/Caracas',
    AMERICA_CATAMARCA = 'America/Catamarca',
    AMERICA_CAYENNE = 'America/Cayenne',
    AMERICA_CAYMAN = 'America/Cayman',
    AMERICA_CHICAGO = 'America/Chicago',
    AMERICA_CHIHUAHUA = 'America/Chihuahua',
    AMERICA_CIUDAD_JUAREZ = 'America/Ciudad_Juarez',
    AMERICA_CORAL_HARBOUR = 'America/Coral_Harbour',
    AMERICA_CORDOBA = 'America/Cordoba',
    AMERICA_COSTA_RICA = 'America/Costa_Rica',
    AMERICA_COYHAIQUE = 'America/Coyhaique',
    AMERICA_CRESTON = 'America/Creston',
    AMERICA_CUIABA = 'America/Cuiaba',
    AMERICA_CURACAO = 'America/Curacao',
    AMERICA_DANMARKSHAVN = 'America/Danmarkshavn',
    AMERICA_DAWSON = 'America/Dawson',
    AMERICA_DAWSON_CREEK = 'America/Dawson_Creek',
    AMERICA_DENVER = 'America/Denver',
    AMERICA_DETROIT = 'America/Detroit',
    AMERICA_DOMINICA = 'America/Dominica',
    AMERICA_EDMONTON = 'America/Edmonton',
    AMERICA_EIRUNEPE = 'America/Eirunepe',
    AMERICA_EL_SALVADOR = 'America/El_Salvador',
    AMERICA_ENSENADA = 'America/Ensenada',
    AMERICA_FORT_NELSON = 'America/Fort_Nelson',
    AMERICA_FORT_WAYNE = 'America/Fort_Wayne',
    AMERICA_FORTALEZA = 'America/Fortaleza',
    AMERICA_GLACE_BAY = 'America/Glace_Bay',
    AMERICA_GODTHAB = 'America/Godthab',
    AMERICA_GOOSE_BAY = 'America/Goose_Bay',
    AMERICA_GRAND_TURK = 'America/Grand_Turk',
    AMERICA_GRENADA = 'America/Grenada',
    AMERICA_GUADELOUPE = 'America/Guadeloupe',
    AMERICA_GUATEMALA = 'America/Guatemala',
    AMERICA_GUAYAQUIL = 'America/Guayaquil',
    AMERICA_GUYANA = 'America/Guyana',
    AMERICA_HALIFAX = 'America/Halifax',
    AMERICA_HAVANA = 'America/Havana',
    AMERICA_HERMOSILLO = 'America/Hermosillo',
    AMERICA_INDIANA_INDIANAPOLIS = 'America/Indiana/Indianapolis',
    AMERICA_INDIANA_KNOX = 'America/Indiana/Knox',
    AMERICA_INDIANA_MARENGO = 'America/Indiana/Marengo',
    AMERICA_INDIANA_PETERSBURG = 'America/Indiana/Petersburg',
    AMERICA_INDIANA_TELL_CITY = 'America/Indiana/Tell_City',
    AMERICA_INDIANA_VEVAY = 'America/Indiana/Vevay',
    AMERICA_INDIANA_VINCENNES = 'America/Indiana/Vincennes',
    AMERICA_INDIANA_WINAMAC = 'America/Indiana/Winamac',
    AMERICA_INDIANAPOLIS = 'America/Indianapolis',
    AMERICA_INUVIK = 'America/Inuvik',
    AMERICA_IQALUIT = 'America/Iqaluit',
    AMERICA_JAMAICA = 'America/Jamaica',
    AMERICA_JUJUY = 'America/Jujuy',
    AMERICA_JUNEAU = 'America/Juneau',
    AMERICA_KENTUCKY_LOUISVILLE = 'America/Kentucky/Louisville',
    AMERICA_KENTUCKY_MONTICELLO = 'America/Kentucky/Monticello',
    AMERICA_KNOX_IN = 'America/Knox_IN',
    AMERICA_KRALENDIJK = 'America/Kralendijk',
    AMERICA_LA_PAZ = 'America/La_Paz',
    AMERICA_LIMA = 'America/Lima',
    AMERICA_LOS_ANGELES = 'America/Los_Angeles',
    AMERICA_LOUISVILLE = 'America/Louisville',
    AMERICA_LOWER_PRINCES = 'America/Lower_Princes',
    AMERICA_MACEIO = 'America/Maceio',
    AMERICA_MANAGUA = 'America/Managua',
    AMERICA_MANAUS = 'America/Manaus',
    AMERICA_MARIGOT = 'America/Marigot',
    AMERICA_MARTINIQUE = 'America/Martinique',
    AMERICA_MATAMOROS = 'America/Matamoros',
    AMERICA_MAZATLAN = 'America/Mazatlan',
    AMERICA_MENDOZA = 'America/Mendoza',
    AMERICA_MENOMINEE = 'America/Menominee',
    AMERICA_MERIDA = 'America/Merida',
    AMERICA_METLAKATLA = 'America/Metlakatla',
    AMERICA_MEXICO_CITY = 'America/Mexico_City',
    AMERICA_MIQUELON = 'America/Miquelon',
    AMERICA_MONCTON = 'America/Moncton',
    AMERICA_MONTERREY = 'America/Monterrey',
    AMERICA_MONTEVIDEO = 'America/Montevideo',
    AMERICA_MONTREAL = 'America/Montreal',
    AMERICA_MONTSERRAT = 'America/Montserrat',
    AMERICA_NASSAU = 'America/Nassau',
    AMERICA_NEW_YORK = 'America/New_York',
    AMERICA_NIPIGON = 'America/Nipigon',
    AMERICA_NOME = 'America/Nome',
    AMERICA_NORONHA = 'America/Noronha',
    AMERICA_NORTH_DAKOTA_BEULAH = 'America/North_Dakota/Beulah',
    AMERICA_NORTH_DAKOTA_CENTER = 'America/North_Dakota/Center',
    AMERICA_NORTH_DAKOTA_NEW_SALEM = 'America/North_Dakota/New_Salem',
    AMERICA_NUUK = 'America/Nuuk',
    AMERICA_OJINAGA = 'America/Ojinaga',
    AMERICA_PANAMA = 'America/Panama',
    AMERICA_PANGNIRTUNG = 'America/Pangnirtung',
    AMERICA_PARAMARIBO = 'America/Paramaribo',
    AMERICA_PHOENIX = 'America/Phoenix',
    AMERICA_PORT_AU_PRINCE = 'America/Port-au-Prince',
    AMERICA_PORT_OF_SPAIN = 'America/Port_of_Spain',
    AMERICA_PORTO_ACRE = 'America/Porto_Acre',
    AMERICA_PORTO_VELHO = 'America/Porto_Velho',
    AMERICA_PUERTO_RICO = 'America/Puerto_Rico',
    AMERICA_PUNTA_ARENAS = 'America/Punta_Arenas',
    AMERICA_RAINY_RIVER = 'America/Rainy_River',
    AMERICA_RANKIN_INLET = 'America/Rankin_Inlet',
    AMERICA_RECIFE = 'America/Recife',
    AMERICA_REGINA = 'America/Regina',
    AMERICA_RESOLUTE = 'America/Resolute',
    AMERICA_RIO_BRANCO = 'America/Rio_Branco',
    AMERICA_ROSARIO = 'America/Rosario',
    AMERICA_SANTA_ISABEL = 'America/Santa_Isabel',
    AMERICA_SANTAREM = 'America/Santarem',
    AMERICA_SANTIAGO = 'America/Santiago',
    AMERICA_SANTO_DOMINGO = 'America/Santo_Domingo',
    AMERICA_SAO_PAULO = 'America/Sao_Paulo',
    AMERICA_SCORESBYSUND = 'America/Scoresbysund',
    AMERICA_SHIPROCK = 'America/Shiprock',
    AMERICA_SITKA = 'America/Sitka',
    AMERICA_ST_BARTHELEMY = 'America/St_Barthelemy',
    AMERICA_ST_JOHNS = 'America/St_Johns',
    AMERICA_ST_KITTS = 'America/St_Kitts',
    AMERICA_ST_LUCIA = 'America/St_Lucia',
    AMERICA_ST_THOMAS = 'America/St_Thomas',
    AMERICA_ST_VINCENT = 'America/St_Vincent',
    AMERICA_SWIFT_CURRENT = 'America/Swift_Current',
    AMERICA_TEGUCIGALPA = 'America/Tegucigalpa',
    AMERICA_THULE = 'America/Thule',
    AMERICA_THUNDER_BAY = 'America/Thunder_Bay',
    AMERICA_TIJUANA = 'America/Tijuana',
    AMERICA_TORONTO = 'America/Toronto',
    AMERICA_TORTOLA = 'America/Tortola',
    AMERICA_VANCOUVER = 'America/Vancouver',
    AMERICA_VIRGIN = 'America/Virgin',
    AMERICA_WHITEHORSE = 'America/Whitehorse',
    AMERICA_WINNIPEG = 'America/Winnipeg',
    AMERICA_YAKUTAT = 'America/Yakutat',
    AMERICA_YELLOWKNIFE = 'America/Yellowknife',
    ANTARCTICA_CASEY = 'Antarctica/Casey',
    ANTARCTICA_DAVIS = 'Antarctica/Davis',
    ANTARCTICA_DUMONT_D_URVILLE = 'Antarctica/DumontDUrville',
    ANTARCTICA_MACQUARIE = 'Antarctica/Macquarie',
    ANTARCTICA_MAWSON = 'Antarctica/Mawson',
    ANTARCTICA_MC_MURDO = 'Antarctica/McMurdo',
    ANTARCTICA_PALMER = 'Antarctica/Palmer',
    ANTARCTICA_ROTHERA = 'Antarctica/Rothera',
    ANTARCTICA_SOUTH_POLE = 'Antarctica/South_Pole',
    ANTARCTICA_SYOWA = 'Antarctica/Syowa',
    ANTARCTICA_TROLL = 'Antarctica/Troll',
    ANTARCTICA_VOSTOK = 'Antarctica/Vostok',
    ARCTIC_LONGYEARBYEN = 'Arctic/Longyearbyen',
    ASIA_ADEN = 'Asia/Aden',
    ASIA_ALMATY = 'Asia/Almaty',
    ASIA_AMMAN = 'Asia/Amman',
    ASIA_ANADYR = 'Asia/Anadyr',
    ASIA_AQTAU = 'Asia/Aqtau',
    ASIA_AQTOBE = 'Asia/Aqtobe',
    ASIA_ASHGABAT = 'Asia/Ashgabat',
    ASIA_ASHKHABAD = 'Asia/Ashkhabad',
    ASIA_ATYRAU = 'Asia/Atyrau',
    ASIA_BAGHDAD = 'Asia/Baghdad',
    ASIA_BAHRAIN = 'Asia/Bahrain',
    ASIA_BAKU = 'Asia/Baku',
    ASIA_BANGKOK = 'Asia/Bangkok',
    ASIA_BARNAUL = 'Asia/Barnaul',
    ASIA_BEIRUT = 'Asia/Beirut',
    ASIA_BISHKEK = 'Asia/Bishkek',
    ASIA_BRUNEI = 'Asia/Brunei',
    ASIA_CALCUTTA = 'Asia/Calcutta',
    ASIA_CHITA = 'Asia/Chita',
    ASIA_CHOIBALSAN = 'Asia/Choibalsan',
    ASIA_CHONGQING = 'Asia/Chongqing',
    ASIA_CHUNGKING = 'Asia/Chungking',
    ASIA_COLOMBO = 'Asia/Colombo',
    ASIA_DACCA = 'Asia/Dacca',
    ASIA_DAMASCUS = 'Asia/Damascus',
    ASIA_DHAKA = 'Asia/Dhaka',
    ASIA_DILI = 'Asia/Dili',
    ASIA_DUBAI = 'Asia/Dubai',
    ASIA_DUSHANBE = 'Asia/Dushanbe',
    ASIA_FAMAGUSTA = 'Asia/Famagusta',
    ASIA_GAZA = 'Asia/Gaza',
    ASIA_HARBIN = 'Asia/Harbin',
    ASIA_HEBRON = 'Asia/Hebron',
    ASIA_HO_CHI_MINH = 'Asia/Ho_Chi_Minh',
    ASIA_HONG_KONG = 'Asia/Hong_Kong',
    ASIA_HOVD = 'Asia/Hovd',
    ASIA_IRKUTSK = 'Asia/Irkutsk',
    ASIA_ISTANBUL = 'Asia/Istanbul',
    ASIA_JAKARTA = 'Asia/Jakarta',
    ASIA_JAYAPURA = 'Asia/Jayapura',
    ASIA_JERUSALEM = 'Asia/Jerusalem',
    ASIA_KABUL = 'Asia/Kabul',
    ASIA_KAMCHATKA = 'Asia/Kamchatka',
    ASIA_KARACHI = 'Asia/Karachi',
    ASIA_KASHGAR = 'Asia/Kashgar',
    ASIA_KATHMANDU = 'Asia/Kathmandu',
    ASIA_KATMANDU = 'Asia/Katmandu',
    ASIA_KHANDYGA = 'Asia/Khandyga',
    ASIA_KOLKATA = 'Asia/Kolkata',
    ASIA_KRASNOYARSK = 'Asia/Krasnoyarsk',
    ASIA_KUALA_LUMPUR = 'Asia/Kuala_Lumpur',
    ASIA_KUCHING = 'Asia/Kuching',
    ASIA_KUWAIT = 'Asia/Kuwait',
    ASIA_MACAO = 'Asia/Macao',
    ASIA_MACAU = 'Asia/Macau',
    ASIA_MAGADAN = 'Asia/Magadan',
    ASIA_MAKASSAR = 'Asia/Makassar',
    ASIA_MANILA = 'Asia/Manila',
    ASIA_MUSCAT = 'Asia/Muscat',
    ASIA_NICOSIA = 'Asia/Nicosia',
    ASIA_NOVOKUZNETSK = 'Asia/Novokuznetsk',
    ASIA_NOVOSIBIRSK = 'Asia/Novosibirsk',
    ASIA_OMSK = 'Asia/Omsk',
    ASIA_ORAL = 'Asia/Oral',
    ASIA_PHNOM_PENH = 'Asia/Phnom_Penh',
    ASIA_PONTIANAK = 'Asia/Pontianak',
    ASIA_PYONGYANG = 'Asia/Pyongyang',
    ASIA_QATAR = 'Asia/Qatar',
    ASIA_QOSTANAY = 'Asia/Qostanay',
    ASIA_QYZYLORDA = 'Asia/Qyzylorda',
    ASIA_RANGOON = 'Asia/Rangoon',
    ASIA_RIYADH = 'Asia/Riyadh',
    ASIA_SAIGON = 'Asia/Saigon',
    ASIA_SAKHALIN = 'Asia/Sakhalin',
    ASIA_SAMARKAND = 'Asia/Samarkand',
    ASIA_SEOUL = 'Asia/Seoul',
    ASIA_SHANGHAI = 'Asia/Shanghai',
    ASIA_SINGAPORE = 'Asia/Singapore',
    ASIA_SREDNEKOLYMSK = 'Asia/Srednekolymsk',
    ASIA_TAIPEI = 'Asia/Taipei',
    ASIA_TASHKENT = 'Asia/Tashkent',
    ASIA_TBILISI = 'Asia/Tbilisi',
    ASIA_TEHRAN = 'Asia/Tehran',
    ASIA_TEL_AVIV = 'Asia/Tel_Aviv',
    ASIA_THIMBU = 'Asia/Thimbu',
    ASIA_THIMPHU = 'Asia/Thimphu',
    ASIA_TOKYO = 'Asia/Tokyo',
    ASIA_TOMSK = 'Asia/Tomsk',
    ASIA_UJUNG_PANDANG = 'Asia/Ujung_Pandang',
    ASIA_ULAANBAATAR = 'Asia/Ulaanbaatar',
    ASIA_ULAN_BATOR = 'Asia/Ulan_Bator',
    ASIA_URUMQI = 'Asia/Urumqi',
    ASIA_UST_NERA = 'Asia/Ust-Nera',
    ASIA_VIENTIANE = 'Asia/Vientiane',
    ASIA_VLADIVOSTOK = 'Asia/Vladivostok',
    ASIA_YAKUTSK = 'Asia/Yakutsk',
    ASIA_YANGON = 'Asia/Yangon',
    ASIA_YEKATERINBURG = 'Asia/Yekaterinburg',
    ASIA_YEREVAN = 'Asia/Yerevan',
    ATLANTIC_AZORES = 'Atlantic/Azores',
    ATLANTIC_BERMUDA = 'Atlantic/Bermuda',
    ATLANTIC_CANARY = 'Atlantic/Canary',
    ATLANTIC_CAPE_VERDE = 'Atlantic/Cape_Verde',
    ATLANTIC_FAEROE = 'Atlantic/Faeroe',
    ATLANTIC_FAROE = 'Atlantic/Faroe',
    ATLANTIC_JAN_MAYEN = 'Atlantic/Jan_Mayen',
    ATLANTIC_MADEIRA = 'Atlantic/Madeira',
    ATLANTIC_REYKJAVIK = 'Atlantic/Reykjavik',
    ATLANTIC_SOUTH_GEORGIA = 'Atlantic/South_Georgia',
    ATLANTIC_ST_HELENA = 'Atlantic/St_Helena',
    ATLANTIC_STANLEY = 'Atlantic/Stanley',
    AUSTRALIA_ACT = 'Australia/ACT',
    AUSTRALIA_ADELAIDE = 'Australia/Adelaide',
    AUSTRALIA_BRISBANE = 'Australia/Brisbane',
    AUSTRALIA_BROKEN_HILL = 'Australia/Broken_Hill',
    AUSTRALIA_CANBERRA = 'Australia/Canberra',
    AUSTRALIA_CURRIE = 'Australia/Currie',
    AUSTRALIA_DARWIN = 'Australia/Darwin',
    AUSTRALIA_EUCLA = 'Australia/Eucla',
    AUSTRALIA_HOBART = 'Australia/Hobart',
    AUSTRALIA_LHI = 'Australia/LHI',
    AUSTRALIA_LINDEMAN = 'Australia/Lindeman',
    AUSTRALIA_LORD_HOWE = 'Australia/Lord_Howe',
    AUSTRALIA_MELBOURNE = 'Australia/Melbourne',
    AUSTRALIA_NSW = 'Australia/NSW',
    AUSTRALIA_NORTH = 'Australia/North',
    AUSTRALIA_PERTH = 'Australia/Perth',
    AUSTRALIA_QUEENSLAND = 'Australia/Queensland',
    AUSTRALIA_SOUTH = 'Australia/South',
    AUSTRALIA_SYDNEY = 'Australia/Sydney',
    AUSTRALIA_TASMANIA = 'Australia/Tasmania',
    AUSTRALIA_VICTORIA = 'Australia/Victoria',
    AUSTRALIA_WEST = 'Australia/West',
    AUSTRALIA_YANCOWINNA = 'Australia/Yancowinna',
    BRAZIL_ACRE = 'Brazil/Acre',
    BRAZIL_DE_NORONHA = 'Brazil/DeNoronha',
    BRAZIL_EAST = 'Brazil/East',
    BRAZIL_WEST = 'Brazil/West',
    CET = 'CET',
    CST6CDT = 'CST6CDT',
    CANADA_ATLANTIC = 'Canada/Atlantic',
    CANADA_CENTRAL = 'Canada/Central',
    CANADA_EASTERN = 'Canada/Eastern',
    CANADA_MOUNTAIN = 'Canada/Mountain',
    CANADA_NEWFOUNDLAND = 'Canada/Newfoundland',
    CANADA_PACIFIC = 'Canada/Pacific',
    CANADA_SASKATCHEWAN = 'Canada/Saskatchewan',
    CANADA_YUKON = 'Canada/Yukon',
    CHILE_CONTINENTAL = 'Chile/Continental',
    CHILE_EASTER_ISLAND = 'Chile/EasterIsland',
    CUBA = 'Cuba',
    EET = 'EET',
    EST = 'EST',
    EST5EDT = 'EST5EDT',
    EGYPT = 'Egypt',
    EIRE = 'Eire',
    ETC_GMT = 'Etc/GMT',
    'ETC_GMT+0' = 'Etc/GMT+0',
    'ETC_GMT+1' = 'Etc/GMT+1',
    'ETC_GMT+10' = 'Etc/GMT+10',
    'ETC_GMT+11' = 'Etc/GMT+11',
    'ETC_GMT+12' = 'Etc/GMT+12',
    'ETC_GMT+2' = 'Etc/GMT+2',
    'ETC_GMT+3' = 'Etc/GMT+3',
    'ETC_GMT+4' = 'Etc/GMT+4',
    'ETC_GMT+5' = 'Etc/GMT+5',
    'ETC_GMT+6' = 'Etc/GMT+6',
    'ETC_GMT+7' = 'Etc/GMT+7',
    'ETC_GMT+8' = 'Etc/GMT+8',
    'ETC_GMT+9' = 'Etc/GMT+9',
    ETC_GMT_0 = 'Etc/GMT-0',
    ETC_GMT_1 = 'Etc/GMT-1',
    ETC_GMT_10 = 'Etc/GMT-10',
    ETC_GMT_11 = 'Etc/GMT-11',
    ETC_GMT_12 = 'Etc/GMT-12',
    ETC_GMT_13 = 'Etc/GMT-13',
    ETC_GMT_14 = 'Etc/GMT-14',
    ETC_GMT_2 = 'Etc/GMT-2',
    ETC_GMT_3 = 'Etc/GMT-3',
    ETC_GMT_4 = 'Etc/GMT-4',
    ETC_GMT_5 = 'Etc/GMT-5',
    ETC_GMT_6 = 'Etc/GMT-6',
    ETC_GMT_7 = 'Etc/GMT-7',
    ETC_GMT_8 = 'Etc/GMT-8',
    ETC_GMT_9 = 'Etc/GMT-9',
    ETC_GMT0 = 'Etc/GMT0',
    ETC_GREENWICH = 'Etc/Greenwich',
    ETC_UCT = 'Etc/UCT',
    ETC_UTC = 'Etc/UTC',
    ETC_UNIVERSAL = 'Etc/Universal',
    ETC_ZULU = 'Etc/Zulu',
    EUROPE_AMSTERDAM = 'Europe/Amsterdam',
    EUROPE_ANDORRA = 'Europe/Andorra',
    EUROPE_ASTRAKHAN = 'Europe/Astrakhan',
    EUROPE_ATHENS = 'Europe/Athens',
    EUROPE_BELFAST = 'Europe/Belfast',
    EUROPE_BELGRADE = 'Europe/Belgrade',
    EUROPE_BERLIN = 'Europe/Berlin',
    EUROPE_BRATISLAVA = 'Europe/Bratislava',
    EUROPE_BRUSSELS = 'Europe/Brussels',
    EUROPE_BUCHAREST = 'Europe/Bucharest',
    EUROPE_BUDAPEST = 'Europe/Budapest',
    EUROPE_BUSINGEN = 'Europe/Busingen',
    EUROPE_CHISINAU = 'Europe/Chisinau',
    EUROPE_COPENHAGEN = 'Europe/Copenhagen',
    EUROPE_DUBLIN = 'Europe/Dublin',
    EUROPE_GIBRALTAR = 'Europe/Gibraltar',
    EUROPE_GUERNSEY = 'Europe/Guernsey',
    EUROPE_HELSINKI = 'Europe/Helsinki',
    EUROPE_ISLE_OF_MAN = 'Europe/Isle_of_Man',
    EUROPE_ISTANBUL = 'Europe/Istanbul',
    EUROPE_JERSEY = 'Europe/Jersey',
    EUROPE_KALININGRAD = 'Europe/Kaliningrad',
    EUROPE_KIEV = 'Europe/Kiev',
    EUROPE_KIROV = 'Europe/Kirov',
    EUROPE_KYIV = 'Europe/Kyiv',
    EUROPE_LISBON = 'Europe/Lisbon',
    EUROPE_LJUBLJANA = 'Europe/Ljubljana',
    EUROPE_LONDON = 'Europe/London',
    EUROPE_LUXEMBOURG = 'Europe/Luxembourg',
    EUROPE_MADRID = 'Europe/Madrid',
    EUROPE_MALTA = 'Europe/Malta',
    EUROPE_MARIEHAMN = 'Europe/Mariehamn',
    EUROPE_MINSK = 'Europe/Minsk',
    EUROPE_MONACO = 'Europe/Monaco',
    EUROPE_MOSCOW = 'Europe/Moscow',
    EUROPE_NICOSIA = 'Europe/Nicosia',
    EUROPE_OSLO = 'Europe/Oslo',
    EUROPE_PARIS = 'Europe/Paris',
    EUROPE_PODGORICA = 'Europe/Podgorica',
    EUROPE_PRAGUE = 'Europe/Prague',
    EUROPE_RIGA = 'Europe/Riga',
    EUROPE_ROME = 'Europe/Rome',
    EUROPE_SAMARA = 'Europe/Samara',
    EUROPE_SAN_MARINO = 'Europe/San_Marino',
    EUROPE_SARAJEVO = 'Europe/Sarajevo',
    EUROPE_SARATOV = 'Europe/Saratov',
    EUROPE_SIMFEROPOL = 'Europe/Simferopol',
    EUROPE_SKOPJE = 'Europe/Skopje',
    EUROPE_SOFIA = 'Europe/Sofia',
    EUROPE_STOCKHOLM = 'Europe/Stockholm',
    EUROPE_TALLINN = 'Europe/Tallinn',
    EUROPE_TIRANE = 'Europe/Tirane',
    EUROPE_TIRASPOL = 'Europe/Tiraspol',
    EUROPE_ULYANOVSK = 'Europe/Ulyanovsk',
    EUROPE_UZHGOROD = 'Europe/Uzhgorod',
    EUROPE_VADUZ = 'Europe/Vaduz',
    EUROPE_VATICAN = 'Europe/Vatican',
    EUROPE_VIENNA = 'Europe/Vienna',
    EUROPE_VILNIUS = 'Europe/Vilnius',
    EUROPE_VOLGOGRAD = 'Europe/Volgograd',
    EUROPE_WARSAW = 'Europe/Warsaw',
    EUROPE_ZAGREB = 'Europe/Zagreb',
    EUROPE_ZAPOROZHYE = 'Europe/Zaporozhye',
    EUROPE_ZURICH = 'Europe/Zurich',
    GB = 'GB',
    GB_EIRE = 'GB-Eire',
    GMT = 'GMT',
    'GMT+0' = 'GMT+0',
    GMT_0 = 'GMT-0',
    GMT0 = 'GMT0',
    GREENWICH = 'Greenwich',
    HST = 'HST',
    HONGKONG = 'Hongkong',
    ICELAND = 'Iceland',
    INDIAN_ANTANANARIVO = 'Indian/Antananarivo',
    INDIAN_CHAGOS = 'Indian/Chagos',
    INDIAN_CHRISTMAS = 'Indian/Christmas',
    INDIAN_COCOS = 'Indian/Cocos',
    INDIAN_COMORO = 'Indian/Comoro',
    INDIAN_KERGUELEN = 'Indian/Kerguelen',
    INDIAN_MAHE = 'Indian/Mahe',
    INDIAN_MALDIVES = 'Indian/Maldives',
    INDIAN_MAURITIUS = 'Indian/Mauritius',
    INDIAN_MAYOTTE = 'Indian/Mayotte',
    INDIAN_REUNION = 'Indian/Reunion',
    IRAN = 'Iran',
    ISRAEL = 'Israel',
    JAMAICA = 'Jamaica',
    JAPAN = 'Japan',
    KWAJALEIN = 'Kwajalein',
    LIBYA = 'Libya',
    MET = 'MET',
    MST = 'MST',
    MST7MDT = 'MST7MDT',
    MEXICO_BAJA_NORTE = 'Mexico/BajaNorte',
    MEXICO_BAJA_SUR = 'Mexico/BajaSur',
    MEXICO_GENERAL = 'Mexico/General',
    NZ = 'NZ',
    NZ_CHAT = 'NZ-CHAT',
    NAVAJO = 'Navajo',
    PRC = 'PRC',
    PST8PDT = 'PST8PDT',
    PACIFIC_APIA = 'Pacific/Apia',
    PACIFIC_AUCKLAND = 'Pacific/Auckland',
    PACIFIC_BOUGAINVILLE = 'Pacific/Bougainville',
    PACIFIC_CHATHAM = 'Pacific/Chatham',
    PACIFIC_CHUUK = 'Pacific/Chuuk',
    PACIFIC_EASTER = 'Pacific/Easter',
    PACIFIC_EFATE = 'Pacific/Efate',
    PACIFIC_ENDERBURY = 'Pacific/Enderbury',
    PACIFIC_FAKAOFO = 'Pacific/Fakaofo',
    PACIFIC_FIJI = 'Pacific/Fiji',
    PACIFIC_FUNAFUTI = 'Pacific/Funafuti',
    PACIFIC_GALAPAGOS = 'Pacific/Galapagos',
    PACIFIC_GAMBIER = 'Pacific/Gambier',
    PACIFIC_GUADALCANAL = 'Pacific/Guadalcanal',
    PACIFIC_GUAM = 'Pacific/Guam',
    PACIFIC_HONOLULU = 'Pacific/Honolulu',
    PACIFIC_JOHNSTON = 'Pacific/Johnston',
    PACIFIC_KANTON = 'Pacific/Kanton',
    PACIFIC_KIRITIMATI = 'Pacific/Kiritimati',
    PACIFIC_KOSRAE = 'Pacific/Kosrae',
    PACIFIC_KWAJALEIN = 'Pacific/Kwajalein',
    PACIFIC_MAJURO = 'Pacific/Majuro',
    PACIFIC_MARQUESAS = 'Pacific/Marquesas',
    PACIFIC_MIDWAY = 'Pacific/Midway',
    PACIFIC_NAURU = 'Pacific/Nauru',
    PACIFIC_NIUE = 'Pacific/Niue',
    PACIFIC_NORFOLK = 'Pacific/Norfolk',
    PACIFIC_NOUMEA = 'Pacific/Noumea',
    PACIFIC_PAGO_PAGO = 'Pacific/Pago_Pago',
    PACIFIC_PALAU = 'Pacific/Palau',
    PACIFIC_PITCAIRN = 'Pacific/Pitcairn',
    PACIFIC_POHNPEI = 'Pacific/Pohnpei',
    PACIFIC_PONAPE = 'Pacific/Ponape',
    PACIFIC_PORT_MORESBY = 'Pacific/Port_Moresby',
    PACIFIC_RAROTONGA = 'Pacific/Rarotonga',
    PACIFIC_SAIPAN = 'Pacific/Saipan',
    PACIFIC_SAMOA = 'Pacific/Samoa',
    PACIFIC_TAHITI = 'Pacific/Tahiti',
    PACIFIC_TARAWA = 'Pacific/Tarawa',
    PACIFIC_TONGATAPU = 'Pacific/Tongatapu',
    PACIFIC_TRUK = 'Pacific/Truk',
    PACIFIC_WAKE = 'Pacific/Wake',
    PACIFIC_WALLIS = 'Pacific/Wallis',
    PACIFIC_YAP = 'Pacific/Yap',
    POLAND = 'Poland',
    PORTUGAL = 'Portugal',
    ROC = 'ROC',
    ROK = 'ROK',
    SINGAPORE = 'Singapore',
    TURKEY = 'Turkey',
    UCT = 'UCT',
    US_ALASKA = 'US/Alaska',
    US_ALEUTIAN = 'US/Aleutian',
    US_ARIZONA = 'US/Arizona',
    US_CENTRAL = 'US/Central',
    US_EAST_INDIANA = 'US/East-Indiana',
    US_EASTERN = 'US/Eastern',
    US_HAWAII = 'US/Hawaii',
    US_INDIANA_STARKE = 'US/Indiana-Starke',
    US_MICHIGAN = 'US/Michigan',
    US_MOUNTAIN = 'US/Mountain',
    US_PACIFIC = 'US/Pacific',
    US_SAMOA = 'US/Samoa',
    UTC = 'UTC',
    UNIVERSAL = 'Universal',
    W_SU = 'W-SU',
    WET = 'WET',
    ZULU = 'Zulu'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type Tracking = {
    readonly id: string;
    trackingNumber?: string;
    courier?: string;
    clientKey?: string;
    orderNumber?: string;
    orderDate?: string | null;
    recipientPostalCode?: string;
    destinationCountryIso3?: string;
    languageIso2?: string;
    timezone?: string;
    courierServiceLevel?: string;
    /**
     * Delivery method (e.g. 'standard shipping'), needs to be set up in the system
     */
    deliveryMethod?: string;
    shippingAddress?: {
        [key: string]: unknown;
    } | null;
    recipientEmail?: string;
    recipientName?: string;
    recipientStreet?: string;
    recipientCity?: string;
    recipientRegion?: string;
    recipientPhone?: string;
    cancelledDate?: string | null;
    /**
     * Is a return tracking or pre-generated return label
     */
    isReturn?: boolean;
    externalReference?: string;
    identifiersConsignment?: string;
    deliveryNumber?: string;
    /**
     * Transport number, if part of a transport, e.g. freight or injection
     */
    transportNumber?: string;
    requiresSignature?: boolean | null;
    isDropshipment?: boolean;
    originCountryIso3?: string;
    originRegion?: string;
    originPostalCode?: string;
    articles?: {
        [key: string]: unknown;
    };
    articlesOpen?: {
        [key: string]: unknown;
    };
    articlesOrder?: {
        [key: string]: unknown;
    };
    warehouse?: string;
    customerNumber?: string;
    invoiceNumber?: string;
    paymentMethod?: string;
    courierContactName?: string;
    courierContactPhone?: string;
    courierContactEmail?: string;
    reviewLink?: string;
    statusLink?: string;
    supportPhone?: string;
    collectionCodeCarrier?: string;
    announcedSendDate?: string | null;
    announcedDeliveryDate?: string | null;
    announcedDeliveryDateMin?: string | null;
    announcedDeliveryDateMax?: string | null;
    notificationsInactive?: boolean | null;
    flags?: {
        [key: string]: unknown;
    } | null;
    tags?: {
        [key: string]: unknown;
    };
    cashOnDeliveryAmount?: string;
    readonly createdAt: string;
    activityMonitorLastUpdate?: string | null;
    activityMonitorCurrentStage?: TrackingStageChoices;
    activityMonitorCurrentDeliveryStatus?: string;
    activityMonitorDelayedAt?: string | null;
    activityMonitorEscalatedAt?: string | null;
    numberOfParcels?: number | null;
    isDoorstepDelivery?: boolean;
    isBranchDelivery?: boolean;
    channel?: string;
    courierChangeUrl?: string;
    podIdentifier?: string;
    podSignature?: string;
    podDate?: string;
    /**
     * Date when shipment was picked up by the carrier (account dependent)
     */
    reportingPickupDate?: string | null;
    /**
     * Date when shipment was sorted by the carrier in their hub
     */
    reportingInTransitDate?: string | null;
    /**
     * Date when delivery was first attempted by courier
     */
    reportingCourierDropoffDate?: string | null;
    /**
     * Date when shipment was delivered
     */
    reportingDeliveryDate?: string | null;
    /**
     * parcelLab Returns Portal
     */
    isReturnsPortal?: boolean;
    /**
     * Security hash for this tracking
     */
    securityHash: string;
    /**
     * Total cost of shipping
     */
    shippingCostTotal?: string | null;
    /**
     * Net amount for shipping
     */
    shippingCostNet?: string | null;
    /**
     * Discount amount for shipping
     */
    shippingCostDiscount?: string | null;
    importSourceMeta?: {
        [key: string]: unknown;
    };
    account: number;
    order?: number | null;
};

export enum TrackingStageChoices {
    PENDING = 'Pending',
    TRANSIT = 'Transit',
    CUSTOMS = 'Customs',
    LAST_MILE = 'LastMile',
    READY_TO_COLLECT = 'ReadyToCollect',
    DELIVERED = 'Delivered',
    SENT_BACK = 'SentBack',
    RETURNED = 'Returned',
    FAILED = 'Failed',
    CANCELLED = 'Cancelled'
}

export type TranslationDetails = {
    highRating: string | unknown;
    lowRating: string | unknown;
    question: string | unknown;
};

/**
 * Adds nested create feature
 */
export type TrendingDelayActivationConfig = {
    readonly id: number;
    courier: number;
    courierKey: string;
    excludedCheckpoints: Array<ReferenceItem>;
};

/**
 * Adds nested create feature
 */
export type TrendingDelayActivationConfigRequest = {
    courier: number;
    courierKey: string;
    excludedCheckpoints: Array<ReferenceItemRequest>;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type TrendingDelayConfiguration = {
    readonly id: number;
    account: number;
    client?: number | null;
    /**
     * Unique identifier to distinguish between trackings on accounts with multiple brands
     */
    readonly clientKey: string;
    /**
     * Warning threshold probability, in percent
     */
    probabilityThresholdWarning?: number;
    /**
     * Delayed threshold probability, in percent
     */
    probabilityThresholdDelayed?: number;
    activationConfigs: Array<TrendingDelayActivationConfig>;
    readonly updatedAt: string;
};

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type TrendingDelayConfigurationRequest = {
    account: number;
    client?: number | null;
    /**
     * Warning threshold probability, in percent
     */
    probabilityThresholdWarning?: number;
    /**
     * Delayed threshold probability, in percent
     */
    probabilityThresholdDelayed?: number;
    activationConfigs: Array<TrendingDelayActivationConfigRequest>;
};

/**
 * * `email` - Mail
 * * `sms` - Sms
 * * `webhook` - Webhook
 * * `slot` - Slot
 * * `kafka` - Kafka
 */
export enum TriggerChannelTypeChoices {
    EMAIL = 'email',
    SMS = 'sms',
    WEBHOOK = 'webhook',
    SLOT = 'slot',
    KAFKA = 'kafka'
}

export enum UnitEnum {
    KM = 'km',
    MI = 'mi'
}

/**
 * Update the status of a return registration
 */
export type UpdateReturnRegistrationStatusRequest = {
    /**
     * The status to set for the return registration
     *
     * * `rejected` - rejected
     * * `approved` - approved
     */
    status: UpdateReturnRegistrationStatusStatusEnum;
    /**
     * Reason for the current status
     */
    statusReason?: string;
};

/**
 * * `rejected` - rejected
 * * `approved` - approved
 */
export enum UpdateReturnRegistrationStatusStatusEnum {
    REJECTED = 'rejected',
    APPROVED = 'approved'
}

export type User = {
    readonly id: number;
    readonly email: string;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     */
    readonly username: string;
    /**
     * The account IDs, this model is associated with
     */
    readonly accounts: Array<number>;
    readonly permissions: Array<string>;
    jobTitle?: string;
    phoneNumber?: string;
    hasMarketingOptIn?: boolean;
    profileRole?: ProfileRoleEnum;
    /**
     * Has early access to new features (should be used internally, unless otherwise confirmed with Product Owners)
     */
    hasPreviewFeatures?: boolean;
};

export type UserFeatureFlag = {
    readonly accounts: Array<Account>;
    /**
     * Uses new track & comms module by default
     */
    hasPortalBetaEnabled?: boolean;
    /**
     * Has early access to new features (should be used internally, unless otherwise confirmed with Product Owners)
     */
    hasPreviewFeatures?: boolean;
    readonly roles: Array<string>;
    readonly groups: Array<string>;
};

export type UserFeatureFlagRequest = {
    /**
     * Uses new track & comms module by default
     */
    hasPortalBetaEnabled?: boolean;
    /**
     * Has early access to new features (should be used internally, unless otherwise confirmed with Product Owners)
     */
    hasPreviewFeatures?: boolean;
};

export type UserFeedback = {
    readonly id: number;
    type: UserFeedbackTypeEnum;
    text: string;
    url?: string;
    screenshot?: string | null;
    urgent?: boolean;
    readonly created_at: string;
};

export type UserFeedbackRequest = {
    type: UserFeedbackTypeEnum;
    text: string;
    url?: string;
    screenshot?: (Blob | File) | null;
    urgent?: boolean;
};

/**
 * * `idea` - 💡 Idea
 * * `bug` - 🐞 Bug
 * * `other` - 💭 Other
 */
export enum UserFeedbackTypeEnum {
    IDEA = 'idea',
    BUG = 'bug',
    OTHER = 'other'
}

export type UserRequest = {
    password: string;
    jobTitle?: string;
    phoneNumber?: string;
    hasMarketingOptIn?: boolean;
    profileRole?: ProfileRoleEnum;
    /**
     * Has early access to new features (should be used internally, unless otherwise confirmed with Product Owners)
     */
    hasPreviewFeatures?: boolean;
};

export type UserSettings = {
    readonly email: string;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     */
    readonly username: string;
    firstName?: string;
    lastName?: string;
    userLocale?: string;
    /**
     * The account IDs, this model is associated with
     */
    readonly accounts: Array<number>;
    readonly groups: Array<string>;
    readonly roles: Array<string>;
    readonly permissions: Array<string>;
    /**
     * Uses new track & comms module by default
     */
    hasPortalBetaEnabled?: boolean;
    portalSettings?: {
        [key: string]: unknown;
    };
    jobTitle?: string;
    phoneNumber?: string;
    hasMarketingOptIn?: boolean;
    profileRole?: ProfileRoleEnum;
    /**
     * Indicates if all required user profile fields have been filled out.
     */
    profileCompleted?: boolean;
    /**
     * Has early access to new features (should be used internally, unless otherwise confirmed with Product Owners)
     */
    readonly hasPreviewFeatures: boolean;
    /**
     * Generate a JWT for Zendesk widget authentication.
     * The JWT claims contain the user's name, and email, beside the mandatory Zendesk claims.
     * Because of security, it is valid for a limited time, this means if a renewal is needed,
     * then this endpoint should be called again to get a new JWT.
     * The official documentation can be found in https://developer.zendesk.com/documentation/zendesk-web-widget-sdks/sdks/web/enabling_auth_visitors/
     */
    readonly zendeskJwt: string | null;
};

export type UserSettingsRequest = {
    firstName?: string;
    lastName?: string;
    userLocale?: string;
    /**
     * Uses new track & comms module by default
     */
    hasPortalBetaEnabled?: boolean;
    portalSettings?: {
        [key: string]: unknown;
    };
    jobTitle?: string;
    phoneNumber?: string;
    hasMarketingOptIn?: boolean;
    profileRole?: ProfileRoleEnum;
    /**
     * Indicates if all required user profile fields have been filled out.
     */
    profileCompleted?: boolean;
};

export type ValidateResponse = {
    token: string;
};

/**
 * * `select` - select
 * * `multiselect` - multiselect
 * * `checkbox` - checkbox
 * * `radio` - radio
 * * `textarea` - textarea
 * * `switch` - switch
 */
export enum ValueEditorTypeEnum {
    SELECT = 'select',
    MULTISELECT = 'multiselect',
    CHECKBOX = 'checkbox',
    RADIO = 'radio',
    TEXTAREA = 'textarea',
    SWITCH = 'switch'
}

/**
 * * `A` - Variant A
 * * `B` - Variant B
 */
export enum VariantLabelEnum {
    A = 'A',
    B = 'B'
}

export enum Version5F5Enum {
    V2 = 'v2',
    V1 = 'v1'
}

/**
 * * `triggers` - Waiting for the triggers
 * * `statics` - Waiting for the statics [NOT IMPLEMENTED]
 * * `users` - Waiting for the users [NOT IMPLEMENTED]
 */
export enum WaitingForMigrationEnum {
    TRIGGERS = 'triggers',
    STATICS = 'statics',
    USERS = 'users'
}

/**
 * Adds nested create feature
 */
export type Warehouse = {
    readonly id: number;
    account: number;
    /**
     * Pretty name for the warehouse
     */
    name: string;
    /**
     * Unique ID for the warehouse, can be used for API calls
     */
    key: string;
    /**
     * List of alternative warehouse codes used in retailer systems, can be used for API calls<br /><b>Important:</b> Needs to list all alternative spellings of the same warehouse in Redshift/trackings/delivery_info_warehoue
     */
    aliases?: Array<string>;
    country: CountriesIso3166Enum;
    region: RegionEnum;
    zip: string;
    timezone?: TimezoneEnum;
    /**
     * If set to true, this warehouse will be used as origin location for all trackings without a specified warehouse<br /><b>Caution:</b>Should only be set once per account
     */
    isDefaultWarehouse?: boolean;
    /**
     * If true, bank holidays in region of warehouse will not be counted as working days
     */
    observeHolidays?: boolean;
    specialDays?: Array<SpecialDay>;
};

export type WarehouseHandlingTimeValue = {
    action: PromiseRuleChoices;
    type?: string;
    value?: number;
};

/**
 * Adds nested create feature
 */
export type WarehouseRequest = {
    account: number;
    /**
     * Pretty name for the warehouse
     */
    name: string;
    /**
     * Unique ID for the warehouse, can be used for API calls
     */
    key: string;
    /**
     * List of alternative warehouse codes used in retailer systems, can be used for API calls<br /><b>Important:</b> Needs to list all alternative spellings of the same warehouse in Redshift/trackings/delivery_info_warehoue
     */
    aliases?: Array<string>;
    country: CountriesIso3166Enum;
    region: RegionEnum;
    zip: string;
    timezone?: TimezoneEnum;
    /**
     * If set to true, this warehouse will be used as origin location for all trackings without a specified warehouse<br /><b>Caution:</b>Should only be set once per account
     */
    isDefaultWarehouse?: boolean;
    /**
     * If true, bank holidays in region of warehouse will not be counted as working days
     */
    observeHolidays?: boolean;
    specialDays?: Array<SpecialDayRequest>;
};

export type WebhookResponse = {
    request: {
        [key: string]: unknown;
    };
    response?: {
        [key: string]: unknown;
    };
};

export type WebhookTestRequestRequest = {
    /**
     * Tracking ID for the message
     */
    tracking_id?: string;
    /**
     * Event type for the message
     *
     * * `OrderCreated` - Order Created
     * * `OrderUpdated` - Order Updated
     * * `TrackingCreated` - Tracking Created
     * * `TrackingUpdated` - Tracking Updated
     * * `DeliveryStatus` - Delivery Status
     * * `DelayedDispatch` - Delayed Dispatch
     * * `LeadTimeExceeded` - Lead Time Exceeded
     * * `Invalid` - Invalid
     * * `Forgotten` - Forgotten
     * * `Dispatch` - Dispatch
     * * `Scheduled` - Scheduled
     * * `FailedAttempt` - Failed Attempt
     * * `Exception` - Exception
     * * `Delay` - Delay
     * * `Escalation` - Escalation
     * * `ReturnWarning` - Return Warning
     * * `MissingUpdates` - Missing Updates
     * * `Return` - Return
     * * `PickupReady` - Pickup Ready
     * * `Delivered` - Delivered
     * * `CustomerPromiseExceeded` - Customer Promise Exceeded
     * * `TimeWindowMissed` - Time Window Missed
     */
    event_type?: EventTypeEnum;
    /**
     * Integration ID for the webhook
     */
    integration_id: number;
    /**
     * Preview the webhook
     */
    preview?: boolean;
};

export enum WeightUnitEnum {
    KG = 'kg',
    G = 'g',
    LBS = 'lbs'
}

/**
 * Abstract base class for generic types.
 *
 * On Python 3.12 and newer, generic classes implicitly inherit from
 * Generic when they declare a parameter list after the class's name::
 *
 * class Mapping[KT, VT]:
 * def __getitem__(self, key: KT) -> VT:
 * ...
 * # Etc.
 *
 * On older versions of Python, however, generic classes have to
 * explicitly inherit from Generic.
 *
 * After a class has been declared to be generic, it can then be used as
 * follows::
 *
 * def lookup_name[KT, VT](mapping: Mapping[KT, VT], key: KT, default: VT) -> VT:
 * try:
 * return mapping[key]
 * except KeyError:
 * return default
 */
export type WhiteLabelDomainConfig = {
    readonly id: number;
    readonly accountId: number;
    archived?: boolean;
    domain: string;
    includesAttachments?: boolean;
    isApiVerified?: boolean;
    isCdnVerified?: boolean;
    readonly isDkimVerified: boolean;
    isMxVerified?: boolean;
    isSpfVerified?: boolean;
    isSuperWhitelabel?: boolean;
    readonly isDmarcVerified: boolean;
};

export type WhiteListedDomainBulkCreateResponse = {
    account?: string;
    domains: Array<string>;
    type: WhitelistedDomainTypeChoices;
    status?: DomainStatusChoices;
    invalid_domains: Array<string>;
};

export type WhitelistCheckResponse = {
    domain: string;
    type: WhitelistedDomainTypeChoices;
    isWhitelisted: boolean;
    status: DomainStatusChoices;
};

export type WhitelistedDomain = {
    account?: number;
    domain: string;
    type?: WhitelistedDomainTypeChoices;
};

export type WhitelistedDomainBulkCreateRequest = {
    account?: string;
    domains: Array<string>;
    type: WhitelistedDomainTypeChoices;
    status?: DomainStatusChoices;
};

export type WhitelistedDomainRequest = {
    account?: number;
    domain: string;
    type?: WhitelistedDomainTypeChoices;
};

export enum WhitelistedDomainTypeChoices {
    OUTBOUND_EMAIL = 'outbound_email',
    RETURNS_PLUGIN = 'returns_plugin'
}

export type WorkingDaysSchemaType = {
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
    saturday?: boolean;
    sunday?: boolean;
};

export type ZenloopSurveyDetails = {
    NpsTags?: string | unknown;
    shopToken?: string | unknown;
    translation: {
        [key: string]: TranslationDetails;
    };
};

export type AccountAccountsListData = {
    body?: never;
    path?: never;
    query?: {
        archived?: boolean;
        id?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        name?: string;
        /**
         * Ordering
         *
         * * `name` - Name
         * * `-name` - Name (descending)
         * * `pretty_name` - Pretty name
         * * `-pretty_name` - Pretty name (descending)
         * * `parent_id` - Parent id
         * * `-parent_id` - Parent id (descending)
         */
        o?: Array<'-name' | '-parent_id' | '-pretty_name' | 'name' | 'parent_id' | 'pretty_name'>;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Search
         */
        search?: string;
    };
    url: '/v3/account/accounts/';
};

export type AccountAccountsListResponses = {
    200: PaginatedAccountList;
};

export type AccountAccountsListResponse = AccountAccountsListResponses[keyof AccountAccountsListResponses];

export type AccountAccountsCreateData = {
    body: AccountRequest;
    path?: never;
    query?: never;
    url: '/v3/account/accounts/';
};

export type AccountAccountsCreateResponses = {
    201: Account;
};

export type AccountAccountsCreateResponse = AccountAccountsCreateResponses[keyof AccountAccountsCreateResponses];

export type AccountAccountsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Account.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/accounts/{id}/';
};

export type AccountAccountsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AccountAccountsDestroyResponse = AccountAccountsDestroyResponses[keyof AccountAccountsDestroyResponses];

export type AccountAccountsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Account.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/accounts/{id}/';
};

export type AccountAccountsRetrieveResponses = {
    200: Account;
};

export type AccountAccountsRetrieveResponse = AccountAccountsRetrieveResponses[keyof AccountAccountsRetrieveResponses];

export type AccountAccountsPartialUpdateData = {
    body?: PatchedAccountRequest;
    path: {
        /**
         * A unique integer value identifying this Account.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/accounts/{id}/';
};

export type AccountAccountsPartialUpdateResponses = {
    200: Account;
};

export type AccountAccountsPartialUpdateResponse = AccountAccountsPartialUpdateResponses[keyof AccountAccountsPartialUpdateResponses];

export type AccountAccountsUpdateData = {
    body: AccountRequest;
    path: {
        /**
         * A unique integer value identifying this Account.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/accounts/{id}/';
};

export type AccountAccountsUpdateResponses = {
    200: Account;
};

export type AccountAccountsUpdateResponse = AccountAccountsUpdateResponses[keyof AccountAccountsUpdateResponses];

export type AccountAccountsOptInsUpdateData = {
    body?: AccountOptInsRequest;
    path: {
        /**
         * A unique integer value identifying this Account.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/accounts/{id}/opt-ins/';
};

export type AccountAccountsOptInsUpdateResponses = {
    200: AccountOptIns;
};

export type AccountAccountsOptInsUpdateResponse = AccountAccountsOptInsUpdateResponses[keyof AccountAccountsOptInsUpdateResponses];

export type AccountUsersListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
    };
    url: '/v3/account/users/';
};

export type AccountUsersListResponses = {
    200: PaginatedUserList;
};

export type AccountUsersListResponse = AccountUsersListResponses[keyof AccountUsersListResponses];

export type AccountUsersCreateData = {
    body: UserRequest;
    path?: never;
    query?: never;
    url: '/v3/account/users/';
};

export type AccountUsersCreateResponses = {
    201: User;
};

export type AccountUsersCreateResponse = AccountUsersCreateResponses[keyof AccountUsersCreateResponses];

export type AccountUsersRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this User.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/users/{id}/';
};

export type AccountUsersRetrieveResponses = {
    200: User;
};

export type AccountUsersRetrieveResponse = AccountUsersRetrieveResponses[keyof AccountUsersRetrieveResponses];

export type AccountUsersPartialUpdateData = {
    body?: PatchedUserRequest;
    path: {
        /**
         * A unique integer value identifying this User.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/users/{id}/';
};

export type AccountUsersPartialUpdateResponses = {
    200: User;
};

export type AccountUsersPartialUpdateResponse = AccountUsersPartialUpdateResponses[keyof AccountUsersPartialUpdateResponses];

export type AccountUsersUpdateData = {
    body: UserRequest;
    path: {
        /**
         * A unique integer value identifying this User.
         */
        id: number;
    };
    query?: never;
    url: '/v3/account/users/{id}/';
};

export type AccountUsersUpdateResponses = {
    200: User;
};

export type AccountUsersUpdateResponse = AccountUsersUpdateResponses[keyof AccountUsersUpdateResponses];

export type AccountUsersFeatureFlagsRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        API_KEY?: string;
        email?: string;
    };
    url: '/v3/account/users/feature-flags/';
};

export type AccountUsersFeatureFlagsRetrieveResponses = {
    200: UserFeatureFlag;
};

export type AccountUsersFeatureFlagsRetrieveResponse = AccountUsersFeatureFlagsRetrieveResponses[keyof AccountUsersFeatureFlagsRetrieveResponses];

export type AccountUsersFeatureFlagsCreateData = {
    body?: UserFeatureFlagRequest;
    path?: never;
    query?: {
        API_KEY?: string;
        email?: string;
    };
    url: '/v3/account/users/feature-flags/';
};

export type AccountUsersFeatureFlagsCreateResponses = {
    200: UserFeatureFlag;
};

export type AccountUsersFeatureFlagsCreateResponse = AccountUsersFeatureFlagsCreateResponses[keyof AccountUsersFeatureFlagsCreateResponses];

export type AccountUsersMeRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v3/account/users/me/';
};

export type AccountUsersMeRetrieveResponses = {
    200: UserSettings;
};

export type AccountUsersMeRetrieveResponse = AccountUsersMeRetrieveResponses[keyof AccountUsersMeRetrieveResponses];

export type AccountUsersMePartialUpdateData = {
    body?: PatchedUserSettingsRequest;
    path?: never;
    query?: never;
    url: '/v3/account/users/me/';
};

export type AccountUsersMePartialUpdateResponses = {
    200: UserSettings;
};

export type AccountUsersMePartialUpdateResponse = AccountUsersMePartialUpdateResponses[keyof AccountUsersMePartialUpdateResponses];

export type AccountUsersMeCreateData = {
    body?: UserSettingsRequest;
    path?: never;
    query?: never;
    url: '/v3/account/users/me/';
};

export type AccountUsersMeCreateResponses = {
    200: UserSettings;
};

export type AccountUsersMeCreateResponse = AccountUsersMeCreateResponses[keyof AccountUsersMeCreateResponses];

export type AccountUsersValidateCreateData = {
    body: SigninRequestRequest;
    path?: never;
    query?: never;
    url: '/v3/account/users/validate/';
};

export type AccountUsersValidateCreateResponses = {
    200: ValidateResponse;
};

export type AccountUsersValidateCreateResponse = AccountUsersValidateCreateResponses[keyof AccountUsersValidateCreateResponses];

export type AgentsSimpleAgentThreadsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/agents/simple-agent-threads/';
};

export type AgentsSimpleAgentThreadsListResponses = {
    200: PaginatedSimpleAgentThreadListList;
};

export type AgentsSimpleAgentThreadsListResponse = AgentsSimpleAgentThreadsListResponses[keyof AgentsSimpleAgentThreadsListResponses];

export type AgentsSimpleAgentThreadsCreateData = {
    body: SimpleAgentThreadCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/agents/simple-agent-threads/';
};

export type AgentsSimpleAgentThreadsCreateResponses = {
    201: SimpleAgentThreadDetail;
};

export type AgentsSimpleAgentThreadsCreateResponse = AgentsSimpleAgentThreadsCreateResponses[keyof AgentsSimpleAgentThreadsCreateResponses];

export type AgentsSimpleAgentThreadsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Simple Agent Thread.
         */
        id: number;
    };
    query?: never;
    url: '/v3/agents/simple-agent-threads/{id}/';
};

export type AgentsSimpleAgentThreadsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AgentsSimpleAgentThreadsDestroyResponse = AgentsSimpleAgentThreadsDestroyResponses[keyof AgentsSimpleAgentThreadsDestroyResponses];

export type AgentsSimpleAgentThreadsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Simple Agent Thread.
         */
        id: number;
    };
    query?: never;
    url: '/v3/agents/simple-agent-threads/{id}/';
};

export type AgentsSimpleAgentThreadsRetrieveResponses = {
    200: SimpleAgentThreadDetail;
};

export type AgentsSimpleAgentThreadsRetrieveResponse = AgentsSimpleAgentThreadsRetrieveResponses[keyof AgentsSimpleAgentThreadsRetrieveResponses];

export type AgentsSimpleAgentThreadsPartialUpdateData = {
    body?: PatchedSimpleAgentAddMessageRequest;
    path: {
        /**
         * A unique integer value identifying this Simple Agent Thread.
         */
        id: number;
    };
    query?: never;
    url: '/v3/agents/simple-agent-threads/{id}/';
};

export type AgentsSimpleAgentThreadsPartialUpdateResponses = {
    200: SimpleAgentThreadDetail;
};

export type AgentsSimpleAgentThreadsPartialUpdateResponse = AgentsSimpleAgentThreadsPartialUpdateResponses[keyof AgentsSimpleAgentThreadsPartialUpdateResponses];

export type AgentsSimpleAgentThreadsUpdateData = {
    body: SimpleAgentAddMessageRequest;
    path: {
        /**
         * A unique integer value identifying this Simple Agent Thread.
         */
        id: number;
    };
    query?: never;
    url: '/v3/agents/simple-agent-threads/{id}/';
};

export type AgentsSimpleAgentThreadsUpdateResponses = {
    200: SimpleAgentThreadDetail;
};

export type AgentsSimpleAgentThreadsUpdateResponse = AgentsSimpleAgentThreadsUpdateResponses[keyof AgentsSimpleAgentThreadsUpdateResponses];

export type AgentsSimpleAgentsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/agents/simple-agents/';
};

export type AgentsSimpleAgentsListResponses = {
    200: PaginatedSimpleAgentList;
};

export type AgentsSimpleAgentsListResponse = AgentsSimpleAgentsListResponses[keyof AgentsSimpleAgentsListResponses];

export type AgentsSimpleAgentsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Simple Agent.
         */
        id: number;
    };
    query?: never;
    url: '/v3/agents/simple-agents/{id}/';
};

export type AgentsSimpleAgentsRetrieveResponses = {
    200: SimpleAgent;
};

export type AgentsSimpleAgentsRetrieveResponse = AgentsSimpleAgentsRetrieveResponses[keyof AgentsSimpleAgentsRetrieveResponses];

export type AnalyticsFeedbackCreateData = {
    body: UserFeedbackRequest;
    path?: never;
    query?: never;
    url: '/v3/analytics/feedback/';
};

export type AnalyticsFeedbackCreateResponses = {
    201: UserFeedback;
};

export type AnalyticsFeedbackCreateResponse = AnalyticsFeedbackCreateResponses[keyof AnalyticsFeedbackCreateResponses];

export type AnalyticsSurveyListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/analytics/survey/';
};

export type AnalyticsSurveyListResponses = {
    200: PaginatedSurveyList;
};

export type AnalyticsSurveyListResponse = AnalyticsSurveyListResponses[keyof AnalyticsSurveyListResponses];

export type AnalyticsSurveyCreateData = {
    body: SurveyRequest;
    path?: never;
    query?: never;
    url: '/v3/analytics/survey/';
};

export type AnalyticsSurveyCreateResponses = {
    201: Survey;
};

export type AnalyticsSurveyCreateResponse = AnalyticsSurveyCreateResponses[keyof AnalyticsSurveyCreateResponses];

export type AnalyticsSurveyDestroyData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: never;
    url: '/v3/analytics/survey/{id}/';
};

export type AnalyticsSurveyDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AnalyticsSurveyDestroyResponse = AnalyticsSurveyDestroyResponses[keyof AnalyticsSurveyDestroyResponses];

export type AnalyticsSurveyRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: never;
    url: '/v3/analytics/survey/{id}/';
};

export type AnalyticsSurveyRetrieveResponses = {
    200: Survey;
};

export type AnalyticsSurveyRetrieveResponse = AnalyticsSurveyRetrieveResponses[keyof AnalyticsSurveyRetrieveResponses];

export type AnalyticsSurveyPartialUpdateData = {
    body?: PatchedSurveyRequest;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: never;
    url: '/v3/analytics/survey/{id}/';
};

export type AnalyticsSurveyPartialUpdateResponses = {
    200: Survey;
};

export type AnalyticsSurveyPartialUpdateResponse = AnalyticsSurveyPartialUpdateResponses[keyof AnalyticsSurveyPartialUpdateResponses];

export type AnalyticsSurveyUpdateData = {
    body: SurveyRequest;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: never;
    url: '/v3/analytics/survey/{id}/';
};

export type AnalyticsSurveyUpdateResponses = {
    200: Survey;
};

export type AnalyticsSurveyUpdateResponse = AnalyticsSurveyUpdateResponses[keyof AnalyticsSurveyUpdateResponses];

export type AnalyticsSurveyAiAnalysisListData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/analytics/survey/{id}/ai-analysis/';
};

export type AnalyticsSurveyAiAnalysisListResponses = {
    200: PaginatedSurveyAiAnalysisList;
};

export type AnalyticsSurveyAiAnalysisListResponse = AnalyticsSurveyAiAnalysisListResponses[keyof AnalyticsSurveyAiAnalysisListResponses];

export type AnalyticsSurveyPrepareEmailContentRetrieveData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query: {
        /**
         * Account associated with the survey
         */
        account: number;
    };
    url: '/v3/analytics/survey/{id}/prepare-email-content/';
};

export type AnalyticsSurveyPrepareEmailContentRetrieveResponses = {
    200: SurveyEmail;
};

export type AnalyticsSurveyPrepareEmailContentRetrieveResponse = AnalyticsSurveyPrepareEmailContentRetrieveResponses[keyof AnalyticsSurveyPrepareEmailContentRetrieveResponses];

export type AnalyticsSurveyPublishCreateData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: never;
    url: '/v3/analytics/survey/{id}/publish/';
};

export type AnalyticsSurveyPublishCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AnalyticsSurveyPublishCreateResponse = AnalyticsSurveyPublishCreateResponses[keyof AnalyticsSurveyPublishCreateResponses];

export type AnalyticsSurveyResultsListData = {
    body?: never;
    path: {
        /**
         * A UUID string identifying this Survey.
         */
        id: string;
    };
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/analytics/survey/{id}/results/';
};

export type AnalyticsSurveyResultsListResponses = {
    200: PaginatedSurveyAnswerList;
};

export type AnalyticsSurveyResultsListResponse = AnalyticsSurveyResultsListResponses[keyof AnalyticsSurveyResultsListResponses];

export type AppsAppsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        has_released_version?: boolean;
        is_official?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        runtime?: string;
        /**
         * type
         */
        type?: string;
    };
    url: '/v3/apps/apps/';
};

export type AppsAppsListResponses = {
    200: PaginatedCustomAppUpdateList;
};

export type AppsAppsListResponse = AppsAppsListResponses[keyof AppsAppsListResponses];

export type AppsAppsCreateData = {
    body: CustomAppCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/apps/apps/';
};

export type AppsAppsCreateResponses = {
    201: CustomAppCreate;
};

export type AppsAppsCreateResponse = AppsAppsCreateResponses[keyof AppsAppsCreateResponses];

export type AppsAppsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/apps/{id}/';
};

export type AppsAppsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AppsAppsDestroyResponse = AppsAppsDestroyResponses[keyof AppsAppsDestroyResponses];

export type AppsAppsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/apps/{id}/';
};

export type AppsAppsRetrieveResponses = {
    200: CustomAppUpdate;
};

export type AppsAppsRetrieveResponse = AppsAppsRetrieveResponses[keyof AppsAppsRetrieveResponses];

export type AppsAppsPartialUpdateData = {
    body?: PatchedCustomAppUpdateRequest;
    path: {
        /**
         * A unique integer value identifying this App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/apps/{id}/';
};

export type AppsAppsPartialUpdateResponses = {
    200: CustomAppUpdate;
};

export type AppsAppsPartialUpdateResponse = AppsAppsPartialUpdateResponses[keyof AppsAppsPartialUpdateResponses];

export type AppsAppsUpdateData = {
    body: CustomAppUpdateRequest;
    path: {
        /**
         * A unique integer value identifying this App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/apps/{id}/';
};

export type AppsAppsUpdateResponses = {
    200: CustomAppUpdate;
};

export type AppsAppsUpdateResponse = AppsAppsUpdateResponses[keyof AppsAppsUpdateResponses];

export type AppsDeploymentsListData = {
    body?: never;
    path?: never;
    query: {
        account: Array<number>;
        /**
         * * `outbound` - Outbound Template
         * * `event_processor` - Event Processor
         * * `tracking_enhancement` - Tracking Enhancement
         * * `payload_rewrite` - Payload Rewrites
         * * `order_status_plugin` - Order Status Page Plugin
         * * `noop` - No-op
         */
        app_type?: 'event_processor' | 'noop' | 'order_status_plugin' | 'outbound' | 'payload_rewrite' | 'tracking_enhancement';
        /**
         * * `preview` - Preview
         * * `test` - Test
         * * `live` - Live
         */
        kind?: 'live' | 'preview' | 'test';
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * * `deployed` - Deployed
         * * `failed` - Failed
         * * `active` - Active
         */
        status?: 'active' | 'deployed' | 'failed';
    };
    url: '/v3/apps/deployments/';
};

export type AppsDeploymentsListResponses = {
    200: PaginatedAppDeploymentList;
};

export type AppsDeploymentsListResponse = AppsDeploymentsListResponses[keyof AppsDeploymentsListResponses];

export type AppsDeploymentsInvokeCreateData = {
    body: AppDeploymentInvocationRequestRequest;
    path?: never;
    query: {
        account: number;
        /**
         * * `payload_rewrite` - payload_rewrite
         */
        app_type: 'payload_rewrite';
        /**
         * * `preview` - preview
         * * `test` - test
         * * `live` - live
         */
        kind?: 'preview' | 'test' | 'live';
    };
    url: '/v3/apps/deployments/invoke/';
};

export type AppsDeploymentsInvokeCreateResponses = {
    200: AppDeploymentInvocationResponse;
};

export type AppsDeploymentsInvokeCreateResponse = AppsDeploymentsInvokeCreateResponses[keyof AppsDeploymentsInvokeCreateResponses];

export type AppsInstalledAppsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/apps/installed-apps/';
};

export type AppsInstalledAppsListResponses = {
    200: PaginatedInstalledAppList;
};

export type AppsInstalledAppsListResponse = AppsInstalledAppsListResponses[keyof AppsInstalledAppsListResponses];

export type AppsInstalledAppsCreateData = {
    body: InstalledAppRequest;
    path?: never;
    query?: never;
    url: '/v3/apps/installed-apps/';
};

export type AppsInstalledAppsCreateResponses = {
    201: InstalledApp;
};

export type AppsInstalledAppsCreateResponse = AppsInstalledAppsCreateResponses[keyof AppsInstalledAppsCreateResponses];

export type AppsInstalledAppsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Installed App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/installed-apps/{id}/';
};

export type AppsInstalledAppsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type AppsInstalledAppsDestroyResponse = AppsInstalledAppsDestroyResponses[keyof AppsInstalledAppsDestroyResponses];

export type AppsInstalledAppsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Installed App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/installed-apps/{id}/';
};

export type AppsInstalledAppsRetrieveResponses = {
    200: InstalledAppDetails;
};

export type AppsInstalledAppsRetrieveResponse = AppsInstalledAppsRetrieveResponses[keyof AppsInstalledAppsRetrieveResponses];

export type AppsInstalledAppsPartialUpdateData = {
    body?: PatchedInstalledAppRequest;
    path: {
        /**
         * A unique integer value identifying this Installed App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/installed-apps/{id}/';
};

export type AppsInstalledAppsPartialUpdateResponses = {
    200: InstalledApp;
};

export type AppsInstalledAppsPartialUpdateResponse = AppsInstalledAppsPartialUpdateResponses[keyof AppsInstalledAppsPartialUpdateResponses];

export type AppsInstalledAppsUpdateData = {
    body: InstalledAppRequest;
    path: {
        /**
         * A unique integer value identifying this Installed App.
         */
        id: number;
    };
    query?: never;
    url: '/v3/apps/installed-apps/{id}/';
};

export type AppsInstalledAppsUpdateResponses = {
    200: InstalledApp;
};

export type AppsInstalledAppsUpdateResponse = AppsInstalledAppsUpdateResponses[keyof AppsInstalledAppsUpdateResponses];

export type CampaignAssetsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/campaign/assets/';
};

export type CampaignAssetsListResponses = {
    200: PaginatedAssetList;
};

export type CampaignAssetsListResponse = CampaignAssetsListResponses[keyof CampaignAssetsListResponses];

export type CampaignAssetsCreateData = {
    body: AssetRequest;
    path?: never;
    query?: never;
    url: '/v3/campaign/assets/';
};

export type CampaignAssetsCreateResponses = {
    201: Asset;
};

export type CampaignAssetsCreateResponse = CampaignAssetsCreateResponses[keyof CampaignAssetsCreateResponses];

export type CampaignAssetsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Asset.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/assets/{id}/';
};

export type CampaignAssetsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CampaignAssetsDestroyResponse = CampaignAssetsDestroyResponses[keyof CampaignAssetsDestroyResponses];

export type CampaignAssetsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Asset.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/assets/{id}/';
};

export type CampaignAssetsRetrieveResponses = {
    200: Asset;
};

export type CampaignAssetsRetrieveResponse = CampaignAssetsRetrieveResponses[keyof CampaignAssetsRetrieveResponses];

export type CampaignAssetsPartialUpdateData = {
    body?: PatchedAssetRequest;
    path: {
        /**
         * A unique integer value identifying this Asset.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/assets/{id}/';
};

export type CampaignAssetsPartialUpdateResponses = {
    200: Asset;
};

export type CampaignAssetsPartialUpdateResponse = CampaignAssetsPartialUpdateResponses[keyof CampaignAssetsPartialUpdateResponses];

export type CampaignAssetsUpdateData = {
    body: AssetRequest;
    path: {
        /**
         * A unique integer value identifying this Asset.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/assets/{id}/';
};

export type CampaignAssetsUpdateResponses = {
    200: Asset;
};

export type CampaignAssetsUpdateResponse = CampaignAssetsUpdateResponses[keyof CampaignAssetsUpdateResponses];

export type CampaignAudiencesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        name?: string;
        /**
         * Ordering
         *
         * * `id` - Id
         * * `-id` - Id (descending)
         * * `key` - Key
         * * `-key` - Key (descending)
         */
        o?: Array<'-id' | '-key' | 'id' | 'key'>;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * * `published` - Published
         * * `archived` - Archived
         * * `draft` - Draft
         */
        status?: Array<'archived' | 'draft' | 'published'>;
        /**
         * * `default` - Default
         * * `exception` - Exception
         */
        target_flow?: 'default' | 'exception';
        target_stages?: string;
    };
    url: '/v3/campaign/audiences/';
};

export type CampaignAudiencesListResponses = {
    200: PaginatedAudienceList;
};

export type CampaignAudiencesListResponse = CampaignAudiencesListResponses[keyof CampaignAudiencesListResponses];

export type CampaignAudiencesCreateData = {
    body: AudienceRequest;
    path?: never;
    query?: never;
    url: '/v3/campaign/audiences/';
};

export type CampaignAudiencesCreateResponses = {
    201: Audience;
};

export type CampaignAudiencesCreateResponse = CampaignAudiencesCreateResponses[keyof CampaignAudiencesCreateResponses];

export type CampaignAudiencesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Audience.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/audiences/{id}/';
};

export type CampaignAudiencesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CampaignAudiencesDestroyResponse = CampaignAudiencesDestroyResponses[keyof CampaignAudiencesDestroyResponses];

export type CampaignAudiencesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Audience.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/audiences/{id}/';
};

export type CampaignAudiencesRetrieveResponses = {
    200: Audience;
};

export type CampaignAudiencesRetrieveResponse = CampaignAudiencesRetrieveResponses[keyof CampaignAudiencesRetrieveResponses];

export type CampaignAudiencesPartialUpdateData = {
    body?: PatchedAudienceRequest;
    path: {
        /**
         * A unique integer value identifying this Audience.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/audiences/{id}/';
};

export type CampaignAudiencesPartialUpdateResponses = {
    200: Audience;
};

export type CampaignAudiencesPartialUpdateResponse = CampaignAudiencesPartialUpdateResponses[keyof CampaignAudiencesPartialUpdateResponses];

export type CampaignAudiencesUpdateData = {
    body: AudienceRequest;
    path: {
        /**
         * A unique integer value identifying this Audience.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/audiences/{id}/';
};

export type CampaignAudiencesUpdateResponses = {
    200: Audience;
};

export type CampaignAudiencesUpdateResponse = CampaignAudiencesUpdateResponses[keyof CampaignAudiencesUpdateResponses];

export type CampaignAudiencesEstimateMatchRateCreateData = {
    body: AudiencePreviewRequestRequest;
    path?: never;
    query?: never;
    url: '/v3/campaign/audiences/estimate-match-rate/';
};

export type CampaignAudiencesEstimateMatchRateCreateResponses = {
    200: unknown;
};

export type CampaignCampaignsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        archive_date__gte?: string;
        archive_date__lte?: string;
        /**
         * * `web` - Web
         * * `email` - Email
         */
        campaign_targets?: Array<'email' | 'web'>;
        end_date__gte?: string;
        end_date__lte?: string;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        name?: string;
        /**
         * Ordering
         *
         * * `id` - Id
         * * `-id` - Id (descending)
         * * `key` - Key
         * * `-key` - Key (descending)
         * * `start_date` - Start date
         * * `-start_date` - Start date (descending)
         */
        o?: Array<'-id' | '-key' | '-start_date' | 'id' | 'key' | 'start_date'>;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        start_date__gte?: string;
        start_date__lte?: string;
        /**
         * * `published` - Published
         * * `archived` - Archived
         * * `draft` - Draft
         */
        status?: Array<'archived' | 'draft' | 'published'>;
    };
    url: '/v3/campaign/campaigns/';
};

export type CampaignCampaignsListResponses = {
    200: PaginatedCampaignResponseList;
};

export type CampaignCampaignsListResponse = CampaignCampaignsListResponses[keyof CampaignCampaignsListResponses];

export type CampaignCampaignsCreateData = {
    body: CampaignRequest;
    path?: never;
    query?: never;
    url: '/v3/campaign/campaigns/';
};

export type CampaignCampaignsCreateResponses = {
    201: Campaign;
};

export type CampaignCampaignsCreateResponse = CampaignCampaignsCreateResponses[keyof CampaignCampaignsCreateResponses];

export type CampaignCampaignsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Campaign.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/campaigns/{id}/';
};

export type CampaignCampaignsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CampaignCampaignsDestroyResponse = CampaignCampaignsDestroyResponses[keyof CampaignCampaignsDestroyResponses];

export type CampaignCampaignsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Campaign.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/campaigns/{id}/';
};

export type CampaignCampaignsRetrieveResponses = {
    200: CampaignResponse;
};

export type CampaignCampaignsRetrieveResponse = CampaignCampaignsRetrieveResponses[keyof CampaignCampaignsRetrieveResponses];

export type CampaignCampaignsPartialUpdateData = {
    body?: PatchedCampaignRequest;
    path: {
        /**
         * A unique integer value identifying this Campaign.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/campaigns/{id}/';
};

export type CampaignCampaignsPartialUpdateResponses = {
    200: Campaign;
};

export type CampaignCampaignsPartialUpdateResponse = CampaignCampaignsPartialUpdateResponses[keyof CampaignCampaignsPartialUpdateResponses];

export type CampaignCampaignsUpdateData = {
    body: CampaignRequest;
    path: {
        /**
         * A unique integer value identifying this Campaign.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/campaigns/{id}/';
};

export type CampaignCampaignsUpdateResponses = {
    200: Campaign;
};

export type CampaignCampaignsUpdateResponse = CampaignCampaignsUpdateResponses[keyof CampaignCampaignsUpdateResponses];

export type CampaignContentTypesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        name?: string;
        /**
         * Ordering
         *
         * * `id` - Id
         * * `-id` - Id (descending)
         * * `key` - Key
         * * `-key` - Key (descending)
         */
        o?: Array<'-id' | '-key' | 'id' | 'key'>;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * * `published` - Published
         * * `archived` - Archived
         * * `draft` - Draft
         */
        status?: 'archived' | 'draft' | 'published';
    };
    url: '/v3/campaign/content-types/';
};

export type CampaignContentTypesListResponses = {
    200: PaginatedContentTypeList;
};

export type CampaignContentTypesListResponse = CampaignContentTypesListResponses[keyof CampaignContentTypesListResponses];

export type CampaignContentTypesCreateData = {
    body: ContentTypeWriteRequest;
    path?: never;
    query?: never;
    url: '/v3/campaign/content-types/';
};

export type CampaignContentTypesCreateResponses = {
    201: ContentTypeWrite;
};

export type CampaignContentTypesCreateResponse = CampaignContentTypesCreateResponses[keyof CampaignContentTypesCreateResponses];

export type CampaignContentTypesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Content Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/content-types/{id}/';
};

export type CampaignContentTypesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type CampaignContentTypesDestroyResponse = CampaignContentTypesDestroyResponses[keyof CampaignContentTypesDestroyResponses];

export type CampaignContentTypesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Content Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/content-types/{id}/';
};

export type CampaignContentTypesRetrieveResponses = {
    200: ContentType;
};

export type CampaignContentTypesRetrieveResponse = CampaignContentTypesRetrieveResponses[keyof CampaignContentTypesRetrieveResponses];

export type CampaignContentTypesPartialUpdateData = {
    body?: PatchedContentTypeRequest;
    path: {
        /**
         * A unique integer value identifying this Content Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/content-types/{id}/';
};

export type CampaignContentTypesPartialUpdateResponses = {
    200: ContentType;
};

export type CampaignContentTypesPartialUpdateResponse = CampaignContentTypesPartialUpdateResponses[keyof CampaignContentTypesPartialUpdateResponses];

export type CampaignContentTypesUpdateData = {
    body: ContentTypeWriteRequest;
    path: {
        /**
         * A unique integer value identifying this Content Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/campaign/content-types/{id}/';
};

export type CampaignContentTypesUpdateResponses = {
    200: ContentTypeWrite;
};

export type CampaignContentTypesUpdateResponse = CampaignContentTypesUpdateResponses[keyof CampaignContentTypesUpdateResponses];

export type ConfigClientsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        archived?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/config/clients/';
};

export type ConfigClientsListResponses = {
    200: PaginatedClientList;
};

export type ConfigClientsListResponse = ConfigClientsListResponses[keyof ConfigClientsListResponses];

export type ConfigClientsCreateData = {
    body: ClientRequest;
    path?: never;
    query?: never;
    url: '/v3/config/clients/';
};

export type ConfigClientsCreateResponses = {
    201: Client;
};

export type ConfigClientsCreateResponse = ConfigClientsCreateResponses[keyof ConfigClientsCreateResponses];

export type ConfigClientsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this client.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/clients/{id}/';
};

export type ConfigClientsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigClientsDestroyResponse = ConfigClientsDestroyResponses[keyof ConfigClientsDestroyResponses];

export type ConfigClientsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this client.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/clients/{id}/';
};

export type ConfigClientsRetrieveResponses = {
    200: Client;
};

export type ConfigClientsRetrieveResponse = ConfigClientsRetrieveResponses[keyof ConfigClientsRetrieveResponses];

export type ConfigClientsPartialUpdateData = {
    body?: PatchedClientRequest;
    path: {
        /**
         * A unique integer value identifying this client.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/clients/{id}/';
};

export type ConfigClientsPartialUpdateResponses = {
    200: Client;
};

export type ConfigClientsPartialUpdateResponse = ConfigClientsPartialUpdateResponses[keyof ConfigClientsPartialUpdateResponses];

export type ConfigClientsUpdateData = {
    body: ClientRequest;
    path: {
        /**
         * A unique integer value identifying this client.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/clients/{id}/';
};

export type ConfigClientsUpdateResponses = {
    200: Client;
};

export type ConfigClientsUpdateResponse = ConfigClientsUpdateResponses[keyof ConfigClientsUpdateResponses];

export type ConfigClientsDetailsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this client.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/clients/{id}/details/';
};

export type ConfigClientsDetailsRetrieveResponses = {
    200: ClientDetails;
};

export type ConfigClientsDetailsRetrieveResponse = ConfigClientsDetailsRetrieveResponses[keyof ConfigClientsDetailsRetrieveResponses];

export type ConfigClientsLanguagesRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        account?: number;
    };
    url: '/v3/config/clients/languages/';
};

export type ConfigClientsLanguagesRetrieveResponses = {
    200: ClientLanguagesResponse;
};

export type ConfigClientsLanguagesRetrieveResponse = ConfigClientsLanguagesRetrieveResponses[keyof ConfigClientsLanguagesRetrieveResponses];

export type ConfigClientsLookupRetrieveData = {
    body?: never;
    path: {
        account: string;
    };
    query?: {
        archived?: boolean;
    };
    url: '/v3/config/clients/lookup/{account}/';
};

export type ConfigClientsLookupRetrieveResponses = {
    200: StaticResponse;
};

export type ConfigClientsLookupRetrieveResponse = ConfigClientsLookupRetrieveResponses[keyof ConfigClientsLookupRetrieveResponses];

export type ConfigCouriersListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
    };
    url: '/v3/config/couriers/';
};

export type ConfigCouriersListResponses = {
    200: PaginatedCourierList;
};

export type ConfigCouriersListResponse = ConfigCouriersListResponses[keyof ConfigCouriersListResponses];

export type ConfigCouriersCreateData = {
    body: CourierRequest;
    path?: never;
    query?: never;
    url: '/v3/config/couriers/';
};

export type ConfigCouriersCreateResponses = {
    201: Courier;
};

export type ConfigCouriersCreateResponse = ConfigCouriersCreateResponses[keyof ConfigCouriersCreateResponses];

export type ConfigCouriersDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this courier.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/couriers/{id}/';
};

export type ConfigCouriersDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigCouriersDestroyResponse = ConfigCouriersDestroyResponses[keyof ConfigCouriersDestroyResponses];

export type ConfigCouriersRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this courier.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/couriers/{id}/';
};

export type ConfigCouriersRetrieveResponses = {
    200: Courier;
};

export type ConfigCouriersRetrieveResponse = ConfigCouriersRetrieveResponses[keyof ConfigCouriersRetrieveResponses];

export type ConfigCouriersPartialUpdateData = {
    body?: PatchedCourierRequest;
    path: {
        /**
         * A unique integer value identifying this courier.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/couriers/{id}/';
};

export type ConfigCouriersPartialUpdateResponses = {
    200: Courier;
};

export type ConfigCouriersPartialUpdateResponse = ConfigCouriersPartialUpdateResponses[keyof ConfigCouriersPartialUpdateResponses];

export type ConfigCouriersUpdateData = {
    body: CourierRequest;
    path: {
        /**
         * A unique integer value identifying this courier.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/couriers/{id}/';
};

export type ConfigCouriersUpdateResponses = {
    200: Courier;
};

export type ConfigCouriersUpdateResponse = ConfigCouriersUpdateResponses[keyof ConfigCouriersUpdateResponses];

export type ConfigFilterFieldsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        returns_portal_id?: number;
        /**
         * * `return_article` - Return Article
         * * `return_article_v2` - Return Article V2
         * * `return_document` - Return Document
         * * `return_document_v2` - Return Document V2
         * * `tracking` - Tracking
         * * `customer_segment` - Customer Segment
         * * `promise_rule` - Promise Rule
         */
        target_model?: 'customer_segment' | 'promise_rule' | 'return_article' | 'return_article_v2' | 'return_document' | 'return_document_v2' | 'tracking';
    };
    url: '/v3/config/filter-fields/';
};

export type ConfigFilterFieldsListResponses = {
    200: PaginatedFilterFieldList;
};

export type ConfigFilterFieldsListResponse = ConfigFilterFieldsListResponses[keyof ConfigFilterFieldsListResponses];

export type ConfigFilterFieldsCreateData = {
    body: FilterFieldRequest;
    path?: never;
    query?: never;
    url: '/v3/config/filter-fields/';
};

export type ConfigFilterFieldsCreateResponses = {
    201: FilterField;
};

export type ConfigFilterFieldsCreateResponse = ConfigFilterFieldsCreateResponses[keyof ConfigFilterFieldsCreateResponses];

export type ConfigFilterFieldsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Filter Field.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/filter-fields/{id}/';
};

export type ConfigFilterFieldsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigFilterFieldsDestroyResponse = ConfigFilterFieldsDestroyResponses[keyof ConfigFilterFieldsDestroyResponses];

export type ConfigFilterFieldsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Filter Field.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/filter-fields/{id}/';
};

export type ConfigFilterFieldsRetrieveResponses = {
    200: FilterField;
};

export type ConfigFilterFieldsRetrieveResponse = ConfigFilterFieldsRetrieveResponses[keyof ConfigFilterFieldsRetrieveResponses];

export type ConfigFilterFieldsPartialUpdateData = {
    body?: PatchedFilterFieldRequest;
    path: {
        /**
         * A unique integer value identifying this Filter Field.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/filter-fields/{id}/';
};

export type ConfigFilterFieldsPartialUpdateResponses = {
    200: FilterField;
};

export type ConfigFilterFieldsPartialUpdateResponse = ConfigFilterFieldsPartialUpdateResponses[keyof ConfigFilterFieldsPartialUpdateResponses];

export type ConfigFilterFieldsUpdateData = {
    body: FilterFieldRequest;
    path: {
        /**
         * A unique integer value identifying this Filter Field.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/filter-fields/{id}/';
};

export type ConfigFilterFieldsUpdateResponses = {
    200: FilterField;
};

export type ConfigFilterFieldsUpdateResponse = ConfigFilterFieldsUpdateResponses[keyof ConfigFilterFieldsUpdateResponses];

export type ConfigIntegrationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        archived?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * Service Key
         */
        service_key?: Array<string>;
        /**
         * Service Role
         *
         * * `integration` - Connect | Integration
         * * `integration-sms` - Connect | SMS Integration
         * * `integration-webhook` - Connect | Webhook Integration
         */
        service_role?: 'integration' | 'integration-sms' | 'integration-webhook';
    };
    url: '/v3/config/integrations/';
};

export type ConfigIntegrationsListResponses = {
    200: PaginatedIntegrationList;
};

export type ConfigIntegrationsListResponse = ConfigIntegrationsListResponses[keyof ConfigIntegrationsListResponses];

export type ConfigIntegrationsCreateData = {
    body: IntegrationRequest;
    path?: never;
    query?: never;
    url: '/v3/config/integrations/';
};

export type ConfigIntegrationsCreateResponses = {
    201: Integration;
};

export type ConfigIntegrationsCreateResponse = ConfigIntegrationsCreateResponses[keyof ConfigIntegrationsCreateResponses];

export type ConfigIntegrationsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this integration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/integrations/{id}/';
};

export type ConfigIntegrationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigIntegrationsDestroyResponse = ConfigIntegrationsDestroyResponses[keyof ConfigIntegrationsDestroyResponses];

export type ConfigIntegrationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this integration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/integrations/{id}/';
};

export type ConfigIntegrationsRetrieveResponses = {
    200: Integration;
};

export type ConfigIntegrationsRetrieveResponse = ConfigIntegrationsRetrieveResponses[keyof ConfigIntegrationsRetrieveResponses];

export type ConfigIntegrationsPartialUpdateData = {
    body?: PatchedIntegrationRequest;
    path: {
        /**
         * A unique integer value identifying this integration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/integrations/{id}/';
};

export type ConfigIntegrationsPartialUpdateResponses = {
    200: Integration;
};

export type ConfigIntegrationsPartialUpdateResponse = ConfigIntegrationsPartialUpdateResponses[keyof ConfigIntegrationsPartialUpdateResponses];

export type ConfigIntegrationsUpdateData = {
    body: IntegrationRequest;
    path: {
        /**
         * A unique integer value identifying this integration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/integrations/{id}/';
};

export type ConfigIntegrationsUpdateResponses = {
    200: Integration;
};

export type ConfigIntegrationsUpdateResponse = ConfigIntegrationsUpdateResponses[keyof ConfigIntegrationsUpdateResponses];

export type ConfigReferenceItemsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        archived?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * Show only items from the given account. Default is to also show parent account items
         */
        override_global?: boolean;
        /**
         * * `destination-country-iso3` - Destination Country ISO3
         * * `client` - Client
         * * `courier` - Courier
         * * `warehouse` - Warehouse
         * * `courier-service-level` - Courier Service Level
         * * `delivery-method` - Delivery Method
         * * `delivery-info-market` - Delivery Info Market
         * * `payment-method` - Payment Method
         * * `order-status` - Order Status
         * * `claim-reason` - Claim Reason
         * * `return-reject-reason` - Return Reject Reason
         * * `delivery-timezone` - Timezone (Delivery Info)
         * * `delivery-region` - Region (Destination)
         * * `delivery-location` - Delivery Location
         * * `delivery-status` - Delivery Status
         * * `delivery-exception` - Delivery Exception
         * * `tracking-tags` - Tracking Tags
         */
        type?: 'claim-reason' | 'client' | 'courier' | 'courier-service-level' | 'delivery-exception' | 'delivery-info-market' | 'delivery-location' | 'delivery-method' | 'delivery-region' | 'delivery-status' | 'delivery-timezone' | 'destination-country-iso3' | 'order-status' | 'payment-method' | 'return-reject-reason' | 'tracking-tags' | 'warehouse';
    };
    url: '/v3/config/reference-items/';
};

export type ConfigReferenceItemsListResponses = {
    200: PaginatedReferenceItemList;
};

export type ConfigReferenceItemsListResponse = ConfigReferenceItemsListResponses[keyof ConfigReferenceItemsListResponses];

export type ConfigReferenceItemsCreateData = {
    body: ReferenceItemRequest;
    path?: never;
    query?: never;
    url: '/v3/config/reference-items/';
};

export type ConfigReferenceItemsCreateResponses = {
    201: ReferenceItem;
};

export type ConfigReferenceItemsCreateResponse = ConfigReferenceItemsCreateResponses[keyof ConfigReferenceItemsCreateResponses];

export type ConfigReferenceItemsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Reference Item.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/reference-items/{id}/';
};

export type ConfigReferenceItemsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigReferenceItemsDestroyResponse = ConfigReferenceItemsDestroyResponses[keyof ConfigReferenceItemsDestroyResponses];

export type ConfigReferenceItemsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Reference Item.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/reference-items/{id}/';
};

export type ConfigReferenceItemsRetrieveResponses = {
    200: ReferenceItem;
};

export type ConfigReferenceItemsRetrieveResponse = ConfigReferenceItemsRetrieveResponses[keyof ConfigReferenceItemsRetrieveResponses];

export type ConfigReferenceItemsPartialUpdateData = {
    body?: PatchedReferenceItemRequest;
    path: {
        /**
         * A unique integer value identifying this Reference Item.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/reference-items/{id}/';
};

export type ConfigReferenceItemsPartialUpdateResponses = {
    200: ReferenceItem;
};

export type ConfigReferenceItemsPartialUpdateResponse = ConfigReferenceItemsPartialUpdateResponses[keyof ConfigReferenceItemsPartialUpdateResponses];

export type ConfigReferenceItemsUpdateData = {
    body: ReferenceItemRequest;
    path: {
        /**
         * A unique integer value identifying this Reference Item.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/reference-items/{id}/';
};

export type ConfigReferenceItemsUpdateResponses = {
    200: ReferenceItem;
};

export type ConfigReferenceItemsUpdateResponse = ConfigReferenceItemsUpdateResponses[keyof ConfigReferenceItemsUpdateResponses];

export type ConfigSmsAutoreplyConfigListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        client?: number;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * SMS Integration Service Key
         */
        sms_integration_service_key?: string;
    };
    url: '/v3/config/sms-autoreply-config/';
};

export type ConfigSmsAutoreplyConfigListResponses = {
    200: PaginatedSmsAutoReplyConfigList;
};

export type ConfigSmsAutoreplyConfigListResponse = ConfigSmsAutoreplyConfigListResponses[keyof ConfigSmsAutoreplyConfigListResponses];

export type ConfigSmsAutoreplyConfigCreateData = {
    body: SmsAutoReplyConfigRequest;
    path?: never;
    query?: never;
    url: '/v3/config/sms-autoreply-config/';
};

export type ConfigSmsAutoreplyConfigCreateResponses = {
    201: SmsAutoReplyConfig;
};

export type ConfigSmsAutoreplyConfigCreateResponse = ConfigSmsAutoreplyConfigCreateResponses[keyof ConfigSmsAutoreplyConfigCreateResponses];

export type ConfigSmsAutoreplyConfigDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this sms auto reply config.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/sms-autoreply-config/{id}/';
};

export type ConfigSmsAutoreplyConfigDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigSmsAutoreplyConfigDestroyResponse = ConfigSmsAutoreplyConfigDestroyResponses[keyof ConfigSmsAutoreplyConfigDestroyResponses];

export type ConfigSmsAutoreplyConfigRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this sms auto reply config.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/sms-autoreply-config/{id}/';
};

export type ConfigSmsAutoreplyConfigRetrieveResponses = {
    200: SmsAutoReplyConfig;
};

export type ConfigSmsAutoreplyConfigRetrieveResponse = ConfigSmsAutoreplyConfigRetrieveResponses[keyof ConfigSmsAutoreplyConfigRetrieveResponses];

export type ConfigSmsAutoreplyConfigPartialUpdateData = {
    body?: PatchedSmsAutoReplyConfigRequest;
    path: {
        /**
         * A unique integer value identifying this sms auto reply config.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/sms-autoreply-config/{id}/';
};

export type ConfigSmsAutoreplyConfigPartialUpdateResponses = {
    200: SmsAutoReplyConfig;
};

export type ConfigSmsAutoreplyConfigPartialUpdateResponse = ConfigSmsAutoreplyConfigPartialUpdateResponses[keyof ConfigSmsAutoreplyConfigPartialUpdateResponses];

export type ConfigSmsAutoreplyConfigUpdateData = {
    body: SmsAutoReplyConfigRequest;
    path: {
        /**
         * A unique integer value identifying this sms auto reply config.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/sms-autoreply-config/{id}/';
};

export type ConfigSmsAutoreplyConfigUpdateResponses = {
    200: SmsAutoReplyConfig;
};

export type ConfigSmsAutoreplyConfigUpdateResponse = ConfigSmsAutoreplyConfigUpdateResponses[keyof ConfigSmsAutoreplyConfigUpdateResponses];

export type ConfigWhitelabelDomainConfigsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        archived?: boolean;
        domain?: string;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/config/whitelabel-domain-configs/';
};

export type ConfigWhitelabelDomainConfigsListResponses = {
    200: PaginatedWhiteLabelDomainConfigList;
};

export type ConfigWhitelabelDomainConfigsListResponse = ConfigWhitelabelDomainConfigsListResponses[keyof ConfigWhitelabelDomainConfigsListResponses];

export type ConfigWhitelabelDomainConfigsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this White-Label Domain.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/whitelabel-domain-configs/{id}/';
};

export type ConfigWhitelabelDomainConfigsRetrieveResponses = {
    200: WhiteLabelDomainConfig;
};

export type ConfigWhitelabelDomainConfigsRetrieveResponse = ConfigWhitelabelDomainConfigsRetrieveResponses[keyof ConfigWhitelabelDomainConfigsRetrieveResponses];

export type ConfigWhitelistedDomainsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/config/whitelisted-domains/';
};

export type ConfigWhitelistedDomainsListResponses = {
    200: PaginatedWhitelistedDomainList;
};

export type ConfigWhitelistedDomainsListResponse = ConfigWhitelistedDomainsListResponses[keyof ConfigWhitelistedDomainsListResponses];

export type ConfigWhitelistedDomainsCreateData = {
    body: WhitelistedDomainRequest;
    path?: never;
    query?: never;
    url: '/v3/config/whitelisted-domains/';
};

export type ConfigWhitelistedDomainsCreateResponses = {
    201: WhitelistedDomain;
};

export type ConfigWhitelistedDomainsCreateResponse = ConfigWhitelistedDomainsCreateResponses[keyof ConfigWhitelistedDomainsCreateResponses];

export type ConfigWhitelistedDomainsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Whitelisted Domain.
         */
        id: number;
    };
    query?: never;
    url: '/v3/config/whitelisted-domains/{id}/';
};

export type ConfigWhitelistedDomainsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ConfigWhitelistedDomainsDestroyResponse = ConfigWhitelistedDomainsDestroyResponses[keyof ConfigWhitelistedDomainsDestroyResponses];

export type ConfigWhitelistedDomainsBulkCreateCreateData = {
    body: WhitelistedDomainBulkCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/config/whitelisted-domains/bulk-create/';
};

export type ConfigWhitelistedDomainsBulkCreateCreateResponses = {
    201: WhiteListedDomainBulkCreateResponse;
};

export type ConfigWhitelistedDomainsBulkCreateCreateResponse = ConfigWhitelistedDomainsBulkCreateCreateResponses[keyof ConfigWhitelistedDomainsBulkCreateCreateResponses];

export type ConfigWhitelistedDomainsLookupRetrieveData = {
    body?: never;
    path?: never;
    query: {
        domain: string;
        /**
         * * `outbound_email` - Outbound Email
         * * `returns_plugin` - Returns Plugin
         */
        type: 'outbound_email' | 'returns_plugin';
    };
    url: '/v3/config/whitelisted-domains/lookup/';
};

export type ConfigWhitelistedDomainsLookupRetrieveResponses = {
    200: WhitelistCheckResponse;
};

export type ConfigWhitelistedDomainsLookupRetrieveResponse = ConfigWhitelistedDomainsLookupRetrieveResponses[keyof ConfigWhitelistedDomainsLookupRetrieveResponses];

export type ImportsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/imports/';
};

export type ImportsListResponses = {
    200: PaginatedImportList;
};

export type ImportsListResponse = ImportsListResponses[keyof ImportsListResponses];

export type ImportsCreateData = {
    body: ImportRequest;
    path?: never;
    query?: never;
    url: '/v3/imports/';
};

export type ImportsCreateResponses = {
    201: Import;
};

export type ImportsCreateResponse = ImportsCreateResponses[keyof ImportsCreateResponses];

export type ImportsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this import.
         */
        id: number;
    };
    query?: never;
    url: '/v3/imports/{id}/';
};

export type ImportsRetrieveResponses = {
    200: Import;
};

export type ImportsRetrieveResponse = ImportsRetrieveResponses[keyof ImportsRetrieveResponses];

export type JourneyConfigurationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/configurations/';
};

export type JourneyConfigurationsListResponses = {
    200: PaginatedJourneyConfigurationList;
};

export type JourneyConfigurationsListResponse = JourneyConfigurationsListResponses[keyof JourneyConfigurationsListResponses];

export type JourneyConfigurationsCreateData = {
    body: JourneyConfigurationRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/configurations/';
};

export type JourneyConfigurationsCreateResponses = {
    201: JourneyConfiguration;
};

export type JourneyConfigurationsCreateResponse = JourneyConfigurationsCreateResponses[keyof JourneyConfigurationsCreateResponses];

export type JourneyConfigurationsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Journey Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/configurations/{id}/';
};

export type JourneyConfigurationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyConfigurationsDestroyResponse = JourneyConfigurationsDestroyResponses[keyof JourneyConfigurationsDestroyResponses];

export type JourneyConfigurationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Journey Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/configurations/{id}/';
};

export type JourneyConfigurationsRetrieveResponses = {
    200: JourneyConfiguration;
};

export type JourneyConfigurationsRetrieveResponse = JourneyConfigurationsRetrieveResponses[keyof JourneyConfigurationsRetrieveResponses];

export type JourneyConfigurationsPartialUpdateData = {
    body?: PatchedJourneyConfigurationRequest;
    path: {
        /**
         * A unique integer value identifying this Journey Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/configurations/{id}/';
};

export type JourneyConfigurationsPartialUpdateResponses = {
    200: JourneyConfiguration;
};

export type JourneyConfigurationsPartialUpdateResponse = JourneyConfigurationsPartialUpdateResponses[keyof JourneyConfigurationsPartialUpdateResponses];

export type JourneyConfigurationsUpdateData = {
    body: JourneyConfigurationRequest;
    path: {
        /**
         * A unique integer value identifying this Journey Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/configurations/{id}/';
};

export type JourneyConfigurationsUpdateResponses = {
    200: JourneyConfiguration;
};

export type JourneyConfigurationsUpdateResponse = JourneyConfigurationsUpdateResponses[keyof JourneyConfigurationsUpdateResponses];

export type JourneyConfigurationsPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Journey Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/configurations/{id}/publish/';
};

export type JourneyConfigurationsPublishCreateResponses = {
    200: JourneyConfiguration;
};

export type JourneyConfigurationsPublishCreateResponse = JourneyConfigurationsPublishCreateResponses[keyof JourneyConfigurationsPublishCreateResponses];

export type JourneyConfigurationsFlowAnalysisRetrieveData = {
    body?: never;
    path: {
        account_id: string;
    };
    query?: {
        courier?: string;
        cutoff_date?: string;
        is_return?: boolean;
        journey?: number;
    };
    url: '/v3/journey/configurations/flow-analysis/{account_id}/';
};

export type JourneyConfigurationsFlowAnalysisRetrieveResponses = {
    200: JourneyMessageFlowAnalysis;
};

export type JourneyConfigurationsFlowAnalysisRetrieveResponse = JourneyConfigurationsFlowAnalysisRetrieveResponses[keyof JourneyConfigurationsFlowAnalysisRetrieveResponses];

export type JourneyConfigurationsLookupRetrieveData = {
    body?: never;
    path: {
        account_id: string;
    };
    query?: {
        /**
         * By default the endpoint returns the last saved version. When this parameter is true we return the last published instead
         */
        published?: boolean;
    };
    url: '/v3/journey/configurations/lookup/{account_id}/';
};

export type JourneyConfigurationsLookupRetrieveResponses = {
    200: JourneyTriggerResponse;
};

export type JourneyConfigurationsLookupRetrieveResponse = JourneyConfigurationsLookupRetrieveResponses[keyof JourneyConfigurationsLookupRetrieveResponses];

export type JourneyEventsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/events/';
};

export type JourneyEventsListResponses = {
    200: PaginatedJourneyTriggerEventList;
};

export type JourneyEventsListResponse = JourneyEventsListResponses[keyof JourneyEventsListResponses];

export type JourneyEventsCreateData = {
    body: JourneyTriggerEventRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/events/';
};

export type JourneyEventsCreateResponses = {
    201: JourneyTriggerEvent;
};

export type JourneyEventsCreateResponse = JourneyEventsCreateResponses[keyof JourneyEventsCreateResponses];

export type JourneyEventsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trigger Event.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/events/{id}/';
};

export type JourneyEventsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyEventsDestroyResponse = JourneyEventsDestroyResponses[keyof JourneyEventsDestroyResponses];

export type JourneyEventsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trigger Event.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/events/{id}/';
};

export type JourneyEventsRetrieveResponses = {
    200: JourneyTriggerEvent;
};

export type JourneyEventsRetrieveResponse = JourneyEventsRetrieveResponses[keyof JourneyEventsRetrieveResponses];

export type JourneyEventsPartialUpdateData = {
    body?: PatchedJourneyTriggerEventRequest;
    path: {
        /**
         * A unique integer value identifying this Trigger Event.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/events/{id}/';
};

export type JourneyEventsPartialUpdateResponses = {
    200: JourneyTriggerEvent;
};

export type JourneyEventsPartialUpdateResponse = JourneyEventsPartialUpdateResponses[keyof JourneyEventsPartialUpdateResponses];

export type JourneyEventsUpdateData = {
    body: JourneyTriggerEventRequest;
    path: {
        /**
         * A unique integer value identifying this Trigger Event.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/events/{id}/';
};

export type JourneyEventsUpdateResponses = {
    200: JourneyTriggerEvent;
};

export type JourneyEventsUpdateResponse = JourneyEventsUpdateResponses[keyof JourneyEventsUpdateResponses];

export type JourneyExperimentsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/experiments/';
};

export type JourneyExperimentsListResponses = {
    200: PaginatedExperimentList;
};

export type JourneyExperimentsListResponse = JourneyExperimentsListResponses[keyof JourneyExperimentsListResponses];

export type JourneyExperimentsCreateData = {
    body: ExperimentRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/experiments/';
};

export type JourneyExperimentsCreateResponses = {
    201: Experiment;
};

export type JourneyExperimentsCreateResponse = JourneyExperimentsCreateResponses[keyof JourneyExperimentsCreateResponses];

export type JourneyExperimentsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/experiments/{id}/';
};

export type JourneyExperimentsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyExperimentsDestroyResponse = JourneyExperimentsDestroyResponses[keyof JourneyExperimentsDestroyResponses];

export type JourneyExperimentsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/experiments/{id}/';
};

export type JourneyExperimentsRetrieveResponses = {
    200: Experiment;
};

export type JourneyExperimentsRetrieveResponse = JourneyExperimentsRetrieveResponses[keyof JourneyExperimentsRetrieveResponses];

export type JourneyExperimentsPartialUpdateData = {
    body?: PatchedExperimentRequest;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/experiments/{id}/';
};

export type JourneyExperimentsPartialUpdateResponses = {
    200: Experiment;
};

export type JourneyExperimentsPartialUpdateResponse = JourneyExperimentsPartialUpdateResponses[keyof JourneyExperimentsPartialUpdateResponses];

export type JourneyExperimentsUpdateData = {
    body: ExperimentRequest;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/experiments/{id}/';
};

export type JourneyExperimentsUpdateResponses = {
    200: Experiment;
};

export type JourneyExperimentsUpdateResponse = JourneyExperimentsUpdateResponses[keyof JourneyExperimentsUpdateResponses];

export type JourneyExperimentsPublishCreateData = {
    body: ExperimentRequest;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/experiments/{id}/publish/';
};

export type JourneyExperimentsPublishCreateResponses = {
    200: Experiment;
};

export type JourneyExperimentsPublishCreateResponse = JourneyExperimentsPublishCreateResponses[keyof JourneyExperimentsPublishCreateResponses];

export type JourneyExperimentsResultsListData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/experiments/{id}/results/';
};

export type JourneyExperimentsResultsListResponses = {
    200: PaginatedExperimentResultsList;
};

export type JourneyExperimentsResultsListResponse = JourneyExperimentsResultsListResponses[keyof JourneyExperimentsResultsListResponses];

export type JourneyExperimentsWinnerVariantPartialUpdateData = {
    body?: PatchedExperimentWinnerRequestRequest;
    path: {
        /**
         * A unique integer value identifying this Experiment.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/experiments/{id}/winner_variant/';
};

export type JourneyExperimentsWinnerVariantPartialUpdateErrors = {
    /**
     * Bad Request: The request could not be processed due to invalid input or the current state of the resource.
     */
    400: unknown;
};

export type JourneyExperimentsWinnerVariantPartialUpdateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyExperimentsWinnerVariantPartialUpdateResponse = JourneyExperimentsWinnerVariantPartialUpdateResponses[keyof JourneyExperimentsWinnerVariantPartialUpdateResponses];

export type JourneyFlowVisualizationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        journey_configuration?: number;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/flow-visualizations/';
};

export type JourneyFlowVisualizationsListResponses = {
    200: PaginatedJourneyFlowVisualizationList;
};

export type JourneyFlowVisualizationsListResponse = JourneyFlowVisualizationsListResponses[keyof JourneyFlowVisualizationsListResponses];

export type JourneyFlowVisualizationsCreateData = {
    body: JourneyFlowVisualizationRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/flow-visualizations/';
};

export type JourneyFlowVisualizationsCreateResponses = {
    201: JourneyFlowVisualization;
};

export type JourneyFlowVisualizationsCreateResponse = JourneyFlowVisualizationsCreateResponses[keyof JourneyFlowVisualizationsCreateResponses];

export type JourneyFlowVisualizationsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Journey Flow Visualization.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/flow-visualizations/{id}/';
};

export type JourneyFlowVisualizationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyFlowVisualizationsDestroyResponse = JourneyFlowVisualizationsDestroyResponses[keyof JourneyFlowVisualizationsDestroyResponses];

export type JourneyFlowVisualizationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Journey Flow Visualization.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/flow-visualizations/{id}/';
};

export type JourneyFlowVisualizationsRetrieveResponses = {
    200: JourneyFlowVisualization;
};

export type JourneyFlowVisualizationsRetrieveResponse = JourneyFlowVisualizationsRetrieveResponses[keyof JourneyFlowVisualizationsRetrieveResponses];

export type JourneyFlowVisualizationsPartialUpdateData = {
    body?: PatchedJourneyFlowVisualizationRequest;
    path: {
        /**
         * A unique integer value identifying this Journey Flow Visualization.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/flow-visualizations/{id}/';
};

export type JourneyFlowVisualizationsPartialUpdateResponses = {
    200: JourneyFlowVisualization;
};

export type JourneyFlowVisualizationsPartialUpdateResponse = JourneyFlowVisualizationsPartialUpdateResponses[keyof JourneyFlowVisualizationsPartialUpdateResponses];

export type JourneyFlowVisualizationsUpdateData = {
    body: JourneyFlowVisualizationRequest;
    path: {
        /**
         * A unique integer value identifying this Journey Flow Visualization.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/flow-visualizations/{id}/';
};

export type JourneyFlowVisualizationsUpdateResponses = {
    200: JourneyFlowVisualization;
};

export type JourneyFlowVisualizationsUpdateResponse = JourneyFlowVisualizationsUpdateResponses[keyof JourneyFlowVisualizationsUpdateResponses];

export type JourneyLayoutsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/layouts/';
};

export type JourneyLayoutsListResponses = {
    200: PaginatedLayoutList;
};

export type JourneyLayoutsListResponse = JourneyLayoutsListResponses[keyof JourneyLayoutsListResponses];

export type JourneyLayoutsCreateData = {
    body: LayoutRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/layouts/';
};

export type JourneyLayoutsCreateResponses = {
    201: Layout;
};

export type JourneyLayoutsCreateResponse = JourneyLayoutsCreateResponses[keyof JourneyLayoutsCreateResponses];

export type JourneyLayoutsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/';
};

export type JourneyLayoutsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyLayoutsDestroyResponse = JourneyLayoutsDestroyResponses[keyof JourneyLayoutsDestroyResponses];

export type JourneyLayoutsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/';
};

export type JourneyLayoutsRetrieveResponses = {
    200: Layout;
};

export type JourneyLayoutsRetrieveResponse = JourneyLayoutsRetrieveResponses[keyof JourneyLayoutsRetrieveResponses];

export type JourneyLayoutsPartialUpdateData = {
    body?: PatchedLayoutRequest;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/';
};

export type JourneyLayoutsPartialUpdateResponses = {
    200: Layout;
};

export type JourneyLayoutsPartialUpdateResponse = JourneyLayoutsPartialUpdateResponses[keyof JourneyLayoutsPartialUpdateResponses];

export type JourneyLayoutsUpdateData = {
    body: LayoutRequest;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/';
};

export type JourneyLayoutsUpdateResponses = {
    200: Layout;
};

export type JourneyLayoutsUpdateResponse = JourneyLayoutsUpdateResponses[keyof JourneyLayoutsUpdateResponses];

export type JourneyLayoutsDetailsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/details/';
};

export type JourneyLayoutsDetailsRetrieveResponses = {
    200: LayoutDetail;
};

export type JourneyLayoutsDetailsRetrieveResponse = JourneyLayoutsDetailsRetrieveResponses[keyof JourneyLayoutsDetailsRetrieveResponses];

export type JourneyLayoutsEditorConfigRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/editor-config/';
};

export type JourneyLayoutsEditorConfigRetrieveResponses = {
    200: Layout;
};

export type JourneyLayoutsEditorConfigRetrieveResponse = JourneyLayoutsEditorConfigRetrieveResponses[keyof JourneyLayoutsEditorConfigRetrieveResponses];

export type JourneyLayoutsHistoryRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/history/';
};

export type JourneyLayoutsHistoryRetrieveResponses = {
    200: Layout;
};

export type JourneyLayoutsHistoryRetrieveResponse = JourneyLayoutsHistoryRetrieveResponses[keyof JourneyLayoutsHistoryRetrieveResponses];

export type JourneyLayoutsHistoryRetrieve2Data = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
        version_pk: string;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/history/{version_pk}/';
};

export type JourneyLayoutsHistoryRetrieve2Responses = {
    200: Layout;
};

export type JourneyLayoutsHistoryRetrieve2Response = JourneyLayoutsHistoryRetrieve2Responses[keyof JourneyLayoutsHistoryRetrieve2Responses];

export type JourneyLayoutsPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/publish/';
};

export type JourneyLayoutsPublishCreateResponses = {
    200: Layout;
};

export type JourneyLayoutsPublishCreateResponse = JourneyLayoutsPublishCreateResponses[keyof JourneyLayoutsPublishCreateResponses];

export type JourneyLayoutsRevertCreateData = {
    body: LayoutRequest;
    path: {
        /**
         * A unique integer value identifying this layout.
         */
        id: number;
        version_pk: string;
    };
    query?: never;
    url: '/v3/journey/layouts/{id}/revert/{version_pk}/';
};

export type JourneyLayoutsRevertCreateResponses = {
    200: Layout;
};

export type JourneyLayoutsRevertCreateResponse = JourneyLayoutsRevertCreateResponses[keyof JourneyLayoutsRevertCreateResponses];

export type JourneyLayoutsDeletedRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v3/journey/layouts/deleted/';
};

export type JourneyLayoutsDeletedRetrieveResponses = {
    200: Layout;
};

export type JourneyLayoutsDeletedRetrieveResponse = JourneyLayoutsDeletedRetrieveResponses[keyof JourneyLayoutsDeletedRetrieveResponses];

export type JourneyMediasListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/medias/';
};

export type JourneyMediasListResponses = {
    200: PaginatedMediaList;
};

export type JourneyMediasListResponse = JourneyMediasListResponses[keyof JourneyMediasListResponses];

export type JourneyMediasCreateData = {
    body: MediaRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/medias/';
};

export type JourneyMediasCreateResponses = {
    201: Media;
};

export type JourneyMediasCreateResponse = JourneyMediasCreateResponses[keyof JourneyMediasCreateResponses];

export type JourneyMediasDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Media.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/medias/{id}/';
};

export type JourneyMediasDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyMediasDestroyResponse = JourneyMediasDestroyResponses[keyof JourneyMediasDestroyResponses];

export type JourneyMediasRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Media.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/medias/{id}/';
};

export type JourneyMediasRetrieveResponses = {
    200: Media;
};

export type JourneyMediasRetrieveResponse = JourneyMediasRetrieveResponses[keyof JourneyMediasRetrieveResponses];

export type JourneyMediasPartialUpdateData = {
    body?: PatchedMediaRequest;
    path: {
        /**
         * A unique integer value identifying this Media.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/medias/{id}/';
};

export type JourneyMediasPartialUpdateResponses = {
    200: Media;
};

export type JourneyMediasPartialUpdateResponse = JourneyMediasPartialUpdateResponses[keyof JourneyMediasPartialUpdateResponses];

export type JourneyMediasUpdateData = {
    body: MediaRequest;
    path: {
        /**
         * A unique integer value identifying this Media.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/medias/{id}/';
};

export type JourneyMediasUpdateResponses = {
    200: Media;
};

export type JourneyMediasUpdateResponse = JourneyMediasUpdateResponses[keyof JourneyMediasUpdateResponses];

export type JourneyMessageTypesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * * `email` - Email
         * * `sms` - Sms
         * * `webhook` - Webhook
         */
        channel?: 'email' | 'sms' | 'webhook';
        has_released_version?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/message-types/';
};

export type JourneyMessageTypesListResponses = {
    200: PaginatedMessageTypeListList;
};

export type JourneyMessageTypesListResponse = JourneyMessageTypesListResponses[keyof JourneyMessageTypesListResponses];

export type JourneyMessageTypesCreateData = {
    body: MessageTypeRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/message-types/';
};

export type JourneyMessageTypesCreateResponses = {
    201: MessageType;
};

export type JourneyMessageTypesCreateResponse = JourneyMessageTypesCreateResponses[keyof JourneyMessageTypesCreateResponses];

export type JourneyMessageTypesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Message Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/message-types/{id}/';
};

export type JourneyMessageTypesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyMessageTypesDestroyResponse = JourneyMessageTypesDestroyResponses[keyof JourneyMessageTypesDestroyResponses];

export type JourneyMessageTypesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Message Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/message-types/{id}/';
};

export type JourneyMessageTypesRetrieveResponses = {
    200: MessageTypeDetail;
};

export type JourneyMessageTypesRetrieveResponse = JourneyMessageTypesRetrieveResponses[keyof JourneyMessageTypesRetrieveResponses];

export type JourneyMessageTypesPartialUpdateData = {
    body?: PatchedMessageTypeRequest;
    path: {
        /**
         * A unique integer value identifying this Message Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/message-types/{id}/';
};

export type JourneyMessageTypesPartialUpdateResponses = {
    200: MessageType;
};

export type JourneyMessageTypesPartialUpdateResponse = JourneyMessageTypesPartialUpdateResponses[keyof JourneyMessageTypesPartialUpdateResponses];

export type JourneyMessageTypesUpdateData = {
    body: MessageTypeRequest;
    path: {
        /**
         * A unique integer value identifying this Message Type.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/message-types/{id}/';
};

export type JourneyMessageTypesUpdateResponses = {
    200: MessageType;
};

export type JourneyMessageTypesUpdateResponse = JourneyMessageTypesUpdateResponses[keyof JourneyMessageTypesUpdateResponses];

export type JourneyMessageTypesAiGenerateCreateData = {
    body: MessageTypeGenerateRequestRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/message-types/ai-generate/';
};

export type JourneyMessageTypesAiGenerateCreateResponses = {
    200: MessageType;
};

export type JourneyMessageTypesAiGenerateCreateResponse = JourneyMessageTypesAiGenerateCreateResponses[keyof JourneyMessageTypesAiGenerateCreateResponses];

export type JourneyMessagesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/messages/';
};

export type JourneyMessagesListResponses = {
    200: PaginatedMessageList;
};

export type JourneyMessagesListResponse = JourneyMessagesListResponses[keyof JourneyMessagesListResponses];

export type JourneyMessagesCreateData = {
    body: CreatMessageRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/messages/';
};

export type JourneyMessagesCreateResponses = {
    201: CreatMessage;
};

export type JourneyMessagesCreateResponse = JourneyMessagesCreateResponses[keyof JourneyMessagesCreateResponses];

export type JourneyMessagesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/';
};

export type JourneyMessagesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyMessagesDestroyResponse = JourneyMessagesDestroyResponses[keyof JourneyMessagesDestroyResponses];

export type JourneyMessagesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/';
};

export type JourneyMessagesRetrieveResponses = {
    200: Message;
};

export type JourneyMessagesRetrieveResponse = JourneyMessagesRetrieveResponses[keyof JourneyMessagesRetrieveResponses];

export type JourneyMessagesPartialUpdateData = {
    body?: PatchedMessageRequest;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/';
};

export type JourneyMessagesPartialUpdateResponses = {
    200: Message;
};

export type JourneyMessagesPartialUpdateResponse = JourneyMessagesPartialUpdateResponses[keyof JourneyMessagesPartialUpdateResponses];

export type JourneyMessagesUpdateData = {
    body: MessageRequest;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/';
};

export type JourneyMessagesUpdateResponses = {
    200: Message;
};

export type JourneyMessagesUpdateResponse = JourneyMessagesUpdateResponses[keyof JourneyMessagesUpdateResponses];

export type JourneyMessagesDetailsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/details/';
};

export type JourneyMessagesDetailsRetrieveResponses = {
    200: MessageDetail;
};

export type JourneyMessagesDetailsRetrieveResponse = JourneyMessagesDetailsRetrieveResponses[keyof JourneyMessagesDetailsRetrieveResponses];

export type JourneyMessagesEditorConfigRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/editor-config/';
};

export type JourneyMessagesEditorConfigRetrieveResponses = {
    200: Message;
};

export type JourneyMessagesEditorConfigRetrieveResponse = JourneyMessagesEditorConfigRetrieveResponses[keyof JourneyMessagesEditorConfigRetrieveResponses];

export type JourneyMessagesHistoryRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/history/';
};

export type JourneyMessagesHistoryRetrieveResponses = {
    200: Message;
};

export type JourneyMessagesHistoryRetrieveResponse = JourneyMessagesHistoryRetrieveResponses[keyof JourneyMessagesHistoryRetrieveResponses];

export type JourneyMessagesHistoryRetrieve2Data = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
        version_pk: string;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/history/{version_pk}/';
};

export type JourneyMessagesHistoryRetrieve2Responses = {
    200: Message;
};

export type JourneyMessagesHistoryRetrieve2Response = JourneyMessagesHistoryRetrieve2Responses[keyof JourneyMessagesHistoryRetrieve2Responses];

export type JourneyMessagesPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/publish/';
};

export type JourneyMessagesPublishCreateResponses = {
    200: Message;
};

export type JourneyMessagesPublishCreateResponse = JourneyMessagesPublishCreateResponses[keyof JourneyMessagesPublishCreateResponses];

export type JourneyMessagesRevertCreateData = {
    body: MessageRequest;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
        version_pk: string;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/revert/{version_pk}/';
};

export type JourneyMessagesRevertCreateResponses = {
    200: Message;
};

export type JourneyMessagesRevertCreateResponse = JourneyMessagesRevertCreateResponses[keyof JourneyMessagesRevertCreateResponses];

export type JourneyMessagesTestCreateData = {
    body: MessageTestRequestRequest;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/test/';
};

export type JourneyMessagesTestCreateResponses = {
    200: Message;
};

export type JourneyMessagesTestCreateResponse = JourneyMessagesTestCreateResponses[keyof JourneyMessagesTestCreateResponses];

export type JourneyMessagesTestWebhookCreateData = {
    body: WebhookTestRequestRequest;
    path: {
        /**
         * A unique integer value identifying this message.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/messages/{id}/test_webhook/';
};

export type JourneyMessagesAiTranslateCreateData = {
    body: MessageGenerateTranslationRequestRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/messages/ai-translate/';
};

export type JourneyMessagesAiTranslateCreateResponses = {
    200: Message;
};

export type JourneyMessagesAiTranslateCreateResponse = JourneyMessagesAiTranslateCreateResponses[keyof JourneyMessagesAiTranslateCreateResponses];

export type JourneyMessagesDeletedRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v3/journey/messages/deleted/';
};

export type JourneyMessagesDeletedRetrieveResponses = {
    200: Message;
};

export type JourneyMessagesDeletedRetrieveResponse = JourneyMessagesDeletedRetrieveResponses[keyof JourneyMessagesDeletedRetrieveResponses];

export type JourneyMessagesGenerateRetrieveData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Account ID
         */
        account: number;
        /**
         * Message Type
         *
         * * `email` - email
         * * `sms` - sms
         * * `webhook` - webhook
         */
        channel?: 'email' | 'sms' | 'webhook';
        /**
         * Client Key
         */
        client?: string;
        /**
         * Country Code (ISO alpha-3)
         */
        country?: string;
        /**
         * Show draft version
         */
        draft?: boolean;
        /**
         * Experiment ID
         */
        experiment_id?: number;
        /**
         * Experiment Variant Label
         *
         * * `A` - A
         * * `B` - B
         */
        experiment_variant_label?: 'A' | 'B';
        /**
         * Language Code (ISO 639-1)
         */
        language?: string;
        /**
         * Message Name
         */
        name: string;
    };
    url: '/v3/journey/messages/generate/';
};

export type JourneyMessagesGenerateRetrieveResponses = {
    200: MessageGenerateResponse;
};

export type JourneyMessagesGenerateRetrieveResponse = JourneyMessagesGenerateRetrieveResponses[keyof JourneyMessagesGenerateRetrieveResponses];

export type JourneyMessagesMigrateCreateData = {
    body: MessageRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/messages/migrate/';
};

export type JourneyMessagesMigrateCreateResponses = {
    200: Message;
};

export type JourneyMessagesMigrateCreateResponse = JourneyMessagesMigrateCreateResponses[keyof JourneyMessagesMigrateCreateResponses];

export type JourneyPartialsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/partials/';
};

export type JourneyPartialsListResponses = {
    200: PaginatedPartialList;
};

export type JourneyPartialsListResponse = JourneyPartialsListResponses[keyof JourneyPartialsListResponses];

export type JourneyPartialsCreateData = {
    body: PartialRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/partials/';
};

export type JourneyPartialsCreateResponses = {
    201: Partial;
};

export type JourneyPartialsCreateResponse = JourneyPartialsCreateResponses[keyof JourneyPartialsCreateResponses];

export type JourneyPartialsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/';
};

export type JourneyPartialsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyPartialsDestroyResponse = JourneyPartialsDestroyResponses[keyof JourneyPartialsDestroyResponses];

export type JourneyPartialsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/';
};

export type JourneyPartialsRetrieveResponses = {
    200: Partial;
};

export type JourneyPartialsRetrieveResponse = JourneyPartialsRetrieveResponses[keyof JourneyPartialsRetrieveResponses];

export type JourneyPartialsPartialUpdateData = {
    body?: PatchedPartialRequest;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/';
};

export type JourneyPartialsPartialUpdateResponses = {
    200: Partial;
};

export type JourneyPartialsPartialUpdateResponse = JourneyPartialsPartialUpdateResponses[keyof JourneyPartialsPartialUpdateResponses];

export type JourneyPartialsUpdateData = {
    body: PartialRequest;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/';
};

export type JourneyPartialsUpdateResponses = {
    200: Partial;
};

export type JourneyPartialsUpdateResponse = JourneyPartialsUpdateResponses[keyof JourneyPartialsUpdateResponses];

export type JourneyPartialsEditorConfigRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/editor-config/';
};

export type JourneyPartialsEditorConfigRetrieveResponses = {
    200: Partial;
};

export type JourneyPartialsEditorConfigRetrieveResponse = JourneyPartialsEditorConfigRetrieveResponses[keyof JourneyPartialsEditorConfigRetrieveResponses];

export type JourneyPartialsHistoryRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/history/';
};

export type JourneyPartialsHistoryRetrieveResponses = {
    200: Partial;
};

export type JourneyPartialsHistoryRetrieveResponse = JourneyPartialsHistoryRetrieveResponses[keyof JourneyPartialsHistoryRetrieveResponses];

export type JourneyPartialsHistoryRetrieve2Data = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
        version_pk: string;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/history/{version_pk}/';
};

export type JourneyPartialsHistoryRetrieve2Responses = {
    200: Partial;
};

export type JourneyPartialsHistoryRetrieve2Response = JourneyPartialsHistoryRetrieve2Responses[keyof JourneyPartialsHistoryRetrieve2Responses];

export type JourneyPartialsPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/publish/';
};

export type JourneyPartialsPublishCreateResponses = {
    200: Partial;
};

export type JourneyPartialsPublishCreateResponse = JourneyPartialsPublishCreateResponses[keyof JourneyPartialsPublishCreateResponses];

export type JourneyPartialsRevertCreateData = {
    body: PartialRequest;
    path: {
        /**
         * A unique integer value identifying this partial.
         */
        id: number;
        version_pk: string;
    };
    query?: never;
    url: '/v3/journey/partials/{id}/revert/{version_pk}/';
};

export type JourneyPartialsRevertCreateResponses = {
    200: Partial;
};

export type JourneyPartialsRevertCreateResponse = JourneyPartialsRevertCreateResponses[keyof JourneyPartialsRevertCreateResponses];

export type JourneyPartialsDeletedRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v3/journey/partials/deleted/';
};

export type JourneyPartialsDeletedRetrieveResponses = {
    200: Partial;
};

export type JourneyPartialsDeletedRetrieveResponse = JourneyPartialsDeletedRetrieveResponses[keyof JourneyPartialsDeletedRetrieveResponses];

export type JourneyPlaceholdersListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/placeholders/';
};

export type JourneyPlaceholdersListResponses = {
    200: PaginatedPlaceholderList;
};

export type JourneyPlaceholdersListResponse = JourneyPlaceholdersListResponses[keyof JourneyPlaceholdersListResponses];

export type JourneyPlaceholdersCreateData = {
    body: PlaceholderRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/placeholders/';
};

export type JourneyPlaceholdersCreateResponses = {
    201: Placeholder;
};

export type JourneyPlaceholdersCreateResponse = JourneyPlaceholdersCreateResponses[keyof JourneyPlaceholdersCreateResponses];

export type JourneyPlaceholdersDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this placeholder.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/placeholders/{id}/';
};

export type JourneyPlaceholdersDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyPlaceholdersDestroyResponse = JourneyPlaceholdersDestroyResponses[keyof JourneyPlaceholdersDestroyResponses];

export type JourneyPlaceholdersRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this placeholder.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/placeholders/{id}/';
};

export type JourneyPlaceholdersRetrieveResponses = {
    200: Placeholder;
};

export type JourneyPlaceholdersRetrieveResponse = JourneyPlaceholdersRetrieveResponses[keyof JourneyPlaceholdersRetrieveResponses];

export type JourneyPlaceholdersPartialUpdateData = {
    body?: PatchedPlaceholderRequest;
    path: {
        /**
         * A unique integer value identifying this placeholder.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/placeholders/{id}/';
};

export type JourneyPlaceholdersPartialUpdateResponses = {
    200: Placeholder;
};

export type JourneyPlaceholdersPartialUpdateResponse = JourneyPlaceholdersPartialUpdateResponses[keyof JourneyPlaceholdersPartialUpdateResponses];

export type JourneyPlaceholdersUpdateData = {
    body: PlaceholderRequest;
    path: {
        /**
         * A unique integer value identifying this placeholder.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/placeholders/{id}/';
};

export type JourneyPlaceholdersUpdateResponses = {
    200: Placeholder;
};

export type JourneyPlaceholdersUpdateResponse = JourneyPlaceholdersUpdateResponses[keyof JourneyPlaceholdersUpdateResponses];

export type JourneySharedFiltersListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/shared-filters/';
};

export type JourneySharedFiltersListResponses = {
    200: PaginatedJourneySharedFilterList;
};

export type JourneySharedFiltersListResponse = JourneySharedFiltersListResponses[keyof JourneySharedFiltersListResponses];

export type JourneySharedFiltersCreateData = {
    body: JourneySharedFilterRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/shared-filters/';
};

export type JourneySharedFiltersCreateResponses = {
    201: JourneySharedFilter;
};

export type JourneySharedFiltersCreateResponse = JourneySharedFiltersCreateResponses[keyof JourneySharedFiltersCreateResponses];

export type JourneySharedFiltersDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trigger Shared Filter.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/shared-filters/{id}/';
};

export type JourneySharedFiltersDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneySharedFiltersDestroyResponse = JourneySharedFiltersDestroyResponses[keyof JourneySharedFiltersDestroyResponses];

export type JourneySharedFiltersRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trigger Shared Filter.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/shared-filters/{id}/';
};

export type JourneySharedFiltersRetrieveResponses = {
    200: JourneySharedFilter;
};

export type JourneySharedFiltersRetrieveResponse = JourneySharedFiltersRetrieveResponses[keyof JourneySharedFiltersRetrieveResponses];

export type JourneySharedFiltersPartialUpdateData = {
    body?: PatchedJourneySharedFilterRequest;
    path: {
        /**
         * A unique integer value identifying this Trigger Shared Filter.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/shared-filters/{id}/';
};

export type JourneySharedFiltersPartialUpdateResponses = {
    200: JourneySharedFilter;
};

export type JourneySharedFiltersPartialUpdateResponse = JourneySharedFiltersPartialUpdateResponses[keyof JourneySharedFiltersPartialUpdateResponses];

export type JourneySharedFiltersUpdateData = {
    body: JourneySharedFilterRequest;
    path: {
        /**
         * A unique integer value identifying this Trigger Shared Filter.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/shared-filters/{id}/';
};

export type JourneySharedFiltersUpdateResponses = {
    200: JourneySharedFilter;
};

export type JourneySharedFiltersUpdateResponse = JourneySharedFiltersUpdateResponses[keyof JourneySharedFiltersUpdateResponses];

export type JourneyTriggersListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/journey/triggers/';
};

export type JourneyTriggersListResponses = {
    200: PaginatedJourneyTriggerList;
};

export type JourneyTriggersListResponse = JourneyTriggersListResponses[keyof JourneyTriggersListResponses];

export type JourneyTriggersCreateData = {
    body: JourneyTriggerRequest;
    path?: never;
    query?: never;
    url: '/v3/journey/triggers/';
};

export type JourneyTriggersCreateResponses = {
    201: JourneyTrigger;
};

export type JourneyTriggersCreateResponse = JourneyTriggersCreateResponses[keyof JourneyTriggersCreateResponses];

export type JourneyTriggersDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trigger Definition.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/triggers/{id}/';
};

export type JourneyTriggersDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type JourneyTriggersDestroyResponse = JourneyTriggersDestroyResponses[keyof JourneyTriggersDestroyResponses];

export type JourneyTriggersRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trigger Definition.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/triggers/{id}/';
};

export type JourneyTriggersRetrieveResponses = {
    200: JourneyTrigger;
};

export type JourneyTriggersRetrieveResponse = JourneyTriggersRetrieveResponses[keyof JourneyTriggersRetrieveResponses];

export type JourneyTriggersPartialUpdateData = {
    body?: PatchedJourneyTriggerRequest;
    path: {
        /**
         * A unique integer value identifying this Trigger Definition.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/triggers/{id}/';
};

export type JourneyTriggersPartialUpdateResponses = {
    200: JourneyTrigger;
};

export type JourneyTriggersPartialUpdateResponse = JourneyTriggersPartialUpdateResponses[keyof JourneyTriggersPartialUpdateResponses];

export type JourneyTriggersUpdateData = {
    body: JourneyTriggerRequest;
    path: {
        /**
         * A unique integer value identifying this Trigger Definition.
         */
        id: number;
    };
    query?: never;
    url: '/v3/journey/triggers/{id}/';
};

export type JourneyTriggersUpdateResponses = {
    200: JourneyTrigger;
};

export type JourneyTriggersUpdateResponse = JourneyTriggersUpdateResponses[keyof JourneyTriggersUpdateResponses];

export type NotificationsNotificationListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        created_at_after?: string;
        created_at_before?: string;
        is_resolved?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * The system that generated the notification, e.g. backend, returns etc.
         *
         * * `backend` - Backend
         * * `returns` - Returns
         * * `portal` - Portal
         */
        source_system?: 'backend' | 'portal' | 'returns';
        /**
         * Type of the notification, e.g. voucher, return_label etc.
         *
         * * `voucher` - No voucher codes left
         * * `returns_label` - Could not create a return label for the order
         * * `tracking_creation` - Could not create tracking/order
         * * `optin` - Opt-in
         * * `recipe-applied` - Recipe has been successfully applied
         * * `recipe-failed` - Recipe couldn't be applied
         * * `returns_vendor_api` - An error occurred in the retailer API
         * * `payload_rewrite` - Something went wrong during payload rewrite
         * * `app_execution` - Something needs attention in the app execution
         * * `track_creation_failed` - Track creation failed
         * * `shopify_api` - An error occurred in the Shopify API
         * * `oauth_grant_refresh_failed` - Your OAuth tokens could not be refreshed
         * * `email_domain_white_label_verification_failed` - Email domain verification failed
         */
        type?: 'app_execution' | 'email_domain_white_label_verification_failed' | 'oauth_grant_refresh_failed' | 'optin' | 'payload_rewrite' | 'recipe-applied' | 'recipe-failed' | 'returns_label' | 'returns_vendor_api' | 'shopify_api' | 'track_creation_failed' | 'tracking_creation' | 'voucher';
    };
    url: '/v3/notifications/notification/';
};

export type NotificationsNotificationListResponses = {
    200: PaginatedNotificationList;
};

export type NotificationsNotificationListResponse = NotificationsNotificationListResponses[keyof NotificationsNotificationListResponses];

export type NotificationsNotificationCreateData = {
    body: NotificationRequest;
    path?: never;
    query?: never;
    url: '/v3/notifications/notification/';
};

export type NotificationsNotificationCreateResponses = {
    201: Notification;
};

export type NotificationsNotificationCreateResponse = NotificationsNotificationCreateResponses[keyof NotificationsNotificationCreateResponses];

export type NotificationsNotificationDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this notification.
         */
        id: number;
    };
    query?: never;
    url: '/v3/notifications/notification/{id}/';
};

export type NotificationsNotificationDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type NotificationsNotificationDestroyResponse = NotificationsNotificationDestroyResponses[keyof NotificationsNotificationDestroyResponses];

export type NotificationsNotificationRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this notification.
         */
        id: number;
    };
    query?: never;
    url: '/v3/notifications/notification/{id}/';
};

export type NotificationsNotificationRetrieveResponses = {
    200: Notification;
};

export type NotificationsNotificationRetrieveResponse = NotificationsNotificationRetrieveResponses[keyof NotificationsNotificationRetrieveResponses];

export type NotificationsNotificationPartialUpdateData = {
    body?: PatchedNotificationRequest;
    path: {
        /**
         * A unique integer value identifying this notification.
         */
        id: number;
    };
    query?: never;
    url: '/v3/notifications/notification/{id}/';
};

export type NotificationsNotificationPartialUpdateResponses = {
    200: Notification;
};

export type NotificationsNotificationPartialUpdateResponse = NotificationsNotificationPartialUpdateResponses[keyof NotificationsNotificationPartialUpdateResponses];

export type NotificationsNotificationUpdateData = {
    body: NotificationRequest;
    path: {
        /**
         * A unique integer value identifying this notification.
         */
        id: number;
    };
    query?: never;
    url: '/v3/notifications/notification/{id}/';
};

export type NotificationsNotificationUpdateResponses = {
    200: Notification;
};

export type NotificationsNotificationUpdateResponse = NotificationsNotificationUpdateResponses[keyof NotificationsNotificationUpdateResponses];

export type PortalCustomAnalyticsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/portal/custom-analytics/';
};

export type PortalCustomAnalyticsListResponses = {
    200: PaginatedCustomAnalyticsList;
};

export type PortalCustomAnalyticsListResponse = PortalCustomAnalyticsListResponses[keyof PortalCustomAnalyticsListResponses];

export type PortalCustomAnalyticsCreateData = {
    body: CustomAnalyticsRequest;
    path?: never;
    query?: never;
    url: '/v3/portal/custom-analytics/';
};

export type PortalCustomAnalyticsCreateResponses = {
    201: CustomAnalytics;
};

export type PortalCustomAnalyticsCreateResponse = PortalCustomAnalyticsCreateResponses[keyof PortalCustomAnalyticsCreateResponses];

export type PortalCustomAnalyticsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Custom Analytics.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/custom-analytics/{id}/';
};

export type PortalCustomAnalyticsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PortalCustomAnalyticsDestroyResponse = PortalCustomAnalyticsDestroyResponses[keyof PortalCustomAnalyticsDestroyResponses];

export type PortalCustomAnalyticsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Custom Analytics.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/custom-analytics/{id}/';
};

export type PortalCustomAnalyticsRetrieveResponses = {
    200: CustomAnalytics;
};

export type PortalCustomAnalyticsRetrieveResponse = PortalCustomAnalyticsRetrieveResponses[keyof PortalCustomAnalyticsRetrieveResponses];

export type PortalCustomAnalyticsPartialUpdateData = {
    body?: PatchedCustomAnalyticsRequest;
    path: {
        /**
         * A unique integer value identifying this Custom Analytics.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/custom-analytics/{id}/';
};

export type PortalCustomAnalyticsPartialUpdateResponses = {
    200: CustomAnalytics;
};

export type PortalCustomAnalyticsPartialUpdateResponse = PortalCustomAnalyticsPartialUpdateResponses[keyof PortalCustomAnalyticsPartialUpdateResponses];

export type PortalCustomAnalyticsUpdateData = {
    body: CustomAnalyticsRequest;
    path: {
        /**
         * A unique integer value identifying this Custom Analytics.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/custom-analytics/{id}/';
};

export type PortalCustomAnalyticsUpdateResponses = {
    200: CustomAnalytics;
};

export type PortalCustomAnalyticsUpdateResponse = PortalCustomAnalyticsUpdateResponses[keyof PortalCustomAnalyticsUpdateResponses];

export type PortalCustomAnalyticsIframeRetrieveData = {
    body?: never;
    path?: never;
    query: {
        account_id: number;
        entity_id: string;
    };
    url: '/v3/portal/custom-analytics/iframe/';
};

export type PortalCustomAnalyticsIframeRetrieveResponses = {
    200: string;
};

export type PortalCustomAnalyticsIframeRetrieveResponse = PortalCustomAnalyticsIframeRetrieveResponses[keyof PortalCustomAnalyticsIframeRetrieveResponses];

export type PortalCustomerPortalsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/portal/customer-portals/';
};

export type PortalCustomerPortalsListResponses = {
    200: PaginatedCustomerPortalList;
};

export type PortalCustomerPortalsListResponse = PortalCustomerPortalsListResponses[keyof PortalCustomerPortalsListResponses];

export type PortalCustomerPortalsCreateData = {
    body: CustomerPortalRequest;
    path?: never;
    query?: never;
    url: '/v3/portal/customer-portals/';
};

export type PortalCustomerPortalsCreateResponses = {
    201: CustomerPortal;
};

export type PortalCustomerPortalsCreateResponse = PortalCustomerPortalsCreateResponses[keyof PortalCustomerPortalsCreateResponses];

export type PortalCustomerPortalsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Customer Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/customer-portals/{id}/';
};

export type PortalCustomerPortalsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PortalCustomerPortalsDestroyResponse = PortalCustomerPortalsDestroyResponses[keyof PortalCustomerPortalsDestroyResponses];

export type PortalCustomerPortalsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Customer Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/customer-portals/{id}/';
};

export type PortalCustomerPortalsRetrieveResponses = {
    200: CustomerPortal;
};

export type PortalCustomerPortalsRetrieveResponse = PortalCustomerPortalsRetrieveResponses[keyof PortalCustomerPortalsRetrieveResponses];

export type PortalCustomerPortalsPartialUpdateData = {
    body?: PatchedCustomerPortalRequest;
    path: {
        /**
         * A unique integer value identifying this Customer Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/customer-portals/{id}/';
};

export type PortalCustomerPortalsPartialUpdateResponses = {
    200: CustomerPortal;
};

export type PortalCustomerPortalsPartialUpdateResponse = PortalCustomerPortalsPartialUpdateResponses[keyof PortalCustomerPortalsPartialUpdateResponses];

export type PortalCustomerPortalsUpdateData = {
    body: CustomerPortalRequest;
    path: {
        /**
         * A unique integer value identifying this Customer Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/customer-portals/{id}/';
};

export type PortalCustomerPortalsUpdateResponses = {
    200: CustomerPortal;
};

export type PortalCustomerPortalsUpdateResponse = PortalCustomerPortalsUpdateResponses[keyof PortalCustomerPortalsUpdateResponses];

export type PortalDataProtectionRequestsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/portal/data-protection-requests/';
};

export type PortalDataProtectionRequestsListResponses = {
    200: PaginatedDataProtectionRequestList;
};

export type PortalDataProtectionRequestsListResponse = PortalDataProtectionRequestsListResponses[keyof PortalDataProtectionRequestsListResponses];

export type PortalDataProtectionRequestsCreateData = {
    body: DataProtectionRequestRequestRequest;
    path?: never;
    query?: never;
    url: '/v3/portal/data-protection-requests/';
};

export type PortalDataProtectionRequestsCreateResponses = {
    201: DataProtectionRequestRequest;
};

export type PortalDataProtectionRequestsCreateResponse = PortalDataProtectionRequestsCreateResponses[keyof PortalDataProtectionRequestsCreateResponses];

export type PortalDataProtectionRequestsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Data Protection Request.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/data-protection-requests/{id}/';
};

export type PortalDataProtectionRequestsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PortalDataProtectionRequestsDestroyResponse = PortalDataProtectionRequestsDestroyResponses[keyof PortalDataProtectionRequestsDestroyResponses];

export type PortalDataProtectionRequestsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Data Protection Request.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/data-protection-requests/{id}/';
};

export type PortalDataProtectionRequestsRetrieveResponses = {
    200: DataProtectionRequest;
};

export type PortalDataProtectionRequestsRetrieveResponse = PortalDataProtectionRequestsRetrieveResponses[keyof PortalDataProtectionRequestsRetrieveResponses];

export type PortalDataProtectionRequestsPartialUpdateData = {
    body?: PatchedDataProtectionRequestRequest;
    path: {
        /**
         * A unique integer value identifying this Data Protection Request.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/data-protection-requests/{id}/';
};

export type PortalDataProtectionRequestsPartialUpdateResponses = {
    200: DataProtectionRequest;
};

export type PortalDataProtectionRequestsPartialUpdateResponse = PortalDataProtectionRequestsPartialUpdateResponses[keyof PortalDataProtectionRequestsPartialUpdateResponses];

export type PortalDataProtectionRequestsUpdateData = {
    body: DataProtectionRequestRequest;
    path: {
        /**
         * A unique integer value identifying this Data Protection Request.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/data-protection-requests/{id}/';
};

export type PortalDataProtectionRequestsUpdateResponses = {
    200: DataProtectionRequest;
};

export type PortalDataProtectionRequestsUpdateResponse = PortalDataProtectionRequestsUpdateResponses[keyof PortalDataProtectionRequestsUpdateResponses];

export type PortalDataProtectionRequestsBulkCreateData = {
    body: Array<DataProtectionRequestRequestRequest>;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/portal/data-protection-requests/bulk/';
};

export type PortalDataProtectionRequestsBulkCreateResponses = {
    200: PaginatedDataProtectionRequestList;
};

export type PortalDataProtectionRequestsBulkCreateResponse = PortalDataProtectionRequestsBulkCreateResponses[keyof PortalDataProtectionRequestsBulkCreateResponses];

export type PortalReportEmbedTokenTokenCreateData = {
    body?: never;
    path: {
        account_id: number;
    };
    query?: never;
    url: '/v3/portal/report-embed-token/token/{account_id}/';
};

export type PortalReportEmbedTokenTokenCreateResponses = {
    200: PowerBiEmbedToken;
};

export type PortalReportEmbedTokenTokenCreateResponse = PortalReportEmbedTokenTokenCreateResponses[keyof PortalReportEmbedTokenTokenCreateResponses];

export type PortalReportsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/portal/reports/';
};

export type PortalReportsListResponses = {
    200: PaginatedReportList;
};

export type PortalReportsListResponse = PortalReportsListResponses[keyof PortalReportsListResponses];

export type PortalReportsCreateData = {
    body: ReportCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/portal/reports/';
};

export type PortalReportsCreateResponses = {
    201: ReportCreate;
};

export type PortalReportsCreateResponse = PortalReportsCreateResponses[keyof PortalReportsCreateResponses];

export type PortalReportsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this PowerBI Report.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/reports/{id}/';
};

export type PortalReportsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PortalReportsDestroyResponse = PortalReportsDestroyResponses[keyof PortalReportsDestroyResponses];

export type PortalReportsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this PowerBI Report.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/reports/{id}/';
};

export type PortalReportsRetrieveResponses = {
    200: Report;
};

export type PortalReportsRetrieveResponse = PortalReportsRetrieveResponses[keyof PortalReportsRetrieveResponses];

export type PortalReportsPartialUpdateData = {
    body?: PatchedReportRequest;
    path: {
        /**
         * A unique integer value identifying this PowerBI Report.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/reports/{id}/';
};

export type PortalReportsPartialUpdateResponses = {
    200: Report;
};

export type PortalReportsPartialUpdateResponse = PortalReportsPartialUpdateResponses[keyof PortalReportsPartialUpdateResponses];

export type PortalReportsUpdateData = {
    body: ReportRequest;
    path: {
        /**
         * A unique integer value identifying this PowerBI Report.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/reports/{id}/';
};

export type PortalReportsUpdateResponses = {
    200: Report;
};

export type PortalReportsUpdateResponse = PortalReportsUpdateResponses[keyof PortalReportsUpdateResponses];

export type PortalSharedObjectsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        object_id?: string;
        /**
         * * `tracking` - Tracking
         */
        object_type?: 'tracking';
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/portal/shared-objects/';
};

export type PortalSharedObjectsListResponses = {
    200: PaginatedSharedObjectList;
};

export type PortalSharedObjectsListResponse = PortalSharedObjectsListResponses[keyof PortalSharedObjectsListResponses];

export type PortalSharedObjectsCreateData = {
    body: SharedObjectRequest;
    path?: never;
    query?: never;
    url: '/v3/portal/shared-objects/';
};

export type PortalSharedObjectsCreateResponses = {
    201: SharedObject;
};

export type PortalSharedObjectsCreateResponse = PortalSharedObjectsCreateResponses[keyof PortalSharedObjectsCreateResponses];

export type PortalSharedObjectsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Shared Object.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/shared-objects/{id}/';
};

export type PortalSharedObjectsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PortalSharedObjectsDestroyResponse = PortalSharedObjectsDestroyResponses[keyof PortalSharedObjectsDestroyResponses];

export type PortalSharedObjectsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Shared Object.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/shared-objects/{id}/';
};

export type PortalSharedObjectsRetrieveResponses = {
    200: SharedObject;
};

export type PortalSharedObjectsRetrieveResponse = PortalSharedObjectsRetrieveResponses[keyof PortalSharedObjectsRetrieveResponses];

export type PortalSharedObjectsPartialUpdateData = {
    body?: PatchedSharedObjectRequest;
    path: {
        /**
         * A unique integer value identifying this Shared Object.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/shared-objects/{id}/';
};

export type PortalSharedObjectsPartialUpdateResponses = {
    200: SharedObject;
};

export type PortalSharedObjectsPartialUpdateResponse = PortalSharedObjectsPartialUpdateResponses[keyof PortalSharedObjectsPartialUpdateResponses];

export type PortalSharedObjectsUpdateData = {
    body: SharedObjectRequest;
    path: {
        /**
         * A unique integer value identifying this Shared Object.
         */
        id: number;
    };
    query?: never;
    url: '/v3/portal/shared-objects/{id}/';
};

export type PortalSharedObjectsUpdateResponses = {
    200: SharedObject;
};

export type PortalSharedObjectsUpdateResponse = PortalSharedObjectsUpdateResponses[keyof PortalSharedObjectsUpdateResponses];

export type PromiseCourierServiceLevelsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/promise/courier-service-levels/';
};

export type PromiseCourierServiceLevelsListResponses = {
    200: PaginatedCourierServiceLevelList;
};

export type PromiseCourierServiceLevelsListResponse = PromiseCourierServiceLevelsListResponses[keyof PromiseCourierServiceLevelsListResponses];

export type PromiseCourierServiceLevelsCreateData = {
    body: CourierServiceLevelRequest;
    path?: never;
    query?: never;
    url: '/v3/promise/courier-service-levels/';
};

export type PromiseCourierServiceLevelsCreateResponses = {
    201: CourierServiceLevel;
};

export type PromiseCourierServiceLevelsCreateResponse = PromiseCourierServiceLevelsCreateResponses[keyof PromiseCourierServiceLevelsCreateResponses];

export type PromiseCourierServiceLevelsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Courier Service Level.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/courier-service-levels/{id}/';
};

export type PromiseCourierServiceLevelsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PromiseCourierServiceLevelsDestroyResponse = PromiseCourierServiceLevelsDestroyResponses[keyof PromiseCourierServiceLevelsDestroyResponses];

export type PromiseCourierServiceLevelsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Courier Service Level.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/courier-service-levels/{id}/';
};

export type PromiseCourierServiceLevelsRetrieveResponses = {
    200: CourierServiceLevel;
};

export type PromiseCourierServiceLevelsRetrieveResponse = PromiseCourierServiceLevelsRetrieveResponses[keyof PromiseCourierServiceLevelsRetrieveResponses];

export type PromiseCourierServiceLevelsPartialUpdateData = {
    body?: PatchedCourierServiceLevelRequest;
    path: {
        /**
         * A unique integer value identifying this Courier Service Level.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/courier-service-levels/{id}/';
};

export type PromiseCourierServiceLevelsPartialUpdateResponses = {
    200: CourierServiceLevel;
};

export type PromiseCourierServiceLevelsPartialUpdateResponse = PromiseCourierServiceLevelsPartialUpdateResponses[keyof PromiseCourierServiceLevelsPartialUpdateResponses];

export type PromiseCourierServiceLevelsUpdateData = {
    body: CourierServiceLevelRequest;
    path: {
        /**
         * A unique integer value identifying this Courier Service Level.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/courier-service-levels/{id}/';
};

export type PromiseCourierServiceLevelsUpdateResponses = {
    200: CourierServiceLevel;
};

export type PromiseCourierServiceLevelsUpdateResponse = PromiseCourierServiceLevelsUpdateResponses[keyof PromiseCourierServiceLevelsUpdateResponses];

export type PromiseDeliveryMethodsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/promise/delivery-methods/';
};

export type PromiseDeliveryMethodsListResponses = {
    200: PaginatedDeliveryMethodDetailsList;
};

export type PromiseDeliveryMethodsListResponse = PromiseDeliveryMethodsListResponses[keyof PromiseDeliveryMethodsListResponses];

export type PromiseDeliveryMethodsCreateData = {
    body: DeliveryMethodRequest;
    path?: never;
    query?: never;
    url: '/v3/promise/delivery-methods/';
};

export type PromiseDeliveryMethodsCreateResponses = {
    201: DeliveryMethod;
};

export type PromiseDeliveryMethodsCreateResponse = PromiseDeliveryMethodsCreateResponses[keyof PromiseDeliveryMethodsCreateResponses];

export type PromiseDeliveryMethodsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Delivery Method.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-methods/{id}/';
};

export type PromiseDeliveryMethodsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PromiseDeliveryMethodsDestroyResponse = PromiseDeliveryMethodsDestroyResponses[keyof PromiseDeliveryMethodsDestroyResponses];

export type PromiseDeliveryMethodsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Delivery Method.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-methods/{id}/';
};

export type PromiseDeliveryMethodsRetrieveResponses = {
    200: DeliveryMethodDetails;
};

export type PromiseDeliveryMethodsRetrieveResponse = PromiseDeliveryMethodsRetrieveResponses[keyof PromiseDeliveryMethodsRetrieveResponses];

export type PromiseDeliveryMethodsPartialUpdateData = {
    body?: PatchedDeliveryMethodRequest;
    path: {
        /**
         * A unique integer value identifying this Delivery Method.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-methods/{id}/';
};

export type PromiseDeliveryMethodsPartialUpdateResponses = {
    200: DeliveryMethod;
};

export type PromiseDeliveryMethodsPartialUpdateResponse = PromiseDeliveryMethodsPartialUpdateResponses[keyof PromiseDeliveryMethodsPartialUpdateResponses];

export type PromiseDeliveryMethodsUpdateData = {
    body: DeliveryMethodRequest;
    path: {
        /**
         * A unique integer value identifying this Delivery Method.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-methods/{id}/';
};

export type PromiseDeliveryMethodsUpdateResponses = {
    200: DeliveryMethod;
};

export type PromiseDeliveryMethodsUpdateResponse = PromiseDeliveryMethodsUpdateResponses[keyof PromiseDeliveryMethodsUpdateResponses];

export type PromiseDeliveryPredictionServicesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/promise/delivery-prediction-services/';
};

export type PromiseDeliveryPredictionServicesListResponses = {
    200: PaginatedDeliveryPredictionServiceList;
};

export type PromiseDeliveryPredictionServicesListResponse = PromiseDeliveryPredictionServicesListResponses[keyof PromiseDeliveryPredictionServicesListResponses];

export type PromiseDeliveryPredictionServicesCreateData = {
    body: DeliveryPredictionServiceRequest;
    path?: never;
    query?: never;
    url: '/v3/promise/delivery-prediction-services/';
};

export type PromiseDeliveryPredictionServicesCreateResponses = {
    201: DeliveryPredictionService;
};

export type PromiseDeliveryPredictionServicesCreateResponse = PromiseDeliveryPredictionServicesCreateResponses[keyof PromiseDeliveryPredictionServicesCreateResponses];

export type PromiseDeliveryPredictionServicesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Delivery Prediction Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-prediction-services/{id}/';
};

export type PromiseDeliveryPredictionServicesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PromiseDeliveryPredictionServicesDestroyResponse = PromiseDeliveryPredictionServicesDestroyResponses[keyof PromiseDeliveryPredictionServicesDestroyResponses];

export type PromiseDeliveryPredictionServicesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Delivery Prediction Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-prediction-services/{id}/';
};

export type PromiseDeliveryPredictionServicesRetrieveResponses = {
    200: DeliveryPredictionService;
};

export type PromiseDeliveryPredictionServicesRetrieveResponse = PromiseDeliveryPredictionServicesRetrieveResponses[keyof PromiseDeliveryPredictionServicesRetrieveResponses];

export type PromiseDeliveryPredictionServicesPartialUpdateData = {
    body?: PatchedDeliveryPredictionServiceRequest;
    path: {
        /**
         * A unique integer value identifying this Delivery Prediction Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-prediction-services/{id}/';
};

export type PromiseDeliveryPredictionServicesPartialUpdateResponses = {
    200: DeliveryPredictionService;
};

export type PromiseDeliveryPredictionServicesPartialUpdateResponse = PromiseDeliveryPredictionServicesPartialUpdateResponses[keyof PromiseDeliveryPredictionServicesPartialUpdateResponses];

export type PromiseDeliveryPredictionServicesUpdateData = {
    body: DeliveryPredictionServiceRequest;
    path: {
        /**
         * A unique integer value identifying this Delivery Prediction Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-prediction-services/{id}/';
};

export type PromiseDeliveryPredictionServicesUpdateResponses = {
    200: DeliveryPredictionService;
};

export type PromiseDeliveryPredictionServicesUpdateResponse = PromiseDeliveryPredictionServicesUpdateResponses[keyof PromiseDeliveryPredictionServicesUpdateResponses];

export type PromiseDeliveryPredictionServicesPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Delivery Prediction Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/delivery-prediction-services/{id}/publish/';
};

export type PromiseDeliveryPredictionServicesPublishCreateResponses = {
    200: DeliveryPredictionService;
};

export type PromiseDeliveryPredictionServicesPublishCreateResponse = PromiseDeliveryPredictionServicesPublishCreateResponses[keyof PromiseDeliveryPredictionServicesPublishCreateResponses];

export type PromiseDeliveryPredictionServicesPublishedRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        account?: number;
        draft?: boolean;
    };
    url: '/v3/promise/delivery-prediction-services/published/';
};

export type PromiseDeliveryPredictionServicesPublishedRetrieveResponses = {
    200: DeliveryPredictionServiceDetails;
};

export type PromiseDeliveryPredictionServicesPublishedRetrieveResponse = PromiseDeliveryPredictionServicesPublishedRetrieveResponses[keyof PromiseDeliveryPredictionServicesPublishedRetrieveResponses];

export type PromiseTrendingDelayConfigurationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/promise/trending-delay-configurations/';
};

export type PromiseTrendingDelayConfigurationsListResponses = {
    200: PaginatedTrendingDelayConfigurationList;
};

export type PromiseTrendingDelayConfigurationsListResponse = PromiseTrendingDelayConfigurationsListResponses[keyof PromiseTrendingDelayConfigurationsListResponses];

export type PromiseTrendingDelayConfigurationsCreateData = {
    body: TrendingDelayConfigurationRequest;
    path?: never;
    query?: never;
    url: '/v3/promise/trending-delay-configurations/';
};

export type PromiseTrendingDelayConfigurationsCreateResponses = {
    201: TrendingDelayConfiguration;
};

export type PromiseTrendingDelayConfigurationsCreateResponse = PromiseTrendingDelayConfigurationsCreateResponses[keyof PromiseTrendingDelayConfigurationsCreateResponses];

export type PromiseTrendingDelayConfigurationsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trending Delay Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/trending-delay-configurations/{id}/';
};

export type PromiseTrendingDelayConfigurationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PromiseTrendingDelayConfigurationsDestroyResponse = PromiseTrendingDelayConfigurationsDestroyResponses[keyof PromiseTrendingDelayConfigurationsDestroyResponses];

export type PromiseTrendingDelayConfigurationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Trending Delay Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/trending-delay-configurations/{id}/';
};

export type PromiseTrendingDelayConfigurationsRetrieveResponses = {
    200: TrendingDelayConfiguration;
};

export type PromiseTrendingDelayConfigurationsRetrieveResponse = PromiseTrendingDelayConfigurationsRetrieveResponses[keyof PromiseTrendingDelayConfigurationsRetrieveResponses];

export type PromiseTrendingDelayConfigurationsPartialUpdateData = {
    body?: PatchedTrendingDelayConfigurationRequest;
    path: {
        /**
         * A unique integer value identifying this Trending Delay Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/trending-delay-configurations/{id}/';
};

export type PromiseTrendingDelayConfigurationsPartialUpdateResponses = {
    200: TrendingDelayConfiguration;
};

export type PromiseTrendingDelayConfigurationsPartialUpdateResponse = PromiseTrendingDelayConfigurationsPartialUpdateResponses[keyof PromiseTrendingDelayConfigurationsPartialUpdateResponses];

export type PromiseTrendingDelayConfigurationsUpdateData = {
    body: TrendingDelayConfigurationRequest;
    path: {
        /**
         * A unique integer value identifying this Trending Delay Configuration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/trending-delay-configurations/{id}/';
};

export type PromiseTrendingDelayConfigurationsUpdateResponses = {
    200: TrendingDelayConfiguration;
};

export type PromiseTrendingDelayConfigurationsUpdateResponse = PromiseTrendingDelayConfigurationsUpdateResponses[keyof PromiseTrendingDelayConfigurationsUpdateResponses];

export type PromiseWarehousesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/promise/warehouses/';
};

export type PromiseWarehousesListResponses = {
    200: PaginatedWarehouseList;
};

export type PromiseWarehousesListResponse = PromiseWarehousesListResponses[keyof PromiseWarehousesListResponses];

export type PromiseWarehousesCreateData = {
    body: WarehouseRequest;
    path?: never;
    query?: never;
    url: '/v3/promise/warehouses/';
};

export type PromiseWarehousesCreateResponses = {
    201: Warehouse;
};

export type PromiseWarehousesCreateResponse = PromiseWarehousesCreateResponses[keyof PromiseWarehousesCreateResponses];

export type PromiseWarehousesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Warehouse.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/warehouses/{id}/';
};

export type PromiseWarehousesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type PromiseWarehousesDestroyResponse = PromiseWarehousesDestroyResponses[keyof PromiseWarehousesDestroyResponses];

export type PromiseWarehousesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Warehouse.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/warehouses/{id}/';
};

export type PromiseWarehousesRetrieveResponses = {
    200: Warehouse;
};

export type PromiseWarehousesRetrieveResponse = PromiseWarehousesRetrieveResponses[keyof PromiseWarehousesRetrieveResponses];

export type PromiseWarehousesPartialUpdateData = {
    body?: PatchedWarehouseRequest;
    path: {
        /**
         * A unique integer value identifying this Warehouse.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/warehouses/{id}/';
};

export type PromiseWarehousesPartialUpdateResponses = {
    200: Warehouse;
};

export type PromiseWarehousesPartialUpdateResponse = PromiseWarehousesPartialUpdateResponses[keyof PromiseWarehousesPartialUpdateResponses];

export type PromiseWarehousesUpdateData = {
    body: WarehouseRequest;
    path: {
        /**
         * A unique integer value identifying this Warehouse.
         */
        id: number;
    };
    query?: never;
    url: '/v3/promise/warehouses/{id}/';
};

export type PromiseWarehousesUpdateResponses = {
    200: Warehouse;
};

export type PromiseWarehousesUpdateResponse = PromiseWarehousesUpdateResponses[keyof PromiseWarehousesUpdateResponses];

export type ReturnsCourierApisListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/courier-apis/';
};

export type ReturnsCourierApisListResponses = {
    200: PaginatedReturnsCourierApiList;
};

export type ReturnsCourierApisListResponse = ReturnsCourierApisListResponses[keyof ReturnsCourierApisListResponses];

export type ReturnsCourierApisCreateData = {
    body: ReturnsCourierApiCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/courier-apis/';
};

export type ReturnsCourierApisCreateResponses = {
    201: ReturnsCourierApiCreate;
};

export type ReturnsCourierApisCreateResponse = ReturnsCourierApisCreateResponses[keyof ReturnsCourierApisCreateResponses];

export type ReturnsCourierApisDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Courier API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/courier-apis/{id}/';
};

export type ReturnsCourierApisDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsCourierApisDestroyResponse = ReturnsCourierApisDestroyResponses[keyof ReturnsCourierApisDestroyResponses];

export type ReturnsCourierApisRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Courier API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/courier-apis/{id}/';
};

export type ReturnsCourierApisRetrieveResponses = {
    200: ReturnsCourierApi;
};

export type ReturnsCourierApisRetrieveResponse = ReturnsCourierApisRetrieveResponses[keyof ReturnsCourierApisRetrieveResponses];

export type ReturnsCourierApisPartialUpdateData = {
    body?: PatchedReturnsCourierApiRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Courier API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/courier-apis/{id}/';
};

export type ReturnsCourierApisPartialUpdateResponses = {
    200: ReturnsCourierApi;
};

export type ReturnsCourierApisPartialUpdateResponse = ReturnsCourierApisPartialUpdateResponses[keyof ReturnsCourierApisPartialUpdateResponses];

export type ReturnsCourierApisUpdateData = {
    body: ReturnsCourierApiRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Courier API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/courier-apis/{id}/';
};

export type ReturnsCourierApisUpdateResponses = {
    200: ReturnsCourierApi;
};

export type ReturnsCourierApisUpdateResponse = ReturnsCourierApisUpdateResponses[keyof ReturnsCourierApisUpdateResponses];

export type ReturnsCourierApisSchemaRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Courier API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/courier-apis/{id}/schema/';
};

export type ReturnsCourierApisSchemaRetrieveResponses = {
    200: unknown;
};

export type ReturnsDocumentTemplatesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        client?: number;
        identifier?: string;
        key?: string;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        name?: string;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/document-templates/';
};

export type ReturnsDocumentTemplatesListResponses = {
    200: PaginatedReturnsDocumentTemplateList;
};

export type ReturnsDocumentTemplatesListResponse = ReturnsDocumentTemplatesListResponses[keyof ReturnsDocumentTemplatesListResponses];

export type ReturnsDocumentTemplatesCreateData = {
    body: ReturnsDocumentTemplateRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/document-templates/';
};

export type ReturnsDocumentTemplatesCreateResponses = {
    201: ReturnsDocumentTemplate;
};

export type ReturnsDocumentTemplatesCreateResponse = ReturnsDocumentTemplatesCreateResponses[keyof ReturnsDocumentTemplatesCreateResponses];

export type ReturnsDocumentTemplatesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Document Template.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/document-templates/{id}/';
};

export type ReturnsDocumentTemplatesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsDocumentTemplatesDestroyResponse = ReturnsDocumentTemplatesDestroyResponses[keyof ReturnsDocumentTemplatesDestroyResponses];

export type ReturnsDocumentTemplatesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Document Template.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/document-templates/{id}/';
};

export type ReturnsDocumentTemplatesRetrieveResponses = {
    200: ReturnsDocumentTemplate;
};

export type ReturnsDocumentTemplatesRetrieveResponse = ReturnsDocumentTemplatesRetrieveResponses[keyof ReturnsDocumentTemplatesRetrieveResponses];

export type ReturnsDocumentTemplatesPartialUpdateData = {
    body?: PatchedReturnsDocumentTemplateRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Document Template.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/document-templates/{id}/';
};

export type ReturnsDocumentTemplatesPartialUpdateResponses = {
    200: ReturnsDocumentTemplate;
};

export type ReturnsDocumentTemplatesPartialUpdateResponse = ReturnsDocumentTemplatesPartialUpdateResponses[keyof ReturnsDocumentTemplatesPartialUpdateResponses];

export type ReturnsDocumentTemplatesUpdateData = {
    body: ReturnsDocumentTemplateRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Document Template.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/document-templates/{id}/';
};

export type ReturnsDocumentTemplatesUpdateResponses = {
    200: ReturnsDocumentTemplate;
};

export type ReturnsDocumentTemplatesUpdateResponse = ReturnsDocumentTemplatesUpdateResponses[keyof ReturnsDocumentTemplatesUpdateResponses];

export type ReturnsDocumentTemplatesPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Document Template.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/document-templates/{id}/publish/';
};

export type ReturnsDocumentTemplatesPublishCreateResponses = {
    200: ReturnsDocumentTemplate;
};

export type ReturnsDocumentTemplatesPublishCreateResponse = ReturnsDocumentTemplatesPublishCreateResponses[keyof ReturnsDocumentTemplatesPublishCreateResponses];

export type ReturnsDocumentTemplatesLookupRetrieveData = {
    body?: never;
    path: {
        /**
         * Technical key, must not contain white space
         */
        key: string;
    };
    query: {
        account_id: number;
        /**
         * By default the endpoint returns the last saved version. When this parameter is true we return the last published instead
         */
        published?: boolean;
    };
    url: '/v3/returns/document-templates/lookup/{key}/';
};

export type ReturnsDocumentTemplatesLookupRetrieveResponses = {
    200: ReturnsDocumentTemplate;
};

export type ReturnsDocumentTemplatesLookupRetrieveResponse = ReturnsDocumentTemplatesLookupRetrieveResponses[keyof ReturnsDocumentTemplatesLookupRetrieveResponses];

export type ReturnsOrderApisListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/order-apis/';
};

export type ReturnsOrderApisListResponses = {
    200: PaginatedReturnsOrderApiList;
};

export type ReturnsOrderApisListResponse = ReturnsOrderApisListResponses[keyof ReturnsOrderApisListResponses];

export type ReturnsOrderApisCreateData = {
    body: ReturnsOrderApiCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/order-apis/';
};

export type ReturnsOrderApisCreateResponses = {
    201: ReturnsOrderApiCreate;
};

export type ReturnsOrderApisCreateResponse = ReturnsOrderApisCreateResponses[keyof ReturnsOrderApisCreateResponses];

export type ReturnsOrderApisDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Order API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/order-apis/{id}/';
};

export type ReturnsOrderApisDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsOrderApisDestroyResponse = ReturnsOrderApisDestroyResponses[keyof ReturnsOrderApisDestroyResponses];

export type ReturnsOrderApisRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Order API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/order-apis/{id}/';
};

export type ReturnsOrderApisRetrieveResponses = {
    200: ReturnsOrderApi;
};

export type ReturnsOrderApisRetrieveResponse = ReturnsOrderApisRetrieveResponses[keyof ReturnsOrderApisRetrieveResponses];

export type ReturnsOrderApisPartialUpdateData = {
    body?: PatchedReturnsOrderApiRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Order API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/order-apis/{id}/';
};

export type ReturnsOrderApisPartialUpdateResponses = {
    200: ReturnsOrderApi;
};

export type ReturnsOrderApisPartialUpdateResponse = ReturnsOrderApisPartialUpdateResponses[keyof ReturnsOrderApisPartialUpdateResponses];

export type ReturnsOrderApisUpdateData = {
    body: ReturnsOrderApiRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Order API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/order-apis/{id}/';
};

export type ReturnsOrderApisUpdateResponses = {
    200: ReturnsOrderApi;
};

export type ReturnsOrderApisUpdateResponse = ReturnsOrderApisUpdateResponses[keyof ReturnsOrderApisUpdateResponses];

export type ReturnsOrderApisSchemaRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Order API.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/order-apis/{id}/schema/';
};

export type ReturnsOrderApisSchemaRetrieveResponses = {
    200: unknown;
};

export type ReturnsPortalsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/portals/';
};

export type ReturnsPortalsListResponses = {
    200: PaginatedReturnsPortalList;
};

export type ReturnsPortalsListResponse = ReturnsPortalsListResponses[keyof ReturnsPortalsListResponses];

export type ReturnsPortalsCreateData = {
    body: ReturnsPortalCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/portals/';
};

export type ReturnsPortalsCreateResponses = {
    201: ReturnsPortalCreate;
};

export type ReturnsPortalsCreateResponse = ReturnsPortalsCreateResponses[keyof ReturnsPortalsCreateResponses];

export type ReturnsPortalsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/';
};

export type ReturnsPortalsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsPortalsDestroyResponse = ReturnsPortalsDestroyResponses[keyof ReturnsPortalsDestroyResponses];

export type ReturnsPortalsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/';
};

export type ReturnsPortalsRetrieveResponses = {
    200: ReturnsPortal;
};

export type ReturnsPortalsRetrieveResponse = ReturnsPortalsRetrieveResponses[keyof ReturnsPortalsRetrieveResponses];

export type ReturnsPortalsPartialUpdateData = {
    body?: PatchedReturnsPortalRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/';
};

export type ReturnsPortalsPartialUpdateResponses = {
    200: ReturnsPortal;
};

export type ReturnsPortalsPartialUpdateResponse = ReturnsPortalsPartialUpdateResponses[keyof ReturnsPortalsPartialUpdateResponses];

export type ReturnsPortalsUpdateData = {
    body: ReturnsPortalRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/';
};

export type ReturnsPortalsUpdateResponses = {
    200: ReturnsPortal;
};

export type ReturnsPortalsUpdateResponse = ReturnsPortalsUpdateResponses[keyof ReturnsPortalsUpdateResponses];

export type ReturnsPortalsDetailsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/details/';
};

export type ReturnsPortalsDetailsRetrieveResponses = {
    200: ReturnsPortalDetails;
};

export type ReturnsPortalsDetailsRetrieveResponse = ReturnsPortalsDetailsRetrieveResponses[keyof ReturnsPortalsDetailsRetrieveResponses];

export type ReturnsPortalsPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/publish/';
};

export type ReturnsPortalsPublishCreateResponses = {
    200: ReturnsPortalDetails;
};

export type ReturnsPortalsPublishCreateResponse = ReturnsPortalsPublishCreateResponses[keyof ReturnsPortalsPublishCreateResponses];

export type ReturnsPortalsSchemaRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Portal.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/portals/{id}/schema/';
};

export type ReturnsPortalsSchemaRetrieveResponses = {
    200: unknown;
};

export type ReturnsPortalsLookupRetrieveData = {
    body?: never;
    path: {
        key: string;
    };
    query?: {
        account?: string;
        draft?: boolean;
    };
    url: '/v3/returns/portals/lookup/{key}/';
};

export type ReturnsPortalsLookupRetrieveResponses = {
    200: ReturnsPortalDetails;
};

export type ReturnsPortalsLookupRetrieveResponse = ReturnsPortalsLookupRetrieveResponses[keyof ReturnsPortalsLookupRetrieveResponses];

export type ReturnsReturnReasonsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/return-reasons/';
};

export type ReturnsReturnReasonsListResponses = {
    200: PaginatedReturnReasonList;
};

export type ReturnsReturnReasonsListResponse = ReturnsReturnReasonsListResponses[keyof ReturnsReturnReasonsListResponses];

export type ReturnsReturnReasonsCreateData = {
    body: ReturnReasonRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/return-reasons/';
};

export type ReturnsReturnReasonsCreateResponses = {
    201: ReturnReason;
};

export type ReturnsReturnReasonsCreateResponse = ReturnsReturnReasonsCreateResponses[keyof ReturnsReturnReasonsCreateResponses];

export type ReturnsReturnReasonsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Return Reason v2.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-reasons/{id}/';
};

export type ReturnsReturnReasonsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsReturnReasonsDestroyResponse = ReturnsReturnReasonsDestroyResponses[keyof ReturnsReturnReasonsDestroyResponses];

export type ReturnsReturnReasonsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Return Reason v2.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-reasons/{id}/';
};

export type ReturnsReturnReasonsRetrieveResponses = {
    200: ReturnReason;
};

export type ReturnsReturnReasonsRetrieveResponse = ReturnsReturnReasonsRetrieveResponses[keyof ReturnsReturnReasonsRetrieveResponses];

export type ReturnsReturnReasonsPartialUpdateData = {
    body?: PatchedReturnReasonRequest;
    path: {
        /**
         * A unique integer value identifying this Return Reason v2.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-reasons/{id}/';
};

export type ReturnsReturnReasonsPartialUpdateResponses = {
    200: ReturnReason;
};

export type ReturnsReturnReasonsPartialUpdateResponse = ReturnsReturnReasonsPartialUpdateResponses[keyof ReturnsReturnReasonsPartialUpdateResponses];

export type ReturnsReturnReasonsUpdateData = {
    body: ReturnReasonRequest;
    path: {
        /**
         * A unique integer value identifying this Return Reason v2.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-reasons/{id}/';
};

export type ReturnsReturnReasonsUpdateResponses = {
    200: ReturnReason;
};

export type ReturnsReturnReasonsUpdateResponse = ReturnsReturnReasonsUpdateResponses[keyof ReturnsReturnReasonsUpdateResponses];

export type ReturnsReturnReasonsMoveToCreateData = {
    body?: ReturnReasonMoveRequest;
    path: {
        /**
         * A unique integer value identifying this Return Reason v2.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-reasons/{id}/move_to/';
};

export type ReturnsReturnReasonsMoveToCreateResponses = {
    200: ReturnReason;
};

export type ReturnsReturnReasonsMoveToCreateResponse = ReturnsReturnReasonsMoveToCreateResponses[keyof ReturnsReturnReasonsMoveToCreateResponses];

export type ReturnsReturnRegistrationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        created_at?: string;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        external_id?: string;
        external_reference?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        reference?: string;
        /**
         * If true, the registration has been submitted. This is a read-only field.
         *
         * * `created` - Created
         * * `submitted` - Submitted
         * * `pending_approval` - Pending Approval
         * * `approved` - Approved
         * * `rejected` - Rejected
         * * `cancelled` - Cancelled
         * * `closed` - Closed
         * * `processing_failed` - Processing Failed
         */
        status?: Array<'approved' | 'cancelled' | 'closed' | 'created' | 'pending_approval' | 'processing_failed' | 'rejected' | 'submitted'>;
        updated_at?: string;
    };
    url: '/v3/returns/return-registrations/';
};

export type ReturnsReturnRegistrationsListResponses = {
    200: PaginatedReturnRegistrationList;
};

export type ReturnsReturnRegistrationsListResponse = ReturnsReturnRegistrationsListResponses[keyof ReturnsReturnRegistrationsListResponses];

export type ReturnsReturnRegistrationsCreateData = {
    body: ReturnRegistrationRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/return-registrations/';
};

export type ReturnsReturnRegistrationsCreateResponses = {
    201: ReturnRegistration;
};

export type ReturnsReturnRegistrationsCreateResponse = ReturnsReturnRegistrationsCreateResponses[keyof ReturnsReturnRegistrationsCreateResponses];

export type ReturnsReturnRegistrationsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Return Registration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-registrations/{id}/';
};

export type ReturnsReturnRegistrationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsReturnRegistrationsDestroyResponse = ReturnsReturnRegistrationsDestroyResponses[keyof ReturnsReturnRegistrationsDestroyResponses];

export type ReturnsReturnRegistrationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Return Registration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-registrations/{id}/';
};

export type ReturnsReturnRegistrationsRetrieveResponses = {
    200: ReturnRegistration;
};

export type ReturnsReturnRegistrationsRetrieveResponse = ReturnsReturnRegistrationsRetrieveResponses[keyof ReturnsReturnRegistrationsRetrieveResponses];

export type ReturnsReturnRegistrationsPartialUpdateData = {
    body?: PatchedReturnRegistrationRequest;
    path: {
        /**
         * A unique integer value identifying this Return Registration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-registrations/{id}/';
};

export type ReturnsReturnRegistrationsPartialUpdateResponses = {
    200: ReturnRegistration;
};

export type ReturnsReturnRegistrationsPartialUpdateResponse = ReturnsReturnRegistrationsPartialUpdateResponses[keyof ReturnsReturnRegistrationsPartialUpdateResponses];

export type ReturnsReturnRegistrationsUpdateData = {
    body: ReturnRegistrationRequest;
    path: {
        /**
         * A unique integer value identifying this Return Registration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-registrations/{id}/';
};

export type ReturnsReturnRegistrationsUpdateResponses = {
    200: ReturnRegistration;
};

export type ReturnsReturnRegistrationsUpdateResponse = ReturnsReturnRegistrationsUpdateResponses[keyof ReturnsReturnRegistrationsUpdateResponses];

export type ReturnsReturnRegistrationsStatusCreateData = {
    body: UpdateReturnRegistrationStatusRequest;
    path: {
        /**
         * A unique integer value identifying this Return Registration.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/return-registrations/{id}/status/';
};

export type ReturnsReturnRegistrationsStatusCreateResponses = {
    200: ReturnRegistration;
};

export type ReturnsReturnRegistrationsStatusCreateResponse = ReturnsReturnRegistrationsStatusCreateResponses[keyof ReturnsReturnRegistrationsStatusCreateResponses];

export type ReturnsRulesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/rules/';
};

export type ReturnsRulesListResponses = {
    200: PaginatedReturnsRulesList;
};

export type ReturnsRulesListResponse = ReturnsRulesListResponses[keyof ReturnsRulesListResponses];

export type ReturnsRulesCreateData = {
    body: ReturnsRulesCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/rules/';
};

export type ReturnsRulesCreateResponses = {
    201: ReturnsRulesCreate;
};

export type ReturnsRulesCreateResponse = ReturnsRulesCreateResponses[keyof ReturnsRulesCreateResponses];

export type ReturnsRulesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Reason.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/rules/{id}/';
};

export type ReturnsRulesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsRulesDestroyResponse = ReturnsRulesDestroyResponses[keyof ReturnsRulesDestroyResponses];

export type ReturnsRulesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Reason.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/rules/{id}/';
};

export type ReturnsRulesRetrieveResponses = {
    200: ReturnsRules;
};

export type ReturnsRulesRetrieveResponse = ReturnsRulesRetrieveResponses[keyof ReturnsRulesRetrieveResponses];

export type ReturnsRulesPartialUpdateData = {
    body?: PatchedReturnsRulesRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Reason.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/rules/{id}/';
};

export type ReturnsRulesPartialUpdateResponses = {
    200: ReturnsRules;
};

export type ReturnsRulesPartialUpdateResponse = ReturnsRulesPartialUpdateResponses[keyof ReturnsRulesPartialUpdateResponses];

export type ReturnsRulesUpdateData = {
    body: ReturnsRulesRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Reason.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/rules/{id}/';
};

export type ReturnsRulesUpdateResponses = {
    200: ReturnsRules;
};

export type ReturnsRulesUpdateResponse = ReturnsRulesUpdateResponses[keyof ReturnsRulesUpdateResponses];

export type ReturnsTranslationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/returns/translations/';
};

export type ReturnsTranslationsListResponses = {
    200: PaginatedReturnsTranslationList;
};

export type ReturnsTranslationsListResponse = ReturnsTranslationsListResponses[keyof ReturnsTranslationsListResponses];

export type ReturnsTranslationsCreateData = {
    body: ReturnsTranslationCreateRequest;
    path?: never;
    query?: never;
    url: '/v3/returns/translations/';
};

export type ReturnsTranslationsCreateResponses = {
    201: ReturnsTranslationCreate;
};

export type ReturnsTranslationsCreateResponse = ReturnsTranslationsCreateResponses[keyof ReturnsTranslationsCreateResponses];

export type ReturnsTranslationsDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Translation.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/translations/{id}/';
};

export type ReturnsTranslationsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ReturnsTranslationsDestroyResponse = ReturnsTranslationsDestroyResponses[keyof ReturnsTranslationsDestroyResponses];

export type ReturnsTranslationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Translation.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/translations/{id}/';
};

export type ReturnsTranslationsRetrieveResponses = {
    200: ReturnsTranslation;
};

export type ReturnsTranslationsRetrieveResponse = ReturnsTranslationsRetrieveResponses[keyof ReturnsTranslationsRetrieveResponses];

export type ReturnsTranslationsPartialUpdateData = {
    body?: PatchedReturnsTranslationRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Translation.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/translations/{id}/';
};

export type ReturnsTranslationsPartialUpdateResponses = {
    200: ReturnsTranslation;
};

export type ReturnsTranslationsPartialUpdateResponse = ReturnsTranslationsPartialUpdateResponses[keyof ReturnsTranslationsPartialUpdateResponses];

export type ReturnsTranslationsUpdateData = {
    body: ReturnsTranslationRequest;
    path: {
        /**
         * A unique integer value identifying this Returns Translation.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/translations/{id}/';
};

export type ReturnsTranslationsUpdateResponses = {
    200: ReturnsTranslation;
};

export type ReturnsTranslationsUpdateResponse = ReturnsTranslationsUpdateResponses[keyof ReturnsTranslationsUpdateResponses];

export type ReturnsTranslationsSchemaRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Returns Translation.
         */
        id: number;
    };
    query?: never;
    url: '/v3/returns/translations/{id}/schema/';
};

export type ReturnsTranslationsSchemaRetrieveResponses = {
    200: unknown;
};

export type ServiceRecipesListData = {
    body?: never;
    path?: never;
    query?: {
        is_official?: boolean;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        tags?: string;
        unique_id?: string;
    };
    url: '/v3/service/recipes/';
};

export type ServiceRecipesListResponses = {
    200: PaginatedRecipeList;
};

export type ServiceRecipesListResponse = ServiceRecipesListResponses[keyof ServiceRecipesListResponses];

export type ServiceRecipesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Recipe.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/recipes/{id}/';
};

export type ServiceRecipesRetrieveResponses = {
    200: Recipe;
};

export type ServiceRecipesRetrieveResponse = ServiceRecipesRetrieveResponses[keyof ServiceRecipesRetrieveResponses];

export type ServiceRecipesApplyCreateData = {
    body: ApplyRecipeRequestRequest;
    path: {
        /**
         * A unique integer value identifying this Recipe.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/recipes/{id}/apply/';
};

export type ServiceRecipesApplyCreateResponses = {
    200: ApplyRecipeResponse;
};

export type ServiceRecipesApplyCreateResponse = ServiceRecipesApplyCreateResponses[keyof ServiceRecipesApplyCreateResponses];

export type ServiceRecipesApplicationsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: number;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        recipe?: number;
    };
    url: '/v3/service/recipes/applications/';
};

export type ServiceRecipesApplicationsListResponses = {
    200: PaginatedRecipeApplicationFetchList;
};

export type ServiceRecipesApplicationsListResponse = ServiceRecipesApplicationsListResponses[keyof ServiceRecipesApplicationsListResponses];

export type ServiceRecipesApplicationsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Recipe Application Log.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/recipes/applications/{id}/';
};

export type ServiceRecipesApplicationsRetrieveResponses = {
    200: RecipeApplicationFetch;
};

export type ServiceRecipesApplicationsRetrieveResponse = ServiceRecipesApplicationsRetrieveResponses[keyof ServiceRecipesApplicationsRetrieveResponses];

export type ServiceRecipesApplicationsPublishCreateData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Recipe Application Log.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/recipes/applications/{id}/publish/';
};

export type ServiceRecipesApplicationsPublishCreateResponses = {
    200: RecipeApplicationPublishResponse;
};

export type ServiceRecipesApplicationsPublishCreateResponse = ServiceRecipesApplicationsPublishCreateResponses[keyof ServiceRecipesApplicationsPublishCreateResponses];

export type ServiceServicesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * * `returns-translation` - Returns | Return Translation
         * * `returns-rules` - Returns | Return Rules
         * * `returns-order` - Returns | Order API
         * * `returns-courier` - Returns | Courier API
         * * `returns-portal` - Returns | Portal
         * * `portal-customer-portal` - Portal | Customer Portal
         * * `portal-order-status` - Portal | Order Status Page
         * * `campaign-campaign` - Campaign | Campaign
         * * `integration` - Connect | Integration
         * * `integration-sms` - Connect | SMS Integration
         * * `integration-webhook` - Connect | Webhook Integration
         * * `integration-placeinfo` - Connect | Placeinfo API
         * * `external-order-management` - Connect | External Order Management
         */
        role?: 'campaign-campaign' | 'external-order-management' | 'integration' | 'integration-placeinfo' | 'integration-sms' | 'integration-webhook' | 'portal-customer-portal' | 'portal-order-status' | 'returns-courier' | 'returns-order' | 'returns-portal' | 'returns-rules' | 'returns-translation';
    };
    url: '/v3/service/services/';
};

export type ServiceServicesListResponses = {
    200: PaginatedServiceList;
};

export type ServiceServicesListResponse = ServiceServicesListResponses[keyof ServiceServicesListResponses];

export type ServiceServicesCreateData = {
    body: ServiceRequest;
    path?: never;
    query?: never;
    url: '/v3/service/services/';
};

export type ServiceServicesCreateResponses = {
    201: Service;
};

export type ServiceServicesCreateResponse = ServiceServicesCreateResponses[keyof ServiceServicesCreateResponses];

export type ServiceServicesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/services/{id}/';
};

export type ServiceServicesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ServiceServicesDestroyResponse = ServiceServicesDestroyResponses[keyof ServiceServicesDestroyResponses];

export type ServiceServicesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/services/{id}/';
};

export type ServiceServicesRetrieveResponses = {
    200: Service;
};

export type ServiceServicesRetrieveResponse = ServiceServicesRetrieveResponses[keyof ServiceServicesRetrieveResponses];

export type ServiceServicesPartialUpdateData = {
    body?: PatchedServiceRequest;
    path: {
        /**
         * A unique integer value identifying this Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/services/{id}/';
};

export type ServiceServicesPartialUpdateResponses = {
    200: Service;
};

export type ServiceServicesPartialUpdateResponse = ServiceServicesPartialUpdateResponses[keyof ServiceServicesPartialUpdateResponses];

export type ServiceServicesUpdateData = {
    body: ServiceRequest;
    path: {
        /**
         * A unique integer value identifying this Service.
         */
        id: number;
    };
    query?: never;
    url: '/v3/service/services/{id}/';
};

export type ServiceServicesUpdateResponses = {
    200: Service;
};

export type ServiceServicesUpdateResponse = ServiceServicesUpdateResponses[keyof ServiceServicesUpdateResponses];

export type ServiceServicesSchemaRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Auth Key
         */
        key?: string;
        role?: 'campaign-campaign' | 'external-order-management' | 'integration' | 'integration-placeinfo' | 'integration-sms' | 'integration-webhook' | 'portal-customer-portal' | 'portal-order-status' | 'returns-courier' | 'returns-order' | 'returns-portal' | 'returns-rules' | 'returns-translation';
    };
    url: '/v3/service/services/schema/';
};

export type ServiceServicesSchemaRetrieveResponses = {
    200: Service;
};

export type ServiceServicesSchemaRetrieveResponse = ServiceServicesSchemaRetrieveResponses[keyof ServiceServicesSchemaRetrieveResponses];

export type TestappTestListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/testapp/test/';
};

export type TestappTestListResponses = {
    200: PaginatedDummyList;
};

export type TestappTestListResponse = TestappTestListResponses[keyof TestappTestListResponses];

export type TestappTestCreateData = {
    body: DummyRequest;
    path?: never;
    query?: never;
    url: '/v3/testapp/test/';
};

export type TestappTestCreateResponses = {
    201: Dummy;
};

export type TestappTestCreateResponse = TestappTestCreateResponses[keyof TestappTestCreateResponses];

export type TestappTestDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this dummy model.
         */
        id: number;
    };
    query?: never;
    url: '/v3/testapp/test/{id}/';
};

export type TestappTestDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type TestappTestDestroyResponse = TestappTestDestroyResponses[keyof TestappTestDestroyResponses];

export type TestappTestRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this dummy model.
         */
        id: number;
    };
    query?: never;
    url: '/v3/testapp/test/{id}/';
};

export type TestappTestRetrieveResponses = {
    200: Dummy;
};

export type TestappTestRetrieveResponse = TestappTestRetrieveResponses[keyof TestappTestRetrieveResponses];

export type TestappTestPartialUpdateData = {
    body?: PatchedDummyRequest;
    path: {
        /**
         * A unique integer value identifying this dummy model.
         */
        id: number;
    };
    query?: never;
    url: '/v3/testapp/test/{id}/';
};

export type TestappTestPartialUpdateResponses = {
    200: Dummy;
};

export type TestappTestPartialUpdateResponse = TestappTestPartialUpdateResponses[keyof TestappTestPartialUpdateResponses];

export type TestappTestUpdateData = {
    body: DummyRequest;
    path: {
        /**
         * A unique integer value identifying this dummy model.
         */
        id: number;
    };
    query?: never;
    url: '/v3/testapp/test/{id}/';
};

export type TestappTestUpdateResponses = {
    200: Dummy;
};

export type TestappTestUpdateResponse = TestappTestUpdateResponses[keyof TestappTestUpdateResponses];

export type TestappTestRaiseErrorRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/v3/testapp/test/raise_error/';
};

export type TestappTestRaiseErrorRetrieveResponses = {
    200: Dummy;
};

export type TestappTestRaiseErrorRetrieveResponse = TestappTestRaiseErrorRetrieveResponses[keyof TestappTestRaiseErrorRetrieveResponses];

export type TrackEmailsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        tracking?: string;
    };
    url: '/v3/track/emails/';
};

export type TrackEmailsListResponses = {
    200: PaginatedEmailList;
};

export type TrackEmailsListResponse = TrackEmailsListResponses[keyof TrackEmailsListResponses];

export type TrackEmailsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this email.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/emails/{id}/';
};

export type TrackEmailsRetrieveResponses = {
    200: Email;
};

export type TrackEmailsRetrieveResponse = TrackEmailsRetrieveResponses[keyof TrackEmailsRetrieveResponses];

export type TrackEventsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        event_type?: string;
        message?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        tracking?: string;
        trigger?: string;
    };
    url: '/v3/track/events/';
};

export type TrackEventsListResponses = {
    200: PaginatedEventList;
};

export type TrackEventsListResponse = TrackEventsListResponses[keyof TrackEventsListResponses];

export type TrackEventsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this event.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/events/{id}/';
};

export type TrackEventsRetrieveResponses = {
    200: Event;
};

export type TrackEventsRetrieveResponse = TrackEventsRetrieveResponses[keyof TrackEventsRetrieveResponses];

export type TrackEventsAvailableTypesRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        account?: number;
    };
    url: '/v3/track/events/available_types/';
};

export type TrackEventsAvailableTypesRetrieveResponses = {
    200: AvailableTypesResponse;
};

export type TrackEventsAvailableTypesRetrieveResponse = TrackEventsAvailableTypesRetrieveResponses[keyof TrackEventsAvailableTypesRetrieveResponses];

export type TrackOrderStatusPagesListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/track/order-status-pages/';
};

export type TrackOrderStatusPagesListResponses = {
    200: PaginatedOrderStatusPageList;
};

export type TrackOrderStatusPagesListResponse = TrackOrderStatusPagesListResponses[keyof TrackOrderStatusPagesListResponses];

export type TrackOrderStatusPagesCreateData = {
    body: OrderStatusPageRequest;
    path?: never;
    query?: never;
    url: '/v3/track/order-status-pages/';
};

export type TrackOrderStatusPagesCreateResponses = {
    201: OrderStatusPage;
};

export type TrackOrderStatusPagesCreateResponse = TrackOrderStatusPagesCreateResponses[keyof TrackOrderStatusPagesCreateResponses];

export type TrackOrderStatusPagesDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Order Status Page.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/order-status-pages/{id}/';
};

export type TrackOrderStatusPagesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type TrackOrderStatusPagesDestroyResponse = TrackOrderStatusPagesDestroyResponses[keyof TrackOrderStatusPagesDestroyResponses];

export type TrackOrderStatusPagesRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Order Status Page.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/order-status-pages/{id}/';
};

export type TrackOrderStatusPagesRetrieveResponses = {
    200: OrderStatusPage;
};

export type TrackOrderStatusPagesRetrieveResponse = TrackOrderStatusPagesRetrieveResponses[keyof TrackOrderStatusPagesRetrieveResponses];

export type TrackOrderStatusPagesPartialUpdateData = {
    body?: PatchedOrderStatusPageRequest;
    path: {
        /**
         * A unique integer value identifying this Order Status Page.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/order-status-pages/{id}/';
};

export type TrackOrderStatusPagesPartialUpdateResponses = {
    200: OrderStatusPage;
};

export type TrackOrderStatusPagesPartialUpdateResponse = TrackOrderStatusPagesPartialUpdateResponses[keyof TrackOrderStatusPagesPartialUpdateResponses];

export type TrackOrderStatusPagesUpdateData = {
    body: OrderStatusPageRequest;
    path: {
        /**
         * A unique integer value identifying this Order Status Page.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/order-status-pages/{id}/';
};

export type TrackOrderStatusPagesUpdateResponses = {
    200: OrderStatusPage;
};

export type TrackOrderStatusPagesUpdateResponse = TrackOrderStatusPagesUpdateResponses[keyof TrackOrderStatusPagesUpdateResponses];

export type TrackPlaceInfoListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        courier?: string;
        external_reference?: string;
        /**
         * Number of results to return per page.
         */
        limit?: number;
        /**
         * The initial index from which to return the results.
         */
        offset?: number;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/track/place-info/';
};

export type TrackPlaceInfoListResponses = {
    200: PaginatedPlaceInfoList;
};

export type TrackPlaceInfoListResponse = TrackPlaceInfoListResponses[keyof TrackPlaceInfoListResponses];

export type TrackPlaceInfoCreateData = {
    body: PlaceInfoRequest;
    path?: never;
    query?: never;
    url: '/v3/track/place-info/';
};

export type TrackPlaceInfoCreateResponses = {
    201: PlaceInfo;
};

export type TrackPlaceInfoCreateResponse = TrackPlaceInfoCreateResponses[keyof TrackPlaceInfoCreateResponses];

export type TrackPlaceInfoDestroyData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Place Info.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/place-info/{id}/';
};

export type TrackPlaceInfoDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type TrackPlaceInfoDestroyResponse = TrackPlaceInfoDestroyResponses[keyof TrackPlaceInfoDestroyResponses];

export type TrackPlaceInfoRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Place Info.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/place-info/{id}/';
};

export type TrackPlaceInfoRetrieveResponses = {
    200: PlaceInfo;
};

export type TrackPlaceInfoRetrieveResponse = TrackPlaceInfoRetrieveResponses[keyof TrackPlaceInfoRetrieveResponses];

export type TrackPlaceInfoPartialUpdateData = {
    body?: PatchedPlaceInfoRequest;
    path: {
        /**
         * A unique integer value identifying this Place Info.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/place-info/{id}/';
};

export type TrackPlaceInfoPartialUpdateResponses = {
    200: PlaceInfo;
};

export type TrackPlaceInfoPartialUpdateResponse = TrackPlaceInfoPartialUpdateResponses[keyof TrackPlaceInfoPartialUpdateResponses];

export type TrackPlaceInfoUpdateData = {
    body: PlaceInfoRequest;
    path: {
        /**
         * A unique integer value identifying this Place Info.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/place-info/{id}/';
};

export type TrackPlaceInfoUpdateResponses = {
    200: PlaceInfo;
};

export type TrackPlaceInfoUpdateResponse = TrackPlaceInfoUpdateResponses[keyof TrackPlaceInfoUpdateResponses];

export type TrackPlaceInfoLookupCreateData = {
    body: ExtendedPlaceInfoLookupRequestRequest;
    path?: never;
    query?: {
        account?: Array<number>;
        courier?: string;
        external_reference?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/track/place-info/lookup/';
};

export type TrackPlaceInfoLookupCreateResponses = {
    200: Array<PlaceInfoLookupResponseItem>;
};

export type TrackPlaceInfoLookupCreateResponse = TrackPlaceInfoLookupCreateResponses[keyof TrackPlaceInfoLookupCreateResponses];

export type TrackRecipientsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
    };
    url: '/v3/track/recipients/';
};

export type TrackRecipientsListResponses = {
    200: PaginatedRecipientList;
};

export type TrackRecipientsListResponse = TrackRecipientsListResponses[keyof TrackRecipientsListResponses];

export type TrackRecipientsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this Recipient.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/recipients/{id}/';
};

export type TrackRecipientsRetrieveResponses = {
    200: Recipient;
};

export type TrackRecipientsRetrieveResponse = TrackRecipientsRetrieveResponses[keyof TrackRecipientsRetrieveResponses];

export type TrackTrackingsListData = {
    body?: never;
    path?: never;
    query?: {
        account?: Array<number>;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/v3/track/trackings/';
};

export type TrackTrackingsListResponses = {
    200: PaginatedTrackingList;
};

export type TrackTrackingsListResponse = TrackTrackingsListResponses[keyof TrackTrackingsListResponses];

export type TrackTrackingsRetrieveData = {
    body?: never;
    path: {
        /**
         * A unique integer value identifying this tracking.
         */
        id: number;
    };
    query?: never;
    url: '/v3/track/trackings/{id}/';
};

export type TrackTrackingsRetrieveResponses = {
    200: Tracking;
};

export type TrackTrackingsRetrieveResponse = TrackTrackingsRetrieveResponses[keyof TrackTrackingsRetrieveResponses];

export type ClientOptions = {
    baseUrl: 'https://product-api.staging.parcellab.dev' | (string & {});
};
